webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(468);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vueRouter = __webpack_require__(718);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(379);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(380);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(252);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _vueAuth = __webpack_require__(261);
	
	var _vueAuth2 = _interopRequireDefault(_vueAuth);
	
	var _en = __webpack_require__(471);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _vueClipboard = __webpack_require__(584);
	
	var _vueClipboard2 = _interopRequireDefault(_vueClipboard);
	
	var _vueInfiniteLoading = __webpack_require__(585);
	
	var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);
	
	var _filter = __webpack_require__(377);
	
	var _App = __webpack_require__(586);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(484);
	
	__webpack_require__(485);
	
	var _eventBus = __webpack_require__(27);
	
	__webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _filter.JustDigits)();
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	_vue2.default.use(_vueClipboard2.default);
	_vue2.default.use(__webpack_require__(717));
	
	console.log(_eventBus.EventBus);
	
	var router = new _vueRouter2.default({
		routes: _routes2.default,
		mode: 'history',
		linkActiveClass: 'open active',
		scrollBehavior: function scrollBehavior(to, from, savedPosition) {
			return savedPosition || { x: 0, y: 0 };
		}
	});
	
	_vue2.default.router = router;
	
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	_vue2.default.use(_vueAuth2.default, {
		auth: __webpack_require__(378),
		http: __webpack_require__(258),
		router: __webpack_require__(259),
		refreshData: { url: 'auth/refresh', method: 'GET', enabled: false, interval: 30 },
		fetchData: { url: 'auth/user', method: 'GET', enabled: false },
		notFoundRedirect: { path: '/admin' },
		rolesVar: 'roles'
	});
	
	_vue2.default.use(_vueInfiniteLoading2.default, {});
	
	_vue2.default.axios.defaults.baseURL = ("https://beta-yeti-api.automatad.com/");
	_vue2.default.config.productionTip = false;
	
	new _vue2.default({
		el: '#app',
		router: router,
		store: _store2.default,
		render: function render(h) {
			return h(_App2.default);
		}
	});
	
	__webpack_require__(393);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	function LetterAvatar(name, size) {
		var w = window,
		    d = document;
	
		name = name || '';
		size = size || 60;
	
		var colours = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"],
		    nameSplit = String(name).toUpperCase().split(' '),
		    initials,
		    charIndex,
		    colourIndex,
		    canvas,
		    context,
		    dataURI;
	
		if (nameSplit.length == 1) {
			initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
		} else {
			initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
		}
	
		if (w.devicePixelRatio) {
			size = size * w.devicePixelRatio;
		}
	
		charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
		colourIndex = charIndex % 20;
		canvas = d.createElement('canvas');
		canvas.width = size;
		canvas.height = size;
		context = canvas.getContext("2d");
	
		context.fillStyle = colours[colourIndex - 1];
		context.fillRect(0, 0, canvas.width, canvas.height);
		context.font = Math.round(canvas.width / 2) + "px Arial";
		context.textAlign = "center";
		context.fillStyle = "#FFF";
		context.fillText(initials, size / 2, size / 1.5);
	
		dataURI = canvas.toDataURL();
		canvas = null;
	
		return dataURI;
	}
	
	LetterAvatar.transform = function () {
		Array.prototype.forEach.call(document.querySelectorAll('img[avatar]'), function (img, name) {
			name = img.getAttribute('avatar');
			img.src = LetterAvatar(name, img.getAttribute('width'));
			img.removeAttribute('avatar');
			img.setAttribute('alt', name);
		});
	};
	
	exports.default = LetterAvatar;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBus = undefined;
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(555)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(346),
	  /* template */
	  __webpack_require__(707),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-9447ee92",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(314),
	  /* template */
	  __webpack_require__(690),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(505)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(317),
	  /* template */
	  __webpack_require__(666),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2b0e785e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(532)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(332),
	  /* template */
	  __webpack_require__(688),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-588fab53",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'App'
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Sidebar = __webpack_require__(649);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(648);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(647);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ControlSidebar = __webpack_require__(646);
	
	var _ControlSidebar2 = _interopRequireDefault(_ControlSidebar);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setdata = function setdata(params, path) {
	  if (path) for (var key in params) {
	    path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);
	  }return path;
	};
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default,
	    'control-sidebar': _ControlSidebar2.default
	  },
	  data: function data() {
	    return {
	      domain_details: {},
	      is90d: false
	    };
	  },
	
	  created: function created() {
	    this.fetchDomainDetails();
	    if (this.$route.path.indexOf('stories') > -1 || this.$route.path.indexOf('manage-service') > -1 || this.$route.path.indexOf('manage-story') > -1) {
	      this.is90d = true;
	      document.body.classList.add('stories90d-gradient');
	    }
	  },
	  watch: {
	    '$route': function $route(newUrl, oldUrl) {
	      if (newUrl.path.indexOf('stories') > -1 || newUrl.path.indexOf('manage-service') > -1 || newUrl.path.indexOf('manage-story') > -1) {
	        this.is90d = true;
	        document.body.classList.add('stories90d-gradient');
	      } else {
	        this.is90d = false;
	        document.body.classList.remove('stories90d-gradient');
	      }
	      if (newUrl.path !== oldUrl.path) {
	        this.fetchDomainDetails();
	      }
	    }, deep: true
	  },
	  methods: {
	    fetchDomainDetails: function fetchDomainDetails() {
	      var _this = this;
	
	      var path = 'v1/publishers/{uuid}/domains/{domId}/';
	      var params = (0, _keys2.default)(this.$route.params);
	      if (params.includes("uuid") && params.includes("domId")) {
	        console.log('fetch domain details');
	        path = setdata(this.$route.params, path);
	        _axios2.default.get(("https://beta-yeti-api.automatad.com/") + path).then(function (response) {
	          _this.domain_details = response.data;
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        name: "",
	        email: "",
	        amp_ss_enable: false
	      },
	      message: "",
	      countryOptions: [],
	      currenciesOptions: [],
	      isactivateaccount: false
	    };
	  },
	
	  created: function created() {
	    console.log(this.$route.params);
	    this.$nextTick(function () {
	      var self = this;
	      _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/countries/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/currencies/")]).then(_axios2.default.spread(function (countries, currencies) {
	        self.countryOptions = countries.data;
	        self.currenciesOptions = currencies.data;
	      })).catch(function (error) {
	        return console.log(error);
	      });
	    });
	  },
	  methods: {
	    sentemail: function sentemail() {
	      var _this = this;
	
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/auth/password/reset/nivid/", {
	        email: this.credentials.email,
	        activateOrReset: "activate"
	      }).then(function (response) {
	        _this.$notify({
	          title: "Success",
	          message: "Successfully created a new publisher",
	          type: "success"
	        });
	
	        setTimeout(function () {
	          _this.$router.push("/admin/AllPublisher/");
	        }, 1000);
	      }).catch(function (error) {
	        _this.$notify({
	          title: "Warning",
	          message: "Unable to create a new publisher",
	          type: "warning"
	        });
	      });
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      console.log("calling create func");
	      var createPublisher = function createPublisher(userId) {
	        _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/publishers/", {
	          name: _this2.credentials.name,
	          owner: userId,
	          contact_email: _this2.credentials.email,
	          amp_ss_enable: _this2.credentials.amp_ss_enable
	        }).then(function (response) {
	          _this2.isactivateaccount = true;
	          _this2.$notify({
	            title: "Success",
	            message: "Successfully created a new publisher",
	            type: "success"
	          });
	
	          setTimeout(function () {
	            _this2.$router.push("/admin/publishers/");
	          }, 1000);
	        }).catch(function (error) {
	          _this2.$notify({
	            title: "Warning",
	            message: "Unable to create a new publisher",
	            type: "warning"
	          });
	        });
	      };
	
	      if (this.credentials.password == this.credentials.repassword) {
	        var splitName = this.credentials.name.split(" "),
	            firstName = splitName[0],
	            lastName = void 0;
	
	        if (splitName.length > 1) {
	          splitName.shift();
	          lastName = splitName.join(" ");
	        } else lastName = splitName[0];
	
	        _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/users/", {
	          first_name: firstName,
	          last_name: lastName,
	          email: this.credentials.email,
	          password: this.credentials.password
	        }).then(function (response) {
	          createPublisher(response.data.id);
	        }).catch(function (error) {
	          _this2.$notify({
	            title: "Warning",
	            message: "Unable to create a new user",
	            type: "warning"
	          });
	        });
	      } else {
	        this.$notify({
	          title: "Warning",
	          message: "Password and Repassword does not match",
	          type: "error"
	        });
	      }
	    }
	  },
	  computed: {
	    formValid: function formValid() {
	      return this.credentials.name && this.credentials.email;
	    }
	  }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            msg: 'charmi',
	            uuid: '',
	            domId: '',
	            bidders: [],
	            biddersData: ''
	        };
	    },
	
	    created: function created() {
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	        console.log("uuid and domid", this.uuid, this.domId);
	        this.getdata();
	        this.getbidderdata();
	    },
	    methods: {
	        getbidderdata: function getbidderdata() {
	            var _this = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/dynamic-bidder-data/' + this.uuid + '/domain/' + this.domId + '/');
	            _axios2.default.get(api).then(function (res) {
	                _this.biddersData = res.data.data[0].dynamic_bidders;
	                console.log("res", res);
	            });
	        },
	        getdata: function getdata() {
	            var _this2 = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/ads-txt-publisher/' + this.uuid + '/domain/' + this.domId + '/');
	
	            _axios2.default.get(api).then(function (res) {
	
	                _this2.bidders = res.data.data;
	            });
	        },
	        addData: function addData() {
	            var _this3 = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/ads-txt-publisher/' + this.uuid + '/domain/' + this.domId + '/');
	            var x = {
	                biddersData: this.biddersData
	            };
	            _axios2.default.post(api, x).then(function (res) {
	                console.log("res", res);
	                _this3.getdata();
	            });
	        }
	    }
	};

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['eventData', 'revenueData', 'eventLoader', 'revenueLoader', 'currentTime'],
	    data: function data() {
	        return {};
	    }
	};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['dimensions', 'item', 'devices', 'browsers', 'changeItemFormat', 'countries', 'creativeList']
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['lineItemId'],
	  data: function data() {
	    return {
	      note: "",
	      notes: [],
	      total_pages: 0,
	      currentPage: 1,
	      offset: 20,
	      domainId: this.domId
	    };
	  },
	
	  created: function created() {
	    this.getNotes();
	  },
	  methods: {
	    getNotes: function getNotes() {
	      var vm = this;
	      console.log(this.lineItemId);
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/notes/?lineitem_id=' + this.lineItemId)).then(function (response) {
	        console.log("response.data", response.data);
	        vm.notes = response.data.results;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    deleteNote: function deleteNote(index) {
	      var vm = this;
	
	      _axios2.default.delete(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/notes/' + this.notes[index].id + '/'));
	      this.$confirm('Are you sure to delete this note?', 'Warning', {
	        confirmButtonText: 'Yes',
	        cancelButtonText: 'No',
	        type: 'warning'
	      }).then(function (response) {
	        vm.getNotes();
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    saveNote: function saveNote() {
	      var vm = this;
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/notes/', {
	        note: this.note,
	        lineitem: this.lineItemId
	      }).then(function (response) {
	        vm.getNotes();
	        vm.note = "";
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    getLineItemNotes: function getLineItemNotes() {
	      var _this = this;
	
	      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      var vm = this;
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/notes/?lineitem_id=' + this.lineItemId + '&page=' + pageNum + '&offset=' + this.offset)).then(function (response) {
	        console.log("response.data", response.data);
	        vm.notes = response.data.results;
	        _this.total_pages = response.data.count;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    handleCurrentChange: function handleCurrentChange(val) {
	      console.log('Current page ' + val);
	      this.getLineItemNotes(val);
	      this.currentPage = val;
	    },
	    handleSizeChange: function handleSizeChange(val) {
	      console.log('Size changed: ', val);
	      this.offset = val;
	      this.getLineItemNotes(1);
	      this.currentPage = 1;
	    },
	    clearContent: function clearContent() {
	      console.log("working", document.getElementById("output").value);
	    }
	  },
	  watch: {
	    lineItemId: function lineItemId(newVal, oldVal) {
	      this.getNotes();
	      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
	    }
	  }
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(30);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(52);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(97);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(389);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _asyncToGenerator2 = __webpack_require__(96);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueSwatches = __webpack_require__(82);
	
	var _vueSwatches2 = _interopRequireDefault(_vueSwatches);
	
	var _verbalExpressions = __webpack_require__(79);
	
	var _verbalExpressions2 = _interopRequireDefault(_verbalExpressions);
	
	var _AdspotDetails = __webpack_require__(254);
	
	var _AdspotDetails2 = _interopRequireDefault(_AdspotDetails);
	
	var _AdspotData = __webpack_require__(590);
	
	var _AdspotData2 = _interopRequireDefault(_AdspotData);
	
	var _AdspotNotes = __webpack_require__(591);
	
	var _AdspotNotes2 = _interopRequireDefault(_AdspotNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        Swatch: _vueSwatches2.default,
	        LineItemDetails: _AdspotDetails2.default,
	        LineItemData: _AdspotData2.default,
	        LineItemNotes: _AdspotNotes2.default
	    },
	    data: function data() {
	        return {
	            positionsRegexExpression: '',
	            rtcUrl: 'https://bid.atmtd.com/request?placement_id=PLACEMENTID&site_id=SITEID&pos=POSITION&viewablity=BKG_STATE&w=ATTR(width)&h=ATTR(height)&ow=ATTR(data-override-width)&oh=ATTR(data-override-height)&ms=ATTR(data-multi-size)&slot=ATTR(data-slot)&curl=CANONICAL_URL&timeout=TIMEOUT&purl=HREF&cur=CURRENCY',
	            tagText: '',
	            positionsListLoading: false,
	            allLineItems: [],
	            mappedLineItemsByType: {},
	            positionList: [],
	            dimensionPos: {},
	            note: "",
	            notes: [],
	            siteDetails: {
	                uid: '',
	                url: '',
	                currency: null,
	                publisher: ''
	            },
	            allFontSizes: [],
	            showCreateLineitemDialog: false,
	            showCreateLineItemNotes: false,
	            showExportParamsDialog: false,
	            showExportTagDialog: false,
	            availableDimensions: [],
	
	            placementType: ['AMP', 'prebid'],
	            placementVertical: [],
	
	            allGraph: [],
	
	            domain_id: '',
	            selectedItem: null,
	
	            divTargettingNames: [],
	            selecteddivTargettingNames: [],
	            dimensions: [],
	            countries: [],
	            browsers: [],
	            selectedBrowsers: [1, 2, 3, 4],
	            selectedCountries: [],
	            devices: [],
	            selectedDevices: [1, 2, 3, 4, 5],
	
	            tagSelectPos: '',
	            tagSelectPosOptions: [],
	            isUniTag: false,
	
	            lineitemidEdit: '',
	            LineItems: [],
	
	            isEditLineitem: false,
	            isLineItemNote: false,
	            adspotIdPassToLineItems: undefined,
	
	            selectedDimensions: [],
	            selectedCreatives: [],
	            creativeAssociation: {
	                modify: false,
	                font_size: '',
	                font_color: '',
	                font_family: '',
	                name: '',
	                background_color: '',
	                cta_color: '',
	                isS2S: false,
	                tagId: ''
	            },
	            DivIdTargetingName: '',
	
	            lineItemNote: {
	                note: '',
	                lineItemId: ''
	            },
	            createLineItemForm: {
	                active: true,
	                name: '',
	                bid_cpm_min: '',
	                bid_cpm_max: '',
	                budget: '',
	                messageBCountry: '',
	                axt_refresh_time: 15,
	                creative: [],
	                creativeIds: [],
	                tagIds: [],
	                isDoubleCreative: false,
	                vertical: '',
	                placements: [{ data: '', operator: '' }],
	                domain: '',
	                type: '',
	                positions: [{ data: '', operator: '' }]
	            },
	            creativeList: [],
	            posOptions: [],
	
	            adspotNativeClick: '',
	            disabledDevice: [],
	            disabledBrowser: [],
	            disabledSize: [],
	
	            earnSpendChart: [],
	            chartWinsReponse: [],
	            CPMRPM: [],
	            allCaseId: '',
	
	            totalReqResponse: [],
	            loadingChart: false,
	            dimensionTemp: [],
	            dimensionsAsPerIsDoubleCreative: [],
	
	            allRequestsResposes: [],
	            currentAllDivIdTargetting: '',
	            placementTotalReqRes: {
	                hour: [0, 0, 0, 0, 0, 0, 0, 0],
	                total_response: [0, 0, 0, 0, 0, 0, 0, 0],
	                total_request: [0, 0, 0, 0, 0, 0, 0, 0]
	            },
	            isEventLoading: true,
	            isRevenueLoading: true,
	            timeNow: null
	
	        };
	    },
	
	    created: function created() {
	        this.domain_id = this.$route.params;
	        console.log('domid', this.domain_id.id, 'route', this.$route.params);
	        console.log('all in created method', this.selecteddivTargettingNames.length);
	
	        this.loadCreatives();
	        this.loadAllLineItems();
	        this.loadCountry();
	        this.loadDevice();
	
	        this.loadBrowser();
	        this.getDomain();
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        console.log('all mounted', this.selecteddivTargettingNames.length);
	
	        _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/vertical-list/').then(function (vertical) {
	            _this.placementVertical = vertical.data;
	        });
	    },
	
	    methods: {
	        convertRegexToString: function convertRegexToString(expr) {
	            return expr.toString().replace('/', '').replace('/gm', '');
	        },
	        convertObjToRegex: function convertObjToRegex(type) {
	            var obj = [];
	            this.createLineItemForm[type].forEach(function (typeValue) {
	                if (typeValue.data.length && typeValue.operator.length) {
	                    obj.push(typeValue);
	                }
	            });
	            var final_regex = '';
	            var expression = '';
	            for (var i in obj) {
	                if (obj[i].operator == 'starts_with') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + obj[i]['data']);
	                }
	                if (obj[i].operator == 'ends_with') {
	                    expression = (0, _verbalExpressions2.default)().add(obj[i]['data'] + '$');
	                }
	                if (obj[i].operator == 'equals') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + obj[i]['data'] + '$');
	                }
	                if (obj[i].operator == 'contains') {
	                    expression = (0, _verbalExpressions2.default)().find(obj[i]['data']);
	                }
	                if (obj[i].operator == 'does_not_contain') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + '(?' + '!.*' + obj[i]['data'] + ')' + '.*');
	                }
	                if (i == 0) {
	                    final_regex = expression;
	                } else {
	                    final_regex = final_regex.or(expression);
	                }
	            }
	            console.log('final_regex', final_regex);
	            var fin = final_regex == '' ? '' : final_regex.toRegExp();
	
	            this[type + 'RegexExpression'] = this.convertRegexToString(fin);
	        },
	        convertRegexToObj: function convertRegexToObj(expr) {
	            var arr = expr.split('|');
	            var regex_sanitize_expression = /[&\\#,+()!$~%.^'":*?<>{}]/g;
	            var j = [];
	            for (var i in arr) {
	                if (arr[i].indexOf('^') > -1 && arr[i].indexOf('$') > -1) {
	                    j.push({
	                        data: arr[i].replace(regex_sanitize_expression, ''),
	                        operator: 'equals'
	                    });
	                } else if (arr[i].indexOf('!') > -1) {
	                    j.push({
	                        operator: 'does_not_contain',
	                        data: arr[i].replace(regex_sanitize_expression, '')
	                    });
	                } else if (arr[i].indexOf('$') > -1) {
	                    j.push({
	                        operator: 'ends_with',
	                        data: arr[i].replace(regex_sanitize_expression, '')
	                    });
	                } else if (arr[i].indexOf('^') > -1) {
	                    j.push({
	                        operator: 'starts_with',
	                        data: arr[i].replace(regex_sanitize_expression, '')
	                    });
	                } else if (arr[i] == '') {
	                    j.push({ operator: 'equals', data: '' });
	                } else {
	                    j.push({
	                        operator: 'contains',
	                        data: arr[i].replace(regex_sanitize_expression, '')
	                    });
	                }
	            }
	            return j;
	        },
	        positionFilter: function positionFilter(query) {
	            if (query !== '') {
	                this.positionsListLoading = true;
	                this.posOptions = this.positionList.filter(function (item) {
	                    return item && item.indexOf(query) > -1;
	                });
	                this.positionsListLoading = false;
	            } else {
	                this.posOptions = [];
	            }
	        },
	        getAllPositionsForDimension: function getAllPositionsForDimension(dimension) {
	            var _this2 = this;
	
	            var existingPositionEntries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            if (dimension.length === 0) return;
	            var dim = [];
	            for (var i in dimension) {
	                dim.push(this.dimensions.filter(function (k) {
	                    return k.id == dimension[i];
	                })[0]);
	            }
	
	            var dimensions = dim.map(function (k) {
	                return k.width + 'x' + k.height;
	            });
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/domains/divids/?site_id=' + this.siteDetails.uuid + '&dimensions=' + dimensions)).then(function (pos) {
	                if (pos.hasOwnProperty('data')) {
	                    _this2.positionList = pos.data;
	                    if (existingPositionEntries.length > 0) {
	                        for (var k in existingPositionEntries) {
	                            if (_this2.positionList.map(function (x) {
	                                return x.data;
	                            }).indexOf(existingPositionEntries[k].data) == -1) {
	                                _this2.positionList.push(existingPositionEntries[k].data);
	                            }
	                        }
	                    }
	                }
	            }).catch(function (err) {
	                console.error('failed to fetch positions: ', err);
	            });
	        },
	        getDomain: function getDomain() {
	            var _this3 = this;
	
	            var api1 = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domains/' + this.$route.params.id + '/';
	            var vm = this;
	            _axios2.default.get(api1).then(function () {
	                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	                    var currDomain, publisherAPI, res, publisher;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    currDomain = response.data;
	                                    publisherAPI = ("https://beta-yeti-api.automatad.com/") + ('bidder/v1/publishers/' + currDomain.publisher + '/');
	                                    _context.next = 4;
	                                    return _axios2.default.get(publisherAPI);
	
	                                case 4:
	                                    res = _context.sent;
	                                    publisher = res.data.name;
	
	                                    vm.siteDetails = (0, _extends3.default)({}, currDomain, { publisher: publisher });
	                                    vm.$forceUpdate();
	
	                                case 8:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this3);
	                }));
	
	                return function (_x2) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	        },
	        loadCreatives: function loadCreatives() {
	            var _this4 = this;
	
	            var apiCreatives = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/creatives/?limit=1000';
	            _axios2.default.get(apiCreatives).then(function (creative) {
	                var _ref2;
	
	                _this4.creativeList = creative.data.results;
	                _this4.availableDimensions = [].concat((0, _toConsumableArray3.default)(new _set2.default((_ref2 = []).concat.apply(_ref2, (0, _toConsumableArray3.default)(_this4.creativeList.map(function (k) {
	                    return k.dimensions;
	                }))))));
	                _this4.loadAddimensions();
	            });
	        },
	        saveCreative: function saveCreative(creativeObj, id) {
	            var _this5 = this;
	
	            var creativeBase = this.creativeList.filter(function (k) {
	                return k.id == _this5.createLineItemForm.creativeIds[id];
	            })[0];
	            if (creativeObj.name == '') {
	                this.$notify({
	                    title: 'error',
	                    message: 'Assign a name to modified creative',
	                    type: 'error'
	                });
	                return;
	            }
	            var toSaveCreative = (0, _assign2.default)({}, creativeObj);
	            toSaveCreative['keywords_count'] = creativeBase.keywords_count;
	            toSaveCreative['sib_id'] = creativeBase.sib_id;
	            delete toSaveCreative.modify;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/creative/', toSaveCreative).then(function (res) {
	                console.log("Creative save successful", res);
	            });
	        },
	        updateCreativeList: function updateCreativeList(liObj, event, sl) {
	            if (liObj.creative.length > 0) {
	                var toremove = liObj.creative.findIndex(function (k) {
	                    return k && k.hasOwnProperty('dimension') ? k.dimension.indexOf(event.currentValue) > -1 : false;
	                });
	
	                this.$delete(liObj.creative, toremove);
	                this.$delete(liObj.creativeIds, toremove);
	            }
	        },
	        getCreativeList: function getCreativeList(dimId) {
	            var crList = this.creativeList.filter(function (k) {
	                return k.dimensions.indexOf(dimId) > -1;
	            });
	            console.log('crList: ' + crList.isS2S);
	            console.log('Creative IDDDD: ' + crList[0].id);
	            if (crList.length > 0) {
	                return crList;
	            }
	            return [];
	        },
	        addCreativeToLineItem: function addCreativeToLineItem(lineItemObj, id) {
	            var creativeObj = (0, _assign2.default)({}, this.creativeAssociation);
	            var creativeBase = this.creativeList.filter(function (k) {
	                return k.id == lineItemObj.creativeIds[id];
	            })[0];
	            console.log('creativeBase.isS2S', creativeBase.isS2S);
	            if (creativeBase.isS2S) {
	                creativeObj.isS2S = creativeBase.isS2S;
	            }
	            if (creativeBase) {
	                creativeObj.dimension = creativeBase.dimensions;
	                this.$set(lineItemObj.creative, id, creativeObj);
	            }
	        },
	        validateUnique: function validateUnique() {
	            var _this6 = this;
	
	            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            var liList = this.isEditLineitem == true ? this.LineItems.filter(function (k) {
	                return k.id != _this6.lineitemidEdit;
	            }) : this.LineItems;
	
	            var repeatedLineItem = '';
	
	            liList.map(function (k) {
	                var dv = _this6.arrSubset(_this6.selectedDevices, k.device.map(function (v) {
	                    return v;
	                }));
	                var br = _this6.arrSubset(_this6.selectedBrowsers, k.browsers.map(function (v) {
	                    return v;
	                }));
	                var dm = _this6.arrSubset(_this6.selectedDimensions, k.dimensions.map(function (v) {
	                    return v;
	                }));
	                var ct = _this6.arrSubset(_this6.selectedCountries, k.country.map(function (v) {
	                    return v;
	                }));
	                var dit = _this6.arrSubset(_this6.createLineItemForm.positions, k.positions.map(function (v) {
	                    return v;
	                }));
	                if (dv == true && br == true && dm == true && ct == true && dit == true) {
	                    repeatedLineItem = k.name;
	                }
	            });
	            if (repeatedLineItem.length > 0) {
	                this.$alert('Similar config exists with selected ' + type + ' for line item: <strong>' + repeatedLineItem + '</strong>', 'Error', {
	                    dangerouslyUseHTMLString: true,
	                    confirmButtonText: 'OK',
	                    callback: function callback(action) {
	                        if (type == 'browser') {
	                            _this6.selectedBrowsers.pop();
	                        }
	                        if (type == 'country') {
	                            _this6.selectedCountries.pop();
	                        }
	                        if (type == 'device') {
	                            _this6.selectedDevices.pop();
	                        }
	                        if (type == 'dimension') {
	                            _this6.selectedDimensions.pop();
	                        }
	                        if (type == 'positions') {
	                            _this6.createLineItemForm.positions.pop();
	                        }
	                    }
	                });
	            }
	        },
	        arrSubset: function arrSubset(arr1, arr2) {
	            var match = false;
	            if (arr1.length > arr2.length) {
	                match = arr2.filter(function (n) {
	                    return arr1.includes(n);
	                }).length > 0;
	            } else {
	                match = arr1.filter(function (n) {
	                    return arr2.includes(n);
	                }).length > 0;
	            }
	            return match;
	        },
	        closeLineitemContainer: function closeLineitemContainer(currentLineItemID) {
	            event.stopPropagation();
	
	            this.allLineItems.map(function (res) {
	                if (res.id != currentLineItemID) {
	                    var idLineitmContainerClose = res.id + 'LineitemContainer';
	                    if (document.getElementById(idLineitmContainerClose)) {
	                        document.getElementById(idLineitmContainerClose).style.display = 'none';
	                    }
	                }
	            });
	        },
	        lineitemHeadingClick: function lineitemHeadingClick(lineitem) {
	            var _this7 = this;
	
	            console.log('lineitemHeadingClick');
	            console.log(lineitem);
	            this.tableDataEvent = [];
	            this.tableDataRevenue = [];
	            var apiEventData = ("https://dhi-analytics-api.90d.io/") + ('api/v2/lineitem/event?xid=' + lineitem.xid);
	            var apiRevenueData = ("https://dhi-analytics-api.90d.io/") + ('api/v2/lineitem/revenue?xid=' + lineitem.xid);
	            console.log(new Date().toISOString());
	            setTimeout(function () {
	                _this7.isEventLoading = true;
	                _this7.isRevenueLoading = true;
	                _axios2.default.get(apiEventData).then(function (response) {
	                    _this7.tableDataEvent = _this7.formatDateandTime(response.data);
	                    _this7.timeNow = _this7.generateTime();
	                    _this7.isEventLoading = false;
	                });
	
	                _axios2.default.get(apiRevenueData).then(function (response) {
	                    _this7.tableDataRevenue = _this7.formatDateandTime(response.data);
	                    _this7.timeNow = _this7.generateTime();
	                    _this7.isRevenueLoading = false;
	                });
	            }, 500);
	
	            this.closeLineitemContainer(lineitem.id);
	
	            this.allGraph = [];
	            var idLineitmContainer = lineitem.id + 'LineitemContainer';
	
	            if (document.getElementById(idLineitmContainer) != undefined) {
	                document.getElementById(idLineitmContainer).style.display = 'block';
	            }
	            this.$forceUpdate();
	        },
	        formatDateandTime: function formatDateandTime(dateVal) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(dateVal), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var e = _step.value;
	
	                    var date = new Date(e.timeslot);
	                    var pstDate = date.toLocaleString('en-US', {
	                        timeZone: 'America/Los_Angeles'
	                    });
	                    console.log(pstDate);
	                    e.timeslot = pstDate;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return dateVal;
	        },
	        generateTime: function generateTime() {
	            var myDate = new Date();
	            var pstDate = myDate.toLocaleString('en-US', {
	                timeZone: 'America/Los_Angeles'
	            });
	            return pstDate;
	        },
	        lineitemStatus: function lineitemStatus(item) {
	            var _this8 = this;
	
	            var apiEditlineitem = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/' + item.id + '/';
	            if (item.type.includes('tag')) {
	                delete item.placement;
	            }
	            if (!item.placement) {
	                delete item.placement;
	            }
	            if ((0, _typeof3.default)(item.positions) == 'object') item.positions = this.convertObjToRegex('positions');
	            _axios2.default.put(apiEditlineitem, item).then(function (res) {
	                _this8.loadAllLineItems();
	                _this8.getDomain();
	            });
	        },
	        resumeExhaustedLineItem: function resumeExhaustedLineItem(event, lineitem) {
	            var _this9 = this;
	
	            event.stopPropagation();
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/' + lineitem.id + '/resume_lineitem/', {}).then(function (response) {
	                _this9.loadAllLineItems();
	            }).catch(function (error) {
	                console.log('error', error);
	            });
	        },
	        resumeStage: function resumeStage(event, lineitem) {
	            var _this10 = this;
	
	            event.stopPropagation();
	            console.log('@&', lineitem);
	            console.log('adspot', this.siteDetails.uuid);
	
	            var x = {
	                domain_uuid: this.siteDetails.uuid,
	                placement_uuid: lineitem.placement.placement_id,
	                creative_uid: lineitem.creative_uid,
	                suspend: false
	            };
	            console.log('@& resumeclick');
	            var url = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/update-circuit-breaker/';
	
	            _axios2.default.put(url, x).then(function (res) {
	                console.log('@&res circuit break', res);
	
	                _this10.loadAllLineItems();
	            });
	        },
	        lineitemDivClick: function lineitemDivClick(e) {
	            e.stopPropagation();
	        },
	        copyToClipBoardLogic: function copyToClipBoardLogic(elm) {
	            if (document.body.createTextRange) {
	                var range = document.body.createTextRange();
	                range.moveToElementText(elm);
	                range.select();
	                document.execCommand('Copy');
	            } else if (window.getSelection) {
	                var selection = window.getSelection();
	                var range = document.createRange();
	                range.selectNodeContents(elm);
	                selection.removeAllRanges();
	                selection.addRange(range);
	                document.execCommand('Copy');
	            }
	        },
	        copiedToClipboardparams: function copiedToClipboardparams() {
	            console.log('params');
	            var elm = document.getElementById('paramsDivId');
	            this.copyToClipBoardLogic(elm);
	        },
	        showExportParamas: function showExportParamas() {
	            this.showExportParamsDialog = true;
	        },
	        showExportTags: function showExportTags() {
	            var _this11 = this;
	
	            var tags = this.allLineItems.filter(function (k) {
	                return k.type.includes('tag');
	            });
	            var formattedTags = [];
	            if (tags.length > 0) {
	                formattedTags = tags.map(function (k) {
	                    k.positions = _this11.changeItemFormat(k.positions ? k.positions : []);
	                    return {
	                        site: _this11.siteDetails.uuid,
	                        positions: k.positions[0] && k.positions[0].hasOwnProperty('data') ? k.positions[0].data : k.positions,
	                        size: k.dimensions[0],
	                        placement: k.placement_text[0]
	                    };
	                });
	
	                var arr = formattedTags;
	                var unique = [];
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    var _loop = function _loop() {
	                        var char = _step2.value;
	
	                        var check = unique.find(function (e) {
	                            return (0, _stringify2.default)(e) == (0, _stringify2.default)(char);
	                        });
	                        if (!check) {
	                            unique.push(char);
	                        }
	                    };
	
	                    for (var _iterator2 = (0, _getIterator3.default)(arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        _loop();
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                this.tagSelectPosOptions = unique;
	            }
	            this.showExportTagDialog = true;
	        },
	        handleCloseTags: function handleCloseTags() {
	            this.showExportTagDialog = false;
	        },
	        handleCloseParama: function handleCloseParama() {
	            this.showExportParamsDialog = false;
	        },
	        copiedToClipboard: function copiedToClipboard(event, id, adspotid) {
	            console.log('@@ite id', id, 'adspotid', adspotid);
	            event.stopPropagation();
	            var elmID = id + 'copy' + adspotid;
	            var elm = document.getElementById(elmID);
	            this.copyToClipBoardLogic(elm);
	        },
	        chartfu: function chartfu(lineitemid, chartData, whichChart) {
	            google.charts.load('current', {
	                packages: ['corechart']
	            });
	
	            console.log('@@$% in chart earnSpendChart =  ', chartData, 'which chart', whichChart);
	
	            google.charts.setOnLoadCallback(drawChart);
	
	            function drawChart() {
	                var datae = [];
	                var temp = [];
	
	                var title = '';
	                var colors = [];
	
	                switch (whichChart) {
	                    case 1:
	                        temp.push('vAxis');
	                        temp.push('Earn(AXT)');
	                        temp.push({ type: 'boolean', role: 'certainty' });
	                        temp.push('Earn(FI)');
	                        temp.push({ type: 'boolean', role: 'certainty' });
	                        temp.push('Spend');
	                        temp.push({ type: 'boolean', role: 'certainty' });
	
	                        datae.push(temp);
	
	                        for (var i = 0; i < chartData.x.length; i++) {
	                            var _temp = [];
	
	                            var to = chartData.x[i] + 1;
	
	                            _temp.push(chartData.x[i] + '-' + to);
	                            _temp.push(chartData.total_earn_axt[i]);
	                            if (i == 0) {
	                                _temp.push(false);
	                            } else {
	                                _temp.push(true);
	                            }
	                            _temp.push(chartData.total_earn_fi[i]);
	
	                            if (i == 0) {
	                                _temp.push(false);
	                            } else {
	                                _temp.push(true);
	                            }
	
	                            _temp.push(chartData.total_spent[i]);
	                            if (i == 0) {
	                                _temp.push(false);
	                            } else {
	                                _temp.push(true);
	                            }
	
	                            datae.push(_temp);
	                        }
	
	
	                        title = 'Earn / Spend $';
	                        colors = ['#11ab16', 'green', 'red'];
	                        break;
	                    case 2:
	                        var winRate = '';
	                        var impressionRate = '';
	                        temp.push('Hours');
	                        temp.push('Responses');
	                        temp.push({ type: 'string', role: 'tooltip' });
	                        temp.push({ type: 'boolean', role: 'certainty' });
	                        temp.push('Wins');
	                        temp.push({ type: 'string', role: 'tooltip' });
	                        temp.push({ type: 'boolean', role: 'certainty' });
	                        temp.push('Impressions');
	
	                        temp.push({ type: 'string', role: 'tooltip' });
	                        temp.push({ type: 'boolean', role: 'certainty' });
	
	
	                        datae.push(temp);
	
	                        for (var i = 0; i < chartData.x.length; i++) {
	                            var _temp2 = [];
	
	                            var to = chartData.x[i] + 1;
	
	                            winRate = chartData.wins[i] / chartData.responses[i];
	                            impressionRate = chartData.impressions[i] / chartData.wins[i];
	                            winRate = winRate.toFixed(2);
	                            impressionRate = impressionRate.toFixed(2);
	
	                            _temp2.push(chartData.x[i] + '-' + to);
	                            _temp2.push(chartData.responses[i]);
	                            _temp2.push('Reponses :' + chartData.responses[i] + ' WinRate :' + winRate + ' Impressions/Wins:' + impressionRate);
	                            if (i == 0) {
	                                _temp2.push(false);
	                            } else {
	                                _temp2.push(true);
	                            }
	                            _temp2.push(chartData.wins[i]);
	                            _temp2.push('Wins :' + chartData.wins[i] + ' WinRate :' + winRate + ' Impressions/Wins:' + impressionRate);
	                            if (i == 0) {
	                                _temp2.push(false);
	                            } else {
	                                _temp2.push(true);
	                            }
	                            _temp2.push(chartData.impressions[i]);
	                            _temp2.push('Impression :' + chartData.impressions[i] + ' WinRate :' + winRate + '  Impressions/Wins:' + impressionRate);
	                            if (i == 0) {
	                                _temp2.push(false);
	                            } else {
	                                _temp2.push(true);
	                            }
	
	
	                            datae.push(_temp2);
	                        }
	
	                        title = 'Wins / Responses / Impressions';
	                        colors = ['orange', '#edbc91', '#cc0000', 'red'];
	
	                        break;
	                    case 3:
	                        temp.push('Hours');
	                        temp.push('Cpm');
	                        temp.push({ type: 'boolean', role: 'certainty' });
	                        temp.push('Rpm');
	                        temp.push({ type: 'boolean', role: 'certainty' });
	
	                        datae.push(temp);
	
	                        for (var i = 0; i < chartData.x.length; i++) {
	                            var _temp3 = [];
	
	                            var to = chartData.x[i] + 1;
	
	                            _temp3.push(chartData.x[i] + '-' + to);
	
	                            _temp3.push(chartData.cpm[i]);
	                            if (i == 0) {
	                                _temp3.push(false);
	                            } else {
	                                _temp3.push(true);
	                            }
	                            _temp3.push(chartData.rpm[i]);
	                            if (i == 0) {
	                                _temp3.push(false);
	                            } else {
	                                _temp3.push(true);
	                            }
	
	                            datae.push(_temp3);
	                        }
	
	                        title = 'CPM / RPM $';
	                        colors = ['#9b7aa3', '#f224d7'];
	                        break;
	                }
	
	                var tdata = new google.visualization.arrayToDataTable(datae);
	
	                var width = 100 + '%';
	
	                var options = {
	                    title: title,
	                    width: width,
	                    height: 300,
	                    colors: colors,
	                    vAxis: {
	                        viewWindow: {
	                            min: 0
	                        }
	                    }
	
	                };
	
	                var chart = new google.visualization.ColumnChart(document.getElementById(lineitemid));
	                chart.draw(tdata, options);
	            }
	        },
	        changeItemFormat: function changeItemFormat(e) {
	            if (typeof e == 'string') {
	                if (e.indexOf('{') > -1 && e.indexOf('}') > -1) {
	                    e = e.replace('{', '').replace('}', '').split(',');
	                } else {
	                    e = this.convertRegexToObj(e);
	                }
	            }
	            if (e && e.length && typeof e[0] == 'string') {
	                e = e.map(function (x) {
	                    return { data: x, operator: 'equals' };
	                });
	            }
	            return e;
	        },
	        loadDevice: function loadDevice() {
	            var _this12 = this;
	
	            var apiDevice = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/device-list/';
	            _axios2.default.get(apiDevice).then(function (response) {
	                var _devices;
	
	                console.log('respomse of device', response.data);
	                _this12.devices = [];
	                (_devices = _this12.devices).push.apply(_devices, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        loadBrowser: function loadBrowser() {
	            var _this13 = this;
	
	            var apiBrowser = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/browser-list/';
	            _axios2.default.get(apiBrowser).then(function (response) {
	                var _browsers;
	
	                console.log('@@respomse of browser-list', response.data);
	                _this13.browsers = [];
	                (_browsers = _this13.browsers).push.apply(_browsers, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        loadCountry: function loadCountry() {
	            var _this14 = this;
	
	            var apiCountry = ("https://beta-yeti-api.automatad.com/") + 'v1/countries/';
	            _axios2.default.get(apiCountry).then(function (response) {
	                var _countries;
	
	                _this14.countries = [];
	                (_countries = _this14.countries).push.apply(_countries, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        addNewItem: function addNewItem(index, type) {
	            var temp = this.createLineItemForm[type][index];
	            if (temp.data.length && temp.operator.length) {
	                this.createLineItemForm[type].push({ data: '', operator: '' });
	            } else {
	                this.$notify({
	                    title: 'Error',
	                    message: 'Input must have a value',
	                    type: 'error'
	                });
	            }
	        },
	        setDevicesForAMP: function setDevicesForAMP() {
	            if (this.createLineItemForm.type == 'AMP') {
	                this.selectedDevices = [1, 2];
	            } else {
	                this.selectedDevices = [1, 2, 3, 4, 5];
	            }
	        },
	        showCreateLineItemNotesfunction: function showCreateLineItemNotesfunction() {
	            event.stopPropagation();
	            this.showCreateLineItemNotes = true;
	        },
	        showCreateLineitemDialogfunction: function showCreateLineitemDialogfunction(event) {
	            event.stopPropagation();
	
	            this.loadAddimensions();
	            this.loadBrowser();
	
	
	            this.createLineItemForm.messageBCountry = '';
	
	            this.isEditLineitem = false;
	            this.createLineItemForm.name = '';
	            this.createLineItemForm.bid_cpm_min = '';
	            this.createLineItemForm.bid_cpm_max = '';
	            this.createLineItemForm.budget = '';
	            this.createLineItemForm.vertical = '';
	
	            this.createLineItemForm.domain = this.domain_id.id;
	            this.createLineItemForm.type = 'prebid';
	            this.createLineItemForm.positions = [{ data: '', operator: '' }];
	            this.createLineItemForm.placements = [{ data: '', operator: '' }];
	
	            this.createLineItemForm.active = true;
	
	            this.createLineItemForm.selectedCreative = 1;
	            this.selectedCountries = [];
	
	            this.selectedDevices = [1, 2, 3, 4, 5];
	            this.selectedBrowsers = [1, 2, 3, 4];
	            this.selectedDimensions = [];
	            this.createLineItemForm.creativeIds = [];
	            this.createLineItemForm.tagIds = [];
	            this.isUniTag = false;
	
	            this.showCreateLineitemDialog = true;
	
	            this.disabledDevice = [];
	            this.disabledBrowser = [];
	            this.disabledSize = [];
	            if (this.createLineItemForm.isDoubleCreative) {
	                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
	            } else {
	                this.dimensions = this.dimensionTemp;
	            }
	        },
	        showCreateTagDialogfunction: function showCreateTagDialogfunction(event) {
	            event.stopPropagation();
	
	            this.loadAddimensions();
	            this.loadBrowser();
	
	
	            this.createLineItemForm.messageBCountry = '';
	
	            this.isEditLineitem = false;
	            this.createLineItemForm.name = '';
	            this.createLineItemForm.bid_cpm_min = '';
	            this.createLineItemForm.bid_cpm_max = '';
	            this.createLineItemForm.budget = '';
	            this.createLineItemForm.vertical = '';
	
	            this.createLineItemForm.domain = this.domain_id.id;
	            this.createLineItemForm.type = 'tag';
	            this.createLineItemForm.positions = [{ data: '', operator: '' }];
	            this.createLineItemForm.placements = [{ data: '', operator: '' }];
	
	            this.createLineItemForm.active = true;
	
	            this.createLineItemForm.selectedCreative = 1;
	            this.selectedCountries = [];
	
	            this.selectedDevices = [1, 2, 3, 4, 5];
	            this.selectedBrowsers = [1, 2, 3, 4];
	            this.selectedDimensions = [];
	            this.createLineItemForm.creativeIds = [];
	            this.isUniTag = false;
	
	            this.showCreateLineitemDialog = true;
	
	            this.disabledDevice = [];
	            this.disabledBrowser = [];
	            this.disabledSize = [];
	            if (this.createLineItemForm.isDoubleCreative) {
	                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
	            } else {
	                this.dimensions = this.dimensionTemp;
	            }
	        },
	        editDuplicateCommon: function editDuplicateCommon(litemobj) {
	            var _this15 = this;
	
	            this.createLineItemForm.messageBCountry = '';
	            this.showCreateLineitemDialog = true;
	            this.isUniTag = litemobj.type == 'unitag' ? true : false;
	            this.createLineItemForm.name = litemobj.name;
	            this.createLineItemForm.bid_cpm_min = litemobj.bid_cpm_min;
	            this.createLineItemForm.bid_cpm_max = litemobj.bid_cpm_max;
	            this.createLineItemForm.active = litemobj.active;
	            this.createLineItemForm.isDoubleCreative = litemobj.is_double_creative;
	            this.createLineItemForm.budget = litemobj.budget;
	            this.createLineItemForm.vertical = litemobj.vertical;
	
	            litemobj.positions = this.changeItemFormat(litemobj.positions);
	            litemobj.placements = this.changeItemFormat(litemobj.placement_text.length ? litemobj.placement_text[0] : ['']);
	
	            this.createLineItemForm.placements = litemobj.placements;
	            this.createLineItemForm.positions = litemobj.positions;
	
	            this.createLineItemForm.domain = litemobj.domain;
	            this.createLineItemForm.type = litemobj.type;
	
	            this.createLineItemForm.axt_refresh_time = litemobj.axt_refresh_time;
	
	            this.selectedBrowsers = [];
	            for (var i = 0; i < litemobj.browsers.length; i++) {
	                this.selectedBrowsers.push(litemobj.browsers[i]);
	            }
	
	            this.selectedDimensions = [];
	            for (var _i = 0; _i < litemobj.dimensions.length; _i++) {
	                this.selectedDimensions.push(litemobj.dimensions[_i]);
	            }
	            this.getAllPositionsForDimension(this.selectedDimensions, litemobj.positions);
	
	            var _loop2 = function _loop2(_i2) {
	                l = _this15.creativeList.filter(function (k) {
	                    return k.id == litemobj.creative[_i2];
	                });
	            };
	
	            for (var _i2 = 0; _i2 < litemobj.creative.length; _i2++) {
	                var l;
	
	                _loop2(_i2);
	            }
	            this.createLineItemForm.creativeIds = (0, _assign2.default)([], litemobj.creative);
	
	            if (this.createLineItemForm.creativeIds.length > 1) {
	                var arr = [].concat((0, _toConsumableArray3.default)(this.selectedDimensions));
	                this.createLineItemForm.creativeIds.sort(function (a, b) {
	                    return arr.indexOf(_this15.creativeList.filter(function (k) {
	                        return k.id == a;
	                    })[0].dimensions[0]) - arr.indexOf(_this15.creativeList.filter(function (k) {
	                        return k.id == b;
	                    })[0].dimensions[0]);
	                });
	            }
	            this.selectedDimensions.map(function (val, index) {
	                _this15.addCreativeToLineItem(_this15.createLineItemForm, index);
	            });
	
	            if (litemobj.tag_ids.length > 0) {
	                litemobj.tag_ids.map(function (k) {
	                    _this15.createLineItemForm.creative[_this15.createLineItemForm.creativeIds.indexOf(k.creative)].tagId = k.tag_id;
	                });
	            }
	
	            this.selectedCountries = [];
	
	            for (var _i3 = 0; _i3 < litemobj.country.length; _i3++) {
	                this.selectedCountries.push(litemobj.country[_i3]);
	            }
	
	            this.selectedDevices = [];
	            for (var j = 0; j < litemobj.device.length; j++) {
	                console.log('@@$%', litemobj.device[j]);
	                this.selectedDevices.push(litemobj.device[j]);
	            }
	            this.selecteddivTargettingNames = [];
	            if (this.createLineItemForm.isDoubleCreative) {
	                this.dimensions = this.dimensionsAsPerIsDoubleCreative;
	            } else {
	                this.dimensions = this.dimensionTemp;
	            }
	            this.showCreateLineitemDialog = true;
	        },
	        createLineItemNotes: function createLineItemNotes(event, item) {
	            event.stopPropagation();
	            console.log(item);
	
	            this.showCreateLineItemNotes = true;
	            this.selectedItem = item.id;
	        },
	        editLineitem: function editLineitem(event, litemobj) {
	            event.stopPropagation();
	            console.log('click open');
	            console.log('@@$%lineitemobj', litemobj);
	            this.isEditLineitem = true;
	            this.lineitemidEdit = litemobj.id;
	            this.editDuplicateCommon(litemobj);
	            console.log('FFFFFFFFFFFFF', this.isEditLineitem);
	            console.log('final debug', this.createLineItemForm);
	        },
	        showDuplicateLineitemDialogfunction: function showDuplicateLineitemDialogfunction(event, litemobj) {
	            event.stopPropagation();
	            console.log('@@$%lineitemobj', litemobj);
	            this.isEditLineitem = false;
	            this.editDuplicateCommon(litemobj);
	        },
	        createLineItem: function createLineItem(event) {
	            var _this16 = this,
	                _console,
	                _console2;
	
	            event.stopPropagation();
	            this.createLineItemForm.tagIds = this.createLineItemForm.creative.map(function (k, index) {
	                if (k.tagId.length > 0) {
	                    return {
	                        tag_id: k.tagId,
	                        creative: _this16.createLineItemForm.creativeIds[index]
	                    };
	                }
	            }).filter(function (k) {
	                return k != null;
	            });
	            if (this.createLineItemForm.type.includes('tag')) {
	                if (this.createLineItemForm.bid_cpm_min.length > 0) {
	                    this.createLineItemForm.bid_cpm_max = this.createLineItemForm.bid_cpm_min;
	                }
	
	                if (this.isUniTag == true) {
	                    this.createLineItemForm.type = 'unitag';
	                } else {
	                    this.createLineItemForm.type = 'tag';
	                }
	            }
	
	            if (this.createLineItemForm.vertical.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter line item vertical',
	                    type: 'error'
	                });
	                return;
	            }
	
	            if (this.selectedDevices.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select devices',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedCountries.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select a country',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedDimensions.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select Dimensions',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedBrowsers.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select browsers',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.bid_cpm_min.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter minimum bidcpm',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.bid_cpm_max.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter maximum bidcpm',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.bid_cpm_max < this.createLineItemForm.bid_cpm_min) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Max bid cpm cannot be less than Min bid cpm',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.budget.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter line item budget',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.creativeIds.length != this.selectedDimensions.length) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Make sure all selected dimensions have creatives associated',
	                    type: 'error'
	                });
	                return;
	            }
	
	            if (this.createLineItemForm.name.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter line item name',
	                    type: 'error'
	                });
	                return;
	            }
	
	            if (this.domain_id) {
	                var apiCreateLineitem = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/';
	
	                var apiEditLineitem = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/' + this.lineitemidEdit + '/';
	            }
	
	            if (this.createLineItemForm.isDoubleCreative == true && this.selectedDimensions.length > 1) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Only one dimension can be selected when double creative is enabled',
	                    type: 'error'
	                });
	                return;
	            }
	            (_console = console).log.apply(_console, ['@@'].concat((0, _toConsumableArray3.default)(this.selectedBrowsers)));
	            (_console2 = console).log.apply(_console2, ['@@'].concat((0, _toConsumableArray3.default)(this.selectedDimensions)));
	
	            this.convertObjToRegex('positions');
	            this.convertObjToRegex('placements');
	
	            var LineitemObject = {
	                name: this.createLineItemForm.name,
	                active: this.createLineItemForm.active,
	                country: this.selectedCountries,
	                device: this.selectedDevices,
	                div_ids: this.selecteddivTargettingNames,
	
	
	                bid_cpm_min: this.createLineItemForm.bid_cpm_min,
	                bid_cpm_max: this.createLineItemForm.bid_cpm_max,
	                budget: this.createLineItemForm.budget,
	
	                axt_refresh_time: parseInt(this.createLineItemForm.axt_refresh_time),
	                browsers: this.selectedBrowsers,
	                dimensions: this.selectedDimensions,
	                is_double_creative: this.createLineItemForm.isDoubleCreative,
	                creative: this.createLineItemForm.creativeIds,
	                vertical: this.createLineItemForm.vertical,
	                domain: this.createLineItemForm.domain,
	                tag_ids: this.createLineItemForm.tagIds,
	                type: this.createLineItemForm.type,
	                placement_text: (0, _typeof3.default)(this.createLineItemForm.placements) == 'object' ? [this.placementsRegexExpression] : [this.createLineItemForm.placements],
	                positions: (0, _typeof3.default)(this.createLineItemForm.positions) == 'object' ? this.positionsRegexExpression : this.createLineItemForm.positions
	            };
	            if (LineitemObject.placement_text[0] == '') {
	                LineitemObject.placement_text = [];
	            }
	
	            if (LineitemObject.type == 'unitag') {
	                delete LineitemObject.placement_text;
	            }
	
	            if (this.isEditLineitem) {
	                _axios2.default.put(apiEditLineitem, LineitemObject).then(function (response) {
	                    _this16.$notify({
	                        title: 'success',
	                        message: 'Successfully Updated Lineitem',
	                        type: 'success'
	                    });
	                    _this16.LineItems = [];
	                    _this16.loadAllLineItems();
	
	                    _this16.isEditLineitem = false;
	                    _this16.lineitemidEdit = '';
	                    _this16.showCreateLineitemDialog = false;
	
	                    _this16.createLineItemForm.name = '';
	                    _this16.createLineItemForm.bid_cpm_min = '';
	                    _this16.createLineItemForm.bid_cpm_max = '';
	                    _this16.createLineItemForm.active = false;
	                    _this16.createLineItemForm.selectedCreative = 1;
	                    _this16.createLineItemForm.budget = '';
	                    _this16.createLineItemForm.positions = [{ data: '', operator: '' }];
	                    _this16.createLineItemForm.tagIds = [];
	                    _this16.positionsRegexExpression = '';
	                    _this16.selectedCountries = [];
	                    _this16.selectedDevices = [];
	
	                    _this16.selectedDimensions = [];
	                    _this16.selectedBrowsers = [];
	                    _this16.isUniTag = false;
	                    _this16.getDomain();
	                }).catch(function (err) {
	                    console.log(err, err.response);
	                    if ((0, _typeof3.default)(_this16.createLineItemForm.positions) != 'object') {
	                        _this16.createLineItemForm.positions = _this16.convertRegexToObj(_this16.createLineItemForm.positions);
	                    }
	                    _this16.$notify({
	                        title: 'error',
	                        message: err.response.hasOwnProperty('data') && err.response.data.hasOwnProperty('message') ? err.response.data.message : 'Something went wrong. Please try again in sometime',
	                        type: 'error'
	                    });
	                });
	                return;
	            }
	            _axios2.default.post(apiCreateLineitem, LineitemObject).then(function (response) {
	                _this16.showCreateLineitemDialog = false;
	                _this16.$notify({
	                    title: 'success',
	                    message: 'Successfully Created Lineitem',
	                    type: 'success'
	                });
	                _this16.LineItems = [];
	                _this16.mappedLineItemsByType = {};
	                _this16.loadAllLineItems();
	
	                _this16.createLineItemForm.bid_cpm_min = '';
	                _this16.createLineItemForm.bid_cpm_max = '';
	                _this16.createLineItemForm.budget = '';
	                _this16.createLineItemForm.active = false;
	                _this16.createLineItemForm.selectedCreative = 1;
	                _this16.selectedCountries = [];
	                _this16.selectedDevices = [];
	                _this16.positionsRegexExpression = '';
	                _this16.createLineItemForm.positions = [{ data: '', operator: '' }];
	
	                _this16.selectedBrowsers = [];
	                _this16.selectedDimensions = [];
	                _this16.getDomain();
	            }).catch(function (err) {
	                console.log(err);
	                _this16.$notify({
	                    title: 'error',
	                    message: err.response.data.hasOwnProperty('message') ? err.response.data.message : 'Something went wrong. Please try again in sometime',
	                    type: 'error'
	                });
	            });
	        },
	        loadAddimensions: function loadAddimensions() {
	            var _this17 = this;
	
	            this.dimensionsAsPerIsDoubleCreative = [];
	            var apidimension = ("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/';
	            var dim = ['300x250', '320x50', '728x90', '970x90', '250x250', '300x50', '320x100', '336x280', '320x480', '970x250', '300x600', '320x250'];
	            _axios2.default.get(apidimension).then(function (response) {
	                var dimensions = response.data;
	
	                _this17.dimensions = dimensions.filter(function (m) {
	                    return _this17.availableDimensions.indexOf(m.id) > -1;
	                });
	                _this17.dimensionTemp = dimensions.filter(function (m) {
	                    return _this17.availableDimensions.indexOf(m.id) > -1;
	                });
	
	                for (var i = 0; i < _this17.dimensions.length; i++) {
	                    if (_this17.dimensions[i].width == 300 && _this17.dimensions[i].height == 600 || _this17.dimensions[i].width == 970 && _this17.dimensions[i].height == 250 || _this17.dimensions[i].width == 336 && _this17.dimensions[i].height == 280 || _this17.dimensions[i].width == 300 && _this17.dimensions[i].height == 250) {
	                        _this17.dimensionsAsPerIsDoubleCreative.push(_this17.dimensions[i]);
	                    }
	                }
	
	                console.log('this.dimensionsAsPerIsDoubleCreative', _this17.dimensionsAsPerIsDoubleCreative);
	            });
	        },
	        loadAllLineItems: function loadAllLineItems() {
	            var _this18 = this;
	
	            var apiLineItems = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/?domain=' + this.domain_id.id + '&limit=1000';
	            _axios2.default.get(apiLineItems).then(function (lineItems) {
	                var lineItemList = lineItems.data.results;
	                _this18.mappedLineItemsByType = {};
	                lineItemList.forEach(function (item) {
	                    if (_this18.mappedLineItemsByType[item.type]) {
	                        _this18.mappedLineItemsByType[item.type].push(item);
	                    } else {
	                        _this18.mappedLineItemsByType[item.type] = [item];
	                    }
	                });
	
	                _this18.allLineItems = lineItemList;
	                _this18.$forceUpdate();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        },
	        handleCloseLineitem: function handleCloseLineitem() {
	            this.showCreateLineitemDialog = false;
	        },
	        handleCloseLineItemNotes: function handleCloseLineItemNotes() {
	            this.showCreateLineItemNotes = false;
	        }
	    }
	};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        revenuShare: {
	            type: Number
	        },
	        periodToSendRevPub: {
	            type: Number
	        },
	        example: {
	            type: String
	        },
	        terminationDuration: {
	            type: Number
	        },
	        LegalPublisherName: {
	            type: String
	        }
	    },
	    data: function data() {
	        return {
	            agreement_bw: '{{t:t;r:y;o:"PUBLISHER";w:100;h:20;}}',
	            pub_sig: '{{t:s;r:y;o:"PUBLISHER";w:100;h:20;}}',
	            pub_name: '{{t:t;r:y;o:"PUBLISHER";w:100;h:20;}}',
	            pub_title: '{{t:t;r:y;o:"PUBLISHER";w:100;h:20;}}',
	            pub_date: '{{t:t;r:y;o:"PUBLISHER";w:100;v:"13435fa6c2a17f83177fcbb5c4a9376ce85befeb";}} ',
	            aut_sig: '{{t:s;r:y;o:"AUTOMATAD";w:100;h:20;}}',
	            aut_name: '{{t:t;r:y;o:"AUTOMATAD";w:100;h:20;}}',
	            aut_title: '{{t:t;r:y;o:"AUTOMATAD";w:100;h:20;}}',
	            aut_date: '{{t:t;r:y;o:"AUTOMATAD";w:100;v:"13435fa6c2a17f83177fcbb5c4a9376ce85befeb";}} ',
	            LogoImg: null
	        };
	    },
	    created: function created() {
	        this.convertToBinary();
	    },
	
	    methods: {
	        convertToBinary: function convertToBinary() {
	            this.LogoImg = "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAI8AAAAuCAYAAAARI0rYAAAby0lEQVR4Ae1cC5hVxZGuqu5z7p0XMMgAMwMDRuMDjS/igxh1omQTXTWAO0SNyUZR9CNZds2qqPk2e80Xs4okuioixI3u+oqMAZSsfmsSg098BB9RUBEBB4YZXgPM8957uqv2qzNzLjMjuFmyMeByvm/mnNOnu6u6+u+q6uruC7D/2i+B/RLYvQQykKHdf93/ZU8lgHtacF8otw3uPLUI0hcJuEMNUHMO/MLmg6OFn101Pbcv8L+38/ipBU8XzL00APwJgRnggYEAQUA4D+7uxoOj7+0H0J8OzU8leNpg9uEB2N8ZoGFZiApSMkAQAHEW3PllMK2+8GH/wx5J4FPqC1BtAKYPcFQ6qoEMGArBnLtH0tpfqI8EPpXgQeCyPq3s9SIg4AEG9Era/7iHEvhUgsen8C0P7Ag+2jz1fRD49T2U1/5ivSTwUen2+rivPg7IDVkiQI+lwMaOssJF/Z1SSEMXRCtzEN2/r7Ztb+L7U+kwq4Db4d7hBLmHCOBUD6Lg6QKAlzzg9SUw9dW9qRP2Vl7OHjHzs0GEtZ7Fg2UTGru1cT09uRS+p7IEu7cy/qfyVQLc0Qa+i4G/YSBoAuC2Yuh6F3sa/qfW//+hfMD2i4bsPDQREKSAnXu3YmjXC7AJ9h7w1NXVmeilk6YS8zhBHwFgCiKpX7jx2sf2tJPaTPZ88KZjIEybj4Cyp/X8JcqdPermb4R5+ooYH4EnKwIvLWq+Zs4nzotl5sgBg4tJC4rvzcNeoXk2bz4CBwv8lcXiCV5yYBQ7tu1DANgj8AjMLW73rg4BfrqvAUc7x0RymrVF3/ScB6IAmLsGAsAnD57eSAEABOgzCHcLnjPh9lRXRUug5Ys2b42ehDt2F9LHuro6AqgDiMNu9VAP9Qx9CAnW1t5gKirGyObNK7B2CXAGMponvpYsybiJVbOyHvPgRYN6COIxm3z/n+5nwt+l/LAa2/YZw0uXqj3mrwSAbUtrm38DS/qXzlBt7RKqqJi2C14yVFsBxSGVyFMbr+7oX1Lfa2szFpZDuiwAXrwh07mrPB9Ny9A5VZBui4C07oEbX8nWQ32fUdy7DAN2KXBUFiIATPRHyULX8JZVQbol32lKTAUPPPWVbH397un0pjl27NTggPUDwvzGUr8EMn8UvT4O8zlVsw6zDCeyhePBy0EIMAQBkIzZxAivUxAt/OXqGb/vTfSssh8fkioLf4AIFrwBJN+VS7t//tXqaxuSfOdW/vSrAcLFjJ4JDIHwu7SBbqqH73WdO/TGYWyC6hDxRkTzVRWYwQAcutkuwrux2JtURJ007tXVvQVxDmSKbXXx6cJ4Boo5FMAPQoNZz7Jqsksde3AEd5y4ffp/JDwk9wkjZp5nJPg6g/ME1jD4pW8VfXjX4a2jzgwCmAQAh4oXDwhvC/Ejixpn/FbLngw3lw0dRuejpa8w8ygkBbe84rr8zxe3XLs8qT+5n1OVKbZQehyxH8eGjgLGGgQpAQAHiGuY+VlqDRYt6LyyKSlT95mbBroOM1KMXGfIXOjZAYEFBv4v8f5qEYOYRjesoez9eXB5HDpXOuTSx1jCkxM6gFwKAHkMaC17/wK1hL/sTSehp/ezq26qCRHrEIIvsPeVANIpgXnFe/mPMIRjJUcPMarPYwFE3nY+N/7xTd/fqGVj8NTVzTfR8w0/IUMXAMtQRAKRHsWAAtgz4WXyO8S5Hx7dlL0t0Rx1Q28Z5wN8kcAAEAKzy7lITnh809V/SJicUHPzPwS+6Fa1nWQseJ9/taixffyDkGn9m6pbZgAG13jJlwpImJRBxE4E6kQ2BIbfbh/YNvG/lmda9PtZo2ceU5Q3NwnBGShkhQUSt0Z5Z40ls6xEzz9atGlGn2n510bMvCGFxT/QkW0ogEjyT0Hkl4Ox3yXEIGl3LANwnWJwWnFD+8KuqrJ/B8IJ6j2JqgPQ5hr1B9Yx+IsTkGn6xOqfHEIC9wjAcYhYEmtSlWdcGAFRxa5rbf5NY2BKfcNVy7TceZUzzxOyd3txpQiSjol0d1Ie0bQiAjJzizdS+/i6GRvOrbr5UCtmHiIeB4ilH6XTHYkR4Tfz4i/5VdM1ryV1xnyOnnkaRDSXQAefdLeLetolkQL8FQT8ugZWdwWeuPb6+skeSINqZmh35d2dIT2N9eLASR6EYSCQ/fEfRpWcmTDBCCwsOdUYniNlIesRCiZJ87EOc/3ekwcEcm1QFPeANzKAyA4GxAJwtAwCFSOYIfqNWYYNbuiO+Kl2THusR1QN4K2XfNwpcYcQAEsUg8cgHULWzpsw+sZvJ7zG9SK6xCTkfScg+5PFwJUIEmjsWf8U5HG9gMXgIdNenf45AEwAVjFyNzhBZZLTCNJIIrqpbkRmcIFOWW6roB9OSCUqCQVkIkvN0y2LvJY92kcwuw5uUp8GhKTYgB1ikArAietEClUWCMEBAliJ3hpNN75rG4AOdqOapi8dlLgN2g5Ec3QgeOf4z3TT0bxfq5k1BvJwPyIdqnmUJwU3CoIwq608EJFi4MQ87OJfIUhorH+QJWoE5Jed+FtE5BJh/KaA+xkhdXSj2gOBSUnEdbuoa4+SEOl1z10LhKFBR7te3aOe32aJHmTI1QPgIpeGbB3MN0b4B8j2YAVznFdIhPwSJncrs3sEBNs0sqwAEIA05MIbzjpw1qg48y7+iWBJTFdkNQq8AYK5hA8Nb4jwaAJ7nqh6E35HBJZ3I6Hb4itYhfHoPKeOS6pf+O71W0XoASBsZnYLhfx1Inyh5+i7DPw0oukeONoGgs/nK+1JWpYi+cBz7iFB/37CgwY4RWSdl/zDTqJHiPihsB1jf2zhxswmtvAQAGwSdIuE3bUgcoFn/10BWZLUoZMQQBhXGsmJPTyi8TLdYDCSuXvhmES9CX7LO3cHi7tHwDcm7dndveAwrx0y+O3qho7a1s2t6/s5TA9MGjkrIrHTugmJqt2qMWPqwhUr6rt7cHe1f0x6GXTF0l/QcNWjAPLLScNvexgBajzku+08RvULG6/5Ye8qJoyeeQxG+FVmp8IAUrCJ/Lw9wr9PHNyJlTd/A4HmCWCxgFPTVBNk818FgLm96yo8k1bk7zadqX8JuKutqyg4F1lmS2xutI/jPw/C30+xuy+LkYApmoZC/yQopLrICAbemJpCnQCwLWy/vYRTD/znxutW906/YOiNj3ZZuxSRDuwxkYbIH6h5Ht107YsA8OKE4Tfdboz5rOpAFKuoWrqwccaFvetJnotb3Z3toXv48c3XrUrS9H7+yJsX5jw+S0gHsTCgISCx8SCqG5MZ5nbg6V5X+XrMr6A8jduCixb2+GATRtx8Ago8ikgjE1Peu359LoBn2bLLo9FDbh5UXlU0cZKZNVo8FPXU7JjliN6WSABo1IrhuKJ/bXv4XldXT+4Fj7qIkFzCsWOQvMZ3ycuxhDSQUa2ijkje5pBmPbXxqsLMaGHTjAcnVs86n8ScrY6eXsbgcRDvJtw5w9N0RKN2bqXNd91Qv21Gc5x5R+b+CTUlk4ntWTpYYoeV5XfBKQfOeljNu864DsncWd5RcgGCOUR6Qh/kfEGWmqfIDuagNX/UhJpbLqUIK5jAotp0UsvnS3pPRtnLzoYrXINYdcbs6D8C063mCik7Hz7YkfNV1cWHTai+5RLiHjogkovtJKsfWcjsnSIRwLeVjgSAoQUeBL0H/NfHeznvi9bPeGXiyFseQTFXfSx4amsz6fL3i28CMVMIqRSFgIwBkB7VDHlwoDP13bahwKA+UKpbLSeJklSUJPS76/S9HGKzvfMLuY8SExwUe++g2s+AiN/cFrWv31mo58nAOwh4diI38TS4DsDWA/TRlLF5E/fu5s2wfWcdGSH/k01qLvRS1c/i3o79wiSTigPNVox9oCRx5z2etXZF96DFL6A3SGQgUH57WhRhZ+yf7CyxZ0/qtxiP80BgHCGR0rE6IHquCLtURslr4e6cK7ImCNW3UV+RMepAsn00V5zZw4pYhh/tifhzjMTylSVTCc3fMyoh9fBgPSMsFoZW9aJE5PNEdrzOYj720lkIYmDIxfGhJK9lUxPb352DIPm0+zvbj+RGD6phYrup3jswlFVAsaKuvXdF6KGiMKq0AHJHvU6Rd3GhzoT7XUKCsXLrSafYg+yXiRMo9E0fW5UpDgD/hcCc7CAPGpRlcc8BwktIIsJIQP4CBKpOZm19a/joG8fRnr7pGocD7ppJkOqmAx48u+cE4SWdN+jGJYj8BWhNdX/NgcaoYooAsUi/IZhUgBI77b2piJWKHuXdO7nwbGN1jvhlTdGK1I8QkO8vWHdNIUbyteqZVxLsGjwSIoPrnruqioxnSTmpGzt27nI1hbHt9DSZcZd9V2CEkqGepPi+ZiDmz8A7QtCBArE6JmOGMvLXAeBfk2LnVP34MBH+cqy148TY5XwbegUlk7x/jntle3G1lPpTY38FdQMIrILUtm8uWHOjRszja8KImaeRgmd3g5F9n7FOvdyLpI7U0OwIYDxVfUTVHsiyBil14YLG6QVN/LXKmacYUTp9x4eRjkbwJVuFuvc1oVAqysoFALA0qf/kIdeUYR4ngImVSZLc525ra4FgFYaJio99CeZqRXYptAiPCI9lpik+1kp9ysYvwrgDKNZQaeienQASXDWyqXXsyJE37UCmU4Cksj/6e9e0ZAnwpCrIJ16OChUNnXte9S1vkcNKl/IrFjbM+PWOps5Xy0cUv0pgv6RTSxE2QpCZOGLmQAP4rDgcBcj/IEDVOlOKTQ64Hd6Zp3rT+3M+G0sBAqdirdIdzy/B1tKhtbWZxvCd9lSRHXYRCh6pTuzuLgTT7azFalZhCCdNGj7z22IoLRE0L9p01SJvKTDAoarnbi1JRYY7htXWZppjOjj8bwn5c7uyFkc1woY3qmSpgeBABZ/mQYuXnVd1i7CHx7yhUsN+ChgYp3Lc3UW6NIDgVmogUK9Y+xD9U2pk/leusnSRB/sUIR2xK9up+ZtrcB2JvB4HCbtrUCUbEtFXSMLJKKTAEQ0fxJ93+S/DjPBuonxihhGPYsBHwIa3CeO3VEY6C3Tif8QiO4isaki1ToOQzQ3e49Ni4D4BOiYBjvIk4O/oHbDcJfn/w8SwJb9ZBFYjqU8WA6SSU+aXg1cV15fSsN8SwxxgKeptVvuTR2eWJyZNFBkiVWDoXoPBHGPwCl0iOSA0zSK4Rv0czSMkwyOwC8pXls2P6RiZDYLFu6KjAV4JzGwAv00DnZpHRNICNB0If2OEH0P7P2/VjRETkdztOb/amJT6LOpOFBk24y2FZ6LHMga/XmcdSqibGBW8Ml1LEvE/ZvCbDIbxaFedm5hAJr+GkR8xYrFQ3vaaVvVIjvPRLzy796xJxXV0m/nuqCeCGTdxWKZCsy5uvO5pRncpMKzRqFM8LlTApIaqG5/KBwm2s/ibc42NP+rTOR4o4SNui+xsSyGf6MS2u63xoEAqxMMKeXSdpUcemoeVGdDlveu3AMJtKOjiqKxGZ5FGkoQTDKVOFCOtgtJWkKc6J7pnrffVGS0Q4We6ZWFi111Nj4YevPGnDFhZdNB9a6/cTgZ+Ch6dLucoAIiwxqCZqHRAZJsItxV4RKN7FQp0HvvwH190Vr4LgtuTfhO1LiSxg8+iEV9+rXd5EDROooJJjStb3HDtcvA8iTn6hQBsEJQOlmibx+gVIPm2QbwBBdcIwPvs/RokbCiFAwqaZEHTtc9y5CYCsa6CbxKQdgBpZO9+EUV4LhAtAoTVcXn2q8FDQ2NFX0OscQpmVyfgdHm1SUCdY9ki4F5D5oc2bITCYt1jjTMejTyfcbyYhaOQtnqRtSKyFYR1uv2mkL/LSf6shRuuvrb/gi4GskXbkLQFANcXwdZCW7QPEWgDo4vzeHZrAXhT776tXgtsBD9klA/ietCvppTf0ZNHjp7aeZ9Hf7FuPgOBbSy+3WGuicEtAMAJgPSEEHzAIKsEeRUL9prtASxsu34rUuoiZj9HGBtieWo9LMshon+zQdiqtOy4V34unr8tIs9raInFdziINjDkFkDoJgrBfwpgLHdAXoXebuvdjsc+vPohCXJnMfADwKzxqO2xHI08iwLfMhLeCGi62wh+tWLAZHdOPAoo0ko1gpuvWldFKRgMeejyuY1Nj2+Z2aZqsur1VFlneVoizmJHw4BoCXyne+bTi5upMDfYNLqzmjvdAA63by1av7JZV4911ZtqqooDNdmcRdO5zT2+ZabOkPp0mlaltCoaBlW5Fl8uQ4L2klUtm3UNrBeZ+FHg71IOxjyyOZT7/rpm3QuVXWXl6Y4wV7S9fduu8iflayGTLqlJFSW8RDmbTwKMSR5dbGSbSmmeLreDWkfu6Fq69NZ4A1RPHjx5yDWlg4rLbVJPcUOuox4yfUIBtRXTSsvDg6p8xGm0tG195XvNy5bNi2phdmlJTWthRsoNGzr7gzyhM2nI9cMdlVSIxfwBYVGzapyEz+T+V8NuKSmxVB2FUZHJBS396SQ87o6OrsYvPzg8oLPDDAlKMO87O5t0x8DYsXOD4ZtbSpPygxpy/kH457buRbqE+j5474R5E9tgziKBTJ/g3D7YlH2W5X1V8CjgLgKQBxAyHx8D2Ge7Zu9nfJ8BTxvMOyINcHYEvtKCoRzkyxpgy+N7v4g/vRzuE+Bph7u/lQaaiQDDQtBFBXXVwo01MFxPfj766e2evbtlfRzmvZHVzXDncSVgf2OBynPJRmzQvRZWA/LNLsQzyvJX/F+t0e6NIthreSrM+/dWDksA69IQFICjfCriFUghBMMh73Tr6P7rLyCBvR48DsyIJPi3K/kwUdWu0ven/fklsNeDxwCuTJYt+otDg0SG8YP+6fvfPxkJ7PXgceAezkG0thjC+CcKVCwKphJIgQN+Jwc8/5MR1X4q/SWw14NnIHxnFYCZEoFfHoKBEgjjny9w4F/Lg0w9AL6zrn+j9r9/MhLY62dbiRgEbh3kobg2CzJKANaVQvgcwiWbk+/773suARFBxP/9kWycP39+UUtLy4grrrji/Tlz5lRba91ll10WH+r6OHbmzp1bjIhfAIDAGPPmlClTNiT577777lOttXrGavCll176bJKu90wmo0dsXCbTdz9xkueuu+4a65xz06dPfzNJmzdv3hG5NIzIWmy6+sLLCufBku9/7vsTTzyROuuss3L33HPPwQMGDGiYPHlynzUs5c85t2HatGnb7rnnnlHMnJo6derKP4av22+/PTV9+vTc3Llza7z3bVpH/3LauXfccUc4fPhwaWlpGdXc3PzB7uSnZbXOoqKicYiYFpH38vn8wFQq1X7ppZcWtpree++96Ysvvjh73333HZHNZg9vbm5e8HF19udJ31EJBUFwJSI+CQBnGGOeEZFKZm621q6OomgAEW1zzlWEYaiLeZWNjY3PV1RUHBSG4TcA4FfOuXZEzBUXF29ob28fYYw5U0QaiOgzU6dOnTV79uxSY8yJItJijNGTDBtF5MkgCI7y3je0tbWtHThwYC0AbPbeHwkAO7LZ7HupVKqxvLy8ffv27dch4rt6UlNE9DDaViLaICLlYRge0NLS8mx5eXmlnvZk5m3W2nVRFB0MAFsQcZiu0peUlGzo7Ow8WkSKRGS99/5AY8yrRDQIEbXDu7z3rZq/s7PzmZKSksOJ6ICurq53ioqK/pGZn1R6zPyUtfYoIiry3j97+eWXd86bN2+OiKxqamq6taqq6t9E5J0gCO7N5/OnIOKbRNSu7VLa2Wz2+VQqNdhae6j3fhkRXW6t/TCfz7dYa5sQcZD3frB+s9aOVLl677W93xOR+cw8CABeCMNwrLaViHTvz7FENKC9vf2N6dOnr1cgAsCVRLTYOXesMcYx89uIuEnbZ4xZwczXEtGT3vtziehVZn5eRMY4516y1qpMVG47vPfDrLURIm5DxOEA8PyUKVPaFDzmySef9JMmTdosIj8kopdF5FBEVCEe7r0/GhFVYO3W2tNF5HgRCcaOHfv6li1byo0xpyPiDhEZRESfy+VyCpjzELGdiHQlfMDixYtfnjBhwhgRmQIAK3s6qtkY0+q9/7wCVgVJRFnnnPKhh+fOsdZCGIavhWHInZ2dX0DEdcqL7vonomOwe5fxZwGgI51O/7X3foz3fgMiThSJj/WeYK1Veocx89lRpO3HcQDx1g49tNis7yJyAjM7RDwJEVWbjkilUtpBISKebq0tR8Qh2pkAcIwxRoVaxcwNQRBsOe6441xpaakCdeSAAQMqmLlUBwkAaL2rEHG8iIxGxKMQsS0Mw/FE9MWekysnGWP0lMoapSsibUSE3vsvh2H4logcAgA6EHUHgh7PUa17pDFGB53K92Bm/pyInKYDUttw/PHHv1JWVqYD/lgAUMDogNPtLApA3ac8npl1b9QQIlomIjWIqIP5ZAB4Xzfx9chJLcQhiDhQ+VeFAgCKhYrFixe/q+CJHeYpU6a8h4hrAUATU8ysy/4qbSEiNWXayVrJdiJ64Utf+pIKO1ANICJvGmO000cAgAqjBBH1xzl06SPedoCITUT0GiKegYhbgyDocs7pvulDRaRaRxszt1prO3RE6457NXkaSF6xYoUa5FJmVuH/joh0n+0bzLyBiJRHFWIxEXkiUh8oK6Js03NRFI323h8DACogPSf+BxF5xhjzHkD8Ewj624Vah55H1/Pm2pY3RORIZj4NEZW3ImbeSBT/OFSgpkC1lI7Kjo4OHDNmjB4BZu/9EhE5Q0SeICI1F0ZNNxHpHmOVxWtBEDwHAGXaESIy3BijB+uanHNZZjbMHHrvVYa/9t6PQsQTlHc9laBag4hU7qHu+tN2i0jeGFOsWi8Mw99oo0877TQKgkBFONIYo4Cc3wPm0cw8Xs/caR8p2PL5fJu2jZmbtEBPv2u/qkyeUQUgIi8j4mv5fP71KIqWMXPhZGxhbcs5V5/L5dYWFxfrCUTt2DXbt29/uby8fDwA6Gh62nvv8vn8lhh1RLrx6pHLLrvsHTV96XR6iLU27b3X/cL66xGdiBhv+s7n82iM2crMbyHiBuecjp6lIqKH/Dudc38IguBk55yakt97739tra3K5/MDMpnMjtmzZy/q7OxccfXVV3fcf//9lV1dXdopK5m5zBhTmc/nb0+lUl8Ukb9V9cLM+stfqj3JGIP5fD5yzr2XTqe5vb29tbS0dGkYhgrgeG9zGIatuVxuWRRF29PptA4erb/COVdORG9r+1WNW2t/G0XRe0EQnEpER6ZSqQ2TJ0/2P/vZz16w1n4gIvEG8mw228LMWWvtyUSkbWnNZrPqG3YYYx5xzrEx5jDNLyLFAHA4M79orc2qBuoZLB/oYGFmBezvVWt570Nm/jUiNitO1HQbY9ScKshVu/yutraWV65cqZ1+2yWXXBL/KIX6p7GZMaYxn8+Xqex6/KHhupEslUp94JxTs3Q0ET3qvR9gjFGT/7L3fov+qenq6ffYZOnzPjPbUmY/7pozZ44C8lgVtAL64/Lu/7ZfAvsl8BeWwH8DkAsuTQgH8xEAAAAASUVORK5CYII=";
	        }
	    }
	};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var api = ("https://beta-yeti-api.automatad.com/") + 'v1/domains/';
	
	exports.default = {
	  data: function data() {
	    return {
	      domains: [],
	      current_page: 1,
	      bottom: false
	    };
	  },
	
	  methods: {
	    infiniteHandler: function infiniteHandler($state) {
	      var _this = this;
	
	      console.log("running infinite handler");
	      console.log($state);
	      _axios2.default.get(api, {
	        params: {
	          page: this.current_page
	        }
	      }).then(function (_ref) {
	        var data = _ref.data;
	
	        if (data.length) {
	          var _domains;
	
	          _this.current_page += 1;
	          (_domains = _this.domains).push.apply(_domains, (0, _toConsumableArray3.default)(data));
	          $state.loaded();
	          window.setTimeout(function () {
	            _letterAvatar2.default.transform();
	          });
	        } else {
	          console.log("completed---!!!!!!");
	          $state.complete();
	        }
	      }).catch(function (error) {
	        module.status = error.response.data.status;
	        $state.complete();
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(257)(module)))

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      publisher: [],
	      bottom: false,
	      frmdata: new FormData(),
	      taxFile: "",
	      downloadurl: "",
	      dialogVisible: false,
	      UploadScreenVisible: false,
	      publisherid: "",
	      uploading: false,
	      publisherinitiateid: "",
	      pubidcontract: "",
	      contractvisiblescreen: false,
	      pubidforemail: "",
	      searchvalue: "",
	      contract: "",
	      currentPage: 1,
	      total_pages: 0,
	      offset: 20,
	      issearch: false,
	      bankInfoScreenVisible: false,
	      EditScreenVisible: false,
	      bankDetail: "charmi shah",
	      iscopied: false,
	      editPubForm: {
	        name: "",
	        email: "",
	        uuid: "",
	        ownerid: "",
	        amp_ss_enable: false
	      }
	    };
	  },
	
	  created: function created() {
	    this.loadPublishers();
	  },
	
	  methods: {
	    copiedToClipboard: function copiedToClipboard() {
	      console.log("iscopied", this.iscopied);
	      this.iscopied = false;
	      var elm = document.getElementById("divClipboard");
	
	
	      if (document.body.createTextRange) {
	        var range = document.body.createTextRange();
	        range.moveToElementText(elm);
	        range.select();
	        document.execCommand("Copy");
	
	        this.iscopied = true;
	      } else if (window.getSelection) {
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	        range.selectNodeContents(elm);
	        selection.removeAllRanges();
	        selection.addRange(range);
	        document.execCommand("Copy");
	        this.iscopied = true;
	      }
	    },
	    showBankInfoScreenVisiblefuncton: function showBankInfoScreenVisiblefuncton(obj) {
	      if (window.getSelection) {
	        var selection = window.getSelection();
	        selection.removeAllRanges();
	      }
	      this.iscopied = false;
	      console.log("obj of bank detail", obj);
	      this.bankInfoScreenVisible = true;
	      this.bankDetail = obj.payment_details;
	      if ((0, _keys2.default)(this.bankDetail).length == 0) {
	        this.bankDetail = "Bank details are not available”";
	      }
	    },
	    closeBankInfoScreen: function closeBankInfoScreen() {
	      this.bankInfoScreenVisible = false;
	    },
	    closeEditScreen: function closeEditScreen() {
	      this.EditScreenVisible = false;
	    },
	    showEditScreenVisiblefuncton: function showEditScreenVisiblefuncton(pubobj) {
	      console.log("@@pubobj", pubobj);
	      this.EditScreenVisible = true;
	
	      this.editPubForm.name = pubobj.name;
	      this.editPubForm.email = pubobj.contact_email;
	
	      this.editPubForm.uuid = pubobj.uuid;
	      this.editPubForm.ownerid = pubobj.owner_id;
	      this.editPubForm.amp_ss_enable = pubobj.amp_ss_enable;
	    },
	    EditPublisher: function EditPublisher() {
	      var _this = this;
	
	      var self = this;
	      var apiEditPub = ("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.editPubForm.uuid + "/";
	      var x = {
	        name: this.editPubForm.name,
	        contact_email: this.editPubForm.email,
	        owner: this.editPubForm.ownerid,
	        amp_ss_enable: this.editPubForm.amp_ss_enable
	      };
	      _axios2.default.put(apiEditPub, x).then(function (response) {
	        console.log("response", response.data.publisher_exists);
	        if (response.data.publisher_exists == true) {
	          _this.$notify({
	            title: "fail",
	            message: "publisher already exist.",
	            type: "fail"
	          });
	          return;
	        } else {
	          console.log("false part");
	          _this.userEdit();
	        }
	        _this.loadPublishers(_this.currentPage);
	        _this.$notify({
	          title: "Success",
	          message: "Publisher Updated successfully.",
	          type: "success"
	        });
	        _this.EditScreenVisible = false;
	        setTimeout(function () {}, 1000);
	      }).catch(function (error) {
	        _this.$notify({
	          title: "Warning",
	          message: "Unable to update  publisher",
	          type: "warning"
	        });
	      });
	    },
	    userEdit: function userEdit() {
	      var _this2 = this;
	
	      var self = this;
	      console.log("calling pub uodate");
	      var splitName = this.editPubForm.name.split(" "),
	          firstName = splitName[0],
	          lastName = void 0;
	      if (splitName.length > 1) {
	        splitName.shift();
	        lastName = splitName.join(" ");
	      } else lastName = splitName[0];
	      _axios2.default.put(("https://beta-yeti-api.automatad.com/") + "v1/users/" + this.editPubForm.ownerid + "/", {
	        first_name: firstName,
	        last_name: lastName,
	        email: this.editPubForm.email
	      }).then(function (response) {}).catch(function (error) {
	        _this2.$notify({
	          title: "Warning",
	          message: "Unable to update publisher",
	          type: "warning"
	        });
	      });
	    },
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.currentPage = val;
	      if (this.issearch) {
	        this.filterByEachInput();
	      } else {
	        this.loadPublishers(val);
	      }
	    },
	    filterByEachInput: function filterByEachInput() {
	      var _this3 = this;
	
	      this.currentPage = 1;
	
	      this.issearch = true;
	
	      if (this.searchvalue.length == 0) {
	        this.issearch = false;
	        var apis = ("https://beta-yeti-api.automatad.com/") + ("v1/publishers/?page=1&&offset=" + this.offset);
	        _axios2.default.get(apis).then(function (response) {
	          var _publisher;
	
	          _this3.publisher = [];
	          var dt = response.data.pub_data;
	          (_publisher = _this3.publisher).push.apply(_publisher, (0, _toConsumableArray3.default)(dt));
	          _this3.total_pages = response.data.total;
	        });
	
	        return;
	      }
	
	      _axios2.default.get("v1/search-publisher/?query=" + this.searchvalue + "&&page=" + this.currentPage + "&&offset=" + this.offset).then(function (response) {
	        var _publisher2;
	
	        var data = response.data.pub_data;
	        _this3.publisher = [];
	        (_publisher2 = _this3.publisher).push.apply(_publisher2, (0, _toConsumableArray3.default)(data));
	        _this3.total_pages = response.data.total;
	      });
	    },
	    confirmIntenttNividEmailSend: function confirmIntenttNividEmailSend(data) {
	      var _this4 = this;
	
	      this.$confirm('This service is intended only for External publishers live with Intentt. Yeti Pubs receive activation email with Contract. Continue?', 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        console.log('pass');
	        _this4.sendNividActivateEmail(data);
	      }).catch(function () {
	        _this4.$message({
	          type: 'info',
	          message: 'Action cancelled'
	        });
	      });
	    },
	    sendNividActivateEmail: function sendNividActivateEmail(obj) {
	      var _this5 = this;
	
	      console.log("obj", obj);
	
	      this.pubidforemail = obj.id;
	      var em = obj.contact_email;
	      var self = this;
	      console.log({
	        email: em,
	        activateOrReset: "activate"
	      });
	
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/auth/password/reset/nivid/", {
	        email: em,
	        activateOrReset: "activate"
	      }).then(function (res) {
	        console.log("@@Res", res);
	        self.$notify({
	          title: "Success",
	          message: "Email for Account Activation sent!",
	          type: "success"
	        });
	        _this5.loadPublishers(_this5.currentPage);
	      }).catch(function (e) {
	        _this5.uploading = false;
	        self.$notify({
	          title: "Fail",
	          message: "Failed to send email of Account Activation.",
	          type: "fail"
	        });
	      });
	    },
	    confirmSendWelcomeEmail: function confirmSendWelcomeEmail(row) {
	      var _this6 = this;
	
	      this.$confirm(row.welcome_mail_sent ? 'The contract and activation email have already been sent to the pub. Send again anyway?' : 'Yeti Pubs receive account activation email with Contract. Continue?', 'Warning', {
	        confirmButtonText: 'Confirm',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        console.log('pass');
	        _this6.sentemail(row);
	      }).catch(function () {
	        _this6.$message({
	          type: 'info',
	          message: 'Action cancelled'
	        });
	      });
	    },
	    sentemail: function sentemail(obj) {
	      var _this7 = this;
	
	      console.log("obj", obj);
	
	      this.pubidforemail = obj.id;
	
	      var em = obj.contact_email;
	      var self = this;
	      var api = ("https://beta-yeti-api.automatad.com/") + "v1/send-email-publisher/" + this.pubidforemail + "/";
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/auth/password/reset/nivid/", {
	        email: em,
	        activateOrReset: "activate"
	      }).then(function (res) {
	        console.log("@@Res", res);
	        _this7.loadPublishers(_this7.currentPage);
	      }).catch(function (e) {
	        _this7.uploading = false;
	        self.$notify({
	          title: "Fail",
	          message: "Failed to send email of Account Activation.",
	          type: "fail"
	        });
	      });
	
	      _axios2.default.get(api).then(function (response) {
	        self.$notify({
	          title: "Success",
	          message: "Email of welcome publisher and Email for Account Activation successfully sent.",
	          type: "success"
	        });
	      }).catch(function (e) {
	        _this7.uploading = false;
	        self.$notify({
	          title: "Fail",
	          message: "Failed to send email of welcome publisher.",
	          type: "fail"
	        });
	      });
	    },
	    dialogVisiblef: function dialogVisiblef(pubid) {
	      this.publisherid = pubid;
	      this.UploadScreenVisible = true;
	    },
	    dialogVisiblecontract: function dialogVisiblecontract(pubid) {
	      this.pubidcontract = pubid;
	      this.contractvisiblescreen = true;
	    },
	
	    cancelUploadAction: function cancelUploadAction() {
	      this.$refs.file.clearFiles();
	      this.contractvisiblescreen = false;
	      this.UploadScreenVisible = false;
	    },
	    handleFileUpload: function handleFileUpload(file) {
	      this.taxFile = file.raw;
	    },
	    handleFileUploadcontract: function handleFileUploadcontract(file) {
	      this.contract = file.raw;
	    },
	    submitcontract: function submitcontract() {
	      var _this8 = this;
	
	      var self = this;
	      var apic = ("https://beta-yeti-api.automatad.com/") + "v1/upload-contract/" + this.pubidcontract + "/";
	
	      if (this.contract.length == 0) {
	        self.$notify({
	          title: "Fail",
	          message: "please select file before uploading",
	          type: "Error"
	        });
	        return;
	      }
	      this.uploading = true;
	      var formData = new FormData();
	      formData.append("contract", this.contract);
	
	      _axios2.default.post(apic, formData, {
	        headers: {
	          "Content-Type": "multipart/form-data"
	        }
	      }).then(function (response) {
	        _this8.loadPublishers(_this8.currentPage);
	        var obj = _this8.publisher.filter(function (obj) {
	          return obj.id == _this8.pubidcontract;
	        });
	        obj[0].contract_details.sign_pdf = response.data.signed_pdf;
	        self.$notify({
	          title: "Success",
	          message: "uploaded  successfully.",
	          type: "success"
	        });
	        _this8.contractvisiblescreen = false;
	        _this8.contract = [];
	        _this8.uploading = false;
	        _this8.$refs.file.clearFiles();
	      }).catch(function (e) {
	        _this8.uploading = false;
	        self.$notify({
	          title: "Fail",
	          message: "uploaded  failed.",
	          type: "fail"
	        });
	      });
	    },
	    submitFile: function submitFile() {
	      var _this9 = this;
	
	      var self = this;
	      var api = ("https://beta-yeti-api.automatad.com/") + "v1/upload-tax-docs/" + this.publisherid + "/";
	      if (this.taxFile.length == 0) {
	        self.$notify({
	          title: "Fail",
	          message: "please select file before uploading",
	          type: "Error"
	        });
	        return;
	      }
	      this.uploading = true;
	      var formData = new FormData();
	      formData.append("taxFile", this.taxFile);
	      _axios2.default.post(api, formData, {
	        headers: {
	          "Content-Type": "multipart/form-data"
	        }
	      }).then(function (response) {
	        self.$notify({
	          title: "Success",
	          message: "uploaded  successfully.",
	          type: "success"
	        });
	
	        _this9.loadPublishers(_this9.currentPage);
	
	        var obj = _this9.publisher.filter(function (obj) {
	          return obj.id == _this9.publisherid;
	        });
	        obj[0].contract_details.tax_pdf = response.data.tax_pdf;
	
	        _this9.UploadScreenVisible = false;
	        _this9.taxFile = [];
	        _this9.uploading = false;
	        _this9.$refs.file.clearFiles();
	      }).catch(function (e) {
	        _this9.uploading = false;
	        self.$notify({
	          title: "Fail",
	          message: "uploaded  failed.",
	          type: "fail"
	        });
	      });
	    },
	
	    clearFilesList: function clearFilesList() {
	      this.$refs.file.clearFiles();
	      this.UploadScreenVisible = false;
	      this.contractvisiblescreen = false;
	    },
	    loadPublishers: function loadPublishers(pageNum) {
	      var _this10 = this;
	
	      if (pageNum == undefined) {
	        pageNum = 1;
	      }
	      var api = ("https://beta-yeti-api.automatad.com/") + ("v1/publishers/?page=" + pageNum + "&&offset=" + this.offset);
	      _axios2.default.get(api).then(function (response) {
	        var _publisher3;
	
	        var data = response.data.pub_data;
	
	        _this10.publisher = [];
	        (_publisher3 = _this10.publisher).push.apply(_publisher3, (0, _toConsumableArray3.default)(data));
	
	        var totalpg = response.data.total;
	        _this10.total_pages = totalpg;
	      });
	    }
	  }
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            publisher: [],
	            bottom: false,
	            frmdata: new FormData(),
	            taxFile: '',
	            downloadurl: "",
	            dialogVisible: false,
	            UploadScreenVisible: false,
	            publisherid: '',
	            uploading: false,
	            publisherinitiateid: '',
	            pubidcontract: '',
	            contractvisiblescreen: false,
	            pubidforemail: '',
	            searchvalue: '',
	            contract: '',
	            currentPage: 1,
	            total_pages: 0,
	            offset: 20,
	            issearch: false
	
	        };
	    },
	
	    created: function created() {
	        this.loadPublishers();
	    },
	
	    methods: {
	        handleCurrentChange: function handleCurrentChange(val) {
	
	            this.currentPage = val;
	            if (this.issearch) {
	                this.filterByEachInput();
	            } else {
	                this.loadPublishers(val);
	            }
	        },
	        filterByEachInput: function filterByEachInput() {
	            var _this = this;
	
	            this.issearch = true;
	
	            if (this.searchvalue.length == 0) {
	                this.issearch = false;
	                var apis = ("https://beta-yeti-api.automatad.com/") + ('bidder/v1/domain-list/?page=' + this.currentPage + '&offset=' + this.offset);
	                _axios2.default.get(apis).then(function (response) {
	                    var _publisher;
	
	                    _this.publisher = [];
	                    var dt = response.data.data;
	                    console.log(dt, response);
	                    (_publisher = _this.publisher).push.apply(_publisher, (0, _toConsumableArray3.default)(dt));
	                    _this.total_pages = response.data.total;
	                });
	
	                return;
	            }
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('bidder/v1/domain-search/?query=' + this.searchvalue + '&&page=' + this.currentPage + '&&offset=' + this.offset);
	
	            _axios2.default.get(api).then(function (response) {
	                var _publisher2;
	
	                var data = response.data.data;
	                _this.publisher = [];
	                (_publisher2 = _this.publisher).push.apply(_publisher2, (0, _toConsumableArray3.default)(data));
	                _this.total_pages = response.data.total;
	            });
	        },
	        loadPublishers: function loadPublishers(pageNum) {
	            var _this2 = this;
	
	            if (pageNum == undefined) {
	                pageNum = 1;
	            }
	            var api1 = ("https://beta-yeti-api.automatad.com/") + ('bidder/v1/domain-list/?page=' + pageNum + '&&offset=' + this.offset);
	            _axios2.default.get(api1).then(function (response) {
	                var _publisher3;
	
	                var data = response.data.data;
	                _this2.publisher = [];
	                (_publisher3 = _this2.publisher).push.apply(_publisher3, (0, _toConsumableArray3.default)(data));
	
	                var totalpg = response.data.total;
	                _this2.total_pages = totalpg;
	
	                console.log("response of api1", response.data);
	            });
	        }
	    }
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				selectedCategories: [],
				blockcategories: [{ "label": "Arts & Entertainment", "id": "0", "children": [{ "label": "Books & Literature", "id": "2" }, { "label": "Celebrity Fan/Gossip", "id": "3" }, { "label": "Fine Art", "id": "4" }, { "label": "Humor", "id": "5" }, { "label": "Movies", "id": "6" }, { "label": "Music", "id": "7" }, { "label": "Television", "id": "8" }] }, { "label": "Automotive", "id": "0", "children": [{ "label": "Auto Parts", "id": "10" }, { "label": "Auto Repair", "id": "11" }, { "label": "Buying/Selling Cars", "id": "12" }, { "label": "Car Culture", "id": "13" }, { "label": "Certified Pre-Owned", "id": "14" }, { "label": "Convertible", "id": "15" }, { "label": "Coupe", "id": "16" }, { "label": "Crossover", "id": "17" }, { "label": "Diesel", "id": "18" }, { "label": "Electric Vehicle", "id": "19" }, { "label": "Hatchback", "id": "20" }, { "label": "Hybrid", "id": "21" }, { "label": "Luxury", "id": "22" }, { "label": "MiniVan", "id": "23" }, { "label": "Mororcycles", "id": "24" }, { "label": "Off-Road Vehicles", "id": "25" }, { "label": "Performance Vehicles", "id": "26" }, { "label": "Pickup", "id": "27" }, { "label": "Road-Side Assistance", "id": "28" }, { "label": "Sedan", "id": "29" }, { "label": "Trucks & Accessories", "id": "30" }, { "label": "Vintage Cars", "id": "31" }, { "label": "Wagon", "id": "32" }] }, { "label": "Business", "id": "0", "children": [{ "label": "Advertising", "id": "34" }, { "label": "Agriculture", "id": "35" }, { "label": "Biotech/Biomedical", "id": "36" }, { "label": "Business Software", "id": "37" }, { "label": "Construction", "id": "38" }, { "label": "Forestry", "id": "39" }, { "label": "Government", "id": "40" }, { "label": "Green Solutions", "id": "41" }, { "label": "Human Resources", "id": "42" }, { "label": "Logistics", "id": "43" }, { "label": "Marketing", "id": "44" }, { "label": "Metals", "id": "45" }] }, { "label": "Careers", "id": "0", "children": [{ "label": "Career Planning", "id": "47" }, { "label": "College", "id": "48" }, { "label": "Financial Aid", "id": "49" }, { "label": "Job Fairs", "id": "50" }, { "label": "Job Search", "id": "51" }, { "label": "Resume Writing/Advice", "id": "52" }, { "label": "Nursing", "id": "53" }, { "label": "Scholarships", "id": "54" }, { "label": "Telecommuting", "id": "55" }, { "label": "U.S. Military", "id": "56" }, { "label": "Career Advice", "id": "57" }] }, { "label": "Education", "id": "0", "children": [{ "label": "7-12 Education", "id": "59" }, { "label": "Adult Education", "id": "60" }, { "label": "Art History", "id": "61" }, { "label": "Colledge Administration", "id": "62" }, { "label": "College Life", "id": "63" }, { "label": "Distance Learning", "id": "64" }, { "label": "English as a 2nd Language", "id": "65" }, { "label": "Language Learning", "id": "66" }, { "label": "Graduate School", "id": "67" }, { "label": "Homeschooling", "id": "68" }, { "label": "Homework/Study Tips", "id": "69" }, { "label": "K-6 Educators", "id": "70" }, { "label": "Private School", "id": "71" }, { "label": "Special Education", "id": "72" }, { "label": "Studying Business", "id": "73" }] }, { "label": "Family & Parenting", "id": "0", "children": [{ "label": "Adoption", "id": "75" }, { "label": "Babies & Toddlers", "id": "76" }, { "label": "Daycare/Pre School", "id": "77" }, { "label": "Family Internet", "id": "78" }, { "label": "Parenting - K-6 Kids", "id": "79" }, { "label": "Parenting teens", "id": "80" }, { "label": "Pregnancy", "id": "81" }, { "label": "Special Needs Kids", "id": "82" }, { "label": "Eldercare", "id": "83" }] }, { "label": "Health & Fitness", "id": "0", "children": [{ "label": "Exercise", "id": "85" }, { "label": "A.D.D.", "id": "86" }, { "label": "AIDS/HIV", "id": "87" }, { "label": "Allergies", "id": "88" }, { "label": "Alternative Medicine", "id": "89" }, { "label": "Arthritis", "id": "90" }, { "label": "Asthma", "id": "91" }, { "label": "Autism/PDD", "id": "92" }, { "label": "Bipolar Disorder", "id": "93" }, { "label": "Brain Tumor", "id": "94" }, { "label": "Cancer", "id": "95" }, { "label": "Cholesterol", "id": "96" }, { "label": "Chronic Fatigue Syndrome", "id": "97" }, { "label": "Chronic Pain", "id": "98" }, { "label": "Cold & Flu", "id": "99" }, { "label": "Deafness", "id": "100" }, { "label": "Dental Care", "id": "101" }, { "label": "Depression", "id": "102" }, { "label": "Dermatology", "id": "103" }, { "label": "Diabetes", "id": "104" }, { "label": "Epilepsy", "id": "105" }, { "label": "GERD/Acid Reflux", "id": "106" }, { "label": "Headaches/Migraines", "id": "107" }, { "label": "Heart Disease", "id": "108" }, { "label": "Herbs for Health", "id": "109" }, { "label": "Holistic Healing", "id": "110" }, { "label": "IBS/Crohn's Disease", "id": "111" }, { "label": "Incest/Abuse Support", "id": "112" }, { "label": "Incontinence", "id": "113" }, { "label": "Infertility", "id": "114" }, { "label": "Men's Health", "id": "115" }, { "label": "Nutrition", "id": "116" }, { "label": "Orthopedics", "id": "117" }, { "label": "Panic/Anxiety Disorders", "id": "118" }, { "label": "Pediatrics", "id": "119" }, { "label": "Physical Therapy", "id": "120" }, { "label": "Psychology/Psychiatry", "id": "121" }, { "label": "Senor Health", "id": "122" }, { "label": "Sexuality", "id": "123" }, { "label": "Sleep Disorders", "id": "124" }, { "label": "Smoking Cessation", "id": "125" }, { "label": "Substance Abuse", "id": "126" }, { "label": "Thyroid Disease", "id": "127" }, { "label": "Weight Loss", "id": "128" }, { "label": "Women's Health", "id": "129" }] }, { "label": "Food & Drink", "id": "0", "children": [{ "label": "American Cuisine", "id": "131" }, { "label": "Barbecues & Grilling", "id": "132" }, { "label": "Cajun/Creole", "id": "133" }, { "label": "Chinese Cuisine", "id": "134" }, { "label": "Cocktails/Beer", "id": "135" }, { "label": "Coffee/Tea", "id": "136" }, { "label": "Cuisine-Specific", "id": "137" }, { "label": "Desserts & Baking", "id": "138" }, { "label": "Dining Out", "id": "139" }, { "label": "Food Allergies", "id": "140" }, { "label": "French Cuisine", "id": "141" }, { "label": "Health/Lowfat Cooking", "id": "142" }, { "label": "Italian Cuisine", "id": "143" }, { "label": "Japanese Cuisine", "id": "144" }, { "label": "Mexican Cuisine", "id": "145" }, { "label": "Vegan", "id": "146" }, { "label": "Vegetarian", "id": "147" }, { "label": "Wine", "id": "148" }] }, { "label": "Hobbies & Interests", "id": "0", "children": [{ "label": "Art/Technology", "id": "150" }, { "label": "Arts & Crafts", "id": "151" }, { "label": "Beadwork", "id": "152" }, { "label": "Birdwatching", "id": "153" }, { "label": "Board Games/Puzzles", "id": "154" }, { "label": "Candle & Soap Making", "id": "155" }, { "label": "Card Games", "id": "156" }, { "label": "Chess", "id": "157" }, { "label": "Cigars", "id": "158" }, { "label": "Collecting", "id": "159" }, { "label": "Comic Books", "id": "160" }, { "label": "Drawing/Sketching", "id": "161" }, { "label": "Freelance Writing", "id": "162" }, { "label": "Genealogy", "id": "163" }, { "label": "Getting Published", "id": "164" }, { "label": "Guitar", "id": "165" }, { "label": "Home Recording", "id": "166" }, { "label": "Investors & Patents", "id": "167" }, { "label": "Jewelry Making", "id": "168" }, { "label": "Magic & Illusion", "id": "169" }, { "label": "Needlework", "id": "170" }, { "label": "Painting", "id": "171" }, { "label": "Photography", "id": "172" }, { "label": "Radio", "id": "173" }, { "label": "Roleplaying Games", "id": "174" }, { "label": "Sci-Fi & Fantasy", "id": "175" }, { "label": "Scrapbooking", "id": "176" }, { "label": "Screenwriting", "id": "177" }, { "label": "Stamps & Coins", "id": "178" }, { "label": "Video & Computer Games", "id": "179" }, { "label": "Woodworking", "id": "180" }] }, { "label": "Home & Garden", "id": "0", "children": [{ "label": "Appliances", "id": "182" }, { "label": "Entertaining", "id": "183" }, { "label": "Environmental Safety", "id": "184" }, { "label": "Gardening", "id": "185" }, { "label": "Home Repair", "id": "186" }, { "label": "Home Theater", "id": "187" }, { "label": "Interior Decorating", "id": "188" }, { "label": "Landscaping", "id": "189" }, { "label": "Remodeling & Construction", "id": "190" }] }, { "label": "Law, Gov't & Politics", "id": "0", "children": [{ "label": "Immigration", "id": "192" }, { "label": "Legal Issues", "id": "193" }, { "label": "U.S. Government Resources", "id": "194" }, { "label": "Politics", "id": "195" }, { "label": "Commentary", "id": "196" }] }, { "label": "News", "id": "0", "children": [{ "label": "International News", "id": "198" }, { "label": "National News", "id": "199" }, { "label": "Local News", "id": "200" }] }, { "label": "Personal Finance", "id": "0", "children": [{ "label": "Beginning Investing", "id": "202" }, { "label": "Credit/Debt & Loans", "id": "203" }, { "label": "Financial News", "id": "204" }, { "label": "Financial Planning", "id": "205" }, { "label": "Hedge Fund", "id": "206" }, { "label": "Insurance", "id": "207" }, { "label": "Investing", "id": "208" }, { "label": "Mutual Funds", "id": "209" }, { "label": "Options", "id": "210" }, { "label": "Retirement Planning", "id": "211" }, { "label": "Stocks", "id": "212" }, { "label": "Tax Planning", "id": "213" }] }, { "label": "Society", "id": "0", "children": [{ "label": "Dating", "id": "215" }, { "label": "Divorce Support", "id": "216" }, { "label": "Gay Life", "id": "217" }, { "label": "Marriage", "id": "218" }, { "label": "Senior Living", "id": "219" }, { "label": "Teens", "id": "220" }, { "label": "Weddings", "id": "221" }, { "label": "Ethnic Specific", "id": "222" }] }, { "label": "Science", "id": "0", "children": [{ "label": "Astrology", "id": "224" }, { "label": "Biology", "id": "225" }, { "label": "Chemistry", "id": "226" }, { "label": "Geology", "id": "227" }, { "label": "Paranormal Phenomena", "id": "228" }, { "label": "Physics", "id": "229" }, { "label": "Space/Astronomy", "id": "230" }, { "label": "Geography", "id": "231" }, { "label": "Botany", "id": "232" }, { "label": "Weather", "id": "233" }] }, { "label": "Pets", "id": "0", "children": [{ "label": "Aquariums", "id": "235" }, { "label": "Birds", "id": "236" }, { "label": "Cats", "id": "237" }, { "label": "Dogs", "id": "238" }, { "label": "Large Animals", "id": "239" }, { "label": "Reptiles", "id": "240" }, { "label": "Veterinary Medicine", "id": "241" }] }, { "label": "Sports", "id": "0", "children": [{ "label": "Auto Racing", "id": "243" }, { "label": "Baseball", "id": "244" }, { "label": "Bicycling", "id": "245" }, { "label": "Bodybuilding", "id": "246" }, { "label": "Boxing", "id": "247" }, { "label": "Canoeing/Kayaking", "id": "248" }, { "label": "Cheerleading", "id": "249" }, { "label": "Climbing", "id": "250" }, { "label": "Cricket", "id": "251" }, { "label": "Figure Skating", "id": "252" }, { "label": "Fly Fishing", "id": "253" }, { "label": "Football", "id": "254" }, { "label": "Freshwater Fishing", "id": "255" }, { "label": "Game & Fish", "id": "256" }, { "label": "Golf", "id": "257" }, { "label": "Horse Racing", "id": "258" }, { "label": "Horses", "id": "259" }, { "label": "Hunting/Shooting", "id": "260" }, { "label": "Inline Skating", "id": "261" }, { "label": "Martial Arts", "id": "262" }, { "label": "Mountain Biking", "id": "263" }, { "label": "NASCAR Racing", "id": "264" }, { "label": "Olympics", "id": "265" }, { "label": "Paintball", "id": "266" }, { "label": "Power & Motorcycles", "id": "267" }, { "label": "Pro Basketball", "id": "268" }, { "label": "Pro Ice Hockey", "id": "269" }, { "label": "Rodeo", "id": "270" }, { "label": "Rugby", "id": "271" }, { "label": "Running/Jogging", "id": "272" }, { "label": "Sailing", "id": "273" }, { "label": "Saltwater Fishing", "id": "274" }, { "label": "Scuba Diving", "id": "275" }, { "label": "Skateboarding", "id": "276" }, { "label": "Skiing", "id": "277" }, { "label": "Snowboarding", "id": "278" }, { "label": "Surfing/Bodyboarding", "id": "279" }, { "label": "Swimming", "id": "280" }, { "label": "Table Tennis/Ping-Pong", "id": "281" }, { "label": "Tennis", "id": "282" }, { "label": "Volleyball", "id": "283" }, { "label": "Walking", "id": "284" }, { "label": "Waterski/Wakeboard", "id": "285" }, { "label": "World Soccer", "id": "286" }] }, { "label": "Style & Fashion", "id": "0", "children": [{ "label": "Beauty", "id": "288" }, { "label": "Body Art", "id": "289" }, { "label": "Fashion", "id": "290" }, { "label": "Jewelry", "id": "291" }, { "label": "Clothing", "id": "292" }, { "label": "Accessories", "id": "293" }] }, { "label": "Technology & Computing", "id": "0", "children": [{ "label": "3-D Graphics", "id": "295" }, { "label": "Animation", "id": "296" }, { "label": "Antivirus Software", "id": "297" }, { "label": "C/C++", "id": "298" }, { "label": "Cameras & Camcorders", "id": "299" }, { "label": "Cell Phones", "id": "300" }, { "label": "Computer Certification", "id": "301" }, { "label": "Computer Networking", "id": "302" }, { "label": "Computer Peripherals", "id": "303" }, { "label": "Computer Reviews", "id": "304" }, { "label": "Data Centers", "id": "305" }, { "label": "Databases", "id": "306" }, { "label": "Desktop Publishing", "id": "307" }, { "label": "Desktop Video", "id": "308" }, { "label": "Email", "id": "309" }, { "label": "Graphics Software", "id": "310" }, { "label": "Home Video/DVD", "id": "311" }, { "label": "Internet Technology", "id": "312" }, { "label": "Java", "id": "313" }, { "label": "JavaScript", "id": "314" }, { "label": "Mac Support", "id": "315" }, { "label": "MP3/MIDI", "id": "316" }, { "label": "Net Conferencing", "id": "317" }, { "label": "Net for Beginners", "id": "318" }, { "label": "Network Security", "id": "319" }, { "label": "Palmtops/PDAs", "id": "320" }, { "label": "PC Support", "id": "321" }, { "label": "Portable", "id": "322" }, { "label": "Entertainment", "id": "323" }, { "label": "Shareware/Freeware", "id": "324" }, { "label": "Unix", "id": "325" }, { "label": "Visual Basic", "id": "326" }, { "label": "Web Clip Art", "id": "327" }, { "label": "Web Design/HTML", "id": "328" }, { "label": "Web Search", "id": "329" }, { "label": "Windows", "id": "330" }] }, { "label": "Travel", "id": "0", "children": [{ "label": "Adventure Travel", "id": "332" }, { "label": "Africa", "id": "333" }, { "label": "Air Travel", "id": "334" }, { "label": "Australia & New Zealand", "id": "335" }, { "label": "Bed & Breakfasts", "id": "336" }, { "label": "Budget Travel", "id": "337" }, { "label": "Business Travel", "id": "338" }, { "label": "By US Locale", "id": "339" }, { "label": "Camping", "id": "340" }, { "label": "Canada", "id": "341" }, { "label": "Caribbean", "id": "342" }, { "label": "Cruises", "id": "343" }, { "label": "Eastern Europe", "id": "344" }, { "label": "Europe", "id": "345" }, { "label": "France", "id": "346" }, { "label": "Greece", "id": "347" }, { "label": "Honeymoons/Getaways", "id": "348" }, { "label": "Hotels", "id": "349" }, { "label": "Italy", "id": "350" }, { "label": "Japan", "id": "351" }, { "label": "Mexico & Central America", "id": "352" }, { "label": "National Parks", "id": "353" }, { "label": "South America", "id": "354" }, { "label": "Spas", "id": "355" }, { "label": "Theme Parks", "id": "356" }, { "label": "Traveling with Kids", "id": "357" }, { "label": "United Kingdom", "id": "358" }] }, { "label": "Real Estate", "id": "0", "children": [{ "label": "Apartments", "id": "360" }, { "label": "Architects", "id": "361" }, { "label": "Buying/Selling Homes", "id": "362" }] }, { "label": "Shopping", "id": "0", "children": [{ "label": "Contests & Freebies", "id": "364" }, { "label": "Couponing", "id": "365" }, { "label": "Comparison", "id": "366" }, { "label": "Engines", "id": "367" }] }, { "label": "Religion & Spirituality", "id": "0", "children": [{ "label": "Alternative Religions", "id": "369" }, { "label": "Atheism/Agnosticism", "id": "370" }, { "label": "Buddhism", "id": "371" }, { "label": "Catholicism", "id": "372" }, { "label": "Christianity", "id": "373" }, { "label": "Hinduism", "id": "374" }, { "label": "Islam", "id": "375" }, { "label": "Judaism", "id": "376" }, { "label": "Latter-Day Saints", "id": "377" }, { "label": "Pagan/Wiccan", "id": "378" }] }, { "label": "Non-Standard Content", "id": "0", "children": [{ "label": "Unmoderated UGC", "id": "381" }, { "label": "Extreme Graphic/Explicit Violence", "id": "382" }, { "label": "Pornography", "id": "383" }, { "label": "Profane Content", "id": "384" }, { "label": "Hate Content", "id": "385" }, { "label": "Under Construction", "id": "386" }, { "label": "Incentivized", "id": "387" }] }, { "label": "Illegal Content", "id": "0", "children": [{ "label": "Illegal Content", "id": "389" }, { "label": "Warez", "id": "390" }, { "label": "Spyware/Malware", "id": "391" }, { "label": "CopyrightInfringement", "id": "392" }] }, { "label": "Uncategorized", "id": "0", "children": [{ "label": "Uncategorized", "id": "393" }] }],
				"defaultProps": {
					"children": 'children',
					"label": 'label'
				}
			};
		},
	
		created: function created() {
			_axios2.default.all([_axios2.default.get('')]).then(_axios2.default.spread(function (response) {
				console.log();
			}));
		},
	
		methods: {
			handleCheckChange: function handleCheckChange(x, y, z) {
				this.selectedCategories.push({ x: x, y: y, z: z });
				this.selectedCategories.forEach(function (element) {
					console.log(element);
					if (element.y != false) {
						console.log(element);
					}
				});
			}
		}
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _methods;
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        var _ref;
	
	        return _ref = {
	            data: [],
	            searchvalue: '',
	            dialogVisible: false,
	            blockList: '',
	            blockedBackend: '',
	            name: undefined,
	            publishers: [],
	            loading: true,
	            dynamicTags: [],
	            dynamicTagsCopy: [],
	            selectedBlockurls: [],
	            visiblityModelBoxForDeleteAllBlockurls: false,
	            inputVisible: false,
	            inputValue: ''
	        }, (0, _defineProperty3.default)(_ref, 'loading', true), (0, _defineProperty3.default)(_ref, 'currentPage', 1), (0, _defineProperty3.default)(_ref, 'total_pages', 0), (0, _defineProperty3.default)(_ref, 'offset', 20), _ref;
	    },
	    created: function created() {
	        this.getAllUrls();
	    },
	    methods: (_methods = {
	        openDeleteAllBlockUrlsModelBox: function openDeleteAllBlockUrlsModelBox() {
	            var _this = this;
	
	            this.$confirm('This will permanently delete all blocked urls. Continue?', 'Warning', {
	                confirmButtonText: 'OK',
	                cancelButtonText: 'Cancel',
	                type: 'warning'
	            }).then(function () {
	                _this.$message({
	                    type: 'success',
	                    message: 'Delete completed',
	                    action: _this.deleteSelectedUrls(1)
	
	                });
	            }).catch(function () {
	                _this.$message({
	                    type: 'info',
	                    message: 'Delete canceled'
	                });
	            });
	        },
	        deleteSelectedUrls: function deleteSelectedUrls(flag) {
	            var _this2 = this;
	
	            var deleteUrl = ("https://beta-yeti-api.automatad.com/") + ('v1/publisher/' + this.$route.params.uuid + '/domain/' + this.$route.params.domId + '/urls-delete/');
	            if (flag == 1) {
	                var x = {
	                    "blocked_urls": [],
	                    "action": "all"
	                };
	            } else {
	                if (this.selectedBlockurls.length == 0) {
	                    this.$notify('error', 'error', "Please select blockedurls.", {
	                        duration: 3000,
	                        permanent: false
	                    });
	                    return;
	                }
	                var x = {
	
	                    "blocked_urls": this.selectedBlockurls,
	                    "action": "partial"
	                };
	            }
	
	            _axios2.default.post(deleteUrl, x).then(function (res) {
	                console.log(res);
	
	                _this2.selectedBlockurls = [];
	                _this2.getAllUrls(1);
	            });
	        },
	        filterByEachInput: function filterByEachInput() {
	            var _this3 = this;
	
	            console.log("searchvalue", this.searchvalue);
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/UrlSearchApi/domain/' + this.$route.params.domId + '/?searchvalue=' + this.searchvalue)).then(function (response) {
	                console.log("data", response);
	                _this3.dynamicTags = response.data.data;
	                _this3.total_pages = response.data.total;
	                _this3.loading = false;
	            });
	        },
	        getAllUrls: function getAllUrls(pageNum) {
	            var _this4 = this;
	
	            this.loading = true;
	            console.log("hgghuhihiuh============", pageNum);
	            if (pageNum == undefined) {
	                pageNum = 1;
	            }
	            _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publisher/' + this.$route.params.uuid + '/domain/' + this.$route.params.domId + '/urls/?page=' + pageNum + '&offset=' + this.offset))]).then(_axios2.default.spread(function (response) {
	                _this4.dynamicTagsCopy = JSON.parse((0, _stringify2.default)(response.data));
	                _this4.dynamicTags = response.data.data;
	                _this4.total_pages = response.data.total;
	                _this4.loading = false;
	            }));
	        },
	        handleClose: function handleClose(done) {
	            var _this5 = this;
	
	            this.$confirm('Are you sure to close this dialog?').then(function (_) {
	                done();
	                _this5.loading = false;
	            }).catch(function (_) {});
	        },
	        onSubmit: function onSubmit() {
	            var _this6 = this;
	
	            var urls = [];
	            this.dynamicTags.forEach(function (url) {
	                if (!url.id) {
	                    urls.push({
	                        'domain': _this6.$route.params.domId,
	                        'url': url.url
	                    });
	                    _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publisher/' + _this6.$route.params.uuid + '/domain/' + _this6.$route.params.domId + '/urls/', {
	                        'domain': _this6.$route.params.domId,
	                        'url': url.url
	                    }).then(function (response) {
	                        console.log(response);
	                        _this6.getAllUrls();
	                    }).catch(function (error) {});
	                }
	                console.log(urls);
	            });
	        }
	    }, (0, _defineProperty3.default)(_methods, 'handleClose', function handleClose(tag) {
	        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
	    }), (0, _defineProperty3.default)(_methods, 'showInput', function showInput() {
	        var _this7 = this;
	
	        this.inputVisible = true;
	        this.$nextTick(function (_) {
	            _this7.$refs.saveTagInput.$refs.input.focus();
	        });
	    }), (0, _defineProperty3.default)(_methods, 'isValidUrl', function isValidUrl(string) {
	        try {
	            new URL(string);
	            return true;
	        } catch (_) {
	            return false;
	        }
	    }), (0, _defineProperty3.default)(_methods, 'handleCurrentChange', function handleCurrentChange(val) {
	        console.log("Current page#####################", val);
	        this.getAllUrls(val);
	    }), (0, _defineProperty3.default)(_methods, 'handleInputConfirm', function handleInputConfirm() {
	        var _this8 = this;
	
	        var inputValue = this.inputValue;
	
	        var inputValues = inputValue.split('\n');
	        console.log(inputValues);
	        var patt = new RegExp('^(?:(?:https?|ftp)://)(?:S+(?::S*)?@)?(?:(?!(?:10|127)(?:.d{1,3}){3})(?!(?:169.254|192.168)(?:.d{1,3}){2})(?!172.(?:1[6-9]|2d|3[0-1])(?:.d{1,3}){2})(?:[1-9]d?|1dd|2[01]d|22[0-3])(?:.(?:1?d{1,2}|2[0-4]d|25[0-5])){2}(?:.(?:[1-9]d?|1dd|2[0-4]d|25[0-4]))|(?:(?:[a-z\xA1-\uFFFF0-9]-*)*[a-z\xA1-\uFFFF0-9]+)(?:.(?:[a-z\xA1-\uFFFF0-9]-*)*[a-z\xA1-\uFFFF0-9]+)*(?:.(?:[a-z\xA1-\uFFFF]{2,})).?)(?::d{2,5})?(?:[/?#]S*)?$');
	
	        inputValues.forEach(function (val) {
	            if (_this8.isValidUrl(val.trim())) _this8.dynamicTags.push({
	                'url': val.trim()
	            });
	        });
	
	        this.inputVisible = false;
	        this.inputValue = '';
	    }), (0, _defineProperty3.default)(_methods, 'deleteUrl', function deleteUrl(tagId) {
	        var _this9 = this;
	
	        console.log(tagId);
	        _axios2.default.delete(("https://beta-yeti-api.automatad.com/") + 'v1/publisher/' + this.$route.params.uuid + '/domain/' + this.$route.params.domId + '/urls/' + tagId).then(function (response) {
	            console.log(response);
	
	            _this9.dynamicTags = _this9.dynamicTags.filter(function (url) {
	                return url.id != tagId;
	            });
	        }).catch(function (error) {});
	    }), _methods)
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(94);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            confirmation_message: "<p>Are you sure that you want to delete this bucket ?</p>",
	            dialogue_title: "Are you sure ?",
	            dialogVisible: false,
	            formData: {
	                ad_lightnings_enable: false,
	                fouanalytics_enable: false,
	                bname: undefined,
	                country: [],
	                isMobile: true,
	                isWeb: true,
	                isTablet: true,
	                prod: undefined,
	                refresh_all_after_bids: false,
	                refresh_all_initially: false,
	                FORENSIQ_ANALYSIS: false,
	                FORENSIQ_FIREWALL: false,
	
	                isMobileEnable: false,
	                isWebEnable: false,
	                isTabletEnable: false,
	                messageBCountry: undefined
	            },
	            allFeatues: [],
	            bucketId: undefined,
	            prod: undefined,
	            countries: [],
	            checkBucket: [],
	            bucketInfoId: undefined,
	            domId: undefined,
	            uuid: undefined,
	            existingCountries: [],
	            reapet: false,
	            existingCountriesMobile: [],
	            existingCountriesDesktop: [],
	            existingCountriesTablet: [],
	            displayexistingCountries: [],
	            products: [],
	            assocProd: [],
	            loading: true,
	            cnm: ""
	        };
	    },
	
	    created: function created() {
	        var _this = this;
	
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	        this.bucketId = this.$route.params.bucketId;
	
	        this.copyFormData = JSON.parse((0, _stringify2.default)(this.formData));
	
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/countries/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/products/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/" + this.bucketId + "/")]).then(_axios2.default.spread(function (buckets, countriesres, products, bucketInfo) {
	            _this.buckets = buckets.data;
	            _this.checkBucket = buckets.data;
	
	            for (var _i = 0; _i < _this.buckets.length; _i++) {
	                for (var j = 0; j < _this.buckets[_i].countries.length; j++) {
	                    if (_this.buckets[_i].mobile_enabled == true && _this.buckets[_i].web_enabled == true && _this.buckets[_i].tablet_enabled == true) {
	                        _this.displayexistingCountries.push(_this.buckets[_i].countries[j].id);
	                    }
	                    if (_this.existingCountriesMobile.indexOf(_this.buckets[_i].countries[j].id) == -1 && _this.buckets[_i].mobile_enabled) {
	                        _this.existingCountriesMobile.push(_this.buckets[_i].countries[j].id);
	                    } else if (_this.existingCountriesDesktop.indexOf(_this.buckets[_i].countries[j].id) == -1 && _this.buckets[_i].web_enabled) {
	                        _this.existingCountriesDesktop.push(_this.buckets[_i].countries[j].id);
	                    } else if (_this.existingCountriesTablet.indexOf(_this.buckets[_i].countries[j].id) == -1 && _this.buckets[_i].tablet_enabled) {
	                        _this.existingCountriesTablet.push(_this.buckets[_i].countries[j].id);
	                    }
	                    if (_this.existingCountriesMobile.includes(_this.buckets[_i].countries[j].id) && _this.existingCountriesDesktop.includes(_this.buckets[_i].countries[j].id) && _this.existingCountriesTablet.includes(_this.buckets[_i].countries[j].id)) {
	                        _this.displayexistingCountries.push(_this.buckets[_i].countries[j].id);
	                    }
	                }
	            }_this.countries = countriesres.data;
	            _this.products = products.data;
	
	            if (bucketInfo.data) {
	                var selectedGeo = [];
	                var country = [];
	                var device = [];
	                var i = 0,
	                    idx = bucketInfo.data.countries.length;
	
	                for (; i < idx; i++) {
	                    selectedGeo.push(bucketInfo.data.countries[i].id);
	
	                    for (var cb = 0; cb < _this.checkBucket.length; cb++) {
	                        if (_this.checkBucket[cb].id != bucketInfo.data.id) {
	                            for (var ic = 0; ic < _this.checkBucket[cb].countries.length; ic++) {
	                                if (bucketInfo.data.countries[i].id == _this.checkBucket[cb].countries[ic].id) {
	                                    country.push(bucketInfo.data.countries[i].name);
	                                    country = (0, _from2.default)(new _set2.default(country));
	
	                                    _this.cnm = country.toString() + ",";
	                                    if (_this.checkBucket[cb].mobile_enabled) {
	                                        device.push('mobile');
	                                        _this.formData.isMobileEnable = true;
	                                        _this.formData.messageBCountry = "Country " + _this.cnm + " already used in other bucket as mobile so mobile is disabled";
	                                    }
	                                    if (_this.checkBucket[cb].web_enabled) {
	                                        device.push('web');
	                                        _this.formData.isWebEnable = true;
	                                        _this.formData.messageBCountry = "Country  " + _this.cnm + " already used in other bucket as web so web is disabled";
	                                    }
	                                    if (_this.checkBucket[cb].tablet_enabled) {
	                                        device.push('tablet');
	                                        _this.formData.isTabletEnable = true;
	                                        _this.formData.messageBCountry = "Country  " + _this.cnm + " already used in other bucket as tablet so tablet is disabled";
	                                    }
	                                    _this.formData.messageBCountry = "Country  " + _this.cnm + " already used in other bucket as " + device + " so " + device + " is disabled";
	                                }
	                            }
	                        }
	                    }
	                }
	                _this.formData.bname = bucketInfo.data.name;
	                _this.bucketInfoId = bucketInfo.data.id;
	                _this.formData.country = selectedGeo;
	                console.log("bucket information", bucketInfo);
	                _this.formData.isMobile = bucketInfo.data.mobile_enabled;
	                _this.formData.isWeb = bucketInfo.data.web_enabled;
	                _this.formData.isTablet = bucketInfo.data.tablet_enabled;
	                _this.formData.prod = bucketInfo.data.product.length > 0 && bucketInfo.data.product[0].product ? bucketInfo.data.product[0].product.id : undefined;
	
	                _this.formData.refresh_all_after_bids = bucketInfo.data.features.indexOf("REFRESH_ALL_UNITS_AFTER_BIDS") > -1;
	                _this.formData.refresh_all_initially = bucketInfo.data.features.indexOf("REFRESH_ALL_UNITS_INITIALLY") > -1;
	                _this.formData.FORENSIQ_FIREWALL = bucketInfo.data.features.indexOf("FORENSIQ_FIREWALL") > -1;
	                _this.formData.FORENSIQ_ANALYSIS = bucketInfo.data.features.indexOf("FORENSIQ_ANALYSIS") > -1;
	                console.log("ad_lightnings_enable in created", bucketInfo.data.ad_lightnings_enable);
	                _this.formData.ad_lightnings_enable = bucketInfo.data.ad_lightnings_enable;
	                _this.formData.fouanalytics_enable = bucketInfo.data.fouanalytics_enable;
	                _this.loading = false;
	            }
	        }));
	    },
	    methods: {
	        countriesChange: function countriesChange(del) {
	            console.log("Countries change function@@@@@@@@@@@@", del);
	            this.cnm = "";
	            this.formData.messageBCountry = undefined;
	            this.formData.isWebEnable = false;
	            this.formData.isMobileEnable = false;
	            this.formData.isTabletEnable = false;
	            var isreapetcountry = false;
	            var tempiswebEnable = false;
	            var tempistabletEnable = false;
	            var tempisMobileenable = false;
	            this.formData.isWeb = true;
	            this.formData.isMobile = true;
	            this.formData.isTablet = true;
	            var country = [];
	            var device = [];
	
	            for (var i = 0; i < del.length; i++) {
	                for (var cb = 0; cb < this.checkBucket.length; cb++) {
	                    if (this.checkBucket[cb].id != this.bucketInfoId) {
	                        for (var ic = 0; ic < this.checkBucket[cb].countries.length; ic++) {
	                            if (del[i] == this.checkBucket[cb].countries[ic].id) {
	                                isreapetcountry = true;
	                                country.push(this.checkBucket[cb].countries[ic].name);
	                                country = (0, _from2.default)(new _set2.default(country));
	
	
	                                this.cnm = country.toString() + ",";
	
	                                if (this.checkBucket[cb].mobile_enabled) {
	                                    device.push('mobile');
	                                    tempisMobileenable = true;
	                                    this.formData.isMobileEnable = true;
	                                    this.formData.isMobile = false;
	                                    this.formData.messageBCountry = "Country " + this.cnm + " already used in other bucket as mobile so mobile is disabled";
	                                }
	
	                                if (this.checkBucket[cb].web_enabled) {
	                                    device.push('web');
	                                    tempiswebEnable = true;
	                                    this.formData.isWebEnable = true;
	                                    this.formData.isWeb = false;
	                                    this.formData.messageBCountry = "Country  " + this.cnm + " already used in other bucket as web so web is disabled";
	                                }
	
	                                if (this.checkBucket[cb].tablet_enabled) {
	                                    device.push('tablet');
	                                    tempistabletEnable = true;
	                                    this.formData.isTabletEnable = true;
	                                    this.formData.isTablet = false;
	                                    this.formData.messageBCountry = "Country  " + this.cnm + " already used in other bucket as tablet so tablet is disabled";
	                                }
	                                this.formData.messageBCountry = "Country  " + this.cnm + " already used in other bucket as " + device + " so " + device + " is disabled";
	                            }
	                        }
	                    }
	                }
	            }
	
	            console.log("is web ismobile ", this.formData.isWeb, this.formData.isMobile, this.formData.isWebEnable);
	            if (this.formData.country.length == 0) {
	                this.$notify({
	                    title: "Warning",
	                    message: "Keep at least one country in a bucket",
	                    type: "warning"
	                });
	                return;
	            }
	        },
	        deleteCountry: function deleteCountry(tag) {},
	        handleDelete: function handleDelete() {
	            var _this2 = this;
	
	            this.uuid = this.$route.params.uuid;
	            this.domId = this.$route.params.domId;
	            this.bucketId = this.$route.params.bucketId;
	
	            if (this.formData.bname == "default") {
	                this.dialogue_title = "Default bucket cannot be deleted !";
	                this.confirmation_message = '<img class="img-responsive center-block" src="https://i.imgur.com/g6KY4mB.gif"/>';
	            } else {
	                this.apiLink = ("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/" + this.bucketId + "/";
	
	                _axios2.default.delete(this.apiLink).then(function (response) {
	                    _this2.dialogVisible = false;
	                    _this2.buckets_index_url = "/admin/publisher/" + _this2.uuid + "/domain" + "/edit/" + _this2.domId;
	                    _this2.$notify({
	                        title: "Success",
	                        message: "Successfully Deleted the bucket",
	                        type: "success"
	                    });
	                    _this2.$router.push(_this2.buckets_index_url);
	                }).catch(function (error) {});
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _this3 = this;
	
	            var prod = this.formData.prod;
	
	            var payload = {
	                pub_id: this.uuid,
	                domId: this.domId,
	                name: this.formData.bname,
	                domain: this.domId,
	                countries: this.formData.country,
	                mobile_enabled: this.formData.isMobile,
	                web_enabled: this.formData.isWeb,
	                tablet_enabled: this.formData.isTablet
	            },
	                apiLink = undefined;
	
	            if (this.formData.country.length == 0 && this.formData.bname !== "default") {
	                this.$notify({
	                    title: "Warning",
	                    message: "Keep atleast one country in a buckets",
	                    type: "warning"
	                });
	                return;
	            }
	            if (this.formData.isWeb == false && this.formData.isMobile == false && this.formData.isTablet == false) {
	                this.$notify({
	                    title: "Warning",
	                    message: "Keep atleast one device in a buckets",
	                    type: "warning"
	                });
	                return;
	            }
	
	            if (this.bucketId) {
	                payload.bucketId = this.bucketId;
	            } else apiLink = ("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/";
	
	            for (var i = 0; i < this.buckets.length; i++) {
	                for (var j = 0; j < this.buckets[i].countries.length; j++) {
	                    if (this.existingCountriesMobile.indexOf(this.buckets[i].countries[j].id) == -1 && this.buckets[i].mobile_enabled) {
	                        this.existingCountriesMobile.push(this.buckets[i].countries[j].id);
	                    } else if (this.existingCountriesDesktop.indexOf(this.buckets[i].countries[j].id) == -1 && !this.buckets[i].mobile_enabled) {
	                        this.existingCountriesDesktop.push(this.buckets[i].countries[j].id);
	                    }
	                }
	            }
	            console.log("ad_lightnings_enable", this.formData.ad_lightnings_enable);
	            var request_obj = {
	                ad_lightnings_enable: this.formData.ad_lightnings_enable,
	                fouanalytics_enable: this.formData.fouanalytics_enable,
	                bucketId: this.bucketId,
	                bname: this.formData.bname,
	                productAssoc: this.formData.prod,
	                refresh_all_initially: this.formData.refresh_all_initially,
	                refresh_all_after_bids: this.formData.refresh_all_after_bids,
	                FORENSIQ_FIREWALL: this.formData.FORENSIQ_FIREWALL,
	                FORENSIQ_ANALYSIS: this.formData.FORENSIQ_ANALYSIS,
	                countries: this.formData.country,
	                web_enabled: this.formData.isWeb,
	                mobile_enabled: this.formData.isMobile,
	                tablet_enabled: this.formData.isTablet
	            };
	
	            if (this.formData.prod !== undefined) {
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/update_bucket/", request_obj).then(function (response) {
	                    if (response.data.status) {
	                        _this3.$notify({
	                            title: "Success",
	                            message: response.data.message,
	                            type: "success"
	                        });
	                        _this3.$router.push("/admin/publisher/" + _this3.uuid + "/domain/" + _this3.domId + "/buckets/" + _this3.bucketId);
	                    } else {
	                        _this3.$notify({
	                            title: "Warning",
	                            message: response.data.message,
	                            type: "warning"
	                        });
	                    }
	                });
	            } else {
	                this.$notify({
	                    title: "Warning",
	                    message: "Associate product for the Bucket!",
	                    type: "warning"
	                });
	            }
	        }
	    }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventBus = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            log_to_console: console.log,
	            mcm_enabled: false,
	            name: undefined,
	            publishers: [],
	            isSecure: true,
	            pubId: undefined,
	            pubUid: undefined,
	            dfp_credentials: undefined,
	            dfp_network: undefined,
	            child_dfp_network: null,
	            dfpAccounts: [],
	            childDfpAccounts: [],
	            mcmAccountType: [],
	            parentAdUnitId: undefined,
	            parentAdUnitCode: undefined,
	            parentAdUnitIdAmp: undefined,
	            parentAdUnitCodeAmp: undefined,
	            infinitescroll: false,
	            account_type: null,
	            filteredAccountList: [],
	            sellers: [],
	            domain_id: ''
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/dfp_accounts/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/mcm-account-list/')]).then(_axios2.default.spread(function (response, dfpAccounts, childAccounts, mcm_type) {
	            _this.publishers = response.data.pub_data;
	            _this.dfpAccounts = dfpAccounts.data;
	            _this.childDfpAccounts = childAccounts.data;
	            _this.mcmAccountType = mcm_type.data;
	            if (_this.$route.query.publisher) {
	                for (var i = 0; i < _this.publishers.length; i++) {
	                    if (_this.publishers[i].id == parseInt(_this.$route.query.publisher)) {
	                        _this.pubId = parseInt(_this.$route.query.publisher);
	                        _this.setPubUid();
	                    }
	                }
	            }
	        }));
	    },
	    methods: {
	        filterNetworkList: function filterNetworkList() {
	            var _this2 = this;
	
	            if (this.dfp_network && this.account_type) {
	                var selectedAccount = this.mcmAccountType.filter(function (k) {
	                    return k.id == _this2.account_type;
	                })[0].account_type;
	                this.filteredAccountList = this.childDfpAccounts.filter(function (k) {
	                    return k.delegation_type == selectedAccount && k.dfp_network == _this2.dfp_network;
	                });
	                this.child_dfp_network = null;
	            }
	        },
	        resetMCM: function resetMCM() {
	            this.account_type = null;
	            this.child_dfp_network = null;
	        },
	        setPubUid: function setPubUid() {
	            this.domain_id = null;
	            var i = 0;
	            for (; i < this.publishers.length; i++) {
	                if (this.publishers[i].id == this.pubId) {
	                    this.pubUid = this.publishers[i].uuid;
	
	                    break;
	                }
	            }
	            this.getSellerId();
	        },
	        getSellerId: function getSellerId() {
	            var _this3 = this;
	
	            console.log('seller called');
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/pub-get-dash-info/', {
	                publisherId: this.pubId
	            }).then(function (response) {
	                if (response.data.status) {
	                    _this3.sellers = response.data.data;
	                }
	            }).catch(function (err) {
	                console.log('err', err);
	            });
	        },
	        onSubmit: function onSubmit() {
	            var _this4 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.pubUid + '/domains/', {
	                pub_id: this.pubUid,
	                name: this.name,
	                is_secure: this.isSecure,
	                publisher: this.pubId,
	                mcm_enable: this.account_type != null ? true : false,
	                mcm: this.account_type,
	                publishers_dfp: this.pubDFP,
	                dfp_credentials: this.dfp_credentials,
	                dfp_network: this.dfp_network,
	                child_dfp_network: this.child_dfp_network,
	                parent_ad_unit_id: this.parentAdUnitId,
	                parent_ad_unit_code: this.parentAdUnitCode,
	                amp_parent_ad_unit_id: this.parentAdUnitIdAmp,
	                amp_parent_ad_unit_code: this.parentAdUnitCodeAmp,
	                infinite_scroll: this.infinitescroll,
	                seller_id_input: this.domain_id
	            }).then(function (response) {
	                _this4.$notify({
	                    title: 'Success',
	                    message: 'Successfully created a new domain',
	                    type: 'success'
	                });
	                _eventBus.EventBus.$emit('update_logs', {});
	
	                setTimeout(function () {
	                    _this4.$router.push('/admin/domains/');
	                }, 1000);
	            }).catch(function (error) {
	                _this4.$notify({
	                    title: 'Warning',
	                    message: 'Unable to create the domain',
	                    type: 'warning'
	                });
	            });
	        },
	        getDfpNetworks: function getDfpNetworks(dfp_credentials_id) {
	            if (dfp_credentials_id) {
	                for (var i = 0; i < this.dfpAccounts.length; i++) {
	                    if (dfp_credentials_id == this.dfpAccounts[i].id) {
	                        var dfp_networks = [];
	                        for (var j = 0; j < this.dfpAccounts[i].networks.length; j++) {
	                            if (this.dfpAccounts[i].networks[j].hb_setup_done) dfp_networks.push(this.dfpAccounts[i].networks[j]);
	                        }
	
	                        return dfp_networks;
	                    }
	                }
	            } else {
	                return [];
	            }
	        }
	    },
	    computed: {
	        formValid: function formValid() {
	            return this.pubUid && this.name && this.isSecure && this.pubId && this.dfp_credentials && this.dfp_network && this.parentAdUnitId && this.parentAdUnitCode;
	        }
	    }
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            formData: {
	                bname: undefined,
	                country: [],
	                isMobile: true,
	                isWeb: true,
	                isTablet: true,
	                prod: undefined,
	                isMobileEnable: true,
	                isWebEnable: true,
	                isTabletEnable: true
	            },
	            bucketId: undefined,
	            prod: undefined,
	            countries: [],
	            domId: undefined,
	            validated: undefined,
	            uuid: undefined,
	            displayexistingCountries: [],
	            existingCountries: [],
	            existingCountriesMobile: [],
	            existingCountriesDesktop: [],
	            existingCountriesTablet: [],
	            existingCountriesMobileDup: [],
	            existingCountriesDesktopDup: [],
	            existingCountriesTabletDup: [],
	            products: [],
	            assocProd: []
	        };
	    },
	
	    created: function created() {
	        var _this = this;
	
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	        this.copyFormData = JSON.parse((0, _stringify2.default)(this.formData));
	
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/countries/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/products/")]).then(_axios2.default.spread(function (buckets, countriesres, products) {
	            _this.buckets = buckets.data;
	            for (var i = 0; i < _this.buckets.length; i++) {
	                for (var j = 0; j < _this.buckets[i].countries.length; j++) {
	                    if (_this.buckets[i].countries[j].name != "All") {
	                        if (_this.buckets[i].mobile_enabled == true && _this.buckets[i].web_enabled == true && _this.buckets[i].tablet_enabled == true) {
	                            _this.existingCountries.push(_this.buckets[i].countries[j].id);
	                        }
	
	                        if (_this.existingCountriesMobile.indexOf(_this.buckets[i].countries[j].id) == -1 && _this.buckets[i].mobile_enabled) {
	                            console.log("only mobile me he");
	                            _this.existingCountriesMobile.push(_this.buckets[i].countries[j].id);
	                        }
	                        if (_this.existingCountriesDesktop.indexOf(_this.buckets[i].countries[j].id) == -1 && _this.buckets[i].web_enabled) {
	                            _this.existingCountriesDesktop.push(_this.buckets[i].countries[j].id);
	                        }
	                        if (_this.existingCountriesTablet.indexOf(_this.buckets[i].countries[j].id) == -1 && _this.buckets[i].tablet_enabled) {
	                            _this.existingCountriesTablet.push(_this.buckets[i].countries[j].id);
	                        }
	                        if (_this.existingCountriesMobile.includes(_this.buckets[i].countries[j].id) && _this.existingCountriesDesktop.includes(_this.buckets[i].countries[j].id) && _this.existingCountriesTablet.includes(_this.buckets[i].countries[j].id)) {
	                            console.log("both me exist he");
	                            _this.existingCountries.push(_this.buckets[i].countries[j].id);
	                        }
	                    }
	                }
	            }
	            _this.displayexistingCountries = _this.existingCountries;
	            console.log(_this.displayexistingCountries);
	            _this.countries = countriesres.data;
	            _this.products = products.data;
	        }));
	    },
	    methods: {
	        loadExistingCountries: function loadExistingCountries() {
	            if (this.formData.isMobile && !this.formData.isWeb && !this.formData.isTablet) {
	                this.displayexistingCountries = this.existingCountriesMobile;
	            } else if (!this.formData.isTablet && !this.formData.isMobile && this.formData.isWeb) {
	                this.displayexistingCountries = this.existingCountriesDesktop;
	            } else if (this.formData.isTablet && !this.formData.isWeb && !this.formData.isMobile) {
	                this.displayexistingCountries = this.existingCountriesTablet;
	            } else {
	                console.log("Both");
	                this.displayexistingCountries = this.existingCountries;
	            }
	        },
	        disable: function disable(name) {
	            if (this.existingCountriesMobileDup.length == this.formData.country.length && this.existingCountriesDesktopDup.length == this.formData.country.length && this.existingCountriesTabletDup.length == this.formData.country.length) return;
	            this.formData.isMobile = true;
	            this.formData.isWeb = true;
	            this.formData.isTablet = true;
	            this.formData.isMobileEnable = true;
	            this.formData.isWebEnable = true;
	            this.formData.isTabletEnable = true;
	
	            var tempIsMobile = true;
	            var tempIsWeb = true;
	            var tempIsTablet = true;
	            var tempIsMobileEnable = true;
	            var tempIsWebenable = true;
	            var tempIsTabletEnable = true;
	
	            console.trace("disable");
	            console.log("change country array of length %%%%%%%%%%%", name.length);
	            for (var i = 0; i < name.length; i++) {
	                console.log("indivisual element$$$$$$$$$$$$", name[i]);
	                var idCompareTo = name[i];
	
	                if (this.existingCountriesMobile.includes(idCompareTo)) {
	                    tempIsMobile = false;
	                    tempIsMobileEnable = false;
	                }
	
	                if (this.existingCountriesDesktop.includes(idCompareTo)) {
	                    tempIsWeb = false;
	                    tempIsWebenable = false;
	                }
	
	                if (this.existingCountriesTablet.includes(idCompareTo)) {
	                    tempIsTablet = false;
	                    tempIsTabletEnable = false;
	                }
	            }
	            console.log("tempmobile^^^^^^^^^^^^^6=", tempIsMobile);
	            console.log("tempweb^^^^^^^^^^^^^6=", tempIsWeb);
	            if (!tempIsMobile) {
	                this.formData.isMobileEnable = false;
	                this.formData.isMobile = false;
	            }
	            if (!tempIsWeb) {
	                this.formData.isWebEnable = false;
	                this.formData.isWeb = false;
	            }
	            if (!tempIsTablet) {
	                this.formData.isTabletEnable = false;
	                this.formData.isTablet = false;
	            }
	            console.log("temptablet^^^^^^^^^^^^^6=", tempIsTablet);
	
	
	            this.existingCountriesMobileDup = JSON.parse((0, _stringify2.default)(this.formData.country));
	            this.existingCountriesDesktopDup = JSON.parse((0, _stringify2.default)(this.formData.country));
	            this.existingCountriesTabletDup = JSON.parse((0, _stringify2.default)(this.formData.country));
	        },
	        onSubmit: function onSubmit() {
	            var _this2 = this;
	
	            var prod = this.formData.prod;
	            console.log("prod", prod);
	
	            if (prod == undefined) {
	                console.log("not slect product");
	                this.$notify({
	                    title: "Warning",
	                    message: "Please select product",
	                    type: "warning"
	                });
	                return;
	            }
	
	            if (this.formData.isMobile == false && this.formData.isWeb == false && this.formData.isTablet == false) {
	                console.log("not slect anything mobile nd web");
	                this.$notify({
	                    title: "Warning",
	                    message: "Please check atleast one device!",
	                    type: "warning"
	                });
	                return;
	            }
	
	            var payload = {
	                pub_id: this.uuid,
	                domId: this.domId,
	                name: this.formData.bname,
	                domain: this.domId,
	                countries: this.formData.country,
	                mobile_enabled: this.formData.isMobile,
	                web_enabled: this.formData.isWeb,
	                tablet_enabled: this.formData.isTablet
	            },
	                apiLink = undefined;
	            console.log("payload info pubid", payload.pub_id);
	            console.log("payload info domID", payload.domId);
	            console.log("payload info name", payload.name);
	            console.log("payload info domain", payload.domain);
	            console.log("payload info country", payload.countries);
	
	            console.log("payload info mobile-enable", payload.isWeb);
	            console.log("payload info web-enable", payload.isMobile);
	            console.log("payload info tablet-enable", payload.isMobile);
	
	            apiLink = ("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/buckets/";
	
	            for (var i = 0; i < this.formData.country.length; i++) {
	                if (this.existingCountries.indexOf(this.formData.country[i]) == -1) this.existingCountries.push(this.formData.country[i]);
	            }_axios2.default.post(apiLink, payload).then(function (response) {
	                _this2.formData = JSON.parse((0, _stringify2.default)(_this2.copyFormData));
	                var newBucket = response.data.id;
	                _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + _this2.uuid + "/domains/" + _this2.domId + "/buckets/")]).then(_axios2.default.spread(function (buckets) {
	                    _this2.buckets = buckets.data;
	                    for (var _i = 0; _i < _this2.buckets.length; _i++) {
	                        for (var j = 0; j < _this2.buckets[_i].countries.length; j++) {
	                            if (_this2.existingCountries.indexOf(_this2.buckets[_i].countries[j].id) == -1) _this2.existingCountries.push(_this2.buckets[_i].countries[j].id);
	                        }
	                    }_axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + _this2.uuid + "/domains/" + _this2.domId + "/buckets/" + newBucket + "/products/", {
	                        bucket_id: newBucket,
	                        pub_id: _this2.uuid,
	                        domId: _this2.domId,
	                        bucket: newBucket,
	                        product: prod
	                    }).then(function (response) {
	                        _this2.$notify({
	                            title: "Success",
	                            message: "Successfully created a bucket & associated a product",
	                            type: "success"
	                        });
	
	                        setTimeout(function () {
	                            _this2.$router.push("/admin/publisher/" + _this2.$route.params.uuid + "/domain/edit/" + _this2.$route.params.domId);
	                        }, 1000);
	                    }).catch(function (error) {
	                        _this2.$notify({
	                            title: "Error",
	                            message: "Cannot use more than one Product witha Bucket",
	                            type: "error"
	                        });
	                    });
	                }));
	            }).catch(function (error) {
	                _this2.$notify({
	                    title: "Warning",
	                    message: "Something went wrong.",
	                    type: "warning"
	                });
	            });
	        }
	    }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				domains: [],
				buckets: [],
				uuid: undefined,
				domId: undefined,
				pubId: undefined,
				products: {},
				loading: true,
				test: []
			};
		},
	
		created: function created() {
			var self = this;
			this.uuid = this.$route.params.uuid;
			this.domId = this.$route.params.domId;
			this.$nextTick(function () {
				_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/8/products/')]).then(_axios2.default.spread(function (domains, buckets, products) {
					self.domains = domains.data;
					self.buckets = buckets.data;
					self.products = products.data;
					self.loading = false;
	
					window.setTimeout(function () {
						_letterAvatar2.default.transform();
					});
	
					console.log(self.buckets[0].active);
					for (var i = 0; i < self.buckets.length; i++) {
						console.log(self.buckets[i].active);
						self.$set(self.test, i, self.buckets[i].active);
					}
				})).catch(function (error) {
					return console.log(error);
				});
			});
		},
	
		methods: {
			confirmAction: function confirmAction(bucketID, domainID, pubID, index, val) {
				var _this = this;
	
				var msg = '';
				console.log('val', val);
				if (val == false) {
					msg = 'disable';
				} else {
					msg = 'enable';
				}
	
				this.$confirm('Are you sure you want to ' + msg + ' bucket?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(function () {
					_this.$message({
						type: 'success',
						message: 'Bucket ' + msg + 'd'
					});
	
					_this.changeBucketState(bucketID, domainID, pubID);
				}).catch(function () {
					_this.test[index] = !_this.$refs["elem" + index].checked;
					_this.$refs["elem" + index].checked = !_this.$refs["elem" + index].checked;
					_this.$refs["elem" + index].value = !_this.$refs["elem" + index].checked;
					console.log('v-model.current', _this.test[index]);
					console.log('checked', _this.$refs['elem' + index].value);
					_this.$message({
						type: 'info',
						message: 'Action canceled'
					});
					return _this.$refs["elem" + index].value;
				});
			},
			changeBucketState: function changeBucketState(bucketId, domainId, pubId) {
				_axios2.default.post('/v1/publishers/' + pubId + '/domains/' + domainId + '/buckets/' + bucketId + '/change-state/').then(function (response) {
					return console.log("state changed");
				}).catch(function (error) {
					return console.log(error);
				});
			},
			getProductsUnderBucket: function getProductsUnderBucket(bucket_id) {
				var self = this;
				var products = [];
				for (var i = 0; i < self.products.length; i++) {
					if (self.products[i].bucket.id == bucket_id) {
						products.push(self.products[i]);
					}
				}
				return products;
			},
			createJs: function createJs(bucketId) {
				var _this2 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/cdn_push/', {
					bucketId: bucketId
				}).then(function (response) {
					var type = 'Error',
					    message = 'Oops Something went wrong!';
					if (response.data.response_data.status) {
						type = 'Success';
						message = response.data.response_data.message;
					} else {
						type = 'Error';
						message = response.data.response_data.message;
					}
					_this2.$notify({
						title: type,
						message: message,
						type: type.toLowerCase()
					});
				});
			}
		}
	};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mcm_enabled: false,
	      ad_lightnings_script_tag: "",
	      fouanalytics_script_tag: "",
	      dfpAccounts: [],
	      dfp_credentials: undefined,
	      uuid: undefined,
	      domId: undefined,
	      domainId: undefined,
	      publisherId: undefined,
	      pubName: undefined,
	      name: undefined,
	      dfpCredId: undefined,
	      child_dfp_network: null,
	      dfp_network: undefined,
	      childDfpAccounts: [],
	      mcmAccountType: [],
	      account_type: null,
	      pubdetaillist: [],
	      pubdetailistid: "",
	      pubdetaillistname: "",
	      parent_ad_unit_id: undefined,
	      parent_ad_unit_code: undefined,
	      amp_parent_ad_unit_id: undefined,
	      amp_parent_ad_unit_code: undefined,
	      dfpNetworkListAsPerSelectedDfpAccount: [],
	      assertive_yield_id: undefined,
	      publishers: [],
	      isSecure: true,
	      publisherDFP: false,
	      infinite_scroll: true,
	      seller_json: false,
	      loading: true,
	      filteredAccountList: [],
	      seller_domain_id: null,
	      sellerLoading: true
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.uuid = this.$route.params.uuid;
	    this.domId = this.$route.params.domId;
	
	    _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/dfp_accounts/"), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/mcm-account-list/')]).then(_axios2.default.spread(function (publisher, domDetails, dfpaccounts, childAccounts, mcm_type) {
	      console.log(domDetails, _this.domId);
	
	
	      _this.pubdetaillist = dfpaccounts.data;
	      _this.pubdetailistid = domDetails.data.dfp_network.id;
	      _this.childDfpAccounts = childAccounts.data;
	      _this.mcmAccountType = mcm_type.data;
	      _this.dfpAccounts = _this.pubdetaillist;
	
	      var selectedDFPAcoountId = domDetails.data.dfp_credentials.id;
	
	      var dp = dfpaccounts.data;
	
	      for (var i = 0; i < dp.length; i++) {
	        if (selectedDFPAcoountId == dp[i].id) {
	          _this.dfpNetworkListAsPerSelectedDfpAccount = dp[i].networks;
	          break;
	        }
	      }
	
	      _this.publishers = publisher.data.pub_data;
	
	      _this.domainId = domDetails.data.id;
	      _this.name = domDetails.data.name;
	      _this.pubName = domDetails.data.publisher.name;
	      _this.parent_ad_unit_id = domDetails.data.parent_ad_unit_id;
	      _this.parent_ad_unit_code = domDetails.data.parent_ad_unit_code;
	      _this.amp_parent_ad_unit_id = domDetails.data.amp_parent_ad_unit_id;
	      _this.amp_parent_ad_unit_code = domDetails.data.amp_parent_ad_unit_code;
	      _this.infinite_scroll = domDetails.data.infinite_scroll;
	      _this.dfp_network = domDetails.data.dfp_network.id;
	      _this.isSecure = domDetails.data.is_secure;
	      _this.publisherDFP = domDetails.data.publishers_dfp;
	      _this.dfpCredId = domDetails.data.dfp_credentials;
	      _this.dfp_credentials = _this.dfpCredId.id;
	      _this.account_type = domDetails.data.mcm_enable ? domDetails.data.mcm.id : _this.account_type;
	      _this.mcm_enabled = domDetails.data.mcm_enable;
	      _this.child_dfp_network = domDetails.data.mcm_enable ? domDetails.data.child_dfp_network.id : _this.child_dfp_network;
	      _this.assertive_yield_id = domDetails.data.assertive_yield_id;
	      _this.seller_json = domDetails.data.sellers_json_disabled;
	      _this.publisherId = domDetails.data.publisher.id;
	      _this.getSellerId();
	      _this.initialPublisherId = domDetails.data.publisher.id;
	      _this.seller_domain_id = domDetails.data.seller_id_input;
	      _this.ad_lightnings_script_tag = domDetails.data.ad_lightnings_script_tag;
	      _this.fouanalytics_script_tag = domDetails.data.fouanalytics_script_tag;
	      var selectedAccount = domDetails.data.mcm_enable ? _this.mcmAccountType.filter(function (k) {
	        return k.id == _this.account_type;
	      })[0].account_type : '';
	      _this.filteredAccountList = domDetails.data.mcm_enable ? _this.childDfpAccounts.filter(function (k) {
	        return k.delegation_type == selectedAccount && k.dfp_network == _this.pubdetailistid;
	      }) : _this.childDfpAccounts;
	
	      _this.loading = false;
	    }));
	  },
	  methods: {
	    setPubId: function setPubId() {
	      this.getSellerId();
	    },
	    getSellerId: function getSellerId() {
	      var _this2 = this;
	
	      this.seller_domain_id = null;
	      this.sellerLoading = true;
	      console.log('seller called');
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/pub-get-dash-info/', {
	        publisherId: this.publisherId
	      }).then(function (response) {
	        if (response.data.status) {
	          _this2.sellers = response.data.data;
	        }
	        _this2.sellerLoading = false;
	      }).catch(function (err) {
	        console.log('err', err);
	      });
	    },
	    filterNetworkList: function filterNetworkList() {
	      var _this3 = this;
	
	      if (this.account_type && this.dfp_network) {
	        var selectedAccount = this.mcmAccountType.filter(function (k) {
	          return k.id == _this3.account_type;
	        })[0].account_type;
	        this.filteredAccountList = this.childDfpAccounts.filter(function (k) {
	          return k.delegation_type == selectedAccount && k.dfp_network == _this3.dfp_network;
	        });
	        this.child_dfp_network = null;
	      }
	    },
	    onSubmit: function onSubmit() {
	      var _this4 = this;
	
	      _axios2.default.put(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/", {
	        fouanalytics_script_tag: this.fouanalytics_script_tag,
	        ad_lightnings_script_tag: this.ad_lightnings_script_tag,
	        name: this.name,
	        is_secure: this.isSecure,
	        publisher: this.publisherId,
	        mcm: this.account_type,
	        mcm_enable: this.account_type != null ? true : false,
	        child_dfp_network: this.child_dfp_network,
	
	        publishers_dfp: this.publisherDFP.id,
	        parent_ad_unit_id: this.parent_ad_unit_id,
	        parent_ad_unit_code: this.parent_ad_unit_code,
	        amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
	        amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
	        dfp_credentials: this.dfp_credentials,
	        dfp_network: this.account_type != null ? this.dfp_network : this.pubdetailistid,
	        infinite_scroll: this.infinite_scroll,
	        sellers_json_disabled: this.seller_json,
	        assertive_yield_id: this.assertive_yield_id,
	        seller_id_input: this.seller_domain_id
	      }).then(function (response) {
	        _this4.$notify({
	          title: "Success",
	          message: "Yay! the domain data has been updated.",
	          type: "success"
	        });
	        setTimeout(function () {
	          if (_this4.initialPublisherId == _this4.publisherId) {
	            _this4.$router.push("/admin/publisher/" + _this4.uuid + "/domain/edit/" + _this4.domId + "/");
	          } else {
	            _this4.$router.push("/admin/domains");
	          }
	        }, 1000);
	      }).catch(function (error) {
	        _this4.$notify({
	          title: "Warning",
	          message: "Shit! Something went wrong.",
	          type: "warning"
	        });
	      });
	    },
	    linkDFP: function linkDFP() {
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/get_dfp_auth_link/").then(function (response) {
	        window.location = response.data.authorization_url;
	      }).catch(function (error) {});
	    },
	    getDfpNetworks: function getDfpNetworks(dfp_credentials_id) {
	      if (dfp_credentials_id) {
	        for (var i = 0; i < this.dfpAccounts.length; i++) {
	          if (dfp_credentials_id == this.dfpAccounts[i].id) {
	            var dfp_networks = [];
	            for (var j = 0; j < this.dfpAccounts[i].networks.length; j++) {
	              if (this.dfpAccounts[i].networks[j].hb_setup_done) dfp_networks.push(this.dfpAccounts[i].networks[j]);
	            }
	
	            return dfp_networks;
	          }
	        }
	      } else {
	        return [];
	      }
	    },
	    migrateToMCM: function migrateToMCM() {
	      var _this5 = this;
	
	      var selectedAccount = this.mcmAccountType.filter(function (k) {
	        return k.id == _this5.account_type;
	      })[0].account_type;
	      var targetDfp = selectedAccount == 'MANAGE_ACCOUNT' ? this.child_dfp_network : this.pubdetailistid;
	      _axios2.default.put(("https://beta-yeti-api.automatad.com/") + "v1/publishers/" + this.uuid + "/domains/" + this.domId + "/", {
	        fouanalytics_script_tag: this.fouanalytics_script_tag,
	        ad_lightnings_script_tag: this.ad_lightnings_script_tag,
	        name: this.name,
	        is_secure: this.isSecure,
	        publisher: this.publisherId,
	        mcm: this.account_type,
	        mcm_enable: this.account_type != null ? true : false,
	        child_dfp_network: this.child_dfp_network,
	
	        publishers_dfp: this.publisherDFP.id,
	        parent_ad_unit_id: this.parent_ad_unit_id,
	        parent_ad_unit_code: this.parent_ad_unit_code,
	        amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
	        amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
	        dfp_credentials: this.dfp_credentials,
	        dfp_network: this.dfp_network,
	        infinite_scroll: this.infinite_scroll,
	        sellers_json_disabled: this.seller_json,
	        assertive_yield_id: this.assertive_yield_id
	      }).then(function (response) {
	        _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/mcm-migration/domain/" + _this5.domId + "/dfp-network/" + targetDfp, {}).then(function (response) {
	          _this5.$notify({
	            title: "Success",
	            message: "Domain Migration Initiated",
	            type: "success"
	          });
	          setTimeout(function () {
	            if (_this5.initialPublisherId == _this5.publisherId) {
	              _this5.$router.push("/admin/publisher/" + _this5.uuid + "/domain/edit/" + _this5.domId + "/");
	            } else {
	              _this5.$router.push("/admin/domains");
	            }
	          }, 1000);
	        }).catch(function (error) {
	          _this5.$notify({
	            title: "Warning",
	            message: "Something went wrong. Try again in sometime",
	            type: "warning"
	          });
	        });
	      }).catch(function (error) {
	        _this5.$notify({
	          title: "Warning",
	          message: "Something went wrong. Try again in sometime",
	          type: "warning"
	        });
	      });
	    },
	    resetMCM: function resetMCM() {
	      this.dfp_credentials = this.dfpCredId.id;
	      this.dfp_network = this.pubdetailistid;
	      this.account_type = null;
	      this.child_dfp_network = null;
	    }
	  },
	  computed: {
	    _get_user: function _get_user() {
	      var token = window.localStorage && localStorage["default_auth_token"];
	      if (token) {
	        var base64Url = token.split(".")[1];
	        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	        var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
	          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
	        }).join(""));
	
	        return JSON.parse(jsonPayload);
	      } else return undefined;
	    },
	    hasAccess: function hasAccess() {
	      return [3, 8, 41, 155, 310].includes(this._get_user && this._get_user.user_id);
	    }
	  }
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        name: '',
	        email: '',
	        number: '',
	        countryId: '',
	        currencyId: ''
	
	      },
	      message: '',
	      countryId: '',
	      currencyId: '',
	      countryOptions: [],
	      currenciesOptions: []
	
	    };
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.$nextTick(function () {
	      console.log(this.$route.params);
	      var self = this;
	      _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/countries/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/')]).then(_axios2.default.spread(function (formData, countries, currencies) {
	        self.countryOptions = countries.data;
	        self.currenciesOptions = currencies.data;
	        self.credentials.name = formData.data.name;
	        self.credentials.number = formData.data.contact_number;
	        self.credentials.email = formData.data.contact_email;
	        self.credentials.countryId = formData.data.country.id;
	        self.credentials.currencyId = formData.data.currency.id;
	      })).catch(function (error) {
	        return console.log(error);
	      });
	    });
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      _axios2.default.put(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/', {
	        name: this.credentials.name,
	        contact_email: this.credentials.email,
	        contact_number: this.credentials.number,
	        country: this.credentials.countryId,
	        currency: this.credentials.currencyId,
	        uuid: this.$route.params.uuid
	      }).then(function (response) {
	        _this.message = 'Success';
	      }).catch(function (error) {
	        if (error.response.status == 400) {
	          if (error.response.data.new_password2[0]) {
	            _this.message = error.response.data.new_password2[0];
	          }
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(30);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            msg: 'charmi',
	            uuid: '',
	            domId: '',
	            keywords: [],
	            keywordsData: '',
	            separatedArray: []
	        };
	    },
	
	    created: function created() {
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	        console.log("uuid and domid", this.uuid, this.domId);
	        this.getdata();
	    },
	    methods: {
	        deleteSingleWordSingle: function deleteSingleWordSingle(singleword) {
	            var sword = ',' + singleword;
	            var a = this.keywordsData;
	            console.log("replay whole a", a, typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a));
	            console.log("replay", a.replace(sword, " "));
	            var finalString = a.replace(sword, " ");
	            console.log("replay final", finalString);
	            this.keywordsData = '';
	            this.keywordsData = finalString;
	
	            this.addData();
	        },
	        separateString: function separateString(originalString) {
	            this.separatedArray = originalString.split(',');
	            console.log("sarray", this.separatedArray, 'type', (0, _typeof3.default)(this.separatedArray));
	            for (var i = 0; i < this.separatedArray.length; i++) {
	                console.log("sarraysingle", this.separatedArray[i]);
	            }
	        },
	        getdata: function getdata() {
	            var _this = this;
	
	            this.keywords = [];
	            this.keywordsData = '';
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/voilated-keyword-block/domain/' + this.domId + '/');
	            _axios2.default.get(api).then(function (res) {
	                _this.keywords = res.data;
	                _this.separateString(_this.keywords);
	                _this.keywordsData = res.data;
	            });
	        },
	        addData: function addData() {
	            var _this2 = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/voilated-keyword-block/domain/' + this.domId + '/');
	            var x = {
	                'keywords': this.keywordsData
	            };
	            _axios2.default.post(api, x).then(function (res) {
	                console.log("res", res);
	                _this2.getdata();
	            });
	        }
	    }
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      notesInput: '',
	      domainName: '',
	      notes: []
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.$route.params.domid + '/notes/?limit=20&offset=0', {}).then(function (response) {
	      console.log(response);
	      _this.domainName = response.data['0'].name;
	      _this.notes = response.data['0'].notes;
	    }).catch(function (error) {});
	  },
	  methods: {
	    stepBack: function stepBack() {
	      setTimeout(function () {
	        window.history.back();
	      }, 200);
	    },
	    handleScroll: function handleScroll(event) {
	      var _this2 = this;
	
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + '/v1/domains/' + this.$route.params.domid + '/notes/?limit=20&offset=0', {}).then(function (response) {
	        console.log(response);
	        _this2.notes = response.data.results;
	        console.log(_this2.notes);
	      }).catch(function (error) {});
	    },
	
	    addnote: function addnote() {
	      var _this3 = this;
	
	      if (this.notesInput) {
	        _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.$route.params.domid + '/notes/', {
	          domain: this.$route.params.domid,
	          note: this.notesInput
	        }).then(function (response) {
	
	          _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + _this3.$route.params.domid + '/notes/?limit=20&offset=0', {}).then(function (response) {
	            console.log(response);
	            _this3.domainName = response.data['0'].name;
	            _this3.notes = response.data['0'].notes;
	            _this3.notesInput = '';
	          }).catch(function (error) {});
	        }).catch(function (error) {});
	      }
	    }
	  }
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Agreement = __webpack_require__(255);
	
	var _Agreement2 = _interopRequireDefault(_Agreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        agreement: _Agreement2.default
	    },
	    data: function data() {
	        return {
	            agreemetformdata: {
	                revenue_share: 15,
	                period_to_send_rev_pub: 60,
	                rev_dist_clarity_example: 'January will be sent 60 days from February 1',
	                termination_duration_for_pub: 24,
	                publisherId: 1,
	                LegalPublisherName: ''
	            },
	            isPreview: false,
	            agreementDoc: '',
	            responsepdf: '',
	            downloadurl: '',
	            sendinginvite: false,
	            iframobj: '',
	            sentInviteScreenVisible: false,
	            issentinvite: false,
	            dowanloadcontractstatus: false,
	            downloadcontracturl: ''
	        };
	    },
	
	    created: function created() {
	        this.loaddownloadcontract();
	    },
	    methods: {
	        loaddownloadcontract: function loaddownloadcontract() {
	            var _this = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + 'v1/download-contract/' + this.$route.params.id + '/';
	            _axios2.default.get(api).then(function (response) {
	                if (response.data[0].status) {
	                    _this.agreemetformdata.revenue_share = response.data[0].revenue_share;
	                    _this.agreemetformdata.period_to_send_rev_pub = response.data[0].period_to_send_rev_pub;
	                    _this.agreemetformdata.rev_dist_clarity_example = response.data[0].rev_dist_clarity_example;
	                    _this.agreemetformdata.termination_duration_for_pub = response.data[0].termination_duration_for_pub;
	                    _this.agreemetformdata.LegalPublisherName = response.data[0].legal_publisher_name;
	                }
	            });
	        },
	        cancelInviteAction: function cancelInviteAction() {
	            this.sentInviteScreenVisible = false;
	        },
	        downloadcontract: function downloadcontract() {
	            var _this2 = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + 'v1/download-contract/' + this.$route.params.id + '/';
	
	            var agreementDoc = document.getElementById('agreementform').innerHTML;
	
	            agreementDoc = agreementDoc.replace(/word-break: break-all;/g, '');
	
	            var x = {
	                revenueShare: this.agreemetformdata.revenue_share,
	                periodToSendRevPub: this.agreemetformdata.period_to_send_rev_pub,
	                revDistClarityExample: this.agreemetformdata.rev_dist_clarity_example,
	                terminationDurationForPub: this.agreemetformdata.termination_duration_for_pub,
	                legalPublisherName: this.agreemetformdata.LegalPublisherName,
	                agreementDoc: agreementDoc
	            };
	            _axios2.default.post(api, x, {
	                headers: {
	                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}'
	                }
	            }).then(function (response) {
	                var b64 = response.data.encoded_string;
	                var link = document.createElement('a');
	                link.innerHTML = 'Download PDF file';
	                link.download = response.data.fileName;
	                link.href = 'data:application/octet-stream;base64,' + b64;
	                link.click();
	
	                _this2.$notify({
	                    title: 'Success',
	                    message: 'Successfully download',
	                    type: 'success'
	                });
	            }, function (error) {
	                _this2.sendinginvite = false;
	            });
	        },
	        submitinvite: function submitinvite() {
	            this.sentInviteScreenVisible = true;
	        },
	        submit: function submit() {
	            var _this3 = this;
	
	            this.sentInviteScreenVisible = false;
	            this.sendinginvite = true;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + 'v1/send-invite-signnow/' + this.$route.params.id + '/';
	
	            var agreementDoc = document.getElementById('agreementform').innerHTML;
	
	            agreementDoc = agreementDoc.replace(/word-break: break-all;/g, '');
	
	            var x = {
	                revenueShare: this.agreemetformdata.revenue_share,
	                periodToSendRevPub: this.agreemetformdata.period_to_send_rev_pub,
	                revDistClarityExample: this.agreemetformdata.rev_dist_clarity_example,
	                terminationDurationForPub: this.agreemetformdata.termination_duration_for_pub,
	                agreementDoc: agreementDoc
	            };
	            _axios2.default.post(api, x, {
	                headers: {
	                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}'
	                }
	            }).then(function (response) {
	                if (response) {
	                    _this3.$notify({
	                        title: 'Success',
	                        message: 'Successfully sent invite',
	                        type: 'success'
	                    });
	                    _this3.sendinginvite = false;
	                    _this3.$router.push('/admin/AllPublisher/');
	                }
	            }, function (error) {
	                _this3.sendinginvite = false;
	            });
	        },
	        editPDF: function editPDF() {
	            this.isPreview = false;
	            var ifram = document.getElementById(this.iframobj);
	
	            this.iframobj.style.display = 'none';
	        },
	        previewPDF: function previewPDF() {
	            var _this4 = this;
	
	            this.isPreview = true;
	            var agreementDoc = document.getElementById('agreementform').innerHTML;
	
	            var x = {
	                revenueShare: this.agreemetformdata.revenue_share,
	                periodToSendRevPub: this.agreemetformdata.period_to_send_rev_pub,
	                revDistClarityExample: this.agreemetformdata.rev_dist_clarity_example,
	                terminationDurationForPub: this.agreemetformdata.termination_duration_for_pub,
	                agreementDoc: agreementDoc
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/pdf-preview/', x, {
	                headers: {
	                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}'
	                }
	            }).then(function (response) {
	                var b64 = response.data;
	
	                _this4.iframobj = document.createElement('iframe');
	
	                _this4.iframobj.style.width = '100%';
	                _this4.iframobj.style.height = '842pt';
	                _this4.iframobj.type = 'application/pdf';
	                _this4.iframobj.src = 'data:application/pdf;base64,' + b64;
	
	                document.getElementById('displaypdf').prepend(_this4.iframobj);
	            }, function (error) {});
	        }
	    }
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Agreement = __webpack_require__(255);
	
	var _Agreement2 = _interopRequireDefault(_Agreement);
	
	var _PreviewPDF = __webpack_require__(256);
	
	var _PreviewPDF2 = _interopRequireDefault(_PreviewPDF);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        agreement: _Agreement2.default,
	        pdf: _PreviewPDF2.default
	    },
	    data: function data() {
	        return {
	            agreemetformdata: {
	                revenue_share: '',
	                period_to_send_rev_pub: '',
	                rev_dist_clarity_example: '',
	                termination_duration_for_pub: ''
	            },
	            agreementDoc: ''
	        };
	    },
	
	    methods: {
	        submit: function submit() {
	            var agreementDoc = document.getElementById('agreementform').innerHTML;
	
	            var x = {
	                revenueShare: this.agreemetformdata.revenue_share,
	                periodToSendRevPub: this.agreemetformdata.period_to_send_rev_pub,
	                revDistClarityExample: this.agreemetformdata.rev_dist_clarity_example,
	                terminationDurationForPub: this.agreemetformdata.termination_duration_for_pub,
	                agreementDoc: agreementDoc
	            };
	
	            console.log(x);
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/signNowApi/', x, {
	                headers: {
	                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}'
	                }
	            }).then(function (response) {
	                console.log(response);
	            }, function (error) {
	                console.log('Error');
	            });
	        },
	        previewPDF: function previewPDF() {
	            var _this = this;
	
	            var agreementDoc = document.getElementById('agreementform').innerHTML;
	
	            var x = {
	                revenueShare: this.agreemetformdata.revenue_share,
	                periodToSendRevPub: this.agreemetformdata.period_to_send_rev_pub,
	                revDistClarityExample: this.agreemetformdata.rev_dist_clarity_example,
	                terminationDurationForPub: this.agreemetformdata.termination_duration_for_pub,
	                agreementDoc: agreementDoc
	            };
	
	            console.log(x);
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/GeneratePDF/', x, {
	                headers: {
	                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}'
	                }
	            }).then(function (response) {
	                _this.$notify({
	                    title: 'Success',
	                    message: 'Successfully created a new publisher',
	                    type: 'success'
	                });
	
	                setTimeout(function () {
	                    _this.$router.push('/admin/publisher/PreviewPDF');
	                }, 1000);
	            }, function (error) {
	                console.log('Error');
	            });
	        }
	    }
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAvatar = __webpack_require__(80);
	
	var _vueAvatar2 = _interopRequireDefault(_vueAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				name: 'ShopHome',
				publishers: [],
				dialogTableVisible: false,
				dialogFormVisible: false,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				formLabelWidth: '120px'
			};
		},
	
		beforeCreate: function beforeCreate() {
			this.$nextTick(function () {
				var _this = this;
	
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/').then(function (response) {
					_this.publishers = response.data;
				}).catch(function (error) {
					if (error.response.status == 400) {
						if (error.response.data) {
							console.log(error.response.data);
						}
					}
				});
			});
		},
		methods: {},
		components: {
			Avatar: _vueAvatar2.default
		}
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAvatar = __webpack_require__(80);
	
	var _vueAvatar2 = _interopRequireDefault(_vueAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: 'ShopHome',
	      publishers: [],
	      publishersId: this.$route.params.id,
	      publishersUuid: this.$route.params.uuid
	    };
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.$nextTick(function () {
	      var _this = this;
	
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/domains/').then(function (response) {
	        console.log(response.data.length);
	        _this.publishers = response.data;
	        if (response.data.length >= 1) {}
	      }).catch(function (error) {
	        if (error.response.status == 400) {
	          if (error.response.data) {
	            console.log(error.response.data);
	          }
	        }
	      });
	    });
	  },
	  methods: {},
	
	  components: {
	    Avatar: _vueAvatar2.default
	  }
	
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(391);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _create = __webpack_require__(95);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _epsilon = __webpack_require__(381);
	
	var _epsilon2 = _interopRequireDefault(_epsilon);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(252);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _vueJsonCsv = __webpack_require__(253);
	
	var _vueJsonCsv2 = _interopRequireDefault(_vueJsonCsv);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue2Datepicker = __webpack_require__(719);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "Revenue",
	    data: function data() {
	        var _this = this;
	
	        return {
	            isLoading: false,
	            publisherId: undefined,
	            domainId: undefined,
	
	            impressionRevenueReportData: [],
	            impressionRevenueTableData: [],
	            selectedValueRange: [new Date(), new Date()],
	            selectedStartDate: undefined,
	            selectedEndDate: undefined,
	            today: undefined,
	            endDate: undefined,
	            startDate: undefined,
	            tableBidderName: [],
	            csvData: [],
	            allDomains: [],
	            reportName: "AutomatadReports_" + (0, _moment2.default)(new Date()).format("YYYY-MM-DD") + ".csv",
	            domainName: [],
	            lang: {
	                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                pickers: ["next 7 days", "next 30 days", "previous 7 days", "previous 30 days"],
	                placeholder: {
	                    date: "Select Date",
	                    dateRange: "Select Date Range"
	                }
	            },
	            shortcuts: [{
	                text: "Month-to-date",
	                onClick: function onClick() {
	                    _this.selectedValueRange = [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()];
	                    _this.getRevenueImpressionReports();
	                }
	            }, {
	                text: "Last Month",
	                onClick: function onClick() {
	                    _this.selectedValueRange = [new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), new Date(new Date().getFullYear(), new Date().getMonth(), 0)];
	                    _this.getRevenueImpressionReports();
	                }
	            }, {
	                text: "Last Six Month",
	                onClick: function onClick() {
	                    _this.selectedValueRange = [new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1), new Date(new Date().getFullYear(), new Date().getMonth(), 0)];
	                    _this.getRevenueImpressionReports();
	                }
	            }],
	            totalColECPM: 0,
	            totalColImpression: 0,
	            totalColRevenue: 0
	        };
	    },
	
	    components: {
	        JsonCSV: _vueJsonCsv2.default,
	        DatePicker: _vue2Datepicker2.default
	    },
	    computed: {},
	    created: function created() {
	        this.domainId = parseInt(this.$route.params.domid);
	
	        this.publisherId = parseInt(this.$route.params.pubid);
	    },
	    mounted: function mounted() {
	        this.publisherId = this.$route.params.pubid;
	
	        this.today = new Date();
	        this.endDate = new Date();
	        var firstStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
	        this.startDate = new Date(firstStartDate.setDate(firstStartDate.getDate() - 2));
	
	        this.selectedValueRange[0] = this.startDate;
	        this.selectedValueRange[1] = this.endDate;
	        this.getBiddernames();
	        this.getDomain(this.domainId);
	        this.getRevenueImpressionReports();
	        this.getPublisherDomainList();
	    },
	
	    methods: {
	        addCommas: function addCommas(number) {
	            var minDecimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var maxDecimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.max(3, minDecimalPlaces);
	
	            var options = {};
	            options.maximumFractionDigits = maxDecimalPlaces;
	            options.minimumFractionDigits = minDecimalPlaces;
	            return Intl.NumberFormat("en-US", options).format(number);
	        },
	        tsting: function tsting() {
	            return {
	                transform: this.transformEachLine
	            };
	        },
	        transformEachLine: function transformEachLine(value, columnNumber) {
	            if (value == "") {
	                value = 0;
	            }
	            return value;
	        },
	        getDomain: function getDomain(domain) {
	            var _this2 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "reports/v1/pub-get-dash-info/", {
	                publisherId: this.publisherId
	            }).then(function (response) {
	                if (response.data.status) {
	                    if (domain == null) {
	                        _this2.allDomains = "".concat(response.data.data.map(function (k) {
	                            return " " + k.domain_name;
	                        }));
	                    } else {
	                        _this2.allDomains = "".concat(response.data.data.filter(function (k) {
	                            return domain == k.domain_id;
	                        })[0].domain_name);
	                    }
	                    return _this2.allDomains;
	                }
	            }).catch(function (e) {});
	        },
	        getColumnCPM: function getColumnCPM(bidder) {
	            var revenue = 0;
	            var impression = 0;
	            var arr = 0;
	
	            if (bidder == "total") {
	                this.impressionRevenueReportData.map(function (k) {
	                    if (k.hasOwnProperty("impression")) {
	                        revenue += k["revenue"];
	                        impression += k["impression"];
	                    }
	                });
	            } else {
	                this.impressionRevenueReportData.map(function (k) {
	                    if (k.bidderImpressionRevenue.hasOwnProperty(bidder)) {
	                        revenue += k.bidderImpressionRevenue[bidder]["revenue"];
	                        impression += k.bidderImpressionRevenue[bidder]["impression"];
	                    }
	                });
	            }
	
	            if (impression != 0) {
	                arr = revenue / impression * 1000;
	                return Math.round((arr + _epsilon2.default) * 100) / 100;
	            }
	            return arr;
	        },
	        fillMissingObj: function fillMissingObj(object) {
	            var defaults = {};
	            var list = [];
	
	            function addToList(obj) {
	                var entry = (0, _create2.default)(defaults);
	
	                (0, _keys2.default)(obj).forEach(function (key) {
	                    if (!defaults.hasOwnProperty(key)) {
	                        defaults[key] = "default for " + key;
	                    }
	
	                    entry[key] = obj[key];
	                });
	
	                list.push(entry);
	            }
	
	            addToList({
	                a: "a0",
	                b: "b0"
	            });
	            addToList({
	                a: "a1",
	                c: "c1"
	            });
	            addToList({
	                b: "b2",
	                d: "d2"
	            });
	
	            list.forEach(function (entry, index) {
	                snippet.log("Object #" + index + ":");
	                (0, _keys2.default)(defaults).forEach(function (key) {
	                    snippet.log(key + " = " + entry[key]);
	                });
	            });
	        },
	        dict_reverse: function dict_reverse(obj) {
	            var new_obj = {};
	            var rev_obj = ["impression", "revenue", "ecpm"];
	            rev_obj.forEach(function (i) {
	                new_obj[i] = obj[i];
	            });
	            return new_obj;
	        },
	        reverseObject: function reverseObject(object) {
	            var newObject = {};
	            var keys = [];
	
	            for (var key in object) {
	                keys.push(key);
	            }
	
	            for (var i = keys.length - 1; i >= 0; i--) {
	                var value = object[keys[i]];
	                newObject[keys[i]] = value;
	            }
	            return newObject;
	        },
	        getColumnTotal: function getColumnTotal(bidder, property) {
	            var arr = 0;
	
	            if (bidder == "total") {
	                this.impressionRevenueReportData.map(function (k) {
	                    if (k.hasOwnProperty(property)) {
	                        arr += k[property];
	                    }
	                });
	            } else {
	                this.impressionRevenueReportData.map(function (k) {
	                    if (k.bidderImpressionRevenue.hasOwnProperty(bidder)) {
	                        arr += k.bidderImpressionRevenue[bidder][property];
	                    }
	                });
	            }
	            if (property == "revenue") {
	                return Math.round((arr + _epsilon2.default) * 100) / 100;
	            }
	            return arr;
	        },
	        getRevenueImpressionReports: function getRevenueImpressionReports() {
	            var _this3 = this;
	
	            var self = this;
	            var diff = this.selectedValueRange[1].getTime() - this.selectedValueRange[0].getTime();
	            var maxDate = Math.floor(diff / (1000 * 60 * 60 * 24));
	
	            if (maxDate <= 186) {
	                this.isLoading = true;
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "reports/v1/get-impression-revenue-reports/", {
	                    publisherId: this.publisherId,
	                    domainId: this.domainId,
	                    selectedDateRange: {
	                        start: _moment2.default.utc(this.selectedValueRange[0]).local().format("DD/MM/YYYY"),
	                        end: _moment2.default.utc(this.selectedValueRange[1]).local().format("DD/MM/YYYY")
	                    }
	                }).then(function (response) {
	                    _this3.isLoading = false;
	                    if (response.data.status) {
	                        _this3.impressionRevenueReportData = response.data.data;
	                        _this3.impressionRevenueTableData = _this3.impressionRevenueReportData.reverse();
	                        _this3.getDomain(_this3.domainId);
	                        var bidderTotal = {};
	                        var sites = {};
	                        var dateRange = {};
	                        var count = 0;
	                        _this3.csvData = _this3.impressionRevenueReportData.map(function (_ref, index) {
	                            var bidderImpressionRevenue = _ref.bidderImpressionRevenue,
	                                currency = _ref.currency,
	                                attrs = (0, _objectWithoutProperties3.default)(_ref, ["bidderImpressionRevenue", "currency"]);
	
	                            var l = {};
	                            for (var i in _this3.tableBidderName) {
	                                var bidr = _this3.tableBidderName[i];
	                                var bidObj = bidderImpressionRevenue.hasOwnProperty(bidr) ? _this3.dict_reverse(bidderImpressionRevenue[bidr]) : _this3.dict_reverse({
	                                    impression: 0,
	                                    ecpm: 0,
	                                    revenue: 0
	                                });
	                                for (var m in bidObj) {
	                                    if (m == "revenue" || m == "ecpm") {
	                                        l[bidr + " " + m + "($)"] = bidderImpressionRevenue.hasOwnProperty(bidr) ? _this3.addCommas(bidderImpressionRevenue[bidr][m]) : 0;
	                                    } else {
	                                        l[bidr + " " + m] = bidderImpressionRevenue.hasOwnProperty(bidr) ? _this3.addCommas(bidderImpressionRevenue[bidr][m]) : 0;
	                                    }
	                                }
	                            }
	
	                            for (var i in bidderImpressionRevenue) {
	                                for (var m in _this3.dict_reverse(bidderImpressionRevenue[i])) {
	                                    if (count == 0) {
	                                        sites[i + " " + m] = _this3.allDomains;
	                                        dateRange[i + " " + m] = (0, _moment2.default)(_this3.selectedValueRange[0]).format("YYYY-MM-DD") + " to " + (0, _moment2.default)(_this3.selectedValueRange[1]).format("YYYY-MM-DD");
	                                    }
	                                    count += 1;
	                                    if (m == "revenue" || m == "ecpm") {
	                                        if (m == "revenue") {
	                                            bidderTotal[i + " " + m + "($)"] = _this3.addCommas(_this3.getColumnTotal(i, m));
	                                        } else {
	                                            bidderTotal[i + " " + m + "($)"] = _this3.getColumnCPM(i);
	                                        }
	                                    } else {
	                                        bidderTotal[i + " " + m] = _this3.addCommas(_this3.getColumnTotal(i, m));
	                                    }
	                                }
	                            }
	
	                            return (0, _assign2.default)({
	                                Date: (0, _moment2.default)(attrs.date).format("ll")
	                            }, l, {
	                                " Ad Impressions": attrs.impression,
	                                "Estimated Revenue($)": attrs.revenue,
	                                "ECPM($)": attrs.ecpm
	                            });
	                        });
	
	                        var dateT = "";
	                        var siteT = "";
	
	                        if ((0, _keys2.default)(dateRange).length == 0) {
	                            dateT = (0, _moment2.default)(_this3.selectedValueRange[0]).format("YYYY-MM-DD") + " to " + (0, _moment2.default)(_this3.selectedValueRange[1]).format("YYYY-MM-DD");
	                        } else {
	                            dateT = "";
	                        }
	
	                        if ((0, _keys2.default)(sites).length == 0) {
	                            siteT = _this3.allDomains;
	                        } else {
	                            siteT = "";
	                        }
	
	
	                        _this3.csvData = [].concat((0, _toConsumableArray3.default)(_this3.csvData), [(0, _assign2.default)({
	                            Date: "Total"
	                        }, bidderTotal, {
	                            " Ad Impressions": _this3.addCommas(_this3.getColumnTotal("total", "impression")),
	                            "Estimated Revenue($)": _this3.addCommas(_this3.getColumnTotal("total", "revenue")),
	                            "ECPM($)": _this3.getColumnCPM("total")
	                        }), {
	                            Date: "",
	                            " Ad Impressions": "",
	                            "Estimated Revenue($)": ""
	                        }, (0, _assign2.default)({
	                            Date: "Domain:"
	                        }, sites, {
	                            " Ad Impressions": siteT,
	                            "Estimated Revenue($)": ""
	                        }), (0, _assign2.default)({
	                            Date: "Date Range:"
	                        }, dateRange, {
	                            " Ad Impressions": dateT,
	                            "Estimated Revenue($)": ""
	                        })]);
	                    }
	                }).catch(function (e) {});
	            } else {
	
	                self.$notify({
	                    title: "warning",
	                    message: "Selected Date range should be lesser than or equal to 6 month.",
	                    type: "warning"
	                });
	            }
	        },
	        domainNameFormatter: function domainNameFormatter(domainName) {
	            return domainName.replace("http://", "").replace("https://", "").replace("/", "");
	        },
	        getPublisherDomainList: function getPublisherDomainList() {
	            var _this4 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "reports/v1/pub-get-dash-info/", {
	                publisherId: this.publisherId
	            }).then(function (response) {
	                if (response.data.status) {
	                    _this4.domainName = response.data.data;
	                }
	            }).catch(function (e) {
	                _this4.unauthorizedAccess();
	            });
	        },
	        getBiddernames: function getBiddernames() {
	            var _this5 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "reports/v1/get-bidder-names/", {
	                publisherId: this.publisherId,
	                domainId: this.domainId
	            }).then(function (response) {
	                if (response.data.status) {
	                    _this5.tableBidderName = response.data.data;
	                }
	            }).catch(function (e) {});
	        },
	        getBidderTotalRevenueAndImpression: function getBidderTotalRevenueAndImpression(idx, bidderNm, impresssionOrRevenue) {
	            var impressionRevenue = 0;
	            if (this.impressionRevenueReportData[idx]["bidderImpressionRevenue"].hasOwnProperty(bidderNm)) {
	                impressionRevenue = this.impressionRevenueReportData[idx]["bidderImpressionRevenue"][bidderNm][impresssionOrRevenue];
	            }
	            return impressionRevenue;
	        },
	        dateFormater: function dateFormater(dt) {
	            return dt.toString().replace("T00:00:00", "");
	        }
	    }
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        newPassword1: '',
	        newPassword2: ''
	      },
	      message: ''
	    };
	  },
	
	
	  methods: {
	    clear: function clear() {
	      this.credentials.old_password = '';
	      this.credentials.newPassword1 = '';
	      this.credentials.newPassword2 = '';
	    },
	    passwordChange: function passwordChange() {
	      var _this = this;
	
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/auth/password/change/', {
	        old_password: this.credentials.oldPassword,
	        new_password1: this.credentials.newPassword1,
	        new_password2: this.credentials.newPassword2
	      }).then(function (response) {
	        _this.$notify({
	          title: 'Success',
	          message: 'Password has been changed successfully.',
	          type: 'success'
	        });
	
	        setTimeout(function () {
	          _this.$router.push('/admin/domains/');
	        }, 1000);
	      }).catch(function (error) {
	        if (error.response.status == 400) {
	          if (error.response.data['old_password']) {
	            _this.$notify({
	              title: 'Entered User Password Wrong',
	              message: 'Please Enter the correct the password.',
	              type: 'warning'
	            });
	            _this.credentials.old_password = '';
	          } else {
	            _this.message = error.response.data.new_password2[0];
	            _this.$notify({
	              title: 'Unable to Update',
	              message: 'The entered passwords don\'t match.',
	              type: 'warning'
	            });
	            _this.credentials.newPassword1 = '';
	            _this.credentials.newPassword2 = '';
	          }
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _veeValidate = __webpack_require__(251);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_veeValidate2.default);
	exports.default = {
	    data: function data() {
	        return {
	            forgetPassword: false,
	            credentials: {
	                email: "",
	                password: ""
	            },
	            roles: [],
	            error: "",
	            resetEmailID: ""
	        };
	    },
	
	    created: function created() {
	        this.$nextTick(function () {
	            if (this.$auth.check() == true) {}
	        });
	    },
	    methods: {
	        backLogin: function backLogin() {
	            this.forgetPassword = false;
	        },
	        resetPassword: function resetPassword() {
	            this.$notify({
	                title: "Success",
	                message: "If the account exists you will recieve an E-Mail for the password reset.",
	                type: "success"
	            });
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/auth/password/reset/", {
	                email: this.resetEmailID
	            }).then(function (response) {
	                console.log("success");
	            }).catch(function (err) {
	                console.log("error");
	            });
	        },
	        forgetpassword: function forgetpassword() {
	            this.forgetPassword = true;
	        },
	        submit: function submit() {
	            var credentials = {
	                email: this.credentials.email,
	                password: this.credentials.password
	            };
	            var redirect = this.$auth.redirect();
	            console.log(redirect);
	            this.$auth.login({
	                data: credentials,
	                url: ("https://beta-yeti-api.automatad.com/") + "v1/auth/login/",
	                fetchUser: false,
	                success: function success(response) {
	                    console.log(response);
	                    if (response.data.story_access && response.data.story_domain_id && response.data.story_pub_uuid) {
	                        console.log("STORY ONLy");
	                    }
	                    this.roles = response.data.user.roles;
	
	                    localStorage.setItem("user", (0, _stringify2.default)(response.data.user));
	                    this.$auth.user(JSON.parse(localStorage.getItem("user")));
	                    this.$auth.watch.authenticated = true;
	                    this.$auth.watch.loaded = true;
	                    console.log(this.$auth.check(["admin"]));
	                    console.log("Success");
	                    console.error(this._user);
	                },
	                error: function error() {
	                    this.$notify({
	                        title: "Warning",
	                        message: "Unable to login, the credentials are wrong.",
	                        type: "warning"
	                    });
	                },
	
	
	                redirect: { path: "/publisher/dashboard" }
	            });
	        }
	    },
	    computed: {
	        formValid: function formValid() {
	            return this.credentials.email && this.credentials.password;
	        },
	        _user: function _user() {
	            return this.$auth.user() || {};
	        }
	    }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      error: ''
	    };
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.$nextTick(function () {
	      this.$auth.logout({
	        makeRequest: true,
	        url: ("https://beta-yeti-api.automatad.com/") + 'v1/auth/logout/',
	        success: function success() {
	          this.$notify({
	            title: 'Success',
	            message: 'You have successfully logged out.',
	            type: 'success'
	          });
	          console.log('success');
	          localStorage.removeItem("user");
	        },
	        error: function error() {
	          console.log('failed');
	        },
	        redirect: '/'
	      });
	    });
	  }
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _veeValidate = __webpack_require__(251);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_veeValidate2.default);
	exports.default = {
		data: function data() {
			return {
				credentials: {
					password1: '',
					password2: ''
				},
				error: ''
			};
		},
	
		methods: {
			submit: function submit() {
				var _this = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/auth/password/reset/confirm/', {
					uid: this.$route.params.id,
					token: this.$route.params.resetID,
					new_password1: this.credentials.password1,
					new_password2: this.credentials.password2
				}).then(function (response) {
					_this.$notify({
						title: 'Success',
						message: 'Password has been changed successfully.',
						type: 'success'
					});
	
					setTimeout(function () {
						_this.$router.push('/login/');
					}, 1500);
				}).catch(function (error) {
					_this.$notify({
						title: 'Warning',
						message: 'Password has not been changed, please check if the passwords entered are same.',
						type: 'warning'
					});
				});
			}
		},
		computed: {
			formValid: function formValid() {
				if (this.credentials.password2 && this.credentials.password1 != this.credentials.password2) {
					this.error = "Error, the two passwords do not match.";
				} else {
					this.error = "";
				}
				return this.credentials.password1 == this.credentials.password2;
			}
		}
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _util = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            module: 'axt',
	            bucketId: undefined,
	            randomSizeForm: {
	                randomSize: ''
	            },
	            axtConfig: {
	                isEnabled: false,
	                initialExpo: 15,
	                subSequentExpo: 15,
	                associatedTags: [],
	                selectedCreative: undefined,
	                selectedTags: undefined,
	                existingCreatives: [],
	                showAddMoreCreative: false,
	                activateWhitelist: false
	            },
	            layoutsList: [],
	
	            layoutAdSpotsList: [],
	            setUnitConfig: {
	                layout: undefined,
	                layoutAdSpots: undefined
	            },
	            adunits: [],
	            axtTags: [],
	            randomSizeList: {},
	            randomSizeList2: {},
	            creativeSizeList: [],
	            bucketListForModuleConfig: [],
	            selectedBucketToImportConfig: undefined,
	            selectedBucketNameToImportConfig: undefined,
	            axtConfigUnitList: [],
	            filterList: [],
	            multiSelectConfig: {
	                isBlocked: false,
	                isWhitelisted: false,
	                initialExpo: undefined,
	                subSeqExpo: undefined,
	                ignoreActivity: false,
	                tagId: '',
	                tagOverride: false,
	                multiSize: ''
	            },
	            multiSelectedUnits: [],
	            enableConfigSetting: false,
	            loading: false,
	            directCampConfig: {
	                advertId: ''
	            },
	            axtDCBlockList: [],
	            addAxtDCBlockList: [],
	            multiSelectedDCUnits: [],
	            multiSelectDCConfig: {
	                isBlocked: false
	            },
	            enableDCConfigSetting: false,
	            subsequentReload: true,
	            isedit: false,
	            israndomsize: false,
	            data_to_be_updated: {},
	            checkedAll: [],
	            messageb: '',
	            isCheckedRandomSizeMap: [],
	            isRandomValid: '/[0-9]*X[0-9]*/g'
	        };
	    },
	
	
	    created: function created() {
	        this.bucketId = this.$route.params.bucketId;
	        this.$nextTick(function () {
	            this.getListOfBucketConfig();
	            this.getAxtConfig(this.$route.params.bucketId);
	            this.getUnitConfigList(this.bucketId);
	            this.getDirectCampaignBlockList();
	        });
	    },
	    methods: {
	        filterByEachInput: function filterByEachInput() {
	            var _this = this;
	
	            var input = this.randomSizeForm.randomSize;
	            this.duplicatekey = ' ';
	            this.isDuplicate = false;
	            if (input.length == 0) {
	                this.randomSizeList2 = this.randomSizeList;
	                this.isedit = false;
	                return;
	            }
	            var keyres = input.includes(':');
	            if (keyres) {
	                var sizeInputObj = this.convertSizeInputStringFromObject(input);
	            }
	
	            var regex = new RegExp('^' + input);
	            var randomSizeList2 = (0, _keys2.default)(this.randomSizeList).filter(function (key) {
	                return regex.test(key);
	            }).reduce(function (obj, key) {
	                obj[key] = _this.randomSizeList[key];
	                return obj;
	            }, {});
	            if ((0, _keys2.default)(randomSizeList2).length != 0) {
	                this.randomSizeList2 = randomSizeList2;
	            } else {
	                this.randomSizeList2 = this.randomSizeList;
	            }
	            return randomSizeList2;
	        },
	        deleteRandomSizeSingle: function deleteRandomSizeSingle(key_AsPerameterOf_delete) {
	            var _this2 = this;
	
	            var randomSizeMap = {};
	            randomSizeMap[key_AsPerameterOf_delete] = this.randomSizeList2[key_AsPerameterOf_delete];
	            var x = {
	                bucketId: this.bucketId,
	                randomSize: randomSizeMap
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/delete_axt_random_size/', x).then(function (response) {
	                delete _this2.randomSizeList2[key_AsPerameterOf_delete];
	                _this2.randomSizeList = {};
	                (0, _assign2.default)(_this2.randomSizeList, _this2.randomSizeList2);
	                _this2.$forceUpdate();
	            }).catch(function (e) {
	                _this2.errors.push(e);
	            });
	        },
	        editRandomSize: function editRandomSize(key_AsPerameterOf_edit) {
	            this.isedit = true;
	            key_AsPerameterOf_edit = key_AsPerameterOf_edit + ':' + this.randomSizeList2[key_AsPerameterOf_edit];
	            this.randomSizeForm.randomSize = key_AsPerameterOf_edit;
	            var key_for_data_to_be_updated = key_AsPerameterOf_edit.split(':');
	            this.data_to_be_updated[key_for_data_to_be_updated[0]] = key_for_data_to_be_updated[1];
	        },
	        selectAll: function selectAll(randomSizeObj) {
	            var key = (0, _keys2.default)(this.isCheckedRandomSizeMap);
	            for (var i = 0; i < key.length; i++) {
	                var k = key[i];
	                if (this.isCheckedRandomSizeMap[k] == true) {
	                    if (this.checkedAll.includes(key[i]) == false) {
	                        this.checkedAll.push(key[i]);
	                    }
	                } else {
	                    for (var j = 0; j < this.checkedAll.length; j++) {
	                        if (this.checkedAll[j] == k) {
	                            delete this.checkedAll[j];
	                            break;
	                        }
	                    }
	                }
	            }
	        },
	        deleteBlogAll: function deleteBlogAll() {
	            var _this3 = this;
	
	            var x = {
	                bucketId: this.bucketId,
	                randomSize: this.checkedAll
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/delete_axt_random_size/', x).then(function (response) {
	                for (var i = 0; i < _this3.checkedAll.length; i++) {
	                    delete _this3.randomSizeList2[_this3.checkedAll[i]];
	                }
	                _this3.randomSizeList = {};
	                (0, _assign2.default)(_this3.randomSizeList, _this3.randomSizeList2);
	                while (_this3.checkedAll.length) {
	                    _this3.checkedAll.pop();
	                }
	                _this3.isCheckedRandomSizeMap = [];
	                _this3.$forceUpdate();
	            }).catch(function (e) {
	                _this3.errors.push(e);
	            });
	        },
	        myTrim: function myTrim(x) {
	            return x.replace(/\s/g, '');
	        },
	        convertSizeInputStringFromObject: function convertSizeInputStringFromObject(sizeInput) {
	            var value;
	            var sizeInputObj = {};
	            sizeInput = this.myTrim(sizeInput);
	            var regex = /[^\w | \, | \:]/g;
	            sizeInput = sizeInput.replace(regex, '');
	            if (sizeInput.indexOf(',') > -1) {
	                var nameArr = sizeInput.split(',');
	                nameArr.filter(function (val) {
	                    value = val.split(':');
	                    sizeInputObj[value[0]] = value[1];
	                });
	            } else {
	                value = sizeInput.split(':');
	                sizeInputObj[value[0]] = value[1];
	            }
	            return sizeInputObj;
	        },
	        saveBlog: function saveBlog() {
	            var _this4 = this;
	
	            var sizeInput = this.randomSizeForm.randomSize;
	            var sizeInputObj = this.convertSizeInputStringFromObject(sizeInput);
	            sizeInputObj = this.getFilterAxtRandomSize(sizeInputObj);
	
	            if (this.isedit) {
	                if ((0, _keys2.default)(sizeInputObj).length == 0) {
	                    return;
	                }
	                var y = {
	                    bucketId: this.bucketId,
	                    data_to_be_updated: this.data_to_be_updated,
	                    randomSize: sizeInputObj
	                };
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/update_axt_random_size/', y).then(function (response) {
	                    var keysz = (0, _keys2.default)(_this4.data_to_be_updated);
	                    delete _this4.randomSizeList2[keysz[0]];
	                    for (var key in sizeInputObj) {
	                        _this4.$set(_this4.randomSizeList2, key, sizeInputObj[key]);
	                    }
	                    _this4.randomSizeList = {};
	                    (0, _assign2.default)(_this4.randomSizeList, _this4.randomSizeList2);
	                    _this4.data_to_be_updated = {};
	                    _this4.isedit = false;
	                }).catch(function (e) {
	                    _this4.errors.push(e);
	                });
	                this.randomSizeForm.randomSize = '';
	                return;
	            }
	
	            var x = {
	                bucketId: this.bucketId,
	                randomSize: sizeInputObj
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/add_axt_random_size/', x).then(function (response) {
	                for (var key in sizeInputObj) {
	                    _this4.$set(_this4.randomSizeList2, key, sizeInputObj[key]);
	                    _this4.randomSizeList2 = JSON.parse((0, _stringify2.default)(_this4.randomSizeList2));
	                }
	                _this4.randomSizeList = {};
	                (0, _assign2.default)(_this4.randomSizeList, _this4.randomSizeList2);
	                _this4.data_to_be_updated = {};
	                _this4.israndomsize = true;
	            }).catch(function (e) {
	                _this4.errors.push(e);
	            });
	            this.randomSizeForm.randomSize = '';
	        },
	
	
	        getFilterAxtRandomSize: function getFilterAxtRandomSize(sizeInputObj) {
	            var isValid = /^\d+X\d+$/;
	            var ObjectRight = {};
	            var ObjectNotRight = {};
	            for (var key in sizeInputObj) {
	                var keyres = isValid.test(key);
	                var valueres = isValid.test(sizeInputObj[key]);
	                if (keyres == true && valueres == true) {
	                    ObjectRight[key] = sizeInputObj[key];
	                } else {
	                    ObjectNotRight[key] = sizeInputObj[key];
	                }
	            }
	            var ar = ObjectNotRight;
	            if ((0, _keys2.default)(ar).length != 0) {
	                ar = (0, _stringify2.default)(ar);
	                this.$notify({
	                    title: 'warning',
	                    message: ar,
	                    type: 'warning'
	                });
	            } else {
	                this.$notify({
	                    title: 'success',
	                    message: 'success',
	                    type: 'success'
	                });
	            }
	            return ObjectRight;
	        },
	        getTag: function getTag(arr, index) {
	            var reqVal = arr.filter(function (val) {
	                if (val.id == index) {
	                    return val;
	                }
	            });
	            if (reqVal.length == 0) {
	                return 'No Tags associated';
	            } else {
	                return reqVal[0]['dfp-ad-unit-path'];
	            }
	        },
	        getSelecteditem: function getSelecteditem(event, tagId) {
	            console.log('test');
	            console.log(tagId.adSpotName);
	            console.log(event);
	        },
	        notificationMsg: function notificationMsg() {
	            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
	            var msg = arguments[1];
	
	            this.$notify({
	                title: type,
	                message: msg ? msg : 'Oops Something went wrong!',
	                type: type.toLowerCase()
	            });
	        },
	        getListOfBucketConfig: function getListOfBucketConfig() {
	            var _this5 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_bucket_config_list/', {
	                bucketId: this.bucketId,
	                module: this.module
	            }).then(function (response) {
	                if (response.data.response_data.status) {
	                    _this5.bucketListForModuleConfig = response.data.response_data.bucket_list;
	                }
	            }).catch(function (e) {
	                console.log();
	            });
	        },
	        getAxtConfig: function getAxtConfig(bucketId) {
	            var _this6 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/axt_module/', {
	                bucketId: bucketId
	            }).then(function (response) {
	                _this6.axtConfig = response.data.data.axt_configuration;
	                _this6.creativeSizeList = response.data.data.ad_dimensions;
	                _this6.axtTags = response.data.data.axt_ad_tags;
	                _this6.layoutsList = response.data.data.domain_layouts;
	                _this6.randomSizeList2 = response.data.data.axt_random_size[0].random_size;
	                _this6.randomSizeList = response.data.data.axt_random_size[0].random_size;
	                if (_this6.randomSizeList2) {
	                    _this6.israndomsize = true;
	                }
	            }).catch(function (e) {
	                _this6.errors.push(e);
	            });
	        },
	        saveAndPublishAxt: function saveAndPublishAxt() {
	            var _this7 = this;
	
	            var valid = true;
	            if (valid && parseInt(this.axtConfig.initialExpo) < 5) {
	                valid = false;
	                this.notificationMsg('Warning', "Initial Exposure time should be greater than or equal to 5sec's.");
	            }
	
	            if (valid && parseInt(this.axtConfig.subSequentExpo) < 5) {
	                valid = false;
	                this.notificationMsg('Warning', "Sub-sequent Exposure time should be greater than or equal to 5sec's.");
	            }
	
	            if (valid) {
	                var i = 0,
	                    idx = this.axtConfig.associatedTags.length;
	                for (; i < idx; i++) {
	                    if (this.axtConfig.associatedTags[i].isChecked && !this.axtConfig.associatedTags[i].selectedTags) {
	                        this.notificationMsg('Warning', 'Associate Tag for the selected Creative size ' + this.axtConfig.associatedTags[i].creativeSizeLable);
	                        valid = false;
	                        return false;
	                    }
	                }
	            }
	
	            if (valid) {
	                var requestData = {
	                    bucketId: this.bucketId,
	                    isEnabled: this.axtConfig.isEnabled,
	                    initialExpo: this.axtConfig.initialExpo,
	                    subExpo: this.axtConfig.subSequentExpo,
	                    associatedTags: this.axtConfig.associatedTags,
	                    activateWhitelist: this.axtConfig.activateWhitelist ? this.axtConfig.activateWhitelist : false,
	                    tagId: this.axtConfig.tagId ? this.axtConfig.tagId : ''
	                };
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/create_axt_unit/', requestData).then(function (response) {
	                    console.log(response);
	                    if (response.data.response_data.status) {
	                        if (_this7.selectedBucketToImportConfig) {
	                            _this7.importAxtConfig();
	                        } else {
	                            _this7.updateConfig();
	                        }
	                        _this7.notificationMsg('Success', response.data.response_data.message);
	                        _this7.getAxtConfig(_this7.bucketId);
	                    } else {
	                        _this7.notificationMsg('Error', response.data.response_data.message);
	                    }
	                }).catch(function (e) {
	                    console.log(e);
	                });
	            }
	        },
	        selectBucketModule: function selectBucketModule(index) {
	            this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
	            this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
	            if (this.selectedBucketToImportConfig !== null && this.selectedBucketToImportConfig !== undefined) {
	                this.getAxtConfig(this.selectedBucketToImportConfig);
	                this.getUnitConfigList(this.selectedBucketToImportConfig);
	                this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
	            }
	        },
	        removeSelectedModuleConfig: function removeSelectedModuleConfig() {
	            this.selectedBucketNameToImportConfig = undefined;
	            this.getAxtConfig(this.bucketId);
	            this.getUnitConfigList(this.bucketId);
	        },
	        getAdSpots: function getAdSpots(query) {
	            var _this8 = this;
	
	            if (query) {
	                var requestData = {
	                    layoutId: query
	                };
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_layout_adspots/', requestData).then(function (response) {
	                    _this8.layoutAdSpotsList = response.data.data;
	                }).catch(function (e) {
	                    _this8.errors.push(e);
	                });
	            }
	        },
	        getUnitConfigList: function getUnitConfigList(bucketId) {
	            var _this9 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_axt_config_unit_list/', {
	                bucketId: bucketId
	            }).then(function (response) {
	                console.log('testing', response);
	                _this9.axtConfigUnitList = response.data.data;
	                _this9.axtConfigUnitList.tagId = '12';
	                var i = 0,
	                    listOfArry = response.data.layoutsList,
	                    idx = listOfArry.length;
	                _this9.filterList = [];
	                for (; i < idx; i++) {
	                    _this9.filterList.push({
	                        text: listOfArry[i],
	                        value: listOfArry[i]
	                    });
	                }
	            }).catch(function (e) {
	                _this9.errors.push(e);
	            });
	        },
	        addUnitToConfigList: function addUnitToConfigList() {
	            var _this10 = this;
	
	            var valid = true,
	                requestData = {
	                bucketId: this.bucketId,
	                layout: this.setUnitConfig.layout || '',
	                adSpotId: this.setUnitConfig.layoutAdSpots || ''
	            };
	            if (!this.setUnitConfig.layout || !this.setUnitConfig.layoutAdSpots) {
	                valid = false;
	                this.notificationMsg('Warning', 'Layout and AdSpot is required!');
	            }
	
	            if (valid) {
	                this.setUnitConfig.layout = this.setUnitConfig.layoutAdSpots = undefined;
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/add_axt_unit_config_to_list/', requestData).then(function (response) {
	                    var statusMsg = response.data.status ? 'Success' : 'Error';
	                    _this10.notificationMsg(statusMsg, response.data.message);
	                    if (response.data.status) {
	                        _this10.getUnitConfigList(_this10.bucketId);
	                    }
	                }).catch(function (e) {
	                    _this10.errors.push(e);
	                });
	            }
	        },
	        handleSelectionChange: function handleSelectionChange(selectedAdSpot) {
	            this.multiSelectedUnits = selectedAdSpot;
	            this.enableConfigSetting = this.multiSelectedUnits.length > 0 ? true : false;
	            if (this.multiSelectedUnits.length == 1) {
	                this.multiSelectConfig = {
	                    isBlocked: this.multiSelectedUnits[0]['isBlocked'],
	                    isWhitelisted: this.multiSelectedUnits[0]['isWhitelisted'],
	                    initialExpo: this.multiSelectedUnits[0]['initialExpo'],
	                    subSeqExpo: this.multiSelectedUnits[0]['subSeqExpo'],
	                    ignoreActivity: this.multiSelectedUnits[0]['ignoreActivity'],
	                    tagId: this.multiSelectedUnits[0]['tagId'],
	                    tagOverride: this.multiSelectedUnits[0]['tagOverride'],
	                    multiSize: this.multiSelectedUnits[0]['multiSize']
	                };
	            } else {
	                this.multiSelectConfig = {
	                    isBlocked: false,
	                    isWhitelisted: false,
	                    initialExpo: 0,
	                    subSeqExpo: 0,
	                    ignoreActivity: false,
	                    tagId: '',
	                    tagOverride: false,
	                    multiSize: ''
	                };
	            }
	        },
	        layoutFilterHandler: function layoutFilterHandler(value, row, column) {
	            return row['layoutName'] === value;
	        },
	        deleteAdSpotFromConfig: function deleteAdSpotFromConfig() {
	            var _this11 = this;
	
	            var i = 0,
	                idx = this.multiSelectedUnits.length,
	                deleteUnits = [];
	            for (; i < idx; i++) {
	                deleteUnits.push(this.multiSelectedUnits[i].id);
	            }
	
	            if (deleteUnits.length > 0) {
	                var requestData = {
	                    bucketId: this.bucketId,
	                    selectedUnit: deleteUnits
	                };
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/delete_configured_units/', requestData).then(function (response) {
	                    var statusMsg = response.data.status ? 'Success' : 'Error';
	                    _this11.notificationMsg(statusMsg, response.data.message);
	                    if (response.data.status) {
	                        _this11.getUnitConfigList(_this11.bucketId);
	                    }
	                }).catch(function (e) {
	                    _this11.errors.push(e);
	                });
	            } else {
	                this.notificationMsg('Warning', 'Select atleast one ADSpot to delete.');
	            }
	        },
	        saveUnitConfiguration: function saveUnitConfiguration() {
	            if (this.multiSelectedUnits.length > 0) {
	                var valid = true;
	                if (!this.multiSelectConfig.isBlocked && this.multiSelectConfig.initialExpo !== undefined && this.multiSelectConfig.subSeqExpo !== undefined) {
	                    if (!this.multiSelectConfig.ignoreActivity && (this.multiSelectConfig.initialExpo < 5 || this.multiSelectConfig.subSeqExpo < 5)) {
	                        valid = false;
	                        this.notificationMsg('Warning', 'Initial and Subsequent Exposure time should be greater than or equal to 5sec.');
	                    } else if (this.multiSelectConfig.ignoreActivity && this.multiSelectConfig.initialExpo < 5) {
	                        valid = false;
	                        this.notificationMsg('Warning', 'AdFocus timer should be greater than or equal to 5sec.');
	                    }
	                }
	
	                if (valid) {
	                    var i = 0,
	                        idx = this.multiSelectedUnits.length;
	                    for (; i < idx; i++) {
	                        if (this.multiSelectConfig.isBlocked) {
	                            this.multiSelectedUnits[i]['isBlocked'] = this.multiSelectConfig.isBlocked;
	                            this.multiSelectedUnits[i]['isWhitelisted'] = false;
	                            this.multiSelectedUnits[i]['tagId'] = '';
	                            this.multiSelectedUnits[i]['tagOverride'] = false;
	                            this.multiSelectedUnits[i]['initialExpo'] = 0;
	                            this.multiSelectedUnits[i]['subSeqExpo'] = 0;
	                            this.multiSelectedUnits[i]['ignoreActivity'] = false;
	                            this.multiSelectedUnits[i]['multiSize'] = '';
	                        } else {
	                            this.multiSelectedUnits[i]['isBlocked'] = false;
	                            this.multiSelectedUnits[i]['isWhitelisted'] = this.multiSelectConfig.isWhitelisted;
	                            this.multiSelectedUnits[i]['tagId'] = this.multiSelectConfig.tagId;
	                            this.multiSelectedUnits[i]['tagOverride'] = this.multiSelectConfig.tagOverride;
	                            this.multiSelectedUnits[i]['initialExpo'] = this.multiSelectConfig.initialExpo;
	                            this.multiSelectedUnits[i]['subSeqExpo'] = this.multiSelectConfig.ignoreActivity ? 0 : this.multiSelectConfig.subSeqExpo;
	                            this.multiSelectedUnits[i]['ignoreActivity'] = this.multiSelectConfig.ignoreActivity;
	                            this.multiSelectedUnits[i]['multiSize'] = this.multiSelectConfig.multiSize;
	                        }
	                        if (i == idx - 1) {
	                            this.multiSelectConfig.isBlocked = this.multiSelectConfig.isWhitelisted = this.multiSelectConfig.ignoreActivity = false;
	                            this.multiSelectConfig.initialExpo = this.multiSelectConfig.subSeqExpo = 0;
	                            this.multiSelectConfig.tagId = '';
	                            this.multiSelectConfig.multiSize = '';
	                            this.multiSelectConfig.tagOverride = false;
	                        }
	                    }
	                }
	            } else {
	                this.notificationMsg('Warning', 'Select atleast one ADSpot to update configuration.');
	            }
	        },
	        updateConfig: function updateConfig() {
	            var _this12 = this;
	
	            var requestData = {
	                bucketId: this.bucketId,
	                configList: this.axtConfigUnitList
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/set_axt_config_unit_list/', requestData).then(function (response) {
	                console.log(response);
	                var statusMsg = response.data.status ? 'Success' : 'Error';
	                _this12.notificationMsg(statusMsg, response.data.message);
	                if (response.data.status) {
	                    _this12.getUnitConfigList(_this12.bucketId);
	                }
	            }).catch(function (e) {
	                _this12.errors.push(e);
	            });
	        },
	        importAxtConfig: function importAxtConfig() {
	            var _this13 = this;
	
	            var requestData = {
	                bucketId: this.bucketId,
	                configList: this.axtConfigUnitList
	            };
	            console.log('Imported config for AXT module');
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/import_axt_config_unit_list/', requestData).then(function (response) {
	                var statusMsg = response.data.status ? 'Success' : 'Error';
	                _this13.notificationMsg(statusMsg, response.data.message);
	                if (response.data.status) {
	                    _this13.getUnitConfigList(_this13.bucketId);
	                }
	            }).catch(function (e) {
	                _this13.errors.push(e);
	            });
	        },
	        getDimensionLable: function getDimensionLable(id) {
	            var i = 0,
	                idx = this.creativeSizeList.length,
	                selectedDimensionLable = 'No Multi Size Tag associated.';
	            if (id !== undefined) {
	                for (; i < idx; i++) {
	                    if (this.creativeSizeList[i]['id'] === id) {
	                        return this.creativeSizeList[i]['width'] + 'X' + this.creativeSizeList[i]['height'];
	                    }
	                }
	            }
	            return selectedDimensionLable;
	        },
	        addAdvertiserIdtoBlock: function addAdvertiserIdtoBlock() {
	            var _this14 = this;
	
	            if (!this.directCampConfig['advertId']) {
	                this.notificationMsg('Warning', 'Advertiser/Campaign ID is required to Block.');
	            } else {
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/set_axt_direct_campaign_block_list/', {
	                    bucketId: this.bucketId,
	                    advertiserId: this.directCampConfig['advertId'],
	                    status: true
	                }).then(function (response) {
	                    var statusMsg = response.data.status ? 'Success' : 'Error';
	                    _this14.notificationMsg(statusMsg, response.data.message);
	                    if (response.data.status) {
	                        _this14.directCampConfig['advertId'] = '';
	                        _this14.getDirectCampaignBlockList();
	                    }
	                }).catch(function (e) {
	                    console.log(e);
	                });
	            }
	        },
	        getDirectCampaignBlockList: function getDirectCampaignBlockList() {
	            var _this15 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_axt_direct_campaign_list/', {
	                bucketId: this.bucketId
	            }).then(function (response) {
	                if (response.data.status) {
	                    _this15.axtDCBlockList = response.data.data;
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        handleDCSelectionChange: function handleDCSelectionChange(selectedDCId) {
	            this.multiSelectedDCUnits = selectedDCId;
	            this.enableDCConfigSetting = this.multiSelectedDCUnits.length > 0 ? true : false;
	            if (this.multiSelectedDCUnits.length == 1) {
	                this.multiSelectDCConfig = {
	                    isBlocked: this.multiSelectedDCUnits[0]['is_blocklisted']
	                };
	            } else {
	                this.multiSelectDCConfig = {
	                    isBlocked: false
	                };
	            }
	        },
	        deleteSelectedDCId: function deleteSelectedDCId() {
	            var _this16 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/delete_direct_campaign_block_list/', {
	                listToDel: this.multiSelectedDCUnits
	            }).then(function (response) {
	                var statusMsg = response.data.status ? 'Success' : 'Error';
	                _this16.notificationMsg(statusMsg, response.data.message);
	                if (response.data.status) {
	                    _this16.getDirectCampaignBlockList();
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        saveDCConfig: function saveDCConfig() {
	            var _this17 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/update_direct_campaign_block_list/', {
	                listToUpdate: this.multiSelectedDCUnits,
	                isBlocked: this.multiSelectDCConfig.isBlocked
	            }).then(function (response) {
	                var statusMsg = response.data.status ? 'Success' : 'Error';
	                _this17.notificationMsg(statusMsg, response.data.message);
	                if (response.data.status) {
	                    _this17.getDirectCampaignBlockList();
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        }
	    }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				module: 'sticky',
				bucketId: undefined,
				stickyConfig: {
					isEnabled: false
				},
				adunits: [],
				stickyConfigsList: [],
				stickyUnitConfig: {
					editId: undefined,
					layout: undefined,
					layoutAdSpots: undefined,
					adSelectorRef: undefined,
					isTimer: undefined,
					startPoint: undefined,
					endPoint: undefined,
					timer: 0,
					moreCSS: undefined,
					top: 0
				},
				layoutsList: [],
				layoutAdSpotsList: [],
				bucketListForModuleConfig: [],
				selectedBucketToImportConfig: undefined,
				selectedBucketNameToImportConfig: undefined
			};
		},
	
		created: function created() {
			this.cloneConfig = JSON.parse((0, _stringify2.default)(this.stickyUnitConfig));
			this.bucketId = this.$route.params.bucketId;
			this.domain = this.$route.params.domId;
			this.$nextTick(function () {
				this.getListOfBucketConfig();
				this.getStickyConfig(this.bucketId);
				this.getStickyUnitConfig(this.bucketId);
			});
		},
		methods: {
			clearForm: function clearForm() {
				this.stickyUnitConfig = JSON.parse((0, _stringify2.default)(this.cloneConfig));
			},
	
			getListOfBucketConfig: function getListOfBucketConfig() {
				var _this = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_bucket_config_list/', { bucketId: this.bucketId, module: this.module }).then(function (response) {
					if (response.data.response_data.status) {
						_this.bucketListForModuleConfig = response.data.response_data.bucket_list;
					}
				}).catch(function (e) {
					console.log();
				});
			},
			notificationMsg: function notificationMsg() {
				var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
				var msg = arguments[1];
	
				this.$notify({
					title: type,
					message: msg ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			saveAndPublishAxtSticky: function saveAndPublishAxtSticky() {
				var _this2 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/create_sticky_module/', {
					bucketId: this.bucketId,
					isActive: this.stickyConfig.isEnabled
				}).then(function (response) {
					if (response.data.response_data.status) {
						_this2.notificationMsg('Success', response.data.response_data.message);
						if (_this2.selectedBucketToImportConfig) {
							_this2.importStickyConfig();
						}
						_this2.stickyConfigsList = [];
						_this2.getStickyConfig(_this2.bucketId);
						_this2.getStickyUnitConfig(_this2.bucketId);
					} else {
						_this2.notificationMsg('Warning', response.data.response_data.message);
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getStickyConfig: function getStickyConfig(bucketId) {
				var _this3 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/sticky_module/', { bucketId: bucketId }).then(function (response) {
					_this3.stickyConfig.isEnabled = response.data.response_data.isActive;
					_this3.layoutsList = response.data.response_data.data.domain_layouts;
				}).catch(function (e) {
					console.log(e);
				});
			},
			getStickyUnitConfig: function getStickyUnitConfig(bucketId) {
				var _this4 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_sticky_config_list/', { bucketId: bucketId }).then(function (response) {
					if (!response.data.status) {
						_this4.notificationMsg('Warning', response.data.message);
					}
					_this4.stickyConfigsList = response.data.data;
				}).catch(function (e) {
					console.log(e);
				});
			},
			addStickyUnitConfig: function addStickyUnitConfig() {
				var _this5 = this;
	
				if (!this.stickyUnitConfig.layout || !this.stickyUnitConfig.layoutAdSpots) {
					this.notificationMsg('Error', 'Provide value for Sticky configuration.');
				} else {
					var formData = {
						editId: this.stickyUnitConfig.editId,
						bucketId: this.bucketId,
						layout: this.stickyUnitConfig.layout,
						adReferenceId: this.stickyUnitConfig.layoutAdSpots,
						startPoint: this.stickyUnitConfig.startPoint || '',
						endPoint: this.stickyUnitConfig.endPoint || '',
						timer: this.stickyUnitConfig.timer,
						isTimer: this.stickyUnitConfig.timer ? true : false,
						moreCSS: this.stickyUnitConfig.moreCSS || '',
						top: this.stickyUnitConfig.top || 0
					};
	
					_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/add_sticky_config/', formData).then(function (response) {
						if (response.data.status) {
							_this5.stickyUnitConfig = JSON.parse((0, _stringify2.default)(_this5.cloneConfig));
							_this5.notificationMsg('Success', response.data.message);
							_this5.getStickyUnitConfig(_this5.bucketId);
						} else _this5.notificationMsg('Error', response.data.message);
					}).catch(function (e) {
						console.log(e);
					});
				}
			},
			editStickyConfig: function editStickyConfig(row) {
				var _this6 = this;
	
				this.stickyUnitConfig.editId = row.id;
				this.stickyUnitConfig.layout = row.layout_id;
				this.stickyUnitConfig.isTimer = row.timer > 0 ? true : false;
				this.stickyUnitConfig.startPoint = row.startPoint;
				this.stickyUnitConfig.endPoint = row.endPoint;
				this.stickyUnitConfig.timer = row.timer;
				this.stickyUnitConfig.moreCSS = row.more_css;
				this.stickyUnitConfig.top = row.top;
	
				this.getAdSpots(row.layout_id, function (status) {
					setTimeout(function () {
						_this6.stickyUnitConfig.layoutAdSpots = row.ref_id;
					});
				});
			},
			deleteStickyUnitConfig: function deleteStickyUnitConfig(row) {
				var _this7 = this;
	
				var i = 0,
				    idx = this.stickyConfigsList.length,
				    selectedStickyUnit = [];
	
				selectedStickyUnit.push(row.id);
				if (selectedStickyUnit.length > 0) {
					var formData = {
						'bucketId': this.bucketId,
						'selectedUnit': selectedStickyUnit
					};
					_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/delete_sticky_unit_config/', formData).then(function (response) {
						if (response.data.status) {
							_this7.getStickyUnitConfig(_this7.bucketId);
							_this7.notificationMsg('Success', response.data.message);
						} else {
							_this7.notificationMsg('Success', response.data.message);
						}
					}).catch(function (e) {
						console.log(e);
					});
				} else {
					this.notificationMsg('Warning', 'Select Sticky unit to Delete.');
				}
			},
			selectBucketModule: function selectBucketModule(index) {
				this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
				this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
				this.getStickyConfig(this.selectedBucketToImportConfig);
				this.getStickyUnitConfig(this.selectedBucketToImportConfig);
				this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
			},
			removeSelectedModuleConfig: function removeSelectedModuleConfig() {
				this.selectedBucketToImportConfig = undefined;
				this.selectedBucketNameToImportConfig = undefined;
				this.stickyConfigsList = [];
				this.stickyConfig['isEnabled'] = false;
			},
			getAdunits: function getAdunits(query) {
				var _this8 = this;
	
				if (query) {
					_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_dfp_adunits/', { bucketId: this.bucketId, query: query }).then(function (response) {
						if (response.data.response_data.status) {
							_this8.adunits = response.data.response_data.dfp_unit_list;
						}
					}).catch(function (e) {
						console.log(e);
					});
				}
			},
			getAdSpots: function getAdSpots(query, callback) {
				var _this9 = this;
	
				if (query) {
					var requestData = {
						"layoutId": query
					};
					_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_layout_adspots/', requestData).then(function (response) {
						_this9.layoutAdSpotsList = response.data.data;
						console.log(callback);
						if (callback !== undefined) {
							console.log(0);
							callback(true);
						}
					}).catch(function (e) {});
				}
			},
			importStickyConfig: function importStickyConfig() {
				var _this10 = this;
	
				console.log("Import Config from this bucket " + this.selectedBucketToImportConfig + " to this one " + this.bucketId);
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/import_sticky_config/', {
					bucketId: this.bucketId,
					importFrmBucket: this.selectedBucketToImportConfig
				}).then(function (response) {
					if (response.data.status) {
						_this10.notificationMsg('Success', response.data.message);
						_this10.selectedBucketToImportConfig = undefined;
						_this10.selectedBucketNameToImportConfig = undefined;
						_this10.getStickyUnitConfig(_this10.bucketId);
					} else {
						_this10.notificationMsg('Warning', response.data.message);
					}
				}).catch(function (e) {
					console.log(e);
				});
			}
		}
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(52);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventBus = __webpack_require__(27);
	
	var _Theme = __webpack_require__(81);
	
	var _Theme2 = _interopRequireDefault(_Theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { theme: _Theme2.default },
	    data: function data() {
	        return {
	            domainList: '',
	            domId: '',
	            name: '',
	            publishers: [],
	            isSecure: true,
	            rtcCurrency: '',
	            pubId: '',
	            domainCount: '',
	            pubUid: '',
	            currenciesOptions: [],
	            theme: {
	                font_size: '', font_family: '', font_color: '', cta_color: '', background_color: ''
	            },
	            isLoading: true,
	            addToCoreDomain: false
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        console.log("Bidder Domain ID: ", this.$route.params.domId);
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/publishers/?limit=1000'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/')]).then(_axios2.default.spread(function (response, currency) {
	            _this.publishers = response.data.results;
	            _this.currenciesOptions = currency.data;
	            if (_this.$route.query.publisher) {
	                for (var i = 0; i < _this.publishers.length; i++) {
	                    if (_this.publishers[i].id == parseInt(_this.$route.query.publisher)) {
	                        _this.pubId = parseInt(_this.$route.query.publisher);
	                    }
	                }
	            }
	            _this.isLoading = false;
	        }));
	    },
	    methods: {
	        handleDomainListChange: function handleDomainListChange(event) {
	            var value = event.target.value;
	
	            var currDomainList = value.trim("\n").split('\n');
	            this.domainList = currDomainList;
	        },
	        updateThemeObj: function updateThemeObj(e) {
	            this.theme = e;
	        },
	        setPubUid: function setPubUid() {
	            var i = 0;
	            for (; i < this.publishers.length; i++) {
	                if (this.publishers[i].id == this.pubId) {
	                    this.pubUid = this.publishers[i].uuid;
	
	                    break;
	                }
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _this2 = this;
	
	            if (this.pubId && this.domainList.length) {
	                for (var index in this.domainList) {
	                    try {
	                        Boolean(new URL(this.domainList[index]));
	                    } catch (e) {
	                        this.$notify({
	                            title: 'Error',
	                            message: 'invalid URL : ' + this.domainList[index],
	                            type: 'error'
	                        });
	                        return false;
	                    }
	                }
	
	                var publisher = this.pubId,
	                    currency = this.rtcCurrency,
	                    _theme = this.theme;
	                var font_size = _theme.font_size,
	                    font_family = _theme.font_family,
	                    font_color = _theme.font_color,
	                    cta_color = _theme.cta_color,
	                    background_color = _theme.background_color;
	
	                var response = [];
	                ["font_size", "font_family", "font_color", "cta_color", "background_color"].forEach(function (type) {
	                    if (!_theme[type]) {
	                        delete _theme[type];
	                    }
	                });
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = (0, _getIterator3.default)(this.domainList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var url = _step.value;
	
	                        var res = {
	                            url: url,
	                            publisher: publisher
	                        };
	                        if (currency) res.currency = currency;
	                        if (font_size || font_family || font_color || cta_color || background_color) res.theme = _theme;
	                        response.push(res);
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/bulk-domains/?add_to_core=' + this.addToCoreDomain), response).then(function (response) {
	                    _this2.$notify({
	                        title: 'Success',
	                        message: 'Successfully created the domains',
	                        type: 'success'
	                    });
	                    _eventBus.EventBus.$emit('update_logs', {});
	
	                    setTimeout(function () {
	                        _this2.$router.push('/admin/bidders/');
	                    }, 1000);
	                }).catch(function (error) {
	                    var tempErr = void 0;
	                    if (error.response) {
	                        var data = error.response.data;
	
	                        tempErr = data[0].hasOwnProperty('url') && data[0].url[0];
	                    }
	                    console.error(error);
	                    _this2.$notify({
	                        title: 'Warning',
	                        message: tempErr || 'Unable to create the domains',
	                        type: 'warning'
	                    });
	                });
	            } else {
	                this.$notify({
	                    title: 'Error',
	                    message: 'Domains or publisher empty',
	                    type: 'error'
	                });
	            }
	        }
	    },
	    computed: {
	        formValid: function formValid() {
	            return this.name && this.pubId;
	        }
	    }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(30);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(97);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(96);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueSwatches = __webpack_require__(82);
	
	var _vueSwatches2 = _interopRequireDefault(_vueSwatches);
	
	var _verbalExpressions = __webpack_require__(79);
	
	var _verbalExpressions2 = _interopRequireDefault(_verbalExpressions);
	
	var _AdspotDetails = __webpack_require__(254);
	
	var _AdspotDetails2 = _interopRequireDefault(_AdspotDetails);
	
	var _Theme = __webpack_require__(81);
	
	var _Theme2 = _interopRequireDefault(_Theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { theme: _Theme2.default },
	    Swatch: _vueSwatches2.default,
	    LineItemDetails: _AdspotDetails2.default,
	    data: function data() {
	        var _createLineItemForm;
	
	        return {
	            domId: [],
	            domains: [],
	            checkedAllDomains: false,
	            name: undefined,
	            publishers: [],
	            pubId: undefined,
	            domUid: undefined,
	            isLoading: true,
	            positionsRegexExpression: '',
	            positionList: [],
	            placementType: ['AMP', 'prebid'],
	            placementVertical: [],
	            domain_id: '',
	            dimensions: [],
	            countries: [],
	            browsers: [],
	            selectedBrowsers: [1, 2, 3, 4],
	            selectedCountries: [],
	            selectedTypes: [],
	            devices: [],
	            selectedDevices: [1, 2, 3, 4, 5],
	            isUniTag: false,
	            lineitemidEdit: '',
	            LineItems: [],
	            selectedDimensions: [],
	            selectedCreatives: [],
	            creativeAssociation: {
	                modify: false,
	                name: '',
	                background_color: '',
	                cta_color: '',
	                isS2S: false,
	                tagId: ''
	            },
	
	            createLineItemForm: (_createLineItemForm = {
	                active: false,
	                name: '',
	                bid_cpm_min: 0,
	                bid_cpm_max: 0,
	                budget: 0,
	                creative: [],
	                creativeIds: [],
	                tagIds: [],
	                isDoubleCreative: false,
	                vertical: '',
	                placements: [{ data: '', operator: '' }],
	                domain: '',
	                type: ''
	            }, (0, _defineProperty3.default)(_createLineItemForm, 'tagIds', []), (0, _defineProperty3.default)(_createLineItemForm, 'positions', [{ data: '', operator: '' }]), _createLineItemForm),
	            creativeList: [],
	            posOptions: [],
	            disabledSize: [],
	            dimensionTemp: [],
	            allDomains: []
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/publishers/?limit=1000'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domains/?limit=1000'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/')]).then(_axios2.default.spread(function (response, currency) {
	            _this.publishers = response.data.results;
	            if (_this.$route.query.publisher) {
	                for (var i = 0; i < _this.publishers.length; i++) {
	                    if (_this.publishers[i].id == parseInt(_this.$route.query.publisher)) {
	                        _this.pubId = parseInt(_this.$route.query.publisher);
	                    }
	                }
	            }
	            _this.isLoading = false;
	        })), this.domain_id = this.$route.params;
	        this.loadCreatives();
	        this.loadCountry();
	        this.loadDevice();
	        this.loadBrowser();
	        this.getDomain();
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/vertical-list/').then(function (vertical) {
	            _this2.placementVertical = vertical.data;
	        });
	    },
	    methods: {
	        setPubUid: function setPubUid() {
	            var _this3 = this;
	
	            this.domId = [];
	            this.domains = this.allDomains.filter(function (d) {
	                return d.publisher == _this3.pubId;
	            });
	            this.checkedAllDomains = false;
	            this.handleCheckAllDomains();
	        },
	        handleCheckAllDomains: function handleCheckAllDomains() {
	            this.checkedAllDomains = !this.checkedAllDomains;
	            if (this.checkedAllDomains) {
	                this.domId = this.domains.map(function (d) {
	                    return d.id;
	                });
	            } else {
	                this.domId = [];
	            }
	        },
	        handleChecked: function handleChecked() {
	            this.checkedAllDomains = this.domains.length === this.domId.length;
	        },
	        convertRegexToString: function convertRegexToString(expr) {
	            return expr.toString().replace('/', '').replace('/gm', '');
	        },
	        convertObjToRegex: function convertObjToRegex(type) {
	            var obj = [];
	            this.createLineItemForm[type].forEach(function (typeValue) {
	                if (typeValue.data.length && typeValue.operator.length) {
	                    obj.push(typeValue);
	                }
	            });
	            var final_regex = '';
	            var expression = '';
	            for (var i in obj) {
	                if (obj[i].operator == 'starts_with') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + obj[i]['data']);
	                }
	                if (obj[i].operator == 'ends_with') {
	                    expression = (0, _verbalExpressions2.default)().add(obj[i]['data'] + '$');
	                }
	                if (obj[i].operator == 'equals') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + obj[i]['data'] + '$');
	                }
	                if (obj[i].operator == 'contains') {
	                    expression = (0, _verbalExpressions2.default)().find(obj[i]['data']);
	                }
	                if (obj[i].operator == 'does_not_contain') {
	                    expression = (0, _verbalExpressions2.default)().add('^' + '(?' + '!.*' + obj[i]['data'] + ')' + '.*');
	                }
	                if (i == 0) {
	                    final_regex = expression;
	                } else {
	                    final_regex = final_regex.or(expression);
	                }
	            }
	            var fin = final_regex == '' ? '' : final_regex.toRegExp();
	            this[type + 'RegexExpression'] = this.convertRegexToString(fin);
	        },
	        positionFilter: function positionFilter(query) {
	            if (query !== '') {
	                this.positionsListLoading = true;
	                this.posOptions = this.positionList.filter(function (item) {
	                    return item && item.indexOf(query) > -1;
	                });
	                this.positionsListLoading = false;
	            } else {
	                this.posOptions = [];
	            }
	        },
	        getAllPositionsForDimension: function getAllPositionsForDimension(dimension) {
	            var _this4 = this;
	
	            var existingPositionEntries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            if (dimension.length === 0) return;
	            var dim = [];
	            for (var i in dimension) {
	                dim.push(this.dimensions.filter(function (k) {
	                    return k.id == dimension[i];
	                })[0]);
	            }
	            var dimensions = dim.map(function (k) {
	                return k.width + 'x' + k.height;
	            });
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('bidder/v1/domains/divids/?publisher_id=' + this.pubId + '&dimensions=' + dimensions)).then(function (pos) {
	                if (pos.hasOwnProperty('data')) {
	                    _this4.positionList = pos.data;
	                    if (existingPositionEntries.length > 0) {
	                        for (var k in existingPositionEntries) {
	                            if (_this4.positionList.map(function (x) {
	                                return x.data;
	                            }).indexOf(existingPositionEntries[k].data) == -1) {
	                                _this4.positionList.push(existingPositionEntries[k].data);
	                            }
	                        }
	                    }
	                }
	            }).catch(function (err) {
	                console.error('failed to fetch positions: ', err);
	            });
	        },
	        getDomain: function getDomain() {
	            var _this5 = this;
	
	            var api1 = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domain-list/';
	            _axios2.default.get(api1).then(function () {
	                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _this5.allDomains = response.data.data;
	
	                                case 1:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this5);
	                }));
	
	                return function (_x2) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	        },
	        loadCreatives: function loadCreatives() {
	            var _this6 = this;
	
	            var apiCreatives = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/creatives/?limit=1000';
	            _axios2.default.get(apiCreatives).then(function (creative) {
	                var _ref2;
	
	                _this6.creativeList = creative.data.results;
	                _this6.availableDimensions = [].concat((0, _toConsumableArray3.default)(new _set2.default((_ref2 = []).concat.apply(_ref2, (0, _toConsumableArray3.default)(_this6.creativeList.map(function (k) {
	                    return k.dimensions;
	                }))))));
	                _this6.loadAddimensions();
	            });
	        },
	        updateCreativeList: function updateCreativeList(liObj, event, sl) {
	            if (liObj.creative.length > 0) {
	                var toremove = liObj.creative.findIndex(function (k) {
	                    return k && k.hasOwnProperty('dimension') ? k.dimension.indexOf(event.currentValue) > -1 : false;
	                });
	                this.$delete(liObj.creative, toremove);
	                this.$delete(liObj.creativeIds, toremove);
	            }
	        },
	        getCreativeList: function getCreativeList(dimId) {
	            var crList = this.creativeList.filter(function (k) {
	                return k.dimensions.indexOf(dimId) > -1;
	            });
	            console.log('crList: ' + crList.isS2S);
	            console.log('Creative ID: ' + crList[0].id);
	            if (crList.length > 0) {
	                return crList;
	            }
	            return [];
	        },
	        addCreativeToLineItem: function addCreativeToLineItem(lineItemObj, id) {
	            var creativeObj = (0, _assign2.default)({}, this.creativeAssociation);
	            var creativeFormId = this.createLineItemForm.creativeIds;
	            var creativeBase = this.creativeList.filter(function (k) {
	                return k.id == lineItemObj.creativeIds[id];
	            })[0];
	
	            console.log('creativeBase.isS2S', creativeBase.isS2S);
	            if (creativeBase.isS2S) {
	                creativeObj.isS2S = creativeBase.isS2S;
	            }
	            if (creativeBase) {
	                creativeObj.dimension = creativeBase.dimensions;
	                this.$set(lineItemObj.creative, id, creativeObj);
	            }
	        },
	        loadDevice: function loadDevice() {
	            var _this7 = this;
	
	            var apiDevice = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/device-list/';
	            _axios2.default.get(apiDevice).then(function (response) {
	                var _devices;
	
	                _this7.devices = [];
	                (_devices = _this7.devices).push.apply(_devices, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        loadBrowser: function loadBrowser() {
	            var _this8 = this;
	
	            var apiBrowser = ("https://beta-yeti-api.automatad.com/") + 'bidder/v1/browser-list/';
	            _axios2.default.get(apiBrowser).then(function (response) {
	                var _browsers;
	
	                _this8.browsers = [];
	                (_browsers = _this8.browsers).push.apply(_browsers, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        loadCountry: function loadCountry() {
	            var _this9 = this;
	
	            var apiCountry = ("https://beta-yeti-api.automatad.com/") + 'v1/countries/';
	            _axios2.default.get(apiCountry).then(function (response) {
	                var _countries;
	
	                _this9.countries = [];
	                (_countries = _this9.countries).push.apply(_countries, (0, _toConsumableArray3.default)(response.data));
	            });
	        },
	        addNewItem: function addNewItem(index, type) {
	            var temp = this.createLineItemForm[type][index];
	            if (temp.data.length && temp.operator.length) {
	                this.createLineItemForm[type].push({ data: '', operator: '' });
	            } else {
	                this.$notify({
	                    title: 'Error',
	                    message: 'Input must have a value',
	                    type: 'error'
	                });
	            }
	        },
	        setDevicesForAMP: function setDevicesForAMP() {
	            if (this.createLineItemForm.type == 'AMP') {
	                this.selectedDevices = [1, 2];
	            } else {
	                this.selectedDevices = [1, 2, 3, 4, 5];
	            }
	        },
	        createLineItem: function createLineItem(event) {
	            var _this10 = this;
	
	            event.stopPropagation();
	            this.createLineItemForm.tagIds = this.createLineItemForm.creative.map(function (k, index) {
	                if (k.tagId.length > 0) {
	                    return {
	                        tag_id: k.tagId,
	                        creative: _this10.createLineItemForm.creativeIds[index]
	                    };
	                }
	            }).filter(function (k) {
	                return k != null;
	            });
	            if (this.createLineItemForm.type.includes('tag')) {
	                if (this.createLineItemForm.bid_cpm_min.length > 0) {
	                    this.createLineItemForm.bid_cpm_max = this.createLineItemForm.bid_cpm_min;
	                }
	                if (this.isUniTag == true) {
	                    this.createLineItemForm.type = 'unitag';
	                } else {
	                    this.createLineItemForm.type = 'tag';
	                }
	            }
	            if (this.createLineItemForm.vertical.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter line item vertical',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedDevices.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select devices',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedCountries.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select a country',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedDimensions.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select Dimensions',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedBrowsers.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select browsers',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.selectedTypes.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please Select type',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.creativeIds.length != this.selectedDimensions.length) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Make sure all selected dimensions have creatives associated',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.name.length == 0) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter line item name',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.createLineItemForm.isDoubleCreative == true && this.selectedDimensions.length > 1) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Only one dimension can be selected when double creative is enabled',
	                    type: 'error'
	                });
	                return;
	            }
	            this.convertObjToRegex('positions');
	            this.convertObjToRegex('placements');
	            var LineitemObject = {
	                name: this.createLineItemForm.name,
	                active: this.createLineItemForm.active,
	                country: this.selectedCountries,
	                device: this.selectedDevices,
	                type: this.selectedTypes,
	                bid_cpm_min: this.createLineItemForm.bid_cpm_min,
	                bid_cpm_max: this.createLineItemForm.bid_cpm_max,
	                budget: this.createLineItemForm.budget,
	                browsers: this.selectedBrowsers,
	                tag_ids: this.createLineItemForm.tagIds,
	                dimensions: this.selectedDimensions,
	                creative: this.createLineItemForm.creativeIds,
	                vertical: this.createLineItemForm.vertical,
	
	                placement_text: (0, _typeof3.default)(this.createLineItemForm.placements) == 'object' ? [this.placementsRegexExpression] : [this.createLineItemForm.placements],
	                positions: (0, _typeof3.default)(this.createLineItemForm.positions) == 'object' ? this.positionsRegexExpression : this.createLineItemForm.positions
	            };
	            if (LineitemObject.placement_text[0] == '') {
	                LineitemObject.placement_text = [];
	            }
	            if (LineitemObject.type == 'unitag') {
	                delete LineitemObject.placement_text;
	            }
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/lineitems/bulk_create/', { domain_list: this.domId, data: LineitemObject }).then(function (response) {
	                _this10.$notify({
	                    title: 'Request Sent',
	                    message: 'Please check notifications after some time.',
	                    type: 'warning'
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	        },
	        loadAddimensions: function loadAddimensions() {
	            var _this11 = this;
	
	            this.dimensionsAsPerIsDoubleCreative = [];
	            var apidimension = ("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/';
	            var dim = ['300x250', '320x50', '728x90', '970x90', '250x250', '300x50', '320x100', '336x280', '320x480', '970x250', '300x600', '320x250'];
	            _axios2.default.get(apidimension).then(function (response) {
	                var dimensions = response.data;
	                _this11.dimensions = dimensions.filter(function (m) {
	                    return _this11.availableDimensions.indexOf(m.id) > -1;
	                });
	                _this11.dimensionTemp = dimensions.filter(function (m) {
	                    return _this11.availableDimensions.indexOf(m.id) > -1;
	                });
	                for (var i = 0; i < _this11.dimensions.length; i++) {
	                    if (_this11.dimensions[i].width == 300 && _this11.dimensions[i].height == 600 || _this11.dimensions[i].width == 970 && _this11.dimensions[i].height == 250 || _this11.dimensions[i].width == 336 && _this11.dimensions[i].height == 280 || _this11.dimensions[i].width == 300 && _this11.dimensions[i].height == 250) {
	                        _this11.dimensionsAsPerIsDoubleCreative.push(_this11.dimensions[i]);
	                    }
	                }
	            });
	        }
	    }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventBus = __webpack_require__(27);
	
	var _Theme = __webpack_require__(81);
	
	var _Theme2 = _interopRequireDefault(_Theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { theme: _Theme2.default },
	    data: function data() {
	        return {
	            bing_web: 0,
	            bing_mobile: 100,
	            web_traffic: 100,
	            mobile_traffic: 0,
	            domId: undefined,
	            name: undefined,
	            publishers: [],
	            isSecure: true,
	            rtcCurrency: undefined,
	            pubId: undefined,
	            pubUid: undefined,
	            currenciesOptions: [],
	            theme: {},
	            isLoading: true,
	            addToCoreDomain: false,
	            KeywordOptions: [{
	                value: null,
	                label: 'None'
	            }, {
	                value: 'replace_l2',
	                label: 'Replace (Dominant L2)'
	            }, {
	                value: 'augment_similarity',
	                label: 'Augment (Similarity)'
	            }, {
	                value: 'augment_l2',
	                label: 'Augment (Dominant L2)'
	            }],
	            kwConfigVal: null
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        console.log("Bidder Domain ID: ", this.$route.params.domId);
	        this.domId = this.$route.params.domId;
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/publishers/?limit=1000'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/')]).then(_axios2.default.spread(function (response, currency) {
	            _this.publishers = response.data.results;
	            _this.currenciesOptions = currency.data;
	            if (_this.$route.query.publisher) {
	                for (var i = 0; i < _this.publishers.length; i++) {
	                    if (_this.publishers[i].id == parseInt(_this.$route.query.publisher)) {
	                        _this.pubId = parseInt(_this.$route.query.publisher);
	                    }
	                }
	            }
	            if (_this.domId) {
	                _this.initializeDomain();
	            }
	            _this.isLoading = false;
	        }));
	    },
	    methods: {
	        initializeDomain: function initializeDomain() {
	            var _this2 = this;
	
	            if (this.domId) {
	                _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domains/' + this.domId + "/").then(function (response) {
	                    var domData = response.data;
	                    _this2.pubId = domData.publisher;
	                    _this2.name = domData.url;
	                    _this2.web_traffic = domData.web_rc_switch && 100 - Number(domData.web_rc_switch) * 100;
	                    _this2.mobile_traffic = domData.mobile_rc_switch && Number(domData.mobile_rc_switch) * 100;
	                    _this2.kwConfigVal = domData.kw_enhancement;
	
	                    if (domData.currency) {
	                        _this2.rtcCurrency = _this2.currenciesOptions.filter(function (k) {
	                            return k.code == domData.currency.code;
	                        })[0].id;
	                    }
	                    var theme = domData.theme ? domData.theme : _this2.theme;
	                    _this2.theme = theme;
	                }).catch(function (error) {
	                    console.log('error', error);
	                });
	            }
	        },
	        updateThemeObj: function updateThemeObj(e) {
	            console.log(e);
	            this.theme = e;
	        },
	        setPubUid: function setPubUid() {
	            var i = 0;
	            for (; i < this.publishers.length; i++) {
	                if (this.publishers[i].id == this.pubId) {
	                    this.pubUid = this.publishers[i].uuid;
	
	                    break;
	                }
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _domainObj,
	                _this3 = this;
	
	            var domainObj = (_domainObj = {
	                url: this.name,
	                publisher: this.pubId,
	                currency: this.rtcCurrency,
	                theme: this.theme,
	                web_rc_switch: this.web_traffic == 100 ? 0 : parseFloat(100 - this.web_traffic) / 100.0,
	                mobile_rc_switch: this.mobile_traffic == 0 ? 0 : parseFloat(this.mobile_traffic) / 100.0
	            }, (0, _defineProperty3.default)(_domainObj, 'theme', this.theme), (0, _defineProperty3.default)(_domainObj, 'kw_enhancement', this.kwConfigVal), _domainObj);
	            if (this.domId) {
	                _axios2.default.put(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domains/' + this.domId + '/', domainObj).then(function (response) {
	                    _this3.$notify({
	                        title: 'Success',
	                        message: 'Successfully updated domain',
	                        type: 'success'
	                    });
	                    _eventBus.EventBus.$emit('update_logs', {});
	
	                    setTimeout(function () {
	                        _this3.$router.push('/admin/bidders/');
	                    }, 1000);
	                }).catch(function (error) {
	                    var errorMessage = error.response.data;
	
	                    var err = null;
	                    if (errorMessage.hasOwnProperty('url')) err = errorMessage.url;
	                    _this3.$notify({
	                        title: 'Warning',
	                        message: err && err[0] || 'Something went wrong',
	                        type: 'warning'
	                    });
	                });
	            } else {
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'bidder/v1/domains/' + ('?add_to_core=' + this.addToCoreDomain), domainObj).then(function (response) {
	                    _this3.$notify({
	                        title: 'Success',
	                        message: 'Successfully created a new domain',
	                        type: 'success'
	                    });
	                    _eventBus.EventBus.$emit('update_logs', {});
	
	                    setTimeout(function () {
	                        _this3.$router.push('/admin/bidders/');
	                    }, 1000);
	                }).catch(function (error) {
	                    var tempErr = void 0;
	                    if (error.response) {
	                        var data = error.response.data;
	
	                        tempErr = data.hasOwnProperty('url') && data.url;
	                    }
	                    _this3.$notify({
	                        title: 'Error',
	                        message: tempErr || 'Unable to create the domains',
	                        type: 'error'
	                    });
	                    console.error(error);
	                });
	            }
	        },
	        handleWebGoogle: function handleWebGoogle() {
	            this.bing_web = 100 - this.web_traffic;
	        },
	        handleWebBing: function handleWebBing() {
	            this.web_traffic = 100 - this.bing_web;
	        },
	        handleMobileGoogle: function handleMobileGoogle() {
	            this.bing_mobile = 100 - this.mobile_traffic;
	        },
	        handleMobileBing: function handleMobileBing() {
	            this.mobile_traffic = 100 - this.bing_mobile;
	        }
	    },
	    computed: {
	        formValid: function formValid() {
	            return this.name && this.pubId;
	        }
	    }
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        name: ""
	      },
	      message: "",
	      countryOptions: [],
	      currenciesOptions: [],
	      isactivateaccount: false
	    };
	  },
	
	  created: function created() {
	    console.log(this.$route.params);
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      console.log("calling create func");
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "bidder/v1/publishers/", {
	        name: this.credentials.name
	      }).then(function (response) {
	        _this.isactivateaccount = true;
	        _this.$notify({
	          title: "Success",
	          message: "Successfully created a new bidder publisher",
	          type: "success"
	        });
	
	        setTimeout(function () {
	          _this.$router.push("/admin/bidders/create-domain");
	        }, 1000);
	      }).catch(function (error) {
	        _this.$notify({
	          title: "Warning",
	          message: "Unable to create a new publisher",
	          type: "warning"
	        });
	      });
	    }
	  },
	  computed: {
	    formValid: function formValid() {
	      return this.credentials.name;
	    }
	  }
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueSwatches = __webpack_require__(82);
	
	var _vueSwatches2 = _interopRequireDefault(_vueSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['themeData'],
	  components: {
	    'Swatch': _vueSwatches2.default
	  },
	  watch: {
	    themeData: function themeData() {
	      this.themeObj = (0, _assign2.default)({}, this.themeData);
	    }
	  },
	  data: function data() {
	    return {
	      fontFamily: '',
	      fontSize: '',
	      allFontSizes: [],
	      googleFontList: [],
	      themeObj: { font_size: '', font_color: '', font_family: '', background_color: '', cta_color: '' }
	    };
	  },
	
	  created: function created() {
	    this.createFontSizeList();
	    this.getGoogleFonts();
	    if (this.themeData) {
	      this.themeObj = (0, _assign2.default)({}, this.themeData);
	    }
	  },
	  methods: {
	    createFontSizeList: function createFontSizeList() {
	      for (var i = 8; i < 31; i++) {
	        this.allFontSizes.push(i + 'px');
	      }
	    },
	    getGoogleFonts: function getGoogleFonts() {
	      var ref = this;
	      var KEY = 'AIzaSyAOK2XUXTAr139VoPxHZ2jscS9-HlwdiME';
	      (0, _axios2.default)({
	        url: 'https://www.googleapis.com/webfonts/v1/webfonts?key=' + KEY,
	        method: 'GET'
	      }).then(function (res) {
	        for (var i in res.data.items) {
	          ref.googleFontList.push({
	            text: res.data.items[i].family,
	            label: res.data.items[i].family,
	            id: res.data.items[i].family
	          });
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlankPage'
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      is_duplicate: false,
	      dfp_parent_ad_unit_path: null,
	      dfp_parent_ad_unit_id: 0,
	      hbId: null,
	      frmData: '',
	      domainMcmEnabled: false,
	      filteredAccountList: [],
	      domainNetworkDelegation: '',
	      domainChildNetwork: null,
	      mcm_enabled: false,
	      account_type: null,
	      child_dfp_network: null,
	      currenciesOptions: [],
	      activeNames: ['1'],
	      dimensions: [],
	      pubUuid: this.$route.params.uuid,
	      domId: this.$route.params.domId,
	      isPubUnit: false,
	      current_dfp_network: null,
	      pubUid: undefined,
	      domain_details: undefined,
	      mcmAccountType: [],
	      childDfpAccounts: [],
	      hb_tag: {
	        name: '',
	        post_fix: '',
	        enabled: true,
	        dimensions: undefined,
	        currencyId: '',
	        device_type: 'web',
	        domain_id: this.$route.params.domId,
	        floor: 0.0,
	        pub_dfp_unit_path: '',
	        pub_dfp_unit_id: '',
	        is_amp: this.is_amp,
	        is_amp_sticky: false,
	        network_override: ''
	      },
	      options: [{
	        value: 'instream',
	        label: 'instream'
	      }, {
	        value: 'outstream',
	        label: 'outstream'
	      }],
	      value: '',
	      player_dimension: '',
	      vpdimension: [{
	        value: '320 x 460',
	        label: '320 x 460'
	      }, {
	        value: '860 x 420',
	        label: '860 x 420'
	      }]
	    };
	  },
	
	  props: {
	    is_amp: Boolean
	  },
	  created: function created() {
	    var self = this;
	    this.pubUid = this.$route.params.uuid;
	    this.hbId = this.$route.query.hb_id;
	    _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publishers/' + this.pubUid + '/domains/' + this.domId + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/mcm-account-list/')]).then(_axios2.default.spread(function (dimensions, domain, currencies, childAccounts, mcm_type) {
	      console.log(dimensions.data);
	      self.dimensions = dimensions.data;
	      self.domain_details = (0, _assign2.default)({}, domain.data);
	      self.domainNetworkDelegation = domain.data.mcm ? domain.data.mcm.account_type : self.domainNetworkDelegation;
	      self.domainMcmEnabled = domain.data.mcm_enable;
	      self.domainChildNetwork = domain.data.child_dfp_network ? domain.data.child_dfp_network.child_network_code : self.domainChildNetwork;
	      self.currenciesOptions = currencies.data;
	      self.mcmAccountType = mcm_type.data;
	      self.childDfpAccounts = childAccounts.data;
	      currencies.data.map(function (k) {
	        if (k.code == 'USD') {
	          return self.hb_tag.currencyId = k.id;
	        }
	      });
	
	      self.hb_tag.network_override = !self.isPubUnit && self.domain_details.mcm_enable == true ? self.domain_details.mcm.account_type == 'MANAGE_ACCOUNT' ? self.domain_details.child_dfp_network.child_network_code : self.domain_details.dfp_network.network_code : self.domain_details.dfp_network.network_code;
	
	      self.dfp_parent_ad_unit_id = self.account_type == null ? self.is_amp ? self.domain_details.amp_parent_ad_unit_id : self.domain_details.parent_ad_unit_id : self.dfp_parent_ad_unit_id;
	
	      self.dfp_parent_ad_unit_path = self.account_type == null ? self.is_amp ? self.domain_details.amp_parent_ad_unit_code : self.domain_details.parent_ad_unit_code : self.dfp_parent_ad_unit_path;
	
	      self.current_dfp_network = self.domain_details.dfp_network.network_code;
	      if (!self.hbId) {
	        self.setMcmInit(self.domain_details);
	      }
	    })).catch(function (error) {
	      return console.log(error);
	    });
	
	    if (this.hbId) {
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/' + (this.is_amp ? 'amp_hb_tags' : 'hb_tags') + '/' + this.domId + '/').then(function (data) {
	        self.is_duplicate = true;
	        self.frmData = data.data.response_data.hb_tags;
	        self.curUnit = self.frmData.filter(function (t) {
	          if (t.id == self.hbId) return t;
	        })[0];
	        console.log(self.curUnit);
	        self.dfp_parent_ad_unit_id = self.domainMcmEnabled == false ? self.curUnit.dfp_parent_ad_unit_id : self.dfp_parent_ad_unit_id;
	        self.hb_tag.currencyId = self.curUnit.hasOwnProperty("amp_currency_id") && self.curUnit.amp_currency_id != '' ? self.curUnit.amp_currency_id : '';
	        console.log(self.hb_tag.currencyId);
	        self.hb_tag.is_amp_sticky = self.curUnit.is_amp_sticky;
	        if (self.hb_tag.currencyId == '') {
	          currencies.data.map(function (k) {
	            if (k.code == 'USD') {
	              return self.hb_tag.currencyId = k.id;
	            }
	          });
	        }
	        self.isPubUnit = self.curUnit.publisher_dfp_unit;
	        if (!self.isPubUnit) {
	          setTimeout(function (e) {
	            self.setMcmInit(self.domain_details);
	          }, 500);
	        }
	        self.hb_tag.floor = self.curUnit.floor;
	        self.hb_tag.post_fix = self.curUnit.post_fix == 'null' ? '' : self.curUnit.post_fix;
	        self.hb_tag.pub_dfp_unit_path = self.curUnit.dfp_ad_unit_code;
	        self.hb_tag.pub_dfp_unit_id = self.curUnit.dfp_ad_unit_id;
	        self.hb_tag.dimensions = self.curUnit.dimensions.map(function (i) {
	          return i.id;
	        });
	        setTimeout(function (e) {
	          self.hb_tag.network_override = self.curUnit.network_override ? self.curUnit.network_override : self.curUnit.current_dfp_network;
	
	          self.account_type = self.curUnit.mcm_account_switch && self.domainMcmEnabled == true && !self.isPubUnit ? self.curUnit.mcm_account_switch : self.account_type;
	
	          self.mcm_enabled = self.account_type != null && self.domainMcmEnabled == true && !self.isPubUnit ? true : false;
	
	          self.child_dfp_network = self.curUnit.child_network_override && self.domainMcmEnabled == true && !self.isPubUnit ? self.curUnit.child_network_override : self.child_dfp_network;
	
	          self.filteredAccountList = self.childDfpAccounts.filter(function (k) {
	            return k.delegation_type == self.account_type;
	          });
	
	          self.current_dfp_network = self.curUnit.current_dfp_network ? self.curUnit.current_dfp_network : self.current_dfp_network;
	
	          self.dfp_parent_ad_unit_id = self.curUnit.dfp_parent_ad_unit_id ? self.curUnit.dfp_parent_ad_unit_id : self.dfp_parent_ad_unit_id;
	
	          self.dfp_parent_ad_unit_path = self.curUnit.dfp_parent_ad_unit_path ? self.curUnit.dfp_parent_ad_unit_path : self.dfp_parent_ad_unit_path;
	        }, 200);
	      }).catch(function (e) {
	        console.log('hb err', e);
	      });
	    }
	  },
	  methods: {
	    setMcmInit: function setMcmInit(domain) {
	      var self = this;
	
	      if (self.is_duplicate) {
	        self.dfp_parent_ad_unit_id = self.curUnit.dfp_parent_ad_unit_id ? self.curUnit.dfp_parent_ad_unit_id : self.dfp_parent_ad_unit_id;
	
	        self.dfp_parent_ad_unit_path = self.curUnit.dfp_parent_ad_unit_path ? self.curUnit.dfp_parent_ad_unit_path : self.dfp_parent_ad_unit_path;
	
	        self.account_type = self.curUnit.mcm_account_switch && self.domainMcmEnabled == true && !self.isPubUnit ? self.curUnit.mcm_account_switch : self.account_type;
	        self.mcm_enabled = self.account_type != null && self.domainMcmEnabled == true && !self.isPubUnit ? true : false;
	
	        self.child_dfp_network = self.curUnit.child_network_override && self.domainMcmEnabled == true && !self.isPubUnit ? self.curUnit.child_network_override : self.child_dfp_network;
	      } else {
	        self.mcm_enabled = domain.mcm_enable;
	        if (self.mcm_enabled) {
	          self.child_dfp_network = domain.child_dfp_network.child_network_code;
	          self.account_type = domain.mcm.account_type;
	          self.dfp_parent_ad_unit_path = self.is_amp ? domain.amp_parent_ad_unit_code : domain.parent_ad_unit_code;
	          self.dfp_parent_ad_unit_id = self.is_amp ? domain.amp_parent_ad_unit_id : domain.parent_ad_unit_id;
	          self.filteredAccountList = self.childDfpAccounts.filter(function (k) {
	            return k.delegation_type == self.account_type;
	          });
	        }
	      }
	    },
	    filterNetworkList: function filterNetworkList() {
	      var selectedAccount = this.account_type;
	      this.filteredAccountList = this.childDfpAccounts.filter(function (k) {
	        return k.delegation_type == selectedAccount;
	      });
	      this.child_dfp_network = null;
	    },
	    resetMCM: function resetMCM() {
	      this.account_type = null;
	      this.child_dfp_network = null;
	    },
	    handleChange: function handleChange(val) {
	      console.log(val);
	    },
	    getDimension: function getDimension(ids) {
	      console.log(ids);
	      console.log(this.dimensions);
	      if (ids) {
	        if (ids.length > 1) {
	          return 'MULTISIZE';
	        } else {
	          for (var i = 0; i < this.dimensions.length; i++) {
	            if (this.dimensions[i].id == ids[0]) {
	              return this.dimensions[i].width + 'x' + this.dimensions[i].height;
	            }
	          }
	        }
	      }
	    },
	    createTag: function createTag() {
	      var _this = this;
	
	      if (this.account_type == "MANAGE_ACCOUNT" && this.dfp_parent_ad_unit_id == 0) {
	        this.$notify({
	          title: 'Error',
	          message: "please add dfp parent ad unit id",
	          type: 'Error'
	        });
	        return;
	      }
	      console.log('createTag calleddd');
	      console.log(this.hb_tag);
	      console.log("network_override", this.hb_tag);
	      console.log("domain_details", this.domain_details.dfp_network);
	      var request_object = {
	        enabled: this.hb_tag.enabled,
	        dimensions: this.hb_tag.dimensions,
	        domain_id: this.hb_tag.domain_id,
	        floor: this.hb_tag.floor,
	        pub_dfp_unit_path: this.hb_tag.pub_dfp_unit_path,
	        pub_dfp_unit_id: this.hb_tag.pub_dfp_unit_id,
	        isPubUnit: this.isPubUnit,
	        is_amp: this.is_amp,
	        is_amp_sticky: this.hb_tag.is_amp_sticky,
	        amp_currency: this.hb_tag.currencyId,
	        network_code: this.domainMcmEnabled ? this.hb_tag.network_override : this.hb_tag.network_override != this.domain_details.dfp_network.network_code ? this.hb_tag.network_override : null,
	        current_dfp_network: this.current_dfp_network,
	        dfp_parent_ad_unit_id: this.dfp_parent_ad_unit_id
	      };
	      console.log(request_object);
	      if (!this.isPubUnit) {
	        request_object.name = 'ATD_' + this.getDimension(this.hb_tag.dimensions) + '_' + this.hb_tag.post_fix;
	        request_object.post_fix = this.hb_tag.post_fix;
	
	        request_object.mcm_account_switch = this.account_type;
	        request_object.child_network_override = this.child_dfp_network;
	        request_object.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
	        request_object.dfp_parent_ad_unit_id = this.dfp_parent_ad_unit_id;
	      } else {
	        request_object.dfp_parent_ad_unit_path = 'null';
	        request_object.name = this.hb_tag.pub_dfp_unit_path;
	        request_object.post_fix = 'null';
	        request_object.mcm_account_switch = this.account_type;
	        request_object.child_network_override = this.child_dfp_network;
	        request_object.dfp_parent_ad_unit_id = 0;
	      }
	
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/create_hb_tag/', request_object).then(function (response) {
	        if (response.data.status == 'success') {
	          _this.$notify({
	            title: 'Success',
	            message: response.data.message,
	            type: 'success'
	          });
	          setTimeout(function () {
	            if (_this.is_amp) _this.$router.push('/admin/publisher/' + _this.pubUuid + '/domain/' + _this.domId + '/hb-tags-amp/?tag_id=' + response.data.tag_id);else _this.$router.push('/admin/publisher/' + _this.pubUuid + '/domain/' + _this.domId + '/hb-tags/?tag_id=' + response.data.tag_id);
	          }, 500);
	        } else if (response.data.status == 'error') {
	          _this.$notify({
	            title: 'Error !!',
	            message: response.data.message,
	            type: 'error'
	          });
	          _this.activeNames = '';
	        }
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    },
	    getDfpAdUnitPathDisplay: function getDfpAdUnitPathDisplay(hb_tag) {
	      console.log(hb_tag);
	      console.log(this.domain_details);
	      console.log(this.hb_tag.network_override);
	
	      var path = '';
	      if (this.domain_details) {
	        var network_code = '';
	        if (this.account_type) {
	          if (this.account_type == 'MANAGE_INVENTORY') {
	            network_code = this.current_dfp_network + ',' + this.child_dfp_network;
	          } else {
	            network_code = this.child_dfp_network;
	          }
	        } else if (this.hb_tag.network_override && (this.hb_tag.network_override != this.domain_details.dfp_network.network_code || this.isPubUnit)) {
	          network_code = this.hb_tag.network_override;
	        } else {
	          if (this.current_dfp_network) {
	            network_code = this.current_dfp_network;
	          } else {
	            if (this.domain_details.mcm_enable) {
	              if (this.domain_details.mcm.account_type == 'MANAGE_INVENTORY') {
	                network_code = this.domain_details.dfp_network.network_code + ',' + this.domain_details.child_dfp_network.child_network_code;
	              } else {
	                network_code = this.domain_details.child_dfp_network.child_network_code;
	              }
	            } else {
	              network_code = this.domain_details.dfp_network.network_code;
	            }
	          }
	        }
	
	        var dfp_parent_code = this.domain_details.parent_ad_unit_code;
	
	        if (this.isPubUnit) {
	          dfp_parent_code = hb_tag.pub_dfp_unit_path;
	        } else {
	          if (this.account_type && this.dfp_parent_ad_unit_id != 0) {
	            dfp_parent_code = this.dfp_parent_ad_unit_path;
	          } else {
	            if (this.is_amp) {
	              dfp_parent_code = this.domain_details.amp_parent_ad_unit_code;
	            } else {
	              dfp_parent_code = this.domain_details.parent_ad_unit_code;
	            }
	          }
	        }
	
	        path = network_code + '/' + dfp_parent_code;
	        if (!this.isPubUnit) path += '/ATD_' + (this.getDimension(hb_tag.dimensions) ? this.getDimension(hb_tag.dimensions) : ' ') + '_' + hb_tag.post_fix;
	      }
	      return path;
	    },
	    getDfpAdUnitPathAmp: function getDfpAdUnitPathAmp(hb_tag) {
	      console.log(hb_tag);
	      console.log(this.domain_details);
	      console.log(";;", this.hb_tag.network_override);
	
	      var path = '';
	      if (this.domain_details) {
	        var network_code = this.domain_details.dfp_network.network_code;
	        if (this.account_type) {
	          if (this.account_type == 'MANAGE_INVENTORY') {
	
	            network_code = this.current_dfp_network + ',' + this.child_dfp_network;
	          } else {
	            network_code = this.child_dfp_network;
	          }
	        } else if (this.hb_tag.network_override && this.hb_tag.network_override != this.current_dfp_network) {
	          network_code = this.hb_tag.network_override;
	        } else {
	          if (this.current_dfp_network) {
	            network_code = this.current_dfp_network;
	          } else {
	            if (this.domain_details.dfp_network.mcm_enable) {
	              if (this.domain_details.dfp_network.mcm.account_type == 'MANAGE_INVENTORY') {
	                network_code = this.domain_details.dfp_network.network_code + ',' + this.domain_details.dfp_network.child_dfp_network.child_network_code;
	              } else {
	                network_code = this.domain_details.dfp_network.child_dfp_network.child_network_code;
	              }
	            } else {
	              network_code = network_code;
	            }
	          }
	        }
	
	        var dfp_parent_code = hb_tag.pub_dfp_unit_path;
	
	        if (this.isPubUnit) {
	          dfp_parent_code = hb_tag.pub_dfp_unit_path;
	        } else {
	          if (this.account_type && this.dfp_parent_ad_unit_id != 0) {
	            dfp_parent_code = this.dfp_parent_ad_unit_path;
	          } else {
	            dfp_parent_code = this.domain_details.amp_parent_ad_unit_code;
	          }
	        }
	
	        path = network_code + '/' + dfp_parent_code;
	        if (!this.isPubUnit) path += '/ATD_' + (this.getDimension(hb_tag.dimensions) ? this.getDimension(hb_tag.dimensions) : ' ') + '_' + hb_tag.post_fix;
	      }
	      return path;
	    },
	    resetNetworkCode: function resetNetworkCode(event) {
	      event.preventDefault();
	      console.log(event);
	      this.hb_tag.network_override = this.domain_details.mcm_enable == true ? this.domain_details.mcm.account_type == 'MANAGE_ACCOUNT' ? this.domain_details.child_dfp_network.child_network_code : this.domain_details.dfp_network.network_code : this.domain_details.dfp_network.network_code;
	      this.account_type = null;
	      this.child_dfp_network = null;
	    },
	    pubUnitToggle: function pubUnitToggle(val) {
	      console.log('pppp', val);
	      if (!val) {
	        this.hb_tag.network_override = '';
	        this.setMcmInit(this.domain_details);
	      } else {
	        this.mcm_enabled = false;
	        this.resetMCM();
	      }
	    }
	  },
	  computed: {
	    isComplete: function isComplete() {
	      console.log(!this.isPubUnit && this.hb_tag.post_fix && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && this.hb_tag.floor);
	
	      if (!this.isPubUnit) return this.hb_tag.post_fix && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && String(this.hb_tag.floor);else if (this.mcm_enabled) return this.dfp_parent_ad_unit_path != '' && this.dfp_parent_ad_unit_path != null && this.dfp_parent_ad_unit_id != 0 && this.account_type != null && this.child_dfp_network != null && this.hb_tag.pub_dfp_unit_path && this.hb_tag.pub_dfp_unit_id && String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && this.hb_tag.network_override;else return this.hb_tag.pub_dfp_unit_path && this.hb_tag.pub_dfp_unit_id && String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && this.hb_tag.network_override;
	    }
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				networks: [],
				loading: true
			};
		},
	
		created: function created() {
			var _this = this;
	
			_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/dfp_accounts/')]).then(_axios2.default.spread(function (response) {
				console.log(response.data);
				for (var i = 0; i < response.data.length; i++) {
					console.log(response.data[i].networks);
					_this.networks = _this.networks.concat(response.data[i].networks);
				}
				console.log(_this.networks);
				_this.loading = false;
	
				window.setTimeout(function () {
					_letterAvatar2.default.transform();
				});
			}));
		},
		methods: {
			syncAdUnits: function syncAdUnits(a, b) {
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/dfp_ad_units_sync/' + a + '/network_id/' + b + '/', {}).then(function (response) {
					console.log(response);
				}).catch(function (error) {});
			},
			refreshNetworkList: function refreshNetworkList(ntwrk_code) {
				var _this2 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-sync/', {
					"network_code": ntwrk_code
				}).then(function (response) {
					console.log(response);
					_this2.$notify({
						title: 'Success',
						message: 'The networks will be updated in some time',
						type: 'success'
					});
					setTimeout(function () {
						window.location.reload();
					}, 5000);
				}).catch(function (error) {});
			},
			getNetworks: function getNetworks() {
				var _this3 = this;
	
				console.log('Upate all networks');
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/dfp-sync/', {}).then(function (response) {
					console.log(response);
					_this3.$notify({
						title: 'Success',
						message: 'The networks will be updated in some time',
						type: 'success'
					});
					setTimeout(function () {
						window.location.reload();
					}, 5000);
				}).catch(function (error) {
					console.error(error);
					_this3.$notify({
						title: 'Error',
						message: 'Problem accessing DFP',
						type: 'error'
					});
				});
			}
		}
	};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            name: undefined,
	            publishers: [],
	            isSecure: true,
	            pubDFP: false,
	            domId: undefined,
	            domUuId: undefined,
	            networkName: undefined,
	            hbSetupInitiated: false,
	            hbAdvCreated: false,
	            creatingAdvertiser: false,
	            bidders: [],
	            current_active_bidders: [],
	            current_started_bidders: [],
	            dfp: {
	                id: undefined,
	
	                number_of_creatives: 12,
	                prebid_currency: '',
	                prebid_bucket_range_min: 0.01,
	                prebid_bucket_range_max: 20.00,
	                granularity: 0.01,
	                order_name_prefix: 'ATD ',
	                biddersList: []
	            },
	            message: '',
	            countryId: '',
	            currencyId: '',
	            countryOptions: [],
	            currenciesOptions: [],
	            loading: true
	        };
	    },
	    created: function created() {
	        this.initialize();
	    },
	    methods: {
	        initialize: function initialize() {
	            var self = this;
	            console.log(this.$route.params.dfpId);
	            this.dfp.id = this.$route.params.dfpId;
	            _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/hb-config/dfp/' + this.dfp.id), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/bidders/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/network-name/' + this.dfp.id + '/')]).then(_axios2.default.spread(function (domains, currencies, hbConfigs, bidders, networkdetail) {
	                console.log(networkdetail);
	                var dfp_currencies = [];
	                self.domains = domains.data;
	                self.currenciesOptions = currencies.data;
	                self.populateDfpData(hbConfigs.data);
	                self.bidders = bidders.data;
	                self.networkName = networkdetail.data['0'].display_name;
	                self.hbSetupInitiated = networkdetail.data['0'].hb_setup_initiated;
	                self.hbAdvCreated = networkdetail.data['0'].advertiser_id != "0" && networkdetail.data['0'].dfp_hb_placement_id != "0";
	
	                dfp_currencies.push(networkdetail.data['0'].currency_code);
	                var seconday_currencies = networkdetail.data['0'].secondary_currency_codes.replace('[', '').replace(']', '').replaceAll("'", '').split(', ');
	                dfp_currencies = dfp_currencies.concat(seconday_currencies);
	
	                self.currenciesOptions = self.currenciesOptions.filter(function (currenciesOption) {
	                    return dfp_currencies.includes(currenciesOption.code);
	                });
	
	                console.log(self.currenciesOptions);
	                self.loading = false;
	            })).catch(function (error) {
	                return console.log(error);
	            });
	        },
	        biddersListChange: function biddersListChange() {
	            console.log(this.dfp.biddersList);
	        },
	        setDomUid: function setDomUid() {
	            var i = 0;
	            console.log(this.domUuId);
	            for (; i < this.domains.length; i++) {
	                if (this.domains[i].id == this.domId) {
	                    this.domUuId = this.domains[i].uuid;
	                    break;
	                }
	            }console.log(this.domUuId);
	        },
	        onSubmit: function onSubmit() {
	            var _this = this;
	
	            var request_data = {
	                "hb_config": {
	                    "number_of_creatives": this.dfp.number_of_creatives,
	                    "prebid_currency": this.dfp.prebid_currency,
	                    "order_name_prefix": this.dfp.order_name_prefix,
	                    "prebid_bucket_range_min": this.dfp.prebid_bucket_range_min,
	                    "prebid_bucket_range_max": this.dfp.prebid_bucket_range_max,
	                    "granularity": this.dfp.granularity,
	                    "dfp_network": this.$route.params.dfpId
	                },
	                "bidder": (0, _stringify2.default)(this.dfp.biddersList)
	            };
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/hb-config/', request_data).then(function (response) {
	                _this.$notify({
	                    title: 'Success',
	                    message: 'Successfully updated the dfp settings',
	                    type: 'success'
	                });
	
	                setTimeout(function () {
	                    _this.$router.push('/admin/dfp-settings/');
	                }, 1000);
	            }).catch(function (error) {
	                _this.$notify({
	                    title: 'Warning',
	                    message: 'Unable to update the dfp settings',
	                    type: 'warning'
	                });
	            });
	        },
	        submit: function submit() {
	            console.log('Submitting DFP setup details');
	            console.log(this.dfp);
	        },
	        initiateSetup: function initiateSetup(bidder) {
	            var _this2 = this;
	
	            console.log(bidder);
	            var request_data = {
	                is_amp: false
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + ('v1/hb-dfp-add-bidder-setup/' + this.dfp.id + '/bidder/' + bidder.id), request_data).then(function (response) {
	                _this2.$notify({
	                    title: 'Success',
	                    message: 'Setup initialized for bidder - ' + bidder.code,
	                    type: 'success'
	                });
	
	                _this2.current_started_bidders.push(bidder.id);
	            }).catch(function (error) {
	                _this2.$notify({
	                    title: 'Warning',
	                    message: 'Server Issue',
	                    type: 'warning'
	                });
	            });
	        },
	        populateDfpData: function populateDfpData(dfpData) {
	            console.log(dfpData);
	
	            for (var i = 0; i < dfpData.length; i++) {
	                this.dfp.biddersList.push(dfpData[i].bidder.id);
	                if (dfpData[i].complete) this.current_active_bidders.push(dfpData[i].bidder.id);else if (dfpData[i].started) this.current_started_bidders.push(dfpData[i].bidder.id);
	            }
	            if (dfpData[0]) {
	                this.dfp.number_of_creatives = dfpData[0].hb_config.number_of_creatives;
	                this.dfp.prebid_currency = dfpData[0].hb_config.prebid_currency;
	                this.dfp.order_name_prefix = dfpData[0].hb_config.order_name_prefix;
	                this.dfp.prebid_bucket_range_min = dfpData[0].hb_config.prebid_bucket_range_min;
	                this.dfp.prebid_bucket_range_max = dfpData[0].hb_config.prebid_bucket_range_max;
	                this.dfp.granularity = dfpData[0].hb_config.granularity;
	
	                console.log(this.dfp);
	                console.log(this.dfp.biddersList);
	            }
	        },
	        createAdvAndPlacement: function createAdvAndPlacement() {
	            var _this3 = this;
	
	            console.log('createAdvAndPlacement');
	            this.creatingAdvertiser = true;
	            console.log(this.dfp.prebid_currency);
	            var request_data = {
	                is_amp: false
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + ('v1/hb-dfp-adv-placement-setup/' + this.dfp.id), request_data).then(function (response) {
	                console.log(response);
	                _this3.$notify({
	                    title: 'Success',
	                    message: 'Advertiser and placement will be created',
	                    type: 'success'
	                });
	                setTimeout(function () {
	                    window.location.reload();
	                }, 5000);
	            });
	        },
	        currencyChanged: function currencyChanged() {},
	        retryLicas: function retryLicas(bidder) {
	            if (!this.hbAdvCreated || !(this.current_active_bidders.indexOf(bidder.id) > -1 || this.current_started_bidders.indexOf(bidder.id) > -1)) {
	                this.$notify({
	                    title: 'warning',
	                    message: 'The advertiser needs to be created or line items for the bidder needs to be created first',
	                    type: 'warning'
	                });
	                return;
	            }
	            var request_data = {
	                is_amp: false
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + ('v1/hb-retry-failed-licas/' + this.dfp.id + '/bidder/' + bidder.id), request_data).then(function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    computed: {
	        isComplete: function isComplete() {
	            return this.dfp.prebid_currency;
	        }
	    }
	};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            isCheckedBidders: [],
	            domainMcmEnabled: false,
	            selectedChildDfpNetworkCode: "",
	            selectedNetworkCode: "",
	            searchNetworkOverride: "",
	            searchString: "",
	            total_pages: 1,
	            currentPage: 1,
	            offset: 5000,
	            bucketId: undefined,
	            hbBidderPartnerList: [],
	            allBidders: [],
	            checkedBidders: [],
	            issearch: false,
	            loading: true,
	            domain_details: undefined,
	            pubUid: ""
	        };
	    },
	
	    created: function created() {
	        this.getDomainDetails();
	
	        this.initialize(this.currentPage);
	    },
	    watch: {
	        $route: function $route(to, from) {
	            console.warn("route changed from " + from + " to " + to);
	            this.allBidders = [];
	            this.hbBidderPartnerList = [];
	            this.checkedBidders = [];
	            this.loading = true;
	            this.initialize(this.currentPage);
	        }
	    },
	    methods: {
	        clearSearch: function clearSearch() {
	            this.searchString = "";
	            this.selectedChildDfpNetworkCode = "";
	            this.selectedNetworkCode = "";
	            this.searchNetworkOverride = false;
	            this.initialize(1);
	        },
	        filterHBunitBidder: function filterHBunitBidder() {
	            this.currentPage = 1;
	            this.issearch = true;
	            this.initialize(1);
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            console.log("val", val);
	            this.initialize(this.currentPage);
	        },
	        getDomainDetails: function getDomainDetails() {
	            var _this = this;
	
	            this.pubUid = this.$route.params.uuid;
	            _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + ("v1/publishers/" + this.pubUid + "/domains/" + this.$route.params.domId + "/"))]).then(_axios2.default.spread(function (domain) {
	                _this.domain_details = domain.data;
	                if (_this.domain_details != undefined) {
	                    _this.domainMcmEnabled = _this.domain_details.mcm_enable;
	                }
	            })).catch(function (e) {
	                console.log(e);
	            });
	        },
	        initialize: function initialize(pageNum) {
	            var _this2 = this;
	
	            this.pubUid = this.$route.params.uuid;
	            if (this.searchString.length != 0) {
	                this.issearch = true;
	            }
	            this.loading = true;
	            if (pageNum == undefined) {
	                pageNum = 1;
	            }
	            this.bucketId = this.$route.params.bucketId;
	
	            var searchapi = ("https://beta-yeti-api.automatad.com/") + ("v1/search-hb-ad-units-in-bucket/domain/" + this.$route.params.domId + "/bucket/" + this.bucketId + "/?page=" + this.currentPage + "&offset=" + this.offset + "&query=" + this.searchString + "&dfp_network_code=" + this.selectedNetworkCode + "&child_dfp_network_code=" + this.selectedChildDfpNetworkCode + "&network_override=" + this.searchNetworkOverride);
	            _axios2.default.all([_axios2.default.post(this.issearch ? searchapi : ("https://beta-yeti-api.automatad.com/") + ("v1/get_bucket_hb_units/?page=" + this.currentPage + "&offset=" + this.offset), { bucketId: this.bucketId }), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + "v1/get-bidders-under-domain/" + this.$route.params.domId)]).then(_axios2.default.spread(function (hbUnits, bidders) {
	                _this2.issearch = false;
	                console.log("hb", hbUnits.data.total);
	                _this2.total_pages = hbUnits.data.total;
	                _this2.hbBidderPartnerList = hbUnits.data.data;
	
	                console.log(bidders);
	                _this2.allBidders = bidders.data;
	                _this2.allBidders.forEach(function (bidder) {
	                    bidder["all"] = _this2.checkIfAll(bidder.id);
	                    bidder["indeterminate"] = _this2.checkIfIndeterminate(bidder.id);
	                });
	                console.log(_this2.allBidders);
	                _this2.$forceUpdate();
	                _this2.loading = false;
	            })).catch(function (e) {
	                console.log(e);
	            });
	        },
	
	        updatedAllBidder: function updatedAllBidder() {
	            var vm = this;
	            this.allBidders.forEach(function (i) {
	                vm.selectAll(i, true);
	            });
	        },
	        updatedHBBidder: function updatedHBBidder() {
	            var _this3 = this;
	
	            console.log("this.domid", this.domId, "buktid", this.bucketId);
	            var apiIscheck = ("https://beta-yeti-api.automatad.com/") + ("v1/update-bucket-for-all-bidders/domain/" + this.$route.params.domId + "/bucket/" + this.bucketId + "/");
	
	
	            var reqobject = { selectBidder: this.checkedBidders };
	
	            console.log("hbBidderPartnerList", this.hbBidderPartnerList);
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + "v1/update_bucket_hb_units/", {
	                bucketId: this.bucketId,
	                hbBidderUpdate: this.hbBidderPartnerList
	            }).then(function (response) {
	                console.log(response.data);
	
	                if (response.data.status) {
	                    console.log(response.data.message);
	                }
	                _this3.$notify({
	                    title: "Success",
	                    message: "Successfully updated the tags",
	                    type: "success"
	                });
	                _axios2.default.post(apiIscheck, reqobject).then(function (res) {
	                    console.log("res", res);
	                });
	            }).catch(function (e) {
	                _this3.errors.push(e);
	                _this3.$notify({
	                    title: "Warning",
	                    message: "Something went wrong",
	                    type: "warning"
	                });
	            });
	        },
	        checkIfAll: function checkIfAll(bidderId) {
	            var flag = true;
	            this.hbBidderPartnerList.forEach(function (hbAdUnit) {
	                hbAdUnit.bidders.forEach(function (bidder) {
	                    if (bidder.bidder.id == bidderId) {
	                        if (!bidder.isChecked) {
	                            flag = false;
	                            return flag;
	                        }
	                    }
	                });
	            });
	            return flag;
	        },
	        checkIfIndeterminate: function checkIfIndeterminate(bidderId) {
	            var flag = false,
	                arr = [];
	
	            this.hbBidderPartnerList.forEach(function (hbAdUnit) {
	                hbAdUnit.bidders.forEach(function (bidder) {
	                    if (bidder.bidder.id == bidderId) arr.push(bidder.isChecked);
	                });
	            });
	            if (arr.length > 0) {
	                var a = arr.reduce(function (acc, cur) {
	                    if (acc != cur) {
	                        flag = true;
	                    } else {
	                        return cur;
	                    }
	                });
	            }
	
	            return flag;
	        },
	        selectAll: function selectAll(selectedBidder) {
	            var _selectAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            this.loading = true;
	
	            var sbidder = this.allBidders.filter(function (bidder) {
	                return bidder.id == selectedBidder.id;
	            })[0];
	            if (_selectAll == true) {
	                sbidder.all = true;
	            } else {
	                sbidder.all = !sbidder.all;
	            }
	            this.hbBidderPartnerList.forEach(function (hbBidderPartner) {
	                hbBidderPartner.bidders.forEach(function (bidder) {
	                    if (bidder.bidder.id == selectedBidder.id) bidder.isChecked = sbidder.all;
	                });
	            });
	            var bidderChecks = this.checkedBidders.filter(function (k) {
	                return k.bidderId == selectedBidder.id;
	            });
	            if (bidderChecks.length > 0) {
	                var bidderIdx = this.checkedBidders.map(function (k) {
	                    return k.bidderId;
	                }).indexOf(selectedBidder.id);
	                this.checkedBidders.splice(bidderIdx, 1);
	            }
	            this.checkedBidders.push({
	                bidderId: selectedBidder.id,
	                checkOrUncheck: selectedBidder.all == false ? "uncheck" : "check"
	            });
	            this.loading = false;
	        },
	        selectAll2: function selectAll2() {
	            this.hbBidderPartnerList.forEach(function (hbBidderPartner) {
	                hbBidderPartner.bidders.forEach(function (bidder) {
	                    bidder.isChecked = true;
	                });
	            });
	        },
	        modified: function modified(val) {
	            var _this4 = this;
	
	            this.allBidders.forEach(function (bidder) {
	                bidder["all"] = _this4.checkIfAll(bidder.id);
	                bidder["indeterminate"] = _this4.checkIfIndeterminate(bidder.id);
	                _this4.$forceUpdate();
	            });
	        }
	    }
	};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				dialogVisible: false,
				message: 'Input HB tag params dimension wise!',
				domId: undefined,
				dimensions: [],
				allBidders: [],
				activeNames: undefined,
				dimensionWiseParams: undefined,
				bidderParamsForm: {},
				loading: true,
				hb_tags: [],
				hb_tag_ids: [],
				pubUid: undefined,
				domain_details: undefined,
				updatingDimen: undefined
			};
		},
	
		created: function created() {
			this.initialize();
		},
		methods: {
			initialize: function initialize() {
				var _this = this;
	
				this.domId = this.$route.params.domId;
				this.pubUid = this.$route.params.uuid;
				_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-bidders-under-domain/' + this.domId), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/hb_tags_dimensions/' + this.domId + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/hb_tags/' + this.domId + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publishers/' + this.pubUid + '/domains/' + this.domId + '/'))]).then(_axios2.default.spread(function (dimensions, bidders, params, hb_tags, domain) {
					console.log(dimensions);
					console.log(bidders);
					console.log(params);
					_this.dimensionWiseParams = params['data']['response_data']['hb_params'];
					_this.dimensions = dimensions.data;
					_this.allBidders = bidders.data;
					_this.hb_tags = hb_tags.data.response_data.hb_tags;
	
	
					_this.domain_details = domain.data;
	
					_this.dimensionWiseParams.forEach(function (dimen) {
						console.log(dimen.id);
						_this.bidderParamsForm[dimen.id] = {};
						for (var bidder in dimen.params) {
							_this.bidderParamsForm[dimen.id][bidder] = dimen.params[bidder];
						}
					});
					_this.loading = false;
				}));
			},
			getDimensionInStr: function getDimensionInStr(id) {
				var dimension = this.dimensions.filter(function (dimen) {
					return dimen['id'] == id;
				})[0];
				return dimension.width + 'X' + dimension.height;
			},
			getBidderFields: function getBidderFields(bidder_id) {
				for (var i = 0; i < this.allBidders.length; i++) {
					if (this.allBidders[i].id == bidder_id) {
						return JSON.parse(this.allBidders[i].param);
					}
				}
			},
			getEnabledBidders: function getEnabledBidders(dimension_id) {
				var bidders = [];
				for (var bidder in this.bidderParamsForm[dimension_id]) {
					if (this.bidderParamsForm[dimension_id][bidder]['enabled']) {
						bidders.push(bidder);
					}
				}
				return bidders;
			},
			handleClose: function handleClose() {},
			closeDialog: function closeDialog() {
				this.dialogVisible = false;
				this.updatingDimen = undefined;
			},
			checkedHbtag: function checkedHbtag(val) {
				console.log(val);
				this.$forceUpdate();
			},
			CheckChanged: function CheckChanged(dimension_id) {
				if (!this.hb_tag_ids.includes(dimension_id)) this.hb_tag_ids.push(dimension_id);else {
					var index = this.hb_tag_ids.indexOf(dimension_id);
					this.hb_tag_ids.splice(index, 1);
				}
			},
			Check: function Check(dimension_id) {
				return this.hb_tag_ids.includes(dimension_id);
			},
			updateHbTagDiag: function updateHbTagDiag(dimension) {
				console.log('updateHbTagDiag');
	
				this.dialogVisible = true;
				this.updatingDimen = dimension;
				this.deselectAll();
			},
			selectAll: function selectAll() {
				var _this2 = this;
	
				this.hb_tags.forEach(function (hb_tag) {
					var dim_found = hb_tag.dimensions.find(function (dimension) {
						return dimension.id == _this2.updatingDimen.id;
					});
					if (dim_found) hb_tag.checked = true;
				});
				this.$forceUpdate();
			},
			deselectAll: function deselectAll() {
				this.hb_tags.forEach(function (hb_tag) {
					hb_tag.checked = false;
				});
				this.$forceUpdate();
			},
			filterHbtag: function filterHbtag(tag) {
				var _this3 = this;
	
				if (this.updatingDimen) {
					var res = tag.dimensions.filter(function (dimension) {
						return _this3.updatingDimen.id == dimension.id;
					});
					if (res.length > 0) return true;else return false;
				}
			},
			updateHbTag: function updateHbTag(dimension) {
				var _this4 = this;
	
				this.hb_tag_ids = this.hb_tags.filter(function (hb_tag) {
					return hb_tag.checked;
				});
				this.hb_tag_ids = this.hb_tag_ids.map(function (hb_tag) {
					return hb_tag.id;
				});
	
				console.log(this.hb_tag_ids);
	
				console.log(this.bidderParamsForm[dimension.id]);
				var tempParams = JSON.parse((0, _stringify2.default)(this.bidderParamsForm[dimension.id]));
	
				for (var bidders in tempParams) {
					console.log(bidders);
					for (var params in tempParams[bidders]) {
						if (tempParams[bidders][params].toString().trim() == '') delete tempParams[bidders][params];
					}
				}
				console.log(tempParams);
	
				var requestObject = {
					'bidders': (0, _stringify2.default)(tempParams),
					'dimensionId': dimension.id,
					'hb_tag_ids': this.hb_tag_ids
				};
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/update_hb_tag_dimension_wise/' + this.domId + '/', requestObject).then(function (response) {
					console.log(response);
					if (response.data.status == 'success') {
						_this4.$notify({
							title: 'Success',
							message: 'Successfully updated the tag!!',
							type: 'success'
						});
						_this4.recentlyClosed = response.data.dimensionId;
						_this4.activeNames = '';
						_this4.dialogVisible = false;
					} else if (response.data.status == 'error') {
						_this4.$notify({
							title: 'Error',
							message: response.data.reason,
							type: 'error'
						});
						_this4.recentlyClosed = response.data.dimensionId;
						_this4.activeNames = '';
					}
				}).catch(function (error) {
					console.log('Error:', error);
				});
			}
		}
	};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(35);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            searchString: '',
	            currentPage: 1,
	            total_pages: 1,
	            offset: 20,
	            domId: undefined,
	            param_sets: [],
	            param_set_bidders: [],
	            dimensions: [],
	            bidders: [],
	            allBidders: [],
	            ampBidders: [],
	            cloneParamSet: {
	                alias: '',
	                is_amp: false
	            },
	            cloningSet: undefined,
	            isSearch: false,
	            recentlyClosed: '',
	            activeNames: undefined,
	            showAliasNameDialog: false,
	            showCreateParamSetDialog: false,
	            loading: true,
	            newParamSet: {
	                alias: '',
	                is_amp: false,
	                dimension: undefined
	            }
	
	        };
	    },
	
	
	    props: {
	        is_amp: Boolean
	    },
	
	    watch: {
	        '$route': function $route(to, from) {
	            console.warn('route changed from ' + from + ' to ' + to);
	            this.initialize(this.currentPage);
	        }
	    },
	
	    created: function created() {
	        this.initialize();
	    },
	    directives: {
	        trim: {
	            inserted: function inserted(el) {},
	            bind: function bind(el, binding, vnode) {
	                var handler = function handler(e) {
	                    var old = e.target.value;
	                    e.target.value = e.target.value.trim();
	                    if (old != e.target.value) vnode.elm.dispatchEvent(new CustomEvent('input'));
	                };
	                el.addEventListener('input', handler);
	            }
	        }
	    },
	    methods: {
	        clearSearch: function clearSearch() {
	            this.searchString = '';
	            this.initialize(1);
	        },
	        filterHbparamset: function filterHbparamset() {
	            this.isSearch = true;
	            this.currentPage = 1;
	
	            this.initialize(this.currentPage);
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            console.log('val', val);
	            console.log('this.search', this.searchString);
	
	            this.currentPage = val;
	
	            this.initialize(val);
	        },
	        initialize: function initialize(pageNum) {
	            var _this = this;
	
	            if (this.searchString.length != 0) {
	                this.isSearch = true;
	                console.log('this.search in abc', this.isSearch, this.searchString.length);
	            }
	
	            this.loading = true;
	            console.log('pagenum', pageNum);
	            if (pageNum == undefined) {
	                pageNum = 1;
	            }
	            this.domId = this.$route.params.domId;
	
	            var viewApi = ("https://beta-yeti-api.automatad.com/") + ('v1/hb-tag-param-set/' + this.domId + '/?page=' + this.currentPage + '&&offset=' + this.offset);
	            var searchapi = ("https://beta-yeti-api.automatad.com/") + ('v1/search-hb-tag-param-sets/domain/' + this.domId + '/?page=' + this.currentPage + '&&offset=' + this.offset + '&&query=' + this.searchString);
	            _axios2.default.all([_axios2.default.get(this.isSearch ? searchapi : viewApi), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/hb-tag-param-set-bidders/' + this.domId + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-bidders-under-domain/' + this.domId), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/bidders/')]).then(_axios2.default.spread(function (param_sets, dimensions, param_set_bidders, bidders, allBidders) {
	                _this.isSearch = false;
	                _this.total_pages = param_sets.data.total;
	                console.log(allBidders);
	                _this.allBidders = allBidders.data;
	                _this.ampBidders = _this.allBidders.filter(function (bidder) {
	                    return bidder.amp_enabled;
	                });
	                console.log(_this.ampBidders);
	                console.log('@@#param_sets', param_sets.data.total);
	                _this.dimensions = dimensions.data;
	                _this.bidders = bidders.data;
	                _this.enabled_bidder_ids = _this.bidders.map(function (bidder) {
	                    return bidder.id;
	                });
	                _this.param_set_bidders = param_set_bidders.data;
	                _this.initializeParamSets(param_sets.data);
	
	                _this.loading = false;
	            }));
	        },
	        initializeParamSets: function initializeParamSets(param_sets) {
	            var _this2 = this;
	
	            console.log('in param set', param_sets);
	            var param_sets_clone = param_sets.data.map(function (param_set) {
	                var data = _this2.getParams(param_set);
	                param_set['params'] = data;
	                return param_set;
	            });
	            this.param_sets = param_sets_clone;
	        },
	        getDimensionInStr: function getDimensionInStr(id) {
	            var dimension = this.dimensions.filter(function (dimen) {
	                return dimen['id'] == id;
	            })[0];
	            return dimension.width + 'X' + dimension.height;
	        },
	        handleChange: function handleChange(val) {
	            this.recentlyClosed = this.prevActiveNames;
	            this.prevActiveNames = this.activeNames;
	            if (val != '') this.recentlyClosed = '';
	        },
	        cloneDialog: function cloneDialog(paramSet) {
	            this.showAliasNameDialog = true;
	            this.cloneParamSet.alias = paramSet.alias + ' - cloned';
	            this.cloningSet = paramSet;
	            this.cloneParamSet.is_amp = paramSet.is_amp;
	        },
	        getBiddersEnabled: function getBiddersEnabled(is_amp) {
	            if (is_amp) {
	                return this.allBidders.filter(function (bidder) {
	                    return bidder.amp_enabled;
	                });
	            } else {
	                var bidders = this.bidders.filter(function (bidder) {
	                    return bidder;
	                });
	                return bidders;
	            }
	        },
	        cloneParamSetSubmit: function cloneParamSetSubmit() {
	            var _this3 = this;
	
	            var paramSet = this.cloningSet,
	                bidders = [];
	            var idx = this.param_sets.findIndex(function (set) {
	                return paramSet.id == set.id;
	            });
	
	            var newParams = JSON.parse((0, _stringify2.default)(paramSet.params));
	
	            var enabledBidders = this.getBiddersEnabled(this.cloneParamSet.is_amp);
	            var enabledBiddersCodes = enabledBidders.map(function (enabledBidder) {
	                return enabledBidder.code;
	            });
	            enabledBiddersCodes.forEach(function (code) {
	                if (!newParams[code]) {
	                    newParams[code] = {
	                        bidder_params: {},
	                        enabled: false,
	                        ownership: true
	                    };
	                }
	            });
	
	            var _loop = function _loop(key) {
	                if (!enabledBiddersCodes.includes(key)) {
	                    delete newParams[key];
	                    return 'continue';
	                }
	                if (_this3.cloneParamSet.is_amp) {
	                    bidders = _this3.ampBidders;
	                } else {
	                    bidders = _this3.bidders;
	                }
	                var bidderObj = bidders.filter(function (bidder) {
	                    return bidder.code == key;
	                })[0];
	                var fields = _this3.getBidderFields(bidderObj, _this3.cloneParamSet.is_amp);
	                fields.forEach(function (field) {
	                    if (field.type == 'text') {
	                        newParams[key]['bidder_params'][field.label] = String(newParams[key]['bidder_params'][field.label]);
	                    } else if (field.type == 'number') {
	                        newParams[key]['bidder_params'][field.label] = parseInt(newParams[key]['bidder_params'][field.label]);
	                    } else if (field.type == 'float') {
	                        newParams[key]['bidder_params'][field.label] = parseFloat(newParams[key]['bidder_params'][field.label]);
	                    }
	                });
	            };
	
	            for (var key in newParams) {
	                var _ret = _loop(key);
	
	                if (_ret === 'continue') continue;
	            }
	
	            this.param_sets.splice(idx + 1, 0, {
	                alias: this.cloneParamSet.alias,
	                dimension: JSON.parse((0, _stringify2.default)(paramSet.dimension)),
	                domain: JSON.parse((0, _stringify2.default)(paramSet.domain)),
	                id: undefined,
	                params: newParams,
	                is_amp: this.cloneParamSet.is_amp
	            });
	            this.cloneParamSet = {
	                alias: '',
	                is_amp: false
	            };
	            this.cloningSet = undefined;
	            this.handleClose();
	        },
	        createParamSet: function createParamSet() {
	            var _this4 = this;
	
	            var requestObject = {
	                alias: this.newParamSet.alias,
	                dimension: this.newParamSet.dimension,
	                domain: this.domId,
	                is_amp: this.newParamSet.is_amp
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/hb-tag-param-set/' + this.domId + '/', requestObject).then(function (response) {
	                console.log(response);
	                var param_set = response.data;
	
	                var data = _this4.getParams(param_set);
	                param_set['params'] = data;
	
	                _this4.param_sets.push(response.data);
	
	                _this4.$notify({
	                    title: 'Success',
	                    message: 'Successfully applied!!',
	                    type: 'success'
	                });
	
	                _this4.recentlyClosed = _this4.activeNames;
	                _this4.activeNames = '';
	                _this4.newParamSet = {
	                    alias: '',
	                    is_amp: false,
	                    dimension: undefined
	                };
	                _this4.handleClose();
	            }).catch(function (error) {
	                console.log('Error:', error);
	                _this4.handleClose();
	            });
	        },
	        handleClose: function handleClose() {
	            this.showAliasNameDialog = false;
	            this.showCreateParamSetDialog = false;
	        },
	        getParams: function getParams(param_set) {
	            var _this5 = this;
	
	            var params = this.param_set_bidders.filter(function (set) {
	                return set.hb_tag_param_set.id == param_set.id;
	            });
	            var final = params.reduce(function (accumulator, current) {
	                current.bidder_params = JSON.parse(current.bidder_params);
	
	
	                if (!accumulator.find(function (p) {
	                    return p.bidder.id === current.bidder.id && p.hb_tag_param_set.id === current.hb_tag_param_set.id;
	                }) && (_this5.enabled_bidder_ids.includes(current.bidder.id) || param_set.is_amp)) {
	                    accumulator.push(current);
	                }
	                return accumulator;
	            }, []);
	
	            var res = {},
	                bidders = [];
	            if (param_set.is_amp) {
	                bidders = this.ampBidders;
	            } else {
	                bidders = this.bidders;
	            }
	            bidders.forEach(function (bidder) {
	
	                res[bidder.code] = {
	                    bidder_params: {},
	                    enabled: false,
	                    ownership: true
	                };
	                var defaults = _this5.getDefaults(bidder.id, param_set);
	                res[bidder.code]['bidder_params'] = JSON.parse(defaults);
	            });
	
	            final.forEach(function (fi) {
	                if (!res[fi.bidder.code]) return;
	                if ((0, _keys2.default)(fi.bidder_params).length === 0 && fi.bidder_params.constructor === Object) {
	                    var defaults = _this5.getDefaults(fi.bidder.id, param_set);
	                    res[fi.bidder.code]['bidder_params'] = JSON.parse(defaults);
	                } else {
	                    res[fi.bidder.code]['bidder_params'] = fi.bidder_params;
	                }
	
	                res[fi.bidder.code]['enabled'] = fi.enabled;
	                res[fi.bidder.code]['ownership'] = fi.ownership;
	            });
	
	            return res;
	        },
	        getDefaults: function getDefaults(bidderId, param_set) {
	            var dimension = undefined;
	            if (param_set) dimension = param_set.dimension.width + 'X' + param_set.dimension.height;
	            var bidder = this.bidders.find(function (bidder) {
	                return bidderId == bidder.id;
	            });
	            if (!bidder) return '{}';
	            var params = JSON.parse(bidder.param),
	                res = {};
	            params.forEach(function (param) {
	                if (param.hasOwnProperty('default')) res[param['name']] = param['default'];
	                if (dimension) {
	                    console.log(dimension);
	                    if (bidder.code == 'pulsepoint' && param['name'] == 'cf') res[param['name']] = dimension;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '300X250') res[param['name']] = 67786;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '728X90') res[param['name']] = 92351;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '160X600') res[param['name']] = 92352;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '300X600') res[param['name']] = 92353;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '320X50') res[param['name']] = 92354;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '970X90') res[param['name']] = 92355;
	                    if (bidder.code == 'smartadserver' && param['name'] == 'formatId' && dimension == '970X250') res[param['name']] = 92356;
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '300X250') res[param['name']] = '69d53a8997ba2aade0afae3c0e13b7e2';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '728X90') res[param['name']] = 'd1628350e52378b475ee425f09726e03';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '160X600') res[param['name']] = '501328d77374a58a6432d41c8ab7fb1c';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '300X600') res[param['name']] = '733f2188df1a63c95e9959044c63cf87';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '320X50') res[param['name']] = '7fcf92fd933e8cdf2db910dee96e7890';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '970X90') res[param['name']] = '794587a396288579e9ecf21e1ef94bff';
	                    if (bidder.code == 'adyoulike' && param['name'] == 'placement' && dimension == '970X250') res[param['name']] = 'fa2370e9c8f44911be90b58852e3effc';
	                }
	            });
	            return (0, _stringify2.default)(res);
	        },
	        getBidderFields: function getBidderFields(bidder, is_amp) {
	            if (is_amp) {
	                return JSON.parse(bidder.amp_param);
	            } else {
	                return JSON.parse(bidder.param);
	            }
	        },
	        applyTagParamSetBidder: function applyTagParamSetBidder(param_set) {
	            var _this6 = this;
	
	            console.log(param_set);
	            var requestObject = {
	                param_set: (0, _stringify2.default)(param_set)
	            };
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/hb-tag-param-set-bidders/' + this.domId + '/', requestObject).then(function (response) {
	                console.log(response);
	                param_set.id = response.data.param_set_id;
	
	                _this6.$notify({
	                    title: 'Success',
	                    message: 'Successfully applied!!',
	                    type: 'success'
	                });
	
	                _this6.recentlyClosed = _this6.activeNames;
	                _this6.activeNames = '';
	            }).catch(function (error) {
	                console.log('Error:', error);
	            });
	        },
	        checkMod: function checkMod(param) {
	            param.enabled = !param.enabled;
	        },
	        getEnabledBidders: function getEnabledBidders(params) {
	            var enabled_bidders = [];
	            for (var bidder in params) {
	                if (params[bidder]['enabled']) enabled_bidders.push(bidder);
	            }
	            return enabled_bidders;
	        }
	    },
	    computed: {
	        createParamSetButtonValid: function createParamSetButtonValid() {
	            return this.newParamSet.alias.length > 0 && this.newParamSet.dimension;
	        }
	    }
	};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            currentPage: 1,
	            offset: 10,
	            total_pages: 0,
	            dfp_parent_ad_unit_path: null,
	            bulkmigrateEnabled: false,
	            dfp_parent_ad_unit_id: 0,
	            searchNetworkOverride: false,
	            checkedHbTags: [],
	            filteredAccountList: [],
	            account_type: null,
	            mcm_enabled: false,
	            child_dfp_network: null,
	            mcmAccountType: [],
	            childDfpAccounts: [],
	            domainMcmEnabled: false,
	            selectedChildDfpNetworkCode: '',
	            selectedNetworkCode: '',
	            selectedDimensions: [],
	            allDimensionsSearch: [],
	            issearch: false,
	            searchString: '',
	            pubUid: undefined,
	            activeNames: undefined,
	            activeNames2: undefined,
	            recentlyClosed: '',
	            domId: undefined,
	            domain_details: undefined,
	            hb_tags: [],
	            all_amp_hb_tags: [],
	            dimensions: [],
	            bidders: [],
	            name: '',
	            bidderParamsForm: {
	                formData: {}
	            },
	            bidderParamsForm2: {},
	            loading: true,
	            dimArr: [],
	            bidderCopyParamsData: {},
	            pubInsdialogVisible: false,
	            param_sets: [],
	            pubInstructions: 'Document header\n\n<!DOCTYPE HTML>\n<html amp>\n<head>\n<meta charset="utf-8">\n<title>Widgets Magazine</title>\n<link rel="canonical" href="$REGULAR_HTML_URL" />\n<meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1">\n<style amp-boilerplate>body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}</style><noscript><style amp-boilerplate>body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style></noscript>\n<script async src="https://cdn.ampproject.org/v0.js"></script>\n<script async custom-element="amp-ad" src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"></script>\n<script async custom-element="amp-sticky-ad" src="https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js"></script>\n<script async custom-element="amp-iframe" src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"></script>\n<script async custom-element="amp-fx-flying-carpet" src="https://cdn.ampproject.org/v0/amp-fx-flying-carpet-0.1.js"></script>\n</head>\n\n\nOn every page, the above ad tags are added, we need to include the following tag inside the body tag:\n <amp-iframe layout="fixed-height" width="auto" title="User Sync" height="1" sandbox="allow-scripts allow-same-origin" frameborder="0" src="https://b2cdn.automatad.com/geo/amp_user_sync/load-cookies.html">\n  <amp-img layout="fill" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" placeholder width="1" height="1"></amp-img>\n </amp-iframe>'
	        };
	    },
	
	    props: {
	        is_amp: Boolean
	    },
	    watch: {
	        $route: function $route(to, from) {
	            console.warn('route changed from ' + from + ' to ' + to);
	            this.initialize(this.currentPage);
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        if (this.$route.query.page && !isNaN(parseInt(this.$route.query.page))) this.currentPage = parseInt(this.$route.query.page);
	        console.log(this.currentPage);
	        this.initialize(this.currentPage);
	        this.getSizeForSearchDropdown();
	
	        _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/mcm-account-list/').then(function (res) {
	            _this.mcmAccountType = res.data;
	        });
	        _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-list/').then(function (res) {
	            _this.childDfpAccounts = res.data;
	        });
	    },
	    methods: {
	        handleCheckedHbTagsChange: function handleCheckedHbTagsChange() {
	            console.log('handleCheckedHbTagsChange', this.checkedHbTags);
	        },
	        finalList: function finalList(isAll) {
	            var _this2 = this;
	
	            var finalList = [];
	            var hb_tags_withoutPubUnit = [];
	            hb_tags_withoutPubUnit = this.hb_tags.filter(function (k) {
	                if (!k.publisher_dfp_unit) return k;
	            });
	            if (isAll == true) {
	                this.$confirm('<label">This will migrate all the adunit. Continue?</label>', 'Warning', {
	                    dangerouslyUseHTMLString: true,
	                    confirmButtonText: 'OK',
	                    cancelButtonText: 'Cancel',
	                    type: 'warning',
	                    center: false
	                }).then(function () {
	                    if (hb_tags_withoutPubUnit && hb_tags_withoutPubUnit.length != 0) {
	                        finalList = hb_tags_withoutPubUnit;
	                    }
	                    _this2.migrateAll(finalList);
	                }).catch(function () {
	                    _this2.$notify({
	                        title: 'Info',
	                        message: 'Migrate all adunit Canceled!',
	                        type: 'info'
	                    });
	                });
	            } else {
	                if (this.checkedHbTags.length == 0) {
	                    this.$notify({
	                        title: 'Error',
	                        message: 'please select adunit',
	                        type: 'Error'
	                    });
	                    return;
	                }
	                finalList = hb_tags_withoutPubUnit.filter(function (k) {
	                    if (_this2.checkedHbTags.includes(k.id)) return k;
	                });
	                this.migrateAll(finalList, isAll);
	            }
	        },
	        migrateAll: function migrateAll(finalList, isAll) {
	            var _this3 = this;
	
	            console.log('finalList', finalList);
	            console.log('finalList', finalList.length);
	            var reqObj = [];
	            var singleObj = {};
	            for (var i = 0; i < finalList.length; i++) {
	                var _singleObj;
	
	                singleObj = (_singleObj = {}, (0, _defineProperty3.default)(_singleObj, 'enabled', finalList[i].enabled), (0, _defineProperty3.default)(_singleObj, 'dimensions', finalList[i].dimensions.map(function (i) {
	                    return i.id;
	                })), (0, _defineProperty3.default)(_singleObj, 'domain_id', finalList[i].domain_id), (0, _defineProperty3.default)(_singleObj, 'floor', finalList[i].floor), (0, _defineProperty3.default)(_singleObj, 'pub_dfp_unit_path', finalList[i].pub_dfp_unit_path), (0, _defineProperty3.default)(_singleObj, 'isPubUnit', this.isPubUnit), (0, _defineProperty3.default)(_singleObj, 'amp_currency', finalList[i].amp_currency_id), (0, _defineProperty3.default)(_singleObj, 'network_code', finalList[i].network_override != this.domain_details.dfp_network.network_code ? finalList[i].network_override : null), (0, _defineProperty3.default)(_singleObj, 'name', finalList[i].pub_dfp_unit_path), (0, _defineProperty3.default)(_singleObj, 'post_fix', finalList[i].post_fix), (0, _defineProperty3.default)(_singleObj, 'current_dfp_network', this.domain_details.dfp_network.network_code), (0, _defineProperty3.default)(_singleObj, 'child_network_override', this.child_dfp_network), (0, _defineProperty3.default)(_singleObj, 'mcm_account_switch', this.account_type), (0, _defineProperty3.default)(_singleObj, 'hb_tag_id', finalList[i].id), (0, _defineProperty3.default)(_singleObj, 'is_amp_sticky', finalList[i].is_amp_sticky), (0, _defineProperty3.default)(_singleObj, 'is_amp', finalList[i].is_amp), (0, _defineProperty3.default)(_singleObj, 'dfp_parent_ad_unit_id', this.dfp_parent_ad_unit_id), _singleObj);
	                if (finalList[i].hasOwnProperty('name') && finalList[i].name) {
	                    singleObj.name = finalList[i].name;
	                    if (!this.isPubUnit) {
	                        singleObj.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
	                    } else {
	                        singleObj.dfp_parent_ad_unit_path = null;
	                    }
	                } else {
	                    if (!this.isPubUnit) {
	                        console.log('dfp_parent_ad_unit_path', this.dfp_parent_ad_unit_path);
	                        singleObj.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
	                        singleObj.name = 'ATD_' + this.getDimension(finalList[i].dimensions) + '_' + finalList[i].post_fix;
	                    } else {
	                        singleObj.dfp_parent_ad_unit_path = null;
	                        singleObj.name = finalList[i].pub_dfp_unit_path;
	                    }
	                }
	
	                reqObj.push(singleObj);
	            }
	            console.log('single obj', singleObj);
	
	            console.log('req obj', reqObj);
	            console.log('this.account_type', this.account_type, 'child_dfp_network', this.child_dfp_network);
	
	            var url = ("https://beta-yeti-api.automatad.com/") + ('v1/migrate-hb-ad-units/' + this.domId);
	            _axios2.default.put(url, reqObj).then(function (res) {
	                console.log('res', res);
	                var msg = '';
	                if (res.data && res.data.status == false) {
	                    _this3.$notify({
	                        title: 'Error',
	                        message: res.data['exising ad units'],
	                        type: 'error',
	                        duration: 15000
	                    });
	                } else {
	                    if (isAll) {
	                        msg = 'Successfully Migrated All Tags';
	                    } else {
	                        msg = 'Successfully Migrate selected Tags';
	                    }
	                    _this3.$notify({
	                        title: 'Success',
	                        message: msg,
	                        type: 'success'
	                    });
	                }
	
	                _this3.checkedHbTags = [];
	                _this3.initialize(_this3.currentPage);
	            });
	        },
	        filterNetworkList: function filterNetworkList() {
	            if (this.account_type) {
	                console.log('calling filterNetworkList');
	                var selectedAccount = this.account_type;
	
	
	                this.filteredAccountList = this.childDfpAccounts.filter(function (k) {
	                    return k.delegation_type == selectedAccount;
	                });
	
	                this.child_dfp_network = null;
	            }
	        },
	        getAdunitPath: function getAdunitPath(k) {
	            var hbAmp = k.is_amp;
	            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
	            var domainParentCode = '';
	            if (k.mcm_account_switch == null) {
	                domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	            } else {
	                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
	                    domainParentCode = k.dfp_parent_ad_unit_path;
	                } else {
	                    if (k.dfp_parent_ad_unit_path != 0) {
	                        domainParentCode = k.dfp_parent_ad_unit_path;
	                    } else {
	                        domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	                    }
	                }
	            }
	
	            this.domainMcmEnabled = this.domain_details.mcm_enable;
	            var domainMcmType = this.domain_details.mcm ? this.domain_details.mcm.account_type : this.domain_details.mcm;
	            var domainMcmChild = this.domain_details.child_dfp_network ? this.domain_details.child_dfp_network.child_network_code : this.domain_details.child_dfp_network;
	            var hbAccountType = k.mcm_account_switch;
	            var hbOverridenChildNetwork = k.child_network_override;
	            var adunitCode = k.dfp_ad_unit_code;
	            var hbNetworkOverride = k.network_override;
	            var isPubUnit = k.publisher_dfp_unit;
	            var ishbNtwrkOverriden = k.network_override == null ? false : true;
	            var current_dfp_network = k.current_dfp_network;
	
	            if (isPubUnit == true) {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + adunitCode;
	                    } else {
	                        return current_dfp_network + ',' + hbOverridenChildNetwork + '/' + adunitCode;
	                    }
	                } else {
	                    if (ishbNtwrkOverriden == true || hbAmp) {
	                        return (hbNetworkOverride ? hbNetworkOverride : current_dfp_network) + '/' + adunitCode;
	                    } else if (current_dfp_network) {
	                        return current_dfp_network + '/' + adunitCode;
	                    } else {
	                        if (this.domainMcmEnabled) {
	                            if (domainMcmType == 'MANAGE_ACCOUNT') {
	                                return domainMcmChild + '/' + adunitCode;
	                            } else {
	                                return domainNetowrkCode + ',' + domainMcmChild + '/' + adunitCode;
	                            }
	                        } else {
	                            return domainNetowrkCode + '/' + adunitCode;
	                        }
	                    }
	                }
	            } else {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    } else {
	                        return current_dfp_network + ',' + hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                }
	                if (ishbNtwrkOverriden == true || hbAmp) {
	                    console.log('opopopop');
	                    return (hbNetworkOverride ? hbNetworkOverride : domainNetowrkCode) + '/' + domainParentCode + '/' + adunitCode;
	                } else if (current_dfp_network) {
	                    return current_dfp_network + '/' + domainParentCode + '/' + adunitCode;
	                } else {
	                    if (this.domainMcmEnabled) {
	                        if (domainMcmType == 'MANAGE_ACCOUNT') {
	                            return domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        } else {
	                            return domainNetowrkCode + ',' + domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        }
	                    } else {
	                        return domainNetowrkCode + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                }
	            }
	
	            return adunitCode;
	        },
	        getSizeForSearchDropdown: function getSizeForSearchDropdown() {
	            var _this4 = this;
	
	            console.log('is_amp', this.is_amp);
	            var getSizes = ("https://beta-yeti-api.automatad.com/") + ('v1/hb-ad-unit-size-list/domain/' + this.domId + '/');
	            var reqObj = {
	                is_amp: this.is_amp
	            };
	            _axios2.default.post(getSizes, reqObj).then(function (res) {
	                console.log('res getsize', res);
	                _this4.allDimensionsSearch = res.data;
	            });
	        },
	        clearSearch: function clearSearch() {
	            this.searchString = '';
	            this.searchNetworkOverride = false;
	            this.selectedNetworkCode = '';
	            this.selectedChildDfpNetworkCode = '';
	            this.initialize(1);
	        },
	        filterHbAdUnit: function filterHbAdUnit() {
	            this.currentPage = 1;
	            console.log('sstring', this.searchString.length);
	
	            this.issearch = true;
	            this.initialize(this.currentPage);
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            console.log('search', this.issearch);
	            console.log('search sstring', this.searchString.length);
	            console.log('val');
	            console.log(val);
	            this.$route.query.page = val;
	            if (this.searchString.length != 0) {
	                this.issearch = true;
	            }
	            this.currentPage = val;
	            this.initialize(val);
	        },
	        handleSizeChange: function handleSizeChange(val) {
	            this.offset = val;
	            this.initialize(1);
	            this.currentPage = 1;
	        },
	        OpenHbAdUnitsUsage: function OpenHbAdUnitsUsage(command) {
	            var _this5 = this;
	
	            console.log('command', command);
	            setTimeout(function () {
	                var url = '/admin/publisher/' + _this5.$route.params.uuid + '/domain/' + _this5.domId + '/buckets/' + command.bucket_id + '/fi/?adHbAdUnit=' + command.hb_tag_id;
	                console.log('command url', url);
	                _this5.$router.push(url);
	            });
	        },
	        filterDimension: function filterDimension() {
	            if (this.selectedDimensions.length != 0) {
	                this.issearch = true;
	            }
	            this.initialize(1);
	        },
	        initialize: function initialize(pageNum) {
	            var _this6 = this;
	
	            if (this.selectedDimensions.length != 0 || this.searchString.length != 0) {
	                this.issearch = true;
	            }
	
	            console.log('Domain ID: ', this.$route.params.domId);
	            this.hb_tags = [];
	            var self = this;
	            this.domId = this.$route.params.domId;
	            this.pubUid = this.$route.params.uuid;
	            this.loading = true;
	            if (pageNum == undefined) {
	                pageNum = 1;
	            }
	
	            var viewApi = ("https://beta-yeti-api.automatad.com/") + ('v1/' + (this.is_amp ? 'amp_hb_tags' : 'hb_tags') + '/' + this.domId + '/?page=' + pageNum + '&&offset=' + this.offset);
	
	            var searchApi = ("https://beta-yeti-api.automatad.com/") + ('v1/' + (this.is_amp ? 'search-hb-amp-ad-unit' : 'search-hb-ad-unit') + '/domain/' + this.domId + '/?query=' + this.searchString + '&offset=' + this.offset + '&page=' + this.currentPage + '&') + 'dimensionId=[' + this.selectedDimensions + ']' + '&dfp_network_code=' + this.selectedNetworkCode + '&child_dfp_network_code=' + this.selectedChildDfpNetworkCode + '&network_override=' + this.searchNetworkOverride;
	
	            console.log(this);
	            _axios2.default.all([_axios2.default.get(this.issearch ? searchApi : viewApi), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-bidders-under-domain/' + this.domId), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publishers/' + this.pubUid + '/domains/' + this.domId + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/hb-tag-param-set/' + this.domId + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/amp_hb_tags/' + this.domId + '/'))]).then(_axios2.default.spread(function (hb_tags, dimensions, bidders, domain, param_sets, all_amp_hb_tags) {
	                _this6.issearch = false;
	
	                _this6.hb_tags = hb_tags.data.response_data.hb_tags;
	                console.log('hb_tags', domain);
	                _this6.bucketList = domain.data.data;
	                console.log('bucketList', _this6.bucketList);
	
	                console.log('hb_tags1', _this6.hb_tags);
	                _this6.all_amp_hb_tags = all_amp_hb_tags.data.response_data.hb_tags;
	                console.log(_this6.all_amp_hb_tags);
	                console.log('my1 hb_tags', _this6.hb_tags);
	                _this6.total_pages = hb_tags.data.response_data.total;
	                _this6.dimensions = dimensions.data;
	                _this6.bidders = bidders.data;
	                _this6.loading = false;
	                _this6.domain_details = domain.data;
	                _this6.buildPublisherInstructions();
	                _this6.param_sets = param_sets.data.data;
	
	                console.log('this.name', _this6.name);
	
	                for (var i = 0; i < _this6.hb_tags.length; i++) {
	                    var tag_id = _this6.hb_tags[i].id;
	                    _this6.bidderParamsForm.formData[tag_id] = {};
	                    for (var j = 0; j < _this6.hb_tags[i].dimensions.length; j++) {
	                        var dimension_str = _this6.hb_tags[i].dimensions[j]['width'] + 'X' + _this6.hb_tags[i].dimensions[j]['height'];
	                        _this6.bidderCopyParamsData[dimension_str] = {};
	                        _this6.bidderParamsForm.formData[tag_id][dimension_str] = {};
	                        _this6.bidderParamsForm.formData[tag_id][dimension_str]['param_set'] = _this6.hb_tags[i][dimension_str]['param_set'];
	                    }
	                }
	                console.log(_this6.bidderParamsForm.formData);
	                _this6.bidderParamsForm2 = JSON.parse((0, _stringify2.default)(_this6.bidderParamsForm));
	
	                console.log('form', _this6.bidderParamsForm.formData);
	                if (_this6.$route.query.tag_id) {
	                    _this6.activeNames = _this6.getTagDetails(_this6.$route.query.tag_id) ? _this6.getTagDetails(_this6.$route.query.tag_id).id : '';
	                    if (!_this6.getTagDetails(_this6.$route.query.tag_id)) {
	                        console.log('Create HB tag entry!!');
	                    }
	                }
	            }));
	        },
	        OpenAdSpotUsage: function OpenAdSpotUsage(command) {
	            var _this7 = this;
	
	            setTimeout(function () {
	                var url = '/admin/publisher/' + _this7.uuid + '/domain/' + _this7.domId + '/buckets/' + command.bucket_id + '/fi/?adSpotId=' + command.id;
	                console.log('command url', url);
	                _this7.$router.push(url);
	            });
	        },
	        copyAmpTag: function copyAmpTag(hbTag) {
	            console.log('@@copy amp hbTag', hbTag);
	            var highestDimension = [hbTag.dimensions[0]['width'], hbTag.dimensions[0]['height']];
	            var allSizes = hbTag.dimensions.map(function (dimen) {
	                return dimen['width'] + 'x' + dimen['height'];
	            }).join(',');
	            console.log('Dimensions: ' + allSizes);
	
	            hbTag.dimensions.forEach(function (dimen) {
	                if (parseInt(dimen['height']) + parseInt(dimen['width']) > parseInt(highestDimension[1]) + parseInt(highestDimension[0])) {
	                    highestDimension[0] = dimen['width'];
	                    highestDimension[1] = dimen['height'];
	                }
	            });
	            var code = hbTag.dfp_ad_unit_code.split('/');
	            var name = code[code.length - 1];
	            console.log(this.domain_details.uuid + '_' + name.trim());
	
	
	            if (hbTag.is_amp_sticky) {
	                '';
	                return ('<amp-sticky-ad layout="nodisplay">\n\t<amp-ad width=' + highestDimension[0] + ' height=' + highestDimension[1] + '\n\t\ttype="doubleclick"\n\t\tdata-slot="/' + this.getAdunitPath(hbTag) + '"\n\t\tdata-multi-size="' + allSizes + '"\n\t\t    rtc-config=\'{"urls":["https://us-east-pbs.automatad.com/openrtb2/amp?tag_id=' + this.domain_details.uuid + '_' + name.trim() + '&curl=CANONICAL_URL"]}\'\ndata-enable-refresh=30>\n\t\t</amp-ad>\n</amp-sticky-ad>').replace(/(https?:\/\/)|(\/)+/g, '$1$2');
	            } else {
	                return ('<amp-ad width=' + highestDimension[0] + ' height=' + highestDimension[1] + '\n\ttype="doubleclick"\n\tdata-slot="/' + this.getAdunitPath(hbTag) + '"\n\tdata-multi-size="' + allSizes + '"\n\t    rtc-config=\'{"urls":["https://us-east-pbs.automatad.com/openrtb2/amp?tag_id=' + this.domain_details.uuid + '_' + name.trim() + '&curl=CANONICAL_URL"]}\'\ndata-enable-refresh=30>\n</amp-ad>\n\n').replace(/(https?:\/\/)|(\/)+/g, '$1$2');
	            }
	        },
	        copyTagId: function copyTagId(hbTag) {
	            console.log('@@copy amp hbTag', hbTag);
	            var highestDimension = [hbTag.dimensions[0]['width'], hbTag.dimensions[0]['height']];
	            var allSizes = hbTag.dimensions.map(function (dimen) {
	                return dimen['width'] + 'x' + dimen['height'];
	            }).join(',');
	            console.log('Dimensions: ' + allSizes);
	
	            hbTag.dimensions.forEach(function (dimen) {
	                if (parseInt(dimen['height']) + parseInt(dimen['width']) > parseInt(highestDimension[1]) + parseInt(highestDimension[0])) {
	                    highestDimension[0] = dimen['width'];
	                    highestDimension[1] = dimen['height'];
	                }
	            });
	            var code = hbTag.dfp_ad_unit_code.split('/');
	            var name = code[code.length - 1];
	            var tagged_ID = this.domain_details.uuid + '_' + name.trim();
	            return tagged_ID;
	        },
	        ampTagCopied: function ampTagCopied() {
	            this.$notify({
	                title: 'Success',
	                message: 'Successfully copied the AMP tag',
	                type: 'success'
	            });
	        },
	        tagIdCopied: function tagIdCopied() {
	            this.$notify({
	                title: 'Success',
	                message: 'Successfully copied the Tag ID',
	                type: 'success'
	            });
	        },
	        buildPublisherInstructions: function buildPublisherInstructions() {
	            var tags = '';
	            for (var i = 0; i < this.all_amp_hb_tags.length; i++) {
	                tags += '\n\n\n' + (i + 1) + ') Position: \'\'\n\n' + this.copyAmpTag(this.all_amp_hb_tags[i]);
	            }
	            this.pubInstructions = this.pubInstructions + tags;
	        },
	        copyParamsAll: function copyParamsAll(selectedDimension, bidderCode, id) {
	            for (var param in this.bidderCopyParamsData[selectedDimension][bidderCode]) {
	                this.bidderParamsForm.formData[id][selectedDimension][bidderCode][param] = JSON.parse((0, _stringify2.default)(this.bidderCopyParamsData[selectedDimension][bidderCode][param]));
	            }
	
	            this.$forceUpdate();
	        },
	        handleChange: function handleChange(val) {
	            console.log(this.activeNames);
	            if (this.activeNames == '') {
	                console.log(this.prevActiveNames + ' was closed');
	            }
	            this.recentlyClosed = this.prevActiveNames;
	
	            this.prevActiveNames = this.activeNames;
	        },
	        getDimension: function getDimension(dimensions) {
	            console.log(dimensions);
	
	            var res = dimensions.map(function (dimension) {
	                return dimension['width'] + 'X' + dimension['height'];
	            });
	            return res;
	        },
	        getDimensionInStr: function getDimensionInStr(dimension) {
	            return dimension['width'] + 'X' + dimension['height'];
	        },
	        getBidderFields: function getBidderFields(bidder_id, hb_tag) {
	            for (var i = 0; i < this.bidders.length; i++) {
	                if (this.bidders[i].id == bidder_id) {
	                    return JSON.parse(this.bidders[i].param);
	                }
	            }
	        },
	        setSelectedBidder: function setSelectedBidder(bidder_code, tag_id, dimension) {
	            console.log(dimension);
	            console.log('setSelectedBidder ran');
	            if (!this.bidderParamsForm.formData[tag_id][dimension][bidder_code]) {
	                console.log('SET defaults ');
	            }
	        },
	        setSelectedOwnership: function setSelectedOwnership(bidder_code, tag_id, val) {},
	        updateHbTag: function updateHbTag(hb_tag, dim) {
	            var _this8 = this;
	
	            console.log(hb_tag);
	            var hb_tag_id = hb_tag.id;
	            this.loading = true;
	            console.log(this.bidderParamsForm2.formData[hb_tag_id]);
	            console.log(this.bidderParamsForm2.formData[hb_tag_id][dim.width + 'X' + dim.height]);
	            var dimId = dim.id;
	            console.log(dimId);
	
	            var requestObject = {
	                hb_tag_id: hb_tag_id,
	                dimension_id: dimId,
	                param_set_id: this.bidderParamsForm2.formData[hb_tag_id][dim.width + 'X' + dim.height]['param_set']
	            };
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/update_hb_tag/' + this.domId + '/', requestObject).then(function (response) {
	                console.log(response);
	                if (response.data.status == 'success') {
	                    _this8.$notify({
	                        title: 'Success',
	                        message: 'Successfully updated the tag!!',
	                        type: 'success'
	                    });
	                    _this8.loading = false;
	                    _this8.recentlyClosed = _this8.activeNames;
	                    if (!(hb_tag.dimensions.length > 1)) _this8.activeNames = '';
	                } else if (response.data.status == 'error') {
	                    _this8.$notify({
	                        title: 'Error',
	                        message: response.data.reason,
	                        type: 'error'
	                    });
	                    _this8.loading = false;
	                    _this8.recentlyClosed = _this8.activeNames;
	                    if (!(hb_tag.dimensions.length > 1)) _this8.activeNames = '';
	                }
	            }).catch(function (error) {
	                console.log('Error:', error);
	                this.loading = false;
	            });
	        },
	        getParamSetsForDim: function getParamSetsForDim(dimId) {
	            var _this9 = this;
	
	            console.log(dimId);
	            var res = this.param_sets.filter(function (param_set) {
	                if (_this9.is_amp) {
	                    return param_set.dimension.id == dimId && param_set.is_amp;
	                } else {
	                    return param_set.dimension.id == dimId && !param_set.is_amp;
	                }
	            });
	            console.log(res);
	            return res;
	        },
	        getTagDetails: function getTagDetails(tag_id) {
	            for (var i = 0; i < this.hb_tags.length; i++) {
	                if (this.hb_tags[i].id == tag_id) {
	                    return this.hb_tags[i];
	                }
	            }
	        }
	    }
	};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dfp_parent_ad_unit_path: 'null',
	      dfp_parent_ad_unit_id: 0,
	      filteredAccountList: [],
	      domainMcmEnabled: false,
	      domainNetworkDelegation: null,
	      domainChildNetwork: null,
	      account_type: null,
	      mcm_enabled: false,
	      child_dfp_network: null,
	      mcmAccountType: [],
	      childDfpAccounts: [],
	      currenciesOptions: [],
	      activeNames: ['1'],
	      dimensions: [],
	      current_dfp_network: null,
	      pubUuid: this.$route.params.uuid,
	      domId: this.$route.params.domId,
	      isPubUnit: false,
	      pubUid: undefined,
	      domain_details: undefined,
	      hb_tag: {
	        name: '',
	        post_fix: '',
	        enabled: true,
	        dimensions: undefined,
	        device_type: 'web',
	        domain_id: this.$route.params.domId,
	        currencyId: '',
	        floor: 0.0,
	        pub_dfp_unit_path: '',
	        pub_dfp_unit_id: '',
	        network_override: ''
	
	      },
	      options: [{
	        value: 'instream',
	        label: 'instream'
	      }, {
	        value: 'outstream',
	        label: 'outstream'
	      }],
	      value: '',
	      player_dimension: '',
	      vpdimension: [{
	        value: '320 x 460',
	        label: '320 x 460'
	      }, {
	        value: '860 x 420',
	        label: '860 x 420'
	      }],
	      frmData: '',
	      curUnit: [],
	      loading: true
	    };
	  },
	
	  props: {
	    is_amp: Boolean,
	    id: Number
	  },
	  created: function created() {
	    var self = this;
	    this.domId = this.$route.params.domId;
	    this.pubUid = this.$route.params.uuid;
	    _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/' + (this.is_amp ? 'amp_hb_tags' : 'hb_tags') + '/' + this.domId + '/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publishers/' + this.pubUid + '/domains/' + this.domId + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/currencies/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/child-dfp-network-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/mcm-account-list/')]).then(_axios2.default.spread(function (dimensions, data, domain, currencies, childAccounts, mcm_type) {
	      console.log(self.id);
	      console.log(self.$route.params.id);
	      self.frmData = data.data.response_data.hb_tags;
	
	
	      self.curUnit = self.frmData.filter(function (t) {
	        if (t.id == self.$route.params.id) return t;
	      })[0];
	      console.log(self.curUnit);
	      self.currenciesOptions = currencies.data;
	      self.hb_tag.currencyId = self.curUnit.hasOwnProperty("amp_currency_id") && self.curUnit.amp_currency_id != '' ? self.curUnit.amp_currency_id : '';
	      console.log(self.hb_tag.currencyId);
	      if (self.hb_tag.currencyId == '') {
	        currencies.data.map(function (k) {
	          if (k.code == 'USD') {
	            return self.hb_tag.currencyId = k.id;
	          }
	        });
	      }
	      self.isPubUnit = self.curUnit.publisher_dfp_unit;
	      self.current_dfp_network = self.curUnit.current_dfp_network;
	      self.domainNetworkDelegation = domain.data.mcm ? domain.data.mcm.account_type : self.domainNetworkDelegation;
	      self.domainMcmEnabled = domain.data.mcm_enable;
	      self.domainChildNetwork = domain.data.child_dfp_network ? domain.data.child_dfp_network.child_network_code : self.domainChildNetwork;
	      self.hb_tag.floor = self.curUnit.floor;
	      self.hb_tag.post_fix = self.curUnit.post_fix;
	      self.dfp_parent_ad_unit_id = self.curUnit.dfp_parent_ad_unit_id;
	      self.hb_tag.pub_dfp_unit_path = self.curUnit.dfp_ad_unit_code;
	      self.hb_tag.pub_dfp_unit_id = self.curUnit.dfp_ad_unit_id;
	      self.hb_tag.dimensions = self.curUnit.dimensions.map(function (i) {
	        return i.id;
	      });
	      self.account_type = self.curUnit.mcm_account_switch ? self.curUnit.mcm_account_switch : self.account_type;
	      self.mcm_enabled = self.account_type != null ? true : false;
	      self.child_dfp_network = self.curUnit.child_network_override ? self.curUnit.child_network_override : self.child_dfp_network;
	      self.domain_details = domain.data;
	      self.childDfpAccounts = childAccounts.data;
	      self.dfp_parent_ad_unit_path = self.curUnit.dfp_parent_ad_unit_path;
	      self.mcmAccountType = mcm_type.data;
	      self.filteredAccountList = self.account_type != null ? self.childDfpAccounts.filter(function (k) {
	        return k.delegation_type == self.account_type;
	      }) : self.childDfpAccounts;
	
	      self.hb_tag.network_override = self.isPubUnit ? self.curUnit.network_override ? self.curUnit.network_override : self.domain_details.mcm_enable == true ? self.domain_details.mcm.account_type == 'MANAGE_ACCOUNT' ? self.domain_details.child_dfp_network.child_network_code : self.domain_details.dfp_network.network_code : self.domain_details.dfp_network.network_code : null;
	
	      console.log('curUnit', self.curUnit);
	      self.dimensions = dimensions.data;
	      console.log('r', data);
	      self.loading = false;
	    })).catch(function (error) {
	      return console.log(error);
	    });
	  },
	  methods: {
	    filterNetworkList: function filterNetworkList() {
	      var selectedAccount = this.account_type;
	      this.filteredAccountList = this.childDfpAccounts.filter(function (k) {
	        return k.delegation_type == selectedAccount;
	      });
	      this.child_dfp_network = null;
	    },
	    resetMCM: function resetMCM() {
	      this.account_type = null;
	      this.child_dfp_network = null;
	    },
	    handleChange: function handleChange(val) {
	      console.log(val);
	    },
	    getDimension: function getDimension(ids) {
	      console.log(ids);
	      if (ids) {
	        if (ids.length > 1) {
	          return 'MULTISIZE';
	        } else {
	          for (var i = 0; i < this.dimensions.length; i++) {
	            if (this.dimensions[i].id == ids[0]) {
	              return this.dimensions[i].width + 'x' + this.dimensions[i].height;
	            }
	          }
	        }
	      }
	    },
	    createTag: function createTag() {
	      var _this = this;
	
	      if (this.account_type == "MANAGE_ACCOUNT" && this.dfp_parent_ad_unit_id == 0) {
	        this.$notify({
	          title: 'Error',
	          message: "please add dfp parent ad unit id",
	          type: 'Error'
	        });
	        return;
	      }
	      console.log('createTag called');
	      console.log(this.hb_tag);
	      var request_object = {
	        enabled: this.hb_tag.enabled,
	        dimensions: this.hb_tag.dimensions,
	        domain_id: this.hb_tag.domain_id,
	        floor: this.hb_tag.floor,
	        pub_dfp_unit_path: this.hb_tag.pub_dfp_unit_path,
	        pub_dfp_unit_id: this.hb_tag.pub_dfp_unit_id,
	        isPubUnit: this.isPubUnit,
	        hb_tag_id: this.curUnit.id,
	        is_amp_sticky: this.curUnit.is_amp_sticky,
	        is_amp: this.is_amp,
	        amp_currency: this.hb_tag.currencyId,
	        network_code: this.domainMcmEnabled ? this.hb_tag.network_override : this.hb_tag.network_override != this.domain_details.dfp_network.network_code ? this.hb_tag.network_override : null,
	        current_dfp_network: this.current_dfp_network,
	        dfp_parent_ad_unit_id: this.dfp_parent_ad_unit_id
	      };
	      console.log(request_object);
	      if (!this.isPubUnit) {
	        request_object.name = 'ATD_' + this.getDimension(this.hb_tag.dimensions) + '_' + this.hb_tag.post_fix;
	        request_object.post_fix = this.hb_tag.post_fix;
	        request_object.child_network_override = this.child_dfp_network;
	        request_object.mcm_account_switch = this.account_type;
	        request_object.dfp_parent_ad_unit_path = this.account_type == null ? this.is_amp ? this.domain_details.amp_parent_ad_unit_code : this.domain_details.parent_ad_unit_code : this.dfp_parent_ad_unit_path;
	
	        request_object.dfp_parent_ad_unit_id = this.account_type == null ? this.is_amp ? this.domain_details.amp_parent_ad_unit_id : this.domain_details.parent_ad_unit_id : this.dfp_parent_ad_unit_id;
	      } else {
	        request_object.dfp_parent_ad_unit_id = this.dfp_parent_ad_unit_id;
	        request_object.dfp_parent_ad_unit_path = 'null';
	        request_object.name = this.hb_tag.pub_dfp_unit_path;
	        request_object.post_fix = 'null';
	        request_object.child_network_override = this.child_dfp_network;
	        request_object.mcm_account_switch = this.account_type;
	      }
	
	      console.log('request sent', request_object);
	
	      _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/create_hb_tag/', request_object).then(function (response) {
	        if (response.data.status == 'success') {
	          _this.$notify({
	            title: 'Success',
	            message: response.data.message,
	            type: 'success'
	          });
	          console.log(response.data);
	          if (_this.$route.query.page && !isNaN(parseInt(_this.$route.query.page))) setTimeout(function () {
	            _this.$router.push('/admin/publisher/' + _this.pubUuid + '/domain/' + _this.domId + '/' + (_this.is_amp ? 'hb-tags-amp' : 'hb-tags') + '/?tag_id=' + response.data.tag_id + '&page=' + parseInt(_this.$route.query.page));
	          }, 500);else setTimeout(function () {
	            _this.$router.push('/admin/publisher/' + _this.pubUuid + '/domain/' + _this.domId + '/' + (_this.is_amp ? 'hb-tags-amp' : 'hb-tags') + '/?tag_id=' + response.data.tag_id);
	          }, 500);
	        } else if (response.data.status == 'error') {
	          _this.$notify({
	            title: 'Error !!',
	            message: response.data.message,
	            type: 'error'
	          });
	          _this.activeNames = '';
	        }
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    },
	    resetNetworkCode: function resetNetworkCode(event) {
	      event.preventDefault();
	      console.log(event);
	      this.hb_tag.network_override = this.domain_details.mcm_enable == true ? this.domain_details.mcm.account_type == 'MANAGE_ACCOUNT' ? this.domain_details.child_dfp_network.child_network_code : this.domain_details.dfp_network.network_code : this.domain_details.dfp_network.network_code;
	      this.mcm_enabled = false;
	      this.account_type = null;
	      this.child_dfp_network = null;
	    },
	    getDfpAdUnitPath: function getDfpAdUnitPath(hb_tag) {
	      console.log(hb_tag);
	      console.log(this.domain_details);
	      console.log(this.hb_tag.network_override);
	
	      var path = '';
	      if (this.domain_details) {
	        var network_code = this.domain_details.dfp_network.network_code;
	        if (this.account_type) {
	          if (this.account_type == 'MANAGE_INVENTORY') {
	            network_code = this.current_dfp_network + ',' + this.child_dfp_network;
	          } else {
	            network_code = this.child_dfp_network;
	          }
	        } else if (this.hb_tag.network_override && (this.hb_tag.network_override != this.domain_details.dfp_network.network_code || this.isPubUnit || this.is_amp)) {
	          network_code = this.hb_tag.network_override;
	        } else {
	          if (this.current_dfp_network) {
	            network_code = this.current_dfp_network;
	          } else {
	            if (this.domain_details.mcm_enable) {
	              if (this.domain_details.mcm.account_type == 'MANAGE_INVENTORY') {
	                network_code = this.domain_details.dfp_network.network_code + ',' + this.domain_details.child_dfp_network.child_network_code;
	              } else {
	                network_code = this.domain_details.child_dfp_network.child_network_code;
	              }
	            } else {
	              network_code = network_code;
	            }
	          }
	        }
	
	        var dfp_parent_code = this.domain_details.parent_ad_unit_code;
	
	        if (this.isPubUnit) {
	          dfp_parent_code = hb_tag.dfp_ad_unit_code;
	        } else {
	          if (this.account_type && this.dfp_parent_ad_unit_id != 0) {
	            dfp_parent_code = this.dfp_parent_ad_unit_path;
	          } else {
	            if (this.is_amp) {
	              dfp_parent_code = this.domain_details.amp_parent_ad_unit_code;
	            } else {
	              dfp_parent_code = this.domain_details.parent_ad_unit_code;
	            }
	          }
	        }
	        path = network_code + '/' + dfp_parent_code;
	
	        if (!this.isPubUnit) path += '/' + hb_tag.dfp_ad_unit_code;
	      }
	      return path;
	    }
	  },
	  computed: {
	    isComplete: function isComplete() {
	      if (!this.isPubUnit && this.mcm_enabled) return this.dfp_parent_ad_unit_path != '' && this.dfp_parent_ad_unit_path != null && this.dfp_parent_ad_unit_id != 0 && this.domainMcmEnabled == true && this.account_type != null && this.child_dfp_network != null && this.hb_tag.hasOwnProperty('dimensions') && String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0;else if (!this.isPubUnit) return this.hb_tag.hasOwnProperty('dimensions') && String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0;else if (this.mcm_enabled) return this.isPubUnit == false && this.dfp_parent_ad_unit_path != '' && this.dfp_parent_ad_unit_path != null && this.dfp_parent_ad_unit_id != 0 && this.domainMcmEnabled == true && this.account_type != null && this.child_dfp_network != null && String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && this.hb_tag.network_override;else return String(this.hb_tag.floor) && this.hb_tag.dimensions && this.hb_tag.dimensions.length > 0 && this.hb_tag.network_override;
	    }
	  }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				directCampaigns: []
			};
		},
	
		created: function created() {
			var _this = this;
	
			_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/domains/' + this.$route.params.domId + '/direct-campaigns/')]).then(_axios2.default.spread(function (response) {
				_this.directCampaigns = response.data;
				window.setTimeout(function () {
					_letterAvatar2.default.transform();
				});
			}));
		}
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			var _ref;
	
			return _ref = {
				module: 'dc',
				rows: [],
				adunits: [],
				credentialId: [],
				selectedAdUnits: [],
				bucketListForModuleConfig: [],
				selectedBucketToImportConfig: undefined,
				selectedBucketNameToImportConfig: undefined
			}, (0, _defineProperty3.default)(_ref, 'adunits', []), (0, _defineProperty3.default)(_ref, 'credentials', {
				date: '',
				name: '',
				primary_goal_goal_type: '',
				cost_type: 'CPM',
				primary_goal_units: '',
				line_item_type: '',
				primary_goal_unit_type: 'IMPRESSIONS',
				pub_id: this.$route.params.uuid,
				creative: '',
				adunit: []
			}), (0, _defineProperty3.default)(_ref, 'formData', {
				adunit: []
			}), (0, _defineProperty3.default)(_ref, 'amount', ''), (0, _defineProperty3.default)(_ref, 'options', [{
				value: 'STANDARD',
				label: 'STANDARD'
			}, {
				value: 'SPONSORSHIP',
				label: 'SPONSORSHIP'
			}]), (0, _defineProperty3.default)(_ref, 'QuantityOptions', [{
				value: 'IMPRESSIONS',
				label: 'IMPRESSIONS'
			}, {
				value: 'CLICKS',
				label: 'CLICKS'
			}]), (0, _defineProperty3.default)(_ref, 'SponsorshipOptions', [{
				value: 'CPD',
				label: 'CPD'
			}, {
				value: 'CPM',
				label: 'CPM'
			}, {
				value: 'CPC',
				label: 'CPC'
			}]), (0, _defineProperty3.default)(_ref, 'value', ''), (0, _defineProperty3.default)(_ref, 'value3', [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)]), (0, _defineProperty3.default)(_ref, 'value4', ''), _ref;
		},
	
		created: function created() {
			this.$nextTick(function () {
				var _this = this;
	
				_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domain/' + this.$route.params.domId + '/dfp-credentials/')]).then(_axios2.default.spread(function (creadentialId, selectedAdUnits) {
					_this.credentialId = creadentialId.data.id;
				}));
	
				this.getListOfBucketConfig();
			});
		},
		methods: {
			removeSelectedModuleConfig: function removeSelectedModuleConfig() {
				this.selectedBucketToImportConfig = undefined;
				this.selectedBucketNameToImportConfig = undefined;
			},
	
			getListOfBucketConfig: function getListOfBucketConfig() {
				var _this2 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_bucket_config_list/', { bucketId: this.$route.params.bucketId, module: this.module }).then(function (response) {
					if (response.data.response_data.status) {
						_this2.bucketListForModuleConfig = response.data.response_data.bucket_list;
					}
				}).catch(function (e) {
					console.log();
				});
			},
			selectBucketModule: function selectBucketModule(index) {
				this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
				this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
				if (this.selectedBucketToImportConfig !== null && this.selectedBucketToImportConfig !== undefined) {
					console.log(this.selectedBucketToImportConfig);
					this.getDFPConfig(this.selectedBucketToImportConfig);
					this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
				}
			},
	
			getDFPConfig: function getDFPConfig(bucketID) {
				_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/domains/' + this.$route.params.domId + '/buckets/' + this.$route.params.bucketId + '/direct-campaign/')]).then(_axios2.default.spread(function (data) {
					console.log(data);
				}));
			},
			notificationMsg: function notificationMsg() {
				var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
				var msg = arguments[1];
	
				this.$notify({
					title: type,
					message: msg ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			getAdunits: function getAdunits(query) {
				var _this3 = this;
	
				if (query) {
					_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/search-ad-unit/' + this.$route.params.domId + '/?query=' + query)]).then(_axios2.default.spread(function (data) {
						_this3.adunits = data.data;
					}));
				}
			},
			setSelectedAdUnit: function setSelectedAdUnit() {
				var _this4 = this;
	
				setTimeout(function () {
					if (_this4.formData.adunit && _this4.formData.adunit.length > 0) {
						_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-ad-unit/' + _this4.credentialId + '/bucket/' + _this4.$route.params.bucketId + '/?query=' + (0, _stringify2.default)(_this4.formData.adunit)).then(function (data) {
							_this4.selectedUnits = data.data;
						});
					}
				});
			},
			addRow: function addRow() {
				if (this.rows.length < 5) {
					this.rows.push({
						title: ""
					});
				} else {
					this.$notify({
						title: "Creatives Limit Exceeded",
						message: "You can only have 5 creatives.",
						type: "warning"
					});
				}
			},
			removeElement: function removeElement(index) {
				this.rows.splice(index, 1);
			},
			submit: function submit() {
				var _this5 = this;
	
				this.credentials.micro_amount = this.convert_to_micro(this.amount);
				if (this.credentials.line_item_type == "STANDARD") {
					this.credentials.primary_goal_goal_type = "LIFETIME";
				} else if (this.credentials.line_item_type == "SPONSORSHIP") {
					this.credentials.primary_goal_goal_type = "DAILY";
				}
				var creatives_dfp = [];
				this.rows.forEach(function (value, index) {
					creatives_dfp.push({ creative: value.title });
				});
				console.log(creatives_dfp);
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.$route.params.uuid + '/domains/' + this.$route.params.domId + '/direct-campaigns/line-items/', {
					line_item_name: this.credentials.name,
					cost_type: this.credentials.cost_type,
					primary_goal_units: this.credentials.primary_goal_units,
					line_item_type: this.credentials.line_item_type,
					primary_goal_unit_type: this.credentials.primary_goal_unit_type,
					micro_amount: this.credentials.micro_amount,
					primary_goal_goal_type: this.credentials.primary_goal_goal_type,
					start_date: this.credentials.date[0],
					end_date: this.credentials.date[1],
					creatives: creatives_dfp,
					ad_units: this.credentials.adunit
				}).then(function (response) {
					_this5.$notify({
						title: "Direct Campaign Created",
						message: "Direct Campaign Created",
						type: "success"
					});
				}).catch(function (error) {
					_this5.$notify({
						title: "Empty/Invalid Fields",
						message: "Please fill all the details",
						type: "warning"
					});
				});
			},
			convert_to_micro: function convert_to_micro(amount) {
				amount = amount * Math.pow(10, 6);
				return amount;
			}
		}
	};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	
	      loading: true
	    };
	  },
	  created: function created() {
	    this.initialize();
	  },
	  methods: {
	    initialize: function initialize() {
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/spot-diagnostics/' + this.$route.params.adSpotId + '/').then(function (res) {
	        console.log(res);
	        window.location = res.data;
	      });
	    }
	  },
	
	  computed: {
	    isComplete: function isComplete() {
	      return this.dfp.prebid_currency;
	    }
	  }
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(30);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            issearch: false,
	            searchFI: '',
	            currentPage: 1,
	            offset: 10,
	            cArr: [],
	            id: '5603',
	            total_pages: 0,
	            uuid: undefined,
	            domId: undefined,
	            bucket_id: undefined,
	            isHeader: false,
	            divIdPrefix: 'fi-ash-',
	            existingAdSpots: [],
	            existingLayouts: [],
	            allKeyValues: [],
	            devicegroup: 'all',
	            fiAdTypes: [],
	            las: {},
	            formData: {
	                index: -1,
	                editId: undefined,
	                existing: true,
	                defineSlot: false,
	                udivid: undefined,
	                selector: undefined,
	                fiAdType: undefined,
	                aliasName: undefined,
	                keyValuePairAssoc: undefined,
	                keyValue: [],
	                adspotLayout: [],
	                adTypeData: {},
	                selectedLayouts: []
	            },
	            adspotLayoutAssoc: {
	                layoutSelected: []
	            },
	            adFormatFields: [],
	            loading: true
	        };
	    },
	
	    props: {
	        domain_details: Object
	    },
	    created: function created() {
	        var _this = this;
	
	        var afterDeleteList = [];
	
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	
	        var viewApi = ("https://beta-yeti-api.automatad.com/") + 'v1/search-adspot/domain/' + this.domId + '/?query=' + this.$route.query.spot_id + '&&page=1&&offset=' + this.offset + '&&isId=0';
	        var searchApi = ("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/setup-fi-adspots/?page=1&&offset=10';
	        this.copyFormData = JSON.parse((0, _stringify2.default)(this.formData));
	        _axios2.default.all([_axios2.default.get(this.$route.query.spot_id ? viewApi : searchApi), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/page-layouts/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-all-fi-ad-types/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-all-key-values/')]).then(_axios2.default.spread(function (adSpots, pageLayouts, fi_ad_types, keyValues) {
	            console.log('route', _this.$route.params.domId);
	
	            _this.total_pages = adSpots.data.total;
	            for (var i = 0; i < adSpots.data.data.length; i++) {
	                adSpots.data.data[i].isbucketused = _this.checkIsBucketUsed(adSpots.data.data[i]);
	                if (adSpots.data.data[i].status) {
	                    afterDeleteList.push(adSpots.data.data[i]);
	                }
	                console.log('status', adSpots.data.data[i]);
	            }
	
	            _this.existingAdSpots = afterDeleteList;
	            _this.existingLayouts = pageLayouts.data;
	            _this.fiAdTypes = fi_ad_types.data;
	            _this.allKeyValues = keyValues.data;
	            _this.loading = false;
	            _this.$nextTick().then(function () {
	                if (_this.$route.query.spot_id) {
	                    console.log('SPOT ID');
	                    console.log(_this.$route.query.spot_id);
	                    var filtered_spot_index = _this.existingAdSpots.findIndex(function (spot) {
	                        return spot.id == _this.$route.query.spot_id;
	                    });
	                    if (filtered_spot_index != -1) {
	                        var filtered_spot = _this.existingAdSpots[filtered_spot_index];
	                        console.log(filtered_spot.alias_name);
	                        _this.editFirstImpression(filtered_spot);
	                        _this.searchFI = adSpots.data.data[0].alias_name;
	                        window.setTimeout(function () {
	                            jQuery('.el-table__body-wrapper:last').animate({
	                                scrollTop: jQuery('.el-table__body-wrapper .el-table__row:eq(' + filtered_spot_index + ')').position().top
	                            }, 600);
	                        }, 300);
	                    } else console.error('no ad spot found!!');
	                }
	            });
	        }));
	    },
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            console.log('Entire DOM updated!!!');
	        });
	    },
	    methods: {
	        checkIsBucketUsed: function checkIsBucketUsed(adSpots) {
	            var isbucketused = false;
	            for (var j = 0; j < adSpots.associations.length; j++) {
	                console.log('asso', adSpots.associations[j].fi_layout_bucket_associations.length);
	                if (adSpots.associations[j].fi_layout_bucket_associations.length == 0) {
	                    isbucketused = false;
	                } else {
	                    isbucketused = true;
	                    break;
	                }
	            }
	            return isbucketused;
	        },
	        clearSearch: function clearSearch() {
	            this.searchFI = '';
	            this.loadAdspotDataByCurrentPage(1);
	        },
	        filterFirstImpressionTagAssociations: function filterFirstImpressionTagAssociations() {
	            var _this2 = this;
	
	            this.issearch = true;
	            this.currentPage = 1;
	            this.loading = true;
	            this.existingAdSpots = [];
	            console.log('search string', this.searchFI, (0, _typeof3.default)(this.searchFI));
	
	            var searchApi = ("https://beta-yeti-api.automatad.com/") + 'v1/search-adspot/domain/' + this.domId + '/?query=' + this.searchFI + '&&page=1&&offset=' + this.offset + '&&isId=1';
	            _axios2.default.get(searchApi).then(function (response) {
	                for (var i = 0; i < response.data.data.length; i++) {
	                    response.data.data[i].isbucketused = _this2.checkIsBucketUsed(response.data.data[i]);
	                }
	                _this2.existingAdSpots = response.data.data;
	                _this2.total_pages = response.data.total;
	                console.log('total_pages', _this2.total_pages);
	                _this2.loading = false;
	            });
	        },
	        loadAdspotDataByCurrentPage: function loadAdspotDataByCurrentPage(pageNum) {
	            var _this3 = this;
	
	            console.log('pagenum', pageNum);
	            this.loading = true;
	            var cancelToken = _axios2.default.CancelToken;
	            if (this.cancelRequest) this.cancelRequest.cancel('Operation canceled by the user.');
	            this.cancelRequest = cancelToken.source();
	            this.existingAdSpots = [];
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/setup-fi-adspots/?page=' + pageNum + '&&offset=' + this.offset, {
	                cancelToken: this.cancelRequest.token
	            }).then(function (res) {
	                console.log('data', res.data);
	                for (var i = 0; i < res.data.data.length; i++) {
	                    res.data.data[i].isbucketused = _this3.checkIsBucketUsed(res.data.data[i]);
	                }
	                _this3.existingAdSpots = res.data.data;
	                _this3.total_pages = res.data.total;
	                _this3.loading = false;
	            }).catch(function (err) {
	                if (_axios2.default.isCancel(err)) {
	                    console.log('First Request canceled', err.message);
	                } else {
	                    console.log('error', err);
	                }
	            }).finally(function () {});
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            console.log('Current page', val);
	            this.currentPage = val;
	            if (this.issearch) {
	                this.filterFirstImpressionTagAssociations();
	            } else {
	                this.loadAdspotDataByCurrentPage(val);
	            }
	        },
	        handleSizeChange: function handleSizeChange(val) {
	            console.log('Size changed: ', val);
	            this.offset = val;
	            this.loadAdspotDataByCurrentPage(1);
	            this.currentPage = 1;
	        },
	        deleteFirstImpression: function deleteFirstImpression(adspot) {
	            var _this4 = this;
	
	            this.$confirm('This will permanently delete Adspot. Continue?', 'Warning', {
	                confirmButtonText: 'OK',
	                cancelButtonText: 'Cancel',
	                type: 'warning'
	            }).then(function () {
	                _this4.$message({
	                    type: 'success',
	                    message: 'Ad spot Deleted',
	                    action: _this4.deleteLogicForFirstImpressionadspot(adspot)
	                });
	            }).catch(function () {
	                _this4.$message({
	                    type: 'info',
	                    message: 'Delete canceled'
	                });
	            });
	        },
	        deleteLogicForFirstImpressionadspot: function deleteLogicForFirstImpressionadspot(adspot) {
	            var _this5 = this;
	
	            var api = ("https://beta-yeti-api.automatad.com/") + ('v1/delete-adspot/' + adspot.id + '/');
	
	            console.log('adspot', adspot);
	            var x = {
	                status: false
	            };
	            _axios2.default.post(api, x).then(function (res) {
	                console.log('res', res);
	                console.log('type', (0, _typeof3.default)(_this5.existingAdSpots));
	                console.log('type', _this5.existingAdSpots.length);
	
	                var index = _this5.existingAdSpots.indexOf(adspot);
	                console.log('this.existingAdSpots.indexOf(adspot) delee', _this5.existingAdSpots.indexOf(adspot));
	
	                _this5.existingAdSpots.splice(index, 1);
	
	                console.log('index dele', _this5.existingAdSpots);
	            });
	        },
	        changeValue: function changeValue(label) {
	            console.log('label', label);
	        },
	        clearForm: function clearForm() {
	            this.formData = JSON.parse((0, _stringify2.default)(this.copyFormData));
	            this.devicegroup = 'all';
	        },
	        getAdTypeName: function getAdTypeName(fi_ad_type_id) {
	            var i = 0;
	            for (; i < this.fiAdTypes.length; i++) {
	                if (this.fiAdTypes[i].id == fi_ad_type_id) return this.fiAdTypes[i].name;
	            }return '-';
	        },
	        checkifMoreCssPresent: function checkifMoreCssPresent(ad_unit_data) {
	            ad_unit_data = JSON.parse(ad_unit_data);
	            return ad_unit_data.mcss && ad_unit_data.mcss !== '';
	        },
	        layoutTagRemoved: function layoutTagRemoved(data) {
	            var _this6 = this;
	
	            this.formData.keyValue.forEach(function (val, index, arr) {
	                if (_this6.formData.adspotLayout.indexOf(index) == -1) {
	                    arr[index] = '';
	                }
	            });
	        },
	        selectLayout: function selectLayout(adspot) {
	            this.selectLayoutEdit(adspot);
	            if (adspot) for (var i = 0; i < adspot.associations.length; i++) {
	                this.formData.keyValue[adspot.associations[i].layout.id] = undefined;
	            }
	        },
	        selectLayoutEdit: function selectLayoutEdit(adspot) {
	            var tempArray = [];
	            for (var i = 0; i < this.formData.adspotLayout.length; i++) {
	                for (var j = 0; j < this.existingLayouts.length; j++) {
	                    if (this.formData.adspotLayout[i] == this.existingLayouts[j].id) {
	                        tempArray.push(JSON.parse((0, _stringify2.default)(this.existingLayouts[j])));
	                        if (!adspot) this.formData.keyValue[this.formData.adspotLayout[i]] = '';
	                        break;
	                    }
	                }
	            }this.formData.selectedLayouts = tempArray;
	        },
	        disableCheck: function disableCheck(data) {
	            var allLayoutVal = false;
	            var formData = data;
	            var k = data.keyValue.filter(function (t, index) {
	                return data.adspotLayout.indexOf(index) != -1;
	            });
	
	            k.map(function (y) {
	                if (typeof y == 'number') {
	                    allLayoutVal = true;
	                }
	            });
	            k.map(function (y) {
	                if (typeof y != 'number' || k.length != data.adspotLayout.length) {
	                    allLayoutVal = true;
	                }
	            });
	
	            if (formData.existing && (!formData.aliasName || !formData.udivid || formData.adspotLayout.length == 0) || !formData.fiAdType && formData.adspotLayout.length == 0 || !formData.aliasName) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        getAdFormatFields: function getAdFormatFields(adspot) {
	            var adTypeFields = {};
	            console.log('fiaddtypes', this.fiAdTypes);
	            for (var i = 0; i < this.fiAdTypes.length; i++) {
	                if (this.fiAdTypes[i].id == this.formData.fiAdType) {
	                    adTypeFields = this.fiAdTypes[i];
	                    break;
	                }
	            }if (adTypeFields && adTypeFields.data_fields) {
	                var fields = JSON.parse(adTypeFields.data_fields);
	                if (!this.formData.editId) {
	                    var tempObject = {};
	                    for (var _i = 0; _i < fields.length; _i++) {
	                        if (fields[_i].type != 'checkbox' && fields[_i].type != 'radio') tempObject[fields[_i].name] = fields[_i].value;else {
	                            if (fields[_i].type == 'checkbox') {
	                                if (fields[_i].value === undefined || !fields[_i].value) tempObject[fields[_i].name] = false;else tempObject[fields[_i].name] = true;
	                            } else tempObject[fields[_i].name] = fields[_i].value;
	                        }
	                    }this.formData.adTypeData = tempObject;
	                } else if (adspot && adspot.ad_unit_data) this.formData.adTypeData = JSON.parse(adspot.ad_unit_data);
	
	                this.adFormatFields = fields;
	
	                if (adTypeFields.name == 'Header') {
	                    this.isHeader = true;
	                }
	            }
	        },
	        tableRowClassName: function tableRowClassName() {
	            jQuery('#assoc-table').find('.warning-row').removeClass('warning-row');
	            if (this.formData.index > -1) jQuery('#assoc-table').find('table>tbody').find('tr').eq(this.formData.index).addClass('warning-row');
	        },
	        editFirstImpression: function editFirstImpression(adspot) {
	            console.log('editimpression');
	            console.log('adspot', adspot);
	            this.formData.aliasName = adspot.alias_name;
	            this.formData.index = this.existingAdSpots.indexOf(adspot);
	            console.log('this.existingAdSpots.indexOf(adspot)', this.existingAdSpots.indexOf(adspot));
	            console.log('index', this.formData.index);
	            this.formData.editId = adspot.id;
	            this.formData.existing = adspot.is_existing;
	            this.formData.udivid = adspot.unique_id;
	            this.formData.selector = adspot.selector;
	            this.formData.fiAdType = adspot.fi_ad_type;
	            this.formData.defineSlot = adspot.define_slot;
	
	            this.formData.adspotLayout = [];
	
	            for (var i = 0; i < adspot.associations.length; i++) {
	                this.formData.adspotLayout.push(adspot.associations[i].layout.id);
	                console.log('adspot.associations[i].ad_spot.device:=', adspot.associations[i].ad_spot.device);
	                this.devicegroup = adspot.associations[i].ad_spot.device;
	            }
	            console.log('devicegroup:=', this.devicegroup);
	            this.selectLayout(adspot);
	            this.getAdFormatFields(adspot);
	            this.tableRowClassName();
	        },
	        saveAdSpots: function saveAdSpots() {
	            var _this7 = this;
	
	            var layoutKeyValueMap = {};
	            var p = this.formData.keyValue;
	            for (var key in p) {
	                if (p.hasOwnProperty(key)) {
	                    layoutKeyValueMap[key] = p[key];
	                }
	            }
	
	            if (this.isHeader == true) {
	                this.formData.adTypeData['vanish_req'] = false;
	                if (this.formData.adTypeData['vanish']) {
	                    this.formData.adTypeData['vanish_req'] = true;
	                }
	
	                this.formData.adTypeData['Off_req'] = false;
	                if (this.formData.adTypeData['offTime']) {
	                    this.formData.adTypeData['Off_req'] = true;
	                }
	
	                this.formData.adTypeData['lazyLoad'] = false;
	                if (this.formData.adTypeData['lazyElm']) {
	                    this.formData.adTypeData['lazyLoad'] = true;
	                }
	            }
	
	            var dataObject = {
	                alias_name: this.formData.aliasName,
	                status: true,
	                device: this.devicegroup,
	                define_slot: this.formData.defineSlot,
	                domain: this.domId,
	                id: this.formData.editId,
	                is_existing: this.formData.existing,
	                unique_id: this.formData.existing ? this.formData.udivid : this.divIdPrefix + Math.round(new Date().getTime() / 1000) + '-' + Math.floor(Math.random() * 1000) + 1,
	                selector: this.formData.selector ? this.formData.selector : 'n/a',
	                fi_ad_type: this.formData.fiAdType ? this.formData.fiAdType : undefined,
	                ad_unit_data: (0, _stringify2.default)(this.formData.adTypeData),
	                layouts: this.formData.adspotLayout,
	
	                keys: layoutKeyValueMap
	            };
	
	            console.log(dataObject);
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/setup-fi-adspots/', dataObject).then(function (response) {
	                if (_this7.formData.editId) {
	                    _this7.existingAdSpots[_this7.formData.index].alias_name = dataObject.alias_name;
	                    _this7.existingAdSpots[_this7.formData.index].unique_id = dataObject.unique_id;
	                    _this7.existingAdSpots[_this7.formData.index].is_existing = dataObject.is_existing;
	                    _this7.existingAdSpots[_this7.formData.index].selector = dataObject.selector;
	                    _this7.existingAdSpots[_this7.formData.index].ad_unit_data = response.data.data.ad_unit_data;
	                    _this7.existingAdSpots[_this7.formData.index].define_slot = dataObject.define_slot;
	                    _this7.existingAdSpots[_this7.formData.index].associations = response.data.associations;
	                    _this7.existingAdSpots[_this7.formData.index].fi_ad_type = response.data.data.fi_ad_type;
	                    _this7.existingAdSpots[_this7.formData.index].device = response.data.data.device;
	                } else {
	                    _this7.existingAdSpots.push({
	                        alias_name: dataObject.alias_name,
	                        unique_id: dataObject.unique_id,
	                        is_existing: dataObject.is_existing,
	                        selector: dataObject.selector,
	                        id: response.data.data.id,
	                        ad_unit_data: response.data.data.ad_unit_data,
	                        fi_ad_type: response.data.data.fi_ad_type,
	                        define_slot: dataObject.define_slot,
	                        associations: response.data.associations,
	                        device: response.data.data.device
	                    });
	                }
	                _this7.$notify({
	                    title: 'Success',
	                    message: 'Ad-spot has been ' + (_this7.formData.editId ? 'created' : 'updated') + ' successfully.',
	                    type: 'success'
	                });
	                _this7.clearForm();
	                _this7.tableRowClassName();
	            });
	        },
	        OpenAdSpotUsage: function OpenAdSpotUsage(command) {
	            var _this8 = this;
	
	            console.log('command', command);
	            setTimeout(function () {
	                var url = '/admin/publisher/' + _this8.uuid + '/domain/' + _this8.domId + '/buckets/' + command.bucket_id + '/fi/?adSpotId=' + command.id;
	                console.log('command url', url);
	                _this8.$router.push(url);
	            });
	        },
	        isUsed: function isUsed(adspot_id, bucket_id) {
	            var adspot = this.existingAdSpots.find(function (adspot) {
	                return adspot.id == adspot_id;
	            }),
	                used_bucket_ids = [];
	            if (adspot['associations'].length > 0) {
	                adspot['associations'].forEach(function (association) {
	                    association['fi_layout_bucket_associations'].forEach(function (fiBucketAsso) {
	                        if (!used_bucket_ids.includes(fiBucketAsso.bucket_id)) used_bucket_ids.push(fiBucketAsso.bucket_id);
	                    });
	                });
	
	                console.log('used_bucketids', used_bucket_ids);
	                return used_bucket_ids.includes(bucket_id);
	            } else return false;
	        },
	        createJs: function createJs(bucket_id) {
	            var _this9 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/cdn_push/', {
	                bucketId: bucket_id
	            }).then(function (response) {
	                var type = 'Error',
	                    message = 'Oops Something went wrong!';
	                if (response.data.response_data.status) {
	                    type = 'Success';
	                    message = response.data.response_data.message;
	                } else {
	                    type = 'Error';
	                    message = response.data.response_data.message;
	                }
	                _this9.$notify({
	                    title: type,
	                    message: message,
	                    type: type.toLowerCase()
	                });
	            });
	        },
	        checkboxChange: function checkboxChange(adspot) {
	            console.log(adspot);
	
	            var vm = this;
	            setTimeout(function () {
	                if (adspot.checked == true) {
	                    vm.cArr.push(adspot);
	                } else if (adspot.checked == false) {
	                    vm.cArr.splice(vm.cArr.indexOf(adspot), 1);
	                }
	                console.log(vm.cArr);
	            }, 300);
	        },
	        deleteSelectedFirstImpressions: function deleteSelectedFirstImpressions() {
	            var _this10 = this;
	
	            var vm = this;
	            var selectedAdspots = [];
	            vm.cArr.forEach(function (adspot) {
	                selectedAdspots.push(adspot);
	            });
	            console.log(selectedAdspots);
	
	            var apiArr = [];
	            var x = {
	                status: false
	            };
	            for (var i = 0; i < selectedAdspots.length; i++) {
	                apiArr.push(("https://beta-yeti-api.automatad.com/") + ('v1/delete-adspot/' + selectedAdspots[i].id + '/'));
	            }
	            this.$confirm('Are you sure you want to delete the selected adspots?', 'Warning', {
	                confirmButtonText: 'Yes',
	                cancelButtonText: 'No',
	                type: 'warning'
	            }).then(function () {
	                _axios2.default.all(apiArr.map(function (api) {
	                    return _axios2.default.post(api, x);
	                })).then(function (data) {
	                    console.log(data);
	                    _this10.existingAdSpots = _this10.existingAdSpots.filter(function (adspot) {
	                        return !selectedAdspots.includes(adspot);
	                    });
	                    console.log(_this10.existingAdSpots);
	                    vm.$notify({
	                        title: 'Success',
	                        message: 'Ad-spots has been deleted successfully.',
	                        type: 'success'
	                    });
	                }).catch(function () {
	                    vm.$notify({
	                        title: 'Cancelled',
	                        message: 'Delete has been cancelled.',
	                        type: 'info'
	                    });
	                });
	            }).catch(function () {
	                vm.$notify({
	                    title: 'Cancelled',
	                    message: 'Action has been cancelled.',
	                    type: 'info'
	                });
	            });
	        },
	        deleteallTagsonBucket: function deleteallTagsonBucket(event, bucket_id, adSpotId) {
	            var _this11 = this;
	
	            var vm = this;
	            var allAssociations = [];
	            var association_ids = [];
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + bucket_id + '/adspot-tag-association/').then(function (response) {
	                allAssociations = response.data.data.filter(function (assoc) {
	                    return assoc.layout.ad_spot.id == adSpotId;
	                });
	                allAssociations.forEach(function (association) {
	                    association_ids.push(association.id);
	                });
	                console.log('association_ids', association_ids);
	            });
	            console.log('association_ids', association_ids);
	
	            this.$confirm('Are you sure you want to delete all tag associations made using this ad spot in this bucket?', 'Warning', {
	                confirmButtonText: 'Yes',
	                cancelButtonText: 'No',
	                type: 'warning'
	            }).then(function () {
	                _axios2.default.all(association_ids.map(function (association_id) {
	                    return _axios2.default.delete(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + _this11.uuid + '/domains/' + _this11.domId + '/buckets/' + bucket_id + '/adspot-tag-association/?assoc_id=' + association_id);
	                })).then(function (data) {
	                    console.log(data);
	                    vm.$notify({
	                        title: 'Success',
	                        message: 'All tag associations deleted successfully',
	                        type: 'success'
	                    });
	                    _this11.loadAdspotDataByCurrentPage(_this11.currentPage);
	                }).catch(function () {
	                    vm.$notify({
	                        title: 'Cancelled',
	                        message: 'Delete has been cancelled.',
	                        type: 'info'
	                    });
	                });
	            }).catch(function () {
	                vm.$notify({
	                    title: 'Cancelled',
	                    message: 'Action has been cancelled.',
	                    type: 'info'
	                });
	            }), event.stopPropagation();
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _getIterator2 = __webpack_require__(52);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(383);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(388);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(392);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(390);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UniqueNameSet = function (_Set) {
	    (0, _inherits3.default)(UniqueNameSet, _Set);
	
	    function UniqueNameSet(values) {
	        var uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        (0, _classCallCheck3.default)(this, UniqueNameSet);
	
	        var _this2 = (0, _possibleConstructorReturn3.default)(this, (UniqueNameSet.__proto__ || (0, _getPrototypeOf2.default)(UniqueNameSet)).call(this, values));
	
	        var ids = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(_this2), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var value = _step.value;
	
	                var uniqueCheck = !uniqueId ? value.id : value['fi_ad_type'];
	                if (ids.includes(uniqueCheck)) {
	                    _this2.delete(value);
	                } else {
	                    ids.push(uniqueCheck);
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return _this2;
	    }
	
	    return UniqueNameSet;
	}(_set2.default);
	
	exports.default = {
	    data: function data() {
	        return {
	            mapAdSpotIdtoFakeIds: {},
	            module: 'fi',
	            uuid: undefined,
	            domId: undefined,
	            bucketId: undefined,
	            credentialId: undefined,
	            fiAdTypes: [],
	            associatedAdSpots: [],
	            allAssociatedAdSpots: [],
	            allAdSpotsWithLayouts: [],
	            allIndividualAdspots: [],
	            allIndividualLayouts: [],
	            allIndividualHBAdUnits: [],
	            dfpAdUnits: [],
	            hbAdUnits: [],
	            allHbAdUnits: [],
	            importBuckets: [],
	            selectedBucketData: {},
	            importedData: false,
	            randomNumber: 0,
	            formData: {
	                index: -1,
	                id: undefined,
	                layout: undefined,
	                hbEnabled: true,
	                is_live: false,
	                dfpAdUnit: undefined,
	                hbAdUnit: undefined,
	                dimensions: [],
	                checkedDimensions: [],
	                availableDimensions: []
	            },
	            cancelRequestMethod: null,
	            filterData: {
	                adSpotId: [],
	                adLayout: [],
	                adIsLive: null,
	                adDfpAdUnit: [],
	                adHbAdUnit: [],
	                adDimensions: []
	            },
	            dropdownLoading: {
	                adSpot: true,
	                adLayout: true,
	                adHbAdUnit: true
	            },
	            fakeAdSpotId: [],
	            loading: true,
	            searchingAdUnit: false,
	            totalPages: 0,
	            currentPage: 1,
	            offset: 20,
	            formLoadingDone: false,
	            searchFI: '',
	            domain_details: undefined,
	            filteredAssociatedAdSpots: []
	        };
	    },
	
	    computed: {
	        computedAdspot: function computedAdspot() {
	            return this.filterData.adSpotId;
	        }
	    },
	    created: function created() {
	        this.uuid = this.$route.params.uuid;
	        this.domId = this.$route.params.domId;
	        this.bucketId = this.$route.params.bucketId;
	        this.copyFormData = JSON.parse((0, _stringify2.default)(this.formData));
	        this.loadAdDimensions();
	        this.loadAllAdspots();
	        this.loadAllLayouts();
	        this.loadAllHBAdunits();
	        this.loadAllData();
	    },
	    watch: {
	        filterData: {
	            handler: function handler(newVal, oldVal) {
	                this.getAdspotTagAssociation();
	            },
	
	            deep: true
	        },
	        computedAdspot: {
	            handler: function handler() {
	                var _this3 = this;
	
	                this.fakeAdSpotId = [];
	                var addedTypes = [];
	
	                var _loop = function _loop(index) {
	                    var currAdSpot = _this3.allIndividualAdspots.filter(function (temp) {
	                        return !temp.is_existing && temp.id == _this3.filterData.adSpotId[index];
	                    });
	                    if (currAdSpot.length) {
	                        currAdSpot = currAdSpot[0];
	                        if (!currAdSpot.is_existing) {
	                            if (!addedTypes.includes(currAdSpot.fi_ad_type)) {
	                                _this3.fakeAdSpotId.push(_this3.mapAdSpotIdtoFakeIds[_this3.filterData.adSpotId[index]]);
	                                addedTypes.push(currAdSpot.fi_ad_type);
	                            }
	                        }
	                    } else _this3.fakeAdSpotId.push(_this3.filterData.adSpotId[index]);
	                };
	
	                for (var index in this.filterData.adSpotId) {
	                    _loop(index);
	                }
	            }
	        }
	    },
	    methods: {
	        loadAllAdspots: function loadAllAdspots() {
	            var _this4 = this;
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/setup-fi-adspots/').then(function (response) {
	                _this4.allIndividualAdspots = response.data.data;
	                _this4.dropdownLoading.adSpot = false;
	            });
	        },
	        loadAllLayouts: function loadAllLayouts() {
	            var _this5 = this;
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/page-layouts/').then(function (response) {
	                _this5.allIndividualLayouts = response.data;
	                _this5.dropdownLoading.adLayout = false;
	            });
	        },
	        loadAllHBAdunits: function loadAllHBAdunits() {
	            var _this6 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_bucket_hb_units/', {
	                bucketId: this.$route.params.bucketId
	            }).then(function (response) {
	                _this6.allIndividualHBAdUnits = response.data.data;
	                _this6.dropdownLoading.adHbAdUnit = false;
	            });
	        },
	        loadAllData: function loadAllData() {
	            var _this7 = this;
	
	            _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/publishers/' + this.uuid + '/domains/' + this.domId + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domain/' + this.domId + '/dfp-credentials/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/buckets/' + this.bucketId + '/las/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/adspot-tag-association/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-all-fi-ad-types/'), _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/get_bucket_config_list/', {
	                bucketId: this.bucketId,
	                module: this.module
	            })]).then(_axios2.default.spread(function (domain, creadentialId, las, associatedSpots, fi_ad_types, bucketModules) {
	                _this7.domain_details = domain.data;
	                _this7.credentialId = creadentialId.data.id;
	                _this7.allAdSpotsWithLayouts = las.data;
	
	                _this7.associatedAdSpots = associatedSpots.data.data;
	                _this7.allAssociatedAdSpots = _this7.allAssociatedAdSpots.concat(associatedSpots.data.data);
	                _this7.allAdSpotsWithLayouts.forEach(function (adSpotWithLayout) {
	                    if (_this7.alreadyAssociated(adSpotWithLayout)) {
	                        adSpotWithLayout.alreadyAssociated = true;
	                    } else {
	                        adSpotWithLayout.alreadyAssociated = false;
	                    }
	                });
	
	                _this7.totalPages = associatedSpots.data.metadata.count;
	                _this7.fiAdTypes = fi_ad_types.data;
	                _this7.importBuckets = bucketModules.data.response_data.bucket_list;
	
	                var query = _this7.$route.query;
	                var tempFilterData = {};
	                tempFilterData['adIsLive'] = query['adIsLive'] ? query['adIsLive'] == 'true' : null;
	                var _arr = ['adLayout', 'adSpotId', 'adHbAdUnit', 'adDimensions'];
	                for (var _i = 0; _i < _arr.length; _i++) {
	                    var filterType = _arr[_i];
	                    tempFilterData[filterType] = query[filterType] ? query[filterType].split(',').map(function (x) {
	                        return parseInt(x);
	                    }) : [];
	                }
	                _this7.getUniqueOrAdFormat();
	                _this7.filterData.adSpotId = tempFilterData.adSpotId;
	                _this7.filterData = (0, _assign2.default)({}, tempFilterData);
	                _this7.formLoadingDone = true;
	                _this7.loading = false;
	            }));
	        },
	        getAdunitPath2: function getAdunitPath2(k) {
	            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
	            var domainParentCode = this.domain_details.parent_ad_unit_code;
	            this.domainMcmEnabled = this.domain_details.mcm_enable;
	            var domainMcmType = this.domain_details.mcm ? this.domain_details.mcm.account_type : this.domain_details.mcm;
	            var domainMcmChild = this.domain_details.child_dfp_network ? this.domain_details.child_dfp_network.child_network_code : this.domain_details.child_dfp_network;
	            var hbAccountType = k.mcm_account_switch;
	            var hbOverridenChildNetwork = k.child_network_override;
	            var adunitCode = k.dfp_ad_unit_code;
	            var hbNetworkOverride = k.network_override;
	            var isPubUnit = k.publisher_dfp_unit;
	            var ishbNtwrkOverriden = k.network_override == null ? false : true;
	            var current_dfp_network = k.current_dfp_network;
	
	            if (k.mcm_account_switch == null) {
	                domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	            } else {
	                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
	                    domainParentCode = k.dfp_parent_ad_unit_path;
	                } else {
	                    if (k.dfp_parent_ad_unit_path != 0) {
	                        domainParentCode = k.dfp_parent_ad_unit_path;
	                    } else {
	                        domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	                    }
	                }
	            }
	
	            if (isPubUnit == true) {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + adunitCode;
	                    } else {
	
	                        return current_dfp_network + ',' + hbOverridenChildNetwork + '/' + adunitCode;
	                    }
	                } else {
	                    if (ishbNtwrkOverriden == true) {
	                        return hbNetworkOverride + '/' + adunitCode;
	                    } else if (current_dfp_network) {
	                        return current_dfp_network + '/' + adunitCode;
	                    } else {
	                        if (this.domainMcmEnabled) {
	                            if (domainMcmType == 'MANAGE_ACCOUNT') {
	                                return domainMcmChild + '/' + adunitCode;
	                            } else {
	                                return domainNetowrkCode + ',' + domainMcmChild + '/' + adunitCode;
	                            }
	                        } else {
	                            return domainNetowrkCode + '/' + adunitCode;
	                        }
	                    }
	                }
	            } else {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    } else {
	                        return domainNetowrkCode + ',' + hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                } else if (current_dfp_network) {
	                    return current_dfp_network + '/' + domainParentCode + '/' + adunitCode;
	                } else {
	                    if (this.domainMcmEnabled) {
	                        if (domainMcmType == 'MANAGE_ACCOUNT') {
	                            return domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        } else {
	                            return domainNetowrkCode + ',' + domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        }
	                    } else {
	                        return domainNetowrkCode + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                }
	            }
	
	            return adunitCode;
	        },
	        getAdunitPath: function getAdunitPath(k) {
	            var hbAmp = k.is_amp;
	            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
	            var domainParentCode = '';
	            if (k.mcm_account_switch == null) {
	                domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	            } else {
	                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
	                    domainParentCode = k.dfp_parent_ad_unit_path;
	                } else {
	                    if (k.dfp_parent_ad_unit_path != 0) {
	                        domainParentCode = k.dfp_parent_ad_unit_path;
	                    } else {
	                        domainParentCode = hbAmp == false ? this.domain_details.parent_ad_unit_code : this.domain_details.amp_parent_ad_unit_code;
	                    }
	                }
	            }
	
	            this.domainMcmEnabled = this.domain_details.mcm_enable;
	            var domainMcmType = this.domain_details.mcm ? this.domain_details.mcm.account_type : this.domain_details.mcm;
	            var domainMcmChild = this.domain_details.child_dfp_network ? this.domain_details.child_dfp_network.child_network_code : this.domain_details.child_dfp_network;
	            var hbAccountType = k.mcm_account_switch;
	            var hbOverridenChildNetwork = k.child_network_override;
	            var adunitCode = k.dfp_ad_unit_code;
	            var hbNetworkOverride = k.network_override;
	            var isPubUnit = k.publisher_dfp_unit;
	            var ishbNtwrkOverriden = k.network_override == null ? false : true;
	            var current_dfp_network = k.current_dfp_network;
	
	            if (isPubUnit == true) {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + adunitCode;
	                    } else {
	                        return current_dfp_network + ',' + hbOverridenChildNetwork + '/' + adunitCode;
	                    }
	                } else {
	                    if (ishbNtwrkOverriden == true || hbAmp) {
	                        return (hbNetworkOverride ? hbNetworkOverride : current_dfp_network) + '/' + adunitCode;
	                    } else if (current_dfp_network) {
	                        return current_dfp_network + '/' + adunitCode;
	                    } else {
	                        if (this.domainMcmEnabled) {
	                            if (domainMcmType == 'MANAGE_ACCOUNT') {
	                                return domainMcmChild + '/' + adunitCode;
	                            } else {
	                                return domainNetowrkCode + ',' + domainMcmChild + '/' + adunitCode;
	                            }
	                        } else {
	                            return domainNetowrkCode + '/' + adunitCode;
	                        }
	                    }
	                }
	            } else {
	                if (hbAccountType) {
	                    if (hbAccountType == 'MANAGE_ACCOUNT') {
	                        return hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    } else {
	                        return current_dfp_network + ',' + hbOverridenChildNetwork + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                }
	                if (ishbNtwrkOverriden == true || hbAmp) {
	                    return (hbNetworkOverride ? hbNetworkOverride : domainNetowrkCode) + '/' + domainParentCode + '/' + adunitCode;
	                } else if (current_dfp_network) {
	                    return current_dfp_network + '/' + domainParentCode + '/' + adunitCode;
	                } else {
	                    if (this.domainMcmEnabled) {
	                        if (domainMcmType == 'MANAGE_ACCOUNT') {
	                            return domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        } else {
	                            return domainNetowrkCode + ',' + domainMcmChild + '/' + domainParentCode + '/' + adunitCode;
	                        }
	                    } else {
	                        return domainNetowrkCode + '/' + domainParentCode + '/' + adunitCode;
	                    }
	                }
	            }
	
	            return adunitCode;
	        },
	        getAllAssociatedAdSpots: function getAllAssociatedAdSpots() {
	            var _this8 = this;
	
	            this.loading = true;
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/adspot-tag-association/').then(function (associatedSpots) {
	                _this8.allAssociatedAdSpots = _this8.allAssociatedAdSpots.concat(associatedSpots.data.data);
	                _this8.allAdSpotsWithLayouts.forEach(function (adSpotWithLayout) {
	                    if (_this8.alreadyAssociated(adSpotWithLayout)) {
	                        adSpotWithLayout.alreadyAssociated = true;
	                    } else {
	                        adSpotWithLayout.alreadyAssociated = false;
	                    }
	                });
	                _this8.formLoadingDone = true;
	                _this8.loading = false;
	            });
	        },
	        getAdspotTagAssociation: function getAdspotTagAssociation() {
	            var _this9 = this;
	
	            var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	            this.associatedAdSpots = [];
	            this.loading = true;
	            var temp = [];
	            var mapper = {
	                adLayout: 'layout',
	                adSpotId: 'adspot',
	                adIsLive: 'is_live',
	                adHbAdUnit: 'hb_id',
	                adDimensions: 'dimension_list'
	            };
	            var queryData = {};
	            for (var item in mapper) {
	                if (Array.isArray(this.filterData[item]) && this.filterData[item].length == 0) {
	                    continue;
	                }
	                if (item == 'adIsLive') {
	                    if (this.filterData[item] !== null) {
	                        temp.push(['is_live', this.filterData[item]]);
	                        queryData[item] = this.filterData[item];
	                    }
	                    continue;
	                }
	                if (this.filterData[item]) {
	                    temp.push([mapper[item], this.filterData[item]]);
	                    queryData[item] = this.filterData[item].join(',');
	                }
	            }
	            this.$router.replace({ query: queryData });
	
	            var params = new URLSearchParams(temp);
	
	            if (this.cancelRequestMethod !== null) {
	                this.cancelRequestMethod();
	            }
	            var axiosSource = _axios2.default.CancelToken.source();
	            this.cancelRequestMethod = axiosSource.cancel;
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/adspot-tag-association/?page=' + pageNum + '&offset=' + this.offset, {
	                params: params,
	                cancelToken: axiosSource.token
	            }).then(function (associatedSpots) {
	                _this9.currentPage = pageNum;
	                _this9.totalPages = associatedSpots.data.metadata.count;
	                _this9.associatedAdSpots = associatedSpots.data.data;
	                _this9.loading = false;
	            }).catch(function (err) {
	                if (_axios2.default.isCancel(err)) {
	                    console.log('request cancelled successfully');
	                } else _this9.loading = false;
	            });
	        },
	        clearFilter: function clearFilter() {
	            this.filterData = {
	                adIsLive: null,
	                adSpotId: [],
	                adLayout: [],
	                adDfpAdUnit: [],
	                adHbAdUnit: [],
	                adDimensions: []
	            };
	            this.getAdspotTagAssociation();
	        },
	        tableRowClassName: function tableRowClassName() {
	            jQuery('#assoc-table').find('.warning-row').removeClass('warning-row');
	            if (this.formData.index > -1) jQuery('#assoc-table').find('table>tbody').find('tr').eq(this.formData.index).addClass('warning-row');
	        },
	        editAdSpotTagAssoc: function editAdSpotTagAssoc(asta) {
	            var _this10 = this;
	
	            console.log('editAdSpotTagAssoc');
	            this.loading = true;
	            var index = -1;
	            for (var i = 0; i < this.associatedAdSpots.length; i++) {
	                if (this.associatedAdSpots[i].id == asta.id) {
	                    index = i;
	                    break;
	                }
	            }if (this.importedData) {
	                this.$notify({
	                    title: 'Error',
	                    message: 'Not possible!! Save the imported data to edit data.',
	                    type: 'error'
	                });
	                return;
	            }
	            var _this = this;
	            this.formData.index = index;
	            this.formData.id = asta.id;
	            this.formData.layout = [asta.layout.id];
	            this.formData.hbEnabled = asta.is_hb;
	            this.formData.checkedDimensions = [];
	            this.formData.is_live = asta.is_live;
	
	            if (this.formData.hbEnabled) this.getHbAdunits(asta.hb_id.dfp_ad_unit_code, function () {
	                _this.formData.hbAdUnit = asta.hb_id.id;
	                var dimensions = asta.hb_id.dimensions;
	                _this10.formData.availableDimensions = dimensions;
	                for (var _i2 = 0; _i2 < dimensions.length; _i2++) {
	                    if (_this10.isChecked(_this10.formData.index, dimensions[_i2].id)) _this10.formData.checkedDimensions.push(dimensions[_i2].id);
	                }
	                _this10.loading = false;
	            });else this.getDfpAdunits(asta.dfp_id.ad_unit_name, function () {
	                _this.formData.dfpAdUnit = asta.dfp_id.id;
	                var dimensions = asta.dfp_id.ad_unit_size;
	                _this10.formData.availableDimensions = dimensions;
	                for (var _i3 = 0; _i3 < dimensions.length; _i3++) {
	                    if (_this10.isChecked(_this10.formData.index, dimensions[_i3].id)) _this10.formData.checkedDimensions.push(dimensions[_i3].id);
	                }
	                _this10.loading = false;
	            });
	            this.tableRowClassName();
	
	            var element = this.$refs['create-edit-block'];
	            element && element.scrollIntoView({ behavior: 'smooth' });
	        },
	        deleteAdSpotTagAssoc: function deleteAdSpotTagAssoc(asta) {
	            var _this11 = this;
	
	            if (this.importedData) {
	                this.$notify({
	                    title: 'Error',
	                    message: 'Not possible!! Save the imported data to delete data.',
	                    type: 'error'
	                });
	                return;
	            }
	
	            var index = this.associatedAdSpots.indexOf(asta);
	            this.$confirm('Are you sure to delete this association?', 'Warning', {
	                confirmButtonText: 'Yes',
	                cancelButtonText: 'No',
	                type: 'warning'
	            }).then(function () {
	                _axios2.default.delete(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + _this11.uuid + '/domains/' + _this11.domId + '/buckets/' + _this11.bucketId + '/adspot-tag-association/?assoc_id=' + asta.id, {}).then(function (response) {
	                    if (response.data.status) {
	                        console.log(response);
	                        _this11.associatedAdSpots.splice(index, 1);
	                        _this11.$notify({
	                            title: 'Success',
	                            message: 'Great! Association has been successfully deleted.',
	                            type: 'success'
	                        });
	                        for (var i = 0; i < _this11.allAdSpotsWithLayouts.length; i++) {
	                            if (_this11.allAdSpotsWithLayouts[i].id === asta.layout.id) {
	                                return _this11.allAdSpotsWithLayouts[i].alreadyAssociated = false;
	                            }
	                            console.log('usable', _this11.allAdSpotsWithLayouts);
	                        }
	
	                        _this11.formData = JSON.parse((0, _stringify2.default)(_this11.copyFormData));
	                        _this11.getAllAssociatedAdSpots(1);
	                        _this11.loadAllData();
	                        _this11.randomNumber = Math.random();
	                        _this11.$forceUpdate();
	                    }
	                });
	            }).catch(function () {
	                _this11.$notify({
	                    title: 'Error',
	                    message: 'Adspot Delete Canceled',
	                    type: 'error'
	                });
	            });
	        },
	        layoutTagAssociation: function layoutTagAssociation() {
	            var _this12 = this;
	
	            for (var i = 0; i < this.formData.layout.length; i++) {
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/adspot-tag-association/', {
	                    id: this.formData.id,
	                    bucket_id: this.bucketId,
	                    layout: this.formData.layout[i],
	                    is_hb: this.formData.hbEnabled,
	                    hb_id: this.formData.hbEnabled ? this.formData.hbAdUnit : undefined,
	                    dfp_id: !this.formData.hbEnabled ? this.formData.dfpAdUnit : undefined,
	                    dimension_ids: this.formData.checkedDimensions,
	                    is_live: this.formData.is_live
	                }).then(function (response) {
	                    if (response.data.status) {
	                        if (_this12.formData.id) {
	                            _this12.associatedAdSpots[_this12.formData.index].is_live = response.data.data.is_live;
	                            _this12.associatedAdSpots[_this12.formData.index].is_hb = response.data.data.is_hb;
	                            _this12.associatedAdSpots[_this12.formData.index].hb_id = response.data.data.hb_id;
	                            _this12.associatedAdSpots[_this12.formData.index].dfp_id = response.data.data.dfp_id;
	                            _this12.associatedAdSpots[_this12.formData.index].dimensions = response.data.data.dimensions;
	                            _this12.associatedAdSpots[_this12.formData.index].floors = response.data.data.floors;
	                        } else _this12.associatedAdSpots.push(response.data.data);
	
	                        var _iteratorNormalCompletion2 = true;
	                        var _didIteratorError2 = false;
	                        var _iteratorError2 = undefined;
	
	                        try {
	                            for (var _iterator2 = (0, _getIterator3.default)(_this12.allAdSpotsWithLayouts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                var adspot = _step2.value;
	
	                                adspot.alreadyAssigned = false;
	                            }
	                        } catch (err) {
	                            _didIteratorError2 = true;
	                            _iteratorError2 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	                            } finally {
	                                if (_didIteratorError2) {
	                                    throw _iteratorError2;
	                                }
	                            }
	                        }
	
	                        console.log('before', _this12.allAdSpotsWithLayouts);
	                        _this12.formData.layout.forEach(function (layout) {
	                            var _iteratorNormalCompletion3 = true;
	                            var _didIteratorError3 = false;
	                            var _iteratorError3 = undefined;
	
	                            try {
	                                for (var _iterator3 = (0, _getIterator3.default)(_this12.allAdSpotsWithLayouts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                    var adspot = _step3.value;
	
	                                    if (adspot.id == layout) {
	                                        adspot.alreadyAssociated = true;
	                                    } else {
	                                        adspot.alreadyAssigned = false;
	                                    }
	                                }
	                            } catch (err) {
	                                _didIteratorError3 = true;
	                                _iteratorError3 = err;
	                            } finally {
	                                try {
	                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                        _iterator3.return();
	                                    }
	                                } finally {
	                                    if (_didIteratorError3) {
	                                        throw _iteratorError3;
	                                    }
	                                }
	                            }
	                        });
	                        console.log('after:', _this12.allAdSpotsWithLayouts[0]);
	                        _this12.randomNumber = Math.random();
	                        _this12.formData = JSON.parse((0, _stringify2.default)(_this12.copyFormData));
	                        _this12.$forceUpdate();
	                        _this12.tableRowClassName();
	                    }
	                });
	            }
	            this.$notify({
	                title: 'Success',
	                message: 'Ad-spot and tag has been successfully associated',
	                type: 'success'
	            });
	        },
	        getDfpAdunits: function getDfpAdunits(query, callback) {
	            var _this13 = this;
	
	            if (query) {
	                this.searchingAdUnit = true;
	                _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/search-ad-unit/' + this.domId + '/?query=' + query)]).then(_axios2.default.spread(function (data) {
	                    _this13.searchingAdUnit = false;
	                    _this13.dfpAdUnits = data.data;
	
	                    if (callback) callback();
	                }));
	            }
	        },
	        getHbAdunits: function getHbAdunits(query, callback) {
	            var _this14 = this;
	
	            if (query) {
	                this.searchingAdUnit = true;
	                _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/search-hb-ad-unit/' + this.domId + '/?query=' + query)]).then(_axios2.default.spread(function (data) {
	                    _this14.searchingAdUnit = false;
	                    _this14.hbAdUnits = data.data;
	
	                    if (callback) callback();
	                }));
	            }
	        },
	        getAdTypeName: function getAdTypeName(fi_ad_type_id) {
	            var i = 0;
	            for (; i < this.fiAdTypes.length; i++) {
	                if (this.fiAdTypes[i].id == fi_ad_type_id) return this.fiAdTypes[i].name;
	            }
	            return '-';
	        },
	        selectedBucket: function selectedBucket(index) {
	            var _this15 = this;
	
	            this.selectedBucketData = this.importBuckets[index];
	            var allPages = 0;
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.selectedBucketData.id + '/adspot-tag-association/?page=' + 1 + '&offset=' + this.offset).then(function (response) {
	                allPages = Math.ceil(response.data.metadata.total / _this15.offset);
	
	                var _loop2 = function _loop2(i) {
	                    _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + _this15.uuid + '/domains/' + _this15.domId + '/buckets/' + _this15.selectedBucketData.id + '/adspot-tag-association/?page=' + (i + 1) + '&offset=' + _this15.offset).then(function (response) {
	                        _this15.importedData = true;
	                        _this15.associatedAdSpots = _this15.associatedAdSpots.concat(response.data.data);
	                        if (i + 1 == allPages) _this15.$notify({
	                            title: 'Success',
	                            message: 'Yass! Import Success! Remember to click save to save the import.',
	                            type: 'success'
	                        });
	                    });
	                };
	
	                for (var i = 0; i < allPages; i++) {
	                    _loop2(i);
	                }
	            });
	        },
	        removeImport: function removeImport(message) {
	            var _this16 = this;
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/adspot-tag-association/?page=1&offset=' + this.offset).then(function (response) {
	                _this16.importedData = false;
	                _this16.associatedAdSpots = response.data.data;
	                _this16.totalPages = response.data.metadata.total;
	                _this16.$notify({
	                    title: 'Success',
	                    message: message ? 'Yay! Data has been successfully imported.' : 'Done! Imported data has been removed.',
	                    type: 'success'
	                });
	            });
	        },
	        saveImportedData: function saveImportedData() {
	            var _this17 = this;
	
	            if (!this.importedData) return;
	
	            var tempArray = [];
	
	            var _loop3 = function _loop3(i) {
	                tempArray.push({
	                    layout: _this17.associatedAdSpots[i].layout.id,
	                    is_hb: _this17.associatedAdSpots[i].is_hb,
	                    hb_id: _this17.associatedAdSpots[i].hb_id.id,
	                    dfp_id: _this17.associatedAdSpots[i].dfp_id.id,
	                    dimensions: _this17.associatedAdSpots[i].dimensions,
	                    is_live: _this17.associatedAdSpots[i].is_live
	                });
	                var adSpotsWithLayout = _this17.allAdSpotsWithLayouts.filter(function (adSpotsWithLayout) {
	                    return adSpotsWithLayout.id == _this17.associatedAdSpots[i].layout.id;
	                })[0];
	                if (adSpotsWithLayout) adSpotsWithLayout.alreadyAssociated = true;
	            };
	
	            for (var i = 0; i < this.associatedAdSpots.length; i++) {
	                _loop3(i);
	            }
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/' + this.bucketId + '/imported-adspot-tag-assoc/', {
	                data: tempArray
	            }).then(function (response) {
	                if (response.data.status) _this17.removeImport(true);
	            });
	        },
	        setUniqueOrAdFormat: function setUniqueOrAdFormat(adSpotId) {
	            var _this18 = this;
	
	            this.fakeAdSpotId = [];
	            this.filterData.adSpotId = [];
	
	            var _loop4 = function _loop4(tempAdId) {
	                var currentAdspotId = adSpotId[tempAdId];
	                var currentAdSpot = _this18.allIndividualAdspots.filter(function (temp) {
	                    return currentAdspotId == temp.id;
	                })[0];
	                if (!currentAdSpot.is_existing) {
	                    var _filterData$adSpotId;
	
	                    (_filterData$adSpotId = _this18.filterData.adSpotId).push.apply(_filterData$adSpotId, (0, _toConsumableArray3.default)(currentAdSpot.id_list));
	                } else _this18.filterData.adSpotId.push(currentAdspotId);
	                _this18.fakeAdSpotId.push(currentAdspotId);
	            };
	
	            for (var tempAdId in adSpotId) {
	                _loop4(tempAdId);
	            }
	        },
	        getLabel: function getLabel(adspot) {
	            return adspot.ad_spot.alias_name + ' - ' + adspot.ad_spot.unique_id + ' - ' + adspot.layout.layout_name;
	        },
	        getUniqueOrAdFormat: function getUniqueOrAdFormat() {
	            var querySet = this.allIndividualAdspots;
	            var existingTypes = [];
	            var typeIdMapping = {};
	            var deleteIndex = [];
	            for (var index in querySet) {
	                index = parseInt(index);
	                if (!querySet[index].is_existing) {
	                    var fiType = querySet[index].fi_ad_type;
	                    if (existingTypes.includes(fiType)) {
	                        deleteIndex.push(index);
	                        querySet[typeIdMapping[fiType]].id_list.push(querySet[index].id);
	                    } else {
	                        existingTypes.push(fiType);
	                        typeIdMapping[fiType] = index;
	                        querySet[index].id_list = [querySet[index].id];
	                    }
	                    this.mapAdSpotIdtoFakeIds[querySet[index].id] = querySet[typeIdMapping[fiType]].id;
	                }
	            }
	            return querySet.filter(function (_, index) {
	                return !deleteIndex.includes(index);
	            });
	        },
	        loadAdDimensions: function loadAdDimensions() {
	            var _this19 = this;
	
	            var apidimension = ("https://beta-yeti-api.automatad.com/") + 'v1/ad-dimensions/';
	
	            _axios2.default.get(apidimension).then(function (response) {
	                _this19.dimensions = response.data;
	            });
	        },
	        alreadyAssociated: function alreadyAssociated(adspot) {
	            for (var i = 0; i < this.allAssociatedAdSpots.length; i++) {
	                if (this.allAssociatedAdSpots[i].layout.id == adspot.id) return true;
	            }
	            return false;
	        },
	        isChecked: function isChecked(adspotassocIndex, dimensionId) {
	            var flag = false;
	            for (var i = 0; i < this.associatedAdSpots[adspotassocIndex].dimensions.length; i++) {
	                if (this.associatedAdSpots[adspotassocIndex].dimensions[i].id == dimensionId) {
	                    flag = true;
	                    break;
	                }
	            }
	            return flag;
	        },
	        adUnitChange: function adUnitChange() {
	            var _this20 = this;
	
	            this.formData.checkedDimensions = [];
	            if (this.formData.hbEnabled) {
	                var hbTag = this.hbAdUnits.filter(function (hbAdUnit) {
	                    if (hbAdUnit.id == _this20.formData.hbAdUnit) return hbAdUnit;
	                })[0];
	                var dimensions = hbTag.dimensions;
	                this.formData.availableDimensions = dimensions;
	                dimensions.forEach(function (dimension) {
	                    _this20.formData.checkedDimensions.push(dimension.id);
	                });
	            } else {
	                var dfpUnit = this.dfpAdUnits.filter(function (dfpAdUnit) {
	                    if (dfpAdUnit.id == _this20.formData.dfpAdUnit) return dfpAdUnit;
	                })[0];
	            }
	        },
	        isDisabled: function isDisabled(dimensionId) {
	            return this.formData.checkedDimensions.length == 1 && this.formData.checkedDimensions.indexOf(dimensionId) > -1;
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            if (this.searchFI == '') this.getAdspotTagAssociation(val);else {
	                this.associatedAdSpots = this.filteredAssociatedAdSpots.slice((val - 1) * 20, val * 20);
	            }
	        },
	        handleSizeChange: function handleSizeChange(val) {
	            this.offset = val;
	            this.getAdspotTagAssociation(1);
	            this.currentPage = 1;
	        },
	        checkDisabled: function checkDisabled() {
	            console.log('adspot', this.formData.layout);
	            console.log('all', this.allAdSpotsWithLayouts);
	            if (this.formData.layout.length <= 0) {
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                    for (var _iterator4 = (0, _getIterator3.default)(this.allAdSpotsWithLayouts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                        var adspot = _step4.value;
	
	                        adspot.alreadyAssigned = false;
	                    }
	                } catch (err) {
	                    _didIteratorError4 = true;
	                    _iteratorError4 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	                    } finally {
	                        if (_didIteratorError4) {
	                            throw _iteratorError4;
	                        }
	                    }
	                }
	            }
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	                for (var _iterator5 = (0, _getIterator3.default)(this.allAdSpotsWithLayouts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    var _adspot = _step5.value;
	
	                    if (_adspot.id == this.formData.layout) {
	                        console.log(_adspot.ad_spot.alias_name);
	                        var alias = _adspot.ad_spot.alias_name;
	                        var _iteratorNormalCompletion6 = true;
	                        var _didIteratorError6 = false;
	                        var _iteratorError6 = undefined;
	
	                        try {
	                            for (var _iterator6 = (0, _getIterator3.default)(this.allAdSpotsWithLayouts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                                var adspot2 = _step6.value;
	
	                                if (alias != adspot2.ad_spot.alias_name) {
	                                    adspot2.alreadyAssigned = true;
	                                }
	                            }
	                        } catch (err) {
	                            _didIteratorError6 = true;
	                            _iteratorError6 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                                    _iterator6.return();
	                                }
	                            } finally {
	                                if (_didIteratorError6) {
	                                    throw _iteratorError6;
	                                }
	                            }
	                        }
	                    }
	                }
	            } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                    }
	                } finally {
	                    if (_didIteratorError5) {
	                        throw _iteratorError5;
	                    }
	                }
	            }
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				uuid: undefined,
				domId: undefined,
				bucketId: undefined,
				credentialId: undefined,
				fiExistingAdUnits: [],
				adunits: [],
				editunitId: undefined,
				selectedUnits: {},
				formData: {
					divid: undefined,
					dynamicPlacement: false,
					selector: undefined,
					adunit: undefined,
					data: []
				},
				editForm: {
					adunit: undefined,
					active: false,
					divid: undefined,
					dynamicPlacement: false,
					selector: undefined
				},
				createFirstImpression: false,
				showeditFirstImpression: false,
				loading: true
			};
		},
	
		created: function created() {
			var _this = this;
	
			this.uuid = this.$route.params.uuid;
			this.domId = this.$route.params.domId;
			this.bucketId = this.$route.params.bucketId;
	
			_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/publishers/' + this.uuid + '/dfp-credentials/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/buckets/' + this.bucketId + '/get-selected-adunits/')]).then(_axios2.default.spread(function (creadentialId, selectedAdUnits) {
				_this.credentialId = creadentialId.data.id;
				_this.fiExistingAdUnits = selectedAdUnits.data;
				_this.loading = false;
	
				window.setTimeout(function () {
					_letterAvatar2.default.transform();
				});
			}));
		},
		methods: {
			cancelForm: function cancelForm() {
				this.createFirstImpression = false;
				this.showeditFirstImpression = false;
			},
			showCreateForm: function showCreateForm() {
				this.createFirstImpression = true;
			},
			removeCreatedAdUnit: function removeCreatedAdUnit(row) {
				var index = this.formData.data.indexOf(row);
				this.formData.data.splice(index, 1);
			},
			createAdUnitSpot: function createAdUnitSpot() {
				this.formData.data.push({
					bucket: this.bucketId,
					ad_unit_name: this.selectedUnits.ad_unit_name,
					ad_unit: this.formData.adunit,
					div_id: this.formData.divid,
					is_dynamic: this.formData.dynamicPlacement,
					dp: this.formData.dynamicPlacement ? 'true' : 'false',
					selector: this.formData.dynamicPlacement ? this.formData.selector : 'N/A',
					is_active: false
				});
				this.formData.divid = undefined;
				this.formData.dynamicPlacement = false;
				this.formData.selector = undefined;
	
				window.setTimeout(function () {
					_letterAvatar2.default.transform();
				});
			},
			getUnits: function getUnits() {
				var _this2 = this;
	
				_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/buckets/' + this.bucketId + '/get-selected-adunits/')]).then(_axios2.default.spread(function (selectedAdUnits) {
					_this2.fiExistingAdUnits = selectedAdUnits.data;
	
					window.setTimeout(function () {
						_letterAvatar2.default.transform();
					});
				}));
			},
			onCreateSubmit: function onCreateSubmit() {
				var _this3 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/buckets/' + this.bucketId + '/save-selected-adunits/', {
					ad_units: this.formData.data
				}).then(function (response) {
					if (response.status) {
						_this3.createFirstImpression = _this3.showeditFirstImpression = false;
						_this3.formData.data = [];
						_this3.$notify({
							title: 'Success',
							message: 'Successfully saved adunits for the first impression',
							type: 'success'
						});
						_this3.getUnits();
					}
				}).catch(function (error) {});
			},
			getAdunits: function getAdunits(query) {
				var _this4 = this;
	
				if (query) {
					_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/search-ad-unit/' + this.domId + '/?query=' + query)]).then(_axios2.default.spread(function (data) {
						_this4.adunits = data.data;
					}));
				}
			},
			setSelectedAdUnit: function setSelectedAdUnit() {
				var _this5 = this;
	
				setTimeout(function () {
					if (_this5.formData.adunit) {
						_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/get-ad-unit/' + _this5.credentialId + '/bucket/' + _this5.bucketId + '/?query=' + (0, _stringify2.default)([_this5.formData.adunit])).then(function (data) {
							_this5.selectedUnits = data.data[0];
						});
					}
				});
			},
			editFirstImpression: function editFirstImpression(props) {
				this.editForm.id = props.row.fiid;
				this.editForm.index = this.fiExistingAdUnits.indexOf(props.row);
				this.adunits = [{
					ad_unit_id: props.row.ad_unit_id,
					ad_unit_name: props.row.ad_unit_name,
					id: props.row.id
				}];
				this.editForm.adunit = props.row.id;
	
				this.editForm.active = props.row.is_active;
				this.editForm.divid = props.row.div_id;
				this.editForm.dynamicPlacement = props.row.is_dynamic;
				this.editForm.selector = props.row.selector == 'N/A' ? undefined : props.row.selector;
				this.createFirstImpression = false;
				this.showeditFirstImpression = true;
			},
			onEditSubmit: function onEditSubmit() {
				var _this6 = this;
	
				var tempObject = {
					id: this.editForm.id,
					bucket: this.bucketId,
					ad_unit: this.editForm.adunit,
					div_id: this.editForm.divid,
					selector: this.editForm.selector ? this.editForm.selector : 'N/A',
					is_dynamic: this.editForm.dynamicPlacement,
					is_active: this.editForm.active
				};
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/buckets/' + this.bucketId + '/save-fi-adunit/' + this.editForm.id + '/', tempObject).then(function (response) {
					_this6.createFirstImpression = _this6.showeditFirstImpression = false;
					_this6.$notify({
						title: 'Success',
						message: 'Successfully edited adunits for the first impression',
						type: 'success'
					});
					_this6.getUnits();
				}).catch(function (error) {});
			}
		}
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _verbalExpressions = __webpack_require__(79);
	
	var _verbalExpressions2 = _interopRequireDefault(_verbalExpressions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.forceUpdate;
	
	exports.default = {
	    data: function data() {
	        return {
	            currentPage: 1,
	            offset: 10,
	            total_Pages: 0,
	            dialogVisible: false,
	            domId: undefined,
	            metaCopy: undefined,
	            isEdit: false,
	            layOutId: null,
	            existingLayouts: [],
	            existingAdSpots: [],
	            formData: {
	                index: -1,
	                editId: undefined,
	                existing: true,
	                udivid: undefined,
	                selector: undefined
	            },
	            layoutForm: {
	                layoutName: '',
	                isActive: true,
	                selectorData: {
	                    data: '',
	                    operator: '',
	                    domSelectorString: '',
	                    domNodeAttribute: ''
	                },
	                layoutType: 'default'
	            },
	            loading: true
	        };
	    },
	
	    props: {
	        domain_details: Object
	    },
	    watch: {
	        $route: function $route(to, from) {
	            this.loadLayoutsDataByCurrentPage(this.currentPage);
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        this.domId = this.$route.params.domId;
	
	
	        this.copyLayoutForm = JSON.parse((0, _stringify2.default)(this.layoutForm));
	        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/page-layouts/')]).then(_axios2.default.spread(function (pageLayouts) {
	            _this.existingLayouts = pageLayouts.data;
	            _this.loading = false;
	            _this.total_Pages = Math.ceil(_this.existingLayouts.length / _this.offset);
	            var i = 0,
	                j = 0;
	
	            var k = 0;
	
	            var layouts = '';
	            for (k = 0; k < pageLayouts.data.length; k++) {
	                if (pageLayouts.data[k].is_active == true) {
	                    layouts += 'Layout Name: ' + pageLayouts.data[k].layout_name + '\nMeta Tag: <meta name="atdlayout" content="' + pageLayouts.data[k].layout_name + '">\n\n';
	                }
	            }
	            _this.metaCopy = 'Instructions for publishers to insert layout metadata tags on their website.These are the layouts which are identified by the Automatad system. The respective meta tags will have to be inserted in the headers of each of the unique layouts mentioned below.\n\n' + layouts;
	        }));
	    },
	    methods: {
	        handleClose: function handleClose(done) {
	            this.$confirm('Are you sure to close this dialog?').then(function (_) {
	                done();
	            }).catch(function (_) {});
	        },
	        open3: function open3() {
	            var _this2 = this;
	
	            this.$prompt('You can Copy Meta here', 'Copy Meta', {
	                customClass: 'elementPromt',
	                inputType: 'textarea',
	                inputValue: this.metaCopy,
	                confirmButtonText: 'OK',
	                cancelButtonText: 'Cancel',
	                inputErrorMessage: 'Invalid Email'
	            }).then(function (value) {
	                _this2.$message({
	                    type: 'success',
	                    message: 'Your email is:' + value
	                });
	                console.log(value);
	            }).catch(function () {
	                _this2.$message({
	                    type: 'info',
	                    message: 'Input canceled'
	                });
	            });
	        },
	        copyMeta: function copyMeta() {
	            conosle.log();
	        },
	        saveLayout: function saveLayout() {
	            var _this3 = this;
	
	            if (!this.layoutForm.layoutName) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Please enter layout name',
	                    type: 'error'
	                });
	                return;
	            }
	            if (this.layoutForm.layoutType === 'url' && (!this.layoutForm.selectorData.data || !this.layoutForm.selectorData.operator)) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Fields are mandatory',
	                    type: 'error'
	                });
	                return;
	            } else if (this.layoutForm.layoutType === 'dom' && (!this.layoutForm.selectorData.domSelectorString || !this.layoutForm.selectorData.domNodeAttribute || !this.layoutForm.selectorData.data || !this.layoutForm.selectorData.operator)) {
	                this.$notify({
	                    title: 'error',
	                    message: 'Fields are mandatory',
	                    type: 'error'
	                });
	                return;
	            }
	            console.log('save click isActive', this.layoutForm.isActive);
	            var request_data = {
	                domain: parseInt(this.domId),
	                layout_name: this.layoutForm.layoutName.toLowerCase(),
	                is_active: this.layoutForm.isActive,
	                type: this.layoutForm.layoutType
	            };
	            if (this.layoutForm.layoutType !== 'default') {
	                request_data['type'] = this.layoutForm.layoutType;
	                var selectorDataPattern = this.convertObjToRegex();
	                request_data['selector_data'] = {
	                    pattern: selectorDataPattern
	                };
	                if (this.layoutForm.layoutType === 'dom') {
	                    request_data['selector_data'].dom_node_attribute = this.layoutForm.selectorData.domNodeAttribute;
	                    request_data['selector_data'].dom_selector_string = this.layoutForm.selectorData.domSelectorString;
	                }
	            }
	            if (this.isEdit) {
	                console.log('save edit click isActive', this.layoutForm.isActive);
	                var URL = ("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/page-layouts/' + this.layOutId + '/';
	
	                _axios2.default.put(URL, request_data).then(function (response) {
	                    _this3.$notify({
	                        title: 'Success',
	                        message: 'Layout has been edit successfully',
	                        type: 'success'
	                    });
	                    _this3.isEdit = false;
	                    for (var i = 0; i < _this3.existingLayouts.length; i++) {
	                        if (_this3.existingLayouts[i].id == _this3.layOutId) {
	                            _this3.existingLayouts.splice(i, 1, response.data);
	                            break;
	                        }
	                    }
	                    _this3.resetForm();
	                    _this3.$forceUpdate();
	                    _this3.currentPage = 1;
	                });
	            } else {
	                console.log('save add isActive', this.layoutForm.isActive);
	                console.log('isEdit in add', this.isEdit);
	                _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/domains/' + this.domId + '/page-layouts/', request_data).then(function (response) {
	                    _this3.existingLayouts.splice(0, 0, response.data);
	                    _this3.$notify({
	                        title: 'Success',
	                        message: 'Layout has been successfully created.',
	                        type: 'success'
	                    });
	                    _this3.resetForm();
	                    _this3.$forceUpdate();
	                });
	            }
	        },
	        editLayout: function editLayout(layout) {
	            console.log('edit', layout);
	            this.isEdit = true;
	            this.layOutId = layout.id;
	            this.layoutForm.layoutName = layout.layout_name;
	            this.layoutForm.isActive = layout.is_active;
	            this.layoutForm.layoutType = layout.type;
	            this.isEdit = true;
	            if (layout.type && layout.type !== 'default') {
	                var obj = this.convertRegexToObj(layout.selector_data.pattern);
	                this.layoutForm.selectorData.data = obj.data;
	                this.layoutForm.selectorData.operator = obj.operator;
	                this.layoutForm.selectorData.domSelectorString = layout.selector_data.dom_selector_string;
	                this.layoutForm.selectorData.domNodeAttribute = layout.selector_data.dom_node_attribute;
	            } else {
	                var _obj = this.copyLayoutForm.selectorData;
	                this.layoutForm.selectorData.data = _obj.data;
	                this.layoutForm.selectorData.operator = _obj.operator;
	                this.layoutForm.selectorData.domSelectorString = _obj.domSelectorString;
	                this.layoutForm.selectorData.domNodeAttribute = _obj.domNodeAttribute;
	            }
	            this.$forceUpdate();
	        },
	        resetForm: function resetForm() {
	            this.layOutId = null;
	            this.isEdit = false;
	            this.layoutForm.layoutName = '';
	            this.layoutForm.isActive = true;
	            this.layoutForm.layoutType = 'default';
	            this.layoutForm.selectorData.data = '';
	            this.layoutForm.selectorData.operator = '';
	            this.layoutForm.selectorData.domSelectorString = '';
	            this.layoutForm.selectorData.domNodeAttribute = '';
	        },
	        handleCurrentChange: function handleCurrentChange(val) {
	            this.currentPage = val;
	            this.loadLayoutsDataByCurrentPage(val);
	        },
	        handleSizeChange: function handleSizeChange(val) {
	            this.offset = val;
	            this.loadLayoutsDataByCurrentPage(1);
	            this.currentPage = 1;
	        },
	        OpenLayoutUsage: function OpenLayoutUsage(command) {
	            var _this4 = this;
	
	            setTimeout(function () {
	                var url = '/admin/publisher/' + _this4.$route.params.uuid + '/domain/' + _this4.domId + '/buckets/' + command.bucket_id + '/fi/?adLayout=' + command.id;
	                _this4.$router.push(url);
	            });
	        },
	        loadLayoutsDataByCurrentPage: function loadLayoutsDataByCurrentPage() {
	            var _this5 = this;
	
	            var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	            this.loading = true;
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/domains/' + this.domId + '/page-layouts/?page=' + pageNum + '&&offset=' + this.offset)).then(function (response) {
	                _this5.existingLayouts = response.data;
	                _this5.total_Pages = response.data.length;
	                _this5.loading = false;
	            });
	        },
	        convertObjToRegex: function convertObjToRegex() {
	            var expression = '';
	            if (this.layoutForm.selectorData.operator === 'equals') {
	                expression = (0, _verbalExpressions2.default)().add('^' + this.layoutForm.selectorData.data + '$');
	            } else if (this.layoutForm.selectorData.operator === 'contains') {
	                expression = (0, _verbalExpressions2.default)().find(this.layoutForm.selectorData.data);
	            }
	            var expr = expression == '' ? '' : expression.toRegExp();
	            return expr.toString().replace('/', '').replace('/gm', '');
	        },
	        convertRegexToObj: function convertRegexToObj(expr) {
	            var regex_sanitize_expression = /[&\\#,+()!$~%.^'":*?<>{}]/g;
	            if (expr.indexOf('^') > -1 && expr.indexOf('$') > -1) {
	                return {
	                    data: expr.replace(regex_sanitize_expression, ''),
	                    operator: 'equals'
	                };
	            } else if (expr == '') {
	                return { operator: 'equals', data: '' };
	            }
	            return { operator: 'contains', data: expr.replace(regex_sanitize_expression, '') };
	        },
	        changeLayout: function changeLayout() {
	            this.layoutForm.selectorData.data = "";
	            this.layoutForm.selectorData.operator = "";
	        }
	    }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {};

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormInput',
	  data: function data() {
	    return {
	      input: '',
	      num1: 1
	    };
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: 'ShopHome',
	      publishers: []
	    };
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.$nextTick(function () {
	      var _this = this;
	
	      _axios2.default.get(baseUrl.url + 'v1/publishers/').then(function (response) {
	        _this.publishers = response.data;
	      }).catch(function (error) {
	        if (error.response.status == 400) {
	          if (error.response.data) {
	            console.log(error.response.data);
	          }
	        }
	      });
	    });
	  },
	  methods: {}
	
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _parseFloat = __webpack_require__(53);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				reportData: [],
				publishersList: [],
				publisherDomainList: [],
				pubData: {},
				UploadScreenVisible: false,
				report_date: '',
				bidder_name: '',
				frmdata: new FormData(),
				approvedData: undefined,
				approveBtn: 'el-icon-check',
				currencyArr: [],
				site_list: new _set2.default(),
				loading: true,
				approveAllBtn: 'el-icon-check',
				reportApprovalStatus: [],
				reportOverallStatus: [],
				disabled: false,
				uploading: false
			};
		},
	
		created: function created() {
			var _this = this;
	
			this.loading = true;
			this.report_date = this.$route.params.reportName;
			_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/domain-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('reports/v1/get-all-reports/' + this.report_date + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('reports/v1/domain-currency-rate/' + this.report_date + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('reports/v1/site-reports-approval-status/' + this.report_date + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/reports-approval-status/')]).then(_axios2.default.spread(function (publisher, reports, currencyRate, reportStatus, reportOverallStatus) {
				_this.reportOverallStatus = reportOverallStatus.data;
				_this.reportApprovalStatus = reportStatus.data;
				_this.currencyArr = currencyRate.data;
				_this.publishersList = publisher.data;
	
				_this.reportData = reports.data;
	
				_this.site_list = new _set2.default(_this.reportData.map(function (t) {
					return t.site;
				}));
				console.log(_this.site_list);
	
				_this.publisherDomainList = _this.publishersList.filter(function (x) {
					return x.domains.some(function (k) {
						return [].concat((0, _toConsumableArray3.default)(_this.site_list)).indexOf(k) != -1;
					});
				});
				_this.loading = false;
			})).catch(function (e) {
				_this.loading = false;
			});
		},
		methods: {
			upload: function upload(_upload) {
				this.frmdata.append('reportFile', _upload.file);
			},
			cancelUploadAction: function cancelUploadAction() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			},
			clearFilesList: function clearFilesList() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			},
			confirmReUpload: function confirmReUpload(reportType, date) {
				var _this2 = this;
	
				this.$confirm('This will override previously uploaded file. Continue?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(function () {
					console.log('pass');
					_this2.UploadScreenVisible = true;
				}).catch(function () {
					_this2.$message({
						type: 'info',
						message: 'Re-upload canceled'
					});
				});
			},
	
			getOverAllReportStatus: function getOverAllReportStatus(date) {
				var approvalStatus = this.reportOverallStatus.filter(function (k) {
					return k.date == date;
				});
	
				if (approvalStatus.length == 2) {
					return "Approve All";
				} else if (approvalStatus.length == 1) {
					if (approvalStatus[0].approve_status == true) {
						return "Approved";
					}
					if (approvalStatus[0].approve_status == false) {
						return "Approve All";
					}
				} else {
					return "Approve All";
				}
			},
			getReportApprovalStatus: function getReportApprovalStatus(site_name) {
				var approvalStatus = this.reportApprovalStatus.filter(function (k) {
					return k.site_name == site_name;
				});
	
				if (approvalStatus.length == 2) {
					return "Approve";
				} else if (approvalStatus.length == 1) {
					if (approvalStatus[0].approve_status == true) {
						return "Approved";
					}
					if (approvalStatus[0].approve_status == false) {
						return "Approve";
					}
				} else {
					return "Approve";
				}
			},
			getFilteredReport: function getFilteredReport(allReportArr, domainToMatch) {
				return allReportArr.filter(function (x) {
					return x['site'] == domainToMatch;
				});
			},
			getFormattedDate: function getFormattedDate(date) {
				var report_date = new Date(date);
				var dd = report_date.getDate();
				var mm = report_date.getMonth() + 1;
				var yyyy = report_date.getFullYear();
	
				if (dd < 10) {
					dd = '0' + dd;
				}
	
				if (mm < 10) {
					mm = '0' + mm;
				}
	
				report_date = yyyy + '-' + mm + '-' + dd;
				return report_date;
			},
			getRoundedNumbers: function getRoundedNumbers(val) {
				var n = (0, _parseFloat2.default)(val);
				if (!val || isNaN(n) || n < 0) return 0;
				return n.toFixed(2);
			},
			setReport: function setReport(bidder_name, report_date) {
				this.UploadScreenVisible = true;
				this.report_date = report_date;
				this.bidder_name = bidder_name;
			},
			getRevenueTotal: function getRevenueTotal(arr, val) {
				var sum_val = 0;
				for (var i in arr) {
					var flt_val = parseFloat(this.getRoundedNumbers(arr[i][val]));
					sum_val += flt_val;
				}
				return Math.round(sum_val * 100) / 100;
			},
			getValTotal: function getValTotal(arr, val) {
				var sum_val = 0;
				for (var i in arr) {
					var int_val = parseInt(this.getRoundedNumbers(arr[i][val]));
	
					sum_val += int_val;
				}
				return sum_val;
			},
	
			approveData: function approveData(domain, date) {
				var _this3 = this;
	
				this.approveBtn = 'el-icon-loading';
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/approve-reports/', { report_date: date, domain: domain }).then(function (response) {
					console.log(response);
					_this3.approveBtn = 'el-icon-check';
				});
			},
			notificationMsg: function notificationMsg() {
				var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
				var msg = arguments[1];
	
				this.$notify({
					title: type,
					message: msg ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			approveAllData: function approveAllData(date) {
				var _this4 = this;
	
				this.approveAllBtn = 'el-icon-loading';
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/approve-all-reports/', { report_date: date }).then(function (response) {
					if (response.data.status == "success") {
						_this4.approveAllBtn = 'el-icon-check';
						jQuery('.approve-all-reports').removeClass("el-button--primary");
						jQuery('.approve-all-reports').addClass("el-button--success");
						_this4.notificationMsg(response.data.status, response.data.msg);
					} else {
						_this4.notificationMsg(response.data.msg);
					}
				});
			},
			submitUpload: function submitUpload() {
				var _this5 = this;
	
				this.$refs.upload.submit();
	
				console.log(this.report_date);
	
				this.report_date = this.report_date;
	
				this.frmdata.append('report_date', this.report_date);
				this.frmdata.append('bidder', 'updated');
				this.frmdata.append('report_type', 'banner');
				this.uploading = true;
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/upload/', this.frmdata).then(function (response) {
					_this5.uploading = false;
	
					_this5.notificationMsg(response.status ? 'Success' : 'Error', response.data.data.message);
					if (response.data.status == 'Success') {
						_this5.UploadScreenVisible = false;
						_this5.$refs.upload.clearFiles();
						setTimeout(function () {
							_this5.$router.push('/admin/reports');
						}, 500);
					} else {
						_this5.UploadScreenVisible = false;
					}
				}).catch(function (e) {
					_this5.uploading = false;
					_this5.notificationMsg(e.response.data.data.status ? 'Success' : 'Error', e.response.data.data.message);
				});
			},
			getExchangeRate: function getExchangeRate(arr, i) {
				var curArr = arr.filter(function (k) {
					return k['site'] == i;
				});
	
				var currency = '';
				var exchange_rate = '';
				if (curArr.length > 0) {
					currency = curArr[0].dfp_currency;
					exchange_rate = curArr[0].exchange_rate_to_usd;
				} else {
					return '';
				}
	
				if (currency != 'Not available') {
					currency = currency;
				} else {
					currency = '';
				}
				return [currency, exchange_rate];
			},
			getBidderRevenue: function getBidderRevenue(arr, bidder) {
				bidder_data = arr.filter(function (x) {
					return x['bidder'] == bidder;
				});
				console.log(this.getRevenueTotal(bidder_data, bidder));
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				biddersList: [],
				reportStatus: [],
				report_name_list: [],
				UploadScreenVisible: false,
				report_date: '',
				bidder_name: '',
				frmdata: new FormData(),
				json_data: []
			};
		},
	
		created: function created() {
			var _this = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-status/').then(function (response) {
				_this.reportStatus = response.data.data;
				var report_dates_array = [];
	
				_this.reportStatus.map(function (k) {
					report_dates_array.push(k.date);
				});
				var latest_date = _this.getLastDateFromReports(report_dates_array);
				console.log(new Date().toJSON().slice(0, 10).replace(/-/g, '/'));
				_this.report_name_list = _this.getDaysArray(new Date(), latest_date.toJSON().slice(0, 10).replace(/-/g, '/'));
				console.log(_this.report_name_list);
			});
		},
		methods: {
			getDownload: function getDownload(date) {
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-bidder-reports/' + date + '/', { responseType: 'blob' }).then(function (response) {
					console.log(response);
					var type = response.headers["content-type"];
					console.log(type);
					var url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
					var link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'Bidders Revenue Report - ' + date + '.csv');
					document.body.appendChild(link);
					link.click();
				});
			},
			getDaysArray: function getDaysArray(start, end) {
				for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
					console.log(start);
					arr.push(new Date(dt));
				}
				return arr;
			},
			getLastDateFromReports: function getLastDateFromReports(arr) {
				return new Date(Math.max.apply(null, arr.map(function (e) {
					return new Date(e);
				})));
			},
			setReport: function setReport(bidder_name, report_date) {
				this.UploadScreenVisible = true;
				this.report_date = report_date;
				this.bidder_name = bidder_name;
			}
		}
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(29);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _methods;
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pusherJs = __webpack_require__(249);
	
	var _pusherJs2 = _interopRequireDefault(_pusherJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				dfpReportUrl: '',
				adxSwitch: true,
				biddersList: [],
				reportStatus: [],
				report_name_list: [],
				UploadScreenVisible: false,
				report_date: '',
				bidder_name: '',
				frmdata: new FormData(),
				data: { 'bidder': '', 'report_date': '' },
				reportOptions: [{
					reportType: 'banner',
					label: 'Banner Report'
				}, {
					reportType: 'video',
					label: 'Video Report'
				}],
				reportType: 'banner',
				reportStartDate: undefined,
				reportDateArr: [],
				loading: false,
				uploading: false,
				clickedClass: '',
				downloadAllReport: 'el-icon-download',
				ongoingReports: [],
				reportApprovalStatus: [],
				taskRunChannel: undefined,
				reportsCheck: undefined,
				totalPage: 0,
				currentPage: 1,
				pickerOptions1: {
					disabledDate: function disabledDate(time) {
						return time.getTime() > Date.now();
					},
	
					shortcuts: [{
						text: 'Today',
						onClick: function onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: 'Yesterday',
						onClick: function onClick(picker) {
							var date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '3 days back',
						onClick: function onClick(picker) {
							var date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
							picker.$emit('pick', date);
						}
					}]
				},
				default_date: (new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getFullYear() + '-' + (new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getMonth() + 1) + '-' + new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getDate()).toString(),
				disabledReports: [],
				emailReportBidderList: []
			};
		},
	
		created: function created() {
			var _this = this;
	
			this.loading = true;
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/available-bidders-list/').then(function (response) {
				_this.biddersList = response.data.data.filter(function (e) {
					return e.disabled == false;
				}).map(function (k) {
					return k.name;
				});
				_this.emailReportBidderList = response.data.data.filter(function (e) {
					return e.is_email_report == true;
				}).map(function (o) {
					return o.name;
				});
				_this.disabledReports = response.data.data.filter(function (e) {
					return e.disabled == true;
				}).map(function (o) {
					return o.name;
				});
			});
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/ongoing-reports/').then(function (response) {
				_this.ongoingReports = response.data.data == null ? [] : response.data.data.filter(function (e) {
					return e != '';
				});
	
				_this.disableOngoingReports(_this.ongoingReports);
			}).catch(function (e) {
				return console.log(e);
			});
	
			this.getReportStatusList(1);
		},
		methods: (_methods = {
			getReportStatusList: function getReportStatusList(page) {
				var _this2 = this;
	
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-status/?page=' + page).then(function (response) {
					_this2.reportStatus = response.data.data;
	
					var report_dates_array = [];
					_this2.totalPage = response.data.pages;
					_this2.currentPage = response.data.page;
	
					_this2.reportStatus.map(function (k) {
						report_dates_array.push(k.date);
					});
					if (page == 1) {
						_this2.reportStartDate = _this2.getFirstDateFromReport(report_dates_array);
	
						_this2.reportDateArr = _this2.getDaysArray(new Date(_this2.reportStartDate), new Date(_this2.getTodayDate()));
	
						_this2.reportDateArr.map(function (e) {
							_this2.checkAndAdd(e, _this2.reportStatus);
						});
						_this2.reportStatus.sort(function compare(a, b) {
							var dateA = new Date(a.date);
							var dateB = new Date(b.date);
							return dateB - dateA;
						});
					}
	
					_this2.pusherStart();
	
					_this2.loading = false;
				}).catch(function (e) {
					console.log(e);
				});
			},
			handleCurrentChange: function handleCurrentChange(val) {
				console.log('Current page ' + val);
				this.getReportStatusList(val);
			},
			reportSync: function reportSync(date) {
				var _this3 = this;
	
				this.report_date = date;
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/sync-report-with-dashboard/', { "report_date": this.report_date }).then(function (response) {
					console.log(response.data);
					var respData = response.data;
					_this3.notificationMsg(respData.status, respData.data.message);
				});
			},
			getLastUpdateDate: function getLastUpdateDate(obj) {
				return obj.last_update == null ? obj.modified : obj.last_update;
			},
	
			disableOngoingReports: function disableOngoingReports(arr) {
				var _this4 = this;
	
				setTimeout(function () {
					if (arr.length > 0) {
						arr.map(function (report) {
							console.log(report);
	
							jQuery(".btn-" + report).children('i').attr('class', 'el-icon-loading');
							jQuery(".btn-" + report).attr('disabled', 'true');
						});
					}
				}, 500);
	
				this.reportsCheck = setInterval(function (report) {
					_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/ongoing-reports/').then(function (response) {
						_this4.ongoingReports = response.data.data == null ? [] : response.data.data.filter(function (e) {
							return e != '';
						});
	
						if (_this4.ongoingReports.length == 0) {
							console.log('all tasks complete');
							clearInterval(_this4.reportsCheck);
						}
					}).catch(function (e) {
						console.log(e);
						clearInterval(_this4.reportsCheck);
					});
					console.log('test:', _this4.ongoingReports);
				}, 10500);
			},
			scrollToTop: function scrollToTop() {
				window.scrollTo(0, 0);
			},
			open5: function open5() {
				this.$message({
					showClose: true,
					message: 'This is a message.'
				});
			},
	
			getReport: function getReport(report_date) {
				_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/download/' + report_date + '/').then(function (response) {
					console.log(response);
				});
			},
			checkAndAdd: function checkAndAdd(val, arr) {
				var date = arr.length + 1;
				var found = arr.some(function (el) {
					return el.date === val;
				});
	
				if (!found) {
					arr.push({ date: val, data: [] });
				}
			},
			getDaysArray: function getDaysArray(start, end) {
				for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
					var curDate = new Date(dt);
					var dd = curDate.getDate();
					var mm = curDate.getMonth() + 1;
					var yyyy = curDate.getFullYear();
	
					if (dd < 10) {
						dd = '0' + dd;
					}
	
					if (mm < 10) {
						mm = '0' + mm;
					}
	
					curDate = yyyy + '-' + mm + '-' + dd;
					arr.push(curDate);
				}
				return arr;
			},
			getFirstDateFromReport: function getFirstDateFromReport(arr) {
				var minDate = new Date(Math.min.apply(null, arr.map(function (e) {
					return new Date(e);
				})));
				var dd = minDate.getDate();
				var mm = minDate.getMonth() + 1;
				var yyyy = minDate.getFullYear();
	
				if (dd < 10) {
					dd = '0' + dd;
				}
	
				if (mm < 10) {
					mm = '0' + mm;
				}
	
				minDate = yyyy + '-' + mm + '-' + dd;
				return minDate;
			},
			getTodayDate: function getTodayDate() {
				var today = new Date();
				var dd = today.getDate();
				var mm = today.getMonth() + 1;
				var yyyy = today.getFullYear();
	
				if (dd < 10) {
					dd = '0' + dd;
				}
	
				if (mm < 10) {
					mm = '0' + mm;
				}
	
				today = yyyy + '-' + mm + '-' + dd;
				return today;
			},
			notificationMsg: function notificationMsg() {
				var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
				var msg = arguments[1];
	
				this.$notify({
					title: type,
					message: msg ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			cancelUploadAction: function cancelUploadAction() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			},
			setReport: function setReport(bidder_name, report_date) {
				this.UploadScreenVisible = true;
	
				this.report_date = report_date;
	
				this.bidder_name = bidder_name;
				console.log(bidder_name);
			},
			setUpdatedReport: function setUpdatedReport(bidder_name, report_date) {
				this.UploadScreenVisible = true;
				this.report_date = report_date;
				this.bidder_name = bidder_name;
				console.log(bidder_name);
			},
			getDateTime: function getDateTime(date) {
				var dateTime = date;
				function pad2(n) {
					return (n < 10 ? '0' : '') + n;
				}
	
				return dateTime.getFullYear() + '-' + pad2(dateTime.getMonth() + 1) + '-' + pad2(dateTime.getDate()) + '<br/>' + pad2(dateTime.getHours()) + ':' + pad2(dateTime.getMinutes()) + ':' + pad2(dateTime.getSeconds());
			}
		}, (0, _defineProperty3.default)(_methods, 'notificationMsg', function notificationMsg() {
			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : type;
			var msg = arguments[1];
	
			this.$notify({
				title: type,
				message: msg,
				type: type.toLowerCase()
			});
		}), (0, _defineProperty3.default)(_methods, 'pusherStart', function pusherStart() {
			var pusher = new (Function.prototype.bind.apply(_pusherJs2.default, [null].concat((0, _toConsumableArray3.default)(JSON.parse(("[\"3303e5b7-4140-40df-9cdd-a35553aa89f7\",{\"wsHost\":\"yeti-5f3965ef-a935-417c-b425-3da6e7bdf4d5.automatad.workers.dev\",\"wsPort\":443,\"wssPort\":443,\"forceTLS\":true,\"encrypted\":true,\"disableStats\":true,\"enabledTransports\":[\"ws\",\"wss\"],\"cluster\":\"ap2\",\"channelAuthorization\":{\"endpoint\":\"https://yeti-api.automatad.com/v1/auth/services/pusher\",\"headers\":{\"Authorization\":\"JWT AUTH_TOKEN_HERE\"}}}]").replace('AUTH_TOKEN_HERE', this.$auth.token()))))))();
			this.taskRunChannel = pusher.subscribe('my-channel');
			this.taskRunChannel.bind("reports_task", function (data) {
				jQuery('.btn-' + data.element).children('i').attr('class', 'el-icon-loading');
				if (data.type == 'complete') {
					jQuery('.btn-' + data.element).removeClass('el-button--success');
					jQuery('.btn-' + data.element).removeClass('el-button--danger');
					jQuery('.btn-' + data.element).addClass('el-button--success');
					jQuery('.btn-' + data.element).children('i').attr('class', 'el-icon-check');
					jQuery('.btn-' + data.element).attr('disabled', 'true');
				} else if (data.type == 'failed') {
					jQuery('.btn-' + data.element).removeClass('el-button--success');
					jQuery('.btn-' + data.element).removeClass('el-button--danger');
					jQuery('.btn-' + data.element).addClass('el-button--danger');
					jQuery('.btn-' + data.element).children('i').attr('class', 'el-icon-close');
					jQuery('.btn-' + data.element).removeAttr('disabled');
				} else {
					jQuery('.btn-' + data.element).children('i').attr('class', 'el-icon-loading');
					jQuery('.btn-' + data.element).attr('disabled', 'true');
				}
			});
		}), (0, _defineProperty3.default)(_methods, 'regenerateReport', function regenerateReport(bidder_name, report_date, event) {
			var _this5 = this;
	
			if (this.emailReportBidderList.indexOf(bidder_name) > -1) {
				return this.setReport(bidder_name, report_date);
			}
	
			jQuery('.btn-' + bidder_name + '-' + report_date).attr('disabled', 'true');
			jQuery('.atd-text-' + bidder_name + '-' + report_date).html((0, _moment2.default)(new Date()).format("MMM Do YYYY[\n] h:mm:ss a"));
	
			if (event.target.className == 'el-icon-close' || event.target.className == 'el-icon-check') {
				event.target.className = 'el-icon-loading';
			} else if (event.target.className == 'el-button is-circle el-button--success' || event.target.className == 'el-button is-circle el-button--danger') {
				event.target.firstElementChild.className = 'el-icon-loading';
			}
	
	
			this.data['bidder'] = bidder_name;
			this.data['report_date'] = report_date;
			this.data['run_time'] = new Date();
	
			_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/regenerate/', this.data).then(function (response) {
				if (response.data.status == 'Success') {
					console.log('a func for ' + _this5.data + ' was called');
					setTimeout(function () {
						var _this6 = this;
	
						_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-status/').then(function (response) {
							_this6.reportStatus = response.data.data;
						});
					}, 2000);
				} else {
					console.log('re:');
				}
			});
		}), (0, _defineProperty3.default)(_methods, 'upload', function upload(_upload) {
			this.frmdata.append('reportFile', _upload.file);
		}), (0, _defineProperty3.default)(_methods, 'submitUpload', function submitUpload() {
			var _this7 = this;
	
			this.$refs.upload.submit();
	
			console.log(this.report_date);
	
			this.report_date = this.report_date;
	
			this.frmdata.append('report_date', this.report_date);
			this.frmdata.append('bidder', this.bidder_name);
			this.frmdata.append('report_type', this.reportType);
			this.uploading = true;
			_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/upload/', this.frmdata).then(function (response) {
				_this7.uploading = false;
	
				_this7.notificationMsg(response.status ? 'Success' : 'Error', response.data.data.message);
				if (response.data.status == 'Success') {
					_this7.UploadScreenVisible = false;
					_this7.$refs.upload.clearFiles();
					console.log(jQuery('.btn-' + _this7.bidder_name + '-' + _this7.report_date));
					jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).removeClass('el-button--success');
					jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).removeClass('el-button--danger');
					jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).addClass('el-button--success');
					jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).children('i').attr('class', 'el-icon-check');
					jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).attr('disabled', 'true');
				} else {
					_this7.UploadScreenVisible = false;
				}
			}).catch(function (e) {
				_this7.uploading = false;
				_this7.notificationMsg(e.response.data.data.status ? 'Success' : 'Error', e.response.data.data.message);
	
				jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).removeClass('el-button--success');
				jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).removeClass('el-button--danger');
				jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).addClass('el-button--danger');
				jQuery('.btn-' + _this7.bidder_name.replace(" ", "_") + '-' + _this7.report_date).children('i').attr('class', 'el-icon-close');
			});
		}), (0, _defineProperty3.default)(_methods, 'confirmReUpload', function confirmReUpload(date) {
			var _this8 = this;
	
			this.$confirm('Publisher Dashboard will be updated even if there are incomplete reports for selected date. Continue?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(function () {
				console.log('pass');
				_this8.reportSync(date);
			}).catch(function () {
				_this8.$message({
					type: 'info',
					message: 'Action cancelled'
				});
			});
		}), (0, _defineProperty3.default)(_methods, 'clearFilesList', function clearFilesList() {
			this.$refs.upload.clearFiles();
			this.UploadScreenVisible = false;
		}), (0, _defineProperty3.default)(_methods, 'getReportApprovalStatus', function getReportApprovalStatus(report_date) {
			var approvalStatus = this.reportApprovalStatus.filter(function (k) {
				return k.date == report_date;
			});
	
			if (approvalStatus.length == 2) {
				return "Ongoing";
			} else if (approvalStatus.length == 1) {
				if (approvalStatus[0].approve_status == true) {
					return "Approved";
				}
				if (approvalStatus[0].approve_status == false) {
					return "Pending";
				}
			} else {
				return "Upload";
			}
		}), (0, _defineProperty3.default)(_methods, 'handleCommand', function handleCommand(command, date, event) {
			this.loading = true;
			if (command == 'get_bidder_revenue_report') {
				return this.getBidderDownload(date);
			}
			if (command == 'get_dfp_bidder_revenue_report') {
				return this.getDownload(date);
			}
			if (command == 'get_axt_report') {
				return this.getAXTReport(date);
			}
			if (command == 'get_amp_report') {
				return this.getAMPReport(date);
			}
			if (command == 'get_adserving_fee') {
				return this.getAdservingReportDownload(date);
			}
		}), (0, _defineProperty3.default)(_methods, 'getDownload', function getDownload(date) {
			var _this9 = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/download/' + date + '/').then(function (response) {
				_this9.dfpReportUrl = response.data.data.data;
				var link = document.createElement('a');
				link.href = _this9.dfpReportUrl;
				link.setAttribute('download', 'DFP + Bidder Report - ' + date + '.csv');
				document.body.appendChild(link);
	
				link.click();
	
				_this9.loading = false;
			});
		}), (0, _defineProperty3.default)(_methods, 'getAdservingReportDownload', function getAdservingReportDownload(date) {
			var _this10 = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/ad-serving-fee/' + date + '/').then(function (response) {
				if (response.data.data.status == true) {
					_this10.dfpReportUrl = response.data.data.data;
					var link = document.createElement('a');
					link.href = _this10.dfpReportUrl;
					link.setAttribute('download', 'Adserving-fee-' + date + '.csv');
					document.body.appendChild(link);
	
					link.click();
				} else {
					_this10.notificationMsg(response.data.status, response.data.data.message);
				}
	
				_this10.loading = false;
			});
		}), (0, _defineProperty3.default)(_methods, 'getAXTReport', function getAXTReport(date) {
			var _this11 = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-axt-report/' + date + '', { responseType: 'blob' }).then(function (response) {
				var type = response.headers["content-type"];
				console.log(type);
				var url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
				var link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'AXT Report - ' + date + '.csv');
				document.body.appendChild(link);
				link.click();
	
				_this11.loading = false;
			});
		}), (0, _defineProperty3.default)(_methods, 'getAMPReport', function getAMPReport(date) {
			var _this12 = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-amp-report/' + date + '', { responseType: 'blob' }).then(function (response) {
				var type = response.headers["content-type"];
				console.log(type);
				var url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
				var link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'AMP Report - ' + date + '.csv');
				document.body.appendChild(link);
				link.click();
	
				_this12.loading = false;
			});
		}), (0, _defineProperty3.default)(_methods, 'getBidderDownload', function getBidderDownload(date) {
			var _this13 = this;
	
			_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-bidder-reports/' + date + '/', { responseType: 'blob' }).then(function (response) {
				var type = response.headers["content-type"];
				console.log(type);
				var url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
				var link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'Bidders Report - ' + date + '.csv');
				document.body.appendChild(link);
				link.click();
				_this13.loading = false;
			});
		}), _methods)
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(28);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _parseFloat = __webpack_require__(53);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				reportData: [],
				publishersList: [],
				publisherDomainList: [],
				pubData: {},
				UploadScreenVisible: false,
				report_date: '',
				bidder_name: '',
				frmdata: new FormData(),
				approvedData: undefined,
				approveBtn: 'el-icon-check',
				currencyArr: [],
				reportType: 'banner',
				loading: false,
				tableLoading: false,
				uploadPercent: 0
			};
		},
	
		created: function created() {
			this.report_date = this.$route.params.reportName;
		},
		methods: {
			getFilteredReport: function getFilteredReport(allReportArr, domainToMatch) {
				return allReportArr.filter(function (x) {
					return x['site'] == domainToMatch;
				});
			},
			getFormattedDate: function getFormattedDate(date) {
				var report_date = new Date(date);
				var dd = report_date.getDate();
				var mm = report_date.getMonth() + 1;
				var yyyy = report_date.getFullYear();
	
				if (dd < 10) {
					dd = '0' + dd;
				}
	
				if (mm < 10) {
					mm = '0' + mm;
				}
	
				report_date = yyyy + '-' + mm + '-' + dd;
				return report_date;
			},
			getRoundedNumbers: function getRoundedNumbers(val) {
				var n = (0, _parseFloat2.default)(val);
				if (!val || isNaN(n) || n < 0) return 0;
				return n.toFixed(2);
			},
			cancelUploadAction: function cancelUploadAction() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			},
			setReport: function setReport(bidder_name, report_date) {
				this.UploadScreenVisible = true;
				this.report_date = report_date;
				this.bidder_name = bidder_name;
			},
			getRevenueTotal: function getRevenueTotal(arr, val) {
				var sum_val = 0;
				for (var i in arr) {
					var flt_val = parseFloat(this.getRoundedNumbers(arr[i][val]));
					sum_val += flt_val;
				}
				return Math.round(sum_val * 100) / 100;
			},
			getValTotal: function getValTotal(arr, val) {
				var sum_val = 0;
				for (var i in arr) {
					var int_val = parseInt(this.getRoundedNumbers(arr[i][val]));
	
					sum_val += int_val;
				}
				return sum_val;
			},
	
			approveData: function approveData(domain, date) {
				var _this = this;
	
				this.approveBtn = 'el-icon-loading';
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/approve-reports/', { report_date: date, domain: domain }).then(function (response) {
					console.log(response);
					_this.approveBtn = 'el-icon-check';
				});
			},
			approveAllData: function approveAllData(date) {
				var _this2 = this;
	
				this.approveBtn = 'el-icon-loading';
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/approve-all-reports/', { report_date: date }).then(function (response) {
					_this2.approveBtn = 'el-icon-check';
					jQuery('.approve-all-reports').removeClass("el-button--primary");
					jQuery('.approve-all-reports').addClass("el-button--success");
					_this2.notificationMsg(type = 'Success', '');
				});
			},
			getExchangeRate: function getExchangeRate(arr, i) {
	
				var curArr = arr.filter(function (k) {
					return k['site'] == i;
				});
	
				var currency = '';
				var exchange_rate = '';
				if (curArr.length > 0) {
					currency = curArr[0].dfp_currency;
					exchange_rate = curArr[0].exchange_rate_to_usd;
				} else {
					return 'data unavailable';
				}
	
				if (currency != 'Not available') {
					currency = currency;
				} else {
					currency = '';
				}
				return currency + ' ' + exchange_rate;
			},
			getBidderRevenue: function getBidderRevenue(arr, bidder) {
				bidder_data = arr.filter(function (x) {
					return x['bidder'] == bidder;
				});
				console.log(this.getRevenueTotal(bidder_data, bidder));
			},
			notificationMsg: function notificationMsg() {
				var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Error';
				var msg = arguments[1];
	
				this.$notify({
					title: type,
					message: msg ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			upload: function upload(_upload) {
				this.frmdata.append('reportFile', _upload.file);
			},
			submitUpload: function submitUpload() {
				var _this3 = this;
	
				this.$refs.upload.submit();
	
				console.log(this.report_date);
				this.frmdata.append('report_date', this.report_date);
				this.frmdata.append('bidder', 'updated');
				this.frmdata.append('report_type', this.reportType);
				this.loading = true;
				var config = {
					onUploadProgress: function onUploadProgress(progressEvent) {
						if (progressEvent.lengthComputable) {
							var val = Math.round(progressEvent.loaded * 100 / progressEvent.total);_this3.uploadPercent = val;
						}
					}
				};
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/upload/', this.frmdata, config).then(function (response) {
					console.log(response);
					_this3.notificationMsg(response.status ? 'Success' : 'Error', response.data.data.message);
					_this3.loading = false;
					if (response.data.status == 'Success') {
						_this3.tableLoading = true;
						_this3.UploadScreenVisible = false;
						_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/domain-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('reports/v1/get-all-reports/' + _this3.report_date + '/')), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('reports/v1/domain-currency-rate/' + _this3.report_date + '/'))]).then(_axios2.default.spread(function (publisher, reports, currencyRate) {
							_this3.currencyArr = currencyRate.data;
							_this3.publishersList = publisher.data;
	
							_this3.reportData = reports.data;
							console.log(_this3.reportData);
	
							var site_list = new _set2.default(_this3.reportData.map(function (t) {
								return t.site;
							}));
	
							_this3.publisherDomainList = _this3.publishersList.filter(function (x) {
								return x.domains.some(function (k) {
									return [].concat((0, _toConsumableArray3.default)(site_list)).indexOf(k) != -1;
								});
							});
						}));
	
						_this3.tableLoading = false;
					} else {}
				}).catch(function (e) {
					console.log(e);
				});
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _parseFloat = __webpack_require__(53);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueJsonCsv = __webpack_require__(253);
	
	var _vueJsonCsv2 = _interopRequireDefault(_vueJsonCsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: { JsonCSV: _vueJsonCsv2.default },
		data: function data() {
			return {
				input10: '',
				input11: '',
				UploadScreenVisible: false,
				report_date: '',
				bidder_name: '',
				frmdata: new FormData(),
				radio: '1',
				formField: { site: '', alias: '' },
				fields_alias: [{ site: '', alias: '' }],
				dfpReportSitesField: { site: '', is_enabled: '' },
				allDfpReportSitesField: [{ site: '', is_enabled: '' }],
				dfpReport: [],
				siteAliasList: [],
				search: '',
				jsonData: [{ "SiteUrl": "", "SiteAlias": "" }]
			};
		},
	
		created: function created() {
			var _this = this;
	
			_axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/all-domain-list/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/sites-with-dfp-reports/'), _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-sites-alias/')]).then(_axios2.default.spread(function (publisher, response, alias) {
				_this.publishersList = publisher.data;
				_this.dfpReport = response.data;
				_this.siteAliasList = alias.data;
			}));
		},
		methods: {
			updateDfpReportSites: function updateDfpReportSites() {
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-site-alias-list/', this.fields_alias).then(function () {});
			},
			saveAliasData: function saveAliasData() {
				var _this2 = this;
	
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/get-site-alias-list/', this.fields_alias).then(function (response) {
					_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-sites-alias/').then(function (alias) {
						_this2.siteAliasList = alias.data;
						_this2.fields_alias = [{ site: '', alias: '' }];
					});
					console.log(response);
				});
			},
			addNewField: function addNewField() {
				this.fields_alias.push((0, _assign2.default)({}, this.formField));
			},
			removeField: function removeField(index) {
				this.$delete(this.fields_alias, index);
			},
			getFilteredReport: function getFilteredReport(allReportArr, domainToMatch) {
				return allReportArr.filter(function (x) {
					return x['site'] == domainToMatch;
				});
			},
			getFormattedDate: function getFormattedDate(date) {
				var report_date = new Date(date);
				var dd = report_date.getDate();
				var mm = report_date.getMonth() + 1;
				var yyyy = report_date.getFullYear();
	
				if (dd < 10) {
					dd = '0' + dd;
				}
	
				if (mm < 10) {
					mm = '0' + mm;
				}
	
				report_date = yyyy + '-' + mm + '-' + dd;
				return report_date;
			},
			getRoundedNumbers: function getRoundedNumbers(val) {
				var n = (0, _parseFloat2.default)(val);
				if (!val || isNaN(n) || n < 0) return 0;
				return n.toFixed(2);
			},
			cancelUploadAction: function cancelUploadAction() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			},
			upload: function upload(_upload) {
				this.frmdata.append('reportFile', _upload.file);
			},
			submitUpload: function submitUpload() {
				var _this3 = this;
	
				this.$refs.upload.submit();
	
				this.report_date = this.report_date;
	
				this.frmdata.append('report_date', this.report_date);
				this.frmdata.append('bidder', 'site_alias_bulk');
				this.frmdata.append('report_type', this.reportType);
				this.uploading = true;
				_axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/upload/', this.frmdata).then(function (response) {
					_this3.uploading = false;
					_axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'reports/v1/report-sites-alias/').then(function (alias) {
						_this3.siteAliasList = alias.data;
					});
					_this3.notificationMsg(response.data.status ? 'Success' : 'Error', response.data.data.message);
					if (response.data.status == 'Success') {
						_this3.UploadScreenVisible = false;
						_this3.$refs.upload.clearFiles();
					} else {
						_this3.UploadScreenVisible = false;
					}
				}).catch(function (e) {
					console.log('test', e.response);
					_this3.uploading = false;
					_this3.notificationMsg(e.response.data.status ? 'Success' : 'Error', e.response.data.data.message);
				});
			},
			clearFilesList: function clearFilesList() {
				this.$refs.upload.clearFiles();
				this.UploadScreenVisible = false;
			}
	
		}
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventBus = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      auditLogs: [],
	      name: '',
	      current_page: 1
	    };
	  },
	
	  mounted: function mounted() {
	    console.log('Control sidebar mounted');
	    _eventBus.EventBus.$on('update_logs', function () {
	      console.log('update_logs event caught!!!');
	    });
	  },
	  name: 'ControlSidebar',
	  created: function created() {
	    this.fetchLogs();
	  },
	  filters: {
	    action: function action(value) {
	      if (!value) return '';
	      var action = value;
	      action = action.toLowerCase();
	      action = action.split('_').join(' ');
	      return action;
	    }
	  },
	  methods: {
	    fetchLogs: function fetchLogs() {
	      var _this = this;
	
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + ('v1/audit-log/?limit=20&offset=0&domain_id=' + this.$route.params.domId)).then(function (response) {
	        console.log(response.data.results);
	        _this.auditLogs = response.data.results;
	      }).catch(function (err) {
	        console.log('Error', err);
	      });
	
	      $(document).ready(function ($) {
	        $('.navbar-stacked').slimScroll({
	          position: 'right',
	          size: '3px',
	          height: '95vh'
	        });
	      });
	    },
	    infiniteHandler: function infiniteHandler($state) {
	      var _this2 = this;
	
	      _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/audit-log/', {
	        params: {
	          limit: 20,
	          offset: this.current_page - 1
	        }
	      }).then(function (_ref) {
	        var data = _ref.data;
	
	        console.log(data);
	        if (data.results.length) {
	          var _auditLogs;
	
	          _this2.current_page += 1;
	          (_auditLogs = _this2.auditLogs).push.apply(_auditLogs, (0, _toConsumableArray3.default)(data.results));
	          $state.loaded();
	        } else {
	          $state.complete();
	        }
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardFooter'
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(14);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	var _eventBus = __webpack_require__(27);
	
	var _pusherJs = __webpack_require__(249);
	
	var _pusherJs2 = _interopRequireDefault(_pusherJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setdata = function setdata(params, path) {
	    if (path) for (var key in params) {
	        path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);
	    }return path;
	},
	    getTopBarNav = function getTopBarNav(controllerName, params, callback) {
	    console.log('Controller Name');
	    console.log(controllerName);
	    console.log(params);
	    switch (controllerName) {
	        case 'DomainContext':
	        case 'DomainBucket':
	        case 'DomainContext':
	        case 'BlockCategories':
	        case 'BlockURLS':
	        case 'EditDomain':
	        case 'FiSetupAdSpots':
	        case 'Layout':
	        case 'HbTagParams':
	        case 'ModifyHbTag':
	        case 'HbTagParamSet':
	        case 'HbTagParamsAMP':
	        case 'CreateHbTag':
	        case 'CreateHbTagAmp':
	        case 'Manage Services':
	        case 'ads.txt':
	        case 'KeywordBlock':
	        case 'Manage Stories':
	        case 'Create Manage Service Tag':
	            var path = 'v1/publishers/{uuid}/domains/{domId}/';
	            path = setdata(params, path);
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + path).then(function (response) {
	                callback({
	                    selectedBucketDetails: {},
	                    domain: {
	                        id: response.data.id,
	                        name: response.data.name,
	                        domuuid: response.data.uuid
	                    },
	                    bucket: [],
	                    currentBucket: undefined
	                });
	            });
	            break;
	
	        case 'BucketDetails':
	        case 'CreateDirectCampaign':
	        case 'AllDirectCampaign':
	        case 'FirstImpression':
	        case 'BucketSettings':
	        case 'AxtModule':
	        case 'StickyModule':
	        case 'CreateHbTag':
	        case 'CreateHbTagAmp':
	        case 'FiTagAssociation':
	        case 'Header-Bidding-Tags':
	            var domPath = 'v1/publishers/{uuid}/domains/{domId}/';
	            domPath = setdata(params, domPath);
	
	            _axios2.default.get(("https://beta-yeti-api.automatad.com/") + domPath).then(function (response) {
	                var selectedBucketDetails = {};
	                for (var i = 0; i < response.data.buckets.length; i++) {
	                    if (response.data.buckets[i].id == params.bucketId) selectedBucketDetails = response.data.buckets[i];
	                }callback({
	                    selectedBucketDetails: selectedBucketDetails,
	                    domain: {
	                        id: response.data.id,
	                        name: response.data.name,
	                        domuuid: response.data.uuid
	                    },
	                    bucket: response.data.buckets,
	                    currentBucket: params.bucketId
	                });
	            });
	            break;
	        case 'ReportsRevenue':
	            console.log('this.$route.params.pubid');
	            console.log(8);
	
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'reports/v1/pub-get-dash-info/', {
	                publisherId: params.pubid
	            }).then(function (response) {
	                if (response.data.status) {
	                    var domain = response.data.data.find(function (k) {
	                        return params.domid == k.domain_id;
	                    });
	                    console.log(response.data);
	
	                    callback({
	                        selectedBucketDetails: {},
	                        domain: {
	                            id: domain.domain_id,
	                            name: domain.domain_name
	                        },
	                        bucket: [],
	                        currentBucket: undefined
	                    });
	                }
	            }).catch(function (e) {});
	            break;
	        default:
	            callback({
	                selectedBucketDetails: {},
	                currentBucket: undefined,
	                domain: {},
	                bucket: []
	            });
	            break;
	    }
	},
	    bindEvent = function bindEvent(el, event, fn) {
	    el.addEventListener ? el.addEventListener(event, fn, false) : el.attachEvent && el.attachEvent('on' + event, fn);
	},
	    unbindEvent = function unbindEvent(el, event, fn) {
	    el.removeEventListener ? el.removeEventListener(event, fn) : el.detachEvent && el.detachEvent('on' + event, fn);
	};
	exports.default = {
	    name: 'DashboardHeader',
	    data: function data() {
	        return {
	            selectedBucketDetails: {},
	            currentBucket: undefined,
	            isDirty: false,
	            dropDownOpen: false,
	            domain: {},
	            bucket: [],
	            uuid: this.$route.params.uuid,
	            search: {
	                binded: false,
	                showSearch: false,
	                networkcall: false,
	                showres: false,
	                timer: undefined,
	                query: undefined,
	                domains: []
	            },
	            allNotifications: []
	        };
	    },
	
	    props: {
	        domain_details: Object,
	        is90d: Boolean
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        console.log('this.$route.name');
	        console.log(this.$route.name);
	        getTopBarNav(this.$route.name, this.$route.params, function (topbar) {
	            _this2.currentBucket = topbar.currentBucket;
	            _this2.bucket = topbar.bucket;
	            _this2.domain = topbar.domain;
	            _this2.selectedBucketDetails = topbar.selectedBucketDetails;
	        });
	    },
	    created: function created() {
	        var _this3 = this;
	
	        console.log(this.domain_details);
	        var pusher = new (Function.prototype.bind.apply(_pusherJs2.default, [null].concat((0, _toConsumableArray3.default)(JSON.parse(("[\"3303e5b7-4140-40df-9cdd-a35553aa89f7\",{\"wsHost\":\"yeti-5f3965ef-a935-417c-b425-3da6e7bdf4d5.automatad.workers.dev\",\"wsPort\":443,\"wssPort\":443,\"forceTLS\":true,\"encrypted\":true,\"disableStats\":true,\"enabledTransports\":[\"ws\",\"wss\"],\"cluster\":\"ap2\",\"channelAuthorization\":{\"endpoint\":\"https://yeti-api.automatad.com/v1/auth/services/pusher\",\"headers\":{\"Authorization\":\"JWT AUTH_TOKEN_HERE\"}}}]").replace('AUTH_TOKEN_HERE', this.$auth.token()))))))();
	
	        console.log(pusher);
	        var channel = pusher.subscribe('private-test');
	        console.log(channel);
	        var self = this;
	        channel.bind('my-event', function (data) {
	            console.log("PUSHER DATA", data);
	            if (data.type == 'complete') {
	                _eventBus.EventBus.$emit('update_logs', {});
	            }
	
	            var existing = self.allNotifications.filter(function (notif) {
	                return notif.id == data.id;
	            });
	            if (existing[0]) {
	                existing[0].type = data.type;
	                existing[0].message = data.message;
	                existing[0].timestamp = data.timestamp;
	                console.log(self.allNotifications);
	            } else {
	                self.allNotifications.push(data);
	                console.log(self.allNotifications);
	            }
	            if (!_this3.dropDownOpen) self.$refs.notifDot.style.display = 'block';
	        });
	    },
	    methods: {
	        createJs: function createJs() {
	            var _this4 = this;
	
	            _axios2.default.post(("https://beta-yeti-api.automatad.com/") + 'v1/cdn_push/', {
	                bucketId: this.$route.params.bucketId
	            }).then(function (response) {
	                var type = 'Error',
	                    message = 'Oops Something went wrong!';
	                if (response.data.response_data.status) {
	                    type = 'Success';
	                    message = response.data.response_data.message;
	                } else {
	                    type = 'Error';
	                    message = response.data.response_data.message;
	                }
	                _this4.$notify({
	                    title: type,
	                    message: message,
	                    type: type.toLowerCase()
	                });
	            });
	        },
	        bucketChange: function bucketChange(command) {
	            var _this5 = this;
	
	            setTimeout(function () {
	                _this5.$router.push('/admin/publisher/' + _this5.$route.params.uuid + '/domain/' + _this5.$route.params.domId + '/buckets/' + command);
	            });
	        },
	        toogleSearch: function toogleSearch() {
	            var _this = this,
	                keyUpBind = function keyUpBind(e) {
	                if (e.keyCode == 27 && _this.search.binded) {
	                    _this.search.showSearch = !_this.search.showSearch;
	                    unbindEvent(document, 'keyup', keyUpBind);
	                    _this.search.binded = false;
	                }
	            };
	
	            this.search.showSearch = !this.search.showSearch;
	
	            if (this.search.showSearch && !this.search.binded) {
	                bindEvent(document, 'keyup', keyUpBind);
	                jQuery('.search-overflow').fadeIn(10);
	                jQuery('.search-overflow input').focus();
	                this.search.binded = true;
	            } else if (this.search.binded) {
	                unbindEvent(document, 'keyup', keyUpBind);
	                this.search.binded = false;
	            }
	        },
	        redirect: function redirect(path) {
	            this.toogleSearch();
	        },
	        searchDomPub: function searchDomPub() {
	            var _this6 = this;
	
	            window.clearTimeout(this.search.timer);
	            this.search.timer = setTimeout(function () {
	                _this6.search.networkcall = true;
	                _axios2.default.get(("https://beta-yeti-api.automatad.com/") + 'v1/search/?query=' + _this6.search.query).then(function (response) {
	                    _this6.search.networkcall = false;
	                    _this6.search.domains = response.data.results;
	                    _this6.search.showres = true;
	                    window.setTimeout(function () {
	                        _letterAvatar2.default.transform();
	                    });
	                });
	            }, 500);
	        },
	        notifDropdownToggle: function notifDropdownToggle(evt) {
	            var _this7 = this;
	
	            this.dropDownOpen = !this.dropDownOpen;
	            if (evt) this.$refs.notifDot.style.display = 'none';
	            if (!evt) {
	                window.setTimeout(function () {
	                    _this7.allNotifications = _this7.allNotifications.filter(function (notif) {
	                        return !(notif.type == 'complete');
	                    });
	                }, 1000);
	            }
	        }
	    },
	    watch: {
	        $route: function $route(newUrl, oldUrl) {
	            var _this8 = this;
	
	            console.log(this.is90d);
	            if (newUrl.path !== oldUrl.path) {
	                getTopBarNav(newUrl.name, newUrl.params, function (topbar) {
	                    _this8.currentBucket = topbar.currentBucket;
	                    _this8.bucket = topbar.bucket;
	                    _this8.domain = topbar.domain;
	                    _this8.selectedBucketDetails = topbar.selectedBucketDetails;
	                });
	            }
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAvatar = __webpack_require__(80);
	
	var _vueAvatar2 = _interopRequireDefault(_vueAvatar);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _letterAvatar = __webpack_require__(16);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sidebarObj = {
	    Domain: [{
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/dfp-settings/',
	        name: 'DFP Settings',
	        modules: []
	    }, {
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-alt" class="svg-inline--fa fa-file-alt fa-w-12" role="img" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/></svg>',
	        isSvg: true,
	        path: '/admin/reports/',
	        name: 'Reports',
	        modules: []
	    }],
	
	    EditDomain: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/edit/{domId}/',
	        name: 'Buckets',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/adstxt/{domId}/',
	        name: 'Ads.txt',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/KeywordBlock/{domId}/',
	        name: 'Keyword Block',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="far" data-icon="browser" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-browser fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 92c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V92zm416 334c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V168h416v258zm0-310c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12V92c0-6.6 5.4-12 12-12h280c6.6 0 12 5.4 12 12v24z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/layout-setup/',
	        name: 'Layouts',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="far" data-icon="audio-description" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-audio-description fa-w-16 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zm-212.541-63.861l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm-82.534-97.43l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zM331.2 160h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386 0-58.977-37.919-95.614-98.96-95.614zm-1.801 145.39h-14.523v-98.78h14.523c28.685 0 46.175 16.767 46.175 49.005 0 32.098-16.399 49.775-46.175 49.775z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/ad-spot-setup/',
	        name: 'Ad Spots',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="far" data-icon="heading" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-heading fa-w-14 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M300 80h36.703v149.983H111.297V80H148c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v24c0 6.627 5.373 12 12 12h35.841v352H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h136c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-36.703V282.016h225.406V432H300c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h136c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-35.841V80H436c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H300c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12z" class=""></path></svg>',
	        isSvg: true,
	
	        name: 'Header Bidding',
	        modules: [{
	            link: '/admin/publisher/{uuid}/domain/{domId}/hb-tags/',
	            name: 'HB Ad Units'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/hb-tag-param-sets/',
	            name: 'HB Param sets'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/hb-tags-amp/',
	            name: 'HB AMP'
	        }]
	    }, {
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve"><g><g id="do-not-disturb"><path d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204    c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35    L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z" style="fill: rgb(255, 255, 255);"></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/settings/block-urls/',
	        name: 'URL Block',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/settings/edit/',
	        name: 'Domain Settings',
	        modules: []
	    }],
	
	    CreateTag: [{
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	        name: 'Manage Service',
	        modules: [{
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	            name: 'Tags'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
	            name: 'Stories'
	        }]
	    }],
	
	    CreateStory: [{
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	        name: 'Manage Service',
	        modules: [{
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
	            name: 'Stories'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	            name: 'Tags'
	        }]
	    }],
	
	    ManageService: [{
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	        name: 'Manage Service',
	        modules: [{
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	            name: 'Tags'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
	            name: 'Stories'
	        }]
	    }],
	
	    DomainBucket: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/edit/{domId}/',
	        name: 'Back to Bucket',
	        modules: []
	    }],
	
	    BucketDetails: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/edit/{domId}',
	        name: 'Back to Bucket',
	        modules: []
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/settings',
	        name: 'Settings',
	        modules: []
	    }],
	    DfpSettings: [{
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18"  width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/dfp-settings/',
	        name: 'DFP Settings',
	        modules: []
	    }],
	    CreateHbTag: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
	        name: 'Back to Bucket',
	        modules: []
	    }],
	    ModifyHbTag: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
	        name: 'Back to Bucket',
	        modules: []
	    }],
	    HbTagParams: [{
	        icon: '<svg aria-hidden="true" data-prefix="fab" data-icon="bitbucket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-bitbucket fa-w-16"  width="20px" height="20px"><path fill="currentColor" d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/',
	        name: 'Back to Bucket',
	        modules: []
	    }],
	    ReportConfig: [{
	        icon: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cogs" class="svg-inline--fa fa-cogs fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"></path></svg>',
	        isSvg: true,
	        path: '/admin/reports/config',
	        name: 'Reports Config',
	        modules: []
	    }],
	    ReportParams: [{
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"/></svg>',
	        isSvg: true,
	        path: '/admin/reports/',
	        name: 'Back to Reports',
	        modules: []
	    }],
	    StoryInfo: [{
	        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="64" viewBox="0 0 64 64" width="20"><g stroke-width=".067977" transform="matrix(2.4789208 0 0 2.4789208 -38.400527 -41.65855)"><circle cx="28.399668" cy="29.713959" fill="#0479c2" r="12.908843"/><path d="m29.364937 27.763019h3.12695s.65938 0 .31949.747747l-5.39058 8.972973h-.99926l.95168-5.866421-3.17453-.02039s-.56421-.224324-.13596-.951679l5.30221-8.769041h1.04005z" fill="#fff"/></g></svg>',
	        isSvg: true,
	        path: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	        name: 'Manage Service',
	        modules: [{
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-story',
	            name: 'Stories'
	        }, {
	            link: '/admin/publisher/{uuid}/domain/{domId}/manage-service',
	            name: 'Tags'
	        }]
	    }, {
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/stories/{storyId}/settings',
	        name: 'Configuration',
	        modules: []
	    }],
	    StoryParams: [{
	        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="sliders-h" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-sliders-h fa-w-18" width="20px" height="20px"><path fill="currentColor" d="M576 80v40c0 6.6-5.4 12-12 12H160v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h84v-8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v8h404c6.6 0 12 5.4 12 12zm-12 148h-84v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h404v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0 160H288v-8c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v8H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h212v8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-8h276c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z" class=""></path></svg>',
	        isSvg: true,
	        path: '/admin/stories/{storyId}/settings',
	        name: 'Configuration',
	        modules: []
	    }]
	};
	
	exports.default = {
	    name: 'DashboardSidebar',
	    data: function data() {
	        return {
	            navigation: [],
	            currentPath: this.$route.path
	        };
	    },
	
	
	    props: {
	        domain_details: Object,
	        is90d: Boolean
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        this.getSideBar(this.$route.name, this.$route.params, function (navigation) {
	            _this2.navigation = navigation;
	            window.setTimeout(function () {
	                _letterAvatar2.default.transform();
	            });
	        });
	
	        $(document).ready(function ($) {
	            $('.main-sidebar > div').slimScroll({
	                width: '230px',
	                position: 'left',
	                size: '3px',
	                height: '95vh'
	            });
	        });
	
	        var _this = this;
	        $(document).on('click', '#prod-association', function () {
	            window.setTimeout(function () {
	                _this.getSideBar(_this.$route.name, _this.$route.params, function (navigation) {
	                    _this.navigation = navigation;
	                    window.setTimeout(function () {
	                        _letterAvatar2.default.transform();
	                    });
	                });
	            }, 1000);
	        });
	    },
	    components: {
	        Avatar: _vueAvatar2.default
	    },
	    computed: {
	        _get_user: function _get_user() {
	            var token = window.localStorage && localStorage['default_auth_token'];
	            if (token) {
	                var base64Url = token.split('.')[1];
	                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
	                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	                }).join(''));
	
	                return JSON.parse(jsonPayload);
	            } else return undefined;
	        },
	        hasAccess: function hasAccess() {
	            return [3, 8, 41, 155, 310, 290, 314].includes(this._get_user && this._get_user.user_id);
	        }
	    },
	    watch: {
	        $route: function $route(newUrl, oldUrl) {
	            var _this3 = this;
	
	            console.log(newUrl);
	            console.log(oldUrl);
	            if (newUrl.path !== oldUrl.path) {
	                this.getSideBar(newUrl.name, newUrl.params, function (navigation, referPath) {
	                    _this3.currentPath = _this3.$route.path;
	                    _this3.navigation = navigation;
	                    window.setTimeout(function () {
	                        _letterAvatar2.default.transform();
	                    });
	                });
	            }
	        },
	        deep: true
	    },
	    methods: {
	        getSideBar: function getSideBar(controllerName, params, callback) {
	            var _this4 = this;
	
	            console.log('Controller Name' + controllerName);
	            console.log(this.$route.path);
	            var setdata = function setdata(params, path) {
	                if (path) for (var key in params) {
	                    path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);
	                }return path;
	            },
	                fixUrl = function fixUrl(navArray) {
	                for (var i = 0; i < navArray.length; i++) {
	                    navArray[i].path = setdata(params, navArray[i].path);
	                }return navArray;
	            },
	                cloneArray = function cloneArray(array) {
	                return JSON.parse((0, _stringify2.default)(array));
	            },
	                navbar = [];
	            var routeSplit = this.$route.path.split('/');
	            if (routeSplit[2] == 'undefined') {
	                navbar = cloneArray(sidebarObj.Domain);
	                callback(navbar);
	            } else {
	                switch (controllerName) {
	                    case 'Domain':
	                    case 'Stories':
	                    case 'StoriesUndef':
	                        navbar = cloneArray(sidebarObj.Domain);
	                        callback(navbar);
	                        break;
	
	                    case 'Manage Services':
	                        navbar = cloneArray(sidebarObj.ManageService);
	                        navbar.forEach(function (nav) {
	                            if (nav.modules.length > 0) {
	                                nav.modules.forEach(function (mod) {
	                                    mod.link = setdata(_this4.$route.params, mod.link);
	                                });
	                            }
	                        });
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'Modify Manage Service Tag':
	                    case 'Create Manage Service Tag':
	                        navbar = cloneArray(sidebarObj.CreateTag);
	                        navbar.forEach(function (nav) {
	                            if (nav.modules.length > 0) {
	                                nav.modules.forEach(function (mod) {
	                                    mod.link = setdata(_this4.$route.params, mod.link);
	                                });
	                            }
	                        });
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'Stories Create':
	                    case 'Manage Stories':
	                        navbar = cloneArray(sidebarObj.CreateStory);
	                        navbar.forEach(function (nav) {
	                            if (nav.modules.length > 0) {
	                                nav.modules.forEach(function (mod) {
	                                    mod.link = setdata(_this4.$route.params, mod.link);
	                                });
	                            }
	                        });
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'EditDomain':
	                    case 'DomainContext':
	                    case 'AdsText':
	                    case 'KeywordBlock':
	                    case 'HbTagParams':
	                    case 'HbTagDimensionParams':
	                    case 'HbTagParamSet':
	                    case 'Layout':
	                    case 'ModifyHbTag':
	                    case 'ModifyHbTagAmp':
	                    case 'BlockURLS':
	                    case 'HbTagParamsAMP':
	                    case 'CreateHbTag':
	                    case 'CreateHbTagAmp':
	                    case 'FiSetupAdSpots':
	                        navbar = cloneArray(sidebarObj.EditDomain);
	                        navbar.forEach(function (nav) {
	                            if (nav.modules.length > 0) {
	                                nav.modules.forEach(function (mod) {
	                                    mod.link = setdata(_this4.$route.params, mod.link);
	                                });
	                            }
	                        });
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'AxtModule':
	                    case 'Header-Bidding-Tags':
	                    case 'AllDirectCampaign':
	                    case 'StickyModule':
	                    case 'FirstImpression':
	                    case 'FiTagAssociation':
	                    case 'BucketDetails':
	                    case 'BucketSettings':
	                    case 'StoryModule':
	                        navbar = cloneArray(sidebarObj.BucketDetails);
	                        var path = 'v1/publishers/{uuid}/domains/{domId}/buckets/{bucketId}/products/';
	                        path = setdata(params, path);
	
	                        _axios2.default.all([_axios2.default.get(("https://beta-yeti-api.automatad.com/") + path)]).then(_axios2.default.spread(function (response) {
	                            var redirPath = undefined;
	                            for (var i = 0; i < response.data.length; i++) {
	                                if (response.data[i].product) {
	                                    var modules = cloneArray(response.data[i].product.modules);
	                                    for (var j = 0; j < modules.length; j++) {
	                                        modules[j].link = '/admin/publisher/{uuid}/domain/{domId}/buckets/{bucketId}/' + modules[j].code.toLowerCase() + '/';
	                                        modules[j].link = setdata(params, modules[j].link);
	
	                                        if (j == 0) redirPath = modules[j].link;
	                                    }
	
	                                    navbar.push({
	                                        icon: '<svg aria-hidden="true" data-prefix="fas" data-icon="text-height" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-text-height fa-w-18 fa-2x" width="20px" height="20px"><path fill="currentColor" d="M16 32h288c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-35.496c-8.837 0-16-7.163-16-16V96h-54.761v320H232c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H88c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h34.257V96H67.496v48c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16zm475.308 4.685l79.995 80.001C581.309 126.693 574.297 144 559.99 144H512v224h48c15.639 0 20.635 17.991 11.313 27.314l-79.995 80.001c-6.247 6.247-16.381 6.245-22.626 0l-79.995-80.001C378.691 385.307 385.703 368 400.01 368H448V144h-48c-15.639 0-20.635-17.991-11.313-27.314l79.995-80.001c6.247-6.248 16.381-6.245 22.626 0z" class=""></path></svg>',
	                                        isSvg: true,
	                                        path: undefined,
	                                        name: response.data[i].product.name,
	                                        modules: modules
	                                    });
	                                }
	                            }
	
	                            navbar = fixUrl(navbar);
	                            if (!redirPath) redirPath = navbar[0].path;
	                            callback(navbar, redirPath);
	                        }));
	                        break;
	
	                    case 'DomainBucket':
	                        navbar = sidebarObj.DomainBucket;
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	                    case 'ads.txt':
	                        navbar = sidebarObj.ads.txt;
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	                    case 'KeywordBlock':
	                        navbar = sidebarObj.KeywordBlock;
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	
	                    case 'DfpSettings':
	                        navbar = sidebarObj.DfpSettings.slice(0);
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'MediaList':
	                        navbar = sidebarObj.MediaList.slice(0);
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'CreateHbTag':
	                        navbar = sidebarObj.CreateHbTag.slice(0);
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'ModifyHbTag':
	                        navbar = sidebarObj.ModifyHbTag.slice(0);
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'StoriesInfo':
	                        navbar = cloneArray(sidebarObj.StoryInfo);
	                        navbar.forEach(function (nav) {
	                            if (nav.modules.length > 0) {
	                                nav.modules.forEach(function (mod) {
	                                    mod.link = setdata(_this4.$route.params, mod.link);
	                                });
	                                console.log('Route');
	                                console.log(_this4.$route.params);
	                            }
	                        });
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'CreatePage':
	                    case 'StoryConfig':
	                        path = '/admin/stories/{storyId}/config';
	                        path = setdata(params, path);
	                        navbar = sidebarObj.StoryParams.slice(0);
	                        navbar[1].path = '/admin/stories/' + this.$route.params.storyId + '/settings';
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	
	                        break;
	
	                    case 'reportApproval':
	                    case 'BidderDfpReport':
	                    case 'ReportsConfig':
	                        path = '/admin/reports/';
	                        path = setdata(params, path);
	                        navbar = sidebarObj.ReportParams.slice(0);
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    case 'Reports':
	                        navbar = cloneArray(sidebarObj.ReportConfig.slice(0));
	                        navbar = fixUrl(navbar);
	                        callback(navbar);
	                        break;
	
	                    default:
	                        callback([]);
	                        break;
	                }
	            }
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.JustDigits = undefined;
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JustDigits = exports.JustDigits = function JustDigits() {
		_vue2.default.directive('digitsonly', function (el, binding) {
			if (/[\d\.]+/i.test(el.value)) {} else {
				var newValue = el.value.replace(/[a-zA-Z]+/ig, '');
				el.value = newValue;
				binding.value = el.value;
			}
		});
		_vue2.default.directive('validstring', function (el, binding) {
			var newValue = el.value.replace(/[^a-zA-Z0-9]/g, "");
			console.log(newValue);
			el.value = newValue;
			binding.value = el.value;
		});
	};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  request: function request(req, token) {
	    this.options.http._setHeaders.call(this, req, { Authorization: 'JWT ' + token });
	  },
	
	  response: function response(res) {
	    if (res.data.token) {
	      return res.data.token;
	    }
	  }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Dashboard = __webpack_require__(587);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _ = __webpack_require__(621);
	
	var _2 = _interopRequireDefault(_);
	
	var _BlankPage = __webpack_require__(620);
	
	var _BlankPage2 = _interopRequireDefault(_BlankPage);
	
	var _Login = __webpack_require__(611);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Logout = __webpack_require__(612);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	var _3 = __webpack_require__(622);
	
	var _4 = _interopRequireDefault(_3);
	
	var _ResetPassword = __webpack_require__(613);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _ChangePassword = __webpack_require__(610);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _AllPublisher = __webpack_require__(594);
	
	var _AllPublisher2 = _interopRequireDefault(_AllPublisher);
	
	var _Bidders = __webpack_require__(595);
	
	var _Bidders2 = _interopRequireDefault(_Bidders);
	
	var _Domain = __webpack_require__(618);
	
	var _Domain2 = _interopRequireDefault(_Domain);
	
	var _BulkDomain = __webpack_require__(616);
	
	var _BulkDomain2 = _interopRequireDefault(_BulkDomain);
	
	var _BulkLineItem = __webpack_require__(617);
	
	var _BulkLineItem2 = _interopRequireDefault(_BulkLineItem);
	
	var _Publisher = __webpack_require__(619);
	
	var _Publisher2 = _interopRequireDefault(_Publisher);
	
	var _Adspotofbidders = __webpack_require__(592);
	
	var _Adspotofbidders2 = _interopRequireDefault(_Adspotofbidders);
	
	var _reports = __webpack_require__(609);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _AddPublisher = __webpack_require__(588);
	
	var _AddPublisher2 = _interopRequireDefault(_AddPublisher);
	
	var _PaymentForm = __webpack_require__(606);
	
	var _PaymentForm2 = _interopRequireDefault(_PaymentForm);
	
	var _PreviewPDF = __webpack_require__(256);
	
	var _PreviewPDF2 = _interopRequireDefault(_PreviewPDF);
	
	var _Publisher3 = __webpack_require__(607);
	
	var _Publisher4 = _interopRequireDefault(_Publisher3);
	
	var _EditPublisher = __webpack_require__(603);
	
	var _EditPublisher2 = _interopRequireDefault(_EditPublisher);
	
	var _PublisherInfo = __webpack_require__(608);
	
	var _PublisherInfo2 = _interopRequireDefault(_PublisherInfo);
	
	var _DomainContext = __webpack_require__(601);
	
	var _DomainContext2 = _interopRequireDefault(_DomainContext);
	
	var _AdsText = __webpack_require__(589);
	
	var _AdsText2 = _interopRequireDefault(_AdsText);
	
	var _KeywordBlock = __webpack_require__(604);
	
	var _KeywordBlock2 = _interopRequireDefault(_KeywordBlock);
	
	var _Profile = __webpack_require__(640);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Demo = __webpack_require__(639);
	
	var _Demo2 = _interopRequireDefault(_Demo);
	
	var _AxtModule = __webpack_require__(614);
	
	var _AxtModule2 = _interopRequireDefault(_AxtModule);
	
	var _ConfigStickyTemplate = __webpack_require__(615);
	
	var _ConfigStickyTemplate2 = _interopRequireDefault(_ConfigStickyTemplate);
	
	var _ConfigHbTemplate = __webpack_require__(638);
	
	var _ConfigHbTemplate2 = _interopRequireDefault(_ConfigHbTemplate);
	
	var _AllDomain = __webpack_require__(593);
	
	var _AllDomain2 = _interopRequireDefault(_AllDomain);
	
	var _CreateDomain = __webpack_require__(599);
	
	var _CreateDomain2 = _interopRequireDefault(_CreateDomain);
	
	var _DomainBucket = __webpack_require__(600);
	
	var _DomainBucket2 = _interopRequireDefault(_DomainBucket);
	
	var _EditDomain = __webpack_require__(602);
	
	var _EditDomain2 = _interopRequireDefault(_EditDomain);
	
	var _BucketDetails = __webpack_require__(598);
	
	var _BucketDetails2 = _interopRequireDefault(_BucketDetails);
	
	var _Notes = __webpack_require__(605);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	var _HBBucketTags = __webpack_require__(626);
	
	var _HBBucketTags2 = _interopRequireDefault(_HBBucketTags);
	
	var _DfpSettings = __webpack_require__(624);
	
	var _DfpSettings2 = _interopRequireDefault(_DfpSettings);
	
	var _EditDfp = __webpack_require__(625);
	
	var _EditDfp2 = _interopRequireDefault(_EditDfp);
	
	var _CreateHbTag = __webpack_require__(623);
	
	var _CreateHbTag2 = _interopRequireDefault(_CreateHbTag);
	
	var _ModifyHbTag = __webpack_require__(630);
	
	var _ModifyHbTag2 = _interopRequireDefault(_ModifyHbTag);
	
	var _HbTagParamsNew = __webpack_require__(629);
	
	var _HbTagParamsNew2 = _interopRequireDefault(_HbTagParamsNew);
	
	var _HbTagDimensionParams = __webpack_require__(627);
	
	var _HbTagDimensionParams2 = _interopRequireDefault(_HbTagDimensionParams);
	
	var _HbTagParamSet = __webpack_require__(628);
	
	var _HbTagParamSet2 = _interopRequireDefault(_HbTagParamSet);
	
	var _BlockCategories = __webpack_require__(596);
	
	var _BlockCategories2 = _interopRequireDefault(_BlockCategories);
	
	var _BlockUrls = __webpack_require__(597);
	
	var _BlockUrls2 = _interopRequireDefault(_BlockUrls);
	
	var _CreateDirectCampaign = __webpack_require__(632);
	
	var _CreateDirectCampaign2 = _interopRequireDefault(_CreateDirectCampaign);
	
	var _AllDirectCampaign = __webpack_require__(631);
	
	var _AllDirectCampaign2 = _interopRequireDefault(_AllDirectCampaign);
	
	var _FirstImpression = __webpack_require__(636);
	
	var _FirstImpression2 = _interopRequireDefault(_FirstImpression);
	
	var _FiSetupAdSpots = __webpack_require__(634);
	
	var _FiSetupAdSpots2 = _interopRequireDefault(_FiSetupAdSpots);
	
	var _DiagRedirect = __webpack_require__(633);
	
	var _DiagRedirect2 = _interopRequireDefault(_DiagRedirect);
	
	var _Layout = __webpack_require__(637);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _FiTagAssociation = __webpack_require__(635);
	
	var _FiTagAssociation2 = _interopRequireDefault(_FiTagAssociation);
	
	var _ReportsAdmin = __webpack_require__(643);
	
	var _ReportsAdmin2 = _interopRequireDefault(_ReportsAdmin);
	
	var _ReportsAdminApproval = __webpack_require__(644);
	
	var _ReportsAdminApproval2 = _interopRequireDefault(_ReportsAdminApproval);
	
	var _ReportsConfig = __webpack_require__(645);
	
	var _ReportsConfig2 = _interopRequireDefault(_ReportsConfig);
	
	var _BidderRevenueReports = __webpack_require__(642);
	
	var _BidderRevenueReports2 = _interopRequireDefault(_BidderRevenueReports);
	
	var _BidderDfpReport = __webpack_require__(641);
	
	var _BidderDfpReport2 = _interopRequireDefault(_BidderDfpReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	    path: '*',
	    redirect: '/admin/domains'
	}, {
	    path: '/',
	    redirect: '/login',
	    meta: {
	        auth: {
	            auth: false
	        }
	    }
	}, {
	    path: '/admin/domains/',
	    name: 'Admin',
	    component: _Dashboard2.default,
	    meta: {
	        auth: true
	    },
	
	    beforeEnter: function beforeEnter(_to, _from, next) {
	        document.body.className += 'skin-gradient sidebar-mini';
	        next();
	    },
	    activate: function activate() {
	        this.$nextTick(function () {});
	    },
	    children: [{
	        path: '/admin/publisher/add',
	        name: 'AddPublisher',
	        component: _AddPublisher2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/publishers/',
	        name: 'AllPublisher',
	        component: _AllPublisher2.default,
	
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/publisher/:pubid/ReportsRevenue/:domid',
	        name: 'ReportsRevenue',
	        component: _reports2.default,
	
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/',
	        name: 'Bidders',
	        component: _Bidders2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/create-publisher',
	        name: 'BidderPublisher',
	        component: _Publisher2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/create-bulk-line-item',
	        name: 'BulkLineItem',
	        component: _BulkLineItem2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/create-domain',
	        name: 'BidderDomain',
	        component: _Domain2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/create-bulk-domain',
	        name: 'BidderBulkDomain',
	        component: _BulkDomain2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/bidders/domain/:domId',
	        name: 'BidderDomain',
	        component: _Domain2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/lineitems/:id',
	        name: 'lineitems',
	        component: _Adspotofbidders2.default,
	
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/publisher/contract/:id',
	        name: 'PaymentForm',
	        component: _PaymentForm2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/publisher/previewpdf',
	        name: 'PreviewPDF',
	        component: _PreviewPDF2.default,
	        meta: {
	            auth: {
	                auth: true
	            }
	        }
	    }, {
	        path: '/admin/password/change',
	        name: 'ChangePassword',
	        component: _ChangePassword2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher',
	        name: 'Publisher',
	        component: _Publisher4.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/domains',
	        name: 'Domain',
	        component: _AllDomain2.default,
	        meta: {
	            auth: true
	        },
	        children: [{ path: 'notes/:domid', component: _Notes2.default }]
	    }, {
	        path: '/admin/create-domain',
	        name: 'CreateDomain',
	        component: _CreateDomain2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/edit/:uuid',
	        name: 'EditPublisher',
	        component: _EditPublisher2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/',
	        name: 'DomainBucket',
	        component: _DomainBucket2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/',
	        name: 'BucketDetails',
	        component: _BucketDetails2.default,
	        meta: {
	            auth: true
	        },
	        redirect: function redirect(to) {
	            return { path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/hb-tags' };
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/edit/:domId',
	        name: 'DomainContext',
	        component: _DomainContext2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/adstxt/:domId',
	        name: 'ads.txt',
	        component: _AdsText2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/KeywordBlock/:domId',
	        name: 'KeywordBlock',
	        component: _KeywordBlock2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher-info/:uuid/:id',
	        name: 'PublisherInfo',
	        component: _PublisherInfo2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/dc/add',
	        name: 'CreateDirectCampaign',
	        component: _CreateDirectCampaign2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/dc/',
	        name: 'AllDirectCampaign',
	        component: _AllDirectCampaign2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/ad-spot-setup/',
	        name: 'FiSetupAdSpots',
	        component: _FiSetupAdSpots2.default,
	        meta: {
	            auth: true
	        },
	        props: true
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/layout-setup/',
	        name: 'Layout',
	        component: _Layout2.default,
	        meta: {
	            auth: true
	        },
	        props: true
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/fi/',
	        name: 'FiTagAssociation',
	        component: _FiTagAssociation2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/settings',
	        name: 'BucketSettings',
	        component: _BucketDetails2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/profile',
	        name: 'Profile',
	        component: _Profile2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/axt',
	        name: 'AxtModule',
	        component: _AxtModule2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/hb-tags',
	        name: 'Header-Bidding-Tags',
	        component: _HBBucketTags2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/buckets/:bucketId/sticky',
	        name: 'StickyModule',
	        component: _ConfigStickyTemplate2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/dfp-settings',
	        name: 'DfpSettings',
	        component: _DfpSettings2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/edit-dfp/:dfpId',
	        name: 'Edit DPF',
	        component: _EditDfp2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/reports',
	        name: 'Reports',
	        component: _ReportsAdmin2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/report-approval/:reportName/',
	        name: 'reportApproval',
	        component: _ReportsAdminApproval2.default,
	        meta: {
	            auth: true
	        },
	        props: true
	    }, {
	        path: '/admin/reports/config',
	        name: 'ReportsConfig',
	        component: _ReportsConfig2.default,
	        meta: {
	            auth: true
	        },
	        props: true
	    }, {
	        path: '/admin/updated-report/:reportName/',
	        name: 'BidderDfpReport',
	        component: _BidderDfpReport2.default,
	        meta: {
	            auth: true
	        },
	        props: true
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/create-hb-tag/',
	        name: 'CreateHbTag',
	        component: _CreateHbTag2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: false
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/create-hb-tag-amp/',
	        name: 'CreateHbTagAmp',
	        component: _CreateHbTag2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/modify-hb-tag/:id/',
	        name: 'ModifyHbTag',
	        component: _ModifyHbTag2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: false
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/modify-hb-tag-amp/:id/',
	        name: 'ModifyHbTagAmp',
	        component: _ModifyHbTag2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/hb-tags/',
	        name: 'HbTagParams',
	        component: _HbTagParamsNew2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: false
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/hb-tags-dimensions/',
	        name: 'HbTagDimensionParams',
	        component: _HbTagDimensionParams2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: false
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/hb-tag-param-sets/',
	        name: 'HbTagParamSet',
	        component: _HbTagParamSet2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: false
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/hb-tags-amp/',
	        name: 'HbTagParamsAMP',
	        component: _HbTagParamsNew2.default,
	        meta: {
	            auth: true
	        },
	        props: {
	            is_amp: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/settings/block-categories',
	        name: 'BlockCategories',
	        component: _BlockCategories2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/settings/edit',
	        name: 'EditDomain',
	        component: _EditDomain2.default,
	        meta: {
	            auth: true
	        }
	    }, {
	        path: '/admin/publisher/:uuid/domain/:domId/settings/block-urls',
	        name: 'BlockURLS',
	        component: _BlockUrls2.default,
	        meta: {
	            auth: true
	        }
	    }]
	}, {
	    path: '/login',
	    name: 'Login',
	    component: _Login2.default,
	    meta: {
	        auth: false
	    }
	}, {
	    path: '/diag-spot/:adSpotId',
	    name: 'DiagRedirect',
	    component: _DiagRedirect2.default,
	    meta: {
	        auth: true
	    }
	}, {
	    path: '/reset/:id/:resetID',
	    name: 'ResetPassword',
	    component: _ResetPassword2.default,
	    meta: {
	        auth: false
	    }
	}, {
	    path: '/logout',
	    name: 'Logout',
	    component: _Logout2.default,
	    meta: {
	        auth: true
	    }
	}];
	
	exports.default = routes;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(720);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  token: null
	};
	
	var mutations = {
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
	    state.token = null;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */,
/* 573 */,
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 125,
		"./af.js": 125,
		"./ar": 132,
		"./ar-dz": 126,
		"./ar-dz.js": 126,
		"./ar-kw": 127,
		"./ar-kw.js": 127,
		"./ar-ly": 128,
		"./ar-ly.js": 128,
		"./ar-ma": 129,
		"./ar-ma.js": 129,
		"./ar-sa": 130,
		"./ar-sa.js": 130,
		"./ar-tn": 131,
		"./ar-tn.js": 131,
		"./ar.js": 132,
		"./az": 133,
		"./az.js": 133,
		"./be": 134,
		"./be.js": 134,
		"./bg": 135,
		"./bg.js": 135,
		"./bm": 136,
		"./bm.js": 136,
		"./bn": 137,
		"./bn.js": 137,
		"./bo": 138,
		"./bo.js": 138,
		"./br": 139,
		"./br.js": 139,
		"./bs": 140,
		"./bs.js": 140,
		"./ca": 141,
		"./ca.js": 141,
		"./cs": 142,
		"./cs.js": 142,
		"./cv": 143,
		"./cv.js": 143,
		"./cy": 144,
		"./cy.js": 144,
		"./da": 145,
		"./da.js": 145,
		"./de": 148,
		"./de-at": 146,
		"./de-at.js": 146,
		"./de-ch": 147,
		"./de-ch.js": 147,
		"./de.js": 148,
		"./dv": 149,
		"./dv.js": 149,
		"./el": 150,
		"./el.js": 150,
		"./en-au": 151,
		"./en-au.js": 151,
		"./en-ca": 152,
		"./en-ca.js": 152,
		"./en-gb": 153,
		"./en-gb.js": 153,
		"./en-ie": 154,
		"./en-ie.js": 154,
		"./en-il": 155,
		"./en-il.js": 155,
		"./en-nz": 156,
		"./en-nz.js": 156,
		"./eo": 157,
		"./eo.js": 157,
		"./es": 160,
		"./es-do": 158,
		"./es-do.js": 158,
		"./es-us": 159,
		"./es-us.js": 159,
		"./es.js": 160,
		"./et": 161,
		"./et.js": 161,
		"./eu": 162,
		"./eu.js": 162,
		"./fa": 163,
		"./fa.js": 163,
		"./fi": 164,
		"./fi.js": 164,
		"./fo": 165,
		"./fo.js": 165,
		"./fr": 168,
		"./fr-ca": 166,
		"./fr-ca.js": 166,
		"./fr-ch": 167,
		"./fr-ch.js": 167,
		"./fr.js": 168,
		"./fy": 169,
		"./fy.js": 169,
		"./gd": 170,
		"./gd.js": 170,
		"./gl": 171,
		"./gl.js": 171,
		"./gom-latn": 172,
		"./gom-latn.js": 172,
		"./gu": 173,
		"./gu.js": 173,
		"./he": 174,
		"./he.js": 174,
		"./hi": 175,
		"./hi.js": 175,
		"./hr": 176,
		"./hr.js": 176,
		"./hu": 177,
		"./hu.js": 177,
		"./hy-am": 178,
		"./hy-am.js": 178,
		"./id": 179,
		"./id.js": 179,
		"./is": 180,
		"./is.js": 180,
		"./it": 181,
		"./it.js": 181,
		"./ja": 182,
		"./ja.js": 182,
		"./jv": 183,
		"./jv.js": 183,
		"./ka": 184,
		"./ka.js": 184,
		"./kk": 185,
		"./kk.js": 185,
		"./km": 186,
		"./km.js": 186,
		"./kn": 187,
		"./kn.js": 187,
		"./ko": 188,
		"./ko.js": 188,
		"./ku": 189,
		"./ku.js": 189,
		"./ky": 190,
		"./ky.js": 190,
		"./lb": 191,
		"./lb.js": 191,
		"./lo": 192,
		"./lo.js": 192,
		"./lt": 193,
		"./lt.js": 193,
		"./lv": 194,
		"./lv.js": 194,
		"./me": 195,
		"./me.js": 195,
		"./mi": 196,
		"./mi.js": 196,
		"./mk": 197,
		"./mk.js": 197,
		"./ml": 198,
		"./ml.js": 198,
		"./mn": 199,
		"./mn.js": 199,
		"./mr": 200,
		"./mr.js": 200,
		"./ms": 202,
		"./ms-my": 201,
		"./ms-my.js": 201,
		"./ms.js": 202,
		"./mt": 203,
		"./mt.js": 203,
		"./my": 204,
		"./my.js": 204,
		"./nb": 205,
		"./nb.js": 205,
		"./ne": 206,
		"./ne.js": 206,
		"./nl": 208,
		"./nl-be": 207,
		"./nl-be.js": 207,
		"./nl.js": 208,
		"./nn": 209,
		"./nn.js": 209,
		"./pa-in": 210,
		"./pa-in.js": 210,
		"./pl": 211,
		"./pl.js": 211,
		"./pt": 213,
		"./pt-br": 212,
		"./pt-br.js": 212,
		"./pt.js": 213,
		"./ro": 214,
		"./ro.js": 214,
		"./ru": 215,
		"./ru.js": 215,
		"./sd": 216,
		"./sd.js": 216,
		"./se": 217,
		"./se.js": 217,
		"./si": 218,
		"./si.js": 218,
		"./sk": 219,
		"./sk.js": 219,
		"./sl": 220,
		"./sl.js": 220,
		"./sq": 221,
		"./sq.js": 221,
		"./sr": 223,
		"./sr-cyrl": 222,
		"./sr-cyrl.js": 222,
		"./sr.js": 223,
		"./ss": 224,
		"./ss.js": 224,
		"./sv": 225,
		"./sv.js": 225,
		"./sw": 226,
		"./sw.js": 226,
		"./ta": 227,
		"./ta.js": 227,
		"./te": 228,
		"./te.js": 228,
		"./tet": 229,
		"./tet.js": 229,
		"./tg": 230,
		"./tg.js": 230,
		"./th": 231,
		"./th.js": 231,
		"./tl-ph": 232,
		"./tl-ph.js": 232,
		"./tlh": 233,
		"./tlh.js": 233,
		"./tr": 234,
		"./tr.js": 234,
		"./tzl": 235,
		"./tzl.js": 235,
		"./tzm": 237,
		"./tzm-latn": 236,
		"./tzm-latn.js": 236,
		"./tzm.js": 237,
		"./ug-cn": 238,
		"./ug-cn.js": 238,
		"./uk": 239,
		"./uk.js": 239,
		"./ur": 240,
		"./ur.js": 240,
		"./uz": 242,
		"./uz-latn": 241,
		"./uz-latn.js": 241,
		"./uz.js": 242,
		"./vi": 243,
		"./vi.js": 243,
		"./x-pseudo": 244,
		"./x-pseudo.js": 244,
		"./yo": 245,
		"./yo.js": 245,
		"./zh-cn": 246,
		"./zh-cn.js": 246,
		"./zh-hk": 247,
		"./zh-hk.js": 247,
		"./zh-tw": 248,
		"./zh-tw.js": 248
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 574;


/***/ }),
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(515)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(309),
	  /* template */
	  __webpack_require__(674),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(546)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(310),
	  /* template */
	  __webpack_require__(699),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(495)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(311),
	  /* template */
	  __webpack_require__(658),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-180f84e4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(312),
	  /* template */
	  __webpack_require__(662),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(313),
	  /* template */
	  __webpack_require__(714),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(553)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(315),
	  /* template */
	  __webpack_require__(705),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-81c129ba",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(568)
	  __webpack_require__(567)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(316),
	  /* template */
	  __webpack_require__(715),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-fbf4596c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(488)
	  __webpack_require__(489)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(318),
	  /* template */
	  __webpack_require__(652),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0453da0c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(494)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(319),
	  /* template */
	  __webpack_require__(657),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-144db838",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(493)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(320),
	  /* template */
	  __webpack_require__(655),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0effe406",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(498)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(321),
	  /* template */
	  __webpack_require__(660),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-1ba15590",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(547)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(322),
	  /* template */
	  __webpack_require__(700),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-7e2aad50",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(545)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(323),
	  /* template */
	  __webpack_require__(698),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-755a7f82",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(558)
	  __webpack_require__(559)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(324),
	  /* template */
	  __webpack_require__(709),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-b02bfe2e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(487)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(325),
	  /* template */
	  __webpack_require__(651),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0208e652",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(538)
	  __webpack_require__(539)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(326),
	  /* template */
	  __webpack_require__(694),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-67eae3dc",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(550)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(327),
	  /* template */
	  __webpack_require__(703),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-80820692",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(492)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(328),
	  /* template */
	  __webpack_require__(654),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(562)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(329),
	  /* template */
	  __webpack_require__(711),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-c4f5eba6",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(509)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(330),
	  /* template */
	  __webpack_require__(670),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-300406f0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(551)
	  __webpack_require__(552)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(331),
	  /* template */
	  __webpack_require__(704),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-81ab1c1e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(486)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(333),
	  /* template */
	  __webpack_require__(650),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-01b06a7a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(542)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(334),
	  /* template */
	  __webpack_require__(696),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(521)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(335),
	  /* template */
	  __webpack_require__(679),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-45b878e6",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(529)
	  __webpack_require__(530)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(336),
	  /* template */
	  __webpack_require__(686),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-56d65af9",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(504)
	  __webpack_require__(503)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(337),
	  /* template */
	  __webpack_require__(665),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-29d8954b",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(338),
	  /* template */
	  __webpack_require__(691),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(544)
	  __webpack_require__(543)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(339),
	  /* template */
	  __webpack_require__(697),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-744d006c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(513)
	  __webpack_require__(512)
	  __webpack_require__(514)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(340),
	  /* template */
	  __webpack_require__(673),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3aba1d3e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(541)
	  __webpack_require__(540)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(341),
	  /* template */
	  __webpack_require__(695),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6badda20",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(501)
	  __webpack_require__(502)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(342),
	  /* template */
	  __webpack_require__(663),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-25caacf8",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(569)
	  __webpack_require__(570)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(343),
	  /* template */
	  __webpack_require__(716),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-fc4a064a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(563)
	  __webpack_require__(564)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(344),
	  /* template */
	  __webpack_require__(712),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-c5379974",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(507)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(345),
	  /* template */
	  __webpack_require__(668),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2b58886a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(347),
	  /* template */
	  __webpack_require__(664),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(348),
	  /* template */
	  __webpack_require__(681),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(349),
	  /* template */
	  __webpack_require__(656),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(537)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(350),
	  /* template */
	  __webpack_require__(693),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-622cbc4a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(524)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(351),
	  /* template */
	  __webpack_require__(683),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4da79797",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(518)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(352),
	  /* template */
	  __webpack_require__(677),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4226406a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(523)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(353),
	  /* template */
	  __webpack_require__(682),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4a679c67",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(548)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(354),
	  /* template */
	  __webpack_require__(701),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-7e804914",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(554)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(355),
	  /* template */
	  __webpack_require__(706),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(519)
	  __webpack_require__(520)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(356),
	  /* template */
	  __webpack_require__(678),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4460cda4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(549)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(702),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-7f6aba4c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(531)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(358),
	  /* template */
	  __webpack_require__(687),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-585d74f4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(510)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(359),
	  /* template */
	  __webpack_require__(671),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-34a2680e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(511)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(360),
	  /* template */
	  __webpack_require__(672),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-38b8de17",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(533)
	  __webpack_require__(534)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(361),
	  /* template */
	  __webpack_require__(689),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-59eea1a4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(526)
	  __webpack_require__(525)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(362),
	  /* template */
	  __webpack_require__(684),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5111d74c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(508)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(363),
	  /* template */
	  __webpack_require__(669),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2f123159",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(527)
	  __webpack_require__(528)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(685),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-52acc55a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(506)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(365),
	  /* template */
	  __webpack_require__(667),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(366),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	
	module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(522)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(367),
	  /* template */
	  __webpack_require__(680),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(560)
	  __webpack_require__(561)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(368),
	  /* template */
	  __webpack_require__(710),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-bb781ab6",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(490)
	  __webpack_require__(491)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  __webpack_require__(653),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-054beff0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(499)
	  __webpack_require__(500)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(370),
	  /* template */
	  __webpack_require__(661),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-1dd9d429",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(565)
	  __webpack_require__(566)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(713),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-e22cd7e8",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(556)
	  __webpack_require__(557)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(708),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-aee5c150",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(497)
	  __webpack_require__(496)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(659),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-187b0baa",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(374),
	  /* template */
	  __webpack_require__(675),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(536)
	  __webpack_require__(535)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(375),
	  /* template */
	  __webpack_require__(692),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5fed2e79",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(517)
	  __webpack_require__(516)
	}
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(676),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-414902a0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "heading-cart cf"
	  }, [_c('h1', [_vm._v("Publishers")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": ("" + ('/admin/publisher/add/'))
	    }
	  }, [_vm._v("Add Publisher")])], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "",
	      "visible": _vm.dialogFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogFormVisible = $event
	      }
	    }
	  }, [_c('div', [_c('el-header', [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8,
	      "offset": 9
	    }
	  }, [_c('p', {
	    staticClass: "headingName"
	  }, [_vm._v(" Add Publisher to Automatad")])])], 1), _vm._v(" "), _c('el-main', [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }), _vm._v(" "), _c('div', {}, [_c('el-row', {
	    attrs: {
	      "gutter": 18
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6,
	      "offset": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 18
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6,
	      "offset": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 18
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6,
	      "offset": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('p', {
	    staticClass: "paragraphBold"
	  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "buttonMargin",
	    attrs: {
	      "span": 8,
	      "offset": 16
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1)], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: "cart-items width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.publishers), function(option) {
	    return _c('li', {
	      staticClass: "row"
	    }, [_c('span', {
	      staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
	    }, [_c('router-link', {
	      staticClass: "h5",
	      attrs: {
	        "to": ("" + ('/admin/publisher-info/' + option.uuid + '/' + option.id))
	      }
	    }, [_c('avatar', {
	      attrs: {
	        "username": option.name,
	        "size": 50,
	        "color": "#fff"
	      }
	    })], 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('span', {
	      staticClass: "cart-description col-xs-12 col-md-5"
	    }, [_c('router-link', {
	      staticClass: "h5",
	      attrs: {
	        "to": ("" + ('/admin/publisher-info/' + option.uuid + '/' + option.id))
	      }
	    }, [_vm._v(_vm._s(("" + (option.name))))])], 1), _vm._v(" "), _c('span', {
	      staticClass: "col-md-5 col-sm-12 text-right"
	    }, [_c('router-link', {
	      staticClass: "hoverColor",
	      attrs: {
	        "to": ("" + ('/admin/publisher/edit/' + option.uuid + '/'))
	      }
	    }, [_c('span', {
	      staticClass: "ti-pencil-alt pull-right mt-5 ml-10"
	    })])], 1)])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
	  }, [_c('span', {
	    staticClass: "col-md-6 text-muted small"
	  }, [_vm._v("Publisher")])])
	}]}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Bucket name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      input: true,
	        'is-danger': _vm.errors.has('bname'),
	    },
	    attrs: {
	      "data-vv-delay": "200",
	      "name": "bname",
	      "type": "text",
	      "placeholder": "Bucket Name"
	    },
	    model: {
	      value: (_vm.formData.bname),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "bname", $$v)
	      },
	      expression: "formData.bname"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('bname')),
	      expression: "errors.has('bname')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first("bname")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select Countries")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "change": _vm.disable(_vm.formData.country),
	      "placeholder": "Select country",
	      "multiple": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.formData.country),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "country", $$v)
	      },
	      expression: "formData.country"
	    }
	  }, _vm._l((_vm.countries), function(option) {
	    return _c('el-option', {
	      key: option.id,
	      attrs: {
	        "label": option.name,
	        "value": option.id,
	        "disabled": _vm.displayexistingCountries.indexOf(
	          option.id
	        ) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Associate Products")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select products"
	    },
	    model: {
	      value: (_vm.formData.prod),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "prod", $$v)
	      },
	      expression: "formData.prod"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": "Select a product",
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.products), function(prod) {
	    return _c('el-option', {
	      key: prod.id,
	      attrs: {
	        "label": prod.name,
	        "value": prod.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": !_vm.formData.isMobileEnable
	    },
	    on: {
	      "change": _vm.loadExistingCountries
	    },
	    model: {
	      value: (_vm.formData.isMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isMobile", $$v)
	      },
	      expression: "formData.isMobile"
	    }
	  }, [_vm._v("Mobile enabled?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": !_vm.formData.isWebEnable
	    },
	    on: {
	      "change": _vm.loadExistingCountries
	    },
	    model: {
	      value: (_vm.formData.isWeb),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isWeb", $$v)
	      },
	      expression: "formData.isWeb"
	    }
	  }, [_vm._v("Web enabled?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": !_vm.formData.isTabletEnable
	    },
	    on: {
	      "change": _vm.loadExistingCountries
	    },
	    model: {
	      value: (_vm.formData.isTablet),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isTablet", $$v)
	      },
	      expression: "formData.isTablet"
	    }
	  }, [_vm._v("Tablet enabled?")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onSubmit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-left",
	    class: {
	      'el-icon-edit': _vm.bucketId !== undefined,
	        'el-icon-plus': _vm.bucketId === undefined,
	    }
	  }), _vm._v("\n                            " + _vm._s(_vm.bucketId === undefined ?
	    "Create Bucket" :
	    "Edit Bucket") + "\n                        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": ("" + ('/admin/publisher/' +
	                                _vm.uuid +
	                                '/domain/edit/' +
	                                _vm.domId +
	                                '/'))
	    }
	  }, [_vm._v("\n                            Cancel\n                        ")])], 1)], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create/Edit Bucket")])])
	}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("All Domains")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": "/admin/create-domain/"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n\t\t\t\t\t\tCreate Domain\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body domain-list"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "height": "400",
	      "data": _vm.domains
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.name))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": "",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/publisher/'+ props.row.publisher.uuid +'/domain/edit/'+ props.row.id))
	          }
	        }, [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(("" + (props.row.name))))]), _vm._v(" "), _c('span', {
	          staticClass: "publisher-name"
	        }, [_vm._v(_vm._s(("" + (props.row.publisher.name))))]), _vm._v(" "), (props.row.dfp_network != null) ? _c('span', {
	          staticClass: "dfp-network-alias"
	        }, [_vm._v(_vm._s(("" + (props.row.dfp_network.display_name))) + " DFP")]) : _vm._e()])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Reports",
	      "prop": "Reports",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Reports",
	            "placement": "bottom"
	          }
	        }, [_c('router-link', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          attrs: {
	            "to": ("" + ('/admin/publisher/'+props.row.publisher.id+'/ReportsRevenue/'+ props.row.id))
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-line-chart",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-dropdown', {
	          attrs: {
	            "trigger": "click"
	          }
	        }, [_c('span', {
	          staticClass: "el-dropdown-link"
	        }, [_c('el-badge', {
	          staticClass: "item",
	          attrs: {
	            "value": 0,
	            "max": 10
	          }
	        }, [_c('el-button', {
	          directives: [{
	            name: "clipboard",
	            rawName: "v-clipboard:copy",
	            value: (props.row.site_tag),
	            expression: "props.row.site_tag",
	            arg: "copy"
	          }, {
	            name: "clipboard",
	            rawName: "v-clipboard:success",
	            value: (_vm.onCopy),
	            expression: "onCopy",
	            arg: "success"
	          }, {
	            name: "clipboard",
	            rawName: "v-clipboard:error",
	            value: (_vm.onError),
	            expression: "onError",
	            arg: "error"
	          }],
	          staticClass: "notes-box",
	          attrs: {
	            "type": "text",
	            "size": "small"
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-copy fa-w-14 fa-2x",
	          attrs: {
	            "width": "17px",
	            "height": "17px",
	            "aria-hidden": "true",
	            "data-prefix": "fal",
	            "data-icon": "copy",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 448 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
	          }
	        })])])])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
	          attrs: {
	            "slot": "dropdown"
	          },
	          slot: "dropdown"
	        }, [_c('ul', {
	          staticClass: "dropdown-menu-devin",
	          staticStyle: {
	            "max-width": "700px !important"
	          }
	        }, [_c('li', {
	          staticClass: "header",
	          staticStyle: {
	            "margin": "5px",
	            "font-size": "12px"
	          }
	        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s((props.row.site_tag) ? props.row.site_tag : 'No Script Present.') + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
	          staticClass: "text-danger",
	          staticStyle: {
	            "margin-left": "20px",
	            "font-size": "10px"
	          }
	        }, [_c('b', [_vm._v("copied!")])])])])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/domains/notes/'+ props.row.id))
	          }
	        }, [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "type": "text",
	            "size": "small"
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-pen-square fa-w-14 fa-2x",
	          attrs: {
	            "width": "17px",
	            "height": "17px",
	            "aria-hidden": "true",
	            "data-prefix": "far",
	            "data-icon": "pen-square",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 448 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
	          }
	        })])])])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "buckets"
	        }, [_c('ul', {
	          staticClass: "bucket-list clearfix",
	          style: ({
	            width: (122 * ((props.row.buckets && props.row.buckets.length) > 3 ? props.row.buckets.length : 4)) + 'px'
	          })
	        }, _vm._l((props.row.buckets), function(bucket) {
	          return _c('li', {
	            key: bucket.id,
	            staticClass: "shadowBox"
	          }, [_c('router-link', {
	            attrs: {
	              "to": ("" + ('/admin/publisher/'+ props.row.publisher.uuid +'/domain/'+ props.row.id +'/buckets/'+ bucket.id +'/'))
	            }
	          }, [_c('span', {}, [_c('svg', {
	            staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-3x",
	            attrs: {
	              "aria-hidden": "true",
	              "width": "12",
	              "height": "12",
	              "data-prefix": "fab",
	              "data-icon": "bitbucket",
	              "role": "img",
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 512 512"
	            }
	          }, [_c('path', {
	            attrs: {
	              "fill": "currentColor",
	              "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
	            }
	          })])]), _vm._v(" "), _c('span', {}, [_vm._v(" " + _vm._s(("" + (bucket.name))))])])], 1)
	        }), 0)])]
	      }
	    }])
	  }), _vm._v(" "), _c('infinite-loading', {
	    attrs: {
	      "slot": "append",
	      "force-use-infinite-wrapper": ".el-table__body-wrapper"
	    },
	    on: {
	      "infinite": _vm.infiniteHandler
	    },
	    slot: "append"
	  })], 1)], 1)])]), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.reportStatus,
	      "height": "355",
	      "id": "assoc-table"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Report Date",
	      "prop": "date"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Download Report"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-button', {
	          attrs: {
	            "size": "mini",
	            "round": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.getDownload(props.row.date)
	            }
	          }
	        }, [_vm._v("Download")])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('hr')], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Admin Reports")])])
	}]}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Radio")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Enter Publisher's Name")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Name"
	    },
	    model: {
	      value: (_vm.credentials.name),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "name", $$v)
	      },
	      expression: "credentials.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enter E-Mail")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('email')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "email",
	      "type": "text",
	      "placeholder": "Email"
	    },
	    model: {
	      value: (_vm.credentials.email),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "email", $$v)
	      },
	      expression: "credentials.email"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enter Contact Number")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('number')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "number",
	      "type": "number",
	      "placeholder": "Contact Number"
	    },
	    model: {
	      value: (_vm.credentials.number),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "number", $$v)
	      },
	      expression: "credentials.number"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('number')),
	      expression: "errors.has('number')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('number')))])], 1), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select Country")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.credentials.countryId),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "countryId", $$v)
	      },
	      expression: "credentials.countryId"
	    }
	  }, _vm._l((_vm.countryOptions), function(option) {
	    return _c('el-option-group', {
	      key: option.id,
	      attrs: {
	        "label": option.name,
	        "value": option.id
	      }
	    }, _vm._l((_vm.countryOptions), function(option) {
	      return _c('el-option', {
	        key: option.id,
	        attrs: {
	          "label": option.name,
	          "value": option.id
	        }
	      })
	    }), 1)
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select Currency")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.credentials.currencyId),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "currencyId", $$v)
	      },
	      expression: "credentials.currencyId"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(option) {
	    return _c('el-option-group', {
	      key: option.id,
	      attrs: {
	        "label": option.code,
	        "value": option.id
	      }
	    }, _vm._l((_vm.currenciesOptions), function(option) {
	      return _c('el-option', {
	        key: option.id,
	        attrs: {
	          "label": option.code,
	          "value": option.id
	        }
	      })
	    }), 1)
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Access")])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h2', {
	    staticClass: "box-title"
	  }, [_vm._v("Search")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-lg-3",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Any Domain By Name"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterByEachInput.apply(null, arguments)
	      }
	    },
	    model: {
	      value: (_vm.searchvalue),
	      callback: function($$v) {
	        _vm.searchvalue = $$v
	      },
	      expression: "searchvalue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body pub-list"
	  }, [_c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": "/admin/bidders/create-domain"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n\t\t\t\t\t\tCreate Domain\n\t\t\t    ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    staticStyle: {
	      "margin-right": "1rem"
	    },
	    attrs: {
	      "to": "/admin/bidders/create-bulk-domain"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                        Create Domains\n                ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    staticStyle: {
	      "margin-right": "1rem"
	    },
	    attrs: {
	      "to": "/admin/bidders/create-bulk-line-item"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                        Bulk Line Item Creation\n                ")]), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "height": "400",
	      "data": _vm.publisher
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Domain Name",
	      "prop": "name",
	      "width": "700"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/lineitems/'+ props.row.id))
	          }
	        }, [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(("" + (props.row.url))))])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Edit Domain",
	            "placement": "bottom"
	          }
	        }, [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/bidders/domain/'+ props.row.id))
	          }
	        }, [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "icon": "el-icon-edit-outline",
	            "type": "text",
	            "size": "small"
	          }
	        })], 1)], 1)]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "page-size": _vm.offset,
	      "pager-count": 20,
	      "layout": "prev, pager, next",
	      "total": _vm.total_pages,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h1', {
	    staticClass: "box-title"
	  }, [_vm._v("Domain")])])
	}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('main', {
	    staticClass: "wrapper-404"
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(1), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": ["Oops! Page not found", "We could not find the page you were looking for", "Meanwhile", "you may return to dashboard", "or try using the search form."],
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n                500 Error Page\n            ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("500 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("5")]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })])])
	}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("ALL Publishers")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": "/admin/publisher/add"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n          Create Publisher\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Search")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-lg-3",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Any Publisher By Name"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterByEachInput.apply(null, arguments)
	      }
	    },
	    model: {
	      value: (_vm.searchvalue),
	      callback: function($$v) {
	        _vm.searchvalue = $$v
	      },
	      expression: "searchvalue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body pub-list"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "height": "400",
	      "data": _vm.publisher
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Name",
	      "prop": "name",
	      "width": "210"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(("" + (props.row.name))))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Reports",
	      "prop": "Reports",
	      "width": "90"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Reports",
	            "placement": "bottom"
	          }
	        }, [_c('router-link', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          attrs: {
	            "to": ("" + ('/admin/publisher/'+props.row.id+'/ReportsRevenue/alldomain'))
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-line-chart",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    staticStyle: {
	      "font-size": "10px"
	    },
	    attrs: {
	      "label": "Contract",
	      "prop": "Contract",
	      "width": "300"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Send welcome email",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text forcontract",
	          staticStyle: {
	            "background": "#33ce33",
	            "color": "white"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.confirmSendWelcomeEmail(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-envelope",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])]), _vm._v(" "), _c('el-tooltip', {
	          attrs: {
	            "content": "Create Contract",
	            "placement": "bottom"
	          }
	        }, [_c('router-link', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "#efb71b",
	            "color": "white"
	          },
	          attrs: {
	            "to": ("" + ('/admin/publisher/contract/'+ props.row.id))
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-plus",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])], 1), _vm._v(" "), _c('el-tooltip', {
	          attrs: {
	            "content": "Upload Signed Contract",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "blue",
	            "color": "white"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.dialogVisiblecontract(props.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-upload"
	        })])]), _vm._v(" "), (!props.row.contract_details.sign_pdf) ? _c('el-tooltip', {
	          attrs: {
	            "content": "Contract not uploaded",
	            "placement": "bottom"
	          }
	        }, [_c('label', {
	          key: props.row.contract_details.sign_pdf,
	          staticClass: "el-button notes-box el-button--text el-button--small bg-success forcontract",
	          staticStyle: {
	            "cursor": "not-allowed",
	            "background": "red",
	            "color": "white"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ban"
	        })])]) : _c('el-tooltip', {
	          attrs: {
	            "content": "Download Signed Contract",
	            "placement": "bottom"
	          }
	        }, [_c('a', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "#00ced1",
	            "color": "white"
	          },
	          attrs: {
	            "href": props.row.contract_details.sign_pdf
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download"
	        })])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Tax Form",
	      "prop": "uuid",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Upload Tax form",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "blue",
	            "color": "white"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.dialogVisiblef(props.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-upload"
	        })])]), _vm._v(" "), (!props.row.contract_details.tax_pdf) ? _c('el-tooltip', {
	          attrs: {
	            "content": "Tax form not uploaded",
	            "placement": "bottom"
	          }
	        }, [_c('label', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "cursor": "not-allowed",
	            "background": "red",
	            "color": "white"
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-ban"
	        })])]) : _c('el-tooltip', {
	          attrs: {
	            "content": "Download Tax form",
	            "placement": "bottom"
	          }
	        }, [_c('a', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "#00ced1",
	            "color": "white"
	          },
	          attrs: {
	            "href": props.row.contract_details.tax_pdf
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-download"
	        })])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Edit",
	      "prop": "publisher",
	      "width": "60"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Edit Publisher",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "white",
	            "color": "black"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.showEditScreenVisiblefuncton(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-edit"
	        })])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Bank Details",
	      "prop": "publisher",
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Copy Bank Details",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "white",
	            "color": "black"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.showBankInfoScreenVisiblefuncton(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-bank"
	        })])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Account Activate",
	      "prop": "publisher",
	      "width": "90"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Send Account Activate to Intentt External Publisher",
	            "placement": "bottom"
	          }
	        }, [_c('button', {
	          staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	          staticStyle: {
	            "background": "white",
	            "color": "black"
	          },
	          attrs: {
	            "type": "success"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.confirmIntenttNividEmailSend(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-envelope"
	        })])])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.EditScreenVisible,
	      "before-close": _vm.closeEditScreen
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.EditScreenVisible = $event
	      }
	    }
	  }, [
	    [_c('div', [_c('h3', [_vm._v("Update Publisher")])]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin": "10px 0px"
	      }
	    }, [_c('el-input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      class: {
	        'input': true, 'is-danger': _vm.errors.has('name')
	      },
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "name",
	        "type": "text",
	        "placeholder": "15%"
	      },
	      model: {
	        value: (_vm.editPubForm.name),
	        callback: function($$v) {
	          _vm.$set(_vm.editPubForm, "name", $$v)
	        },
	        expression: "editPubForm.name"
	      }
	    }), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.errors.has('name')),
	        expression: "errors.has('name')"
	      }],
	      staticClass: "help is-danger"
	    }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin": "10px 0px"
	      }
	    }, [_c('el-input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      class: {
	        'input': true, 'is-danger': _vm.errors.has('email')
	      },
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "email",
	        "type": "text",
	        "placeholder": "15%"
	      },
	      model: {
	        value: (_vm.editPubForm.email),
	        callback: function($$v) {
	          _vm.$set(_vm.editPubForm, "email", $$v)
	        },
	        expression: "editPubForm.email"
	      }
	    }), _vm._v(" "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.errors.has('email')),
	        expression: "errors.has('email')"
	      }],
	      staticClass: "help is-danger"
	    }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin": "10px 0px"
	      }
	    }, [_c('span', [_vm._v("enable AMP Setup")]), _vm._v(" "), _c('el-switch', {
	      attrs: {
	        "active-color": "#13ce66",
	        "inactive-color": "#ff4949"
	      },
	      model: {
	        value: (_vm.editPubForm.amp_ss_enable),
	        callback: function($$v) {
	          _vm.$set(_vm.editPubForm, "amp_ss_enable", $$v)
	        },
	        expression: "editPubForm.amp_ss_enable"
	      }
	    })], 1), _vm._v(" "), _c('div', [_c('el-button', {
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.EditPublisher()
	        }
	      }
	    }, [_vm._v("Update Publisher")])], 1)]
	  ], 2), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.bankInfoScreenVisible,
	      "before-close": _vm.closeBankInfoScreen
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.bankInfoScreenVisible = $event
	      }
	    }
	  }, [
	    [_c('div', [_c('h3', [_vm._v("Bank Details")])]), _vm._v(" "), _c('pre', {
	      staticStyle: {
	        "margin": "10px 0"
	      },
	      attrs: {
	        "id": "divClipboard"
	      }
	    }, [_vm._v(_vm._s(_vm.bankDetail))]), _vm._v(" "), (!_vm.iscopied) ? _c('el-button', {
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copiedToClipboard()
	        }
	      }
	    }, [_vm._v("Copy to clipboard")]) : _c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "button"
	      }
	    }, [_vm._v("Copied")])]
	  ], 2), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.UploadScreenVisible,
	      "before-close": _vm.clearFilesList
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.UploadScreenVisible = $event
	      }
	    }
	  }, [
	    [_c('el-upload', {
	      directives: [{
	        name: "loading",
	        rawName: "v-loading",
	        value: (_vm.uploading),
	        expression: "uploading"
	      }],
	      ref: "file",
	      staticClass: "upload-demo m-t-20",
	      attrs: {
	        "drag": "",
	        "limit": 1,
	        "action": "v1/upload-tax-docs/",
	        "auto-upload": false,
	        "http-request": _vm.upload,
	        "file-list": _vm.fileList,
	        "on-change": _vm.handleFileUpload
	      }
	    }, [_c('i', {
	      staticClass: "el-icon-upload"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "el-upload__text"
	    }, [_vm._v("\n                Drop file here or\n                "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('span', {
	      staticClass: "dialog-footer",
	      attrs: {
	        "slot": "footer"
	      },
	      slot: "footer"
	    }, [_c('el-button', {
	      on: {
	        "click": _vm.cancelUploadAction
	      }
	    }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.submitFile()
	        }
	      }
	    }, [_vm._v("Upload Tax Form")])], 1)]
	  ], 2), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.contractvisiblescreen,
	      "before-close": _vm.clearFilesList
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.contractvisiblescreen = $event
	      }
	    }
	  }, [
	    [_c('el-upload', {
	      directives: [{
	        name: "loading",
	        rawName: "v-loading",
	        value: (_vm.uploading),
	        expression: "uploading"
	      }],
	      ref: "file",
	      staticClass: "upload-demo m-t-20",
	      attrs: {
	        "drag": "",
	        "limit": 1,
	        "action": "v1/upload-contract/",
	        "auto-upload": false,
	        "http-request": _vm.upload,
	        "file-list": _vm.fileList,
	        "on-change": _vm.handleFileUploadcontract
	      }
	    }, [_c('i', {
	      staticClass: "el-icon-upload"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "el-upload__text"
	    }, [_vm._v("\n                Drop file here or\n                "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('span', {
	      staticClass: "dialog-footer",
	      attrs: {
	        "slot": "footer"
	      },
	      slot: "footer"
	    }, [_c('el-button', {
	      on: {
	        "click": _vm.cancelUploadAction
	      }
	    }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.submitcontract()
	        }
	      }
	    }, [_vm._v("Upload Contract")])], 1)]
	  ], 2), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "page-size": _vm.offset,
	      "pager-count": 20,
	      "layout": "prev, pager, next",
	      "total": _vm.total_pages,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Enter Publisher's Name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Publisher name"
	    },
	    model: {
	      value: (_vm.credentials.name),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "name", $$v)
	      },
	      expression: "credentials.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enter E-Mail")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('email')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "email",
	      "type": "text",
	      "placeholder": "Please enter email address"
	    },
	    model: {
	      value: (_vm.credentials.email),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "email", $$v)
	      },
	      expression: "credentials.email"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', [_vm._v("enable AMP Setup")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.credentials.amp_ss_enable),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "amp_ss_enable", $$v)
	      },
	      expression: "credentials.amp_ss_enable"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "disabled": !_vm.formValid
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n            Create Publisher\n          ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/AllPublisher/"
	    }
	  }, [_vm._v("Cancel")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Publisher")])])
	}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    staticClass: "control-sidebar control-sidebar-light"
	  }, [_c('ul', {
	    staticClass: "nav navbar-stacked"
	  }, [_c('li'), _vm._v(" "), _vm._l((_vm.auditLogs), function(auditLog, index) {
	    return _c('li', [_c('svg', {
	      staticClass: "svg-inline--fa fa-user-plus fa-w-20 fa-2x",
	      attrs: {
	        "aria-hidden": "true",
	        "height": "20px",
	        "width": "20px",
	        "data-prefix": "fal",
	        "data-icon": "user-plus",
	        "role": "img",
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 640 512"
	      }
	    }, [_c('path', {
	      attrs: {
	        "fill": "currentColor",
	        "d": "M640 252v8c0 6.627-5.373 12-12 12h-68v68c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12v-68h-68c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h68v-68c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v68h68c6.627 0 12 5.373 12 12zm-264.942 32.165l-43.497-12.428C355.115 245.342 368 211.663 368 176c0-79.525-64.339-144-144-144-79.525 0-144 64.339-144 144 0 35.663 12.885 69.342 36.439 95.737l-43.497 12.428C17.501 300.005 0 350.424 0 380.866v39.705C0 453.34 26.66 480 59.429 480h329.143C421.34 480 448 453.34 448 420.571v-39.705c0-57.659-43.675-88.339-72.942-96.701zM224 64c61.856 0 112 50.144 112 112s-50.144 112-112 112-112-50.144-112-112S162.144 64 224 64zm192 356.571C416 435.72 403.72 448 388.571 448H59.429C44.28 448 32 435.72 32 420.571v-39.705c0-30.616 20.296-57.522 49.733-65.933l63.712-18.203C168.611 311.87 195.679 320 224 320s55.389-8.13 78.555-23.27l63.712 18.203C395.704 323.344 416 350.251 416 380.866v39.705z"
	      }
	    })]), _vm._v(" "), _vm._v(" \n            "), _c('strong', [_vm._v(_vm._s(("" + ((auditLog.user)?auditLog.user.first_name:''))) + " " + _vm._s(_vm._f("action")(auditLog.action)) + " ")]), _vm._v("\n            " + _vm._s((auditLog.obj) ? (auditLog.obj.name) : '') + " " + _vm._s(("" + (auditLog.action == 'PUBLISHED_SNIPPET' || auditLog.action == 'ADDED URL BLOCK' ? auditLog.extra.info:''))) + "\n            " + _vm._s((auditLog.action.indexOf('HB_TAG') > -1 && auditLog.obj) ? 'for the domain ' + auditLog.obj.domain.name : '') + "\n                  "), _c('div', [_vm._v("\n                    at "), _c('small', [_vm._v(_vm._s(_vm._f("moment")(("" + (auditLog.timestamp)), "'MMM Do YYYY, h:mm:ss a")))])]), _vm._v(" "), (index == (_vm.auditLogs.length - 1)) ? _c('br') : _vm._e()])
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _c('el-tree', {
	    attrs: {
	      "data": _vm.blockcategories,
	      "show-checkbox": "",
	      "node-key": "value",
	      "props": _vm.defaultProps
	    },
	    on: {
	      "check-change": _vm.handleCheckChange
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("All Domains")])])
	}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body reports-admin-panel"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.reportStatus,
	      "height": "655",
	      "stripe": "",
	      "id": "assoc-table"
	    }
	  }, [_c('el-table-column', {
	    staticClass: "text-center",
	    attrs: {
	      "label": "Report Date",
	      "width": "100",
	      "fixed": "left"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.date) + "\n\t\t\t\t\t\t\t")]
	      }
	    }])
	  }), _vm._v(" "), _vm._l((_vm.biddersList), function(bidder, index) {
	    return _c('el-table-column', {
	      staticClass: "text-center",
	      attrs: {
	        "label": bidder,
	        "width": "100"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [(props.row.data.filter(function (x) { return x['report_name'] == bidder; }).length > 0) ? _c('div', [(props.row.data.filter(function (x) { return x['report_name'] == bidder; })[0].is_done) ? _c('div', {
	            class: 'text-center index' + index
	          }, [_c('el-button', {
	            key: bidder.replace(" ", "_") + "-" + props.row.date,
	            class: "is-circle btn-" + bidder.replace(" ", "_") + "-" + props.row.date,
	            attrs: {
	              "type": "success",
	              "icon": "el-icon-check"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.regenerateReport(bidder, props.row.date, $event)
	              }
	            }
	          })], 1) : _c('div', {
	            staticClass: "text-center"
	          }, [_c('el-button', {
	            key: bidder.replace(" ", "_") + "-" + props.row.date,
	            class: "is-circle btn-" + bidder.replace(" ", "_") + "-" + props.row.date,
	            attrs: {
	              "type": "danger",
	              "icon": "el-icon-close"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.regenerateReport(bidder, props.row.date, $event)
	              }
	            }
	          })], 1)]) : _c('div', {
	            staticClass: "text-center"
	          }, [_c('el-button', {
	            key: bidder.replace(" ", "_") + "-" + props.row.date,
	            class: "is-circle btn-" + bidder.replace(" ", "_") + "-" + props.row.date,
	            attrs: {
	              "type": "danger",
	              "icon": "el-icon-close"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.regenerateReport(bidder, props.row.date, $event)
	              }
	            }
	          })], 1), _vm._v(" "), _c('div', {
	            class: "text-center white-space-pre atd-text-" + bidder.replace(" ", "_") + "-" + props.row.date
	          }, [(props.row.data.filter(function (x) { return x['report_name'] == bidder; }).length > 0) ? _c('div', [_vm._v(_vm._s(_vm._f("moment")(_vm.getLastUpdateDate(props.row.data.filter(function (x) { return x['report_name'] == bidder; })[0]), "MMM Do YYYY[\n] h:mm:ss a")))]) : _vm._e()])]
	        }
	      }], null, true)
	    })
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Update Pub Dashboard",
	      "width": "110",
	      "fixed": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('el-button', {
	          class: "is-circle btn-resync text-center",
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-refresh"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.confirmReUpload(props.row.date)
	            }
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Download",
	      "width": "110",
	      "fixed": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-dropdown', {
	          attrs: {
	            "trigger": "click"
	          },
	          on: {
	            "command": function (command) { return _vm.handleCommand(command, props.row.date); }
	          }
	        }, [_c('el-button', {
	          staticClass: "el-dropdown-link",
	          attrs: {
	            "size": "mini",
	            "round": ""
	          }
	        }, [_vm._v("\n        Download\n      ")]), _vm._v(" "), _c('el-dropdown-menu', {
	          attrs: {
	            "slot": "dropdown"
	          },
	          slot: "dropdown"
	        }, [_c('el-dropdown-item', {
	          attrs: {
	            "icon": "el-icon-plus",
	            "command": "get_bidder_revenue_report"
	          }
	        }, [_vm._v("Bidder Report")]), _vm._v(" "), _c('el-dropdown-item', {
	          attrs: {
	            "icon": "el-icon-circle-plus",
	            "command": "get_dfp_bidder_revenue_report"
	          }
	        }, [_vm._v("DFP + Bidder Report")]), _vm._v(" "), _c('el-dropdown-item', {
	          attrs: {
	            "icon": "el-icon-circle-plus-outline",
	            "command": "get_axt_report"
	          }
	        }, [_vm._v("AXT Report")]), _vm._v(" "), _c('el-dropdown-item', {
	          attrs: {
	            "icon": "el-icon-circle-plus-outline",
	            "command": "get_amp_report"
	          }
	        }, [_vm._v("AMP Report")]), _vm._v(" "), _c('el-dropdown-item', {
	          attrs: {
	            "icon": "el-icon-circle-plus-outline",
	            "command": "get_adserving_fee"
	          }
	        }, [_vm._v("Adserving Fee Report")])], 1)], 1)]
	      }
	    }])
	  })], 2), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.UploadScreenVisible,
	      "before-close": _vm.clearFilesList
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.UploadScreenVisible = $event
	      }
	    }
	  }, [_c('span', {
	    staticClass: "el-dialog__title text-center"
	  }, [_vm._v("Upload " + _vm._s(_vm.bidder_name) + " report for " + _vm._s(_vm.report_date))]), _vm._v(" "), (_vm.bidder_name == 'mmadx') ? [_c('div', {
	    staticClass: "text-center"
	  }, [_c('span', {
	    staticClass: "m-r-15"
	  }, [_c('h5', {
	    staticClass: "dis-inline-block"
	  }, [_vm._v("Report type:")])]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.reportType),
	      callback: function($$v) {
	        _vm.reportType = $$v
	      },
	      expression: "reportType"
	    }
	  }, _vm._l((_vm.reportOptions), function(item) {
	    return _c('el-option', {
	      key: item.reportType,
	      attrs: {
	        "label": item.label,
	        "value": item.reportType
	      }
	    })
	  }), 1)], 1)] : _vm._e(), _vm._v(" "), _c('el-upload', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.uploading),
	      expression: "uploading"
	    }],
	    ref: "upload",
	    staticClass: "upload-demo m-t-20",
	    attrs: {
	      "drag": "",
	      "limit": 1,
	      "action": "reports/v1/upload/",
	      "auto-upload": false,
	      "http-request": _vm.upload,
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__text"
	  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), (_vm.bidder_name == 'updated') ? _c('div', {
	    staticClass: "el-upload__text",
	    attrs: {
	      "slot": "tip"
	    },
	    slot: "tip"
	  }, [_vm._v("Upload modified DFP + Bidder Report")]) : _vm._e()]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.cancelUploadAction
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.submitUpload
	    }
	  }, [_vm._v("Upload Report")])], 1)], 2), _vm._v(" "), _c('el-pagination', {
	    attrs: {
	      "background": "",
	      "layout": "prev, pager, next",
	      "current-page": _vm.currentPage,
	      "total": _vm.totalPage,
	      "page-size": 5
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Admin Reports")])])
	}]}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(0), _vm._v(" "), _c('pre', {
	    attrs: {
	      "id": "divClipboard"
	    }
	  }, [_vm._v(_vm._s(_vm.bidders))])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.biddersData),
	      expression: "biddersData"
	    }],
	    staticStyle: {
	      "border": "1px solid black",
	      "padding": "10px"
	    },
	    attrs: {
	      "placeholder": "Enter data",
	      "rows": "4",
	      "cols": "150"
	    },
	    domProps: {
	      "value": (_vm.biddersData)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.biddersData = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addData
	    }
	  }, [_vm._v("Submit")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "box-title"
	  }, [_c('b', [_vm._v("ads.txt")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "box-title"
	  }, [_c('b', [_vm._v("Please add domain specific ads.txt entries here")])])
	}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Select Publisher")]), _vm._v(" "), (!_vm.domId) ? _c('p', [_vm._v("Choose publisher from the dropdown or create one by clicking +add publisher")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setPubUid()
	      }
	    },
	    model: {
	      value: (_vm.pubId),
	      callback: function($$v) {
	        _vm.pubId = $$v
	      },
	      expression: "pubId"
	    }
	  }, _vm._l((_vm.publishers), function(pub) {
	    return _c('el-option', {
	      key: pub.name,
	      attrs: {
	        "data-id": pub.uuid,
	        "label": pub.name,
	        "value": pub.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (!_vm.domId) ? _c('div', {
	    staticClass: "col-md-3 m-t-7"
	  }, [_c('router-link', {
	    staticClass: "el-button--info m-t-15",
	    attrs: {
	      "to": "/admin/bidders/create-publisher/"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                    Create Publisher\n                                ")])], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Line Separated Domain URLs")]), _vm._v(" "), _c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('textarea', {
	    staticClass: "textarea-custom",
	    staticStyle: {
	      "padding": "15px 15px 0 15px",
	      "width": "100%",
	      "height": "100px",
	      "border-radius": "4px",
	      "border": "1px solid #d8dce5",
	      "resize": "none"
	    },
	    attrs: {
	      "placeholder": "Enter Domains line-by-line",
	      "name": "domainList",
	      "id": "domain-name-listing"
	    },
	    on: {
	      "change": _vm.handleDomainListChange
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 m-t-10"
	  }, [_c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.addToCoreDomain),
	      callback: function($$v) {
	        _vm.addToCoreDomain = $$v
	      },
	      expression: "addToCoreDomain"
	    }
	  }, [_vm._v("Add to Yeti Domains")])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("RTC Currency")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "clearable": "",
	      "filterable": "",
	      "placeholder": "Select RTC Currency"
	    },
	    model: {
	      value: (_vm.rtcCurrency),
	      callback: function($$v) {
	        _vm.rtcCurrency = $$v
	      },
	      expression: "rtcCurrency"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.code,
	        "value": item.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._v("Theme Settings:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "el-button el-button--secondary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.theme = {}
	      }
	    }
	  }, [_vm._v("\n                                    Reset\n                                ")])])]), _vm._v(" "), _c('theme', {
	    attrs: {
	      "themeData": _vm.theme
	    },
	    on: {
	      "themeChange": _vm.updateThemeObj
	    }
	  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Domains")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clearfix"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                Create Domains\n                            ")])])
	}]}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Content Goes Here")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "limiter"
	  }, [_c('div', {
	    staticClass: "container-login100"
	  }, [_c('div', {
	    staticClass: "wrap-login100"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "login100-form validate-form"
	  }, [_vm._m(1), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
	    staticClass: "wrap-input100 validate-input",
	    attrs: {
	      "data-validate": "Valid email is required: ex@abc.xyz"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "input100",
	    class: {
	      input: true,
	        'is-danger': _vm.errors.has('email'),
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "email",
	      "type": "text",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "focus-input100"
	  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
	    staticClass: "wrap-input100 validate-input",
	    attrs: {
	      "data-validate": "Password is required"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "input100",
	    class: {
	      input: true,
	        'is-danger': _vm.errors.has('password'),
	    },
	    attrs: {
	      "data-vv-delay": "5000",
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "focus-input100"
	  }), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == true) ? _c('div', [_c('p', [_vm._v("Enter your E-Mail ID")]), _vm._v(" "), _c('div', {
	    staticClass: "wrap-input100 validate-input",
	    attrs: {
	      "data-validate": "E-Mail is required"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.resetEmailID),
	      expression: "resetEmailID"
	    }],
	    staticClass: "input100",
	    class: {
	      input: true,
	        'is-danger': _vm.errors.has('email'),
	    },
	    attrs: {
	      "data-vv-delay": "5000",
	      "name": "email",
	      "type": "email",
	      "placeholder": "E-Mail"
	    },
	    domProps: {
	      "value": (_vm.resetEmailID)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.resetPassword()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.resetEmailID = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "focus-input100"
	  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
	    staticClass: "back-login textAlign"
	  }, [_c('button', {
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backLogin()
	      }
	    }
	  }, [_vm._v("\n                                Back to Login\n                            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "container-login100-form-btn"
	  }, [_c('button', {
	    staticClass: "login100-form-btn",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resetPassword()
	      }
	    }
	  }, [_vm._v("\n                                Submit\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
	    staticClass: "textAlign"
	  }, [_c('button', {
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.forgetpassword()
	      }
	    }
	  }, [_vm._v("\n                            Forgot Password?\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
	    staticClass: "container-login100-form-btn"
	  }, [_c('button', {
	    staticClass: "login100-form-btn",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.formValid
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("\n                            Login\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "text-center p-t-12"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login100-pic js-tilt",
	    attrs: {
	      "data-tilt": ""
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/Blue-Yeti.png",
	      "alt": "IMG"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "login100-form-title"
	  }, [_c('img', {
	    attrs: {
	      "src": "https://nivid.automatad.com/assets/img/logo-white-md.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "symbol-input100"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "symbol-input100"
	  }, [_c('i', {
	    staticClass: "fa fa-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "symbol-input100"
	  }, [_c('i', {
	    staticClass: "fa fa-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper",
	    staticStyle: {
	      "border": "1px solid black",
	      "width": "100%",
	      "margin": "0",
	      "padding": "40px 10px 20px 10px",
	      "font-family": "Arial"
	    },
	    attrs: {
	      "id": "agreementform",
	      "contenteditable": "true"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "margin-top": "30px",
	      "height": "55px",
	      "width": "25%"
	    },
	    attrs: {
	      "src": _vm.LogoImg,
	      "alt": "automatad-logo"
	    }
	  }), _vm._v(" "), _c('center', {
	    staticClass: "heading",
	    staticStyle: {
	      "margin-bottom": "20px",
	      "font-size": "18px"
	    }
	  }, [_c('b', [_vm._v("Service Terms and Conditions(“Terms”)")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("THIS AGREEMENT")]), _vm._v(" is made between "), _c('b', [_vm._v("Automatad, Inc. (“Automatad”)")]), _vm._v(" and "), _c('span', {
	    staticStyle: {
	      "border-bottom": "1px solid black",
	      "min-width": "110px",
	      "display": "inline-block"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.LegalPublisherName))])]), _vm._v(" "), _c('b', [_vm._v("(\"Publisher\") NOW THEREFORE THIS AGREEMENT WITNESSES THAT")]), _vm._v(" in consideration of good and valuable consideration,\n    the receipt and sufficiency of which are hereby acknowledged, the parties hereby covenant and agree as follows:")]), _vm._v(" "), _c('b', [_vm._v("1.    DEFINITIONS -")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b', [_vm._v("2.    TERM -")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v(" The term shall commence on the Effective Date. The term shall continue for a period of one (1) year and shall automatically renew at the end\n        of the one (1) year (collectively, the “Term”), unless otherwise earlier terminated by either party in accordance with this Agreement.")]), _vm._v(" "), _c('b', [_vm._v("3.    FEES AND REVENUES –")]), _c('br'), _vm._v(" "), _c('ol', {
	    staticClass: "list-items",
	    staticStyle: {
	      "margin-left": "40px"
	    },
	    attrs: {
	      "type": "a"
	    }
	  }, [_c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    },
	    attrs: {
	      "contenteditable": "false"
	    }
	  }, [_vm._v(" The Revenue Share Fee shall be "), _c('b', [_vm._v(_vm._s(_vm.revenuShare + '%'))]), _vm._v(" of Gross Revenue.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Net Revenues shall be sent to Publisher by Automatad within "), _c('b', {
	    attrs: {
	      "contenteditable": "false"
	    }
	  }, [_vm._v(_vm._s(_vm.periodToSendRevPub + " days"))]), _vm._v(" from the first day of the month following the month in which the Net\n            Revenues were earned. For clarity, Net Revenues earned in "), _c('b', {
	    attrs: {
	      "contenteditable": "false"
	    }
	  }, [_vm._v(_vm._s(_vm.example))]), _vm._v(".")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Automatad will not pay out any Running Balances less than Minimum Running Balance. If monthly Net Revenue is lower than the Minimum\n            Running Balance, it will be paid out in the first pay period where the Running Balance exceeds the Minimum Running Balance. If Net\n            Revenue in any month is less than $5.00 USD, the Net Revenue in that month will be $0 for all purposes.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Fee shall be calculated based on Automatad’s dashboard. In the event of a discrepancy of greater than 10% between Automatad’s records and Publisher’s records the parties shall review the data in good faith to resolve the discrepancy.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Publisher shall be responsible for payment of any taxes on Gross Revenues with the exception of corporate income taxes incurred by\n            Automatad on The Fee.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Net Revenues generated from prohibited content and/or fraudulent activities or in the event Revenues are uncollectible from Advertising Partners will not be paid by Automatad to Publisher. In the event these amounts have already been paid by Automatad to Publisher, Automatad shall have the right to withhold the balance receivable from future Net Revenues or to require immediate payment from Publisher to Automatad.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" In the event Net Revenues are less than zero for a month, the net amount owing to Automatad shall be paid by the Publisher to Automatad within 60 days from the first day of the month following the month in which the Revenues were earned. Should Publisher owe a balance to Automatad, Automatad shall issue an invoice to Publisher at least 15 days prior to the due date.")])]), _vm._v(" "), _c('b', [_vm._v("4.    TERMINATION OF AGREEMENT –")]), _vm._v(" "), _c('ol', {
	    staticClass: "list-items",
	    staticStyle: {
	      "margin-left": "40px"
	    },
	    attrs: {
	      "type": "a"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Term may be terminated by Publisher on "), _c('b', {
	    attrs: {
	      "contenteditable": "false"
	    }
	  }, [_vm._v(_vm._s(_vm.terminationDuration + " hours'"))]), _vm._v(" notice to Automatad.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Term may be terminated by Automatad immediately if Automatad reasonably believes there is any prohibited content or fraudulent activities.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" On the effective date of termination, all licenses granted hereunder shall terminate, all confidential information shall be returned to the respective party, the Automatad ad tags shall be turned off and Publisher shall cease use of any Automatad ad tags, code or other intellectual property.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Unless otherwise stated herein, a party shall pay all Net Revenues, up to the effective date of termination in accordance with Section 3.")])]), _vm._v(" "), _c('b', [_vm._v("5.    PUBLISHER MEDIA - ")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v(" Publisher must obtain Automatad’s prior written approval over all Publisher Media on which Publisher wishes to make ad inventory available through Automatad platform. Automatad may reject any Publisher Media for any reason in its sole discretion, and may also withdraw approval following acceptance (and cease delivery of ads to such Publisher Media) if Automatad reasonably determines any Publisher Media: (i) is no longer complying with the terms of this Agreement, (ii) has substantially changed since approval or no longer meets Automatad’s approval standards, (iii) contains prohibited content or is associated with a fraudulent activity, or (iv) is otherwise likely to cause damage or injury to the Automatad platform or Automatad’s reputation. By submitting any type of application for approval as a Publisher Media, Publisher represents and warrants to Automatad that such application: (i) provides the user with clear and conspicuous notice about all material functionality, (ii) obtains informed consent from the user prior to download, (iii) provides an easy-to-use uninstall to the user, and (iv) allows the user to maintain control over such user’s computing environment.")]), _vm._v(" "), _c('b', [_vm._v("6.    LICENSES - ")]), _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v(" Automatad hereby grants Publisher a non-exclusive, non-transferable, revocable license to use the Automatad platform and ad tags in accordance with these Terms and in connection with the Term. The Publisher hereby grants to Automatad a non-exclusive, non-transferable, revocable license to use the Publisher’s name, logo and trademarks in accordance with these Terms and in connection with the Term. Automatad shall own and retain all right, title and interest in and to Automatad’s platform, ad tags, confidential information and other intellectual property and Publisher shall own and retain all right, title and interest to the Publisher’s name, logo, trademarks, confidential information and other intellectual property.")]), _vm._v(" "), _c('b', [_vm._v("7.    DATA USE –")]), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v("\n        Automatad has the right to collect, use and disclose Non-Identifiable Data as follows (1) to carry out the service terms and conditions, (2) to perform analytics for general business purposes using aggregated Non-Identifiable Data from multiple sources and (3) any similar or related business purposes.")]), _vm._v(" "), _c('b', [_vm._v("8.    REPRESENTATIONS AND WARRANTIES –")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('b', [_vm._v("9.    CONFIDENTIAL INFORMATION –")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v(" Confidential information means all confidential and proprietary information of a party, whether oral or in writing, which is designated or identified as confidential or that reasonably should be understood to be confidential given the nature of the information and surrounding circumstances, but shall not include information that is (1) generally known to the public without breach hereunder; (2) was known prior to disclosure hereunder without restriction on disclosure; (3) independently developed without breach hereunder; or (4) is rightfully received from a third party without any restriction on disclosure. The parties shall only use confidential information for the purposes of performing the obligations hereunder. Automatad will not sell first party data without consent.")]), _vm._v(" "), _c('b', [_vm._v("10.    INDEMNITY")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('b', [_vm._v("11.    LIMITATION OF LIABILITY -")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("12.    MISCELLANEOUS –")]), _vm._v(" "), _vm._m(5), _vm._v("\n    Publisher Media is governed by the prior agreement or by this Agreement, this Agreement shall govern.\n    "), _vm._m(6)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    staticClass: "list-items",
	    staticStyle: {
	      "margin-left": "40px"
	    },
	    attrs: {
	      "type": "a"
	    }
	  }, [_c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Effective Date’ means the date noted above. ")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘External Advertising Fees’ means any fees that Automatad must pay in order to secure advertising spend and/or host and serve video advertisements and content on behalf of Publisher.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Gross Revenue’ means earnings net of External Advertising Fees generated from traffic through the Automatad platform.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Minimum Running Balance’ means $100.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Net Revenues’ means Revenues less Fees, if applicable.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Non-Identifiable Data’ means data that does not identify an individual, corporation or other entity, for all practical purposes, when used alone or combined with other available information.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Prohibited and Fraudulent Activities’ and ‘Prohibited Content’ and ‘Fraudulent Activities’ collectively include but are not limited to activities and content that violates applicable laws or intellectual property rights or that fraudulently, deceptively or artificially inflate the number of impressions, clicks or other payable action.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Publisher Media’ means all websites and mobile applications owned or operated by Publisher.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Requests’ means the sum of raw programmatic ad requests to Automatad and direct or other ad requests to Publisher’s advertisers, as displayed in Automatad’s dashboard.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Revenues’: earnings generated through Automatad’s accounts with Advertising Partners and payable directly to Automatad")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Running Balance’ means the total of all unpaid Net Revenues due to be paid.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Services’ means Automatad online advertising and real time bidding services including herein or otherwise mutually agreed to in writing between the parties.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Automatad Licensor’ means any party which licenses or provides Automatad a right to use such party’s solution or offer such solution to\n            Automatad customers and partners.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Automatad Licensor Solutions’ means services which are provided by applicable third party licensors and are obtained by Customer through Automatad.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘The Fee’ and ‘Fees’ refers to all fees defined in this Agreement or amendments thereof, including the Revenue Share Fee and Ad Serving\n            Fee")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" ‘Third Party Terms’ means a service or product agreement or terms and conditions offered by a third party, including Automatad Licensor")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Term may be terminated by Automatad on "), _c('b', [_vm._v("24 hours'")]), _vm._v(" notice to Publisher.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_vm._v("Publisher represents and warrants the following: (1) all of the Publisher’s websites, applications and other media complies with all applicable laws (the “Publisher’s Media”); (2) it shall place Automatad’s ad tags and code only on Publisher’s Media that has been approved by Automatad in writing; (3) it shall not modify or reverse engineer the Automatad platform, ad tags or other intellectual property; (4) it complies with all applicable laws, including privacy laws; (5) it shall not include any prohibited content in the Publisher’s Media; and (6) it shall not sell ad inventory on sites directed at users under the age of 13 years. Automatad represents and warrants the following: (1) it has the right to enter into the Agreement; (2) it will comply with all applicable laws and regulations relating to the Agreement; (3) it shall not modify or reverse engineer Publisher Media or other intellectual property of the Publisher; and (4) its performance of the Services will not violate or infringe on any third party’s intellectual property rights or proprietary or confidential information."), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    staticClass: "list-items",
	    staticStyle: {
	      "margin-left": "40px"
	    },
	    attrs: {
	      "type": "a"
	    }
	  }, [_c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Publisher shall indemnify, defend and hold harmless Automatad, its affiliates and their respective directors, officers, employees, agents, consultants and subcontractors (each a “Automatad Indemnitee”) from and against any and all Losses incurred by by such Automatad Indemnitee arising out of or relating to (i) allegation of facts that, if true, would constitute Publisher’s breach of any of its representations, warranties, covenants or obligations under this Agreement, (ii) negligence or willful misconduct by Publisher or any third party on behalf of Publisher in connection with this Agreement, and (iii) claims for which Publisher is at law responsible. Publisher shall also indemnify, defend and hold harmless all Automatad Licensors whose Third Party Terms apply to Publisher (“Automatad Licensor Indemnitee”) against all Losses incurred by Automatad Licensor Indemnitee in relation to breach of any of its representations, warranties, covenants or obligations under this Agreement.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Automatad shall indemnify, defend and hold harmless Publisher and Publisher’s officers, directors, employees, agents, permitted successors and permitted assigns (each, a “Publisher Indemnitee”) from and against any and all Losses incurred by such Publisher Indemnitee arising out of or relating to any Claim by a third party (other than an Affiliate of a Publisher Indemnitee) to the extent that such Losses arise from any allegation that Publisher’s use of the Services (excluding Automatad Licensor services) in compliance with this Agreement infringes the Intellectual Property rights of a third party.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "margin-left": "35px"
	    }
	  }, [_vm._v(" NOTWITHSTANDING ANY OTHER PROVISION HEREIN OR ANY APPLICABLE STATUTORY PROVISIONS, NEITHER PARTY SHALL BE LIABLE TO THE OTHER PARTY OR ANY THIRD PARTY FOR INDIRECT, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES WHATSOEVER, INCLUDING LOSS OF PROFITS, WHETHER ARISING DIRECTLY OR INDIRECTLY FROM ANY BREACH OF THE TERMS OR FROM ANY ACTIONS OR OMISSIONS OF ITS OFFICERS, EMPLOYEES OR AGENTS WHICH MAY GIVE RISE TO ANY LIABILITY (WHETHER IN TORT, INCLUDING FOR NEGLIGENCE, STRICT LIABILITY OR UNDER ANY OTHER THEORY OF LEGAL LIABILITY). IN NO EVENT SHALL THE AGGREGATE LIABILITY OF EITHER PARTY EXCEED THE AMOUNT OF THE FEE IN THE 3 MONTH PERIOD PRECEDING THE INCIDENT GIVING RISE TO THE CLAIM."), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    staticClass: "list-items",
	    staticStyle: {
	      "margin-left": "40px"
	    },
	    attrs: {
	      "type": "a"
	    }
	  }, [_c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" All notices given hereunder shall be in writing and may be sent by registered mail, courier, email or facsimile transmission, and addressed to the receiving party at the address set out in the Invoice or as subsequently agreed between the parties. Notices shall be deemed to be given when received by the other party.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Agreement constitutes the entire understanding between the parties concerning its subject matter and supersedes all prior agreements and understandings between the parties. Automatad may update its standard terms and conditions on notice to Publisher.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Nothing in the Agreement shall create any association, partnership, joint venture, employer-employee or agent-principal relationship between the parties.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Any waiver or failure to perform or breach of any provision of the Agreement shall not operate or be construed as a waiver of any other right under the Agreement or of any other breach or failure whether of a similar nature or otherwise.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" If any provision of the Agreement is held to be invalid, the remaining provisions shall remain in full force and effect.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Publisher acknowledges that Automatad may pay a referral fee in respect of this Agreement and Publisher hereby consents to Automatad releasing information related to the Fees to the applicable referrer in order to pay such referral fee.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" Neither party may assign the Agreement, by operation of law or otherwise, without the written consent of the other party, however either party may assign this agreement in its entirety without the other party’s consent to its affiliate or in connection with a merger, acquisition, corporate reorganization or a sale of all or substantially all of its assets.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" The Agreement and the rights of the parties hereunder shall be governed by and interpreted in accordance with the laws of the Delaware, US, without giving effect to principles of conflicts of laws. The parties hereto irrevocably and unconditionally submit to the exclusive jurisdiction of the courts of the Delaware, US, over any suit, action or proceeding arising out of or relating to the Agreement.")]), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(" If Publisher has entered into a prior agreement with Automatad, to the extent there are any inconsistencies between whether a particular.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "display": "inline-block"
	    }
	  }, [_c('b', [_vm._v("[Publisher]")]), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v("Signature")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v(" Name")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v(" Title")]), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date Signed")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "word-break": "break-all",
	      "margin-left": "5px",
	      "display": "inline-block",
	      "vertical-align": "baseline",
	      "width": "50%"
	    },
	    attrs: {
	      "id": "pdt"
	    }
	  }, [_c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "40%",
	      "margin-left": "150px",
	      "display": "inline-block"
	    }
	  }, [_c('br', {
	    staticStyle: {
	      "clear": "both"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("[Automatad]")]), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v("Signature")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "margin-right": "10px"
	    }
	  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date Signed")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "word-break": "break-all",
	      "margin-left": "5px",
	      "display": "inline-block",
	      "vertical-align": "baseline",
	      "width": "50%"
	    },
	    attrs: {
	      "id": "pdt2"
	    }
	  }, [_c('input', {
	    staticStyle: {
	      "background": "transparent",
	      "border": "none",
	      "border-bottom": "1px solid #000000"
	    },
	    attrs: {
	      "type": "text"
	    }
	  })])])])])])
	}]}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Enter Publisher's Name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Publisher name"
	    },
	    model: {
	      value: (_vm.credentials.name),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "name", $$v)
	      },
	      expression: "credentials.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "disabled": !_vm.formValid
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n            Create Publisher\n          ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/bidders/"
	    }
	  }, [_vm._v("Cancel")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Publisher For Bidder")])])
	}]}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.createFirstImpression && !_vm.showeditFirstImpression),
	      expression: "!createFirstImpression && !showeditFirstImpression"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Existing Adunits Under First Impression")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0);"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showCreateForm()
	      }
	    }
	  }, [_vm._v("Create First Impression Ad Unit")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.fiExistingAdUnits
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.div_id))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Ad Unit",
	      "prop": "ad_unit_name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unique id",
	      "prop": "div_id"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Selector",
	      "prop": "selector"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Dyn. Plcmnt?",
	      "width": "110"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.row.is_dynamic ? 'true' : 'false') + "\n\t\t\t\t\t\t")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Activate?",
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!scope.row.hb) ? _c('div', {
	          staticClass: "clearfix"
	        }, [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/publisher/'+ _vm.uuid +'/domain/'+ _vm.domId +'/buckets/'+ _vm.bucketId +'/hb-tags/?tag_id='+ scope.row.id))
	          }
	        }, [_c('span', [_vm._v("Setup HB")])])], 1) : _vm._e(), _vm._v(" "), (scope.row.hb) ? _c('div', {
	          staticClass: "clearfix"
	        }, [_c('el-switch', {
	          attrs: {
	            "active-color": "#13ce66",
	            "inactive-color": "#ff4949"
	          },
	          model: {
	            value: (scope.row.active),
	            callback: function($$v) {
	              _vm.$set(scope.row, "active", $$v)
	            },
	            expression: "scope.row.active"
	          }
	        })], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Edit",
	      "width": "60"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--success edit",
	          on: {
	            "click": function($event) {
	              return _vm.editFirstImpression(props)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-pencil"
	        })])]
	      }
	    }])
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.createFirstImpression),
	      expression: "createFirstImpression"
	    }],
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.formData.data.length > 0),
	      expression: "formData.data.length > 0"
	    }],
	    staticClass: "clearfix"
	  }, [_c('h5', [_vm._v("Created ad unit")]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.formData.data
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "icon",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.div_id))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unique div id",
	      "prop": "div_id"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Selector",
	      "prop": "selector"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Ad unit name",
	      "prop": "ad_unit_name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Dyn. Plcmnt?",
	      "prop": "dp",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Remove?",
	      "width": "90"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--danger remove",
	          on: {
	            "click": function($event) {
	              return _vm.removeCreatedAdUnit(props.row)
	            }
	          }
	        }, [_c('span', [_vm._v("×")])])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post",
	      "name": "firstImpression"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onCreateSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Select Ad Unit")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select a adunit",
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.getAdunits,
	      "loading": _vm.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setSelectedAdUnit()
	      }
	    },
	    model: {
	      value: (_vm.formData.adunit),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "adunit", $$v)
	      },
	      expression: "formData.adunit"
	    }
	  }, _vm._l((_vm.adunits), function(adunit) {
	    return _c('el-option', {
	      key: adunit.ad_unit_id,
	      attrs: {
	        "label": adunit.ad_unit_name,
	        "value": adunit.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h5', [_vm._v("Unique Div id")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('divid')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "divid",
	      "type": "text",
	      "placeholder": "Unique div id"
	    },
	    model: {
	      value: (_vm.formData.divid),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "divid", $$v)
	      },
	      expression: "formData.divid"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('divid')),
	      expression: "errors.has('divid')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('divid')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Dynamic Placement?")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-5"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.formData.dynamicPlacement),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "dynamicPlacement", $$v)
	      },
	      expression: "formData.dynamicPlacement"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Selector")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('selector')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "selector",
	      "type": "text",
	      "placeholder": "Selector of element where ad will appear"
	    },
	    model: {
	      value: (_vm.formData.selector),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "selector", $$v)
	      },
	      expression: "formData.selector"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('selector')),
	      expression: "errors.has('selector')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('selector')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('h5', [_vm._v("Add?")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createAdUnitSpot()
	      }
	    }
	  }, [_vm._v("Add")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row text-center"
	  }, [_c('button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.formData.data.length == 0
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelForm()
	      }
	    }
	  }, [_vm._v("Cancel")])])], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showeditFirstImpression),
	      expression: "showeditFirstImpression"
	    }],
	    staticClass: "box"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post",
	      "name": "firstImpression"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onEditSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Select Ad Unit")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select a adunit",
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.getAdunits,
	      "loading": _vm.loading
	    },
	    model: {
	      value: (_vm.editForm.adunit),
	      callback: function($$v) {
	        _vm.$set(_vm.editForm, "adunit", $$v)
	      },
	      expression: "editForm.adunit"
	    }
	  }, _vm._l((_vm.adunits), function(adunit) {
	    return _c('el-option', {
	      key: adunit.ad_unit_id,
	      attrs: {
	        "label": adunit.ad_unit_name,
	        "value": adunit.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Active?")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-5"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.editForm.active),
	      callback: function($$v) {
	        _vm.$set(_vm.editForm, "active", $$v)
	      },
	      expression: "editForm.active"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Unique Div id")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('edivid')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "edivid",
	      "type": "text",
	      "placeholder": "Unique div id"
	    },
	    model: {
	      value: (_vm.editForm.divid),
	      callback: function($$v) {
	        _vm.$set(_vm.editForm, "divid", $$v)
	      },
	      expression: "editForm.divid"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('edivid')),
	      expression: "errors.has('edivid')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('edivid')))])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Dynamic Placement?")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-5"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.editForm.dynamicPlacement),
	      callback: function($$v) {
	        _vm.$set(_vm.editForm, "dynamicPlacement", $$v)
	      },
	      expression: "editForm.dynamicPlacement"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Selector")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "eselector",
	      "type": "text",
	      "placeholder": "Selector of element where ad will appear"
	    },
	    model: {
	      value: (_vm.editForm.selector),
	      callback: function($$v) {
	        _vm.$set(_vm.editForm, "selector", $$v)
	      },
	      expression: "editForm.selector"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix text-center"
	  }, [_c('button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelForm()
	      }
	    }
	  }, [_vm._v("Cancel")])])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create First Impression Ad Unit")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Edit First Impression Ad Unit")])])
	}]}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slide"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "container main-notes"
	  }, [_c('div', {
	    staticClass: "form-container"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('h5', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(("" + _vm.domainName)))]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right",
	    attrs: {
	      "id": "svgContainer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addnote()
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-plus-circle fa-w-16 fa-2x",
	    attrs: {
	      "width": "18px",
	      "height": "18px",
	      "aria-hidden": "true",
	      "data-prefix": "fal",
	      "data-icon": "plus-circle",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 512 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "notes-text"
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 2,
	      "placeholder": "Please input notes"
	    },
	    on: {
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.addnote.apply(null, arguments)
	      }
	    },
	    model: {
	      value: (_vm.notesInput),
	      callback: function($$v) {
	        _vm.notesInput = $$v
	      },
	      expression: "notesInput"
	    }
	  })], 1)]), _vm._v(" "), (_vm.notes.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.notes.slice().reverse()), function(not, index) {
	    return _c('li', [_c('span'), _vm._v(" "), _c('div', [_c('div', {
	      staticClass: "title first-name"
	    }, [_vm._v(_vm._s(("" + (not.created_by.first_name))))]), _vm._v(" "), _c('div', {
	      staticClass: "type"
	    }, [_vm._v(_vm._s(("" + (not.note))))])]), _vm._v(" "), _c('span', {
	      staticClass: "number"
	    }, [_c('span', [_c('span', {
	      staticClass: "notes-time"
	    }, [_vm._v(_vm._s(_vm._f("moment")(("" + (not.created)), "MMM Do, h:mm:ss a")))])]), _vm._v(" "), _c('span')])])
	  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "overlay",
	    on: {
	      "click": function($event) {
	        return _vm.stepBack()
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "heading-cart"
	  }, [_c('div', {
	    staticClass: "col-lg-6 col-md-6 no-padding"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct direct-campaigns")]), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('h3', {
	    staticClass: "box-title text-danger animated flash config-notif"
	  }, [_c('b', [_vm._v(" Imported config from " + _vm._s(_vm.selectedBucketNameToImportConfig) + " Bucket. Click save to use the config.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 col-md-6 no-padding"
	  }, [_c('a', {
	    staticClass: "btn-success",
	    staticStyle: {
	      "background": "#5cb85c",
	      "margin-right": "175px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "right",
	      "padding": "0px",
	      "margin": "0px"
	    }
	  }, [_c('el-dropdown', {
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.selectBucketModule
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "mini",
	      "title": (_vm.selectedBucketNameToImportConfig) ? _vm.selectedBucketNameToImportConfig : 'Import Config'
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s((_vm.selectedBucketNameToImportConfig) ? _vm.selectedBucketNameToImportConfig : 'Import Config')), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.bucketListForModuleConfig), function(bucket, index) {
	    return _c('el-dropdown-item', {
	      attrs: {
	        "command": index
	      }
	    }, [_vm._v(_vm._s(bucket.bucketName))])
	  }), 1)], 1), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('button', {
	    staticClass: "btn btn-sm btn-default btn-circle",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.removeSelectedModuleConfig()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-close"
	  })]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Enter Name for Direct Campaign")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publishers-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Name"
	    },
	    model: {
	      value: (_vm.credentials.name),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "name", $$v)
	      },
	      expression: "credentials.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select Ad Unit")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select a adunit",
	      "filterable": "",
	      "multiple": "",
	      "remote": "",
	      "remote-method": _vm.getAdunits,
	      "loading": _vm.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setSelectedAdUnit()
	      }
	    },
	    model: {
	      value: (_vm.credentials.adunit),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "adunit", $$v)
	      },
	      expression: "credentials.adunit"
	    }
	  }, _vm._l((_vm.adunits), function(adunit) {
	    return _c('el-option', {
	      key: adunit.ad_unit_id,
	      attrs: {
	        "label": adunit.ad_unit_name,
	        "value": adunit.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('h5', {
	    staticClass: "demonstration"
	  }, [_vm._v("Specify Start Date and End Date")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "datetimerange",
	      "range-separator": "To",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date"
	    },
	    model: {
	      value: (_vm.credentials.date),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "date", $$v)
	      },
	      expression: "credentials.date"
	    }
	  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Direct Campaign Type")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.credentials.line_item_type),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "line_item_type", $$v)
	      },
	      expression: "credentials.line_item_type"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.credentials.line_item_type == 'STANDARD') ? _c('div', [_c('h5', [_vm._v("Enter Quantity")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('number')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "number",
	      "type": "number",
	      "placeholder": "Contact Number"
	    },
	    model: {
	      value: (_vm.credentials.primary_goal_units),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "primary_goal_units", $$v)
	      },
	      expression: "credentials.primary_goal_units"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('number')),
	      expression: "errors.has('number')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('number')))]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.credentials.primary_goal_unit_type),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "primary_goal_unit_type", $$v)
	      },
	      expression: "credentials.primary_goal_unit_type"
	    }
	  }, _vm._l((_vm.QuantityOptions), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enter Rate")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('number')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "number",
	      "type": "number",
	      "placeholder": "Contact Number"
	    },
	    model: {
	      value: (_vm.amount),
	      callback: function($$v) {
	        _vm.amount = $$v
	      },
	      expression: "amount"
	    }
	  }, [_vm._v("% of total impressions ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('number')),
	      expression: "errors.has('number')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('number')))]), _vm._v(" "), _c('hr')], 1) : (_vm.credentials.line_item_type == 'SPONSORSHIP') ? _c('div', [_c('h5', [_vm._v("Enter Quantity % of total impressions")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('number')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "number",
	      "type": "number",
	      "placeholder": "Contact Number"
	    },
	    model: {
	      value: (_vm.credentials.primary_goal_units),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "primary_goal_units", $$v)
	      },
	      expression: "credentials.primary_goal_units"
	    }
	  }, [_vm._v("% of total impressions ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('number')),
	      expression: "errors.has('number')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('number')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enter Rate")]), _vm._v(" "), _c('p', {
	    class: {
	      'control': true
	    }
	  }), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "publisher-input",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('number')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "number",
	      "type": "number",
	      "placeholder": "Contact Number"
	    },
	    model: {
	      value: (_vm.amount),
	      callback: function($$v) {
	        _vm.amount = $$v
	      },
	      expression: "amount"
	    }
	  }, [_vm._v("% of total impressions ")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('number')),
	      expression: "errors.has('number')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('number')))]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.credentials.cost_type),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "cost_type", $$v)
	      },
	      expression: "credentials.cost_type"
	    }
	  }, _vm._l((_vm.SponsorshipOptions), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.credentials.line_item_type == 'STANDARD' | 'SPONSORSHIP') ? _c('div', {
	    staticClass: "col-md-12 creativeSnippet"
	  }, [_c('h5', [_vm._v("Enter the Creative")]), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
	    return _c('div', [_c('div', {
	      staticClass: "col-md-8 creativeSnippet"
	    }, [_c('el-input', {
	      attrs: {
	        "type": "textarea",
	        "autosize": {
	          minRows: 2,
	          maxRows: 4
	        },
	        "placeholder": "Please input"
	      },
	      model: {
	        value: (row.title),
	        callback: function($$v) {
	          _vm.$set(row, "title", $$v)
	        },
	        expression: "row.title"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4 creativeSnippet"
	    }, [_c('button', {
	      staticClass: "btn btn-sm btn-danger btn-circle",
	      on: {
	        "click": function($event) {
	          return _vm.removeElement(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon-close"
	    })])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.addRow
	    }
	  }, [_vm._v("Add Creative")]), _vm._v(" "), _c('hr')], 1)], 2) : _vm._e(), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Submit")])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("loading ...")])])
	}]}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    staticStyle: {
	      "background": "#d6d7d9"
	    }
	  }, [_c('div', {
	    staticClass: "heading-cart"
	  }, [_c('div', {
	    staticClass: "col-lg-12 col-md-12 no-padding"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Activity Exposure Time")]), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('h3', {
	    staticClass: "box-title text-danger animated flash config-notif"
	  }, [_c('b', [_vm._v("Imported config from " + _vm._s(_vm.selectedBucketNameToImportConfig) + " Bucket. Click save to\n                                    use the config.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12 col-md-12 no-padding"
	  }, [_c('div', {
	    staticClass: "col-md-9 col-lg-9"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-lg-2",
	    staticStyle: {
	      "display": "inline-block",
	      "padding": "0px",
	      "margin": "0px"
	    }
	  }, [(!_vm.selectedBucketNameToImportConfig) ? _c('el-dropdown', {
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.selectBucketModule
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "mini",
	      "title": 'Import Config'
	    }
	  }, [_vm._v("\n                                        Import Config"), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), (_vm.bucketListForModuleConfig.length > 0) ? _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.bucketListForModuleConfig), function(bucket, index) {
	    return _c('el-dropdown-item', {
	      key: index,
	      attrs: {
	        "command": index
	      }
	    }, [_vm._v(_vm._s(bucket.bucketName))])
	  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('el-button', {
	    staticStyle: {
	      "min-width": "130px",
	      "float": "right"
	    },
	    attrs: {
	      "type": "danger",
	      "size": "mini",
	      "title": _vm.Reset
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.removeSelectedModuleConfig()
	      }
	    }
	  }, [_vm._v("Reset\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1 col-lg-1 no-padding"
	  }, [_c('a', {
	    staticClass: "btn-success",
	    staticStyle: {
	      "background": "#5cb85c",
	      "position": "relative !important"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveAndPublishAxt()
	      }
	    }
	  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 col-md-12"
	  }, [_c('div', {
	    staticClass: "col-lg-2 col-md-2"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Enable/Disable")]), _vm._v(" "), _c('el-switch', {
	    staticStyle: {
	      "line-height": "35px !important"
	    },
	    attrs: {
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.axtConfig.isEnabled),
	      callback: function($$v) {
	        _vm.$set(_vm.axtConfig, "isEnabled", $$v)
	      },
	      expression: "axtConfig.isEnabled"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-md-3"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("\n                                    Ignore Ad-Unit Auto detection\n                                ")]), _vm._v(" "), _c('el-switch', {
	    staticStyle: {
	      "line-height": "35px !important"
	    },
	    attrs: {
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.axtConfig.activateWhitelist),
	      callback: function($$v) {
	        _vm.$set(_vm.axtConfig, "activateWhitelist", $$v)
	      },
	      expression: "axtConfig.activateWhitelist"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-md-3 no-padding"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Initial exposure(sec)")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "initial"
	    },
	    model: {
	      value: (_vm.axtConfig.initialExpo),
	      callback: function($$v) {
	        _vm.$set(_vm.axtConfig, "initialExpo", $$v)
	      },
	      expression: "axtConfig.initialExpo"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-md-3"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Subsequent exposure(sec)")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "sub-sequent"
	    },
	    model: {
	      value: (_vm.axtConfig.subSequentExpo),
	      callback: function($$v) {
	        _vm.$set(_vm.axtConfig, "subSequentExpo", $$v)
	      },
	      expression: "axtConfig.subSequentExpo"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12 col-md-12"
	  }, [
	    [_c('el-table', {
	      directives: [{
	        name: "loading",
	        rawName: "v-loading",
	        value: (_vm.loading),
	        expression: "loading"
	      }],
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "data": _vm.axtDCBlockList,
	        "stripe": "",
	        "height": "200"
	      },
	      on: {
	        "selection-change": _vm.handleDCSelectionChange
	      }
	    }, [_c('el-table-column', {
	      attrs: {
	        "type": "selection",
	        "width": "30"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "advertiser_id",
	        "align": _vm.left,
	        "label": "Advertiser/Campaign ID",
	        "width": "600"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "IsBlocked",
	        "width": "200"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [(props.row.is_blocklisted) ? _c('div', {
	            staticClass: "text-center"
	          }, [_c('svg', {
	            staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	            attrs: {
	              "data-v-7a40f996": "",
	              "aria-hidden": "true",
	              "height": "20px",
	              "width": "20px",
	              "data-prefix": "far",
	              "data-icon": "check-circle",
	              "role": "img",
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 512 512"
	            }
	          }, [_c('path', {
	            attrs: {
	              "data-v-7a40f996": "",
	              "fill": "green",
	              "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	            }
	          })])]) : _vm._e(), _vm._v(" "), (!props.row.is_blocklisted) ? _c('div', {
	            staticClass: "text-center"
	          }, [_c('svg', {
	            staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	            attrs: {
	              "aria-hidden": "true",
	              "height": "20px",
	              "width": "20px",
	              "data-prefix": "fal",
	              "data-icon": "times-circle",
	              "role": "img",
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 512 512"
	            }
	          }, [_c('path', {
	            attrs: {
	              "fill": "red",
	              "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	            }
	          })])]) : _vm._e()]
	        }
	      }])
	    })], 1)]
	  ], 2), _vm._v(" "), (!_vm.enableDCConfigSetting) ? _c('div', {
	    staticClass: "col-lg-12 col-md-12",
	    staticStyle: {
	      "padding": "3px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-10 col-lg-10"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Advertiser/Campaign ID")]), _vm._v(" "), _c('el-input', {
	    staticStyle: {
	      "margin-top": "7px !important"
	    },
	    attrs: {
	      "placeholder": "Advertiser/Campaign Id"
	    },
	    model: {
	      value: (_vm.directCampConfig.advertId),
	      callback: function($$v) {
	        _vm.$set(_vm.directCampConfig, "advertId", $$v)
	      },
	      expression: "directCampConfig.advertId"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-2 col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-md btn-primary btn-mt",
	    staticStyle: {
	      "margin-top": "20px !important"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addAdvertiserIdtoBlock()
	      }
	    }
	  }, [_vm._v("\n                                    Add\n                                ")])])]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-12 col-md-12"
	  }, _vm._l((_vm.axtConfig.associatedTags), function(dimension, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "col-lg-6 col-md-6"
	    }, [_c('div', {
	      staticClass: "col-lg-3 col-md-3 no-padding",
	      staticStyle: {
	        "padding-top": "10px !important"
	      }
	    }, [_c('el-checkbox', {
	      attrs: {
	        "label": dimension.creativeSizeLable,
	        "size": "small"
	      },
	      model: {
	        value: (dimension.isChecked),
	        callback: function($$v) {
	          _vm.$set(dimension, "isChecked", $$v)
	        },
	        expression: "dimension.isChecked"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-8 col-md-8 no-padding",
	      staticStyle: {
	        "margin-top": "3px"
	      }
	    }, [_c('el-select', {
	      attrs: {
	        "size": "small",
	        "placeholder": "Select Tag",
	        "filterable": ""
	      },
	      model: {
	        value: (_vm.axtConfig.associatedTags[index].selectedTags),
	        callback: function($$v) {
	          _vm.$set(_vm.axtConfig.associatedTags[index], "selectedTags", $$v)
	        },
	        expression: "axtConfig.associatedTags[index].selectedTags"
	      }
	    }, _vm._l((_vm.axtTags), function(tags) {
	      return _c('el-option', {
	        key: tags.id,
	        attrs: {
	          "label": tags['dfp-ad-unit-path'],
	          "value": tags.id,
	          "selected": dimension.selectedTags == tags.id
	        }
	      })
	    }), 1)], 1)])
	  }), 0)]), _vm._v(" "), _vm._m(3), _vm._v(" "), [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.axtConfigUnitList,
	      "stripe": "",
	      "height": "400"
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "30"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "layoutName",
	      "sortable": "",
	      "filters": _vm.filterList,
	      "filter-method": _vm.layoutFilterHandler,
	      "label": "Layout",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "adSpotName",
	      "label": "Ad Spot",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Block AXT",
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.isBlocked) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.isBlocked) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Force AXT",
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.isWhitelisted) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.isWhitelisted) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Initial(sec)",
	      "prop": "initialExpo",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Subsequent(sec)",
	      "prop": "subSeqExpo",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Ignore Activity",
	      "width": "110"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.ignoreActivity) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.ignoreActivity) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Selected Tag "
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(prop) {
	        return [_c('div', [_vm._v("\n                                        " + _vm._s(_vm.getTag(_vm.axtTags, prop.row.tagId)) + "\n                                    ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Multisize Dimension(WxH)"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(prop) {
	        return [_c('div', [_vm._v("\n                                        " + _vm._s(_vm.getDimensionLable(prop.row.multiSize)) + "\n                                    ")])]
	      }
	    }])
	  })], 1)], _vm._v(" "), _c('div', {
	    staticClass: "row clearfix"
	  }, [(_vm.multiSelectedUnits.length == 0) ? _c('div', {
	    staticClass: "col-lg-12 col-md-12 no-padding"
	  }, [_c('div', {
	    staticClass: "col-lg-5 col-md-5"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a Layout"
	    },
	    on: {
	      "change": _vm.getAdSpots
	    },
	    model: {
	      value: (_vm.setUnitConfig.layout),
	      callback: function($$v) {
	        _vm.$set(_vm.setUnitConfig, "layout", $$v)
	      },
	      expression: "setUnitConfig.layout"
	    }
	  }, _vm._l((_vm.layoutsList), function(layout) {
	    return _c('el-option', {
	      key: layout.id,
	      attrs: {
	        "label": layout.layout_name,
	        "value": layout.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-5 col-md-5"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ad Spot")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a AdSpot"
	    },
	    model: {
	      value: (_vm.setUnitConfig.layoutAdSpots),
	      callback: function($$v) {
	        _vm.$set(_vm.setUnitConfig, "layoutAdSpots", $$v)
	      },
	      expression: "setUnitConfig.layoutAdSpots"
	    }
	  }, _vm._l((_vm.layoutAdSpotsList), function(adSpot) {
	    return _c('el-option', {
	      key: adSpot.id,
	      attrs: {
	        "label": adSpot.adSpot,
	        "value": adSpot.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-2 col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-md btn-primary btn-mt",
	    on: {
	      "click": function($event) {
	        return _vm.addUnitToConfigList()
	      }
	    }
	  }, [_vm._v("\n                                    Add\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.multiSelectedUnits.length > 0) ? _c('div', {
	    staticClass: "col-md-12 col-lg-12 no-padding"
	  }, [_c('div', {
	    staticClass: "col-md-1 col-lg-1"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Block AXT")]), _vm._v(" "), _c('el-switch', {
	    staticStyle: {
	      "line-height": "30px !important"
	    },
	    attrs: {
	      "disabled": _vm.multiSelectConfig.isWhitelisted,
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.multiSelectConfig.isBlocked),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "isBlocked", $$v)
	      },
	      expression: "multiSelectConfig.isBlocked"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1 col-lg-1"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Force AXT")]), _vm._v(" "), _c('el-switch', {
	    staticStyle: {
	      "line-height": "30px !important"
	    },
	    attrs: {
	      "disabled": _vm.multiSelectConfig.isBlocked,
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.multiSelectConfig.isWhitelisted),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "isWhitelisted", $$v)
	      },
	      expression: "multiSelectConfig.isWhitelisted"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-lg-2"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Initial exposure(sec)")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.multiSelectConfig.isBlocked,
	      "placeholder": "Initial"
	    },
	    model: {
	      value: (_vm.multiSelectConfig.initialExpo),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "initialExpo", $$v)
	      },
	      expression: "multiSelectConfig.initialExpo"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-lg-2"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Subsequent exposure(sec)")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.multiSelectConfig.isBlocked,
	      "placeholder": "Subsequent"
	    },
	    model: {
	      value: (_vm.multiSelectConfig.subSeqExpo),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "subSeqExpo", $$v)
	      },
	      expression: "multiSelectConfig.subSeqExpo"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-lg-2"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Select Tag")]), _vm._v(" "), _c('el-select', {
	    staticClass: "tag-dropdown",
	    attrs: {
	      "size": "small",
	      "clearable": "",
	      "placeholder": "Select Tag",
	      "filterable": "",
	      "disabled": _vm.multiSelectConfig.isBlocked
	    },
	    model: {
	      value: (_vm.multiSelectConfig.tagId),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "tagId", $$v)
	      },
	      expression: "multiSelectConfig.tagId"
	    }
	  }, _vm._l((_vm.axtTags), function(tags) {
	    return _c('el-option', {
	      key: tags.id,
	      attrs: {
	        "label": tags['dfp-ad-unit-path'],
	        "value": tags.id,
	        "selected": _vm.multiSelectConfig.tagId == tags.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-lg-2"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Multisize (W X H)")]), _vm._v(" "), _c('el-select', {
	    staticClass: "tag-dropdown",
	    attrs: {
	      "size": "small",
	      "clearable": "",
	      "placeholder": "W X H",
	      "filterable": "",
	      "disabled": _vm.multiSelectConfig.isBlocked
	    },
	    model: {
	      value: (_vm.multiSelectConfig.multiSize),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "multiSize", $$v)
	      },
	      expression: "multiSelectConfig.multiSize"
	    }
	  }, _vm._l((_vm.creativeSizeList), function(dimension) {
	    return _c('el-option', {
	      key: dimension.id,
	      attrs: {
	        "label": dimension.width + 'x' + dimension.height,
	        "value": dimension.id,
	        "selected": _vm.multiSelectConfig.multiSize == dimension.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1 col-lg-1"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Ignore Activity")]), _vm._v(" "), _c('el-switch', {
	    staticStyle: {
	      "line-height": "30px !important"
	    },
	    attrs: {
	      "disabled": _vm.multiSelectConfig.isBlocked,
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.multiSelectConfig.ignoreActivity),
	      callback: function($$v) {
	        _vm.$set(_vm.multiSelectConfig, "ignoreActivity", $$v)
	      },
	      expression: "multiSelectConfig.ignoreActivity"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiSelectedUnits.length > 0) ? _c('div', {
	    staticClass: "col-md-12 col-lg-12 no-padding"
	  }, [_c('div', {
	    staticClass: "col-md-1 col-lg-1 no-padding text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-success",
	    staticStyle: {
	      "background": "#5cb85c",
	      "position": "relative !important",
	      "margin-top": "10px !important"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveUnitConfiguration()
	      }
	    }
	  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1 col-lg-1 no-padding text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-danger",
	    staticStyle: {
	      "position": "relative !important",
	      "margin-top": "10px !important"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deleteAdSpotFromConfig()
	      }
	    }
	  }, [_vm._v("Delete")])]), _vm._v(" "), _vm._m(4)]) : _vm._e()])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-lg-12 col-md-12",
	    staticStyle: {
	      "background": "#d6d7d9",
	      "padding": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-lg-11 col-md-11"
	  }, [_c('h2', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Campaign Blocklist(Advertiser/Campaign ID)")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 col-md-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-lg-12 col-md-12",
	    staticStyle: {
	      "background": "#d6d7d9",
	      "padding": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-lg-11 col-md-11"
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "display": "block !important"
	    }
	  }, [_vm._v("Tag Association")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 col-md-12",
	    staticStyle: {
	      "background": "#d6d7d9",
	      "padding": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "col-lg-11 col-md-11"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ad-Unit specific configuration")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-1 col-lg-1 no-padding text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-primary",
	    staticStyle: {
	      "position": "relative !important",
	      "margin-top": "10px !important"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Cancel")])])
	}]}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('div', {
	    staticClass: "pull-right hidden-xs"
	  }, [_c('b', [_vm._v("Version")]), _vm._v(" 1.0.0\n  ")]), _vm._v("\n  Automatad © 2018 "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('strong', [_vm._v("Yeti")])]), _vm._v(". Made with love\n")])
	}]}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('section', {
	    staticClass: "sidebar"
	  }, [_c('div', {
	    staticClass: "user-panel"
	  }, [_c('div', {
	    staticClass: "image"
	  }, [(!_vm.is90d) ? _c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/avatar2.png",
	      "alt": "User Image"
	    }
	  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
	    staticClass: "bg-user",
	    attrs: {
	      "src": "/static/img/avatar-bg.png",
	      "alt": "User Image"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "treeview"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/admin/publishers/"
	    }
	  }, [_c('span', {
	    staticClass: "svg-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    staticStyle: {
	      "font-size": "17px"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v("Publishers")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/admin/domains/"
	    }
	  }, [_c('span', {
	    staticClass: "svg-icon"
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-globe fa-w-16",
	    attrs: {
	      "aria-hidden": "true",
	      "width": "20px",
	      "height": "20px",
	      "data-prefix": "fal",
	      "data-icon": "globe",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 496 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"
	    }
	  })])]), _vm._v(" "), _c('span', [_vm._v("Domains")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  })])], 1), _vm._v(" "), _vm._l((_vm.navigation), function(nav) {
	    return _c('li', {
	      key: nav.name,
	      staticClass: "treeview"
	    }, [(
	      (nav.path && nav.path.indexOf('dfp-settings') == -1) ||
	      (nav.path && nav.path.indexOf('dfp-settings') > -1 && _vm.hasAccess)
	    ) ? _c('router-link', {
	      attrs: {
	        "to": ("" + (nav.path))
	      }
	    }, [(!nav.isSvg) ? _c('i', {
	      class: ("" + (nav.icon))
	    }) : _vm._e(), _vm._v(" "), (nav.isSvg) ? _c('span', {
	      staticClass: "svg-icon",
	      domProps: {
	        "innerHTML": _vm._s(nav.icon)
	      }
	    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(nav.name))]), _vm._v(" "), (nav.modules.length) ? _c('span', {
	      staticClass: "pull-right-container"
	    }, [_c('i', {
	      staticClass: "fa fa-angle-left pull-right"
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!nav.path) ? _c('a', {
	      attrs: {
	        "href": "javascript:void(0);"
	      }
	    }, [(!nav.isSvg) ? _c('i', {
	      class: ("" + (nav.icon))
	    }) : _vm._e(), _vm._v(" "), (nav.isSvg) ? _c('span', {
	      staticClass: "svg-icon",
	      domProps: {
	        "innerHTML": _vm._s(nav.icon)
	      }
	    }) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "products-name"
	    }, [_vm._v(_vm._s(nav.name))]), _vm._v(" "), (nav.modules.length) ? _c('span', {
	      staticClass: "pull-right-container"
	    }, [_c('i', {
	      staticClass: "fa fa-angle-left pull-right"
	    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (nav.modules.length) ? _c('ul', {
	      staticClass: "treeview-menu sidebar-menu",
	      staticStyle: {
	        "display": "block"
	      }
	    }, _vm._l((nav.modules), function(module, index) {
	      return _c('li', {
	        key: index,
	        staticClass: "treeview",
	        class: module.link === _vm.currentPath ? 'active' : ''
	      }, [_c('router-link', {
	        attrs: {
	          "to": ("" + (module.link))
	        }
	      }, [_c('div', {
	        staticClass: "vue-avatar--wrapper"
	      }, [_c('span', [_c('img', {
	        staticClass: "round",
	        attrs: {
	          "width": "20",
	          "height": "20",
	          "avatar": ("" + (module.name))
	        }
	      })])]), _vm._v("\n                            " + _vm._s(module.name) + "\n                        ")])], 1)
	    }), 0) : _vm._e()], 1)
	  }), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/admin/bidders/"
	    }
	  }, [_c('span', {
	    staticClass: "svg-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    staticStyle: {
	      "font-size": "17px"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v("Bidders")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  })])], 1)], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info"
	  }, [_c('p'), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "/admin/password/change"
	    }
	  }, [_c('i', {
	    staticClass: "ti-user"
	  }), _c('small', [_vm._v("Profile")])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "/logout"
	    }
	  }, [_c('i', {
	    staticClass: "ti-power-off"
	  }), _c('small', [_vm._v("Logout")])])])])
	}]}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("DFP Setup for " + _vm._s(_vm.networkName))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body"
	  }, [_c('el-button', {
	    attrs: {
	      "title": (_vm.hbAdvCreated) ? 'advertiser and placement already created' : 'create advertiser and placement',
	      "disabled": _vm.hbAdvCreated,
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createAdvAndPlacement()
	      }
	    }
	  }, [_vm._v("\n        Create advertiser, placement and mod key with values "), (_vm.creatingAdvertiser) ? _c('i', {
	    staticClass: "el-icon-loading"
	  }) : _vm._e()]), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Select Bidders")]), _vm._v(" "), _c('el-row', {
	    staticStyle: {
	      "display": "flex",
	      "flex-flow": "row wrap"
	    }
	  }, _vm._l((_vm.bidders), function(bidder) {
	    return _c('el-col', {
	      staticStyle: {
	        "margin": "10px"
	      },
	      attrs: {
	        "span": 4
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "text-align": "left",
	        "position": "relative"
	      }
	    }, [_c('el-button', {
	      key: bidder.id,
	      attrs: {
	        "label": bidder.id,
	        "title": (_vm.current_active_bidders.indexOf(bidder.id) > -1 || _vm.current_started_bidders.indexOf(bidder.id) > -1) ? 'DFP setup is already complete' : 'select bidder',
	        "disabled": !_vm.hbAdvCreated || (_vm.current_active_bidders.indexOf(bidder.id) > -1 || _vm.current_started_bidders.indexOf(bidder.id) > -1),
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.initiateSetup(bidder)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(bidder.name) + " "), (_vm.current_started_bidders.indexOf(bidder.id) > -1) ? _c('i', {
	      staticClass: "el-icon-loading"
	    }) : _vm._e()]), _vm._v(" "), _c('i', {
	      staticClass: "el-icon-refresh",
	      staticStyle: {
	        "position": "absolute",
	        "top": "50%",
	        "transform": "translateY(-50%)",
	        "margin-left": "5px",
	        "cursor": "pointer"
	      },
	      attrs: {
	        "title": "retry failed line item create associations"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.retryLicas(bidder)
	        }
	      }
	    })], 1)])
	  }), 1), _vm._v(" "), _c('h5', [_vm._v("Select Currency")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    on: {
	      "change": _vm.currencyChanged
	    },
	    model: {
	      value: (_vm.dfp.prebid_currency),
	      callback: function($$v) {
	        _vm.$set(_vm.dfp, "prebid_currency", $$v)
	      },
	      expression: "dfp.prebid_currency"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(option) {
	    return _c('el-option', {
	      key: option.id,
	      attrs: {
	        "label": option.code,
	        "value": option.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "disabled": !_vm.isComplete || _vm.hbSetupInitiated,
	      "title": _vm.hbSetupInitiated ? 'Header Bidding Setup is running' : ''
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onSubmit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n            Submit\n            ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/dfp-settings/"
	    }
	  }, [_vm._v("\n            Cancel\n            ")])], 1), _vm._v(" "), _c('hr')])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Select Param set for " + _vm._s(_vm.is_amp ? 'AMP' : 'DISPLAY') + " ad units")]), _vm._v(" "), _c('div', [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block",
	      "width": "80%",
	      "margin": "0 0 10px 10px"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "searchString",
	      "type": "text",
	      "placeholder": "search HB Unit by HB Unit tag (type and enter)"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHbAdUnit()
	      }
	    },
	    model: {
	      value: (_vm.searchString),
	      callback: function($$v) {
	        _vm.searchString = $$v
	      },
	      expression: "searchString"
	    }
	  }), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "content": "clearSearch",
	      "placement": "top"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearSearch()
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Dimensions",
	      "name": "Dimensions"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.filterDimension()
	      }
	    },
	    model: {
	      value: (_vm.selectedDimensions),
	      callback: function($$v) {
	        _vm.selectedDimensions = $$v
	      },
	      expression: "selectedDimensions"
	    }
	  }, _vm._l((_vm.allDimensionsSearch), function(dimension, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": ((dimension.width) + "X" + (dimension.height)),
	        "value": dimension.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "selectedNetworkCode",
	      "type": "text",
	      "placeholder": "Search Parent Network Code"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHbAdUnit()
	      }
	    },
	    model: {
	      value: (_vm.selectedNetworkCode),
	      callback: function($$v) {
	        _vm.selectedNetworkCode = $$v
	      },
	      expression: "selectedNetworkCode"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "selectedChildDfpNetworkCode",
	      "type": "text",
	      "placeholder": "Search Child Network Code"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHbAdUnit()
	      }
	    },
	    model: {
	      value: (_vm.selectedChildDfpNetworkCode),
	      callback: function($$v) {
	        _vm.selectedChildDfpNetworkCode = $$v
	      },
	      expression: "selectedChildDfpNetworkCode"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding-left": "10px",
	      "width": "100%",
	      "padding-top": "8px"
	    },
	    model: {
	      value: (_vm.searchNetworkOverride),
	      callback: function($$v) {
	        _vm.searchNetworkOverride = $$v
	      },
	      expression: "searchNetworkOverride"
	    }
	  }, [_vm._v("Search Network Override?")])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Meta Tags",
	      "visible": _vm.pubInsdialogVisible,
	      "width": "30%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.pubInsdialogVisible = $event
	      }
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 10
	    },
	    model: {
	      value: (_vm.pubInstructions),
	      callback: function($$v) {
	        _vm.pubInstructions = $$v
	      },
	      expression: "pubInstructions"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.pubInsdialogVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pubInsdialogVisible = false
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is_amp),
	      expression: "is_amp"
	    }, {
	      name: "clipboard",
	      rawName: "v-clipboard:copy",
	      value: (_vm.pubInstructions),
	      expression: "pubInstructions",
	      arg: "copy"
	    }],
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "type": "text"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pubInsdialogVisible = true
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-copy fa-w-14",
	    staticStyle: {
	      "font-size": "48px"
	    },
	    attrs: {
	      "aria-hidden": "true",
	      "width": "16px",
	      "height": "16px",
	      "data-prefix": "fal",
	      "data-icon": "copy",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 448 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
	    }
	  })]), _vm._v("  Copy Publisher Instructions\n                    ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": _vm.is_amp ?
	        ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag-amp/") :
	        ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag/")
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                            Create " + _vm._s(_vm.is_amp ? "AMP" : "display") + " HB tag\n                        ")]), _vm._v(" "), (_vm.domainMcmEnabled) ? _c('el-button', {
	    staticClass: "pull-right",
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": function($event) {
	        _vm.bulkmigrateEnabled = !_vm.bulkmigrateEnabled
	      }
	    }
	  }, [_vm._v("Bulk Migrate")]) : _vm._e()], 1), _vm._v(" "), (_vm.domainMcmEnabled && _vm.bulkmigrateEnabled) ? _c('div', {}, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v("Bulk Migration")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "80%",
	      "margin": "0px 0px 10px 10px"
	    }
	  }, [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.mcm_enabled),
	      callback: function($$v) {
	        _vm.mcm_enabled = $$v
	      },
	      expression: "mcm_enabled"
	    }
	  }, [_vm._v("Is sticky Unit?")])], 1), _vm._v(" "), (_vm.mcm_enabled && _vm.domainMcmEnabled) ? _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin": "0px 0px 8px -6px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select MCM Delegation Type"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.account_type),
	      callback: function($$v) {
	        _vm.account_type = $$v
	      },
	      expression: "account_type"
	    }
	  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "data-id": id,
	        "label": mcm_account_type.account_type.replaceAll('_', ' '),
	        "value": mcm_account_type.account_type
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "disabled": _vm.account_type == null,
	      "filterable": "",
	      "placeholder": "Select Child DFP Network"
	    },
	    model: {
	      value: (_vm.child_dfp_network),
	      callback: function($$v) {
	        _vm.child_dfp_network = $$v
	      },
	      expression: "child_dfp_network"
	    }
	  }, _vm._l((_vm.filteredAccountList), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.child_network_code + ' : ' + network.name)),
	        "value": network.child_network_code
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null && _vm.child_dfp_network == null,
	      "placeholder": "Add DFP Parent Adunit Id"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_id),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_id = $$v
	      },
	      expression: "dfp_parent_ad_unit_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Path")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null || _vm.child_dfp_network == null || _vm.dfp_parent_ad_unit_id == 0,
	      "placeholder": "Add DFP Parent Adunit Path"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_path),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_path = $$v
	      },
	      expression: "dfp_parent_ad_unit_path"
	    }
	  })], 1), _vm._v(" "), (_vm.account_type != null) ? _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "success",
	      "disabled": _vm.dfp_parent_ad_unit_path == null || _vm.dfp_parent_ad_unit_path == ''
	    },
	    on: {
	      "click": function($event) {
	        return _vm.finalList(true)
	      }
	    }
	  }, [_vm._v("\n                                    Migrate all\n                                ")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "success",
	      "disabled": _vm.dfp_parent_ad_unit_path == null || _vm.dfp_parent_ad_unit_path == ''
	    },
	    on: {
	      "click": function($event) {
	        return _vm.finalList(false)
	      }
	    }
	  }, [_vm._v("\n                                    Migrate selected\n                                ")])], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "padding-top": "30px"
	    }
	  }, [(_vm.hb_tags.length == 0) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('h5', [_vm._v("No " + _vm._s(_vm.is_amp ? 'AMP' : 'display') + " HB tags. Create a tag by clicking create HB tag")])]) : _vm._e(), _vm._v(" "), _c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    },
	    on: {
	      "change": _vm.handleChange
	    },
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, _vm._l((_vm.hb_tags), function(hb_tag) {
	    return _c('el-collapse-item', {
	      staticClass: "collapse--item",
	      class: {
	        recentlyClosed: _vm.recentlyClosed == hb_tag.id,
	          opened: _vm.activeNames == hb_tag.id,
	      },
	      attrs: {
	        "title": hb_tag.id + '',
	        "name": hb_tag.id
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_c('div', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "width": "36%",
	        "float": "left",
	        "position": "relative"
	      }
	    }, [(_vm.domainMcmEnabled && _vm.bulkmigrateEnabled) ? _c('el-checkbox-group', {
	      staticClass: "hb-tag--checkbox-container",
	      attrs: {
	        "disabled": hb_tag.publisher_dfp_unit
	      },
	      on: {
	        "change": _vm.handleCheckedHbTagsChange
	      },
	      model: {
	        value: (_vm.checkedHbTags),
	        callback: function($$v) {
	          _vm.checkedHbTags = $$v
	        },
	        expression: "checkedHbTags"
	      }
	    }, [_c('el-checkbox', {
	      key: hb_tag.id,
	      attrs: {
	        "label": hb_tag.id
	      }
	    }, [_c('label', {
	      staticStyle: {
	        "font-weight": "900",
	        "white-space": "nowrap",
	        "text-overflow": "ellipsis"
	      },
	      attrs: {
	        "title": _vm.getAdunitPath(hb_tag)
	      }
	    }, [_vm._v(_vm._s(_vm.getAdunitPath(hb_tag)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "else",
	        rawName: "v-else:title",
	        value: (_vm.getAdunitPath(hb_tag)),
	        expression: "getAdunitPath(hb_tag)",
	        arg: "title"
	      }],
	      staticStyle: {
	        "font-weight": "900",
	        "white-space": "nowrap",
	        "text-overflow": "ellipsis",
	        "overflow": "hidden"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\n                                                " + _vm._s(_vm.getAdunitPath(hb_tag)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\n                                            ")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "hbtag--dimension",
	      staticStyle: {
	        "width": "30%",
	        "float": "left",
	        "position": "relative"
	      }
	    }, [_c('h5', {
	      staticStyle: {
	        "/*padding": "20px 0px"
	      }
	    }, _vm._l((_vm.getDimension(hb_tag.dimensions)), function(dim) {
	      return _c('span', {
	        staticStyle: {
	          "width": "100%",
	          "position": "relative",
	          "background-color": "aquamarine",
	          "padding": "3px",
	          "border-radius": "10px",
	          "margin-right": "10px"
	        }
	      }, [_vm._v("\n                                                    " + _vm._s(dim) + "\n                                                    "), (
	        _vm.bidderParamsForm2.formData[hb_tag.id][dim]['param_set'] !=
	        undefined
	      ) ? _c('i', {
	        staticClass: "el-icon-success",
	        staticStyle: {
	          "/*position": "absolute",
	          "left": "0px",
	          "right": "0px",
	          "text-align": "center",
	          "top": "-12px"
	        }
	      }) : _vm._e()])
	    }), 0)]), _vm._v(" "), _c('div', {
	      class: _vm.is_amp ? 'hb-amp--container' : '',
	      staticStyle: {
	        "width": "30%",
	        "float": "left",
	        "position": "relative",
	        "display": "flex"
	      }
	    }, [(_vm.is_amp) ? _c('el-button', {
	      directives: [{
	        name: "clipboard",
	        rawName: "v-clipboard:copy",
	        value: (_vm.copyAmpTag(hb_tag)),
	        expression: "copyAmpTag(hb_tag)",
	        arg: "copy"
	      }, {
	        name: "clipboard",
	        rawName: "v-clipboard:success",
	        value: (_vm.ampTagCopied),
	        expression: "ampTagCopied",
	        arg: "success"
	      }],
	      staticClass: "el-button el-button--info pull-right",
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon"
	    }), _vm._v("\n                                                Copy AMP tag\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.is_amp) ? _c('el-button', {
	      directives: [{
	        name: "clipboard",
	        rawName: "v-clipboard:copy",
	        value: (_vm.copyTagId(hb_tag)),
	        expression: "copyTagId(hb_tag)",
	        arg: "copy"
	      }, {
	        name: "clipboard",
	        rawName: "v-clipboard:success",
	        value: (_vm.tagIdCopied),
	        expression: "tagIdCopied",
	        arg: "success"
	      }],
	      staticClass: "el-button el-button--info pull-right",
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon"
	    }), _vm._v("\n                                                Copy Tag ID\n                                            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      staticClass: "el-button el-button--info pull-right modify--btn",
	      attrs: {
	        "to": {
	          path: _vm.is_amp ?
	            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/modify-hb-tag-amp/" + (hb_tag.id) + "/?page=" + _vm.currentPage) :
	            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/modify-hb-tag/" + (hb_tag.id) + "/?page=" + _vm.currentPage),
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon"
	    }), _vm._v("\n                                                Modify Tag\n                                            ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "el-button el-button--info modify--btn",
	      attrs: {
	        "to": {
	          path: _vm.is_amp ?
	            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag-amp/?hb_id=" + (hb_tag.id) + "&page=" + _vm.currentPage) :
	            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag/?hb_id=" + (hb_tag.id) + "&page=" + _vm.currentPage),
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon"
	    }), _vm._v("\n                                                Duplicate Tag\n                                            ")])], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "100%",
	        "display": "inline-block"
	      }
	    }, [_c('el-dropdown', {
	      staticClass: "see-usage",
	      staticStyle: {
	        "display": "inline"
	      },
	      attrs: {
	        "trigger": "click"
	      },
	      on: {
	        "command": _vm.OpenHbAdUnitsUsage
	      }
	    }, [_c('span', {
	      staticClass: "el-dropdown-link"
	    }, [_vm._v("\n                                        See usage in bucket"), _c('i', {
	      staticClass: "el-icon-arrow-down el-icon--right"
	    })]), _vm._v(" "), _c('el-dropdown-menu', {
	      attrs: {
	        "slot": "dropdown"
	      },
	      slot: "dropdown"
	    }, _vm._l((_vm.domain_details.buckets), function(bucket) {
	      return _c('el-dropdown-item', {
	        key: bucket.id,
	        attrs: {
	          "command": {
	            name: _vm.bucket_name,
	            bucket_id: bucket.id,
	            hb_tag_id: hb_tag.id,
	          }
	        }
	      }, [_c('span', [_vm._v(_vm._s(bucket.name))])])
	    }), 1)], 1)], 1)])]), _vm._v(" "), _vm._l((hb_tag.dimensions), function(dim, index) {
	      return _c('div', {
	        staticStyle: {
	          "height": "50px",
	          "margin": "10px 0px"
	        }
	      }, [_c('el-row', {
	        attrs: {
	          "gutter": 20
	        }
	      }, [_c('el-col', {
	        attrs: {
	          "span": 8
	        }
	      }, [_c('div', {
	        staticClass: "grid-content"
	      }, [_c('h5', {
	        staticStyle: {
	          "margin": "0px",
	          "line-height": "50px",
	          "display": "inline-block"
	        }
	      }, [_vm._v("\n                                                    Select Param set for " + _vm._s(((dim.width) + "X" + (dim.height))) + "\n                                                ")])])]), _vm._v(" "), _c('el-col', {
	        staticStyle: {
	          "height": "50px"
	        },
	        attrs: {
	          "span": 8
	        }
	      }, [_c('div', {
	        staticClass: "grid-content",
	        staticStyle: {
	          "top": "50%",
	          "position": "relative",
	          "transform": "translateY(-50%)"
	        }
	      }, [_c('el-select', {
	        staticClass: "param-set-input select-input",
	        attrs: {
	          "filterable": "",
	          "placeholder": "Select param set"
	        },
	        on: {
	          "change": function($event) {
	            return _vm.updateHbTag(hb_tag, dim)
	          }
	        },
	        model: {
	          value: (
	            _vm.bidderParamsForm2.formData[hb_tag.id][
	              ((dim.width) + "X" + (dim.height))
	            ]['param_set']
	          ),
	          callback: function($$v) {
	            _vm.$set(_vm.bidderParamsForm2.formData[hb_tag.id][
	              ((dim.width) + "X" + (dim.height))
	            ], 'param_set', $$v)
	          },
	          expression: "\n                                                        bidderParamsForm2.formData[hb_tag.id][\n                                                            `${dim.width}X${dim.height}`\n                                                        ]['param_set']\n                                                    "
	        }
	      }, _vm._l((_vm.getParamSetsForDim(dim.id)), function(param_set) {
	        return _c('el-option', {
	          key: param_set.id,
	          attrs: {
	            "label": param_set.alias,
	            "value": param_set.id
	          }
	        })
	      }), 1)], 1)]), _vm._v(" "), _c('el-col', {
	        staticStyle: {
	          "height": "50px"
	        },
	        attrs: {
	          "span": 8
	        }
	      }, [_c('div', {
	        staticClass: "grid-content",
	        staticStyle: {
	          "top": "50%",
	          "position": "relative",
	          "transform": "translateY(-50%)"
	        }
	      }, [_c('div', {
	        staticStyle: {
	          "margin": "0px",
	          "display": "inline-block"
	        }
	      }, [_c('el-button', {
	        attrs: {
	          "disabled": _vm.bidderParamsForm2.formData[hb_tag.id][
	            ((dim.width) + "X" + (dim.height))
	          ]['param_set'] == undefined,
	          "type": "primary"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.updateHbTag(hb_tag, dim)
	          }
	        }
	      }, [_vm._v("\n                                                        Update Tag\n                                                    ")])], 1)])])], 1)], 1)
	    })], 2)
	  }), 1), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [10, 20, 50, 100],
	      "total": _vm.total_pages,
	      "layout": "sizes, prev, pager, next",
	      "page-size": _vm.offset
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [(_vm.impressionRevenueTableData.length > 0) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "grid-content"
	  }, [(_vm.impressionRevenueReportData.length > 0) ? _c('JsonCSV', {
	    staticClass: "btn btn-default atd-report-download",
	    staticStyle: {
	      "background-color": "#0da1f5",
	      "border": "none",
	      "-moz-box-shadow": "2px 2px 4px #000000",
	      "-webkit-box-shadow": "2px 2px 4px #000000",
	      "box-shadow": "2px 2px 4px #000000"
	    },
	    attrs: {
	      "advancedOptions": _vm.tsting(),
	      "data": _vm.csvData,
	      "name": _vm.reportName
	    }
	  }, [_c('i', {
	    staticClass: "iconsmind-Data-Download",
	    staticStyle: {
	      "color": "#fff",
	      "font-weight": "bold"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "atd-title-text"
	  }, [_vm._v("Download")])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": "12"
	    }
	  }, [_c('div', {
	    staticClass: "grid-content"
	  }, [_c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('span', {
	    staticClass: "align-middle d-inline-block",
	    staticStyle: {
	      "width": "150px"
	    }
	  }, [_c('date-picker', {
	    staticStyle: {
	      "min-width": "180px"
	    },
	    attrs: {
	      "lang": _vm.lang,
	      "shortcuts": _vm.shortcuts,
	      "mode": "range",
	      "range": "",
	      "not-after": _vm.endDate
	    },
	    on: {
	      "change": function($event) {
	        return _vm.getRevenueImpressionReports()
	      }
	    },
	    model: {
	      value: (_vm.selectedValueRange),
	      callback: function($$v) {
	        _vm.selectedValueRange = $$v
	      },
	      expression: "selectedValueRange"
	    }
	  })], 1)])])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "table-container",
	    class: (_vm.isLoading) ? 'table-container-loading' : 'table-container'
	  }, [_c('table', {
	    staticClass: "table table-sm"
	  }, [_c('thead', [_c('tr', [_c('th', [_c('el-row', {
	    staticClass: "text-center text-uppercase",
	    staticStyle: {
	      "width": "100px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('span', [_vm._v("Date")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, index) {
	    return _c('th', {
	      key: index
	    }, [_c('el-row', {
	      staticStyle: {
	        "width": "240px"
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-col', {
	      staticClass: "text-center text-uppercase",
	      attrs: {
	        "span": 24
	      }
	    }, [_c('span', [_vm._v(_vm._s(bidder))])]), _vm._v(" "), _c('el-col', {
	      staticClass: "atd-revenue-report",
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 9
	      }
	    }, [_c('span', [_vm._v("Impressions")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 9
	      }
	    }, [_c('span', [_vm._v("Revenue")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 6
	      }
	    }, [_c('span', [_vm._v("eCPM")])])], 1)], 1)], 1)], 1)
	  }), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "position": "sticky",
	      "top": "0"
	    }
	  }, [_c('el-row', {
	    staticStyle: {
	      "width": "220px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-col', {
	    staticClass: "text-center text-uppercase",
	    attrs: {
	      "span": 24
	    }
	  }, [_c('span', [_vm._v("Total")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('span', [_vm._v("Impressions")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('span', [_vm._v("Revenue")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('span', [_vm._v("eCPM")])])], 1)], 1)], 1)], 1)], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.impressionRevenueTableData), function(revenue, parentIndex) {
	    return _c('tr', {
	      key: parentIndex
	    }, [_c('td', [_c('span', {
	      staticClass: "font-weight-medium"
	    }, [_vm._v(_vm._s(_vm.dateFormater(revenue.date)))])]), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, childindex) {
	      return _c('td', {
	        key: childindex
	      }, [_c('el-row', {
	        staticStyle: {
	          "width": "240px"
	        }
	      }, [_c('el-col', {
	        attrs: {
	          "span": 24
	        }
	      }, [_c('el-col', {
	        attrs: {
	          "span": 10
	        }
	      }, [(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression')) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression'))))])]), _vm._v(" "), _c('el-col', {
	        attrs: {
	          "span": 8
	        }
	      }, [(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue') != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue')) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue'))))])]), _vm._v(" "), _c('el-col', {
	        attrs: {
	          "span": 4
	        }
	      }, [(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue') != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm') == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm')))])])], 1)], 1)], 1)
	    }), _vm._v(" "), _c('td', [_c('el-row', {
	      staticStyle: {
	        "width": "220px"
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 10
	      }
	    }, [(_vm.addCommas(revenue.impression) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(revenue.impression)))])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [(revenue.revenue != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.addCommas(revenue.revenue) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(revenue.revenue)))])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 4
	      }
	    }, [(revenue.ecpm != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (revenue.ecpm == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(revenue.ecpm))])])], 1)], 1)], 1)], 2)
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr'), _c('tr', [_c('th', [_c('el-row', {
	    staticStyle: {
	      "width": "100px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('span', [_vm._v("Total")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, childindex) {
	    return _c('td', {
	      key: childindex
	    }, [_c('el-row', {
	      staticStyle: {
	        "width": "240px"
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 10
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal(bidder, 'impression'))))])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('span', [_vm._v("$")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal(bidder, 'revenue'))))])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 4
	      }
	    }, [_c('span', [_vm._v("$")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getColumnCPM(bidder)))])])], 1)], 1)], 1)
	  }), _vm._v(" "), _c('td', [_c('el-row', {
	    staticStyle: {
	      "width": "220px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal('total', 'impression'))))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('span', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal('total', 'revenue'))) + "\n                                                                    ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('span', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.getColumnCPM('total')) + "\n                                                                    ")])])], 1)], 1)], 1)], 2)])])])])], 1)], 1) : _c('div', {
	    staticClass: "text-center d-flex justify-content-between"
	  }, [_c('div', {
	    staticClass: "loading"
	  })])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h1', [_vm._v("Revenue")]), _vm._v(" "), _c('span', {
	    attrs: {
	      "id": "downloadcon"
	    }
	  })])
	}]}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Shop Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Shop Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs nav-tabs-shop-devin",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    attrs: {
	      "data-wow-delay": "0.6s"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#featured",
	      "data-toggle": "tab",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("featured")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane fade active in",
	    attrs: {
	      "role": "tabpanel",
	      "id": "featured"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.publishers), function(option) {
	    return _c('div', {
	      staticClass: "col-md-3 col-sm-6"
	    }, [_c('div', {
	      staticClass: "product-item"
	    }, [_c('div', {
	      staticClass: "product-item-thumbnail text-center mb-15"
	    }, [_c('img', {
	      staticClass: "img-responsive",
	      attrs: {
	        "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	        "alt": "product image"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "product-item-thumbnail-overlay"
	    }, [_c('router-link', {
	      staticClass: "btn btn-default pulse",
	      attrs: {
	        "to": ("" + ('/publisher/edit/' + option.uuid))
	      }
	    }, [_c('span', {
	      staticClass: "ti-settings mr-0"
	    })])], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-6 publishers-all"
	    }, [_c('h5', {
	      staticClass: "publishers-name"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("" + ('/publisher-info/' + option.id + '/'))
	      }
	    }, [_vm._v(_vm._s(option.name))])], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-6 text-right"
	    })])])])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('main', {
	    staticClass: "wrapper-404"
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(1), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": ["Oops! Page not found", "We could not find the page you were looking for", "Meanwhile", "you may return to dashboard", "or try using the search form."],
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n                404 Error Page\n            ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("404 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("4")]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _c('span', [_vm._v("4")])])
	}]}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("HB Unit Bidder Config")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "background": "#5cb85c"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.updatedHBBidder
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "background": "#5cb85c"
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.updatedAllBidder
	    }
	  }, [_vm._v("Select all bidders")]), _vm._v(" "), _c('el-row', {
	    staticStyle: {
	      "padding": "20px 20px 0px"
	    }
	  }, _vm._l((_vm.allBidders), function(bidder, idx) {
	    return _c('el-col', {
	      key: idx,
	      attrs: {
	        "span": 5
	      }
	    }, [_c('el-checkbox', {
	      key: bidder.id,
	      ref: "bidderAllCheck",
	      refInFor: true,
	      attrs: {
	        "checked": bidder.all,
	        "value": bidder.all
	      },
	      on: {
	        "change": function($event) {
	          return _vm.selectAll(bidder)
	        }
	      }
	    }, [_vm._v("Check all " + _vm._s(bidder.name))]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin": "15px 0"
	      }
	    })], 1)
	  }), 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block",
	      "width": "80%",
	      "margin": "0 0 10px 10px"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "searchString",
	      "type": "text",
	      "placeholder": "search HB Unit by HB Unit tag (type and enter)"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHBunitBidder()
	      }
	    },
	    model: {
	      value: (_vm.searchString),
	      callback: function($$v) {
	        _vm.searchString = $$v
	      },
	      expression: "searchString"
	    }
	  }), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "content": "clearSearch",
	      "placement": "top"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearSearch()
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "selectedNetworkCode",
	      "type": "text",
	      "placeholder": "Search Parent Network Code"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHBunitBidder()
	      }
	    },
	    model: {
	      value: (_vm.selectedNetworkCode),
	      callback: function($$v) {
	        _vm.selectedNetworkCode = $$v
	      },
	      expression: "selectedNetworkCode"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "selectedChildDfpNetworkCode",
	      "type": "text",
	      "placeholder": "Search Child Network Code"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHBunitBidder()
	      }
	    },
	    model: {
	      value: (_vm.selectedChildDfpNetworkCode),
	      callback: function($$v) {
	        _vm.selectedChildDfpNetworkCode = $$v
	      },
	      expression: "selectedChildDfpNetworkCode"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "overflow": "auto"
	    }
	  }, [_c('el-checkbox', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "padding-left": "10px",
	      "width": "100%",
	      "padding-top": "8px"
	    },
	    model: {
	      value: (_vm.searchNetworkOverride),
	      callback: function($$v) {
	        _vm.searchNetworkOverride = $$v
	      },
	      expression: "searchNetworkOverride"
	    }
	  }, [_vm._v("Search Network Override?")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._l((_vm.hbBidderPartnerList), function(hbUnit) {
	    return (_vm.hbBidderPartnerList.length > 0) ? _c('div', {
	      staticClass: "col-lg-12 col-md-12 bidder-config-layout"
	    }, [_c('div', {
	      staticClass: "col-lg-4 col-md-4"
	    }, [_vm._v("\n                                " + _vm._s(hbUnit.name) + "\n                                "), _c('div', {
	      staticStyle: {
	        "font-size": "12px",
	        "font-weight": "600"
	      }
	    }, [_vm._v("\n                                    " + _vm._s(hbUnit["dfp-ad-unit-path"] ?
	      "" + hbUnit["dfp-ad-unit-path"] :
	      "") + "\n                                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-8 col-md-8"
	    }, _vm._l((hbUnit.bidders), function(bidders) {
	      return _c('h3', {
	        staticClass: "col-lg-4 col-md-4 box-title"
	      }, [_c('el-checkbox', {
	        model: {
	          value: (bidders.isChecked),
	          callback: function($$v) {
	            _vm.$set(bidders, "isChecked", $$v)
	          },
	          expression: "bidders.isChecked"
	        }
	      }, [_vm._v("\n                                        " + _vm._s(bidders.bidder.name) + ". (" + _vm._s(bidders.dimension) + ")\n                                    ")])], 1)
	    }), 0)]) : _vm._e()
	  }), _vm._v(" "), (_vm.hbBidderPartnerList.length < 1) ? _c('div', {
	    staticClass: "col-lg-12 col-md-12"
	  }, [_c('h3', {
	    staticClass: "box-title text-center"
	  }, [_vm._v("\n                                No Header Bidding Ad unit present.\n                            ")])]) : _vm._e()], 2)]), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "page-size": _vm.offset,
	      "pager-count": 20,
	      "layout": "prev, pager, next",
	      "total": _vm.total_pages,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("DFP Settings")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--info pull-right",
	    on: {
	      "click": function($event) {
	        return _vm.getNetworks()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-reload",
	    staticStyle: {
	      "font-size": "14px"
	    }
	  }), _vm._v(" Refresh Networks\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.networks
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.display_name))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    staticClass: "col-md-4",
	    attrs: {
	      "label": "",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": ("/admin/edit-dfp/" + (props.row.id))
	          }
	        }, [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(((props.row.display_name) + " (" + (props.row.network_code) + ")")))])]), _vm._v(" "), _c('div', {
	          staticClass: "publisher-name"
	        }, [_vm._v("Publisher: " + _vm._s(("" + ((props.row.publisher) ? (props.row.publisher.name) : 'Automatad'))))])]
	      }
	    }])
	  }, [_vm._v(" "), _c('div', [_c('el-tag', {
	    attrs: {
	      "size": "mini"
	    }
	  }, [_vm._v("Mini")])], 1)]), _vm._v(" "), _c('el-table-column', {
	    staticClass: "col-md-4",
	    attrs: {
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.hb_setup_done === true) ? _c('el-button', {
	          staticClass: "active-button",
	          attrs: {
	            "type": "success",
	            "icon": "el-icon-circle-check"
	          }
	        }, [_vm._v("Active")]) : (props.row.hb_setup_initiated === true) ? _c('el-button', {
	          staticClass: "active-button",
	          attrs: {
	            "type": "warning",
	            "icon": "el-icon-loading"
	          }
	        }, [_vm._v("DFP task Initiated")]) : _c('el-button', {
	          staticClass: "active-button",
	          attrs: {
	            "type": "danger",
	            "icon": "el-icon-error"
	          }
	        }, [_vm._v("Not active")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    staticClass: "col-md-4",
	    attrs: {
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "data-toggle": "tooltip",
	            "data-placement": "top",
	            "title": "Refresh Child Networks",
	            "type": "text",
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.refreshNetworkList(props.row.network_code)
	            }
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-sync fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "width": "16px",
	            "height": "16px",
	            "data-prefix": "far",
	            "data-icon": "sync",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
	          }
	        })])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    staticClass: "col-md-2",
	    attrs: {
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "data-toggle": "tooltip",
	            "data-placement": "top",
	            "title": "Sync AdUnits",
	            "type": "text",
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.syncAdUnits(("" + (props.row.dfp.id)), ("" + (props.row.id)))
	            }
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-sync fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "width": "16px",
	            "height": "16px",
	            "data-prefix": "far",
	            "data-icon": "sync",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
	          }
	        })])])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    staticClass: "col-md-4",
	    attrs: {
	      "align": "center",
	      "label": "",
	      "prop": "settings"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          staticClass: "pull-right",
	          attrs: {
	            "to": ("/admin/edit-dfp/" + (props.row.id))
	          }
	        }, [_c('el-button', {
	          attrs: {
	            "plain": "",
	            "icon": "el-icon-setting"
	          }
	        }, [_vm._v("Prebid Settings")])], 1)]
	      }
	    }])
	  })], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart clearfix"
	  }, [_c('div', {
	    staticClass: "clearfix pull-left col-md-12"
	  }, [_c('div', {
	    staticStyle: {
	      "margin-bottom": "30px"
	    }
	  }, [_c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "font-size": "20px",
	      "margin-left": "-17px"
	    }
	  }, [_vm._v("Adspots Layouts Association")]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right clearfix import",
	    staticStyle: {
	      "padding": "5px",
	      "padding-top": "0px",
	      "padding-right": "15px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9 text-right"
	  }, [_c('el-dropdown', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.importedData),
	      expression: "!importedData"
	    }],
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.selectedBucket
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v("\n                                        Import Config\n                                        "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.importBuckets), function(bucket, index) {
	    return _c('el-dropdown-item', {
	      key: 'bucketindex' + index,
	      attrs: {
	        "command": index
	      }
	    }, [_vm._v(_vm._s(bucket.bucketName))])
	  }), 1)], 1), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.importedData),
	      expression: "importedData"
	    }],
	    staticClass: "el-button el-button--danger",
	    on: {
	      "click": function($event) {
	        return _vm.removeImport()
	      }
	    }
	  }, [_vm._v("\n                                    Remove\n                                ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 no-padding"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "disabled": !_vm.importedData
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveImportedData()
	      }
	    }
	  }, [_vm._v("\n                                    Save\n                                ")])])])]), _vm._v(" "), (_vm.formLoadingDone) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "5px"
	    }
	  }, [_vm._v("Ad Spots:")]), _vm._v(" "), _c('el-select', {
	    key: _vm.randomNumber,
	    staticClass: "col",
	    staticStyle: {
	      "display": "inline-block",
	      "max-width": "215px"
	    },
	    attrs: {
	      "placeholder": "Search and select ad spot",
	      "loading": _vm.dropdownLoading.adSpot,
	      "multiple": "",
	      "clearable": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.filterData.adSpotId),
	      callback: function($$v) {
	        _vm.$set(_vm.filterData, "adSpotId", $$v)
	      },
	      expression: "filterData.adSpotId"
	    }
	  }, _vm._l((_vm.allIndividualAdspots), function(adspot, index) {
	    return _c('el-option', {
	      key: 'alias name' + index,
	      attrs: {
	        "label": adspot.alias_name,
	        "value": adspot.id
	      }
	    }, [_vm._v("\n                                    " + _vm._s(adspot.alias_name) + "\n                                ")])
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("Unique Id:")]), _vm._v(" "), _c('el-select', {
	    staticClass: "col",
	    staticStyle: {
	      "display": "inline-block",
	      "max-width": "215px"
	    },
	    attrs: {
	      "loading": _vm.dropdownLoading.adSpot,
	      "value": _vm.fakeAdSpotId,
	      "placeholder": "Search and select unique id",
	      "multiple": "",
	      "clearable": "",
	      "filterable": ""
	    },
	    on: {
	      "input": _vm.setUniqueOrAdFormat
	    }
	  }, _vm._l((_vm.getUniqueOrAdFormat()), function(adspot, index) {
	    return _c('el-option', {
	      key: 'unique id keys' + index,
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "label": adspot.is_existing ? adspot.unique_id : _vm.getAdTypeName(adspot.fi_ad_type),
	        "value": adspot.id
	      }
	    }, [_vm._v("\n                                    " + _vm._s(adspot.is_existing ? adspot.unique_id : _vm.getAdTypeName(adspot.fi_ad_type)) + "\n                                ")])
	  }), 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("Layout:")]), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "display": "inline-block",
	      "width": "215px"
	    },
	    attrs: {
	      "loading": _vm.dropdownLoading.adLayout,
	      "placeholder": "Search and select layout",
	      "multiple": "",
	      "clearable": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.filterData.adLayout),
	      callback: function($$v) {
	        _vm.$set(_vm.filterData, "adLayout", $$v)
	      },
	      expression: "filterData.adLayout"
	    }
	  }, _vm._l((_vm.allIndividualLayouts), function(layout, index) {
	    return _c('el-option', {
	      key: 'layout keys' + index,
	      attrs: {
	        "label": layout.layout_name,
	        "value": layout.id
	      }
	    }, [_vm._v("\n                                    " + _vm._s(layout.layout_name) + "\n                                ")])
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between",
	      "padding-top": "10px",
	      "padding-right": "7px",
	      "margin-left": "5px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "flex": "auto"
	    }
	  }, [_c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "-16px"
	    }
	  }, [_vm._v("Tag Name:")]), _vm._v(" "), _c('el-select', {
	    staticClass: "col",
	    staticStyle: {
	      "display": "inline-block",
	      "max-width": "208px",
	      "margin-top": "10px"
	    },
	    attrs: {
	      "loading": _vm.dropdownLoading.adHbAdUnit,
	      "placeholder": "Search and select tag name",
	      "multiple": "",
	      "clearable": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.filterData.adHbAdUnit),
	      callback: function($$v) {
	        _vm.$set(_vm.filterData, "adHbAdUnit", $$v)
	      },
	      expression: "filterData.adHbAdUnit"
	    }
	  }, _vm._l((_vm.allIndividualHBAdUnits), function(hb_id, index) {
	    return _c('el-option', {
	      key: 'tagnamekeys' + index,
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "label": hb_id.name,
	        "value": hb_id.id
	      }
	    }, [_vm._v("\n                                        " + _vm._s(hb_id.name) + "\n                                    ")])
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("Dimension:")]), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "display": "inline-block",
	      "max-width": "300px"
	    },
	    attrs: {
	      "placeholder": "Select dimensions",
	      "multiple": "",
	      "clearable": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.filterData.adDimensions),
	      callback: function($$v) {
	        _vm.$set(_vm.filterData, "adDimensions", $$v)
	      },
	      expression: "filterData.adDimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension, index) {
	    return _c('el-option', {
	      key: 'abc' + index,
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "label": ((dimension.width) + "x" + (dimension.height)),
	        "value": dimension.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "m-l-20 form-label",
	    staticStyle: {
	      "margin-left": "43px"
	    }
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-radio-group', {
	    staticStyle: {
	      "display": "inline-block",
	      "max-width": "300px",
	      "height": "40px"
	    },
	    attrs: {
	      "size": "medium"
	    },
	    model: {
	      value: (_vm.filterData.adIsLive),
	      callback: function($$v) {
	        _vm.$set(_vm.filterData, "adIsLive", $$v)
	      },
	      expression: "filterData.adIsLive"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": null
	    }
	  }, [_vm._v("All")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": true
	    }
	  }, [_vm._v("Live")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": false
	    }
	  }, [_vm._v("Demo")])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "pull-right m-t-10",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "size": "medium",
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearFilter()
	      }
	    }
	  }, [_vm._v("\n                                    Clear Filters\n                                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.importedData) ? _c('span', {
	    staticClass: "text-danger animated flash config-notif"
	  }, [_vm._v("\n                        Imported config from\n                        " + _vm._s(_vm.selectedBucketData.bucketName) + " Bucket. Click save to use the config.\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "height": "400",
	      "data": _vm.associatedAdSpots,
	      "id": "assoc-table"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Alias Name",
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_vm._v("\n                            " + _vm._s(props.row.layout.ad_spot.alias_name) + "\n                            "), (!props.row.layout.ad_spot.is_existing) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type)) + "\n                                ad format)\n                            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
	          attrs: {
	            "to": {
	              path: ("/admin/publisher/" + _vm.uuid + "/domain/" + _vm.domId + "/ad-spot-setup/"),
	              query: {
	                spot_id: props.row.layout.ad_spot.id,
	              },
	            }
	          }
	        }, [_vm._v("\n                                View ad spot\n                            ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unique Id / Ad Format"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', [_vm._v(_vm._s(_vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type) != '-' ?
	          _vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type) :
	          props.row.layout.ad_spot.unique_id))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Layout",
	      "prop": "layout.layout.layout_name",
	      "width": "100"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "HB?",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.is_hb) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_hb) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Tag Name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_vm._v("\n                            " + _vm._s(props.row.is_hb ?
	          _vm.getAdunitPath(props.row.hb_id) :
	          props.row.dfp_id.dfp_network.network_code +
	          '/' +
	          props.row.dfp_id.ad_unit_name) + "\n                        ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Edit",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--success edit",
	          on: {
	            "click": function($event) {
	              return _vm.editAdSpotTagAssoc(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-pencil"
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Delete",
	      "width": "70"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--danger edit",
	          on: {
	            "click": function($event) {
	              return _vm.deleteAdSpotTagAssoc(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-close"
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Dimension/s",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "col-md-10"
	        }, _vm._l((props.row.dimensions), function(dimension) {
	          return _c('p', {
	            key: 'agedlsf' + dimension.id,
	            staticStyle: {
	              "margin": "0px",
	              "font-size": "13px"
	            }
	          }, [_vm._v("\n                                    " + _vm._s(dimension.width) + " X\n                                    " + _vm._s(dimension.height) + "\n                                ")])
	        }), 0)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status",
	      "width": "60"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "col-md-10"
	        }, [(props.row.is_live) ? _c('el-tooltip', {
	          attrs: {
	            "content": "live",
	            "placement": "top"
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-success",
	          staticStyle: {
	            "color": "green"
	          }
	        })]) : _c('el-tooltip', {
	          attrs: {
	            "content": "demo",
	            "placement": "top"
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-error",
	          staticStyle: {
	            "color": "red"
	          }
	        })])], 1)]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [20, 50, 100],
	      "total": _vm.totalPages,
	      "layout": "sizes, prev, pager, next",
	      "page-size": _vm.offset
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  }), _vm._v(" "), (_vm.formLoadingDone) ? _c('form', {
	    ref: "create-edit-block",
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.layoutTagAssociation.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Choose Adspot on Layout")]), _vm._v(" "), _c('el-select', {
	    key: _vm.randomNumber,
	    attrs: {
	      "placeholder": "Search and select a layout adspot",
	      "filterable": "",
	      "multiple": "",
	      "clearable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.checkDisabled()
	      }
	    },
	    model: {
	      value: (_vm.formData.layout),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "layout", $$v)
	      },
	      expression: "formData.layout"
	    }
	  }, _vm._l((_vm.allAdSpotsWithLayouts), function(adspot) {
	    return _c('el-option', {
	      key: adspot.id +
	        '-' +
	        adspot.ad_spot.unique_id +
	        ' - ' +
	        adspot.layout.layout_name,
	      attrs: {
	        "label": _vm.getLabel(adspot),
	        "value": adspot.id,
	        "disabled": adspot.alreadyAssociated || adspot.alreadyAssigned
	      }
	    }, [_vm._v("\n                                    " + _vm._s(_vm.getLabel(adspot)) + "\n\n                                    "), (adspot.alreadyAssociated) ? _c('span', {
	      staticStyle: {
	        "color": "red",
	        "font-style": "italic",
	        "margin-left": "5px"
	      }
	    }, [_vm._v("USED")]) : _vm._e()])
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1"
	  }, [_c('h5', [_vm._v("HB?")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-5"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.formData.hbEnabled),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "hbEnabled", $$v)
	      },
	      expression: "formData.hbEnabled"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.formData.hbEnabled),
	      expression: "!formData.hbEnabled"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Select DFP Adunit")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Search and select a dfp adunit",
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.getDfpAdunits,
	      "loading": _vm.loading
	    },
	    on: {
	      "change": _vm.adUnitChange
	    },
	    model: {
	      value: (_vm.formData.dfpAdUnit),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "dfpAdUnit", $$v)
	      },
	      expression: "formData.dfpAdUnit"
	    }
	  }, _vm._l((_vm.dfpAdUnits), function(adunit) {
	    return _c('el-option', {
	      key: adunit.ad_unit_id,
	      attrs: {
	        "label": _vm.domain_details.dfp_network.network_code + '/' + adunit.ad_unit_name,
	        "value": adunit.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.formData.hbEnabled),
	      expression: "formData.hbEnabled"
	    }],
	    staticClass: "col-md-4"
	  }, [_c('h5', [_vm._v("Select Hb Adunit")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Search and select a HB adunit",
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.getHbAdunits,
	      "loading": _vm.loading
	    },
	    on: {
	      "change": _vm.adUnitChange
	    },
	    model: {
	      value: (_vm.formData.hbAdUnit),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "hbAdUnit", $$v)
	      },
	      expression: "formData.hbAdUnit"
	    }
	  }, _vm._l((_vm.hbAdUnits), function(adunit) {
	    return _c('el-option', {
	      key: adunit.id,
	      attrs: {
	        "label": _vm.getAdunitPath(adunit),
	        "value": adunit.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.searchingAdUnit),
	      expression: "searchingAdUnit"
	    }],
	    staticClass: "el-icon-loading",
	    staticStyle: {
	      "position": "absolute",
	      "top": "50px",
	      "right": "20px"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('h5', [_vm._v("Live?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.formData.is_live),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "is_live", $$v)
	      },
	      expression: "formData.is_live"
	    }
	  })], 1), _vm._v(" "), (_vm.formData.hbAdUnit || _vm.formData.dfpAdUnit) ? _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('h5', [_vm._v("Choose Dimensions")]), _vm._v(" "), _c('el-checkbox-group', {
	    model: {
	      value: (_vm.formData.checkedDimensions),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "checkedDimensions", $$v)
	      },
	      expression: "formData.checkedDimensions"
	    }
	  }, _vm._l((_vm.formData.availableDimensions), function(dimension) {
	    return _c('el-checkbox', {
	      key: dimension.id,
	      staticClass: "col-md-2",
	      attrs: {
	        "label": dimension.id,
	        "disabled": _vm.isDisabled(dimension.id),
	        "title": _vm.isDisabled(dimension.id) ? 'At least one dimension to be associated' : ''
	      }
	    }, [_vm._v("\n                                    " + _vm._s(dimension.width) + " X\n                                    " + _vm._s(dimension.height) + "\n                                ")])
	  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('button', {
	    staticClass: "el-button btn-rounded el-button--success",
	    attrs: {
	      "disabled": !_vm.formData.layout ||
	        (_vm.formData.hbEnabled && !_vm.formData.hbAdUnit) ||
	        (!_vm.formData.hbEnabled && !_vm.formData.dfpAdUnit) ||
	        _vm.formData.checkedDimensions.length == 0
	    }
	  }, [_c('i', {
	    staticClass: "ti-save"
	  }), _vm._v("\n                                " + _vm._s(!_vm.formData.id ? 'Save' : 'Update') + "\n                            ")])])])]) : _vm._e()], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("New Layouts")]), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Meta Tags",
	      "visible": _vm.dialogVisible,
	      "width": "30%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 10
	    },
	    model: {
	      value: (_vm.metaCopy),
	      callback: function($$v) {
	        _vm.metaCopy = $$v
	      },
	      expression: "metaCopy"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = false
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-button', {
	    directives: [{
	      name: "clipboard",
	      rawName: "v-clipboard:copy",
	      value: (_vm.metaCopy),
	      expression: "metaCopy",
	      arg: "copy"
	    }],
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "type": "text"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = true
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-copy fa-w-14",
	    staticStyle: {
	      "font-size": "48px"
	    },
	    attrs: {
	      "aria-hidden": "true",
	      "width": "16px",
	      "height": "16px",
	      "data-prefix": "fal",
	      "data-icon": "copy",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 448 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
	    }
	  })]), _vm._v("  Copy Meta\n                ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.existingLayouts,
	      "height": "300",
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Layout name",
	      "width": "420",
	      "prop": "layout_name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', [_vm._v(_vm._s(props.row.layout_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dropdown', {
	          staticClass: "see-usage",
	          attrs: {
	            "trigger": "click"
	          },
	          on: {
	            "command": _vm.OpenLayoutUsage
	          }
	        }, [_c('span', {
	          staticClass: "el-dropdown-link"
	        }, [_vm._v("\n                                    See usage in bucket"), _c('i', {
	          staticClass: "el-icon-arrow-down el-icon--right"
	        })]), _vm._v(" "), _c('el-dropdown-menu', {
	          attrs: {
	            "slot": "dropdown"
	          },
	          slot: "dropdown"
	        }, _vm._l((_vm.domain_details.buckets), function(bucket) {
	          return _c('el-dropdown-item', {
	            key: bucket.id,
	            attrs: {
	              "command": {
	                alias: props.row.layout_name,
	                bucket_id: bucket.id,
	                id: props.row.id,
	              }
	            }
	          }, [_c('span', [_vm._v(_vm._s(bucket.name))])])
	        }), 1)], 1), _vm._v(" "), _c('br')]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Layout type",
	      "width": "200",
	      "prop": "type"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('p', [_vm._v(_vm._s(props.row.type))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Active"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.is_active) ? _c('div', [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_active) ? _c('div', [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Edit",
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--success edit",
	          on: {
	            "click": function($event) {
	              return _vm.editLayout(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-pencil"
	        })])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.saveLayout.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('h5', [_vm._v("Layout name")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "selector",
	      "type": "text",
	      "placeholder": "layout name"
	    },
	    model: {
	      value: (_vm.layoutForm.layoutName),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm, "layoutName", $$v)
	      },
	      expression: "layoutForm.layoutName"
	    }
	  })], 1)]), _vm._v(" "), (_vm.domain_details.features && (_vm.domain_details.features['advance_layouts'] == 'enabled')) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 select-items"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Layout Type")]), _vm._v(" "), _c('el-radio-group', {
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "change": _vm.changeLayout
	    },
	    model: {
	      value: (_vm.layoutForm.layoutType),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm, "layoutType", $$v)
	      },
	      expression: "layoutForm.layoutType"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "default",
	      "value": "default"
	    }
	  }, [_vm._v("Default")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "url",
	      "value": "url"
	    }
	  }, [_vm._v("URL")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "dom",
	      "value": "dom"
	    }
	  }, [_vm._v("DOM")])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row fields-section"
	  }, [(_vm.layoutForm.layoutType === 'dom') ? _c('div', {
	    staticClass: "dom-section col-md-8"
	  }, [_c('div', [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("DOM Selector String")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "selector",
	      "type": "text",
	      "placeholder": "DOM Selector String",
	      "required": ""
	    },
	    model: {
	      value: (_vm.layoutForm.selectorData.domSelectorString),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm.selectorData, "domSelectorString", $$v)
	      },
	      expression: "layoutForm.selectorData.domSelectorString"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("DOM Node Attribute")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "selector",
	      "type": "text",
	      "placeholder": "DOM Node Attribute",
	      "required": ""
	    },
	    model: {
	      value: (_vm.layoutForm.selectorData.domNodeAttribute),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm.selectorData, "domNodeAttribute", $$v)
	      },
	      expression: "layoutForm.selectorData.domNodeAttribute"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.layoutForm.layoutType !== 'default') ? _c('div', {
	    staticClass: "target-section col-md-8"
	  }, [_c('div', [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Operator")]), _vm._v(" "), _c('el-select', {
	    staticClass: "publisher-input select-input",
	    attrs: {
	      "collapse-tags": "",
	      "filterable": "",
	      "placeholder": "Select",
	      "required": ""
	    },
	    model: {
	      value: (_vm.layoutForm.selectorData.operator),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm.selectorData, "operator", $$v)
	      },
	      expression: "layoutForm.selectorData.operator"
	    }
	  }, _vm._l((['equals', 'contains']), function(option, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": option,
	        "value": option
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Value")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "selector",
	      "type": "text",
	      "placeholder": "Match String",
	      "required": ""
	    },
	    model: {
	      value: (_vm.layoutForm.selectorData.data),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm.selectorData, "data", $$v)
	      },
	      expression: "layoutForm.selectorData.data"
	    }
	  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h5', [_vm._v("Active")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-5"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.layoutForm.isActive),
	      callback: function($$v) {
	        _vm.$set(_vm.layoutForm, "isActive", $$v)
	      },
	      expression: "layoutForm.isActive"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 save-section"
	  }, [_c('button', {
	    staticClass: "el-button el-button--secondary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resetForm()
	      }
	    }
	  }, [_vm._v("\n                                Reset\n                            ")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [10, 20, 50, 100],
	      "total": _vm.total_Pages,
	      "layout": "sizes, prev, pager, next",
	      "page-size": _vm.offset
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-sm-offset-4"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('p', [_vm._v("Enter the old password")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "Old Password"
	    },
	    model: {
	      value: (_vm.credentials.oldPassword),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "oldPassword", $$v)
	      },
	      expression: "credentials.oldPassword"
	    }
	  })], 1), _vm._v(" "), _c('p', [_vm._v("Enter the password")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "New Password"
	    },
	    model: {
	      value: (_vm.credentials.newPassword1),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "newPassword1", $$v)
	      },
	      expression: "credentials.newPassword1"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "New Password"
	    },
	    model: {
	      value: (_vm.credentials.newPassword2),
	      callback: function($$v) {
	        _vm.$set(_vm.credentials, "newPassword2", $$v)
	      },
	      expression: "credentials.newPassword2"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('span', [_c('button', {
	    staticClass: "btn btn-success",
	    on: {
	      "click": function($event) {
	        return _vm.passwordChange()
	      }
	    }
	  }, [_vm._v("Submit")])]), _vm._v(" "), _c('span', [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.clear()
	      }
	    }
	  }, [_vm._v("Clear")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Change Password")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  })])
	}]}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": ("" + ('/admin/publisher/'+ this.$route.params.uuid +'/domain/'+ this.$route.params.domId + '/buckets/' + this.$route.params.bucketId + '/dc/add'))
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n\t\t\t\t\t\tCreate a Direct Campaign\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.directCampaigns
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('p', [_vm._v("Campaign Name: " + _vm._s(props.row.advertiser.advertiser_name))]), _vm._v(" "), _c('p', [_vm._v("Cost Type: " + _vm._s(props.row.line_item.cost_type))]), _vm._v(" "), _c('p', [_vm._v("Line Item Type: " + _vm._s(props.row.line_item.line_item_type))]), _vm._v(" "), _c('p', [_vm._v("Primary Goal Unit Type: " + _vm._s(props.row.line_item.primary_goal_unit_type))]), _vm._v(" "), _c('span', [_vm._v("Creatives: ")]), _c('p', {
	          domProps: {
	            "innerHTML": _vm._s(props.row.creatives.creative)
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.advertiser.advertiser_name))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": "",
	      "prop": "advertiser.advertiser_name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('p', [_vm._v(" " + _vm._s(new Date(props.row.line_item.start_date).toLocaleString()))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('p', [_vm._v(" " + _vm._s(new Date(props.row.line_item.end_date).toLocaleString()))])]
	      }
	    }])
	  })], 1)], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("All Direct Campaigns")])])
	}]}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('body', [_c('h1', [_vm._v("Demo for downloading/display PDF base64 string in IE, Chrome, Safari")])])
	}]}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ad Spots")]), _vm._v(" "), _c('div', [_c('el-input', {
	    staticStyle: {
	      "display": "inline-block",
	      "width": "80%",
	      "margin": "0 0 10px 10px"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "searchFI",
	      "type": "text",
	      "placeholder": "search adspot by alias name (type and enter)"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterFirstImpressionTagAssociations(_vm.searchFI)
	      }
	    },
	    model: {
	      value: (_vm.searchFI),
	      callback: function($$v) {
	        _vm.searchFI = $$v
	      },
	      expression: "searchFI"
	    }
	  }), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "content": "clearSearch",
	      "placement": "top"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearSearch()
	      }
	    }
	  })], 1)], 1), _vm._v(" "), (
	    _vm.domain_details.buckets && _vm.domain_details.buckets[0] ?
	    _vm.domain_details.buckets[0].features.indexOf('SELECTORS_AS_EXISTING') > -1 :
	    false
	  ) ? _c('span', {
	    staticStyle: {
	      "color": "red",
	      "font-style": "italic",
	      "background": "yellow",
	      "padding": "6px",
	      "margin": "5px",
	      "border-radius": "3px",
	      "float": "right"
	    }
	  }, [_vm._v("Note: For existing ad spot, selectors to be given (eg: div-gpt-30934894-1 -->\n                    #div-gpt-30934894-1)")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.existingAdSpots,
	      "height": "355",
	      "stripe": "",
	      "id": "assoc-table"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Alias Name",
	      "width": "230",
	      "prop": "alias_name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', [_vm._v(_vm._s(props.row.alias_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dropdown', {
	          staticClass: "see-usage",
	          attrs: {
	            "trigger": "click"
	          },
	          on: {
	            "command": _vm.OpenAdSpotUsage
	          }
	        }, [_c('span', {
	          staticClass: "el-dropdown-link"
	        }, [_vm._v("\n                                    See usage in bucket"), _c('i', {
	          staticClass: "el-icon-arrow-down el-icon--right"
	        })]), _vm._v(" "), _c('el-dropdown-menu', {
	          attrs: {
	            "slot": "dropdown"
	          },
	          slot: "dropdown"
	        }, _vm._l((_vm.domain_details.buckets), function(bucket) {
	          return _c('el-dropdown-item', {
	            key: bucket.id,
	            attrs: {
	              "command": {
	                alias: props.row.alias_name,
	                bucket_id: bucket.id,
	                id: props.row.id,
	              }
	            }
	          }, [(_vm.isUsed(props.row.id, bucket.id)) ? _c('i', {
	            staticClass: "el-icon-success",
	            staticStyle: {
	              "position": "absolute",
	              "left": "4px",
	              "top": "12px"
	            }
	          }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(bucket.name) + " ")]), _vm._v(" "), (_vm.isUsed(props.row.id, bucket.id)) ? _c('span', {
	            staticStyle: {
	              "position": "absolute",
	              "top": "50%",
	              "transform": "translateY(-50%)",
	              "right": "-1px"
	            }
	          }, [_c('el-tooltip', {
	            attrs: {
	              "content": "Delete all assocations on the bucket",
	              "placement": "bottom"
	            }
	          }, [_c('button', {
	            staticClass: "el-button el-button--danger el-button-small",
	            attrs: {
	              "type": "button"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.deleteallTagsonBucket($event, bucket.id, props.row.id)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "ti-trash",
	            staticStyle: {
	              "font-size": "12px",
	              "padding": "3px"
	            }
	          })])]), _vm._v(" "), _c('el-tooltip', {
	            attrs: {
	              "content": "Push script for bucket",
	              "placement": "bottom"
	            }
	          }, [_c('a', {
	            staticClass: "upload",
	            attrs: {
	              "href": "javascript:void(0);"
	            },
	            on: {
	              "click": function($event) {
	                $event.stopPropagation();
	                return _vm.createJs(bucket.id)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "el-icon-upload el-icon--right"
	          })])])], 1) : _vm._e()])
	        }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.checkifMoreCssPresent(props.row.ad_unit_data)) ? _c('span', {
	          staticClass: "more-css"
	        }, [_vm._v("\n                                MORE CSS\n                            ")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Existing",
	      "width": "90"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.is_existing) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
	          attrs: {
	            "data-v-7a40f996": "",
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "far",
	            "data-icon": "check-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "data-v-7a40f996": "",
	            "fill": "green",
	            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
	          }
	        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_existing) ? _c('div', {
	          staticClass: "text-center"
	        }, [_c('svg', {
	          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
	          attrs: {
	            "aria-hidden": "true",
	            "height": "20px",
	            "width": "20px",
	            "data-prefix": "fal",
	            "data-icon": "times-circle",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 512 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "red",
	            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
	          }
	        })])]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Unique Id / Ad Format"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', [_vm._v(_vm._s(_vm.getAdTypeName(props.row.fi_ad_type) != '-' ?
	          _vm.getAdTypeName(props.row.fi_ad_type) :
	          props.row.unique_id))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Layout"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_vm._l((props.row.associations), function(lay, index) {
	          return (props.row.associations.length != 0) ? _c('span', {
	            key: lay.id,
	            staticClass: "text-capitalize"
	          }, [_vm._v("\n                                " + _vm._s(lay.layout.layout_name + (index < props.row.associations.length - 1 ? ', ' : '')) + "\n                            ")]) : _vm._e()
	        }), _vm._v(" "), (props.row.associations.length == 0) ? _c('span', {
	          staticClass: "text-capitalize"
	        }, [_vm._v("-")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "device"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('span', {
	          staticClass: "text-capitalize"
	        }, [_vm._v("\n                                " + _vm._s(props.row.device) + "\n                            ")]), _vm._v(" "), (props.row.associations.length == 0) ? _c('span', {
	          staticClass: "text-capitalize"
	        }, [_vm._v("-")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Select",
	      "width": "70"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (props.row.checked),
	            expression: "props.row.checked"
	          }],
	          attrs: {
	            "type": "checkbox",
	            "disabled": props.row.isbucketused
	          },
	          domProps: {
	            "checked": Array.isArray(props.row.checked) ? _vm._i(props.row.checked, null) > -1 : (props.row.checked)
	          },
	          on: {
	            "click": function($event) {
	              return _vm.checkboxChange(props.row, props.row.checked)
	            },
	            "change": function($event) {
	              var $$a = props.row.checked,
	                $$el = $event.target,
	                $$c = $$el.checked ? (true) : (false);
	              if (Array.isArray($$a)) {
	                var $$v = null,
	                  $$i = _vm._i($$a, $$v);
	                if ($$el.checked) {
	                  $$i < 0 && (_vm.$set(props.row, "checked", $$a.concat([$$v])))
	                } else {
	                  $$i > -1 && (_vm.$set(props.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	                }
	              } else {
	                _vm.$set(props.row, "checked", $$c)
	              }
	            }
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Delete",
	      "width": "70"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--danger edit",
	          attrs: {
	            "type": "button",
	            "disabled": props.row.isbucketused
	          },
	          on: {
	            "click": function($event) {
	              return _vm.deleteFirstImpression(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-trash"
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Edit",
	      "width": "70"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('button', {
	          staticClass: "el-button btn-rounded el-button--success edit",
	          attrs: {
	            "id": props.row.id
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editFirstImpression(props.row)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "ti-pencil"
	        })])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [10, 20, 50, 100],
	      "total": _vm.total_pages,
	      "layout": "sizes, prev, pager, next",
	      "page-size": _vm.offset
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('el-button', {
	    staticClass: "btn-rounded float-right",
	    attrs: {
	      "type": "danger",
	      "disabled": _vm.cArr.length == 0
	    },
	    on: {
	      "click": _vm.deleteSelectedFirstImpressions
	    }
	  }, [_c('i', {
	    staticClass: "ti-trash"
	  }), _vm._v("Delete Multiple")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.saveAdSpots.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row clearfix"
	  }, [_c('div', {
	    staticClass: "col-md-1"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Existing")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-15"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.formData.existing),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "existing", $$v)
	      },
	      expression: "formData.existing"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Alias Name")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "aliasName",
	      "type": "text",
	      "placeholder": "Alias Name"
	    },
	    model: {
	      value: (_vm.formData.aliasName),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "aliasName", $$v)
	      },
	      expression: "formData.aliasName"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Select device")]), _vm._v(" "), _c('el-radio-group', {
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "input": _vm.changeValue
	    },
	    model: {
	      value: (_vm.devicegroup),
	      callback: function($$v) {
	        _vm.devicegroup = $$v
	      },
	      expression: "devicegroup"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "mobile",
	      "value": "devicegroup"
	    }
	  }, [_vm._v("Mobile")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "web",
	      "value": "devicegroup"
	    }
	  }, [_vm._v("Web")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "tablet",
	      "value": "devicegroup"
	    }
	  }, [_vm._v("Tablet")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "all",
	      "value": "devicegroup"
	    }
	  }, [_vm._v("All")])], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.formData.existing),
	      expression: "formData.existing"
	    }],
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Unique")]), _vm._v(" "), _c('el-input', {
	    staticClass: "publisher-input",
	    attrs: {
	      "name": "udivid",
	      "type": "text",
	      "placeholder": "Unique div id"
	    },
	    model: {
	      value: (_vm.formData.udivid),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "udivid", $$v)
	      },
	      expression: "formData.udivid"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.formData.existing),
	      expression: "!formData.existing"
	    }],
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Select Ad Format")]), _vm._v(" "), _c('el-select', {
	    staticClass: "select-input",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Choose ad format"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.getAdFormatFields()
	      }
	    },
	    model: {
	      value: (_vm.formData.fiAdType),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "fiAdType", $$v)
	      },
	      expression: "formData.fiAdType"
	    }
	  }, _vm._l((_vm.fiAdTypes), function(fiAdType) {
	    return _c('el-option', {
	      key: fiAdType.id,
	      attrs: {
	        "label": fiAdType.name,
	        "value": fiAdType.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
	    staticClass: "publisher-input select-input",
	    attrs: {
	      "multiple": "",
	      "collapse-tags": "",
	      "filterable": "",
	      "placeholder": "Select layout"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.selectLayoutEdit(_vm.formData)
	      },
	      "remove-tag": function($event) {
	        return _vm.layoutTagRemoved(_vm.formData)
	      }
	    },
	    model: {
	      value: (_vm.formData.adspotLayout),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "adspotLayout", $$v)
	      },
	      expression: "formData.adspotLayout"
	    }
	  }, _vm._l((_vm.existingLayouts), function(layout) {
	    return _c('el-option', {
	      key: layout.id,
	      attrs: {
	        "label": layout.layout_name,
	        "value": layout.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1"
	  }, [_c('p', {
	    staticClass: "form-label"
	  }, [_vm._v("Def. Slot")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-15"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.formData.defineSlot),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "defineSlot", $$v)
	      },
	      expression: "formData.defineSlot"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.formData.existing),
	      expression: "!formData.existing"
	    }],
	    staticClass: "row clearfix"
	  }, _vm._l((_vm.adFormatFields), function(field) {
	    return _c('div', {
	      key: field.name,
	      staticClass: "col-md-4 m-t-15"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("\n                                " + _vm._s(field.display_name) + "\n                            ")]), _vm._v(" "), (field.type == 'text') ? _c('el-input', {
	      attrs: {
	        "type": "text",
	        "placeholder": field.display_name,
	        "id": field.display_name
	      },
	      model: {
	        value: (_vm.formData.adTypeData[field.name]),
	        callback: function($$v) {
	          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
	        },
	        expression: "formData.adTypeData[field.name]"
	      }
	    }) : _vm._e(), _vm._v(" "), (field.type == 'number') ? _c('el-input', {
	      attrs: {
	        "type": "number",
	        "id": field.display_name,
	        "step": "0.01"
	      },
	      model: {
	        value: (_vm.formData.adTypeData[field.name]),
	        callback: function($$v) {
	          _vm.$set(_vm.formData.adTypeData, field.name, _vm._n($$v))
	        },
	        expression: "formData.adTypeData[field.name]"
	      }
	    }) : _vm._e(), _vm._v(" "), (field.type == 'checkbox') ? _c('div', {
	      staticClass: "clearfix m-t-15 m-b-13"
	    }, [_c('el-switch', {
	      attrs: {
	        "active-color": "#13ce66",
	        "inactive-color": "#ff4949",
	        "for": field.display_name,
	        "active-text": "Active",
	        "inactive-text": "Inactive"
	      },
	      model: {
	        value: (_vm.formData.adTypeData[field.name]),
	        callback: function($$v) {
	          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
	        },
	        expression: "formData.adTypeData[field.name]"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (field.type == 'radio') ? _c('el-radio-group', {
	      attrs: {
	        "size": "small"
	      },
	      model: {
	        value: (_vm.formData.adTypeData[field.name]),
	        callback: function($$v) {
	          _vm.$set(_vm.formData.adTypeData, field.name, $$v)
	        },
	        expression: "formData.adTypeData[field.name]"
	      }
	    }, _vm._l((field.values), function(val) {
	      return _c('el-radio-button', {
	        key: val.value,
	        attrs: {
	          "label": val.value
	        }
	      }, [_vm._v(_vm._s(val.display_name))])
	    }), 1) : _vm._e()], 1)
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "row m-t-15 clearfix text-right"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.formData.editId),
	      expression: "formData.editId"
	    }],
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearForm()
	      }
	    }
	  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), _c('button', {
	    ref: "changesSubmit",
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.disableCheck(_vm.formData)
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm.formData.editId ? 'Update' : 'Save') + "\n                            ")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": _vm.item.id + 'LineitemContainer'
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-r-15"
	  }, [_c('div', {
	    staticStyle: {
	      "border": "1px solid grey",
	      "padding": "10px",
	      "background": "white",
	      "margin-bottom": "20px"
	    }
	  }, [_c('div', [_vm._v("Type: " + _vm._s(_vm.item.type))]), _vm._v(" "), _c('div', [_vm._v("\n                    Line item Id :\n                    "), _c('span', [_vm._v(_vm._s(_vm.item.xid))])]), _vm._v(" "), _c('div', [_vm._v("\n                    Size :\n                    "), _vm._l((_vm.item.dimensions), function(dimension, index) {
	    return _c('span', {
	      key: dimension.id
	    }, [(_vm.dimensions.length && index + 1 == _vm.item.dimensions.length) ? _c('span', [_vm._v(_vm._s(_vm.dimensions.filter(function (k) { return k.id == dimension; })[0].width +
	      'X' +
	      _vm.dimensions.filter(function (k) { return k.id == dimension; })[0].height))]) : (_vm.dimensions.length) ? _c('span', [_vm._v(_vm._s(_vm.dimensions.filter(function (k) { return k.id == dimension; })[0].width +
	      'X' +
	      _vm.dimensions.filter(function (k) { return k.id == dimension; })[0].height +
	      ' , '))]) : _vm._e()])
	  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Device :\n                    "), _vm._l((_vm.item.device), function(dev, index) {
	    return _c('span', {
	      key: index
	    }, [(index + 1 == _vm.item.device.length) ? _c('span', [_vm._v(_vm._s(_vm.devices.length && _vm.devices.filter(function (k) { return k.id == dev; })[0].name))]) : _c('span', [_vm._v(_vm._s(_vm.devices.length && _vm.devices.filter(function (k) { return k.id == dev; })[0].name + ' , '))])])
	  })], 2), _vm._v(" "), (_vm.item.type !== 'unitag') ? _c('div', [_vm._v("\n                    Placements :\n                    "), (_vm.item.placement_text && _vm.item.placement_text.length) ? _c('ol', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }, _vm._l((_vm.changeItemFormat(_vm.item.placement_text[0])), function(divt, index) {
	    return _c('li', {
	      key: index
	    }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
	      staticClass: "p-l-20"
	    }, [_vm._v(_vm._s(index + 1) + ". Operator:\n                                    " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                    " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
	  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    Position :\n                    "), (_vm.item.positions && _vm.item.positions.length) ? _c('ol', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }, _vm._l((_vm.changeItemFormat(_vm.item.positions)), function(divt, index) {
	    return _c('li', {
	      key: index
	    }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
	      staticClass: "p-l-20"
	    }, [_vm._v(_vm._s(index + 1) + ". Operator:\n                                    " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                    " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
	  }), 0) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n                    Browser :\n                    "), _vm._l((_vm.item.browsers), function(browser, index) {
	    return (_vm.browsers && _vm.browsers.length) ? _c('span', {
	      key: index
	    }, [(index + 1 == _vm.item.browsers.length) ? _c('span', [_vm._v(_vm._s(_vm.browsers.filter(function (k) { return k.id == browser; })[0].name))]) : _c('span', [_vm._v(_vm._s(_vm.browsers.filter(function (k) { return k.id == browser; })[0].name + ' , '))])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Geo :\n                    "), _vm._l((_vm.item.country), function(con, index) {
	    return (_vm.countries && _vm.countries.length) ? _c('span', {
	      key: index
	    }, [(index + 1 == _vm.item.country.length) ? _c('span', [_vm._v(_vm._s(_vm.countries.filter(function (k) { return k.id == con; })[0].code))]) : _c('span', [_vm._v(_vm._s(_vm.countries.filter(function (k) { return k.id == con; })[0].code + ' , '))])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Revenue Channels :\n\n                    "), _vm._l((_vm.item.revenue_channel), function(revenue_channel) {
	    return _c('ol', {
	      staticClass: "p-l-20"
	    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(revenue_channel.type) + ": " + _vm._s(revenue_channel.name) + " ")])])])
	  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Creative :\n                    "), (_vm.creativeList && _vm.creativeList.length) ? _c('ol', {
	    staticClass: "p-l-20"
	  }, _vm._l((_vm.item.creative), function(creative, id) {
	    return _c('li', {
	      key: id
	    }, [_vm._v("\n                            " + _vm._s(id + 1) + ". Name: " + _vm._s(_vm.creativeList.filter(function (k) { return k.id == creative; })[0].name) + ", Sib Id:\n                            " + _vm._s(_vm.creativeList.filter(function (k) { return k.id == creative; })[0].sib_id) + "\n                        ")])
	  }), 0) : _vm._e()])])])])])
	},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header",
	    class: {
	      stories90d: _vm.is90d
	    }
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/admin/domains"
	    }
	  }, [(!_vm.is90d) ? _c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_c('img', {
	    attrs: {
	      "src": "/static/img/sm-logo.png",
	      "alt": "User Image"
	    }
	  })])]) : _c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_c('img', {
	    attrs: {
	      "src": "/static/img/rsz_logo_black_fav.png",
	      "alt": "User Image"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.is90d),
	      expression: "!is90d"
	    }],
	    staticClass: "logo-lg"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/bg-logo.png",
	      "alt": "User Image"
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is90d),
	      expression: "is90d"
	    }],
	    staticClass: "logo-lg"
	  }, [_c('img', {
	    staticClass: "logo-90d",
	    attrs: {
	      "src": "/static/img/rsz_Logo_Black_Verticle.png",
	      "alt": "User Image"
	    }
	  })])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pull-left-search",
	    on: {
	      "click": function($event) {
	        return _vm.toogleSearch()
	      }
	    }
	  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.domain.name),
	      expression: "domain.name"
	    }],
	    staticClass: "domain-bucket-details"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "atdIcon"
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-globe fa-w-16 fa-2x",
	    attrs: {
	      "width": "12px",
	      "height": "12px",
	      "aria-hidden": "true",
	      "data-prefix": "fas",
	      "data-icon": "globe",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 512 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M364.215 192h131.43c5.439 20.419 8.354 41.868 8.354 64s-2.915 43.581-8.354 64h-131.43c5.154-43.049 4.939-86.746 0-128zM185.214 352c10.678 53.68 33.173 112.514 70.125 151.992.221.001.44.008.661.008s.44-.008.661-.008c37.012-39.543 59.467-98.414 70.125-151.992H185.214zm174.13-192h125.385C452.802 84.024 384.128 27.305 300.95 12.075c30.238 43.12 48.821 96.332 58.394 147.925zm-27.35 32H180.006c-5.339 41.914-5.345 86.037 0 128h151.989c5.339-41.915 5.345-86.037-.001-128zM152.656 352H27.271c31.926 75.976 100.6 132.695 183.778 147.925-30.246-43.136-48.823-96.35-58.393-147.925zm206.688 0c-9.575 51.605-28.163 104.814-58.394 147.925 83.178-15.23 151.852-71.949 183.778-147.925H359.344zm-32.558-192c-10.678-53.68-33.174-112.514-70.125-151.992-.221 0-.44-.008-.661-.008s-.44.008-.661.008C218.327 47.551 195.872 106.422 185.214 160h141.572zM16.355 192C10.915 212.419 8 233.868 8 256s2.915 43.581 8.355 64h131.43c-4.939-41.254-5.154-84.951 0-128H16.355zm136.301-32c9.575-51.602 28.161-104.81 58.394-147.925C127.872 27.305 59.198 84.024 27.271 160h125.385z"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "name"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/admin/publisher/' + _vm.uuid + '/domain/edit/' + _vm.domain.id
	    }
	  }, [_vm._v(_vm._s(_vm.domain.name) + " ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.bucket.length > 0),
	      expression: "bucket.length > 0"
	    }],
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "atdIcon"
	  }, [_c('svg', {
	    staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-2x",
	    attrs: {
	      "width": "12px",
	      "height": "12px",
	      "aria-hidden": "true",
	      "data-prefix": "fab",
	      "data-icon": "bitbucket",
	      "role": "img",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 512 512"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "name"
	  }, [_c('el-dropdown', {
	    on: {
	      "command": _vm.bucketChange
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_vm._v("\n                            " + _vm._s(_vm.selectedBucketDetails.name) + " "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.bucket), function(b) {
	    return _c('el-dropdown-item', {
	      key: b.id,
	      attrs: {
	        "command": ("" + (b.id))
	      }
	    }, [_vm._v(_vm._s(b.name))])
	  }), 1)], 1), _vm._v(" "), _c('a', {
	    staticClass: "upload",
	    attrs: {
	      "href": "javascript:void(0);"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createJs()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload el-icon--right"
	  })])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', [_c('el-dropdown', {
	    staticClass: "header-dropdown-devin",
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "visible-change": _vm.notifDropdownToggle
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('el-badge', {
	    staticClass: "item"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "text",
	      "size": "small"
	    }
	  }, [_c('i', {
	    staticClass: "ti-bell"
	  })])], 1), _vm._v(" "), _c('sup', {
	    ref: "notifDot",
	    staticClass: "el-badge__content is-fixed is-dot Blink"
	  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('ul', {
	    staticClass: "dropdown-menu-devin"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("Latest notifications")]), _vm._v(" "), _c('li', [_c('ul', {
	    staticClass: "menu"
	  }, [(_vm.allNotifications.length == 0) ? _c('h5', {
	    staticStyle: {
	      "text-align": "center",
	      "color": "#d75252"
	    }
	  }, [_vm._v("No new notifications")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allNotifications), function(notif) {
	    return _c('li', {
	      key: notif.id
	    }, [_c('i', {
	      staticClass: "ti-user"
	    }), _vm._v(" "), _c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [(notif.pub_uid && notif.domain_id) ? _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: ("/admin/publisher/" + (notif.pub_uid) + "/domain/edit/" + (notif.domain_id) + "/")
	        }
	      }
	    }, [_c('h3', {
	      staticClass: "notif-message"
	    }, [_vm._v(_vm._s(notif.message)), _c('span', {
	      staticClass: "text-yellow fontello-record"
	    }, [(notif.type == 'started') ? _c('i', {
	      staticClass: "el-icon-loading"
	    }) : _vm._e(), _vm._v(" "), (notif.type == 'complete') ? _c('i', {
	      staticClass: "el-icon-success"
	    }) : _vm._e(), _vm._v(" "), (notif.type == 'error') ? _c('i', {
	      staticClass: "el-icon-error",
	      staticStyle: {
	        "color": "red !important"
	      }
	    }) : _vm._e(), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-external-link",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])])], 1) : _c('div', [_c('h3', {
	      staticClass: "notif-message"
	    }, [_vm._v(_vm._s(notif.message)), _c('span', {
	      staticClass: "text-yellow fontello-record"
	    }, [(notif.type == 'started') ? _c('i', {
	      staticClass: "el-icon-loading"
	    }) : _vm._e(), _vm._v(" "), (notif.type == 'complete') ? _c('i', {
	      staticClass: "el-icon-success"
	    }) : _vm._e(), _vm._v(" "), (notif.type == 'error') ? _c('i', {
	      staticClass: "el-icon-error",
	      staticStyle: {
	        "color": "red !important"
	      }
	    }) : _vm._e()])])]), _vm._v(" "), _c('p', [_vm._v("at " + _vm._s(_vm._f("moment")(notif.timestamp, "'MMM Do YYYY, h:mm:ss a")))])])])
	  })], 2)])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
	    staticClass: "header-dropdown-devin",
	    attrs: {
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('el-button', {
	    attrs: {
	      "data-toggle": "control-sidebar",
	      "type": "text",
	      "size": "small"
	    }
	  }, [_c('i', {
	    staticClass: "ti-menu-alt"
	  })])], 1)])], 1)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.search.showSearch),
	      expression: "search.showSearch"
	    }],
	    staticClass: "search-overflow",
	    class: {
	      appear: _vm.search.showSearch
	    }
	  }, [_c('div', {
	    staticClass: "close-container",
	    on: {
	      "click": function($event) {
	        return _vm.toogleSearch()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "cclose"
	  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
	    staticClass: "close-text"
	  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
	    staticClass: "search-container"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "search pull-left",
	    class: {
	      searching: _vm.search.networkcall
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.query),
	      expression: "search.query"
	    }],
	    ref: "search",
	    staticClass: "devin-search",
	    attrs: {
	      "type": "search",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.search.query)
	    },
	    on: {
	      "keyup": _vm.searchDomPub,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "query", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "create-button pull-left"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: "/admin/create-domain/"
	      }
	    }
	  }, [_c('a', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "href": "javascript:void(0);"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.redirect('/admin/create-domain/')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                            Domain\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "search-result"
	  }, [_c('div', {
	    staticClass: "search-list"
	  }, [_c('div', {
	    staticClass: "heading"
	  }, [_vm._v("Domain list")]), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border-spacing": "0"
	    },
	    attrs: {
	      "data": _vm.search.domains
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (scope.row.name))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": "",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": {
	              path: ("/admin/publisher/" + (props.row.publisher.uuid) + "/domain/edit/" + (props.row.id) + "/")
	            }
	          }
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0);"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.redirect('/admin/publisher/' + props.row.publisher.uuid + '/domain/edit/' + props.row.id + '/')
	            }
	          }
	        }, [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(("" + (props.row.name))))]), _vm._v(" "), _c('span', {
	          staticClass: "publisher-name"
	        }, [_vm._v(_vm._s(("" + (props.row.publisher.name))))]), _vm._v(" "), (props.row.dfp_network != null) ? _c('span', {
	          staticClass: "dfp-name"
	        }, [_vm._v(_vm._s(("" + (props.row.dfp_network.display_name))) + " DFP")]) : _vm._e()])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Reports",
	      "prop": "Reports",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": "Reports",
	            "placement": "bottom"
	          }
	        }, [_c('router-link', {
	          attrs: {
	            "to": {
	              path: ("/admin/publisher/" + (props.row.publisher.id) + "/ReportsRevenue/" + (props.row.id) + "/")
	            }
	          }
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0);"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.redirect('/admin/publisher/' + props.row.publisher.id + '/ReportsRevenue/' + props.row.id)
	            }
	          }
	        }, [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "type": "text",
	            "size": "small"
	          }
	        }, [_c('span', [_c('i', {
	          staticClass: "fa fa-line-chart",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        })])])], 1)])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-dropdown', {
	          attrs: {
	            "trigger": "click"
	          }
	        }, [_c('span', {
	          staticClass: "el-dropdown-link"
	        }, [_c('el-badge', {
	          staticClass: "item",
	          attrs: {
	            "value": 0,
	            "max": 10
	          }
	        }, [_c('el-button', {
	          directives: [{
	            name: "clipboard",
	            rawName: "v-clipboard:copy",
	            value: (props.row.site_tag),
	            expression: "props.row.site_tag",
	            arg: "copy"
	          }, {
	            name: "clipboard",
	            rawName: "v-clipboard:success",
	            value: (_vm.onCopy),
	            expression: "onCopy",
	            arg: "success"
	          }, {
	            name: "clipboard",
	            rawName: "v-clipboard:error",
	            value: (_vm.onError),
	            expression: "onError",
	            arg: "error"
	          }],
	          staticClass: "notes-box",
	          attrs: {
	            "type": "text",
	            "size": "small"
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-copy fa-w-14 fa-2x",
	          attrs: {
	            "width": "17px",
	            "height": "17px",
	            "aria-hidden": "true",
	            "data-prefix": "fal",
	            "data-icon": "copy",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 448 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
	          }
	        })])])])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
	          attrs: {
	            "slot": "dropdown"
	          },
	          slot: "dropdown"
	        }, [_c('ul', {
	          staticClass: "dropdown-menu-devin",
	          staticStyle: {
	            "max-width": "700px !important"
	          }
	        }, [_c('li', {
	          staticClass: "header",
	          staticStyle: {
	            "margin": "5px",
	            "font-size": "12px"
	          }
	        }, [_vm._v("\n                                                " + _vm._s((props.row.site_tag) ? props.row.site_tag : 'No Script Present.') + "\n                                            ")]), _vm._v(" "), _c('li', {
	          staticClass: "text-danger",
	          staticStyle: {
	            "margin-left": "20px",
	            "font-size": "10px"
	          }
	        }, [_c('b', [_vm._v("copied!")])])])])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": {
	              path: ("/admin/domains/notes/" + (props.row.id))
	            }
	          }
	        }, [_c('a', {
	          attrs: {
	            "href": "javascript:void(0);"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.redirect('/admin/domains/notes/' + props.row.id)
	            }
	          }
	        }, [_c('el-button', {
	          staticClass: "notes-box",
	          attrs: {
	            "type": "text",
	            "size": "small"
	          }
	        }, [_c('span', [_c('svg', {
	          staticClass: "svg-inline--fa fa-pen-square fa-w-14 fa-2x",
	          attrs: {
	            "width": "17px",
	            "height": "17px",
	            "aria-hidden": "true",
	            "data-prefix": "far",
	            "data-icon": "pen-square",
	            "role": "img",
	            "xmlns": "http://www.w3.org/2000/svg",
	            "viewBox": "0 0 448 512"
	          }
	        }, [_c('path', {
	          attrs: {
	            "fill": "currentColor",
	            "d": "M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
	          }
	        })])])])], 1)])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "buckets"
	        }, [_c('ul', {
	          staticClass: "bucket-list clearfix",
	          style: ({
	            width: (122 * ((props.row.buckets && props.row.buckets.length) > 3 ? props.row.buckets.length : 4)) + 'px'
	          })
	        }, _vm._l((props.row.buckets), function(bucket) {
	          return _c('li', {
	            staticClass: "shadowBox"
	          }, [_c('router-link', {
	            attrs: {
	              "to": {
	                path: ("/admin/publisher/" + (props.row.publisher.uuid) + "/domain/" + (props.row.id) + "/buckets/" + (bucket.id) + "/")
	              }
	            }
	          }, [_c('a', {
	            attrs: {
	              "href": "javascript:void(0);"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.redirect('/admin/publisher/' + props.row.publisher.uuid + '/domain/' + props.row.id + '/buckets/' + bucket.id + '/')
	              }
	            }
	          }, [_c('span', {}, [_c('svg', {
	            staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-3x",
	            attrs: {
	              "aria-hidden": "true",
	              "width": "12",
	              "height": "12",
	              "data-prefix": "fab",
	              "data-icon": "bitbucket",
	              "role": "img",
	              "xmlns": "http://www.w3.org/2000/svg",
	              "viewBox": "0 0 512 512"
	            }
	          }, [_c('path', {
	            attrs: {
	              "fill": "currentColor",
	              "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
	            }
	          })])]), _vm._v(" "), _c('span', {}, [_vm._v(" " + _vm._s(("" + (bucket.name))))])])])], 1)
	        }), 0)])]
	      }
	    }])
	  })], 1)], 1)])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "offcanvas",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "relative",
	    attrs: {
	      "id": "demo-2"
	    }
	  }, [_c('input', {
	    staticClass: "devin-search",
	    attrs: {
	      "type": "search"
	    }
	  })])
	}]}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Header Bidding tag for " + _vm._s((_vm.is_amp) ? 'AMP' : 'DISPLAY'))])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.createTag.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.pubUnitToggle
	    },
	    model: {
	      value: (_vm.isPubUnit),
	      callback: function($$v) {
	        _vm.isPubUnit = $$v
	      },
	      expression: "isPubUnit"
	    }
	  }, [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Select Dimension/s")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "multiple": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.hb_tag.dimensions),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "dimensions", $$v)
	      },
	      expression: "hb_tag.dimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension) {
	    return _c('el-option', {
	      attrs: {
	        "data-id": dimension.id,
	        "label": dimension.width + 'x' + dimension.height,
	        "value": dimension.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr')]), _vm._v(" "), (!_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter tag post fix")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "text",
	      "placeholder": "Enter tag post fix"
	    },
	    model: {
	      value: (_vm.hb_tag.post_fix),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "post_fix", $$v)
	      },
	      expression: "hb_tag.post_fix"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', {
	    staticStyle: {
	      "padding-top": "10px"
	    }
	  }, [_vm._v("DFP Ad unit path:  " + _vm._s((_vm.is_amp) ? _vm.getDfpAdUnitPathAmp(_vm.hb_tag).replace(null, '') : _vm.getDfpAdUnitPathDisplay(_vm.hb_tag).replace(null, '')))])]), _vm._v(" "), _c('div', [(_vm.domainMcmEnabled || (_vm.isPubUnit || _vm.is_amp)) ? _c('h5', [_vm._v("Override DFP network code here")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('button', {
	    staticClass: "el-button el-button--success pull-right",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resetNetworkCode($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-refresh"
	  }), _vm._v("\n                Reset to default\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "network_override",
	      "type": "text",
	      "placeholder": "Enter DFP Network Override"
	    },
	    model: {
	      value: (_vm.hb_tag.network_override),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "network_override", $$v)
	      },
	      expression: "hb_tag.network_override"
	    }
	  }) : _vm._e(), _vm._v(" "), ((_vm.domainMcmEnabled && !_vm.isPubUnit)) ? _c('div', [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.resetMCM
	    },
	    model: {
	      value: (_vm.mcm_enabled),
	      callback: function($$v) {
	        _vm.mcm_enabled = $$v
	      },
	      expression: "mcm_enabled"
	    }
	  }, [_vm._v("Is sticky Unit?")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isPubUnit && (_vm.mcm_enabled && _vm.domainMcmEnabled)) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select MCM Delegation Type"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.account_type),
	      callback: function($$v) {
	        _vm.account_type = $$v
	      },
	      expression: "account_type"
	    }
	  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "data-id": id,
	        "label": mcm_account_type.account_type.replaceAll('_', ' '),
	        "value": mcm_account_type.account_type
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "disabled": _vm.account_type == null,
	      "filterable": "",
	      "placeholder": "Select Child DFP Network"
	    },
	    model: {
	      value: (_vm.child_dfp_network),
	      callback: function($$v) {
	        _vm.child_dfp_network = $$v
	      },
	      expression: "child_dfp_network"
	    }
	  }, _vm._l((_vm.filteredAccountList), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.child_network_code +' : ' + network.name)),
	        "value": network.child_network_code
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null && _vm.child_dfp_network == null,
	      "placeholder": "Add DFP Parent Adunit Id"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_id),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_id = $$v
	      },
	      expression: "dfp_parent_ad_unit_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Path")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null || _vm.child_dfp_network == null || _vm.dfp_parent_ad_unit_id == 0,
	      "placeholder": "Add DFP Parent Adunit Path"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_path),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_path = $$v
	      },
	      expression: "dfp_parent_ad_unit_path"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('hr')], 1), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Select Currency for AMP")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.hb_tag.currencyId),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "currencyId", $$v)
	      },
	      expression: "hb_tag.currencyId"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(option) {
	    return _c('el-option', {
	      key: option.id,
	      attrs: {
	        "label": option.code,
	        "value": option.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Is AMP sticky Unit?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.hb_tag.is_amp_sticky),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "is_amp_sticky", $$v)
	      },
	      expression: "hb_tag.is_amp_sticky"
	    }
	  }, [_vm._v("Is sticky Unit?")]), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit path")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "text",
	      "placeholder": "Enter publisher's DFP Ad unit path"
	    },
	    model: {
	      value: (_vm.hb_tag.pub_dfp_unit_path),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "pub_dfp_unit_path", $$v)
	      },
	      expression: "hb_tag.pub_dfp_unit_path"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit id")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "number",
	      "placeholder": "Enter publisher's DFP Ad unit id"
	    },
	    model: {
	      value: (_vm.hb_tag.pub_dfp_unit_id),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "pub_dfp_unit_id", $$v)
	      },
	      expression: "hb_tag.pub_dfp_unit_id"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.isComplete
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                Create tag\n              ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": (_vm.is_amp) ? ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags-amp/") : ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags/")
	    }
	  }, [_vm._v("\n                Cancel\n              ")])], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("List of Buckets")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--info pull-right",
	    attrs: {
	      "to": ("" + ('/admin/publisher/'+ this.$route.params.uuid +'/domain/'+ this.$route.params.domId + '/buckets'))
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n\t\t\t\t\tCreate Bucket\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body domain-list"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.buckets
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "",
	      "width": "50"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('div', {
	          staticClass: "text-center"
	        }, [_c('img', {
	          staticClass: "round",
	          attrs: {
	            "width": "30",
	            "height": "30",
	            "avatar": ("" + (props.row.name))
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "300",
	      "label": "",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('router-link', {
	          attrs: {
	            "to": ("" + ('/admin/publisher/'+ props.row.domain.publisher.uuid +'/domain/'+ _vm.domId + '/buckets/' + props.row.id))
	          }
	        }, [_c('span', {
	          staticClass: "domain-name"
	        }, [_vm._v(_vm._s(("" + (props.row.name))))])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "buckets"
	        }, [_c('ul', {
	          staticClass: "bucket-list clearfix"
	        }, [(scope.row.product && scope.row.product.length > 0) ? _c('li', [_c('span', {
	          staticClass: "el-button el-button--info pull-right"
	        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s((scope.row.product[0].product && scope.row.product[0].product !== undefined) ? scope.row.product[0].product.name : 'No Product Associated yet.') + "\n\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (scope.row.product && scope.row.product.length < 1) ? _c('li', [_c('span', {
	          staticClass: "el-button el-button--info pull-right"
	        }, [_vm._v("No product associated yet.")])]) : _vm._e(), _vm._v(" "), (scope.row.snippet_updated_at) ? _c('li', [_c('span', {
	          staticClass: "el-button el-button--info pull-right"
	        }, [_vm._v(_vm._s(_vm._f("moment")(("" + (scope.row.snippet_updated_at)), "MMM Do, h:mm:ss a")))])]) : _vm._e(), _vm._v(" "), (!scope.row.snippet_updated_at) ? _c('li', [_c('span', {
	          staticClass: "el-button el-button--info pull-right"
	        }, [_vm._v("No Module configuration added yet!")])]) : _vm._e(), _vm._v(" "), (scope.row.product && scope.row.product.length > 0) ? _c('li', [_c('span', {
	          staticClass: "pull-right",
	          staticStyle: {
	            "position": "absolute !important",
	            "right": "0px !important"
	          }
	        }, [((scope.row.product[0].product && scope.row.product[0].product !== undefined)) ? _c('button', {
	          class: (scope.row.dirty) ? 'btn upload animated flash' : 'btn upload',
	          style: ((scope.row.dirty) ? 'background : rgb(226, 203, 35) !important;' : ''),
	          on: {
	            "click": function($event) {
	              return _vm.createJs(scope.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-upload el-icon--right"
	        })]) : _vm._e()])]) : _vm._e()])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-tooltip', {
	          attrs: {
	            "content": (scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 || scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1) ? 'Publisher has GPT disableinitialload setup' : 'Disable/Enable bucket',
	            "placement": "top"
	          }
	        }, [(scope.row.name != 'default') ? _c('el-switch', {
	          ref: 'elem' + scope.$index,
	          staticClass: "pull-right ht-24",
	          attrs: {
	            "disabled": scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 || scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1,
	            "title": (scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 || scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1) ? 'Publisher has GPT disableinitial setup' : ''
	          },
	          on: {
	            "change": function($event) {
	              return _vm.confirmAction(scope.row.id, scope.row.domain.id, scope.row.domain.publisher.id, scope.$index, $event)
	            }
	          },
	          model: {
	            value: (_vm.test[scope.$index]),
	            callback: function($$v) {
	              _vm.$set(_vm.test, scope.$index, $$v)
	            },
	            expression: "test[scope.$index]"
	          }
	        }) : _vm._e()], 1)]
	      }
	    }])
	  })], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart clearfix"
	  }, [_c('div', {
	    staticClass: "clearfix pull-left col-md-8"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Sticky")]), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('span', {
	    staticClass: "text-danger animated flash config-notif"
	  }, [_vm._v("\n\t\t\t\t\t\tImported config from " + _vm._s(_vm.selectedBucketNameToImportConfig) + " Bucket. Click save to use the config.\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "pull-left clearfix import col-md-1 text-center"
	  }, [_c('el-switch', {
	    attrs: {
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.stickyConfig.isEnabled),
	      callback: function($$v) {
	        _vm.$set(_vm.stickyConfig, "isEnabled", $$v)
	      },
	      expression: "stickyConfig.isEnabled"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "pull-right clearfix import col-md-3"
	  }, [_c('div', {
	    staticClass: "col-md-9 text-right"
	  }, [_c('el-dropdown', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.selectedBucketNameToImportConfig),
	      expression: "!selectedBucketNameToImportConfig"
	    }],
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.selectBucketModule
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "title": 'Import Config'
	    }
	  }, [_vm._v(" \n\t\t\t\t\t\t\t\tImport Config "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.bucketListForModuleConfig), function(bucket, index) {
	    return _c('el-dropdown-item', {
	      attrs: {
	        "command": index
	      }
	    }, [_vm._v(_vm._s(bucket.bucketName))])
	  }), 1)], 1), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedBucketNameToImportConfig),
	      expression: "selectedBucketNameToImportConfig"
	    }],
	    staticClass: "el-button el-button--danger",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.removeSelectedModuleConfig()
	      }
	    }
	  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 no-padding"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    on: {
	      "click": function($event) {
	        return _vm.saveAndPublishAxtSticky()
	      }
	    }
	  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [
	    [_c('el-table', {
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "data": _vm.stickyConfigsList,
	        "stripe": "",
	        "height": "400"
	      }
	    }, [_c('el-table-column', {
	      attrs: {
	        "prop": "layout",
	        "sortable": "",
	        "filters": _vm.filterList,
	        "filter-method": _vm.layoutFilterHandler,
	        "label": "Layout"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "alias_name",
	        "label": "Ad Spot"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "Start Point"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.startPoint ? props.row.startPoint : '-') + "\n\t\t\t\t\t\t\t")]
	        }
	      }])
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "End Point"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.endPoint ? props.row.endPoint : '-') + "\n\t\t\t\t\t\t\t")]
	        }
	      }])
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "Timer(sec)"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.timer > 0 ? props.row.timer : '-') + "\n\t\t\t\t\t\t\t")]
	        }
	      }])
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "Edit",
	        "width": "50"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [_c('button', {
	            staticClass: "el-button btn-rounded el-button--success edit",
	            on: {
	              "click": function($event) {
	                return _vm.editStickyConfig(props.row)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "ti-pencil"
	          })])]
	        }
	      }])
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": "Delete",
	        "width": "60"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(props) {
	          return [_c('button', {
	            staticClass: "el-button btn-rounded el-button--danger edit",
	            on: {
	              "click": function($event) {
	                return _vm.deleteStickyUnitConfig(props.row)
	              }
	            }
	          }, [_c('i', {
	            staticClass: "ti-close"
	          })])]
	        }
	      }])
	    })], 1)], _vm._v(" "), _c('form', {
	      staticClass: "form",
	      attrs: {
	        "method": "post"
	      },
	      on: {
	        "submit": function($event) {
	          $event.preventDefault();
	          return _vm.addStickyUnitConfig.apply(null, arguments)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row clearfix"
	    }, [_c('div', {
	      staticClass: "col-md-4"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "filterable": "",
	        "placeholder": "Select a Layout"
	      },
	      on: {
	        "change": _vm.getAdSpots
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.layout),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "layout", $$v)
	        },
	        expression: "stickyUnitConfig.layout"
	      }
	    }, _vm._l((_vm.layoutsList), function(layout) {
	      return _c('el-option', {
	        key: layout.id,
	        attrs: {
	          "label": layout.layout_name,
	          "value": layout.id
	        }
	      })
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("Main Selector(Ad Spot)")]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "filterable": "",
	        "placeholder": "Select a AdSpot"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.layoutAdSpots),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "layoutAdSpots", $$v)
	        },
	        expression: "stickyUnitConfig.layoutAdSpots"
	      }
	    }, _vm._l((_vm.layoutAdSpotsList), function(adSpot) {
	      return _c('el-option', {
	        key: adSpot.id,
	        attrs: {
	          "label": adSpot.adSpot,
	          "value": adSpot.id
	        }
	      })
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("Timer(sec)")]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "placeholder": "Timer",
	        "type": "number",
	        "value": "1",
	        "min": "0",
	        "max": "600"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.timer),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "timer", $$v)
	        },
	        expression: "stickyUnitConfig.timer"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4 m-t-15"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("Start Point")]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "placeholder": "Start-point"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.startPoint),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "startPoint", $$v)
	        },
	        expression: "stickyUnitConfig.startPoint"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4 m-t-15"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("End Point")]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "placeholder": "End-point"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.endPoint),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "endPoint", $$v)
	        },
	        expression: "stickyUnitConfig.endPoint"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4 m-t-15"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("More CSS")]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "placeholder": "CSS to fix the ad unit"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.moreCSS),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "moreCSS", $$v)
	        },
	        expression: "stickyUnitConfig.moreCSS"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4 m-t-15"
	    }, [_c('p', {
	      staticClass: "form-label"
	    }, [_vm._v("Top")]), _vm._v(" "), _c('el-input', {
	      attrs: {
	        "type": "number",
	        "placeholder": "Top value to avoid header overlap"
	      },
	      model: {
	        value: (_vm.stickyUnitConfig.top),
	        callback: function($$v) {
	          _vm.$set(_vm.stickyUnitConfig, "top", $$v)
	        },
	        expression: "stickyUnitConfig.top"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-12 m-t-15 text-right"
	    }, [_c('button', {
	      staticClass: "el-button el-button--success",
	      attrs: {
	        "type": "submit"
	      }
	    }, [_vm._v(_vm._s(_vm.stickyUnitConfig.editId ? 'Update' : 'Save'))]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.stickyUnitConfig.editId),
	        expression: "stickyUnitConfig.editId"
	      }],
	      staticClass: "el-button el-button--danger",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.clearForm()
	        }
	      }
	    }, [_vm._v("Clear")])])])])
	  ], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/admin"
	    }
	  }, [_vm._v("Admin")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/admin/publisher"
	    }
	  }, [_vm._v("Publishers")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Publisher Domains")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "add-domain-button float-right"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("" + ('/admin/publisher/'  + _vm.publishersUuid +  '/' + _vm.publishersId + '/domain/add/'))
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-circle-plus"
	  })])], 1)], 1)]), _vm._v(" "), _c('ul', {
	    staticClass: "cart-items width-custom width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
	  }, [_c('li', {
	    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
	  }, [_c('span', {
	    staticClass: "col-md-6 text-muted small"
	  }, [_vm._v("Domains")])]), _vm._v(" "), _vm._l((_vm.publishers), function(option) {
	    return _c('li', {
	      staticClass: "row"
	    }, [_c('span', {
	      staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
	    }, [_c('router-link', {
	      staticClass: "h5",
	      attrs: {
	        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
	      }
	    }, [_c('avatar', {
	      attrs: {
	        "username": option.name,
	        "size": 50,
	        "color": "#fff"
	      }
	    })], 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('span', {
	      staticClass: "cart-description col-xs-12 col-md-5"
	    }, [_c('router-link', {
	      staticClass: "h5",
	      attrs: {
	        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
	      }
	    }, [_vm._v(_vm._s(("" + (option.name))))])], 1), _vm._v(" "), _c('span', {
	      staticClass: "col-md-5 col-sm-12 text-right"
	    }, [_c('router-link', {
	      staticClass: "hoverColor",
	      attrs: {
	        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
	      }
	    }, [_c('span', {
	      staticClass: "ti-pencil-alt pull-right mt-5 ml-10"
	    })])], 1)])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "limiter"
	  }, [_c('div', {
	    staticClass: "container-login100"
	  }, [_c('div', {
	    staticClass: "wrap-login100"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "login100-form validate-form"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "error-msg"
	  }, [_c('p', [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
	    staticClass: "wrap-input100 validate-input",
	    attrs: {
	      "data-validate": "Password is required"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password1),
	      expression: "credentials.password1"
	    }],
	    staticClass: "input100",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('password')
	    },
	    attrs: {
	      "data-vv-delay": "5000",
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password1)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password1", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "focus-input100"
	  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
	    staticClass: "wrap-input100 validate-input",
	    attrs: {
	      "data-validate": "Password is required"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password2),
	      expression: "credentials.password2"
	    }],
	    staticClass: "input100",
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('password')
	    },
	    attrs: {
	      "data-vv-delay": "5000",
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password2)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password2", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "focus-input100"
	  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
	    staticClass: "container-login100-form-btn"
	  }, [_c('button', {
	    staticClass: "login100-form-btn",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.formValid
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Reset Password")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-center p-t-12"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login100-pic js-tilt",
	    attrs: {
	      "data-tilt": ""
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/Blue-Yeti.png",
	      "alt": "IMG"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "login100-form-title"
	  }, [_c('img', {
	    attrs: {
	      "src": "https://pub.automatad.com/static/img/apl-h.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "symbol-input100"
	  }, [_c('i', {
	    staticClass: "fa fa-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "symbol-input100"
	  }, [_c('i', {
	    staticClass: "fa fa-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Bucket name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      input: true,
	        'is-danger': _vm.errors.has('bname'),
	    },
	    attrs: {
	      "data-vv-delay": "200",
	      "name": "bname",
	      "type": "text",
	      "placeholder": "Bucket Name",
	      "disabled": _vm.formData.bname == 'default'
	    },
	    model: {
	      value: (_vm.formData.bname),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "bname", $$v)
	      },
	      expression: "formData.bname"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('bname')),
	      expression: "errors.has('bname')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first("bname")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select country",
	      "multiple": "",
	      "filterable": "",
	      "disabled": _vm.formData.bname == 'default'
	    },
	    on: {
	      "remove-tag": _vm.deleteCountry,
	      "change": _vm.countriesChange
	    },
	    model: {
	      value: (_vm.formData.country),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "country", $$v)
	      },
	      expression: "formData.country"
	    }
	  }, _vm._l((_vm.countries), function(option) {
	    return _c('el-option', {
	      key: option.id,
	      attrs: {
	        "label": option.name,
	        "value": option.id,
	        "disabled": _vm.formData.bname == 'default' ||
	          _vm.displayexistingCountries.indexOf(
	            option.id
	          ) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Associate Products")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select products"
	    },
	    model: {
	      value: (_vm.formData.prod),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "prod", $$v)
	      },
	      expression: "formData.prod"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": "Select a product",
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.products), function(prod) {
	    return _c('el-option', {
	      key: prod.id,
	      attrs: {
	        "label": prod.name,
	        "value": prod.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Bucket features")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.formData.refresh_all_initially
	    },
	    model: {
	      value: (_vm.formData.refresh_all_after_bids),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "refresh_all_after_bids", $$v)
	      },
	      expression: "formData.refresh_all_after_bids"
	    }
	  }, [_vm._v("Refresh all units after bids")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.formData.refresh_all_after_bids
	    },
	    model: {
	      value: (_vm.formData.refresh_all_initially),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "refresh_all_initially", $$v)
	      },
	      expression: "formData.refresh_all_initially"
	    }
	  }, [_vm._v("Refresh all units initially")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enable Ad Lightning?")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-switch', {
	    model: {
	      value: (_vm.formData.ad_lightnings_enable),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "ad_lightnings_enable", $$v)
	      },
	      expression: "formData.ad_lightnings_enable"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enable Fouanalytics?")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-switch', {
	    model: {
	      value: (_vm.formData.fouanalytics_enable),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "fouanalytics_enable", $$v)
	      },
	      expression: "formData.fouanalytics_enable"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Devices")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.formData.isMobileEnable
	    },
	    model: {
	      value: (_vm.formData.isMobile),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isMobile", $$v)
	      },
	      expression: "formData.isMobile"
	    }
	  }, [_vm._v("Mobile enabled?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.formData.isWebEnable
	    },
	    model: {
	      value: (_vm.formData.isWeb),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isWeb", $$v)
	      },
	      expression: "formData.isWeb"
	    }
	  }, [_vm._v("Web enabled?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.formData.isTabletEnable
	    },
	    model: {
	      value: (_vm.formData.isTablet),
	      callback: function($$v) {
	        _vm.$set(_vm.formData, "isTablet", $$v)
	      },
	      expression: "formData.isTablet"
	    }
	  }, [_vm._v("Tablet enabled?")])], 1), _vm._v(" "), (_vm.formData.messageBCountry) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n                                    " + _vm._s(this.formData.messageBCountry) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onSubmit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-left",
	    class: {
	      'el-icon-edit': _vm.bucketId !== undefined,
	        'el-icon-plus': _vm.bucketId === undefined,
	    }
	  }), _vm._v("\n                                " + _vm._s(_vm.bucketId === undefined ?
	    "Create Bucket" :
	    "Edit Bucket") + "\n                            ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--warning",
	    attrs: {
	      "to": "/admin/domains/"
	    }
	  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.dialogue_title,
	      "visible": _vm.dialogVisible,
	      "width": "30%"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation_message)
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleDelete()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-button', {
	    staticClass: "pull-right",
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-delete",
	      "circle": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = true
	      }
	    }
	  })], 1)], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Update Bucket")])])
	}]}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('app-header', {
	    attrs: {
	      "domain_details": _vm.domain_details,
	      "is90d": _vm.is90d
	    }
	  }), _vm._v(" "), _c('app-sidebar', {
	    attrs: {
	      "is90d": _vm.is90d
	    }
	  }), _vm._v(" "), (this.$auth.ready() && this.$auth.check()) ? _c('router-view', {
	    key: _vm.$route.path,
	    attrs: {
	      "domain_details": _vm.domain_details
	    }
	  }) : _vm._e(), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
	},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Search")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-md-6",
	    attrs: {
	      "placeholder": "search any urls",
	      "type": "text"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterByEachInput.apply(null, arguments)
	      }
	    },
	    model: {
	      value: (_vm.searchvalue),
	      callback: function($$v) {
	        _vm.searchvalue = $$v
	      },
	      expression: "searchvalue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('p', [_vm._v("Add the URLS to be blocked here(each url on separate line)")]), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
	    ref: "saveTagInput",
	    staticClass: "input-new-tag",
	    attrs: {
	      "size": "mini",
	      "type": "textarea"
	    },
	    on: {
	      "blur": _vm.handleInputConfirm
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.handleInputConfirm.apply(null, arguments)
	      }
	    },
	    model: {
	      value: (_vm.inputValue),
	      callback: function($$v) {
	        _vm.inputValue = $$v
	      },
	      expression: "inputValue"
	    }
	  }) : _c('el-button', {
	    staticClass: "button-new-tag",
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": _vm.showInput
	    }
	  }, [_vm._v("+ Add URL")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticStyle: {
	      "margin": "0px 0px 10px 0px"
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                Save\n                            ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/domains/"
	    }
	  }, [_vm._v("\n                                Cancel\n                            ")])], 1)]), _vm._v(" "), (_vm.dynamicTagsCopy.length != _vm.dynamicTags.length) ? _c('p', {
	    staticStyle: {
	      "color": "red",
	      "float": "right",
	      "font-style": "italic"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "20px"
	    }
	  }, [_vm._v("*")]), _vm._v(" NOT SAVED")]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "button-new-tag el-button--danger",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openDeleteAllBlockUrlsModelBox(1)
	      }
	    }
	  }, [_vm._v("Delete All blockedurls")]), _vm._v(" "), _c('el-button', {
	    staticClass: "button-new-tag",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deleteSelectedUrls(0)
	      }
	    }
	  }, [_vm._v("Delete Selected blockedurls")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, _vm._l((_vm.dynamicTags), function(tag) {
	    return _c('el-tag', {
	      attrs: {
	        "disable-transitions": false
	      },
	      on: {
	        "close": function($event) {
	          return _vm.handleClose(tag)
	        }
	      }
	    }, [_c('a', {
	      staticStyle: {
	        "display": "inline-block",
	        "width": "calc(100% - 50px)",
	        "line-height": "30px",
	        "overflow": "hidden",
	        "text-overflow": "ellipsis"
	      },
	      attrs: {
	        "href": tag.url,
	        "target": "_blank"
	      }
	    }, [_vm._v("\n                                " + _vm._s(tag.url) + "\n                                "), _c('i', {
	      staticClass: "fa fa-external-link",
	      staticStyle: {
	        "display": "inline",
	        "margin-left": "5px",
	        "line-height": "30px",
	        "font-size": "20px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), (tag.id == undefined) ? _c('span', {
	      staticStyle: {
	        "color": "red",
	        "font-size": "30px"
	      }
	    }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedBlockurls),
	        expression: "selectedBlockurls"
	      }],
	      staticStyle: {
	        "float": "right"
	      },
	      attrs: {
	        "type": "checkbox",
	        "id": tag.id
	      },
	      domProps: {
	        "value": tag.id,
	        "checked": Array.isArray(_vm.selectedBlockurls) ? _vm._i(_vm.selectedBlockurls, tag.id) > -1 : (_vm.selectedBlockurls)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.selectedBlockurls,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = tag.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.selectedBlockurls = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.selectedBlockurls = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selectedBlockurls = $$c
	          }
	        }
	      }
	    })])
	  }), 1), _vm._v(" "), _c('el-pagination', {
	    attrs: {
	      "background": "",
	      "layout": "prev, pager, next",
	      "pager-count": 20,
	      "current-page": _vm.currentPage,
	      "total": _vm.total_pages,
	      "page-size": _vm.offset
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Block URLS")])])
	}]}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Select HB tags",
	      "visible": _vm.dialogVisible,
	      "width": "40%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.selectAll
	    }
	  }, [_vm._v("Select all")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding": "20px 0px"
	    }
	  }, _vm._l((_vm.hb_tags), function(hb_tag) {
	    return (_vm.filterHbtag(hb_tag)) ? _c('el-checkbox', {
	      staticStyle: {
	        "width": "50%",
	        "margin": "10px 0px"
	      },
	      attrs: {
	        "value": hb_tag.id,
	        "name": "hb_tag[]",
	        "id": ("" + (hb_tag.id))
	      },
	      on: {
	        "change": _vm.checkedHbtag
	      },
	      model: {
	        value: (hb_tag['checked']),
	        callback: function($$v) {
	          _vm.$set(hb_tag, 'checked', $$v)
	        },
	        expression: "hb_tag['checked']"
	      }
	    }, [(hb_tag.publisher_dfp_unit) ? _c('span', [_vm._v(_vm._s(((_vm.domain_details.dfp_network.network_code) + "/" + (hb_tag.dfp_ad_unit_code))))]) : _c('span', [_vm._v(_vm._s(((_vm.domain_details.dfp_network.network_code) + "/" + (hb_tag.dfp_parent_ad_unit_path) + "/" + (hb_tag.dfp_ad_unit_code))))])]) : _vm._e()
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.closeDialog
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.updateHbTag(_vm.updatingDimen)
	      }
	    }
	  }, [_vm._v("Apply")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "heading-cart"
	  }, [_c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    },
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, _vm._l((_vm.dimensionWiseParams), function(dimension) {
	    return _c('el-collapse-item', {
	      staticClass: "collapse--item",
	      class: {
	        recentlyClosed: (_vm.recentlyClosed == dimension.id), opened: (_vm.activeNames == dimension.id)
	      },
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "title": _vm.getDimensionInStr(dimension.id),
	        "name": dimension.id
	      }
	    }, [_c('template', {
	      staticStyle: {
	        "height": "auto"
	      },
	      slot: "title"
	    }, [_c('div', {
	      staticStyle: {
	        "width": "10%",
	        "display": "inline-block",
	        "position": "relative"
	      }
	    }, [_c('h4', {
	      staticStyle: {
	        "line-height": "47px",
	        "margin": "0px",
	        "padding": "0px 10px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getDimensionInStr(dimension.id)) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "85%",
	        "display": "inline-block",
	        "position": "relative"
	      }
	    }, [_c('div', {
	      staticClass: "enabled-bidders"
	    }, [_vm._l((_vm.getEnabledBidders(dimension.id)), function(bidder) {
	      return _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(bidder) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
	    }), _vm._v(" "), _c('p', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.getEnabledBidders(dimension.id).length == 0),
	        expression: "getEnabledBidders(dimension.id).length == 0"
	      }],
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNo bidders enabled\n\t\t\t\t\t\t\t\t\t\t\t")])], 2)])]), _vm._v(" "), _c('div', _vm._l((_vm.allBidders), function(bidder) {
	      return _c('div', [_c('div', {
	        staticClass: "col-md-12 m-b-10 m-t-10"
	      }, [_c('el-checkbox', {
	        attrs: {
	          "value": bidder.id,
	          "name": "bidder[]",
	          "id": bidder.code + '_' + dimension.id
	        },
	        model: {
	          value: (_vm.bidderParamsForm[dimension.id][bidder.code]['enabled']),
	          callback: function($$v) {
	            _vm.$set(_vm.bidderParamsForm[dimension.id][bidder.code], 'enabled', $$v)
	          },
	          expression: "bidderParamsForm[dimension.id][bidder.code]['enabled']"
	        }
	      }, [_c('label', {
	        attrs: {
	          "for": bidder.code
	        }
	      }, [_vm._v(_vm._s(bidder.name))])]), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.bidderParamsForm[dimension.id][bidder.code]['enabled']),
	          expression: "bidderParamsForm[dimension.id][bidder.code]['enabled']"
	        }],
	        staticClass: "row"
	      }, _vm._l((_vm.getBidderFields(bidder.id)), function(field) {
	        return _c('div', {
	          staticClass: "col-md-4"
	        }, [(field.type == 'text') ? _c('div', {
	          staticClass: "form-group"
	        }, [(_vm.bidderParamsForm[dimension.id][bidder.code]) ? _c('div', [_c('p', {
	          staticClass: "bold pull-left",
	          attrs: {
	            "for": field.label
	          }
	        }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (_vm.bidderParamsForm[dimension.id][bidder.code][field.name]),
	            expression: "bidderParamsForm[dimension.id][bidder.code][field.name]"
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "id": field.label,
	            "required": _vm.bidderParamsForm[dimension.id][bidder.code]['enabled']
	          },
	          domProps: {
	            "value": (_vm.bidderParamsForm[dimension.id][bidder.code][field.name])
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.bidderParamsForm[dimension.id][bidder.code], field.name, $event.target.value)
	            }
	          }
	        })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type == 'number') ? _c('div', {
	          staticClass: "form-group"
	        }, [(_vm.bidderParamsForm[dimension.id][bidder.code]) ? _c('div', [_c('p', {
	          staticClass: "bold pull-left",
	          attrs: {
	            "for": field.label
	          }
	        }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (_vm.bidderParamsForm[dimension.id][bidder.code][field.name]),
	            expression: "bidderParamsForm[dimension.id][bidder.code][field.name]",
	            modifiers: {
	              "number": true
	            }
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "number",
	            "id": "[[ field.label ]]",
	            "step": "0.01"
	          },
	          domProps: {
	            "value": (_vm.bidderParamsForm[dimension.id][bidder.code][field.name])
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(_vm.bidderParamsForm[dimension.id][bidder.code], field.name, _vm._n($event.target.value))
	            },
	            "blur": function($event) {
	              return _vm.$forceUpdate()
	            }
	          }
	        })]) : _vm._e()]) : _vm._e()])
	      }), 0)], 1)])
	    }), 0), _vm._v(" "), _c('el-button', {
	      staticClass: "col-md-2",
	      staticStyle: {
	        "float": "left",
	        "margin": "20px"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.updateHbTagDiag(dimension)
	        }
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tApply\n\t\t\t\t\t\t\t\t")])], 2)
	  }), 1)], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Modify " + _vm._s((_vm.is_amp) ? 'AMP' : 'display') + " Header Bidding tag - " + _vm._s(_vm.curUnit.dfp_ad_unit_code) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.createTag.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.isPubUnit),
	      callback: function($$v) {
	        _vm.isPubUnit = $$v
	      },
	      expression: "isPubUnit"
	    }
	  }, [_vm._v("Publisher's Unit")]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Select Dimension/s")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "multiple": "",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.hb_tag.dimensions),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "dimensions", $$v)
	      },
	      expression: "hb_tag.dimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension) {
	    return _c('el-option', {
	      attrs: {
	        "data-id": dimension.id,
	        "label": dimension.width + 'x' + dimension.height,
	        "value": dimension.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr')]), _vm._v(" "), (!_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter tag post fix")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "text",
	      "placeholder": "Enter tag post fix",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.hb_tag.post_fix),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "post_fix", $$v)
	      },
	      expression: "hb_tag.post_fix"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
	    staticStyle: {
	      "padding-top": "10px"
	    }
	  }, [_vm._v("DFP Ad unit path:  " + _vm._s(_vm.getDfpAdUnitPath(_vm.curUnit).replace(null, '')))])]), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Is AMP sticky Unit?")]), _vm._v(" "), (_vm.is_amp) ? _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.curUnit.is_amp_sticky),
	      callback: function($$v) {
	        _vm.$set(_vm.curUnit, "is_amp_sticky", $$v)
	      },
	      expression: "curUnit.is_amp_sticky"
	    }
	  }, [_vm._v("Is sticky Unit?")]) : _vm._e(), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit path")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "text",
	      "placeholder": "Enter publisher's DFP Ad unit path",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.hb_tag.pub_dfp_unit_path),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "pub_dfp_unit_path", $$v)
	      },
	      expression: "hb_tag.pub_dfp_unit_path"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.domainMcmEnabled || (_vm.isPubUnit || _vm.is_amp)) ? _c('h5', [_vm._v("DFP network code override")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('button', {
	    staticClass: "el-button el-button--success pull-right",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resetNetworkCode($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-refresh"
	  }), _vm._v("\n                Reset to default\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.mcm_enabled && (_vm.isPubUnit || (!_vm.domainMcmEnabled && _vm.is_amp))) ? _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "network_override",
	      "type": "text",
	      "placeholder": "Enter DFP network code override"
	    },
	    model: {
	      value: (_vm.hb_tag.network_override),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "network_override", $$v)
	      },
	      expression: "hb_tag.network_override"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.mcm_enabled || (_vm.domainMcmEnabled && !_vm.isPubUnit)) ? _c('div', [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.resetMCM
	    },
	    model: {
	      value: (_vm.mcm_enabled),
	      callback: function($$v) {
	        _vm.mcm_enabled = $$v
	      },
	      expression: "mcm_enabled"
	    }
	  }, [_vm._v("Is sticky Unit?")])], 1) : _vm._e(), _vm._v(" "), (_vm.mcm_enabled) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select MCM Delegation Type"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.account_type),
	      callback: function($$v) {
	        _vm.account_type = $$v
	      },
	      expression: "account_type"
	    }
	  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "data-id": id,
	        "label": mcm_account_type.account_type.replaceAll('_', ' '),
	        "value": mcm_account_type.account_type
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "disabled": _vm.account_type == null,
	      "filterable": "",
	      "placeholder": "Select Child DFP Network"
	    },
	    model: {
	      value: (_vm.child_dfp_network),
	      callback: function($$v) {
	        _vm.child_dfp_network = $$v
	      },
	      expression: "child_dfp_network"
	    }
	  }, _vm._l((_vm.filteredAccountList), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.child_network_code +' : ' + network.name)),
	        "value": network.child_network_code
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null && _vm.child_dfp_network == null,
	      "placeholder": "Add DFP Parent Adunit Id"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_id),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_id = $$v
	      },
	      expression: "dfp_parent_ad_unit_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Path")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.account_type == null || _vm.child_dfp_network == null || _vm.dfp_parent_ad_unit_id == 0,
	      "placeholder": "Add DFP Parent Adunit Path"
	    },
	    model: {
	      value: (_vm.dfp_parent_ad_unit_path),
	      callback: function($$v) {
	        _vm.dfp_parent_ad_unit_path = $$v
	      },
	      expression: "dfp_parent_ad_unit_path"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('hr')], 1), _vm._v(" "), (_vm.is_amp) ? _c('div', [_c('h5', [_vm._v("Select Currency for AMP")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.hb_tag.currencyId),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "currencyId", $$v)
	      },
	      expression: "hb_tag.currencyId"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(option) {
	    return _c('el-option', {
	      key: option.id,
	      attrs: {
	        "label": option.code,
	        "value": option.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.isPubUnit) ? _c('div', [_c('h5', [_vm._v("Enter publisher's DFP Ad unit id")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "post_fix",
	      "type": "text",
	      "placeholder": "Enter publisher's DFP Ad unit id",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.hb_tag.pub_dfp_unit_id),
	      callback: function($$v) {
	        _vm.$set(_vm.hb_tag, "pub_dfp_unit_id", $$v)
	      },
	      expression: "hb_tag.pub_dfp_unit_id"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (((_vm.mcm_enabled && _vm.domainMcmEnabled == false) || (_vm.isPubUnit == true && _vm.mcm_enabled == true))) ? _c('div', {
	    staticClass: "mcm-update-error"
	  }, [_vm._v("\n                Remove MCM Network Override to Update this HB Tag\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.isComplete
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-left"
	  }), _vm._v("\n                Update tag\n              ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": (_vm.is_amp) ? ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags-amp/") : ("/admin/publisher/" + (this.pubUuid) + "/domain/" + (this.domId) + "/hb-tags/")
	    }
	  }, [_vm._v("\n                Cancel\n              ")])], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Edit Domain.. (" + _vm._s(_vm.name) + ")")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Publisher")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    on: {
	      "change": function ($event) { return _vm.setPubId(); }
	    },
	    model: {
	      value: (_vm.publisherId),
	      callback: function($$v) {
	        _vm.publisherId = $$v
	      },
	      expression: "publisherId"
	    }
	  }, _vm._l((_vm.publishers), function(pub) {
	    return _c('el-option', {
	      key: pub.name,
	      attrs: {
	        "label": pub.name,
	        "value": pub.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.mcm_enabled) ? _c('div', [_c('h5', [_vm._v("DFP Network")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.pubdetailistid),
	      callback: function($$v) {
	        _vm.pubdetailistid = $$v
	      },
	      expression: "pubdetailistid"
	    }
	  }, _vm._l((_vm.dfpNetworkListAsPerSelectedDfpAccount), function(dfp) {
	    return _c('el-option', {
	      key: dfp.id,
	      attrs: {
	        "label": dfp.display_name,
	        "value": dfp.id
	      }
	    })
	  }), 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Domain URL")]), _vm._v(" "), _c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('div', {
	    staticClass: "el-input-group__prepend",
	    attrs: {
	      "tabindex": "0"
	    }
	  }, [_vm._v("\n                " + _vm._s(!_vm.isSecure ? "http://" : "https://") + "\n              ")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "200",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Domain URL"
	    },
	    model: {
	      value: (_vm.name),
	      callback: function($$v) {
	        _vm.name = $$v
	      },
	      expression: "name"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first("name")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.resetMCM
	    },
	    model: {
	      value: (_vm.mcm_enabled),
	      callback: function($$v) {
	        _vm.mcm_enabled = $$v
	      },
	      expression: "mcm_enabled"
	    }
	  }, [_vm._v("Is sticky Unit?")])], 1)]), _vm._v(" "), (_vm.mcm_enabled) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Select DFP Account")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a DFP"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.dfp_credentials),
	      callback: function($$v) {
	        _vm.dfp_credentials = $$v
	      },
	      expression: "dfp_credentials"
	    }
	  }, _vm._l((_vm.dfpAccounts), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.alias_name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Select Parent DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a Parent DFP Network"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.dfp_network),
	      callback: function($$v) {
	        _vm.dfp_network = $$v
	      },
	      expression: "dfp_network"
	    }
	  }, _vm._l((_vm.getDfpNetworks(_vm.dfp_credentials)), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.network_code +' : ' + network.display_name)),
	        "value": network.id
	      }
	    })
	  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mcm_enabled) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select MCM Delegation Type"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.account_type),
	      callback: function($$v) {
	        _vm.account_type = $$v
	      },
	      expression: "account_type"
	    }
	  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "data-id": id,
	        "label": mcm_account_type.account_type.replaceAll('_', ' '),
	        "value": mcm_account_type.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "disabled": _vm.account_type == null,
	      "filterable": "",
	      "placeholder": "Select Child DFP Network"
	    },
	    model: {
	      value: (_vm.child_dfp_network),
	      callback: function($$v) {
	        _vm.child_dfp_network = $$v
	      },
	      expression: "child_dfp_network"
	    }
	  }, _vm._l((_vm.filteredAccountList), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.child_network_code +' : ' + network.name)),
	        "value": network.id
	      }
	    })
	  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Display parent ad unit id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "parent_ad_unit_id "
	    },
	    model: {
	      value: (_vm.parent_ad_unit_id),
	      callback: function($$v) {
	        _vm.parent_ad_unit_id = $$v
	      },
	      expression: "parent_ad_unit_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Display parent ad unit code")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "parent_ad_unit_code "
	    },
	    model: {
	      value: (_vm.parent_ad_unit_code),
	      callback: function($$v) {
	        _vm.parent_ad_unit_code = $$v
	      },
	      expression: "parent_ad_unit_code"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("AMP parent ad unit id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "amp_parent_ad_unit_id "
	    },
	    model: {
	      value: (_vm.amp_parent_ad_unit_id),
	      callback: function($$v) {
	        _vm.amp_parent_ad_unit_id = $$v
	      },
	      expression: "amp_parent_ad_unit_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("AMP parent ad unit code")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "amp_parent_ad_unit_code "
	    },
	    model: {
	      value: (_vm.amp_parent_ad_unit_code),
	      callback: function($$v) {
	        _vm.amp_parent_ad_unit_code = $$v
	      },
	      expression: "amp_parent_ad_unit_code"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Assertive Yield id")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "get this from Assertive Yield's website"
	    },
	    model: {
	      value: (_vm.assertive_yield_id),
	      callback: function($$v) {
	        _vm.assertive_yield_id = $$v
	      },
	      expression: "assertive_yield_id"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Ad Lightning Script Tag")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Enter Ad Lightning Script Tag"
	    },
	    model: {
	      value: (_vm.ad_lightnings_script_tag),
	      callback: function($$v) {
	        _vm.ad_lightnings_script_tag = $$v
	      },
	      expression: "ad_lightnings_script_tag"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h5', [_vm._v("Fouanalytics Script Tag")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Enter Fouanalytics Script Tag"
	    },
	    model: {
	      value: (_vm.fouanalytics_script_tag),
	      callback: function($$v) {
	        _vm.fouanalytics_script_tag = $$v
	      },
	      expression: "fouanalytics_script_tag"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.isSecure),
	      callback: function($$v) {
	        _vm.isSecure = $$v
	      },
	      expression: "isSecure"
	    }
	  }, [_vm._v("Secure site?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.infinite_scroll),
	      callback: function($$v) {
	        _vm.infinite_scroll = $$v
	      },
	      expression: "infinite_scroll"
	    }
	  }, [_vm._v("Infinite Scroll?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.seller_json),
	      callback: function($$v) {
	        _vm.seller_json = $$v
	      },
	      expression: "seller_json"
	    }
	  }, [_vm._v("Ignore in Sellers.json?")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Seller Id Domain")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.seller_domain_id),
	      callback: function($$v) {
	        _vm.seller_domain_id = $$v
	      },
	      expression: "seller_domain_id"
	    }
	  }, _vm._l((_vm.sellers), function(seller) {
	    return _c('el-option', {
	      key: seller.domain_name,
	      attrs: {
	        "label": seller.domain_name,
	        "value": seller.domain_id,
	        "loading": _vm.sellerLoading
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_c('button', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "type": "submit",
	      "disabled": (_vm.mcm_enabled) ? _vm.account_type == null && _vm.child_dfp_network == null : false
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit el-icon-left"
	  }), _vm._v("\n                Update Domain\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.account_type == null && _vm.child_dfp_network == null
	    },
	    on: {
	      "click": _vm.migrateToMCM
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload el-icon-left"
	  }), _vm._v("\n                Migrate Domain\n              ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/domains/"
	    }
	  }, [_vm._v("\n                Cancel\n              ")])], 1)])])])])])
	},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isPreview),
	      expression: "!isPreview"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-12"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v("Automatad Revenue Share")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max_value:100'),
	      expression: "'required|max_value:100'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('AutomatadRevenueShare')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "AutomatadRevenueShare",
	      "type": "text",
	      "placeholder": "Enter revenue share in percentage like 15%"
	    },
	    model: {
	      value: (_vm.agreemetformdata.revenue_share),
	      callback: function($$v) {
	        _vm.$set(_vm.agreemetformdata, "revenue_share", $$v)
	      },
	      expression: "agreemetformdata.revenue_share"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('AutomatadRevenueShare')),
	      expression: "errors.has('AutomatadRevenueShare')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('AutomatadRevenueShare')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v("Payment Duration")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|numeric'),
	      expression: "'required|numeric'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('days')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "days",
	      "type": "text",
	      "placeholder": "Enter Number of days like 60 Days"
	    },
	    model: {
	      value: (_vm.agreemetformdata.period_to_send_rev_pub),
	      callback: function($$v) {
	        _vm.$set(_vm.agreemetformdata, "period_to_send_rev_pub", $$v)
	      },
	      expression: "agreemetformdata.period_to_send_rev_pub"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('days')),
	      expression: "errors.has('days')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('days')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-md-12",
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v("Payment Explainer Message")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('paymentduration')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "paymentduration",
	      "type": "text",
	      "placeholder": "Enter Payment duration tax"
	    },
	    model: {
	      value: (_vm.agreemetformdata.rev_dist_clarity_example),
	      callback: function($$v) {
	        _vm.$set(_vm.agreemetformdata, "rev_dist_clarity_example", $$v)
	      },
	      expression: "agreemetformdata.rev_dist_clarity_example"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('paymentduration')),
	      expression: "errors.has('paymentduration')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('paymentduration')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v("Termination Duration")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|numeric'),
	      expression: "'required|numeric'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('terminationduration')
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "terminationduration",
	      "type": "text",
	      "placeholder": "Termination Duration like 24 hours"
	    },
	    model: {
	      value: (_vm.agreemetformdata.termination_duration_for_pub),
	      callback: function($$v) {
	        _vm.$set(_vm.agreemetformdata, "termination_duration_for_pub", $$v)
	      },
	      expression: "agreemetformdata.termination_duration_for_pub"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('terminationduration')),
	      expression: "errors.has('terminationduration')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('terminationduration')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-md-12",
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v("Legal Publisher Name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "LegalPublisherName",
	      "type": "text",
	      "placeholder": "Enter Legal Publisher Name"
	    },
	    model: {
	      value: (_vm.agreemetformdata.LegalPublisherName),
	      callback: function($$v) {
	        _vm.$set(_vm.agreemetformdata, "LegalPublisherName", $$v)
	      },
	      expression: "agreemetformdata.LegalPublisherName"
	    }
	  })], 1)])]), _vm._v(" "), _c('agreement', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isPreview),
	      expression: "!isPreview"
	    }],
	    attrs: {
	      "revenuShare": _vm.agreemetformdata.revenue_share,
	      "periodToSendRevPub": _vm.agreemetformdata.period_to_send_rev_pub,
	      "example": _vm.agreemetformdata.rev_dist_clarity_example,
	      "terminationDuration": _vm.agreemetformdata.termination_duration_for_pub,
	      "LegalPublisherName": _vm.agreemetformdata.LegalPublisherName
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    attrs: {
	      "id": "displaypdf"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin": "10px 0 0 0"
	    }
	  }, [(!_vm.isPreview) ? _c('button', {
	    staticClass: "el-button el-button--success",
	    on: {
	      "click": function($event) {
	        return _vm.previewPDF()
	      }
	    }
	  }, [_vm._v("\n                                Preview Contract\n                            ")]) : _c('button', {
	    staticClass: "el-button el-button--success",
	    on: {
	      "click": function($event) {
	        return _vm.editPDF()
	      }
	    }
	  }, [_vm._v("Edit PDF")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--success",
	    on: {
	      "click": function($event) {
	        return _vm.downloadcontract()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download"
	  }), _vm._v("\n                                Download Contract\n                            ")]), _vm._v(" "), (_vm.sendinginvite) ? _c('div', {
	    staticClass: "load-4"
	  }, [_c('div', {
	    staticClass: "ring-1"
	  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger clearfix",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "to": "/admin/Publishers/"
	    }
	  }, [_vm._v("\n                                Cancel\n                            ")])], 1)])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Contract")]), _vm._v(" "), _c('span', {
	    attrs: {
	      "id": "downloadcon"
	    }
	  })])
	}]}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    staticStyle: {
	      "max-width": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "textfield mt-5",
	    staticStyle: {
	      "max-width": "100%"
	    },
	    attrs: {
	      "id": "output"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note),
	      expression: "note"
	    }],
	    staticClass: "input-area w-50 form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Enter your notes here..."
	    },
	    domProps: {
	      "value": (_vm.note)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.note = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "save btn rounded-0",
	    on: {
	      "click": _vm.saveNote
	    }
	  }, [_vm._v("\n      Save\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "notes"
	  }, _vm._l((_vm.notes), function(note, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "notes-div"
	    }, [_c('div', {
	      staticClass: "note-div"
	    }, [_c('span', {
	      staticClass: "note"
	    }, [_vm._v(_vm._s(note.note))]), _vm._v(" "), _c('div', {
	      staticClass: "note-details"
	    }, [_c('div', {
	      staticClass: "time-and-delete"
	    }, [_c('div', {
	      staticClass: "note-owner-and-time"
	    }, [_c('span', {
	      staticClass: "note-owner"
	    }, [_vm._v(_vm._s(note.created_by.first_name + " " + note.created_by.last_name))]), _vm._v(" "), _c('span', {
	      staticClass: "dot"
	    }, [_vm._v(".")]), _vm._v(" "), _c('span', {
	      staticClass: "note-time"
	    }, [_vm._v(_vm._s(_vm._f("moment")(("" + (note.created)), "DD/MM/YY, h:mm a")))])]), _vm._v(" "), _c('div', [_c('span', {
	      staticClass: "remove fa fa-trash-o pointer",
	      on: {
	        "click": function($event) {
	          return _vm.deleteNote(index)
	        }
	      }
	    })])])])])])
	  }), 0), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "margin-top": "25px",
	      "margin-left": "-10px"
	    },
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [10, 20, 50, 100],
	      "total": _vm.total_pages,
	      "layout": "sizes, prev, pager, next",
	      "page-size": _vm.offset
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Edit/create Param sets")]), _vm._v(" "), _c('el-button', {
	    staticClass: "pull-right",
	    attrs: {
	      "disabled": _vm.loading,
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showCreateParamSetDialog = true
	      }
	    }
	  }, [_vm._v("Create Param set")]), _vm._v(" "), _c('el-input', {
	    staticStyle: {
	      "display": "inline-block",
	      "width": "80%",
	      "margin": "0 0 10px 10px"
	    },
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "searchString",
	      "type": "text",
	      "placeholder": "search HB Unit by HB Unit tag (type and enter)"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filterHbparamset()
	      }
	    },
	    model: {
	      value: (_vm.searchString),
	      callback: function($$v) {
	        _vm.searchString = $$v
	      },
	      expression: "searchString"
	    }
	  }), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "content": "clearSearch",
	      "placement": "top"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.clearSearch()
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Clone param set",
	      "visible": _vm.showAliasNameDialog,
	      "width": "40%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showAliasNameDialog = $event
	      }
	    }
	  }, [_c('h5', [_vm._v("Alias name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "text",
	      "rows": 10
	    },
	    model: {
	      value: (_vm.cloneParamSet.alias),
	      callback: function($$v) {
	        _vm.$set(_vm.cloneParamSet, "alias", $$v)
	      },
	      expression: "cloneParamSet.alias"
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("IS AMP?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "disabled": _vm.cloningSet && _vm.cloningSet.is_amp
	    },
	    model: {
	      value: (_vm.cloneParamSet.is_amp),
	      callback: function($$v) {
	        _vm.$set(_vm.cloneParamSet, "is_amp", $$v)
	      },
	      expression: "cloneParamSet.is_amp"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.cloneParamSetSubmit
	    }
	  }, [_vm._v("Create clone")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Input alias name",
	      "visible": _vm.showCreateParamSetDialog,
	      "width": "40%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showCreateParamSetDialog = $event
	      }
	    }
	  }, [_c('h5', [_vm._v("Alias name")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "text",
	      "rows": 10
	    },
	    model: {
	      value: (_vm.newParamSet.alias),
	      callback: function($$v) {
	        _vm.$set(_vm.newParamSet, "alias", $$v)
	      },
	      expression: "newParamSet.alias"
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("IS AMP?")]), _vm._v(" "), _c('el-switch', {
	    model: {
	      value: (_vm.newParamSet.is_amp),
	      callback: function($$v) {
	        _vm.$set(_vm.newParamSet, "is_amp", $$v)
	      },
	      expression: "newParamSet.is_amp"
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("Dimension")]), _vm._v(" "), _c('el-select', {
	    staticClass: "param-set-input select-input",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select dimension"
	    },
	    model: {
	      value: (_vm.newParamSet.dimension),
	      callback: function($$v) {
	        _vm.$set(_vm.newParamSet, "dimension", $$v)
	      },
	      expression: "newParamSet.dimension"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension) {
	    return _c('el-option', {
	      key: dimension.id,
	      attrs: {
	        "label": ((dimension.width) + "X" + (dimension.height)),
	        "value": dimension.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "disabled": !_vm.createParamSetButtonValid,
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.createParamSet
	    }
	  }, [_vm._v("Create Param set")])], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._l((_vm.param_sets), function(param_set) {
	    return _c('div', [_c('el-collapse', {
	      attrs: {
	        "accordion": ""
	      },
	      on: {
	        "change": _vm.handleChange
	      },
	      model: {
	        value: (_vm.activeNames),
	        callback: function($$v) {
	          _vm.activeNames = $$v
	        },
	        expression: "activeNames"
	      }
	    }, [_c('el-collapse-item', {
	      staticClass: "collapse--item",
	      class: {
	        recentlyClosed: _vm.recentlyClosed == param_set.alias,
	          opened: _vm.activeNames == param_set.alias,
	      },
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "title": param_set.alias,
	        "name": param_set.alias
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 7
	      }
	    }, [_c('div', {
	      staticClass: "grid-content"
	    }, [_c('div', [_c('h5', [_vm._v("\n                                                            " + _vm._s(param_set.alias) + " -\n                                                            "), _c('span', {
	      staticClass: "param-type"
	    }, [_vm._v("(" + _vm._s(param_set.is_amp ? 'AMP' : 'Display') + ")")]), (!param_set.id) ? _c('span', {
	      staticStyle: {
	        "color": "red",
	        "font-style": "italic"
	      }
	    }, [_vm._v("* NOT SAVED")]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 12
	      }
	    }, [_c('div', {
	      staticClass: "grid-content",
	      staticStyle: {
	        "overflow": "scroll"
	      }
	    }, [_c('div', {
	      staticClass: "enabled-bidders"
	    }, [_vm._l((_vm.getEnabledBidders(param_set.params)), function(bidder) {
	      return _c('p', [_vm._v("\n                                                            " + _vm._s(bidder) + "\n                                                        ")])
	    }), _vm._v(" "), _c('p', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.getEnabledBidders(param_set.params).length == 0),
	        expression: "getEnabledBidders(param_set.params).length == 0"
	      }],
	      staticStyle: {
	        "color": "#a13333"
	      }
	    }, [_vm._v("\n                                                            No bidders enabled\n                                                        ")])], 2)])]), _vm._v(" "), _c('el-col', {
	      staticStyle: {
	        "padding-left": "10px"
	      },
	      attrs: {
	        "span": 2
	      }
	    }, [_c('div', {
	      staticClass: "grid-content"
	    }, [_c('div', [_c('el-button', {
	      staticClass: "el-button el-button--info",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.cloneDialog(param_set)
	        }
	      }
	    }, [_vm._v("\n                                                            Clone Param Set\n                                                        ")])], 1)])])], 1)], 1), _vm._v(" "), (_vm.activeNames == param_set.alias) ? _c('div', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, _vm._l((param_set.is_amp ? _vm.ampBidders : _vm.bidders), function(bidder) {
	      return ((param_set.is_amp && bidder.amp_enabled) || !param_set.is_amp) ? _c('div', {
	        staticClass: "col-md-12",
	        class: {
	          'bidder-params-box': param_set.params[bidder.code]['enabled'],
	            'bidder-params': true,
	        },
	        staticStyle: {
	          "width": "98%",
	          "left": "1%"
	        }
	      }, [_c('div', [_c('el-checkbox', {
	        attrs: {
	          "name": "bidder[]",
	          "id": ((param_set.id) + "-" + (bidder.code))
	        },
	        model: {
	          value: (param_set.params[bidder.code]['enabled']),
	          callback: function($$v) {
	            _vm.$set(param_set.params[bidder.code], 'enabled', $$v)
	          },
	          expression: "param_set.params[bidder.code]['enabled']"
	        }
	      }, [_vm._v("\n                                                    " + _vm._s(bidder.name) + "\n                                                    ")])], 1), _vm._v(" "), _vm._l((_vm.getBidderFields(bidder, param_set.is_amp)), function(field) {
	        return (param_set.params[bidder.code]['enabled']) ? _c('div', {
	          staticClass: "col-md-4"
	        }, [(field.type == 'text') ? _c('div', {
	          staticClass: "form-group"
	        }, [_c('div', [_c('p', {
	          staticClass: "bold pull-left",
	          attrs: {
	            "for": field.label
	          }
	        }, [_vm._v("\n                                                            " + _vm._s(field.label) + "\n                                                        ")]), _vm._v(" "), _c('input', {
	          directives: [{
	            name: "trim",
	            rawName: "v-trim"
	          }, {
	            name: "model",
	            rawName: "v-model",
	            value: (
	              param_set.params[bidder.code]['bidder_params'][
	                field.name
	              ]
	            ),
	            expression: "\n                                                                param_set.params[bidder.code]['bidder_params'][\n                                                                    field.name\n                                                                ]\n                                                            "
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "text",
	            "id": field.label
	          },
	          domProps: {
	            "value": (
	              param_set.params[bidder.code]['bidder_params'][
	                field.name
	              ]
	            )
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(param_set.params[bidder.code]['bidder_params'],
	                field.name, $event.target.value)
	            }
	          }
	        })])]) : _vm._e(), _vm._v(" "), (field.type == 'number' || field.type == 'float') ? _c('div', {
	          staticClass: "form-group"
	        }, [_c('div', [_c('p', {
	          staticClass: "bold pull-left",
	          attrs: {
	            "for": field.label
	          }
	        }, [_vm._v("\n                                                            " + _vm._s(field.label) + "\n                                                        ")]), _vm._v(" "), _c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (
	              param_set.params[bidder.code]['bidder_params'][
	                field.name
	              ]
	            ),
	            expression: "\n                                                                param_set.params[bidder.code]['bidder_params'][\n                                                                    field.name\n                                                                ]\n                                                            ",
	            modifiers: {
	              "number": true
	            }
	          }],
	          staticClass: "form-control",
	          attrs: {
	            "type": "number",
	            "id": "field.label",
	            "step": "0.01"
	          },
	          domProps: {
	            "value": (
	              param_set.params[bidder.code]['bidder_params'][
	                field.name
	              ]
	            )
	          },
	          on: {
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              _vm.$set(param_set.params[bidder.code]['bidder_params'],
	                field.name, _vm._n($event.target.value))
	            },
	            "blur": function($event) {
	              return _vm.$forceUpdate()
	            }
	          }
	        })])]) : _vm._e()]) : _vm._e()
	      })], 2) : _vm._e()
	    }), 0) : _vm._e(), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "float": "right",
	        "margin": "10px"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.applyTagParamSetBidder(param_set)
	        }
	      }
	    }, [_vm._v("Apply")])], 2)], 1)], 1)
	  }), _vm._v(" "), _c('el-pagination', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "30px"
	    },
	    attrs: {
	      "page-size": _vm.offset,
	      "pager-count": 20,
	      "layout": "prev, pager, next",
	      "total": _vm.total_pages,
	      "current-page": _vm.currentPage
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      },
	      "update:current-page": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  })], 2)])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2 p-t-15"
	  }, [_c('div', [_vm._v("Font-Size")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "clearable": "",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('themeChange', _vm.themeObj)
	      }
	    },
	    model: {
	      value: (_vm.themeObj.font_size),
	      callback: function($$v) {
	        _vm.$set(_vm.themeObj, "font_size", $$v)
	      },
	      expression: "themeObj.font_size"
	    }
	  }, _vm._l((_vm.allFontSizes), function(fontSize, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": fontSize,
	        "value": fontSize
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 p-t-15"
	  }, [_c('div', [_vm._v("Font-Style")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "clearable": "",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('themeChange', _vm.themeObj)
	      }
	    },
	    model: {
	      value: (_vm.themeObj.font_family),
	      callback: function($$v) {
	        _vm.$set(_vm.themeObj, "font_family", $$v)
	      },
	      expression: "themeObj.font_family"
	    }
	  }, _vm._l((_vm.googleFontList), function(font, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "label": ("" + (font.text)),
	        "value": font.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-15"
	  }, [_c('div', {
	    staticClass: "col-md-2 atd-theme-group"
	  }, [_c('div', [_vm._v("Font Color")]), _vm._v(" "), _c('swatch', {
	    staticStyle: {
	      "width": "50px",
	      "height": "42px"
	    },
	    attrs: {
	      "colors": "text-advanced",
	      "popover-to": "top",
	      "show-fallback": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$emit('themeChange', _vm.themeObj)
	      }
	    },
	    model: {
	      value: (_vm.themeObj.font_color),
	      callback: function($$v) {
	        _vm.$set(_vm.themeObj, "font_color", $$v)
	      },
	      expression: "themeObj.font_color"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 atd-theme-group"
	  }, [_c('div', [_vm._v("CTA Color")]), _vm._v(" "), _c('swatch', {
	    staticStyle: {
	      "width": "50px",
	      "height": "42px"
	    },
	    attrs: {
	      "colors": "text-advanced",
	      "popover-to": "top",
	      "show-fallback": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$emit('themeChange', _vm.themeObj)
	      }
	    },
	    model: {
	      value: (_vm.themeObj.cta_color),
	      callback: function($$v) {
	        _vm.$set(_vm.themeObj, "cta_color", $$v)
	      },
	      expression: "themeObj.cta_color"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 atd-theme-group"
	  }, [_c('div', [_vm._v("Background Color")]), _vm._v(" "), _c('swatch', {
	    staticStyle: {
	      "width": "50px",
	      "height": "42px"
	    },
	    attrs: {
	      "colors": "text-advanced",
	      "show-fallback": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$emit('themeChange', _vm.themeObj)
	      }
	    },
	    model: {
	      value: (_vm.themeObj.background_color),
	      callback: function($$v) {
	        _vm.$set(_vm.themeObj, "background_color", $$v)
	      },
	      expression: "themeObj.background_color"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body reports-admin-panel"
	  }, [_c('div', [_c('h3', {
	    staticClass: "atd-box-title"
	  }, [_vm._v("Site Name alias")]), _vm._v(" "), [_c('el-radio', {
	    attrs: {
	      "label": "1"
	    },
	    model: {
	      value: (_vm.radio),
	      callback: function($$v) {
	        _vm.radio = $$v
	      },
	      expression: "radio"
	    }
	  }, [_vm._v("Upload CSV")]), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": "2"
	    },
	    model: {
	      value: (_vm.radio),
	      callback: function($$v) {
	        _vm.radio = $$v
	      },
	      expression: "radio"
	    }
	  }, [_vm._v("Add single entry")]), _vm._v(" "), (_vm.radio == '1') ? _c('div', {
	    staticClass: "dis-flex"
	  }, [_c('div', {
	    staticClass: "p-r-10"
	  }, [_vm._v("upload csv format:")]), _c('JsonCSV', {
	    staticClass: "data--csv",
	    attrs: {
	      "data": _vm.jsonData,
	      "name": "site-name-alias-format.csv"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.radio == '2') ? _c('div', {
	    staticClass: "atd-add-remove-container"
	  }, [_c('div', {
	    staticClass: "atd-add-new-field"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.addNewField
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdd +\n\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _vm._l((_vm.fields_alias), function(formField, index) {
	    return _c('div', {
	      staticClass: "dis-flex"
	    }, [_c('el-button', {
	      staticClass: "flex-order-3 atd-remove-new-field",
	      attrs: {
	        "icon": "el-icon-remove-outline"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removeField(index)
	        }
	      }
	    }), _vm._v(" "), _c('el-input', {
	      staticClass: "col-md-6 col-sm-6 col-xs-12 atd-input-alias",
	      attrs: {
	        "name": "fields_alias[][alias]",
	        "placeholder": "alias",
	        "clearable": ""
	      },
	      model: {
	        value: (formField.alias),
	        callback: function($$v) {
	          _vm.$set(formField, "alias", $$v)
	        },
	        expression: "formField.alias"
	      }
	    }), _vm._v(" "), _c('el-select', {
	      staticClass: "col-md-6 col-sm-6 col-xs-12 atd-input-site",
	      attrs: {
	        "name": "fields_alias[][site]",
	        "filterable": "",
	        "placeholder": "site"
	      },
	      model: {
	        value: (formField.site),
	        callback: function($$v) {
	          _vm.$set(formField, "site", $$v)
	        },
	        expression: "formField.site"
	      }
	    }, _vm._l((_vm.publishersList), function(item) {
	      return _c('el-option', {
	        key: item,
	        attrs: {
	          "label": item,
	          "value": item
	        }
	      })
	    }), 1)], 1)
	  }), _vm._v(" "), (_vm.fields_alias.length > 0) ? _c('el-button', {
	    staticClass: "text-right",
	    on: {
	      "click": function($event) {
	        return _vm.saveAliasData()
	      }
	    }
	  }, [_vm._v("Save")]) : _vm._e()], 2) : _c('div', {
	    staticClass: "text-right",
	    staticStyle: {
	      "max-width": "900px",
	      "margin": "0 auto"
	    }
	  }, [_c('el-upload', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.uploading),
	      expression: "uploading"
	    }],
	    ref: "upload",
	    staticClass: "upload-demo m-t-20",
	    attrs: {
	      "drag": "",
	      "limit": 1,
	      "action": "reports/v1/upload/",
	      "auto-upload": false,
	      "http-request": _vm.upload,
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__text"
	  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.submitUpload
	    }
	  }, [_vm._v("Submit")])], 1)], _vm._v(" "), [_c('el-table', {
	    staticClass: "atd-dfp-report",
	    attrs: {
	      "data": _vm.siteAliasList,
	      "height": "250"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "alias_site_name",
	      "label": "Alias Site Name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "site",
	      "label": "Site"
	    }
	  })], 1)]], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Reports Settings")])])
	}]}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Select Publisher")]), _vm._v(" "), _c('p', [_vm._v("Choose publisher from the dropdown or create one by clicking +add publisher")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setPubUid()
	      }
	    },
	    model: {
	      value: (_vm.pubId),
	      callback: function($$v) {
	        _vm.pubId = $$v
	      },
	      expression: "pubId"
	    }
	  }, _vm._l((_vm.publishers), function(pub) {
	    return _c('el-option', {
	      key: pub.name,
	      attrs: {
	        "data-id": pub.uuid,
	        "label": pub.name,
	        "value": pub.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('router-link', {
	    staticClass: "el-button--info m-t-15",
	    attrs: {
	      "to": "/admin/publisher/add"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                Create Publisher\n                            ")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Domain URL")]), _vm._v(" "), _c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('div', {
	    staticClass: "el-input-group__prepend",
	    attrs: {
	      "tabindex": "0",
	      "title": "We support BOTH !!"
	    }
	  }, [_vm._v("\n                                    " + _vm._s(!_vm.isSecure ? 'http://' : 'http(s)://') + "\n                                ")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "200",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Domain URL"
	    },
	    model: {
	      value: (_vm.name),
	      callback: function($$v) {
	        _vm.name = $$v
	      },
	      expression: "name"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h5', [_vm._v("Infinite Scroll?")]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-15"
	  }, [_c('el-switch', {
	    attrs: {
	      "active-color": "#13ce66"
	    },
	    model: {
	      value: (_vm.infinitescroll),
	      callback: function($$v) {
	        _vm.infinitescroll = $$v
	      },
	      expression: "infinitescroll"
	    }
	  })], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Select DFP Account")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a DFP"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.dfp_credentials),
	      callback: function($$v) {
	        _vm.dfp_credentials = $$v
	      },
	      expression: "dfp_credentials"
	    }
	  }, _vm._l((_vm.dfpAccounts), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.alias_name,
	        "value": item.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', [_c('h5', [_vm._v("Select DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select a DFP Network"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.dfp_network),
	      callback: function($$v) {
	        _vm.dfp_network = $$v
	      },
	      expression: "dfp_network"
	    }
	  }, _vm._l((_vm.getDfpNetworks(_vm.dfp_credentials)), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.network_code + ' : ' + network.display_name)),
	        "value": network.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "inactive-text": "",
	      "active-color": "#13ce66",
	      "inactive-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.resetMCM
	    },
	    model: {
	      value: (_vm.mcm_enabled),
	      callback: function($$v) {
	        _vm.mcm_enabled = $$v
	      },
	      expression: "mcm_enabled"
	    }
	  }, [_vm._v("Is sticky Unit?")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined && _vm.mcm_enabled == true) ? _c('div', {
	    staticStyle: {
	      "padding": "10px 0 20px 0"
	    }
	  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select MCM Delegation Type"
	    },
	    on: {
	      "change": _vm.filterNetworkList
	    },
	    model: {
	      value: (_vm.account_type),
	      callback: function($$v) {
	        _vm.account_type = $$v
	      },
	      expression: "account_type"
	    }
	  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
	    return _c('el-option', {
	      key: id,
	      attrs: {
	        "data-id": id,
	        "label": mcm_account_type.account_type.replaceAll('_', ' '),
	        "value": mcm_account_type.id
	      }
	    })
	  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined && _vm.mcm_enabled == true) ? _c('div', [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "disabled": _vm.account_type == null,
	      "filterable": "",
	      "placeholder": "Select Child DFP Network"
	    },
	    model: {
	      value: (_vm.child_dfp_network),
	      callback: function($$v) {
	        _vm.child_dfp_network = $$v
	      },
	      expression: "child_dfp_network"
	    }
	  }, _vm._l((_vm.filteredAccountList), function(network) {
	    return _c('el-option', {
	      key: network.id,
	      attrs: {
	        "label": ("" + (network.child_network_code + ' : ' + network.name)),
	        "value": network.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', [_c('h5', [_vm._v("Parent Ad Unit Id (Display)")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: ('required|alpha'),
	      expression: "'required|alpha'",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('parentAdUnitId')
	    },
	    attrs: {
	      "type": "number",
	      "onkeypress": "return event.charCode >= 48",
	      "min": "1",
	      "placeholder": "Parent Ad Unit Id from DFP for display"
	    },
	    model: {
	      value: (_vm.parentAdUnitId),
	      callback: function($$v) {
	        _vm.parentAdUnitId = $$v
	      },
	      expression: "parentAdUnitId"
	    }
	  }), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('parentAdUnitId')),
	      expression: "errors.has('parentAdUnitId')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('parentAdUnitId')),
	      expression: "errors.has('parentAdUnitId')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('parentAdUnitId')))]), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', [_c('h5', [_vm._v("Parent Ad Unit Path (Display)")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "placeholder": "Parent Ad Unit Code from DFP for display"
	    },
	    model: {
	      value: (_vm.parentAdUnitCode),
	      callback: function($$v) {
	        _vm.parentAdUnitCode = $$v
	      },
	      expression: "parentAdUnitCode"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', [_c('h5', [_vm._v("Parent Ad Unit Id (AMP)")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate.initial",
	      value: ('required|alpha'),
	      expression: "'required|alpha'",
	      modifiers: {
	        "initial": true
	      }
	    }],
	    class: {
	      input: true, 'is-danger': _vm.errors.has('parentAdUnitIdAmp')
	    },
	    attrs: {
	      "type": "number",
	      "onkeypress": "return event.charCode >= 48",
	      "min": "1",
	      "placeholder": "Parent Ad Unit Id from DFP for AMP"
	    },
	    model: {
	      value: (_vm.parentAdUnitIdAmp),
	      callback: function($$v) {
	        _vm.parentAdUnitIdAmp = $$v
	      },
	      expression: "parentAdUnitIdAmp"
	    }
	  }), _vm._v(" "), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('parentAdUnitIdAmp')),
	      expression: "errors.has('parentAdUnitIdAmp')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('parentAdUnitIdAmp')),
	      expression: "errors.has('parentAdUnitIdAmp')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('parentAdUnitIdAmp')))]), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.dfp_credentials != undefined) ? _c('div', [_c('h5', [_vm._v("Parent Ad Unit Path(AMP)")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "placeholder": "Parent Ad Unit Code from DFP for AMP"
	    },
	    model: {
	      value: (_vm.parentAdUnitCodeAmp),
	      callback: function($$v) {
	        _vm.parentAdUnitCodeAmp = $$v
	      },
	      expression: "parentAdUnitCodeAmp"
	    }
	  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Seller Id Domain")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.domain_id),
	      callback: function($$v) {
	        _vm.domain_id = $$v
	      },
	      expression: "domain_id"
	    }
	  }, _vm._l((_vm.sellers), function(seller) {
	    return _c('el-option', {
	      key: seller.domain_name,
	      attrs: {
	        "label": seller.domain_name,
	        "value": seller.domain_id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "clearfix m-t-15"
	  }, [_c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.formValid
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                            Create Domain\n                        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/domains/"
	    }
	  }, [_vm._v(" Cancel ")])], 1)], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Domain")])])
	}]}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Publisher Reports Approval")]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success",
	      "icon": "el-icon-upload"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmReUpload("updated", _vm.report_date)
	      }
	    }
	  }, [_vm._v("Re - Upload Report")]), _vm._v(" "), (_vm.getOverAllReportStatus(_vm.report_date) == 'Approved') ? _c('el-button', {
	    staticClass: "approve-all-reports",
	    attrs: {
	      "type": "success",
	      "icon": _vm.approveAllBtn
	    },
	    on: {
	      "click": function($event) {
	        return _vm.approveAllData(_vm.report_date, $event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.getOverAllReportStatus(_vm.report_date)))]) : _c('el-button', {
	    staticClass: "approve-all-reports",
	    attrs: {
	      "type": "primary",
	      "icon": _vm.approveAllBtn
	    },
	    on: {
	      "click": function($event) {
	        return _vm.approveAllData(_vm.report_date, $event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.getOverAllReportStatus(_vm.report_date)))])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body p-b-15",
	    staticStyle: {
	      "max-height": "80vh",
	      "overflow": "auto"
	    }
	  }, [(_vm.publisherDomainList.length != 0) ? _c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    }
	  }, _vm._l((_vm.publisherDomainList), function(data) {
	    return _c('el-collapse-item', {
	      staticClass: "collapse--item",
	      attrs: {
	        "title": data.publisher,
	        "name": data.publisher
	      }
	    }, _vm._l((data.domains), function(i, index) {
	      return (_vm.getFilteredReport(_vm.reportData, i).length > 0) ? _c('div', [_c('el-collapse', {
	        attrs: {
	          "accordion": ""
	        }
	      }, [_c('el-collapse-item', {
	        staticClass: "collapse--item"
	      }, [_c('template', {
	        slot: "title"
	      }, [_c('div', {
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReport for " + _vm._s(i) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
	        staticStyle: {
	          "width": "100%",
	          "border-spacing": "0"
	        },
	        attrs: {
	          "data": _vm.getFilteredReport(_vm.reportData, i),
	          "id": ""
	        }
	      }, [_c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Report Date"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getFormattedDate(props.row.date)) + "\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Site",
	          "prop": "site"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Dimension",
	          "prop": "dimension"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder",
	          "prop": "bidder"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder Impression",
	          "prop": "bidder_impression"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder Revenue",
	          "prop": "bidder_revenue"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP Impression",
	          "prop": "dfp_impression"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP Revenue",
	          "prop": "dfp_revenue"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder eCPM"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getRoundedNumbers((props.row.bidder_revenue / props.row.bidder_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP eCPM"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getRoundedNumbers((props.row.dfp_revenue / props.row.dfp_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      })], 1), _vm._v(" "), _c('div', {
	        staticClass: "container"
	      }, [_c('div', {
	        staticClass: "row"
	      }, [_c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('h5', [_vm._v("DFP Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_impression')))])]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('h5', [_vm._v("Bidder Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_impression')))])]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('div', [_c('h5', [_vm._v("Exchange Rate for USD to " + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0]) + ": ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getExchangeRate(_vm.currencyArr, i)[1]))])]), _vm._v(" "), _c('div', [_c('el-button', {
	        attrs: {
	          "type": "success",
	          "icon": _vm.approveBtn
	        },
	        on: {
	          "click": function($event) {
	            return _vm.approveData(i, _vm.report_date, $event)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.getReportApprovalStatus(i)))])], 1)])])])], 2)], 1)], 1) : _vm._e()
	    }), 0)
	  }), 1) : _c('div', {
	    staticClass: "p-t-20 p-t-5"
	  }, [_vm._v("No data available")]), _vm._v(" "), _c('el-dialog', {
	    staticClass: "report-upload-popup",
	    attrs: {
	      "visible": _vm.UploadScreenVisible,
	      "before-close": _vm.clearFilesList
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.UploadScreenVisible = $event
	      }
	    }
	  }, [_c('span', {
	    staticClass: "el-dialog__title text-center"
	  }, [_vm._v("Upload updated report for " + _vm._s(_vm.report_date))]), _vm._v(" "), _c('el-upload', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.uploading),
	      expression: "uploading"
	    }],
	    ref: "upload",
	    staticClass: "upload-demo m-t-20",
	    attrs: {
	      "drag": "",
	      "limit": 1,
	      "action": "reports/v1/upload/",
	      "auto-upload": false,
	      "http-request": _vm.upload,
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__text"
	  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__text",
	    attrs: {
	      "slot": "tip"
	    },
	    slot: "tip"
	  }, [_vm._v("Upload modified DFP + Bidder Report")])]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.cancelUploadAction
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.submitUpload
	    }
	  }, [_vm._v("Upload Report")])], 1)], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "buckets"
	  }, [_c('ul', {
	    staticClass: "bucket-list clearfix"
	  }, _vm._l((_vm.separatedArray), function(singleWord, index) {
	    return _c('li', {
	      key: index,
	      staticClass: "shadowBox"
	    }, [_c('span', [_vm._v("\n                                    " + _vm._s(singleWord) + "\n                                    "), _c('i', {
	      staticClass: "fa fa-remove design-d design-delete",
	      on: {
	        "click": function($event) {
	          return _vm.deleteSingleWordSingle(singleWord)
	        }
	      }
	    })])])
	  }), 0)])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywordsData),
	      expression: "keywordsData"
	    }],
	    staticStyle: {
	      "border": "1px solid black",
	      "padding": "10px"
	    },
	    attrs: {
	      "placeholder": "Enter keywords",
	      "rows": "4",
	      "cols": "150"
	    },
	    domProps: {
	      "value": (_vm.keywordsData)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keywordsData = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addData
	    }
	  }, [_vm._v("Submit")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "box-title"
	  }, [_c('b', [_vm._v("Blocked Keywords")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "box-title"
	  }, [_c('b', [_vm._v("Please add domain specific keywords entries here")])])
	}]}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v(_vm._s((_vm.domId) ? 'Edit' : 'Create') + " Domain")])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.onSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('h5', [_vm._v("Select Publisher")]), _vm._v(" "), (!_vm.domId) ? _c('p', [_vm._v("Choose publisher from the dropdown or create one by clicking +add publisher")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setPubUid()
	      }
	    },
	    model: {
	      value: (_vm.pubId),
	      callback: function($$v) {
	        _vm.pubId = $$v
	      },
	      expression: "pubId"
	    }
	  }, _vm._l((_vm.publishers), function(pub) {
	    return _c('el-option', {
	      key: pub.name,
	      attrs: {
	        "data-id": pub.uuid,
	        "label": pub.name,
	        "value": pub.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (!_vm.domId) ? _c('div', {
	    staticClass: "col-md-3 m-t-7"
	  }, [_c('router-link', {
	    staticClass: "el-button--info m-t-15",
	    attrs: {
	      "to": "/admin/bidders/create-publisher/"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                Create Publisher\n                            ")])], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h5', [_vm._v("Domain URL\n                                "), (!_vm.domId) ? _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.addToCoreDomain),
	      callback: function($$v) {
	        _vm.addToCoreDomain = $$v
	      },
	      expression: "addToCoreDomain"
	    }
	  }, [_vm._v("Add to Yeti Domains")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "el-input el-input-group el-input-group--prepend"
	  }, [_c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    class: {
	      'input': true, 'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "data-vv-delay": "200",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Domain URL"
	    },
	    model: {
	      value: (_vm.name),
	      callback: function($$v) {
	        _vm.name = $$v
	      },
	      expression: "name"
	    }
	  })], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("RTC Currency")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select RTC Currency"
	    },
	    model: {
	      value: (_vm.rtcCurrency),
	      callback: function($$v) {
	        _vm.rtcCurrency = $$v
	      },
	      expression: "rtcCurrency"
	    }
	  }, _vm._l((_vm.currenciesOptions), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.code,
	        "value": item.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "demand-switch flex-col"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "flex-col-demandswitch"
	  }, [_c('div', {
	    staticClass: "flex-sa-m",
	    staticStyle: {
	      "width": "65%"
	    }
	  }, [_c('strong', {
	    staticStyle: {
	      "margin-right": "15px"
	    }
	  }, [_vm._v(" Web:")]), _vm._v(" "), _c('div', {
	    staticClass: "flex-col-c"
	  }, [_c('div', [_vm._v("Bing")]), _vm._v(" "), _c('el-input-number', {
	    staticStyle: {
	      "width": "120px"
	    },
	    attrs: {
	      "min": 0,
	      "max": 100,
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.handleWebBing,
	      "input": _vm.handleWebBing
	    },
	    model: {
	      value: (_vm.bing_web),
	      callback: function($$v) {
	        _vm.bing_web = $$v
	      },
	      expression: "bing_web"
	    }
	  })], 1), _vm._v(" "), _c('el-slider', {
	    staticStyle: {
	      "width": "20%"
	    },
	    attrs: {
	      "show-tooltip": false
	    },
	    on: {
	      "change": _vm.handleWebGoogle
	    },
	    model: {
	      value: (_vm.web_traffic),
	      callback: function($$v) {
	        _vm.web_traffic = $$v
	      },
	      expression: "web_traffic"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex-col-c"
	  }, [_c('div', [_vm._v("Google")]), _vm._v(" "), _c('el-input-number', {
	    staticStyle: {
	      "width": "120px"
	    },
	    attrs: {
	      "min": 0,
	      "max": 100,
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.handleWebGoogle,
	      "input": _vm.handleWebGoogle
	    },
	    model: {
	      value: (_vm.web_traffic),
	      callback: function($$v) {
	        _vm.web_traffic = $$v
	      },
	      expression: "web_traffic"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex-sa-m",
	    staticStyle: {
	      "width": "65%",
	      "margin-top": "5%"
	    }
	  }, [_c('strong', [_vm._v(" Mobile:")]), _vm._v(" "), _c('div', {
	    staticClass: "flex-col-c"
	  }, [_c('div', [_vm._v("Bing")]), _vm._v(" "), _c('el-input-number', {
	    staticStyle: {
	      "width": "120px"
	    },
	    attrs: {
	      "min": 0,
	      "max": 100,
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.handleMobileBing,
	      "input": _vm.handleMobileBing
	    },
	    model: {
	      value: (_vm.bing_mobile),
	      callback: function($$v) {
	        _vm.bing_mobile = $$v
	      },
	      expression: "bing_mobile"
	    }
	  })], 1), _vm._v(" "), _c('el-slider', {
	    staticStyle: {
	      "width": "20%"
	    },
	    attrs: {
	      "show-tooltip": false
	    },
	    on: {
	      "change": _vm.handleWebGoogle
	    },
	    model: {
	      value: (_vm.mobile_traffic),
	      callback: function($$v) {
	        _vm.mobile_traffic = $$v
	      },
	      expression: "mobile_traffic"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex-col-c"
	  }, [_c('div', [_vm._v("Google")]), _vm._v(" "), _c('el-input-number', {
	    staticStyle: {
	      "width": "120px"
	    },
	    attrs: {
	      "min": 0,
	      "max": 100,
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.handleMobileGoogle,
	      "input": _vm.handleMobileGoogle
	    },
	    model: {
	      value: (_vm.mobile_traffic),
	      callback: function($$v) {
	        _vm.mobile_traffic = $$v
	      },
	      expression: "mobile_traffic"
	    }
	  })], 1)], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Keyword config")]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Keyword config"
	    },
	    model: {
	      value: (_vm.kwConfigVal),
	      callback: function($$v) {
	        _vm.kwConfigVal = $$v
	      },
	      expression: "kwConfigVal"
	    }
	  }, _vm._l((_vm.KeywordOptions), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('h5', [_vm._v("Theme Settings\n                                    "), _c('el-tooltip', {
	    staticClass: "item",
	    attrs: {
	      "effect": "dark",
	      "content": "Reset theme",
	      "placement": "bottom"
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--secondary el-button--mini",
	    staticStyle: {
	      "marginLeft": "5px",
	      "borderRadius": "50%",
	      "padding": "3px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.theme = {}
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-refresh"
	  })])])], 1)])]), _vm._v(" "), _c('theme', {
	    attrs: {
	      "themeData": _vm.theme
	    },
	    on: {
	      "themeChange": _vm.updateThemeObj
	    }
	  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [(!_vm.domId) ? _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.formValid
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                            Create Domain\n                        ")]) : _c('button', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.formValid
	    }
	  }, [_vm._v("\n                            Update Domain\n                        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": "/admin/bidders/"
	    }
	  }, [_vm._v("\n                            Cancel\n                        ")])], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex-l-m"
	  }, [_c('div', {
	    staticStyle: {
	      "margin-right": "15px"
	    }
	  }, [_vm._v("Demand Switch:")])])
	}]}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box-body",
	    staticStyle: {
	      "max-height": "500px",
	      "overflow": "auto"
	    }
	  }, [_c('el-upload', {
	    ref: "upload",
	    staticClass: "upload-demo m-t-20",
	    attrs: {
	      "drag": "",
	      "action": "reports/v1/upload/",
	      "auto-upload": false,
	      "http-request": _vm.upload,
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList,
	      "limit": 1
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-upload"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__text"
	  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer text-right p-t-15 p-b-15",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.cancelUploadAction
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.submitUpload
	    }
	  }, [_vm._v("Upload Report")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
	    staticClass: "p-b-12"
	  }, [_vm._v("Updated Report")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.tableLoading),
	      expression: "tableLoading"
	    }]
	  }, [(_vm.publisherDomainList.length != 0) ? _c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    }
	  }, [_vm._l((_vm.publisherDomainList), function(data) {
	    return _c('el-collapse-item', {
	      staticClass: "collapse--item",
	      attrs: {
	        "title": data.publisher,
	        "name": data.publisher
	      }
	    }, _vm._l((data.domains), function(i, index) {
	      return _c('div', [_c('el-collapse', {
	        attrs: {
	          "accordion": ""
	        }
	      }, [_c('el-collapse-item', {
	        staticClass: "collapse--item"
	      }, [_c('template', {
	        slot: "title"
	      }, [_c('div', {
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReport for " + _vm._s(i) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
	        directives: [{
	          name: "loading",
	          rawName: "v-loading",
	          value: (_vm.loading),
	          expression: "loading"
	        }],
	        staticStyle: {
	          "width": "100%",
	          "border-spacing": "0"
	        },
	        attrs: {
	          "data": _vm.getFilteredReport(_vm.reportData, i),
	          "id": "",
	          "height": "450"
	        }
	      }, [_c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Report Date"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getFormattedDate(props.row.date)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Site",
	          "prop": "site"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Dimension",
	          "prop": "dimension"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder",
	          "prop": "bidder"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder Impression",
	          "prop": "bidder_impression"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder Revenue",
	          "prop": "bidder_revenue"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP Impression",
	          "prop": "dfp_impression"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP Revenue",
	          "prop": "dfp_revenue"
	        }
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "Bidder eCPM"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.dfp_currency + ". " + _vm.getRoundedNumbers((props.row.bidder_revenue / props.row.bidder_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      }), _vm._v(" "), _c('el-table-column', {
	        staticClass: "text-center",
	        attrs: {
	          "label": "DFP eCPM"
	        },
	        scopedSlots: _vm._u([{
	          key: "default",
	          fn: function(props) {
	            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.dfp_currency + ". " + _vm.getRoundedNumbers((props.row.dfp_revenue / props.row.dfp_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
	          }
	        }], null, true)
	      })], 1), _vm._v(" "), _c('div', {
	        staticClass: "container"
	      }, [_c('div', {
	        staticClass: "row"
	      }, [_c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('h5', [_vm._v("DFP Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_impression')))])]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('h5', [_vm._v("Bidder Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_impression')))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
	        staticClass: "col-md-4 col-sm-6 col-xs-12"
	      }, [_c('div', [_c('h5', [_vm._v("exchange rate for usd to inr: ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getExchangeRate(_vm.currencyArr, i)))])]), _vm._v(" "), _c('div', [_c('el-button', {
	        attrs: {
	          "type": "success",
	          "icon": _vm.approveBtn
	        },
	        on: {
	          "click": function($event) {
	            return _vm.approveData(i, _vm.report_date, $event)
	          }
	        }
	      }, [_vm._v("Approve Report")])], 1)])])])], 2)], 1)], 1)
	    }), 0)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-right p-t-15 p-b-15"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "success",
	      "icon": _vm.approveBtn
	    },
	    on: {
	      "click": function($event) {
	        return _vm.approveAllData(_vm.report_date, $event)
	      }
	    }
	  }, [_vm._v("Approve Complete Report")])], 1)], 2) : _c('div', [_vm._v("No data available")])], 1)], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border heading-cart"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Publisher Reports Approval")])])
	}]}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-r-15"
	  }, [_c('div', {
	    staticStyle: {
	      "border": "1px solid #878d99",
	      "padding": "10px",
	      "background": "white",
	      "margin-bottom": "20px"
	    }
	  }, [_c('h4', [_vm._v("Event Data (Last 24 hours) ")]), _vm._v(" "), _c('h6', [_c('i', [_c('b', [_vm._v("Last Updated")]), _vm._v(" - " + _vm._s(_vm.currentTime) + " (PST/PDT)")])]), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.eventLoader),
	      expression: "eventLoader"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border": "1px solid #878d99",
	      "padding": "5px"
	    },
	    attrs: {
	      "data": _vm.eventData,
	      "height": "250"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "timeslot",
	      "label": "Time",
	      "width": "170"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "requests",
	      "label": "Requests"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "bids",
	      "label": "Bids"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "rejects",
	      "label": "Rejects"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "wins",
	      "label": "Wins"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "invalid_wins",
	      "label": "Invalid Wins"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "sib_impressions",
	      "label": "SIB Impressions",
	      "width": "150"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "serp_clicks",
	      "label": "SERP Clicks"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "spend",
	      "label": "Spend"
	    }
	  })], 1), _vm._v(" "), _c('h4', [_vm._v("Revenue Data (Last 24 hours)")]), _vm._v(" "), _c('h6', [_c('i', [_c('b', [_vm._v("Last Updated")]), _vm._v(" - " + _vm._s(_vm.currentTime) + " (PST/PDT)")])]), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.revenueLoader),
	      expression: "revenueLoader"
	    }],
	    staticStyle: {
	      "width": "100%",
	      "border": "1px solid #878d99",
	      "padding": "5px"
	    },
	    attrs: {
	      "data": _vm.revenueData,
	      "height": "250"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "timeslot",
	      "label": "Time",
	      "width": "170"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "clicks",
	      "label": "Clicks"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "revenue",
	      "label": "Revenue"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "rpc",
	      "label": "RPC"
	    }
	  })], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border",
	    staticStyle: {
	      "display": "flex",
	      "padding": "0 30px 0 30px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "flex": "auto"
	    }
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.siteDetails.url) ? _c('div', [_vm._v("\n                              Line Items For the Domain:\n                              "), _c('a', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    },
	    attrs: {
	      "href": _vm.siteDetails.url,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.siteDetails.url))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [(_vm.siteDetails.publisher) ? _c('div', [_vm._v("\n                              Publisher:\n                              "), _c('a', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    }
	  }, [_vm._v(_vm._s(_vm.siteDetails.publisher))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "flex": "none",
	      "display": "flex",
	      "align-items": "end"
	    }
	  }, [(_vm.allLineItems.length > 0 && _vm.siteDetails.currency && _vm.siteDetails.currency.code) ? _c('h3', {
	    staticClass: "box-title",
	    staticStyle: {
	      "margin-top": "7px"
	    }
	  }, [_vm._v("\n                          RTC Currency: " + _vm._s(_vm.siteDetails.currency.code) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "pull-right",
	    staticStyle: {
	      "margin-left": "10px",
	      "margin-top": "7px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.showExportParamas
	    }
	  }, [_vm._v("Export Params")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "atd-tags"
	  }, [_c('div', {
	    staticClass: "flex-sb"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v("Tags:")]), _vm._v(" "), _c('div', [_c('el-button', {
	    staticClass: "pull-right",
	    staticStyle: {
	      "margin": "10px 0px 10px 10px"
	    },
	    attrs: {
	      "type": "success",
	      "disabled": _vm.allLineItems.filter(function (k) {
	        return k.type.includes('tag');
	      }).length == 0
	    },
	    on: {
	      "click": _vm.showExportTags
	    }
	  }, [_vm._v("Export Tag")]), _vm._v(" "), _c('el-button', {
	    staticClass: "pull-right",
	    staticStyle: {
	      "margin": "10px 0"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.showCreateTagDialogfunction($event)
	      }
	    }
	  }, [_vm._v("Create Tag")])], 1)]), _vm._v(" "), (
	    _vm.allLineItems.length > 0 &&
	    _vm.allLineItems.filter(function (k) {
	      return k.type.includes('tag');
	    }).length > 0
	  ) ? _c('div', _vm._l((_vm.allLineItems), function(item, index) {
	    return (item.type.includes('tag')) ? _c('div', {
	      key: index,
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.lineitemDivClick($event)
	        }
	      }
	    }, [_c('div', {
	      class: [
	        item.suspend || item.budget_exhausted ?
	        'isSuspendedTrueClass' :
	        'isSuspendedFalseClass' ]
	    }, [(_vm.siteDetails && (item.type !== 'unitag' && _vm.siteDetails['placement_targeting_' + item.type.toLowerCase()] && item.placement_text.length == 0)) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "width": "100%",
	        "display": "flex",
	        "justify-content": "center",
	        "color": "red"
	      }
	    }, [_vm._v("\n                                          *disabled(No placement targeting enabled)\n                                      ")]) : _vm._e(), _vm._v(" "), (_vm.siteDetails && _vm.siteDetails['position_targeting_' + item.type.toLowerCase()] && item.positions.length == 0) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "width": "100%",
	        "display": "flex",
	        "justify-content": "center",
	        "color": "red"
	      }
	    }, [_vm._v("\n                                          *disabled(No position targeting enabled)\n                                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.lineitemHeadingClick(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px",
	        "word-break": "break-word"
	      }
	    }, [_vm._v("\n                                                  Line item : " + _vm._s(item.name) + "\n                                              ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "litype"
	      }
	    }, [_vm._v("\n                                                  Type : " + _vm._s(item.type) + "\n                                              ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "bidcpm"
	      }
	    }, [_vm._v("\n                                                  Bid CPM Range : "), _c('br'), _vm._v(_vm._s(item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $') + "\n                                              ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "budget"
	      }
	    }, [_vm._v("\n                                                  Budget : " + _vm._s((item.budget || '') + ' $') + "\n                                              ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [(item.budget_exhausted == true) ? _c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	      staticStyle: {
	        "background": "white",
	        "color": "black",
	        "border": "1px solid black",
	        "padding": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.resumeExhaustedLineItem($event, item)
	        }
	      }
	    }, [_vm._v("\n                                                  Resume\n                                              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      }
	    }, [_c('el-switch', {
	      attrs: {
	        "active-color": "#13ce66",
	        "inactive-color": "#ff4949"
	      },
	      on: {
	        "change": function($event) {
	          return _vm.lineitemStatus(item)
	        }
	      },
	      model: {
	        value: (item.active),
	        callback: function($$v) {
	          _vm.$set(item, "active", $$v)
	        },
	        expression: "item.active"
	      }
	    })], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 text-center"
	    }, [_c('el-tooltip', {
	      attrs: {
	        "content": "Duplicate Tag",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showDuplicateLineitemDialogfunction($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-copy",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 text-center"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px",
	        "display": "flex",
	        "justify-content": "space-around"
	      }
	    }, [_c('el-tooltip', {
	      attrs: {
	        "content": "Notes",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.createLineItemNotes($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-sticky-note",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), _c('el-tooltip', {
	      attrs: {
	        "content": "Edit Lineitem",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editLineitem($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), (item.suspend == true) ? _c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	      staticStyle: {
	        "background": "white",
	        "color": "black",
	        "border": "1px solid black",
	        "padding": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.resumeStage($event, item)
	        }
	      }
	    }, [_vm._v("\n                                                      Resume\n                                                  ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-tabs', {
	      attrs: {
	        "type": "border-card"
	      },
	      on: {
	        "tab-click": function($event) {
	          return _vm.lineitemHeadingClick(item)
	        }
	      },
	      model: {
	        value: (_vm.activeName),
	        callback: function($$v) {
	          _vm.activeName = $$v
	        },
	        expression: "activeName"
	      }
	    }, [_c('el-tab-pane', {
	      attrs: {
	        "label": "Details",
	        "name": 'first_' + item.xid
	      }
	    }, [_c('LineItemDetails', {
	      attrs: {
	        "dimensions": _vm.dimensions,
	        "item": item,
	        "devices": _vm.devices,
	        "browsers": _vm.browsers,
	        "changeItemFormat": _vm.changeItemFormat,
	        "countries": _vm.countries,
	        "creativeList": _vm.creativeList
	      }
	    })], 1), _vm._v(" "), _c('el-tab-pane', {
	      attrs: {
	        "label": "Data",
	        "name": 'second_' + item.xid
	      }
	    }, [_c('LineItemData', {
	      attrs: {
	        "eventLoader": _vm.isEventLoading,
	        "revenueLoader": _vm.isRevenueLoading,
	        "eventData": _vm.tableDataEvent,
	        "revenueData": _vm.tableDataRevenue,
	        "currentTime": _vm.timeNow
	      }
	    })], 1)], 1)], 1)]) : _vm._e()
	  }), 0) : _c('div', [_vm._v("No Tags Created")])]), _vm._v(" "), _c('div', {
	    staticClass: "atd-placements"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin": "0 0 10px 0",
	      "display": "flex",
	      "align-items": "center",
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v("Line Items:")]), _vm._v(" "), _c('span', [_vm._v("No. of LineItems : " + _vm._s(_vm.allLineItems.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('el-button', {
	    staticClass: "pull-right",
	    attrs: {
	      "type": "success",
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.showCreateLineitemDialogfunction($event)
	      }
	    }
	  }, [_vm._v("Create Line Item")])], 1)]), _vm._v(" "), _vm._l((_vm.allLineItems), function(item) {
	    return (!item.type.includes('tag')) ? _c('div', {
	      key: item.id,
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          return _vm.lineitemDivClick($event)
	        }
	      }
	    }, [_c('div', {
	      class: [
	        item.suspend || item.budget_exhausted ?
	        'isSuspendedTrueClass' :
	        'isSuspendedFalseClass' ]
	    }, [(_vm.siteDetails && _vm.siteDetails['placement_targeting_' + item.type.toLowerCase()] && item.placement_text.length == 0) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "width": "100%",
	        "display": "flex",
	        "justify-content": "center",
	        "color": "red"
	      }
	    }, [_vm._v("\n                                      *disabled(No placement targeting enabled)\n                                  ")]) : _vm._e(), _vm._v(" "), (_vm.siteDetails && _vm.siteDetails['position_targeting_' + item.type.toLowerCase()] && item.positions.length == 0) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "width": "100%",
	        "display": "flex",
	        "justify-content": "center",
	        "color": "red"
	      }
	    }, [_vm._v("\n                                      *disabled(No position targeting enabled)\n                                  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.lineitemHeadingClick(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px",
	        "word-break": "break-word"
	      }
	    }, [_vm._v("\n                                              Line item : " + _vm._s(item.name) + "\n                                          ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "litype"
	      }
	    }, [_vm._v("Type : " + _vm._s(item.type))])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "bidcpm"
	      }
	    }, [_vm._v("\n                                              Bid CPM Range : "), _c('br'), _vm._v("\n                                              " + _vm._s(item.bid_cpm_min + ' $ - ' + item.bid_cpm_max + ' $') + "\n                                          ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      },
	      attrs: {
	        "id": "budget"
	      }
	    }, [_vm._v("\n                                              Budget : " + _vm._s((item.budget || '') + ' $') + "\n                                          ")])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [(item.budget_exhausted == true) ? _c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	      staticStyle: {
	        "background": "white",
	        "color": "black",
	        "border": "1px solid black",
	        "padding": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.resumeExhaustedLineItem($event, item)
	        }
	      }
	    }, [_vm._v("\n                                              Resume\n                                          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      }
	    }, [_c('el-switch', {
	      attrs: {
	        "active-color": "#13ce66",
	        "inactive-color": "#ff4949"
	      },
	      on: {
	        "change": function($event) {
	          return _vm.lineitemStatus(item)
	        }
	      },
	      model: {
	        value: (item.active),
	        callback: function($$v) {
	          _vm.$set(item, "active", $$v)
	        },
	        expression: "item.active"
	      }
	    })], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 text-center"
	    }, [_c('el-tooltip', {
	      attrs: {
	        "content": "Duplicate Lineitem",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showDuplicateLineitemDialogfunction($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-copy",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 text-center"
	    }, [_c('div', {
	      staticStyle: {
	        "margin-bottom": "10px",
	        "display": "flex",
	        "justify-content": "space-around"
	      }
	    }, [_c('el-tooltip', {
	      attrs: {
	        "content": "Notes",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.createLineItemNotes($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-sticky-note",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), _c('el-tooltip', {
	      attrs: {
	        "content": "Edit Lineitem",
	        "placement": "bottom"
	      }
	    }, [_c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small",
	      staticStyle: {
	        "background": "none",
	        "color": "black"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.editLineitem($event, item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-pencil",
	      staticStyle: {
	        "font-size": "17px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), (item.suspend == true) ? _c('button', {
	      staticClass: "el-button notes-box el-button--text el-button--small forcontract",
	      staticStyle: {
	        "background": "white",
	        "color": "black",
	        "border": "1px solid black",
	        "padding": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.resumeStage($event, item)
	        }
	      }
	    }, [_vm._v("\n                                                  Resume\n                                              ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	      staticClass: "p-r-15"
	    }, [_c('el-tabs', {
	      attrs: {
	        "type": "border-card"
	      },
	      on: {
	        "tab-click": function($event) {
	          return _vm.lineitemHeadingClick(item)
	        }
	      },
	      model: {
	        value: (_vm.activeName),
	        callback: function($$v) {
	          _vm.activeName = $$v
	        },
	        expression: "activeName"
	      }
	    }, [_c('el-tab-pane', {
	      attrs: {
	        "label": "Details",
	        "name": 'first_' + item.xid
	      }
	    }, [_c('LineItemDetails', {
	      attrs: {
	        "dimensions": _vm.dimensions,
	        "item": item,
	        "devices": _vm.devices,
	        "browsers": _vm.browsers,
	        "changeItemFormat": _vm.changeItemFormat,
	        "countries": _vm.countries,
	        "creativeList": _vm.creativeList
	      }
	    })], 1), _vm._v(" "), _c('el-tab-pane', {
	      attrs: {
	        "label": "Data",
	        "name": 'second_' + item.xid
	      }
	    }, [_c('LineItemData', {
	      attrs: {
	        "eventLoader": _vm.isEventLoading,
	        "revenueLoader": _vm.isRevenueLoading,
	        "eventData": _vm.tableDataEvent,
	        "revenueData": _vm.tableDataRevenue,
	        "currentTime": _vm.timeNow
	      }
	    })], 1)], 1)], 1)])]) : _vm._e()
	  }), _vm._v(" "), (_vm.allLineItems.length == 0) ? _c('div', [_c('h5', [_vm._v("Line items are not created")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt line-item-dialog",
	    attrs: {
	      "title": "Notes",
	      "visible": _vm.showCreateLineItemNotes,
	      "width": "40%",
	      "before-close": _vm.handleCloseLineItemNotes
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showCreateLineItemNotes = $event
	      }
	    }
	  }, [_c('line-item-notes', {
	    attrs: {
	      "lineItemId": _vm.selectedItem
	    }
	  })], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt line-item-dialog",
	    attrs: {
	      "title": "Line item",
	      "visible": _vm.showCreateLineitemDialog,
	      "width": "40%",
	      "before-close": _vm.handleCloseLineitem
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showCreateLineitemDialog = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Enter LineItem Name"
	    },
	    model: {
	      value: (_vm.createLineItemForm.name),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "name", $$v)
	      },
	      expression: "createLineItemForm.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Is Universal Tag?")]), _vm._v(" "), _c('el-switch', {
	    staticClass: "col-md-12",
	    model: {
	      value: (_vm.isUniTag),
	      callback: function($$v) {
	        _vm.isUniTag = $$v
	      },
	      expression: "isUniTag"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Enable")]), _vm._v(" "), _c('el-switch', {
	    staticClass: "col-md-12",
	    model: {
	      value: (_vm.createLineItemForm.active),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "active", $$v)
	      },
	      expression: "createLineItemForm.active"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Vertical:")]), _vm._v(" "), _c('el-select', {
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.createLineItemForm.vertical),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "vertical", $$v)
	      },
	      expression: "createLineItemForm.vertical"
	    }
	  }, _vm._l((_vm.placementVertical), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), (!_vm.createLineItemForm.type.includes('tag')) ? _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Type:")]), _vm._v(" "), _c('el-select', {
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select"
	    },
	    on: {
	      "change": _vm.setDevicesForAMP
	    },
	    model: {
	      value: (_vm.createLineItemForm.type),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "type", $$v)
	      },
	      expression: "createLineItemForm.type"
	    }
	  }, _vm._l((_vm.placementType), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Geo")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Country",
	      "name": "Country",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.validateUnique('country')
	      }
	    },
	    model: {
	      value: (_vm.selectedCountries),
	      callback: function($$v) {
	        _vm.selectedCountries = $$v
	      },
	      expression: "selectedCountries"
	    }
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('el-option', {
	      key: country.id,
	      attrs: {
	        "label": country.name,
	        "value": country.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Country')),
	      expression: "errors.has('Country')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Country')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Device")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Device",
	      "name": "Devices"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.validateUnique('device')
	      }
	    },
	    model: {
	      value: (_vm.selectedDevices),
	      callback: function($$v) {
	        _vm.selectedDevices = $$v
	      },
	      expression: "selectedDevices"
	    }
	  }, _vm._l((_vm.devices), function(device) {
	    return _c('el-option', {
	      key: device.id,
	      attrs: {
	        "label": device.name,
	        "value": device.id,
	        "disabled": _vm.disabledDevice.indexOf(device.id) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Devices')),
	      expression: "errors.has('Devices')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Devices')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Browser")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Browsers",
	      "name": "Browsers"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.validateUnique('browser')
	      }
	    },
	    model: {
	      value: (_vm.selectedBrowsers),
	      callback: function($$v) {
	        _vm.selectedBrowsers = $$v
	      },
	      expression: "selectedBrowsers"
	    }
	  }, _vm._l((_vm.browsers), function(browser) {
	    return _c('el-option', {
	      key: browser.id,
	      attrs: {
	        "label": browser.name,
	        "value": browser.id,
	        "disabled": _vm.disabledBrowser.indexOf(browser.id) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Browsers')),
	      expression: "errors.has('Browsers')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Browsers')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Dimension")]), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', [_c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select Dimensions",
	      "name": "Dimensions",
	      "multiple": "",
	      "multiple-limit": 1,
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        _vm.validateUnique('dimension');
	        _vm.getAllPositionsForDimension($event);
	      },
	      "remove-tag": function($event) {
	        return _vm.updateCreativeList(_vm.createLineItemForm, $event)
	      }
	    },
	    model: {
	      value: (_vm.selectedDimensions),
	      callback: function($$v) {
	        _vm.selectedDimensions = $$v
	      },
	      expression: "selectedDimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": ((dimension.width) + "X" + (dimension.height)),
	        "value": dimension.id,
	        "disabled": _vm.disabledSize.indexOf(dimension.id) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Dimensions')),
	      expression: "errors.has('Dimensions')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Dimensions')))])], 1) : _c('div', [_c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select Dimensions",
	      "name": "Dimensions",
	      "multiple": "",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        _vm.validateUnique('dimension');
	        _vm.getAllPositionsForDimension($event);
	      },
	      "remove-tag": function($event) {
	        return _vm.updateCreativeList(_vm.createLineItemForm, $event)
	      }
	    },
	    model: {
	      value: (_vm.selectedDimensions),
	      callback: function($$v) {
	        _vm.selectedDimensions = $$v
	      },
	      expression: "selectedDimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": ((dimension.width) + "X" + (dimension.height)),
	        "value": dimension.id,
	        "disabled": _vm.disabledSize.indexOf(dimension.id) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Dimensions')),
	      expression: "errors.has('Dimensions')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Dimensions')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Creatives ("), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://scripts.atmtd.com/sib_preview/"
	    }
	  }, [_vm._v("Preview")]), _vm._v(")")]), _vm._v(" "), (_vm.selectedDimensions.length > 0) ? _c('div', _vm._l((_vm.selectedDimensions), function(dim, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "m-t-15 m-b-15"
	    }, [_c('div', {
	      staticClass: "dis-flex"
	    }, [_c('span', {
	      staticStyle: {
	        "width": "75px"
	      }
	    }, [_vm._v(_vm._s(_vm.dimensions.length &&
	      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].width +
	      'X' +
	      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].height) + "\n                              -\n                          ")]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "68%"
	      }
	    }, [_c('el-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-12",
	      attrs: {
	        "placeholder": "Select Creative",
	        "name": "Creatives",
	        "filterable": ""
	      },
	      on: {
	        "change": function($event) {
	          return _vm.addCreativeToLineItem(_vm.createLineItemForm, index)
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.creativeIds[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creativeIds, index, $$v)
	        },
	        expression: "createLineItemForm.creativeIds[index]"
	      }
	    }, _vm._l((_vm.getCreativeList(dim)), function(creative, idx) {
	      return _c('el-option', {
	        key: idx,
	        attrs: {
	          "label": creative.name,
	          "value": creative.id
	        }
	      })
	    }), 1)], 1)]), _vm._v(" "), (_vm.createLineItemForm.creative.length > index && _vm.createLineItemForm.creative[index]) ? _c('div', {
	      staticClass: "dis-flex"
	    }, [_c('span', {
	      staticStyle: {
	        "width": "75px"
	      }
	    }), _vm._v(" "), (_vm.createLineItemForm.creative[index].isS2S == true) ? _c('div', {
	      staticStyle: {
	        "width": "68%",
	        "padding": "0 15px"
	      }
	    }, [_vm._v("\n                              Tag ID :"), _c('el-input', {
	      model: {
	        value: (_vm.createLineItemForm.creative[index].tagId),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "tagId", $$v)
	        },
	        expression: "createLineItemForm.creative[index].tagId"
	      }
	    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
	      _vm.createLineItemForm.creative.length > index &&
	      _vm.createLineItemForm.creative[index] &&
	      _vm.createLineItemForm.creative[index].modify == true
	    ) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "border-bottom": "1px solid #ececec",
	        "padding-bottom": "19px"
	      }
	    }, [_c('div', {
	      staticClass: "col-md-3 p-t-15"
	    }, [_c('div', [_vm._v("Modified creative name:")]), _vm._v(" "), _c('el-input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|alpha_dash'),
	        expression: "'required|alpha_dash'"
	      }],
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "name",
	        "type": "text",
	        "placeholder": "Enter Creative Name"
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].name),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "name", $$v)
	        },
	        expression: "createLineItemForm.creative[index].name"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 p-t-15"
	    }, [_c('div', [_vm._v("Font-Size:")]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "filterable": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].font_size),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "font_size", $$v)
	        },
	        expression: "createLineItemForm.creative[index].font_size"
	      }
	    }, _vm._l((_vm.allFontSizes), function(fontSize, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": fontSize,
	          "value": fontSize
	        }
	      })
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', [_vm._v("Font Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].font_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "font_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].font_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', [_vm._v("CTA Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].cta_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "cta_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].cta_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', [_vm._v("Background Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].background_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "background_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].background_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "creative-save-btn"
	    }, [_c('el-button', {
	      staticStyle: {
	        "margin-top": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.saveCreative(_vm.createLineItemForm.creative[index], index)
	        }
	      }
	    }, [_vm._v("Save")])], 1)]) : _vm._e()])
	  }), 0) : _c('div', [_vm._v("Select a dimension for creative association")])]), _vm._v(" "), (!_vm.isUniTag) ? _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Placement")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.placements), function(data, index) {
	    return _c('div', {
	      key: (index + "positioninput"),
	      staticClass: "col-md-12 dis-flex"
	    }, [_c('el-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-3",
	      staticStyle: {
	        "padding": "0 5px 5px 0"
	      },
	      attrs: {
	        "clearable": "",
	        "placeholder": "Select an Operator",
	        "name": "Operator",
	        "reserve-keyword": "",
	        "allow-create": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('placements')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('placements')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.placements[index].operator),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.placements[index], "operator", $$v)
	        },
	        expression: "createLineItemForm.placements[index].operator"
	      }
	    }, _vm._l(([
	      ['Starts With', 'starts_with'],
	      ['Ends With', 'ends_with'],
	      ['Contains', 'contains'],
	      ['Equals', 'equals'],
	      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": operator[0],
	          "value": operator[1]
	        }
	      })
	    }), 1), _vm._v(" "), _c('el-input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-11",
	      staticStyle: {
	        "margin": "0 5px 0 0",
	        "padding": "0px 5px 5px 5px"
	      },
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "placementName",
	        "type": "text",
	        "placeholder": "Enter Placement Name"
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('placements')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('placements')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.placements[index].data),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.placements[index], "data", $$v)
	        },
	        expression: "createLineItemForm.placements[index].data"
	      }
	    }), _vm._v(" "), (index === _vm.createLineItemForm.placements.length - 1) ? _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "secondary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addNewItem(index, 'placements');
	          _vm.convertObjToRegex('placements');
	        }
	      }
	    }, [_vm._v("OR")]) : _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.createLineItemForm.placements.splice(index, 1);
	          _vm.convertObjToRegex('placements');
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])], 1)
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Position")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.positions), function(data, index) {
	    return _c('div', {
	      key: (index + "positioninput"),
	      staticClass: "col-md-12 dis-flex"
	    }, [_c('el-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-3",
	      staticStyle: {
	        "padding": "0 5px 5px 0"
	      },
	      attrs: {
	        "clearable": "",
	        "placeholder": "Select an Operator",
	        "name": "Operator",
	        "reserve-keyword": "",
	        "allow-create": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('positions')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('positions')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.positions[index].operator),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.positions[index], "operator", $$v)
	        },
	        expression: "createLineItemForm.positions[index].operator"
	      }
	    }, _vm._l(([
	      ['Starts With', 'starts_with'],
	      ['Ends With', 'ends_with'],
	      ['Contains', 'contains'],
	      ['Equals', 'equals'],
	      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": operator[0],
	          "value": operator[1]
	        }
	      })
	    }), 1), _vm._v(" "), _c('el-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-11",
	      staticStyle: {
	        "margin": "0 5px 0 0",
	        "padding": "0px 5px 5px 5px"
	      },
	      attrs: {
	        "clearable": "",
	        "allow-create": "",
	        "remote": "",
	        "remote-method": _vm.positionFilter,
	        "placeholder": "Select or Add Position",
	        "name": "Positions",
	        "loading": _vm.positionsListLoading,
	        "reserve-keyword": "",
	        "filterable": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('positions')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('positions')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.positions[index].data),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.positions[index], "data", $$v)
	        },
	        expression: "createLineItemForm.positions[index].data"
	      }
	    }, _vm._l((_vm.posOptions), function(pos, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": pos,
	          "value": pos
	        }
	      })
	    }), 1), _vm._v(" "), (index === _vm.createLineItemForm.positions.length - 1) ? _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "secondary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addNewItem(index, 'positions');
	          _vm.convertObjToRegex('positions');
	        }
	      }
	    }, [_vm._v("OR")]) : _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.createLineItemForm.positions.splice(index, 1);
	          _vm.convertObjToRegex('positions');
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])], 1)
	  })], 2), _vm._v(" "), (_vm.createLineItemForm.type.includes('tag')) ? _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Bid CPM(USD):")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|decimal:6'),
	      expression: "'required|decimal:6'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Bid CPM(USD):",
	      "rows": 10,
	      "placeholder": "Enter ECPM"
	    },
	    model: {
	      value: (_vm.createLineItemForm.bid_cpm_min),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "bid_cpm_min", $$v)
	      },
	      expression: "createLineItemForm.bid_cpm_min"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Bid CPM(USD) Min:')),
	      expression: "errors.has('Bid CPM(USD) Min:')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Min:')))])], 1) : _c('div', [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Bid CPM(USD) Min:")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|decimal:6'),
	      expression: "'required|decimal:6'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Bid CPM(USD) Min:",
	      "rows": 10,
	      "placeholder": "Enter Min ECPM"
	    },
	    model: {
	      value: (_vm.createLineItemForm.bid_cpm_min),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "bid_cpm_min", $$v)
	      },
	      expression: "createLineItemForm.bid_cpm_min"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Bid CPM(USD) Min:')),
	      expression: "errors.has('Bid CPM(USD) Min:')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Min:')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Bid CPM(USD) Max:")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|decimal:6'),
	      expression: "'required|decimal:6'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Bid CPM(USD) Max:",
	      "rows": 10,
	      "placeholder": "Enter Max ECPM"
	    },
	    model: {
	      value: (_vm.createLineItemForm.bid_cpm_max),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "bid_cpm_max", $$v)
	      },
	      expression: "createLineItemForm.bid_cpm_max"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Bid CPM(USD) Max:')),
	      expression: "errors.has('Bid CPM(USD) Max:')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Max:')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Budget (USD):")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|decimal:6'),
	      expression: "'required|decimal:6'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Budget (USD):",
	      "rows": 10,
	      "placeholder": "Enter Line item budget (USD)"
	    },
	    model: {
	      value: (_vm.createLineItemForm.budget),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "budget", $$v)
	      },
	      expression: "createLineItemForm.budget"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Budget (USD):')),
	      expression: "errors.has('Budget (USD):')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Budget (USD):')))])], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.isEditLineitem) ? _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createLineItem($event)
	      }
	    }
	  }, [_vm._v("Create Line item")]) : _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createLineItem($event)
	      }
	    }
	  }, [_vm._v("Save")])], 1)]), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Export Params",
	      "visible": _vm.showExportParamsDialog,
	      "width": "40%",
	      "before-close": _vm.handleCloseParama
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showExportParamsDialog = $event
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "paramsDivId"
	    }
	  }, [_c('div', [_c('h4', [_vm._v("Prebid Params:")]), _vm._v(" "), _c('h5', [_vm._v("siteId : " + _vm._s(this.siteDetails.uuid))]), _vm._v(" "), (_vm.allLineItems.length !== 0) ? _c('h5', [_vm._v("Placements:")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.mappedLineItemsByType['prebid']), function(lItem, index) {
	    return (lItem.placement_text.length) ? _c('div', {
	      key: index,
	      staticStyle: {
	        "list-style-type": "inherit"
	      }
	    }, [(lItem.placement_text && lItem.placement_text.length) ? _c('ol', {
	      staticStyle: {
	        "margin": "0"
	      }
	    }, _vm._l((_vm.changeItemFormat(lItem.placement_text[0])), function(divt, index) {
	      return _c('li', {
	        key: index
	      }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
	        staticClass: "p-l-20"
	      }, [_vm._v("Operator: " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                  " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
	    }), 0) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), (_vm.mappedLineItemsByType['AMP'] && _vm.mappedLineItemsByType['AMP'].length > 0) ? _c('div', [(_vm.mappedLineItemsByType['prebid'] && _vm.mappedLineItemsByType['prebid'].length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("RTC Urls:")])]) : _vm._e(), _vm._v(" "), _c('ol', {
	    staticClass: "m-l-20"
	  }, _vm._l((_vm.mappedLineItemsByType['AMP']), function(lItem, index) {
	    return _c('li', {
	      key: index,
	      staticStyle: {
	        "list-style-type": "inherit"
	      }
	    }, [(lItem.positions.length == 0) ? _c('div', [_vm._v("\n                          Name: " + _vm._s(lItem.placement_text[0] || '') + "\n                          "), _c('div', {
	      staticStyle: {
	        "word-break": "break-word",
	        "border-bottom": "1px solid #ececec"
	      }
	    }, [_vm._v("\n                              " + _vm._s(_vm.siteDetails.currency ?
	      _vm.rtcUrl
	      .replace('SITEID', _vm.siteDetails.uuid)
	      .replace('PLACEMENTID', lItem.placement_text[0] || '')
	      .replace('POSITION', '')
	      .replace('CURRENCY', _vm.siteDetails.currency.code) :
	      _vm.rtcUrl
	      .replace('SITEID', _vm.siteDetails.uuid)
	      .replace('POSITION', '')
	      .replace('PLACEMENTID', lItem.placement_text[0] || '')
	      .split('&cur')[0]) + "\n                          ")])]) : _vm._l((_vm.changeItemFormat(lItem.positions)), function(pos, id) {
	      return _c('div', {
	        key: id
	      }, [_vm._v("\n                          Name:\n                          " + _vm._s(lItem.placement_text[0] + ' - ' + pos.data ? pos.data : pos) + "\n                          "), _c('div', {
	        staticStyle: {
	          "word-break": "break-word",
	          "border-bottom": "1px solid #ececec"
	        }
	      }, [_vm._v("\n                              " + _vm._s(_vm.siteDetails.currency ?
	        _vm.rtcUrl
	        .replace('SITEID', _vm.siteDetails.uuid)
	        .replace('PLACEMENTID', lItem.placement_text[0])
	        .replace('POSITION', pos.data ? pos.data[0] : pos)
	        .replace('CURRENCY', _vm.siteDetails.currency.code) :
	        _vm.rtcUrl
	        .replace('SITEID', _vm.siteDetails.uuid)
	        .replace('POSITION', pos.data ? pos.data[0] : pos)
	        .replace('PLACEMENTID', lItem.placement_text[0])
	        .split('&cur')[0]) + "\n                          ")])])
	    })], 2)
	  }), 0)], 2), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.copiedToClipboardparams
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-clipboard",
	    staticStyle: {
	      "color": "white"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              Copy To Clipboard\n          ")])], 1), _vm._v(" "), _c('el-dialog', {
	    staticClass: "element-promt",
	    attrs: {
	      "title": "Export Tags",
	      "visible": _vm.showExportTagDialog,
	      "width": "40%",
	      "before-close": _vm.handleCloseTags
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showExportTagDialog = $event
	      }
	    }
	  }, [(_vm.tagSelectPosOptions.length > 0) ? _c('div', [_c('div', {
	    attrs: {
	      "id": "paramsDivId"
	    }
	  }, _vm._l((_vm.tagSelectPosOptions), function(i, index) {
	    return _c('div', {
	      key: index
	    }, [_vm._v("\n                      " + _vm._s(index + 1) + ". size:\n                      " + _vm._s(_vm.dimensions.filter(function (k) {
	        return k.id == i.size;
	      })[0].width +
	      'x' +
	      _vm.dimensions.filter(function (k) {
	        return k.id == i.size;
	      })[0].height) + ", position: " + _vm._s(i.positions) + ", placement: " + _vm._s(i.placement) + "\n                      "), _c('pre', {
	      ref: "tag-code",
	      refInFor: true,
	      staticClass: "tag-code border border-gray-100",
	      staticStyle: {
	        "font-size": "12px",
	        "margin-top": "0",
	        "border-bottom-left-radius": "4px",
	        "border-bottom-right-radius": "4px"
	      }
	    }, [_c('code', {
	      staticClass: "language-html"
	    }, [_vm._v("\n<script src=\"" + _vm._s('https://scripts.atmtd.com/js/tag.js?cb=%%CACHEBUSTER%%') + "\" async></script>\n<script>\n      window.tagData = {};\n      tagData.siteID = \"" + _vm._s(_vm.siteDetails.uuid) + "\";\n      tagData.position = \"" + _vm._s(i.positions) + "\";\n      tagData.size = \"" + _vm._s(_vm.dimensions.filter(function (k) {
	      return k.id == i.size
	    })[0].width + 'x' + _vm.dimensions.filter(function (k) {
	      return k.id == i.size
	    })[0].height) + "\";\n      tagData.placement = \"" + _vm._s(i.placement && "/*** Add placement params manually. ***/") + "\";\n      try {\n        (function(){var intr=window.setInterval(function(){if(window.atmtdTag){window.clearInterval(intr);new atmtdTag(window.tagData);}});})();\n      }\n      catch (e) {\n        console.log(e);\n      }\n</script>")])])])
	  }), 0), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": _vm.copiedToClipboardparams
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-clipboard",
	    staticStyle: {
	      "color": "white"
	    },
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                  Copy To Clipboard\n              ")])], 1) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "box-body"
	  }, [_c('form', {
	    staticClass: "form",
	    attrs: {
	      "method": "post"
	    }
	  }, [_c('h5', [_vm._v("Select Publisher")]), _vm._v(" "), _c('p', [_vm._v("Choose publisher from the dropdown or create one by clicking +add publisher")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setPubUid()
	      }
	    },
	    model: {
	      value: (_vm.pubId),
	      callback: function($$v) {
	        _vm.pubId = $$v
	      },
	      expression: "pubId"
	    }
	  }, _vm._l((_vm.publishers), function(pub) {
	    return _c('el-option', {
	      key: pub.name,
	      attrs: {
	        "data-id": pub.uuid,
	        "label": pub.name,
	        "value": pub.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "btn"
	  }, [_c('router-link', {
	    staticClass: "el-button--info m-t-15",
	    attrs: {
	      "to": "/admin/bidders/create-publisher/"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus el-icon-left"
	  }), _vm._v("\n                                Create Publisher\n                            ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "domain-div"
	  }, [_c('h5', [_vm._v("Select Domain")]), _c('el-checkbox', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pubId),
	      expression: "pubId"
	    }],
	    staticClass: "domain-checkbox",
	    attrs: {
	      "checked": _vm.handleChecked(),
	      "value": _vm.checkedAllDomains,
	      "label": "Select All",
	      "size": "large"
	    },
	    on: {
	      "input": _vm.handleCheckAllDomains
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select",
	      "filterable": "",
	      "multiple": "",
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.domId),
	      callback: function($$v) {
	        _vm.domId = $$v
	      },
	      expression: "domId"
	    }
	  }, _vm._l((_vm.domains), function(dom) {
	    return _c('el-option', {
	      key: dom.id,
	      attrs: {
	        "data-id": dom.uuid,
	        "label": dom.url,
	        "value": dom.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "data-vv-delay": "1000",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Enter LineItem Name"
	    },
	    model: {
	      value: (_vm.createLineItemForm.name),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "name", $$v)
	      },
	      expression: "createLineItemForm.name"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Enable")]), _vm._v(" "), _c('el-switch', {
	    staticClass: "col-md-12",
	    model: {
	      value: (_vm.createLineItemForm.active),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "active", $$v)
	      },
	      expression: "createLineItemForm.active"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Vertical:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.createLineItemForm.vertical),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "vertical", $$v)
	      },
	      expression: "createLineItemForm.vertical"
	    }
	  }, _vm._l((_vm.placementVertical), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Type:")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select"
	    },
	    on: {
	      "change": _vm.setDevicesForAMP
	    },
	    model: {
	      value: (_vm.selectedTypes),
	      callback: function($$v) {
	        _vm.selectedTypes = $$v
	      },
	      expression: "selectedTypes"
	    }
	  }, _vm._l((_vm.placementType), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Geo")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Country",
	      "name": "Country",
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.selectedCountries),
	      callback: function($$v) {
	        _vm.selectedCountries = $$v
	      },
	      expression: "selectedCountries"
	    }
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('el-option', {
	      key: country.id,
	      attrs: {
	        "label": country.name,
	        "value": country.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Country')),
	      expression: "errors.has('Country')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Country')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Device")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Device",
	      "name": "Devices"
	    },
	    model: {
	      value: (_vm.selectedDevices),
	      callback: function($$v) {
	        _vm.selectedDevices = $$v
	      },
	      expression: "selectedDevices"
	    }
	  }, _vm._l((_vm.devices), function(device) {
	    return _c('el-option', {
	      key: device.id,
	      attrs: {
	        "label": device.name,
	        "value": device.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Devices')),
	      expression: "errors.has('Devices')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Devices')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Browser")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "param-set-input select-input col-md-12",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select Browsers",
	      "name": "Browsers"
	    },
	    model: {
	      value: (_vm.selectedBrowsers),
	      callback: function($$v) {
	        _vm.selectedBrowsers = $$v
	      },
	      expression: "selectedBrowsers"
	    }
	  }, _vm._l((_vm.browsers), function(browser) {
	    return _c('el-option', {
	      key: browser.id,
	      attrs: {
	        "label": browser.name,
	        "value": browser.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Browsers')),
	      expression: "errors.has('Browsers')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Browsers')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Dimension")]), _vm._v(" "), _c('div', [_c('el-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "col-md-12",
	    attrs: {
	      "placeholder": "Select Dimensions",
	      "name": "Dimensions",
	      "multiple": "",
	      "filterable": ""
	    },
	    on: {
	      "change": function($event) {
	        return _vm.getAllPositionsForDimension(_vm.selectedDimensions);
	      },
	      "remove-tag": function($event) {
	        return _vm.updateCreativeList(_vm.createLineItemForm, $event)
	      }
	    },
	    model: {
	      value: (_vm.selectedDimensions),
	      callback: function($$v) {
	        _vm.selectedDimensions = $$v
	      },
	      expression: "selectedDimensions"
	    }
	  }, _vm._l((_vm.dimensions), function(dimension, index) {
	    return _c('el-option', {
	      key: index,
	      attrs: {
	        "label": ((dimension.width) + "X" + (dimension.height)),
	        "value": dimension.id,
	        "disabled": _vm.disabledSize.indexOf(dimension.id) > -1
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Dimensions')),
	      expression: "errors.has('Dimensions')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Dimensions')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [(_vm.selectedDimensions.length > 0) ? _c('div', _vm._l((_vm.selectedDimensions), function(dim, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "m-t-15 m-b-15"
	    }, [_c('div', {
	      staticClass: "dis-flex"
	    }, [_c('span', {
	      staticStyle: {
	        "width": "75px",
	        "margin-top": "10px"
	      }
	    }, [_vm._v(_vm._s(_vm.dimensions.length &&
	      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].width +
	      'X' +
	      _vm.dimensions.filter(function (k) { return k.id == dim; })[0].height) + "\n                                        -\n                                    ")]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "68%"
	      }
	    }, [_c('el-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "col-md-12",
	      attrs: {
	        "placeholder": "Select Creative",
	        "name": "Creatives",
	        "filterable": ""
	      },
	      on: {
	        "change": function($event) {
	          return _vm.addCreativeToLineItem(_vm.createLineItemForm, index)
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.creativeIds[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creativeIds, index, $$v)
	        },
	        expression: "createLineItemForm.creativeIds[index]"
	      }
	    }, _vm._l((_vm.getCreativeList(dim)), function(creative, idx) {
	      return _c('el-option', {
	        key: idx,
	        attrs: {
	          "label": creative.name,
	          "value": creative.id
	        }
	      })
	    }), 1)], 1)]), _vm._v(" "), (
	      _vm.createLineItemForm.creative.length > index &&
	      _vm.createLineItemForm.creative[index]) ? _c('div', {
	      staticClass: "row"
	    }, [(_vm.createLineItemForm.creative[index].isS2S == true) ? _c('div', {
	      staticStyle: {
	        "width": "68%",
	        "margin-left": "75px",
	        "margin-top": "10px"
	      }
	    }, [_vm._v("\n                                        Tag ID :"), _c('el-input', {
	      model: {
	        value: (_vm.createLineItemForm.creative[index].tagId),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "tagId", $$v)
	        },
	        expression: "createLineItemForm.creative[index].tagId"
	      }
	    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
	      _vm.createLineItemForm.creative.length > index &&
	      _vm.createLineItemForm.creative[index] &&
	      _vm.createLineItemForm.creative[index].modify == true
	    ) ? _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "border-bottom": "1px solid #ececec",
	        "padding-bottom": "19px"
	      }
	    }, [_c('div', {
	      staticClass: "col-md-3 p-t-15"
	    }, [_c('div', [_vm._v("Modified creative name:")]), _vm._v(" "), _c('el-input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|alpha_dash'),
	        expression: "'required|alpha_dash'"
	      }],
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "name",
	        "type": "text",
	        "placeholder": "Enter Creative Name"
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].name),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "name", $$v)
	        },
	        expression: "createLineItemForm.creative[index].name"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 p-t-15"
	    }, [_c('div', [_vm._v("Font-Size:")]), _vm._v(" "), _c('el-select', {
	      attrs: {
	        "filterable": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].font_size),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "font_size", $$v)
	        },
	        expression: "createLineItemForm.creative[index].font_size"
	      }
	    }, _vm._l((_vm.allFontSizes), function(fontSize, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": fontSize,
	          "value": fontSize
	        }
	      })
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', [_vm._v("Font Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].font_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "font_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].font_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', [_vm._v("CTA Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].cta_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "cta_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].cta_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('div', [_vm._v("Background Color:")]), _vm._v(" "), _c('swatch', {
	      staticStyle: {
	        "width": "50px",
	        "height": "50px"
	      },
	      attrs: {
	        "colors": "text-advanced",
	        "popover-to": "top",
	        "show-fallback": ""
	      },
	      model: {
	        value: (_vm.createLineItemForm.creative[index].background_color),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.creative[index], "background_color", $$v)
	        },
	        expression: "createLineItemForm.creative[index].background_color"
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "creative-save-btn"
	    }, [_c('el-button', {
	      staticStyle: {
	        "margin-top": "10px"
	      },
	      attrs: {
	        "type": "success"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.saveCreative(_vm.createLineItemForm.creative[index], index)
	        }
	      }
	    }, [_vm._v("Save")])], 1)]) : _vm._e()])
	  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Placement")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.placements), function(data, index) {
	    return _c('div', {
	      key: (index + "positioninput"),
	      staticClass: "col-md-12 dis-flex"
	    }, [_c('el-select', {
	      staticClass: "col-md-3",
	      staticStyle: {
	        "padding": "0 5px 5px 0"
	      },
	      attrs: {
	        "clearable": "",
	        "placeholder": "Select an Operator",
	        "name": "Operator",
	        "reserve-keyword": "",
	        "allow-create": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('placements')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('placements')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.placements[index].operator),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.placements[index], "operator", $$v)
	        },
	        expression: "createLineItemForm.placements[index].operator"
	      }
	    }, _vm._l(([
	      ['Starts With', 'starts_with'],
	      ['Ends With', 'ends_with'],
	      ['Contains', 'contains'],
	      ['Equals', 'equals'],
	      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": operator[0],
	          "value": operator[1]
	        }
	      })
	    }), 1), _vm._v(" "), _c('el-input', {
	      staticClass: "col-md-11",
	      staticStyle: {
	        "margin": "0 5px 0 0",
	        "padding": "0px 0px 5px 5px"
	      },
	      attrs: {
	        "data-vv-delay": "1000",
	        "name": "placementName",
	        "type": "text",
	        "placeholder": "Enter Placement Name"
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('placements')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('placements')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.placements[index].data),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.placements[index], "data", $$v)
	        },
	        expression: "createLineItemForm.placements[index].data"
	      }
	    }), _vm._v(" "), (index === _vm.createLineItemForm.placements.length - 1) ? _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0",
	        "margin-top": "0px"
	      },
	      attrs: {
	        "type": "secondary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addNewItem(index, 'placements');
	          _vm.convertObjToRegex('placements');
	        }
	      }
	    }, [_vm._v("OR")]) : _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.createLineItemForm.placements.splice(index, 1);
	          _vm.convertObjToRegex('placements');
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])], 1)
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Position")]), _vm._v(" "), _vm._l((_vm.createLineItemForm.positions), function(data, index) {
	    return _c('div', {
	      key: (index + "positioninput"),
	      staticClass: "col-md-12 dis-flex"
	    }, [_c('el-select', {
	      staticClass: "col-md-3",
	      staticStyle: {
	        "padding": "0 5px 5px 0"
	      },
	      attrs: {
	        "clearable": "",
	        "placeholder": "Select an Operator",
	        "name": "Operator",
	        "reserve-keyword": "",
	        "allow-create": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('positions')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('positions')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.positions[index].operator),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.positions[index], "operator", $$v)
	        },
	        expression: "createLineItemForm.positions[index].operator"
	      }
	    }, _vm._l(([
	      ['Starts With', 'starts_with'],
	      ['Ends With', 'ends_with'],
	      ['Contains', 'contains'],
	      ['Equals', 'equals'],
	      ['Does Not Contain', 'does_not_contain'] ]), function(operator, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": operator[0],
	          "value": operator[1]
	        }
	      })
	    }), 1), _vm._v(" "), _c('el-select', {
	      staticClass: "col-md-11",
	      staticStyle: {
	        "margin": "0 5px 0 0",
	        "padding": "0px 0px 5px 5px"
	      },
	      attrs: {
	        "clearable": "",
	        "allow-create": "",
	        "remote": "",
	        "remote-method": _vm.positionFilter,
	        "placeholder": "Select or Add Position",
	        "name": "Positions",
	        "loading": _vm.positionsListLoading,
	        "reserve-keyword": "",
	        "filterable": ""
	      },
	      on: {
	        "remove-tag": function($event) {
	          return _vm.convertObjToRegex('positions')
	        },
	        "change": function($event) {
	          return _vm.convertObjToRegex('positions')
	        }
	      },
	      model: {
	        value: (_vm.createLineItemForm.positions[index].data),
	        callback: function($$v) {
	          _vm.$set(_vm.createLineItemForm.positions[index], "data", $$v)
	        },
	        expression: "createLineItemForm.positions[index].data"
	      }
	    }, _vm._l((_vm.posOptions), function(pos, index) {
	      return _c('el-option', {
	        key: index,
	        attrs: {
	          "label": pos,
	          "value": pos
	        }
	      })
	    }), 1), _vm._v(" "), (index === _vm.createLineItemForm.positions.length - 1) ? _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0",
	        "margin-top": "0"
	      },
	      attrs: {
	        "type": "secondary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addNewItem(index, 'positions');
	          _vm.convertObjToRegex('positions');
	        }
	      }
	    }, [_vm._v("OR")]) : _c('el-button', {
	      staticClass: "col-md-1",
	      staticStyle: {
	        "height": "100%",
	        "text-align": "center",
	        "padding-left": "0",
	        "padding-right": "0"
	      },
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.createLineItemForm.positions.splice(index, 1);
	          _vm.convertObjToRegex('positions');
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])], 1)
	  })], 2), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Bid CPM(USD) Min:")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "number",
	      "value": "0",
	      "data-vv-delay": "1000",
	      "name": "Bid CPM(USD) Min:",
	      "rows": 10,
	      "placeholder": "Enter Min ECPM"
	    },
	    model: {
	      value: (_vm.createLineItemForm.bid_cpm_min),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "bid_cpm_min", $$v)
	      },
	      expression: "createLineItemForm.bid_cpm_min"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Bid CPM(USD) Min:')),
	      expression: "errors.has('Bid CPM(USD) Min:')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Min:')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Bid CPM(USD) Max:")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Bid CPM(USD) Max:",
	      "rows": 10,
	      "placeholder": "Enter Max ECPM"
	    },
	    model: {
	      value: (_vm.createLineItemForm.bid_cpm_max),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "bid_cpm_max", $$v)
	      },
	      expression: "createLineItemForm.bid_cpm_max"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Bid CPM(USD) Max:')),
	      expression: "errors.has('Bid CPM(USD) Max:')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Bid CPM(USD) Max:')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "p-t-1 of-auto"
	  }, [_c('h5', [_vm._v("Budget (USD):")]), _vm._v(" "), _c('el-input', {
	    staticClass: "col-md-12",
	    attrs: {
	      "type": "text",
	      "data-vv-delay": "1000",
	      "name": "Budget (USD):",
	      "rows": 10,
	      "placeholder": "Enter Line item budget (USD)"
	    },
	    model: {
	      value: (_vm.createLineItemForm.budget),
	      callback: function($$v) {
	        _vm.$set(_vm.createLineItemForm, "budget", $$v)
	      },
	      expression: "createLineItemForm.budget"
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('Budget (USD):')),
	      expression: "errors.has('Budget (USD):')"
	    }],
	    staticClass: "help is-danger",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.errors.first('Budget (USD):')))])], 1)]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(!_vm.isEditLineitem) ? _c('el-button', {
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "type": "success"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createLineItem($event)
	      }
	    }
	  }, [_vm._v("Create Bulk Line item")]) : _vm._e()], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Create Bulk line item")])])
	}]}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.47b7121a2bfd911b144f.js